import * as i3 from '@angular/common';
import { CommonModule, DOCUMENT, isPlatformServer, isPlatformBrowser } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Directive, Input, HostBinding, HostListener, EventEmitter, Output, inject, ElementRef, Renderer2, NgModule, Inject, isDevMode, Component, ApplicationRef, Injector, PLATFORM_ID, ComponentFactory, TemplateRef, InjectionToken, APP_INITIALIZER, Optional, ComponentFactoryResolver, SecurityContext, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Pipe, HostAttributeToken, forwardRef, ContentChild, APP_BOOTSTRAP_LISTENER, DestroyRef, ViewChildren } from '@angular/core';
import * as i1 from '@spartacus/core';
import { WindowRef, Priority, Config, LoggerService, resolveApplicable, useFeatureStyles, isNotNullable, DeferLoadingStrategy, MODULE_INITIALIZER, provideDefaultConfig, FeatureConfigService, ANONYMOUS_CONSENT_STATUS, GlobalMessageType, GlobalMessageService, I18nModule, FeaturesConfigModule, wrapIntoObservable, isNotUndefined, ConfigChunk, DefaultConfigChunk, deepMerge, CxEvent, getLastValueSync, PageType, RouteLoadStrategy, FeatureToggles, provideDefaultConfigFactory, ProtectedRoutesGuard, RoutingModule as RoutingModule$1, LanguageService, ProductScope, provideConfig, ConfigModule, AuthGuard, UrlModule, isObject, SiteThemeService, THEME_CONTEXT_ID, TranslationService, LANGUAGE_CONTEXT_ID, CURRENCY_CONTEXT_ID, SiteContextModule, ContextServiceMap, SiteThemeModule, ContainerBackgroundOptions, CustomerCouponService, RoutingService, PageMetaModule, ProductActions, EMAIL_PATTERN, SECURE_PASSWORD_PATTERN, STRONG_PASSWORD_PATTERN, MIN_ONE_UPPER_CASE_CHARACTER_PATTERN, MIN_ONE_DIGIT_PATTERN, MIN_ONE_SPECIAL_CHARACTER_PATTERN, MIN_SIX_CHARACTERS_PATTERN, MIN_EIGHT_CHARACTERS_PATTERN, MAX_CHARACTERS_PATTERN, CONSECUTIVE_CHARACTERS, ScrollBehavior, ProductSearchByCodeService, ProductSearchByCategoryService, OCC_USER_ID_ANONYMOUS, NotificationType, OAuthFlow, UrlMatcherService, DEFAULT_URL_MATCHER, createFrom, BaseCoreModule } from '@spartacus/core';
import { BehaviorSubject, combineLatest, Subscription, of, Observable, ReplaySubject, Subject, first as first$1, concat, skipWhile, endWith, defer, EMPTY, forkJoin, from, lastValueFrom, tap as tap$1, merge, filter as filter$1, take as take$1, map as map$1, timer, using, asapScheduler, interval, switchMap as switchMap$1, zip } from 'rxjs';
import { filter, tap, map, take, first, mergeMap, distinctUntilChanged, shareReplay, switchMap, share, startWith, finalize, withLatestFrom, skipWhile as skipWhile$1, scan, delayWhen, concatMap, debounceTime, catchError, skip, observeOn, pairwise } from 'rxjs/operators';
import { __decorate, __param } from 'tslib';
import * as i1$1 from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import * as i1$2 from '@angular/router';
import { Router, NavigationStart, RouterModule, NavigationEnd, ROUTER_CONFIGURATION, Scroll, EventType } from '@angular/router';
import * as i1$3 from '@angular/service-worker';
import { SwRegistrationOptions, ServiceWorkerModule } from '@angular/service-worker';
import * as i1$4 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, NG_VALUE_ACCESSOR, UntypedFormGroup, UntypedFormControl, Validators, FormGroup, FormControl, UntypedFormArray } from '@angular/forms';
import * as i2 from '@ng-select/ng-select';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i3$1 from 'ngx-infinite-scroll';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import * as i1$5 from '@ngrx/store';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/** The element attribute used to store the focus state */
const _c0 = a0 => ({
  "anonymous-consent-banner-hidden": a0
});
function AnonymousConsentManagementBannerComponent_ng_container_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 8)(9, "button", 9);
    i0.ɵɵlistener("click", function AnonymousConsentManagementBannerComponent_ng_container_0_div_3_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.viewDetails());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 10);
    i0.ɵɵlistener("click", function AnonymousConsentManagementBannerComponent_ng_container_0_div_3_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.allowAll());
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "anonymousConsents.banner.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "anonymousConsents.banner.description"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 8, "anonymousConsents.banner.viewDetails"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 10, "anonymousConsents.banner.allowAll"), " ");
  }
}
function AnonymousConsentManagementBannerComponent_ng_container_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 11)(2, "div", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 7);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 12)(9, "button", 9);
    i0.ɵɵlistener("click", function AnonymousConsentManagementBannerComponent_ng_container_0_div_4_Template_button_click_9_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.viewDetails());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 10);
    i0.ɵɵlistener("click", function AnonymousConsentManagementBannerComponent_ng_container_0_div_4_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.allowAll());
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "anonymousConsents.banner.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "anonymousConsents.banner.description"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 8, "anonymousConsents.banner.consentManagement"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 10, "anonymousConsents.banner.allowAll"), " ");
  }
}
function AnonymousConsentManagementBannerComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵtemplate(3, AnonymousConsentManagementBannerComponent_ng_container_0_div_3_Template, 15, 12, "div", 3)(4, AnonymousConsentManagementBannerComponent_ng_container_0_div_4_Template, 15, 12, "div", 3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const bannerVisible_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, !bannerVisible_r4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yHideConsentButtonWhenBannerVisible");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yHideConsentButtonWhenBannerVisible");
  }
}
const _c1 = ["*"];
function ConsentManagementFormComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.consentTemplate == null ? null : ctx_r1.consentTemplate.name, " ");
  }
}
function ConsentManagementFormComponent_span_5_ng_template_2_Template(rf, ctx) {}
function ConsentManagementFormComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ConsentManagementFormComponent_span_5_ng_template_2_Template, 0, 0, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const requiredAsterisk_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.consentTemplate == null ? null : ctx_r1.consentTemplate.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
  }
}
function ConsentManagementFormComponent_span_6_ng_template_2_Template(rf, ctx) {}
function ConsentManagementFormComponent_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ConsentManagementFormComponent_span_6_ng_template_2_Template, 0, 0, "ng-template", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const requiredAsterisk_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.consentTemplate == null ? null : ctx_r1.consentTemplate.description, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", requiredAsterisk_r3);
  }
}
function ConsentManagementFormComponent_ng_template_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "abbr", 8);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtext(3, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 1, "common.required"));
  }
}
function ConsentManagementFormComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ConsentManagementFormComponent_ng_template_7_ng_container_0_Template, 4, 3, "ng-container", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.showMandatory);
  }
}
const _c2 = ["messageContainer"];
const _c3 = ["*", "*"];
function MessageComponent_div_0_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function MessageComponent_div_0_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.showBody = !ctx_r1.showBody);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "cx-icon", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-expanded", ctx_r1.showBody)("aria-label", ctx_r1.accordionText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.accordionText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.showBody ? "CARET_UP" : "CARET_DOWN");
  }
}
function MessageComponent_div_0_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function MessageComponent_div_0_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.buttonAction.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cxAtMessage", ctx_r1.actionButtonMessage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionButtonText, " ");
  }
}
function MessageComponent_div_0_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function MessageComponent_div_0_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeMessage.emit());
    });
    i0.ɵɵelement(4, "cx-icon", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 4, "common.close"));
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(2, 6, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 8, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function MessageComponent_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function MessageComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3, 0)(2, "div", 4)(3, "div", 5)(4, "span", 6);
    i0.ɵɵelement(5, "cx-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 8);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, MessageComponent_div_0_button_8_Template, 3, 4, "button", 9)(9, MessageComponent_div_0_button_9_Template, 2, 2, "button", 10)(10, MessageComponent_div_0_button_10_Template, 5, 10, "button", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, MessageComponent_div_0_div_11_Template, 2, 0, "div", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getCssClassesForMessage);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("type", ctx_r1.getIconType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.accordionText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.actionButtonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isVisibleCloseButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showBody || !ctx_r1.accordionText);
  }
}
function MessageComponent_div_1_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function MessageComponent_div_1_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.showBody = !ctx_r1.showBody);
    });
    i0.ɵɵtext(1);
    i0.ɵɵelement(2, "cx-icon", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-expanded", ctx_r1.showBody)("aria-label", ctx_r1.accordionText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.accordionText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.showBody ? "CARET_UP" : "CARET_DOWN");
  }
}
function MessageComponent_div_1_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function MessageComponent_div_1_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.buttonAction.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cxAtMessage", ctx_r1.actionButtonMessage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.actionButtonText, " ");
  }
}
function MessageComponent_div_1_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function MessageComponent_div_1_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeMessage.emit());
    });
    i0.ɵɵelement(4, "cx-icon", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 4, "common.close"));
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(2, 6, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 8, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function MessageComponent_div_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function MessageComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19)(1, "div", 4)(2, "div", 20)(3, "span", 21);
    i0.ɵɵelement(4, "cx-icon", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵtemplate(7, MessageComponent_div_1_button_7_Template, 3, 4, "button", 9)(8, MessageComponent_div_1_button_8_Template, 2, 2, "button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, MessageComponent_div_1_button_9_Template, 5, 10, "button", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, MessageComponent_div_1_div_10_Template, 2, 0, "div", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.getCssClassesForMessage);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r1.getIconType);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.accordionText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.actionButtonText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isVisibleCloseButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showBody || !ctx_r1.accordionText);
  }
}
const _c4 = () => ({
  autofocus: ".cx-message"
});
function AnonymousConsentDialogComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function AnonymousConsentDialogComponent_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function AnonymousConsentDialogComponent_ng_template_4_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelement(3, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "anonymousConsents.dialog.legalDescription"), " ");
  }
}
function AnonymousConsentDialogComponent_ng_template_4_ng_container_11_cx_message_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-message", 20);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("closeMessage", function AnonymousConsentDialogComponent_ng_template_4_ng_container_11_cx_message_2_Template_cx_message_closeMessage_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.closeMessage());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r5 = ctx.ngIf;
    i0.ɵɵproperty("text", i0.ɵɵpipeBind1(1, 4, message_r5.key))("type", message_r5.type)("isVisibleCloseButton", true)("cxFocus", i0.ɵɵpureFunction0(6, _c4));
  }
}
function AnonymousConsentDialogComponent_ng_template_4_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵtemplate(2, AnonymousConsentDialogComponent_ng_template_4_ng_container_11_cx_message_2_Template, 2, 7, "cx-message", 19);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 1, ctx_r2.message$));
  }
}
function AnonymousConsentDialogComponent_ng_template_4_div_19_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "cx-consent-management-form", 25);
    i0.ɵɵlistener("consentChanged", function AnonymousConsentDialogComponent_ng_template_4_div_19_ng_container_1_div_1_Template_cx_consent_management_form_consentChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onConsentChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const template_r7 = ctx.$implicit;
    const consents_r8 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("consentTemplate", template_r7)("requiredConsents", ctx_r2.requiredConsents)("consent", ctx_r2.getCorrespondingConsent(template_r7, consents_r8));
  }
}
function AnonymousConsentDialogComponent_ng_template_4_div_19_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AnonymousConsentDialogComponent_ng_template_4_div_19_ng_container_1_div_1_Template, 2, 3, "div", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const templates_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", templates_r9);
  }
}
function AnonymousConsentDialogComponent_ng_template_4_div_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, AnonymousConsentDialogComponent_ng_template_4_div_19_ng_container_1_Template, 2, 1, "ng-container", 22);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r2.consents$));
  }
}
function AnonymousConsentDialogComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, AnonymousConsentDialogComponent_ng_template_4_div_0_Template, 2, 3, "div", 4);
    i0.ɵɵelementStart(1, "div", 5)(2, "h3", 6);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function AnonymousConsentDialogComponent_ng_template_4_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close("Cross click"));
    });
    i0.ɵɵelementStart(8, "span", 8);
    i0.ɵɵelement(9, "cx-icon", 9);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, AnonymousConsentDialogComponent_ng_template_4_div_10_Template, 4, 3, "div", 10)(11, AnonymousConsentDialogComponent_ng_template_4_ng_container_11_Template, 4, 3, "ng-container", 11);
    i0.ɵɵelementStart(12, "div", 12)(13, "button", 13);
    i0.ɵɵlistener("click", function AnonymousConsentDialogComponent_ng_template_4_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.rejectAll());
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 13);
    i0.ɵɵlistener("click", function AnonymousConsentDialogComponent_ng_template_4_Template_button_click_16_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.allowAll());
    });
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(19, AnonymousConsentDialogComponent_ng_template_4_div_19_Template, 3, 3, "div", 14);
    i0.ɵɵpipe(20, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, "anonymousConsents.dialog.title"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 12, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 14, "common.close"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showLegalDescription);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yAnonymousConsentMessageInDialog");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 16, "anonymousConsents.dialog.clearAll"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 18, "anonymousConsents.dialog.selectAll"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(20, 20, ctx_r2.templates$));
  }
}
const _c5 = ["open"];
function AnonymousConsentOpenDialogComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 2, 0);
    i0.ɵɵlistener("click", function AnonymousConsentOpenDialogComponent_ng_container_0_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openDialog());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "anonymousConsents.dialog.title"), " ");
  }
}
function AnonymousConsentOpenDialogComponent_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 2, 0);
    i0.ɵɵlistener("click", function AnonymousConsentOpenDialogComponent_ng_container_1_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openDialog());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "anonymousConsents.dialog.title"), " ");
  }
}
function AnonymousConsentOpenDialogComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AnonymousConsentOpenDialogComponent_ng_container_1_button_1_Template, 4, 3, "button", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 1, ctx_r1.bannerVisible$));
  }
}
const _c6 = a0 => ({
  components$: a0
});
const _c7 = a0 => ({
  component: a0
});
function PageSlotComponent_0_ng_template_0_ng_container_0_1_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 4);
  }
  if (rf & 2) {
    const component_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("cxComponentWrapper", component_r2);
  }
}
function PageSlotComponent_0_ng_template_0_ng_container_0_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, PageSlotComponent_0_ng_template_0_ng_container_0_1_ng_template_0_Template, 1, 1, "ng-template", 3);
    i0.ɵɵlistener("loaded", function PageSlotComponent_0_ng_template_0_ng_container_0_1_Template_ng_template_loaded_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.isLoaded($event));
    });
  }
  if (rf & 2) {
    const component_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cxOutlet", component_r2.flexType)("cxOutletContext", i0.ɵɵpureFunction1(3, _c7, component_r2))("cxOutletDefer", ctx_r2.getComponentDeferOptions(component_r2.flexType));
  }
}
function PageSlotComponent_0_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PageSlotComponent_0_ng_template_0_ng_container_0_1_Template, 1, 5, null, 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const component_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", component_r2.flexType);
  }
}
function PageSlotComponent_0_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PageSlotComponent_0_ng_template_0_ng_container_0_Template, 2, 1, "ng-container", 2);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.components);
  }
}
function PageSlotComponent_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PageSlotComponent_0_ng_template_0_Template, 1, 1, "ng-template", 1);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxOutlet", ctx_r2.position)("cxOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r2.components$));
  }
}
const _c8 = (a0, a1, a2) => ({
  templateName$: a0,
  slots$: a1,
  section$: a2
});
function PageLayoutComponent_0_ng_template_0_cx_page_slot_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-page-slot", 3);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const slot_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("position", slot_r1)("isPageFold", slot_r1 === i0.ɵɵpipeBind1(1, 2, ctx_r1.pageFoldSlot$));
  }
}
function PageLayoutComponent_0_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵtemplate(1, PageLayoutComponent_0_ng_template_0_cx_page_slot_1_Template, 2, 4, "cx-page-slot", 2);
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r1.slots$));
  }
}
function PageLayoutComponent_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PageLayoutComponent_0_ng_template_0_Template, 3, 3, "ng-template", 1);
  }
  if (rf & 2) {
    const layoutName_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxPageTemplateStyle", layoutName_r3)("cxOutlet", layoutName_r3)("cxOutletContext", i0.ɵɵpureFunction3(3, _c8, ctx_r1.templateName$, ctx_r1.slots$, ctx_r1.section$));
  }
}
function AddToHomeScreenBannerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 1)(2, "div", 2)(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul")(7, "li");
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "li");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(13, "button", 3);
    i0.ɵɵlistener("click", function AddToHomeScreenBannerComponent_div_0_Template_button_click_13_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prompt());
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "pwa.addToHomeScreenDescription"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 6, "pwa.noInstallationNeeded"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 8, "pwa.fastAccessToApplication"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 10, "pwa.addToHomeScreen"), " ");
  }
}
function AddToHomeScreenBtnComponent_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "canPrompt$ | async"]);
  }
}
const _c9 = () => ({
  tab: true
});
function SkipLinkComponent_div_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵlistener("click", function SkipLinkComponent_div_0_button_1_Template_button_click_0_listener() {
      const link_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.scrollToTarget(link_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "skipLink.skipTo"), " ", i0.ɵɵpipeBind1(3, 4, link_r2.i18nKey), " ");
  }
}
function SkipLinkComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, SkipLinkComponent_div_0_button_1_Template, 4, 6, "button", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const links_r4 = ctx.ngIf;
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(2, _c9));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", links_r4);
  }
}
const _c10 = a0 => ({
  item: a0
});
const _c11 = (a0, a1) => ({
  currentSlideNumber: a0,
  numberOfSlides: a1
});
function CarouselComponent_ng_container_0_h2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.title);
  }
}
function CarouselComponent_ng_container_0_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CarouselComponent_ng_container_0_button_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const size_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r0 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.activeSlide === 0 ? null : ctx_r0.activeSlide = ctx_r0.activeSlide - size_r3);
    })("keydown.arrowleft", function CarouselComponent_ng_container_0_button_3_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowright", function CarouselComponent_ng_container_0_button_3_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowup", function CarouselComponent_ng_container_0_button_3_Template_button_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowdown", function CarouselComponent_ng_container_0_button_3_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    });
    i0.ɵɵelement(3, "cx-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-disabled", ctx_r0.activeSlide === 0)("aria-label", i0.ɵɵpipeBind1(1, 4, "carousel.previousSlide"))("title", i0.ɵɵpipeBind1(2, 6, "carousel.previousSlide"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r0.previousIcon);
  }
}
function CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵlistener("keydown", function CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_div_1_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const size_r3 = i0.ɵɵnextContext(4).ngIf;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onItemKeydown($event, size_r3));
    });
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_div_1_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r5 = ctx.ngIf;
    const i_r6 = i0.ɵɵnextContext(3).index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("active", i_r6 === ctx_r0.activeSlide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c10, data_r5));
  }
}
function CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_div_1_Template, 2, 6, "div", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, item_r7));
  }
}
function CarouselComponent_ng_container_0_ng_container_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_ng_container_5_div_1_ng_container_1_Template, 3, 3, "ng-container", 4);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r6 = i0.ɵɵnextContext().index;
    const size_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", i_r6 === ctx_r0.activeSlide);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 3, ctx_r0.items, i_r6, i_r6 + size_r3));
  }
}
function CarouselComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_ng_container_5_div_1_Template, 3, 7, "div", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r6 = ctx.index;
    const size_r3 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r6 % size_r3 === 0);
  }
}
function CarouselComponent_ng_container_0_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CarouselComponent_ng_container_0_button_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const size_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r0 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.activeSlide > ctx_r0.items.length - size_r3 - 1 ? null : ctx_r0.activeSlide = ctx_r0.activeSlide + size_r3);
    })("keydown.arrowleft", function CarouselComponent_ng_container_0_button_6_Template_button_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowright", function CarouselComponent_ng_container_0_button_6_Template_button_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowup", function CarouselComponent_ng_container_0_button_6_Template_button_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    })("keydown.arrowdown", function CarouselComponent_ng_container_0_button_6_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.shareEvent($event));
    });
    i0.ɵɵelement(3, "cx-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const size_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-disabled", ctx_r0.activeSlide > ctx_r0.items.length - size_r3 - 1)("aria-label", i0.ɵɵpipeBind1(1, 4, "carousel.nextSlide"))("title", i0.ɵɵpipeBind1(2, 6, "carousel.nextSlide"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r0.nextIcon);
  }
}
function CarouselComponent_ng_container_0_div_7_ng_container_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function CarouselComponent_ng_container_0_div_7_ng_container_1_button_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const i_r10 = i0.ɵɵnextContext().index;
      const ctx_r0 = i0.ɵɵnextContext(3);
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r0.activeSlide = i_r10);
    });
    i0.ɵɵelement(3, "cx-icon", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r10 = i0.ɵɵnextContext().index;
    const size_r3 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-current", i_r10 === ctx_r0.activeSlide)("aria-disabled", i_r10 === ctx_r0.activeSlide)("aria-label", i0.ɵɵpipeBind2(1, 5, "carousel.slideNumber", i0.ɵɵpureFunction2(11, _c11, ctx_r0.getSlideNumber(size_r3, i_r10), size_r3)))("title", i0.ɵɵpipeBind2(2, 8, "carousel.slideNumber", i0.ɵɵpureFunction2(14, _c11, ctx_r0.getSlideNumber(size_r3, i_r10), size_r3)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r0.indicatorIcon);
  }
}
function CarouselComponent_ng_container_0_div_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_div_7_ng_container_1_button_1_Template, 4, 17, "button", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r10 = ctx.index;
    const size_r3 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r10 % size_r3 === 0);
  }
}
function CarouselComponent_ng_container_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_div_7_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
  }
}
function CarouselComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CarouselComponent_ng_container_0_h2_1_Template, 2, 1, "h2", 0);
    i0.ɵɵelementStart(2, "div", 1);
    i0.ɵɵtemplate(3, CarouselComponent_ng_container_0_button_3_Template, 4, 8, "button", 2);
    i0.ɵɵelementStart(4, "div", 3);
    i0.ɵɵtemplate(5, CarouselComponent_ng_container_0_ng_container_5_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CarouselComponent_ng_container_0_button_6_Template, 4, 8, "button", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CarouselComponent_ng_container_0_div_7_Template, 2, 1, "div", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const size_r3 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", "size-" + size_r3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", size_r3 < ctx_r0.items.length);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.items);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", size_r3 < ctx_r0.items.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideIndicators && size_r3 < ctx_r0.items.length);
  }
}
const _c12 = (a0, a1, a2) => ({
  flexType: a0,
  typeCode: a1,
  uid: a2
});
function BannerCarouselComponent_cx_carousel_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 2);
  }
  if (rf & 2) {
    const items_r1 = ctx.ngIf;
    i0.ɵɵnextContext();
    const template_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("items", items_r1)("template", template_r2);
  }
}
function BannerCarouselComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    i0.ɵɵproperty("cxComponentWrapper", i0.ɵɵpureFunction3(1, _c12, item_r3.typeCode, item_r3.typeCode, item_r3 == null ? null : item_r3.uid));
  }
}
const _c13 = (a0, a1, a2) => ({
  loading: a0,
  templateList: a1,
  allConsentsLoading: a2
});
function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_cx_consent_management_form_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-consent-management-form", 12);
    i0.ɵɵlistener("consentChanged", function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_cx_consent_management_form_4_Template_cx_consent_management_form_consentChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.onConsentChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consentTemplate_r5 = ctx.$implicit;
    const data_r6 = i0.ɵɵnextContext(3).ngIf;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("consentTemplate", consentTemplate_r5)("requiredConsents", ctx_r2.requiredConsents)("disabled", !!data_r6.loading);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_div_1_Template, 2, 3, "div", 8);
    i0.ɵɵelementStart(2, "div", 9)(3, "div", 4);
    i0.ɵɵtemplate(4, ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_cx_consent_management_form_4_Template, 1, 3, "cx-consent-management-form", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const templateList_r2 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", templateList_r2);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "button", 5);
    i0.ɵɵlistener("click", function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_Template_button_click_3_listener() {
      const templateList_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.rejectAll(templateList_r2));
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 5);
    i0.ɵɵlistener("click", function ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_Template_button_click_6_listener() {
      const templateList_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.allowAll(templateList_r2));
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(9, ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_div_9_Template, 2, 0, "div", 6)(10, ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_ng_container_10_Template, 5, 2, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const templateList_r2 = ctx.ngIf;
    const data_r6 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", data_r6.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 6, "consentManagementForm.clearAll"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", data_r6.loading);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 8, "consentManagementForm.selectAll"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", data_r6.allConsentsLoading || data_r6.loading && !(templateList_r2 == null ? null : templateList_r2.length));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !data_r6.allConsentsLoading);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsentManagementComponent_ng_container_0_ng_container_1_ng_container_1_Template, 11, 10, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const data_r6 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", data_r6.templateList);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 7);
    i0.ɵɵelement(2, "cx-spinner");
    i0.ɵɵelementEnd()();
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_cx_consent_management_form_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-consent-management-form", 16);
    i0.ɵɵlistener("consentChanged", function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_cx_consent_management_form_11_Template_cx_consent_management_form_consentChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.onConsentChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consentTemplate_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("consentTemplate", consentTemplate_r10)("requiredConsents", ctx_r2.requiredConsents);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "button", 14);
    i0.ɵɵlistener("click", function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_Template_button_click_3_listener() {
      const templateList_r8 = i0.ɵɵrestoreView(_r7).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.rejectAll(templateList_r8));
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 14);
    i0.ɵɵlistener("click", function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_Template_button_click_6_listener() {
      const templateList_r8 = i0.ɵɵrestoreView(_r7).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.allowAll(templateList_r8));
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 9)(10, "div", 4);
    i0.ɵɵtemplate(11, ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_cx_consent_management_form_11_Template, 1, 2, "cx-consent-management-form", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const templateList_r8 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 3, "consentManagementForm.clearAll"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, "consentManagementForm.selectAll"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", templateList_r8);
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_div_0_Template, 2, 3, "div", 8)(1, ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_ng_container_1_Template, 12, 7, "ng-container", 2);
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r2.templateList$));
  }
}
function ConsentManagementComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsentManagementComponent_ng_container_0_ng_container_5_div_1_Template, 3, 0, "div", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ConsentManagementComponent_ng_container_0_ng_container_5_ng_template_3_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const consentManagementForm_r11 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r2.loading$))("ngIfElse", consentManagementForm_r11);
  }
}
function ConsentManagementComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConsentManagementComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtemplate(5, ConsentManagementComponent_ng_container_0_ng_container_5_Template, 5, 4, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction3(8, _c13, i0.ɵɵpipeBind1(2, 2, ctx_r2.loading$), i0.ɵɵpipeBind1(3, 4, ctx_r2.templateList$), i0.ɵɵpipeBind1(4, 6, ctx_r2.allConsentsLoading$)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cxFeature", "!a11yNotificationsOnConsentChange");
  }
}
function MyAccountV2ConsentManagementFormComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.consentTemplate == null ? null : ctx_r0.consentTemplate.name, " ");
  }
}
function MyAccountV2ConsentManagementFormComponent_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "myAccountV2Consent.dateDescription"), "", ctx_r0.consentApprovedTime, " ");
  }
}
function MyAccountV2ConsentManagementComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 2);
    i0.ɵɵelement(2, "cx-spinner");
    i0.ɵɵelementEnd()();
  }
}
function MyAccountV2ConsentManagementComponent_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_cx_my_account_v2_consent_management_form_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-my-account-v2-consent-management-form", 12);
    i0.ɵɵlistener("consentChanged", function MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_cx_my_account_v2_consent_management_form_13_Template_cx_my_account_v2_consent_management_form_consentChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onConsentChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const consentTemplate_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("consentTemplate", consentTemplate_r5)("requiredConsents", ctx_r2.requiredConsents);
  }
}
function MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "div", 7)(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9)(7, "button", 10);
    i0.ɵɵlistener("click", function MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_Template_button_click_7_listener() {
      const templateList_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.rejectAll(templateList_r2));
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 10);
    i0.ɵɵlistener("click", function MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_Template_button_click_10_listener() {
      const templateList_r2 = i0.ɵɵrestoreView(_r1).ngIf;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.allowAll(templateList_r2));
    });
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_cx_my_account_v2_consent_management_form_13_Template, 1, 2, "cx-my-account-v2-consent-management-form", 11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const templateList_r2 = ctx.ngIf;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 4, "myAccountV2Consent.header"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 6, "myAccountV2Consent.clearAll"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 8, "myAccountV2Consent.selectAll"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", templateList_r2);
  }
}
function MyAccountV2ConsentManagementComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MyAccountV2ConsentManagementComponent_ng_template_2_div_0_Template, 2, 3, "div", 3)(1, MyAccountV2ConsentManagementComponent_ng_template_2_ng_container_1_Template, 14, 10, "ng-container", 4);
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r2.templateList$));
  }
}
function PopoverComponent_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("keydown.enter", function PopoverComponent_button_3_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("keydown.space", function PopoverComponent_button_3_Template_button_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("click", function PopoverComponent_button_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close($event));
    });
    i0.ɵɵelement(3, "cx-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 5, "common.close"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
  }
}
function PopoverComponent_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PopoverComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PopoverComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.content);
  }
}
function PopoverComponent_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.content);
  }
}
const _c14 = a0 => [a0];
const _c15 = () => ({
  placement: "auto",
  appendToBody: true,
  displayCloseButton: true
});
function TruncateTextPopoverComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content, " ");
  }
}
function TruncateTextPopoverComponent_button_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const fullText_r2 = i0.ɵɵreference(6);
    i0.ɵɵproperty("cxPopover", fullText_r2)("cxPopoverOptions", i0.ɵɵpureFunction0(5, _c15));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, "common.more"), " ");
  }
}
function GenericLinkComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function GenericLinkComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 3);
    i0.ɵɵtemplate(2, GenericLinkComponent_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.url, i0.ɵɵsanitizeUrl)("tabindex", ctx_r0.tabindex);
    i0.ɵɵattribute("target", ctx_r0.target)("rel", ctx_r0.rel)("id", ctx_r0.id)("class", ctx_r0.class)("style", ctx_r0.style, i0.ɵɵsanitizeStyle)("title", ctx_r0.title)("aria-label", ctx_r0.ariaLabel ? ctx_r0.ariaLabel : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function GenericLinkComponent_ng_template_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function GenericLinkComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtemplate(1, GenericLinkComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("routerLink", ctx_r0.routerUrl)("queryParams", ctx_r0.queryParams)("fragment", ctx_r0.fragment)("target", ctx_r0.target || undefined)("tabindex", ctx_r0.tabindex);
    i0.ɵɵattribute("id", ctx_r0.id)("class", ctx_r0.class)("style", ctx_r0.style, i0.ɵɵsanitizeStyle)("title", ctx_r0.title)("aria-label", ctx_r0.ariaLabel ? ctx_r0.ariaLabel : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function GenericLinkComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c16 = [[["", "label_container_bottom", ""]]];
const _c17 = ["[label_container_bottom]"];
const _c18 = (a0, a1, a2, a3) => ({
  content: a0,
  truncateText: a1,
  charactersLimit: a2,
  class: "cx-card-label",
  text: a3
});
const _c19 = (a0, a1, a2, a3) => ({
  content: a0,
  truncateText: a1,
  charactersLimit: a2,
  class: "cx-card-paragraph-text",
  text: a3
});
const _c20 = () => ({
  autofocus: true
});
function CardComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.getLabel("content-header"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content.header, " ");
  }
}
function CardComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content.deleteMsg, " ");
  }
}
function CardComponent_div_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", ctx_r0.getLabel("content-title"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content.title, " ");
  }
}
function CardComponent_div_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.content.textBold, " ");
  }
}
function CardComponent_div_0_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardComponent_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CardComponent_div_0_div_8_ng_container_1_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const line_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const showText_r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", showText_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c18, ctx_r0.content, ctx_r0.truncateText, ctx_r0.charactersLimit, line_r2));
  }
}
function CardComponent_div_0_div_9_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardComponent_div_0_div_9_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CardComponent_div_0_div_9_div_3_ng_container_1_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    const showText_r3 = i0.ɵɵreference(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", showText_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c19, ctx_r0.content, ctx_r0.truncateParagraphText, ctx_r0.charactersLimit, text_r4));
  }
}
function CardComponent_div_0_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, CardComponent_div_0_div_9_div_3_Template, 2, 7, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r5.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", item_r5.text);
  }
}
function CardComponent_div_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelement(3, "cx-icon", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, (tmp_3_0 = ctx_r0.content.imgLabel) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "paymentCard.credit"))("title", i0.ɵɵpipeBind1(2, 5, (tmp_4_0 = ctx_r0.content.imgLabel) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "paymentCard.credit"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r0.content.img);
  }
}
function CardComponent_div_0_div_12_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 27)(2, "button", 28);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_12_div_1_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.delete());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 29)(6, "button", 30);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function CardComponent_div_0_div_12_div_1_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.cancelEdit());
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(10, _c20));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "common.delete"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(7, 6, "assistiveMessage.actionCancelled"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "common.cancel"), " ");
  }
}
function CardComponent_div_0_div_12_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "div", 29)(2, "button", 30);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵlistener("click", function CardComponent_div_0_div_12_div_2_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.cancelEdit());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 27)(7, "button", 28);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_12_div_2_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.delete());
    });
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(3, 4, "assistiveMessage.actionCancelled"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 6, "common.cancel"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(10, _c20));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "common.delete"), " ");
  }
}
function CardComponent_div_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_12_div_1_Template, 10, 11, "div", 25)(2, CardComponent_div_0_div_12_div_2_Template, 10, 11, "div", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yDeleteButton2First");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yDeleteButton2First");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.delete());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r9.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.setDefault());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r9.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.send());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-describedby", ctx_r0.index >= 0 && ctx_r0.content.header && !ctx_r0.editMode ? "content-header-" + ctx_r0.index : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r9.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.edit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r9.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 35);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_1_Template, 2, 1, "button", 36)(2, CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_2_Template, 2, 1, "button", 36)(3, CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_3_Template, 2, 2, "button", 36)(4, CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_button_4_Template, 2, 1, "button", 36);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngSwitch", action_r9.event);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "default");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "send");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "edit");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_a_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 38);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("href", action_r9.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r9.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtemplate(2, CardComponent_div_0_div_13_ng_container_1_div_1_ng_container_2_Template, 5, 5, "ng-container", 33)(3, CardComponent_div_0_div_13_ng_container_1_div_1_a_3_Template, 2, 2, "a", 34);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r9 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isCardAction(action_r9));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isCardLinkAction(action_r9));
  }
}
function CardComponent_div_0_div_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_13_ng_container_1_div_1_Template, 4, 2, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.content.actions);
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.delete());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r14.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.setDefault());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r14.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.send());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵattribute("aria-describedby", ctx_r0.index >= 0 && ctx_r0.content.header && !ctx_r0.editMode ? "content-header-" + ctx_r0.index : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r14.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r17);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0.edit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", action_r14.name, " ");
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 35);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_1_Template, 2, 1, "button", 42)(2, CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_2_Template, 2, 1, "button", 42)(3, CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_3_Template, 2, 2, "button", 42)(4, CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_button_4_Template, 2, 1, "button", 42);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngSwitch", action_r14.event);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "delete");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "default");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "send");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "edit");
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_cx_generic_link_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "cx-generic-link", 44);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_9_0;
    const action_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("url", action_r14.link)("ariaLabel", action_r14.ariaLabel ? i0.ɵɵpipeBind1(1, 4, action_r14.ariaLabel) : undefined)("target", (tmp_9_0 = action_r14.target) !== null && tmp_9_0 !== undefined ? tmp_9_0 : null);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(action_r14.name);
  }
}
function CardComponent_div_0_div_13_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 40)(1, "div");
    i0.ɵɵtemplate(2, CardComponent_div_0_div_13_ng_container_2_div_1_ng_container_2_Template, 5, 5, "ng-container", 33)(3, CardComponent_div_0_div_13_ng_container_2_div_1_cx_generic_link_3_Template, 3, 6, "cx-generic-link", 41);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r14 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.isCardAction(action_r14));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isCardLinkAction(action_r14));
  }
}
function CardComponent_div_0_div_13_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_13_ng_container_2_div_1_Template, 4, 2, "div", 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.content.actions);
  }
}
function CardComponent_div_0_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_13_ng_container_1_Template, 2, 1, "ng-container", 32)(2, CardComponent_div_0_div_13_ng_container_2_Template, 2, 1, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yImproveButtonsInCardComponent");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yImproveButtonsInCardComponent");
  }
}
function CardComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, CardComponent_div_0_div_1_Template, 2, 2, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵtemplate(3, CardComponent_div_0_div_3_Template, 2, 1, "div", 5)(4, CardComponent_div_0_span_4_Template, 2, 2, "span", 6);
    i0.ɵɵelementStart(5, "div", 7)(6, "div", 8);
    i0.ɵɵtemplate(7, CardComponent_div_0_div_7_Template, 2, 1, "div", 9)(8, CardComponent_div_0_div_8_Template, 2, 7, "div", 10)(9, CardComponent_div_0_div_9_Template, 4, 2, "div", 11);
    i0.ɵɵprojection(10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CardComponent_div_0_div_11_Template, 4, 7, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, CardComponent_div_0_div_12_Template, 3, 2, "div", 13)(13, CardComponent_div_0_div_13_Template, 3, 2, "div", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cx-card-border", ctx_r0.border)("cx-card-fit-to-container", ctx_r0.fitToContainer);
    i0.ɵɵproperty("tabindex", ctx_r0.border ? 0 : -1);
    i0.ɵɵattribute("role", ctx_r0.role)("aria-labelledby", ctx_r0.isHeaderVisible ? ctx_r0.getLabel("content-header") : null)("aria-describedby", ctx_r0.ariaDescribedBy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isHeaderVisible);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("cx-card-delete", ctx_r0.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.content.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.getLabel("cx-card-container"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.content.textBold);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.content.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.content.paragraphs)("ngForTrackBy", ctx_r0.trackByIndex);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.content.img);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.editMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.content.actions && !ctx_r0.editMode);
  }
}
function CardComponent_ng_template_1_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const content_r19 = ctx_r17.content;
    const class_r20 = ctx_r17.class;
    const text_r21 = ctx_r17.text;
    i0.ɵɵclassMap(class_r20);
    i0.ɵɵproperty("ngClass", content_r19.customClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r21, " ");
  }
}
function CardComponent_ng_template_1_cx_truncate_text_popover_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-truncate-text-popover", 48);
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const content_r19 = ctx_r17.content;
    const charactersLimit_r22 = ctx_r17.charactersLimit;
    const class_r20 = ctx_r17.class;
    const text_r21 = ctx_r17.text;
    i0.ɵɵproperty("charactersLimit", charactersLimit_r22)("content", text_r21)("customClass", content_r19.customClass || class_r20);
  }
}
function CardComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CardComponent_ng_template_1_div_0_Template, 2, 4, "div", 45)(1, CardComponent_ng_template_1_cx_truncate_text_popover_1_Template, 1, 3, "cx-truncate-text-popover", 46);
  }
  if (rf & 2) {
    const truncateText_r23 = ctx.truncateText;
    i0.ɵɵproperty("ngIf", !truncateText_r23);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", truncateText_r23);
  }
}
function MediaComponent_ng_container_0_ng_container_1_picture_1_source_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source", 7);
  }
  if (rf & 2) {
    const source_r2 = ctx.$implicit;
    i0.ɵɵproperty("media", source_r2.media)("srcset", source_r2.srcset);
    i0.ɵɵattribute("width", source_r2.width)("height", source_r2.height);
  }
}
function MediaComponent_ng_container_0_ng_container_1_picture_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "picture");
    i0.ɵɵtemplate(1, MediaComponent_ng_container_0_ng_container_1_picture_1_source_1_Template, 1, 4, "source", 5);
    i0.ɵɵelementStart(2, "img", 6);
    i0.ɵɵlistener("load", function MediaComponent_ng_container_0_ng_container_1_picture_1_Template_img_load_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.loadHandler());
    })("error", function MediaComponent_ng_container_0_ng_container_1_picture_1_Template_img_error_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.errorHandler());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.media.sources)("ngForTrackBy", ctx_r2.trackByMedia);
    i0.ɵɵadvance();
    i0.ɵɵproperty("loading", ctx_r2.effectiveLoadingStrategy)("alt", ctx_r2.media.alt)("title", ctx_r2.media.alt)("src", ctx_r2.media.src, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("fetchpriority", ctx_r2.fetchPriority)("role", ctx_r2.media.role)("width", ctx_r2.media.width)("height", ctx_r2.media.height);
  }
}
function MediaComponent_ng_container_0_ng_container_1_ng_template_2_img_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 9);
    i0.ɵɵlistener("load", function MediaComponent_ng_container_0_ng_container_1_ng_template_2_img_0_Template_img_load_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.loadHandler());
    })("error", function MediaComponent_ng_container_0_ng_container_1_ng_template_2_img_0_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.errorHandler());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("loading", ctx_r2.effectiveLoadingStrategy)("alt", ctx_r2.media.alt)("title", ctx_r2.media.alt)("src", ctx_r2.media.src, i0.ɵɵsanitizeUrl)("srcset", ctx_r2.media.srcset || ctx_r2.media.src);
    i0.ɵɵattribute("fetchpriority", ctx_r2.fetchPriority)("role", ctx_r2.media.role)("width", ctx_r2.media.width)("height", ctx_r2.media.height)("sizes", ctx_r2.sizesForImgElement);
  }
}
function MediaComponent_ng_container_0_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MediaComponent_ng_container_0_ng_container_1_ng_template_2_img_0_Template, 1, 10, "img", 8);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r2.media.src);
  }
}
function MediaComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MediaComponent_ng_container_0_ng_container_1_picture_1_Template, 3, 10, "picture", 4)(2, MediaComponent_ng_container_0_ng_container_1_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const imageElementTmp_r5 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!(ctx_r2.media == null ? null : ctx_r2.media.sources == null ? null : ctx_r2.media.sources.length) && ctx_r2.elementType !== "img")("ngIfElse", imageElementTmp_r5);
  }
}
function MediaComponent_ng_container_0_ng_container_2_picture_1_source_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "source", 11);
  }
  if (rf & 2) {
    const source_r7 = ctx.$implicit;
    i0.ɵɵproperty("srcset", source_r7.srcset)("media", source_r7.media);
  }
}
function MediaComponent_ng_container_0_ng_container_2_picture_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "picture");
    i0.ɵɵtemplate(1, MediaComponent_ng_container_0_ng_container_2_picture_1_source_1_Template, 1, 2, "source", 10);
    i0.ɵɵpipe(2, "cxMediaSources");
    i0.ɵɵelementStart(3, "img", 6);
    i0.ɵɵlistener("load", function MediaComponent_ng_container_0_ng_container_2_picture_1_Template_img_load_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.loadHandler());
    })("error", function MediaComponent_ng_container_0_ng_container_2_picture_1_Template_img_error_3_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.errorHandler());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 8, ctx_r2.media.srcset))("ngForTrackBy", ctx_r2.trackByMedia);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", ctx_r2.effectiveLoadingStrategy)("alt", ctx_r2.media.alt)("title", ctx_r2.media.alt)("src", ctx_r2.media.src, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("fetchpriority", ctx_r2.fetchPriority)("role", ctx_r2.media.role);
  }
}
function MediaComponent_ng_container_0_ng_container_2_ng_template_2_img_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 9);
    i0.ɵɵlistener("load", function MediaComponent_ng_container_0_ng_container_2_ng_template_2_img_0_Template_img_load_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.loadHandler());
    })("error", function MediaComponent_ng_container_0_ng_container_2_ng_template_2_img_0_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.errorHandler());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("loading", ctx_r2.effectiveLoadingStrategy)("alt", ctx_r2.media.alt)("title", ctx_r2.media.alt)("src", ctx_r2.media.src, i0.ɵɵsanitizeUrl)("srcset", (ctx_r2.media == null ? null : ctx_r2.media.srcset) || ctx_r2.media.src);
    i0.ɵɵattribute("fetchpriority", ctx_r2.fetchPriority)("role", ctx_r2.media.role);
  }
}
function MediaComponent_ng_container_0_ng_container_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MediaComponent_ng_container_0_ng_container_2_ng_template_2_img_0_Template, 1, 7, "img", 8);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r2.media.src);
  }
}
function MediaComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MediaComponent_ng_container_0_ng_container_2_picture_1_Template, 4, 10, "picture", 4)(2, MediaComponent_ng_container_0_ng_container_2_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const legacyImgTmp_r9 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.media.srcset && !ctx_r2.isLegacy)("ngIfElse", legacyImgTmp_r9);
  }
}
function MediaComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MediaComponent_ng_container_0_ng_container_1_Template, 4, 2, "ng-container", 3)(2, MediaComponent_ng_container_0_ng_container_2_Template, 4, 2, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "useExtendedMediaComponentConfiguration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!useExtendedMediaComponentConfiguration");
  }
}
const _c21 = (a0, a1) => [a0, a1];
function FormErrorsComponent_ng_container_0_ng_container_1_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const error_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, i0.ɵɵpureFunction2(4, _c21, ctx_r1.prefix + "." + error_r1[0], ctx_r1.fallbackPrefix + "." + error_r1[0]), ctx_r1.getTranslationParams(error_r1[1])), " ");
  }
}
function FormErrorsComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormErrorsComponent_ng_container_0_ng_container_1_p_1_Template, 3, 7, "p", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const errorDetails_r3 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", errorDetails_r3);
  }
}
function FormErrorsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormErrorsComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.hidden);
  }
}
const _c22 = (a0, a1, a2) => ({
  label: a0,
  max: a1,
  min: a2
});
const _c23 = ["fileInput"];
function FileUploadComponent_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function FileUploadComponent_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      i0.ɵɵnextContext();
      const fileInput_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(fileInput_r3.click());
    });
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.selectFile"));
  }
}
function FileUploadComponent_button_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FileUploadComponent_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function FileUploadComponent_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      i0.ɵɵnextContext();
      const fileInput_r3 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(fileInput_r3.click());
    });
    i0.ɵɵtemplate(1, FileUploadComponent_button_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r4.customButton);
  }
}
function FileUploadComponent_p_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const file_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", file_r6 == null ? null : file_r6.name, "\n");
  }
}
const _c24 = ["qty"];
const _c25 = () => ({
  key: "qty"
});
const _c26 = () => ({
  key: "decrement"
});
const _c27 = () => ({
  key: "increment"
});
function ItemCounterComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ItemCounterComponent_button_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.decrement());
    });
    i0.ɵɵtext(3, " -\n");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 5, "itemCounter.removeOne"));
    i0.ɵɵproperty("tabindex", ctx_r2.control.disabled || ctx_r2.control.value <= ctx_r2.min ? -1 : 0)("cxFocus", i0.ɵɵpureFunction0(9, _c26));
    i0.ɵɵattribute("aria-disabled", ctx_r2.control.disabled || ctx_r2.control.value <= ctx_r2.min)("aria-label", i0.ɵɵpipeBind1(2, 7, "itemCounter.removeOne"));
  }
}
function ItemCounterComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ItemCounterComponent_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.decrement());
    });
    i0.ɵɵtext(3, " -\n");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 5, "itemCounter.removeOne"));
    i0.ɵɵproperty("disabled", ctx_r2.control.disabled || ctx_r2.control.value <= ctx_r2.min)("tabindex", ctx_r2.control.disabled || ctx_r2.control.value <= ctx_r2.min ? -1 : 0)("cxFocus", i0.ɵɵpureFunction0(9, _c26));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 7, "itemCounter.removeOne"));
  }
}
function ItemCounterComponent_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ItemCounterComponent_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.increment());
    });
    i0.ɵɵtext(3, " +\n");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 4, "itemCounter.addOneMore"));
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(8, _c27));
    i0.ɵɵattribute("aria-disabled", ctx_r2.control.disabled || ctx_r2.control.value >= ctx_r2.max)("aria-label", i0.ɵɵpipeBind1(2, 6, "itemCounter.addOneMore"));
  }
}
function ItemCounterComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ItemCounterComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.increment());
    });
    i0.ɵɵtext(3, " +\n");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 4, "itemCounter.addOneMore"));
    i0.ɵɵproperty("disabled", ctx_r2.control.disabled || ctx_r2.control.value >= ctx_r2.max)("cxFocus", i0.ɵɵpureFunction0(8, _c27));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "itemCounter.addOneMore"));
  }
}
function GlobalMessageComponent_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const assistiveMsg_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, assistiveMsg_r1));
  }
}
function GlobalMessageComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵelement(2, "cx-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function GlobalMessageComponent_div_0_div_2_Template_button_click_6_listener() {
      const i_r3 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clear(ctx_r3.messageType.MSG_TYPE_CONFIRMATION, i_r3));
    });
    i0.ɵɵelement(8, "cx-icon", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const confMsg_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.SUCCESS);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, confMsg_r5));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 6, "common.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.CLOSE);
  }
}
function GlobalMessageComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 8);
    i0.ɵɵelement(2, "cx-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function GlobalMessageComponent_div_0_div_3_Template_button_click_6_listener() {
      const i_r7 = i0.ɵɵrestoreView(_r6).index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clear(ctx_r3.messageType.MSG_TYPE_INFO, i_r7));
    });
    i0.ɵɵelement(8, "cx-icon", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const infoMsg_r8 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.INFO);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, infoMsg_r8));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 6, "common.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.CLOSE);
  }
}
function GlobalMessageComponent_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "span", 8);
    i0.ɵɵelement(2, "cx-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function GlobalMessageComponent_div_0_div_4_Template_button_click_6_listener() {
      const i_r10 = i0.ɵɵrestoreView(_r9).index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clear(ctx_r3.messageType.MSG_TYPE_WARNING, i_r10));
    });
    i0.ɵɵelement(8, "cx-icon", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const infoMsg_r11 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.WARNING);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, infoMsg_r11));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 6, "common.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.CLOSE);
  }
}
function GlobalMessageComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "span", 8);
    i0.ɵɵelement(2, "cx-icon", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 10);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function GlobalMessageComponent_div_0_div_5_Template_button_click_6_listener() {
      const i_r13 = i0.ɵɵrestoreView(_r12).index;
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.clear(ctx_r3.messageType.MSG_TYPE_ERROR, i_r13));
    });
    i0.ɵɵelement(8, "cx-icon", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const errorMsg_r14 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.ERROR);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 4, errorMsg_r14));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 6, "common.close"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r3.iconTypes.CLOSE);
  }
}
function GlobalMessageComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, GlobalMessageComponent_div_0_div_1_Template, 4, 3, "div", 1)(2, GlobalMessageComponent_div_0_div_2_Template, 9, 8, "div", 2)(3, GlobalMessageComponent_div_0_div_3_Template, 9, 8, "div", 3)(4, GlobalMessageComponent_div_0_div_4_Template, 9, 8, "div", 4)(5, GlobalMessageComponent_div_0_div_5_Template, 9, 8, "div", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const messages_r15 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", messages_r15[ctx_r3.messageType.MSG_TYPE_ASSISTIVE]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", messages_r15[ctx_r3.messageType.MSG_TYPE_CONFIRMATION]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", messages_r15[ctx_r3.messageType.MSG_TYPE_INFO]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", messages_r15[ctx_r3.messageType.MSG_TYPE_WARNING]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", messages_r15[ctx_r3.messageType.MSG_TYPE_ERROR]);
  }
}
const _c28 = () => ({
  disableMouseFocus: true
});
function StorefrontComponent_ng_template_0_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "header", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("keydown.escape", function StorefrontComponent_ng_template_0_ng_template_0_Template_header_keydown_escape_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.collapseMenu());
    })("click", function StorefrontComponent_ng_template_0_ng_template_0_Template_header_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.collapseMenuIfClickOutside($event));
    });
    i0.ɵɵelement(2, "cx-page-layout", 5)(3, "cx-page-layout", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "cx-page-slot", 7)(5, "cx-global-message", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("is-expanded", i0.ɵɵpipeBind1(1, 4, ctx_r1.isExpanded$));
    i0.ɵɵproperty("cxFocus", ctx_r1.focusConfig);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxSkipFocus", ctx_r1.skipFocusConfig);
  }
}
function StorefrontComponent_ng_template_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "footer", 9);
    i0.ɵɵelement(1, "cx-page-layout", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(1, _c28));
  }
}
function StorefrontComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, StorefrontComponent_ng_template_0_ng_template_0_Template, 6, 6, "ng-template", 1);
    i0.ɵɵelementStart(1, "main", 2);
    i0.ɵɵelement(2, "router-outlet");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, StorefrontComponent_ng_template_0_ng_template_3_Template, 2, 2, "ng-template", 3);
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction0(1, _c28));
  }
}
const _c29 = (a0, a1) => ({
  ariaLabel: a0,
  ariaControls: a1
});
function SortingComponent_ng_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ng-option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const sort_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", sort_r1.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(sort_r1.name ? sort_r1.name : ctx_r1.sortLabels && sort_r1.code ? ctx_r1.sortLabels[sort_r1.code] : "");
  }
}
const _c30 = a0 => ({
  key: a0
});
function PaginationComponent_a_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function PaginationComponent_a_0_Template_a_click_0_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.pageChange(item_r2));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(item_r2.type);
    i0.ɵɵclassProp("disabled", ctx_r2.isInactive(item_r2))("current", ctx_r2.isCurrent(item_r2));
    i0.ɵɵproperty("routerLink", ctx_r2.pageRoute)("queryParams", ctx_r2.getQueryParams(item_r2))("tabIndex", ctx_r2.isInactive(item_r2) ? -1 : 0)("cxFocus", i0.ɵɵpureFunction1(19, _c30, ctx_r2.paginationID + i_r4.toString()));
    i0.ɵɵattribute("aria-current", ctx_r2.isCurrent(item_r2))("aria-disabled", ctx_r2.isInactive(item_r2))("aria-label", i0.ɵɵpipeBind1(1, 15, ctx_r2.getAriaLabel$(item_r2)))("title", i0.ɵɵpipeBind1(2, 17, ctx_r2.getAriaLabel$(item_r2)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r2.label, "\n");
  }
}
function TotalComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 1);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.totalResults, " ", i0.ɵɵpipeBind1(3, 6, "common.results"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate4(" ", ctx_r0.fromItem, "-", ctx_r0.toItem, " ", i0.ɵɵpipeBind1(7, 8, "common.of"), " ", ctx_r0.totalResults, " ");
  }
}
function ProgressButtonComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "spinner.loading"));
  }
}
function PromotionsComponent_div_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.promotions[0].description);
  }
}
function PromotionsComponent_div_0_ng_container_2_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const promotion_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", promotion_r2.description, " ");
  }
}
function PromotionsComponent_div_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ul");
    i0.ɵɵtemplate(2, PromotionsComponent_div_0_ng_container_2_li_2_Template, 2, 1, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.promotions);
  }
}
function PromotionsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, PromotionsComponent_div_0_ng_container_1_Template, 3, 1, "ng-container", 2)(2, PromotionsComponent_div_0_ng_container_2_Template, 3, 1, "ng-container", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.promotions.length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.promotions.length > 1);
  }
}
function SiteContextSelectorComponent_label_0_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const items_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("value", item_r3.isocode);
    i0.ɵɵproperty("selected", i0.ɵɵpipeBind1(1, 4, ctx_r1.activeItem$) === item_r3.isocode);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, ctx_r1.ariaLabel$(item_r3.label, i_r4, items_r5.length)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r3.label, " ");
  }
}
function SiteContextSelectorComponent_label_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "select", 1);
    i0.ɵɵlistener("change", function SiteContextSelectorComponent_label_0_Template_select_change_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.active = $event.target.value);
    });
    i0.ɵɵtemplate(5, SiteContextSelectorComponent_label_0_option_5_Template, 4, 8, "option", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "cx-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 3, ctx_r1.label$), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", items_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CARET_DOWN);
  }
}
function SiteThemeSwitcherComponent_label_0_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const theme_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const themes_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("value", theme_r3.className);
    i0.ɵɵproperty("selected", i0.ɵɵpipeBind1(1, 4, ctx_r1.activeItem$) === theme_r3.className);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, ctx_r1.ariaLabel$(theme_r3, i_r4, themes_r5.length)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", theme_r3.i18nNameKey ? i0.ɵɵpipeBind1(4, 8, theme_r3.i18nNameKey) : theme_r3.className, " ");
  }
}
function SiteThemeSwitcherComponent_label_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "select", 1);
    i0.ɵɵlistener("change", function SiteThemeSwitcherComponent_label_0_Template_select_change_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.activeItem = $event.target.value);
    });
    i0.ɵɵtemplate(5, SiteThemeSwitcherComponent_label_0_option_5_Template, 5, 10, "option", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "cx-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const themes_r5 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "siteThemeSwitcher.theme"), ":");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", themes_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CARET_DOWN);
  }
}
const _c31 = a0 => ({
  rating: a0
});
const _c32 = () => [1, 2, 3, 4, 5];
const _c33 = a0 => ({
  count: a0
});
function StarRatingComponent_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function StarRatingComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, StarRatingComponent_div_0_ng_container_3_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const starRating_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind2(1, 3, "productReview.ratedOutOf", i0.ɵɵpureFunction1(9, _c31, ctx_r0.rating.toFixed(1))));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 6, "productReview.ratedOutOf", i0.ɵɵpureFunction1(11, _c31, ctx_r0.rating.toFixed(1))));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", starRating_r2);
  }
}
function StarRatingComponent_ng_template_1_cx_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-icon", 5);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("mouseover", function StarRatingComponent_ng_template_1_cx_icon_0_Template_cx_icon_mouseover_0_listener() {
      const i_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.setRate(i_r4));
    })("click", function StarRatingComponent_ng_template_1_cx_icon_0_Template_cx_icon_click_0_listener() {
      const i_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.saveRate(i_r4));
    })("keydown.space", function StarRatingComponent_ng_template_1_cx_icon_0_Template_cx_icon_keydown_space_0_listener() {
      const i_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.saveRate(i_r4));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r4 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r0.icon);
    i0.ɵɵattribute("aria-current", !ctx_r0.disabled && i_r4 === ctx_r0.rating)("tabindex", ctx_r0.disabled ? null : 0)("role", ctx_r0.disabled ? null : "button")("aria-label", !ctx_r0.disabled ? i0.ɵɵpipeBind2(1, 6, "productReview.addRate", i0.ɵɵpureFunction1(9, _c33, i_r4)) : null)("aria-hidden", ctx_r0.disabled);
  }
}
function StarRatingComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, StarRatingComponent_ng_template_1_cx_icon_0_Template, 2, 11, "cx-icon", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c32));
  }
}
function TableComponent_table_0_ng_container_1_tbody_1_tr_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const cell_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", cell_r4, " ");
  }
}
function TableComponent_table_0_ng_container_1_tbody_1_tr_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const cell_r4 = i0.ɵɵnextContext().$implicit;
    const item_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r2[cell_r4], " ");
  }
}
function TableComponent_table_0_ng_container_1_tbody_1_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th");
    i0.ɵɵtemplate(2, TableComponent_table_0_ng_container_1_tbody_1_tr_1_ng_template_2_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtemplate(4, TableComponent_table_0_ng_container_1_tbody_1_tr_1_ng_template_4_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const cell_r4 = ctx.$implicit;
    const item_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(cell_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r2.getHeaderOutletRef(cell_r4))("cxOutletContext", ctx_r2.getHeaderOutletContext(cell_r4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r2.getDataOutletRef(cell_r4))("cxOutletContext", ctx_r2.getDataOutletContext(cell_r4, item_r2));
  }
}
function TableComponent_table_0_ng_container_1_tbody_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody", 2);
    i0.ɵɵlistener("click", function TableComponent_table_0_ng_container_1_tbody_1_Template_tbody_click_0_listener() {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.launchItem(item_r2));
    });
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_1_tbody_1_tr_1_Template, 5, 6, "tr", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-current", ctx_r2.isCurrentItem(item_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.structure.cells);
  }
}
function TableComponent_table_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_1_tbody_1_Template, 2, 3, "tbody", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data)("ngForTrackBy", ctx_r2.trackData);
  }
}
function TableComponent_table_0_ng_container_2_th_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const cell_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", cell_r5, " ");
  }
}
function TableComponent_table_0_ng_container_2_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 6);
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_2_th_3_ng_template_1_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cell_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(cell_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r2.getHeaderOutletRef(cell_r5))("cxOutletContext", ctx_r2.getHeaderOutletContext(cell_r5));
  }
}
function TableComponent_table_0_ng_container_2_tr_4_td_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const cell_r8 = i0.ɵɵnextContext().$implicit;
    const item_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r7[cell_r8], " ");
  }
}
function TableComponent_table_0_ng_container_2_tr_4_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_2_tr_4_td_1_ng_template_1_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cell_r8 = ctx.$implicit;
    const item_r7 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(cell_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r2.getDataOutletRef(cell_r8))("cxOutletContext", ctx_r2.getDataOutletContext(cell_r8, item_r7));
  }
}
function TableComponent_table_0_ng_container_2_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 2);
    i0.ɵɵlistener("click", function TableComponent_table_0_ng_container_2_tr_4_Template_tr_click_0_listener() {
      const item_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.launchItem(item_r7));
    });
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_2_tr_4_td_1_Template, 2, 4, "td", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-current", ctx_r2.isCurrentItem(item_r7));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.structure.cells);
  }
}
function TableComponent_table_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "thead")(2, "tr");
    i0.ɵɵtemplate(3, TableComponent_table_0_ng_container_2_th_3_Template, 2, 4, "th", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, TableComponent_table_0_ng_container_2_tr_4_Template, 2, 3, "tr", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r2.structure.cells);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data)("ngForTrackBy", ctx_r2.trackData);
  }
}
function TableComponent_table_0_ng_container_3_tr_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const cell_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", cell_r9, " ");
  }
}
function TableComponent_table_0_ng_container_3_tr_1_td_3_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    const cell_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r11[cell_r9], " ");
  }
}
function TableComponent_table_0_ng_container_3_tr_1_td_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 2);
    i0.ɵɵlistener("click", function TableComponent_table_0_ng_container_3_tr_1_td_3_Template_td_click_0_listener() {
      const item_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.launchItem(item_r11));
    });
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_3_tr_1_td_3_ng_template_1_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const cell_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("is-current", ctx_r2.isCurrentItem(item_r11));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r2.getDataOutletRef(cell_r9))("cxOutletContext", ctx_r2.getDataOutletContext(cell_r9, item_r11));
  }
}
function TableComponent_table_0_ng_container_3_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "th", 6);
    i0.ɵɵtemplate(2, TableComponent_table_0_ng_container_3_tr_1_ng_template_2_Template, 1, 1, "ng-template", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, TableComponent_table_0_ng_container_3_tr_1_td_3_Template, 2, 4, "td", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const cell_r9 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(cell_r9);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r2.getHeaderOutletRef(cell_r9))("cxOutletContext", ctx_r2.getHeaderOutletContext(cell_r9));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.data)("ngForTrackBy", ctx_r2.trackData);
  }
}
function TableComponent_table_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_3_tr_1_Template, 4, 6, "tr", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.structure.cells);
  }
}
function TableComponent_table_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵtemplate(1, TableComponent_table_0_ng_container_1_Template, 2, 2, "ng-container", 0)(2, TableComponent_table_0_ng_container_2_Template, 5, 3, "ng-container", 0)(3, TableComponent_table_0_ng_container_3_Template, 2, 1, "ng-container", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.verticalStackedLayout);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.verticalLayout);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.horizontalLayout);
  }
}
const _c34 = ["captcha"];
const _c35 = a0 => ({
  "right-align": a0
});
function AvatarComponent_div_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getInitials((ctx_r0.message == null ? null : ctx_r0.message.author) || ""), " ");
  }
}
function AvatarComponent_div_0_cx_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r0.iconTypes.USER);
  }
}
function AvatarComponent_div_0_cx_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("type", ctx_r0.iconTypes.HEADSET);
  }
}
function AvatarComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, AvatarComponent_div_0_span_1_Template, 2, 1, "span", 2)(2, AvatarComponent_div_0_cx_icon_2_Template, 1, 1, "cx-icon", 3)(3, AvatarComponent_div_0_cx_icon_3_Template, 1, 1, "cx-icon", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c35, ctx_r0.message.rightAlign));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.message.rightAlign && (ctx_r0.message == null ? null : ctx_r0.message.author));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.message.rightAlign && !(ctx_r0.message == null ? null : ctx_r0.message.author));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.message.rightAlign);
  }
}
const _c36 = a0 => ({
  "cx-message-display": a0
});
const _c37 = (a0, a1, a2) => ({
  author: a0,
  text: a1,
  date: a2
});
const _c38 = () => [];
function MessagingComponent_ng_container_0_ng_container_5_a_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11);
    i0.ɵɵlistener("click", function MessagingComponent_ng_container_0_ng_container_5_a_10_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const message_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onItemClicked(message_r4.item));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const message_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", message_r4.item.name, ":");
  }
}
function MessagingComponent_ng_container_0_ng_container_5_a_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 12);
    i0.ɵɵlistener("click", function MessagingComponent_ng_container_0_ng_container_5_a_12_Template_a_click_0_listener() {
      const attachment_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const message_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.triggerDownload(message_r4.code, attachment_r6.id, attachment_r6.filename));
    });
    i0.ɵɵelement(1, "cx-icon", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const attachment_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconTypes.ATTACHMENT);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", attachment_r6.filename, " ");
  }
}
function MessagingComponent_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "cx-avatar", 7);
    i0.ɵɵelementStart(3, "div")(4, "label");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵpipe(8, "cxDate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵtemplate(10, MessagingComponent_ng_container_0_ng_container_5_a_10_Template, 2, 1, "a", 9);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, MessagingComponent_ng_container_0_ng_container_5_a_12_Template, 3, 2, "a", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_7_0;
    let tmp_8_0;
    let tmp_10_0;
    let tmp_13_0;
    const message_r4 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c36, (tmp_5_0 = message_r4.rightAlign) !== null && tmp_5_0 !== undefined ? tmp_5_0 : false));
    i0.ɵɵadvance();
    i0.ɵɵproperty("message", message_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((tmp_7_0 = i0.ɵɵpipeBind2(6, 9, message_r4.createdAt, ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.dateFormat)) !== null && tmp_7_0 !== undefined ? tmp_7_0 : ctx_r1.dateFormat);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ((tmp_8_0 = message_r4.rightAlign) !== null && tmp_8_0 !== undefined ? tmp_8_0 : false) ? "cx-message-right-align-text" : "cx-message-left-align-text")("tabindex", i_r7 ? -1 : 0);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(9, 15, "chatMessaging.informationLabel", i0.ɵɵpureFunction3(20, _c37, message_r4.author, ctx_r1.getMessageText(message_r4), (tmp_10_0 = i0.ɵɵpipeBind2(8, 12, message_r4.createdAt, ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.dateFormat)) !== null && tmp_10_0 !== undefined ? tmp_10_0 : ctx_r1.dateFormat)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", message_r4.item);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", message_r4.text, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", (tmp_13_0 = message_r4.attachments) !== null && tmp_13_0 !== undefined ? tmp_13_0 : i0.ɵɵpureFunction0(24, _c38));
  }
}
function MessagingComponent_ng_container_0_div_6_select_6_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r9 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("value", item_r9.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r9.name, " ");
  }
}
function MessagingComponent_ng_container_0_div_6_select_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "select", 26);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtemplate(2, MessagingComponent_ng_container_0_div_6_select_6_option_2_Template, 2, 2, "option", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const itemList_r10 = ctx.ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "chatMessaging.a11y.itemListBoxLabel"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", itemList_r10);
  }
}
function MessagingComponent_ng_container_0_div_6_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 29);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "chatMessaging.characterLimitAlert"), " ");
  }
}
function MessagingComponent_ng_container_0_div_6_cx_file_upload_16_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 13);
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.UPLOAD);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(3, 2, "chatMessaging.uploadFile"), " ");
  }
}
function MessagingComponent_ng_container_0_div_6_cx_file_upload_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "cx-file-upload", 30);
    i0.ɵɵtemplate(1, MessagingComponent_ng_container_0_div_6_cx_file_upload_16_ng_template_1_Template, 4, 4, "ng-template");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControl", ctx_r1.form.get("file"))("accept", ctx_r1.allowedTypes);
  }
}
function MessagingComponent_ng_container_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "label", 16)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵtemplate(6, MessagingComponent_ng_container_0_div_6_select_6_Template, 3, 4, "select", 17);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 18)(9, "input", 19);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵlistener("keydown.enter", function MessagingComponent_ng_container_0_div_6_Template_input_keydown_enter_9_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSend());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, MessagingComponent_ng_container_0_div_6_span_11_Template, 3, 3, "span", 20);
    i0.ɵɵelementStart(12, "button", 21);
    i0.ɵɵlistener("click", function MessagingComponent_ng_container_0_div_6_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onSend());
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "div", 22);
    i0.ɵɵtemplate(16, MessagingComponent_ng_container_0_div_6_cx_file_upload_16_Template, 2, 2, "cx-file-upload", 23);
    i0.ɵɵelementStart(17, "p", 24);
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(20, "cx-form-errors", 25);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.form);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 11, "chatMessaging.addNewMessage"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 13, ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.itemList$));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("placeholder", (ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.newMessagePlaceHolder) || i0.ɵɵpipeBind1(10, 15, "chatMessaging.addMessagePlaceHolder"));
    i0.ɵɵproperty("maxLength", (ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.charactersLimit) || ctx_r1.MAX_INPUT_CHARACTERS);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.inputCharacterLeft === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", !!(ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.sendBtnIsNotPrimary) ? "btn-secondary" : "btn-primary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 17, "chatMessaging.send"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.enableFileUploadOption);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(19, 19, "chatMessaging.charactersLeft", i0.ɵɵpureFunction1(22, _c33, ctx_r1.inputCharacterLeft)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("control", ctx_r1.form.get("file"));
  }
}
function MessagingComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelement(2, "div", 2);
    i0.ɵɵelementStart(3, "div", 3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵlistener("keydown.arrowdown", function MessagingComponent_ng_container_0_Template_div_keydown_arrowdown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusNextChild($event));
    })("keydown.arrowup", function MessagingComponent_ng_container_0_Template_div_keydown_arrowup_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.focusPreviousChild($event));
    });
    i0.ɵɵtemplate(5, MessagingComponent_ng_container_0_ng_container_5_Template, 13, 25, "ng-container", 4);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, MessagingComponent_ng_container_0_div_6_Template, 21, 24, "div", 5);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const messageEvents_r11 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 3, "chatMessaging.messages"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", messageEvents_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 5, ctx_r1.messagingConfigs == null ? null : ctx_r1.messagingConfigs.displayAddMessageSection));
  }
}
function BannerComponent_ng_container_0_ng_container_1_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 6);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("innerHTML", data_r1.headline, i0.ɵɵsanitizeHtml);
  }
}
function BannerComponent_ng_container_0_ng_container_1_cx_media_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 7);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("container", ctx_r1.getImage(data_r1))("elementType", "picture");
  }
}
function BannerComponent_ng_container_0_ng_container_1_cx_media_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 8);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("container", ctx_r1.getImage(data_r1));
  }
}
function BannerComponent_ng_container_0_ng_container_1_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 9);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("innerHTML", data_r1.content, i0.ɵɵsanitizeHtml);
  }
}
function BannerComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-generic-link", 1);
    i0.ɵɵtemplate(2, BannerComponent_ng_container_0_ng_container_1_p_2_Template, 1, 1, "p", 2)(3, BannerComponent_ng_container_0_ng_container_1_cx_media_3_Template, 1, 2, "cx-media", 3)(4, BannerComponent_ng_container_0_ng_container_1_cx_media_4_Template, 1, 1, "cx-media", 4)(5, BannerComponent_ng_container_0_ng_container_1_p_5_Template, 1, 1, "p", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("url", ctx_r1.routerLink)("target", ctx_r1.getTarget(data_r1))("ariaLabel", ctx_r1.getLinkAriaLabel(data_r1));
    i0.ɵɵattribute("title", !data_r1.headline ? ctx_r1.getImageAltText(data_r1) : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", data_r1.headline);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "useExtendedMediaComponentConfiguration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!useExtendedMediaComponentConfiguration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", data_r1.content);
  }
}
function BannerComponent_ng_container_0_ng_container_2_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 6);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("innerHTML", data_r1.headline, i0.ɵɵsanitizeHtml);
  }
}
function BannerComponent_ng_container_0_ng_container_2_cx_media_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 7);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("container", ctx_r1.getImage(data_r1))("elementType", "picture");
  }
}
function BannerComponent_ng_container_0_ng_container_2_cx_media_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 8);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("container", ctx_r1.getImage(data_r1));
  }
}
function BannerComponent_ng_container_0_ng_container_2_p_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 9);
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("innerHTML", data_r1.content, i0.ɵɵsanitizeHtml);
  }
}
function BannerComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, BannerComponent_ng_container_0_ng_container_2_p_2_Template, 1, 1, "p", 2)(3, BannerComponent_ng_container_0_ng_container_2_cx_media_3_Template, 1, 2, "cx-media", 3)(4, BannerComponent_ng_container_0_ng_container_2_cx_media_4_Template, 1, 1, "cx-media", 4)(5, BannerComponent_ng_container_0_ng_container_2_p_5_Template, 1, 1, "p", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", data_r1.headline);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "useExtendedMediaComponentConfiguration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!useExtendedMediaComponentConfiguration");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", data_r1.content);
  }
}
function BannerComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, BannerComponent_ng_container_0_ng_container_1_Template, 6, 8, "ng-container", 0)(2, BannerComponent_ng_container_0_ng_container_2_Template, 6, 4, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.routerLink);
  }
}
function LinkComponent_cx_generic_link_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "cx-generic-link", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const data_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(data_r1.styleAttributes);
    i0.ɵɵproperty("url", (tmp_3_0 = data_r1.url) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "")("target", ctx_r1.getTarget(data_r1));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(data_r1.linkName);
  }
}
function ParagraphComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 1);
    i0.ɵɵpipe(1, "cxSupplementHashAnchors");
  }
  if (rf & 2) {
    const data_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r1.bypassSecurityTrustHtml(i0.ɵɵpipeBind1(1, 1, data_r1.content)), i0.ɵɵsanitizeHtml);
  }
}
function PDFComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "a", 2)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 3);
    i0.ɵɵelement(7, "cx-icon", 4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const data_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("href", ctx_r1.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.addPdfExtension((data_r1 == null ? null : data_r1.title) || (data_r1 == null ? null : data_r1.pdfFile == null ? null : data_r1.pdfFile.altText) || i0.ɵɵpipeBind1(5, 3, "pdf.defaultTitle")));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", "PDF_FILE");
  }
}
const _c39 = a0 => ({
  focusOnEscape: a0
});
function TabPanelComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.tab.content);
  }
}
const _c40 = ["tabHeader"];
const _c41 = () => ({});
const _c42 = a0 => ({
  tabNum: a0
});
function TabComponent_ng_container_0_ng_container_3_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext().index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r3.isOpen(i_r2) ? "\u2013" : "+", " ");
  }
}
function TabComponent_ng_container_0_ng_container_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const i_r2 = i0.ɵɵnextContext().index;
    i0.ɵɵnextContext();
    const tabPanel_r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", tabPanel_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c42, i_r2));
  }
}
function TabComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 4, 1);
    i0.ɵɵlistener("click", function TabComponent_ng_container_0_ng_container_3_Template_button_click_1_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const mode_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.select(i_r2, mode_r3));
    })("keydown", function TabComponent_ng_container_0_ng_container_3_Template_button_keydown_1_listener($event) {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const mode_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.handleKeydownEvent(i_r2, ctx_r3.tabs, mode_r3, $event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵtemplate(5, TabComponent_ng_container_0_ng_container_3_span_5_Template, 2, 1, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, TabComponent_ng_container_0_ng_container_3_ng_container_6_Template, 1, 4, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const tab_r6 = ctx.$implicit;
    const i_r2 = ctx.index;
    const mode_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r3.isOpen(i_r2));
    i0.ɵɵproperty("disabled", ctx_r3.disabled);
    i0.ɵɵattribute("role", mode_r3 === ctx_r3.TAB_MODE.ACCORDIAN ? "button" : "tab")("aria-selected", mode_r3 === ctx_r3.TAB_MODE.ACCORDIAN ? null : ctx_r3.isOpen(i_r2))("aria-expanded", mode_r3 === ctx_r3.TAB_MODE.TAB ? null : ctx_r3.isOpen(i_r2))("aria-controls", ctx_r3.isOpen(i_r2) ? "section-" + i_r2 : null)("tabindex", ctx_r3.getTabIndex(i_r2, mode_r3))("id", tab_r6.id)("title", ctx_r3.getTitle(mode_r3, i_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", tab_r6.headerKey ? i0.ɵɵpipeBind2(4, 13, tab_r6.headerKey, tab_r6.headerParams || i0.ɵɵpureFunction0(16, _c41)) : tab_r6.header, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", mode_r3 === ctx_r3.TAB_MODE.ACCORDIAN);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", mode_r3 === ctx_r3.TAB_MODE.ACCORDIAN);
  }
}
function TabComponent_ng_container_0_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 8);
  }
  if (rf & 2) {
    const i_r7 = ctx.index;
    i0.ɵɵnextContext(2);
    const tabPanel_r5 = i0.ɵɵreference(6);
    i0.ɵɵproperty("ngTemplateOutlet", tabPanel_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c42, i_r7));
  }
}
function TabComponent_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabComponent_ng_container_0_ng_container_4_ng_container_1_Template, 1, 4, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.tabs);
  }
}
function TabComponent_ng_container_0_ng_template_5_cx_tab_panel_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-tab-panel", 11);
  }
  if (rf & 2) {
    const tabNum_r8 = i0.ɵɵnextContext().tabNum;
    const mode_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tab", ctx_r3.tabs[tabNum_r8])("mode", mode_r3);
  }
}
function TabComponent_ng_container_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabComponent_ng_container_0_ng_template_5_cx_tab_panel_0_Template, 1, 2, "cx-tab-panel", 10);
  }
  if (rf & 2) {
    const tabNum_r8 = ctx.tabNum;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r3.isOpen(tabNum_r8));
  }
}
function TabComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵtemplate(3, TabComponent_ng_container_0_ng_container_3_Template, 7, 17, "ng-container", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TabComponent_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 2)(5, TabComponent_ng_container_0_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const mode_r3 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap(mode_r3.toLowerCase());
    i0.ɵɵattribute("role", mode_r3 === ctx_r3.TAB_MODE.ACCORDIAN ? null : "tablist")("aria-label", i0.ɵɵpipeBind1(2, 6, ctx_r3.config.label));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.tabs);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", mode_r3 === ctx_r3.TAB_MODE.TAB);
  }
}
const _c43 = ["tabRef"];
const _c44 = a0 => ({
  param: a0
});
function TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 10);
    i0.ɵɵlistener("cxComponentRef", function TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_ng_template_9_Template_ng_container_cxComponentRef_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r2.tabCompLoaded($event));
    });
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const component_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("cxComponentWrapper", component_r5);
  }
}
function TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 6);
    i0.ɵɵlistener("click", function TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const i_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.select(i_r2, $event));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelement(5, "span", 7);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵtemplate(9, TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_ng_template_9_Template, 1, 1, "ng-template", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    const component_r5 = ctx_r5.$implicit;
    const i_r2 = ctx_r5.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", i_r2 === ctx_r2.activeTabNum);
    i0.ɵɵattribute("aria-expanded", i_r2 === ctx_r2.activeTabNum);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 11, component_r5.title, i0.ɵɵpureFunction1(18, _c44, i0.ɵɵpipeBind1(3, 9, ctx_r2.tabTitleParams[i_r2]))), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i_r2 === ctx_r2.activeTabNum ? i0.ɵɵpipeBind1(6, 14, "common.collapse") : i0.ɵɵpipeBind1(7, 16, "common.expand"));
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("active", i_r2 === ctx_r2.activeTabNum);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", component_r5.flexType)("cxOutletContext", i0.ɵɵpureFunction0(20, _c41));
  }
}
function TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_ng_container_1_Template, 10, 21, "ng-container", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const component_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", component_r5);
  }
}
function TabParagraphContainerComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtemplate(2, TabParagraphContainerComponent_ng_container_0_div_1_ng_container_2_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const components_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, ctx_r2.ariaLabel));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", components_r7);
  }
}
function TabParagraphContainerComponent_ng_container_0_ng_container_2_4_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 10);
    i0.ɵɵlistener("cxComponentRef", function TabParagraphContainerComponent_ng_container_0_ng_container_2_4_ng_template_0_Template_ng_container_cxComponentRef_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const component_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.tabCompLoaded($event, component_r9.uid));
    });
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const component_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("cxComponentWrapper", component_r9);
  }
}
function TabParagraphContainerComponent_ng_container_0_ng_container_2_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TabParagraphContainerComponent_ng_container_0_ng_container_2_4_ng_template_0_Template, 1, 1, "ng-template", 12, 0, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const component_r9 = ctx.$implicit;
    i0.ɵɵproperty("cxOutlet", component_r9.flexType);
  }
}
function TabParagraphContainerComponent_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cx-tab", 11);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, TabParagraphContainerComponent_ng_container_0_ng_container_2_4_Template, 2, 1, null, 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const components_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabs", i0.ɵɵpipeBind1(2, 3, ctx_r2.tabs$))("config", i0.ɵɵpipeBind1(3, 5, ctx_r2.tabConfig$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", components_r7);
  }
}
function TabParagraphContainerComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TabParagraphContainerComponent_ng_container_0_div_1_Template, 3, 4, "div", 2)(2, TabParagraphContainerComponent_ng_container_0_ng_container_2_Template, 5, 7, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yTabComponent");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTabComponent");
  }
}
function VideoComponent_div_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.routerLink);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(data_r1.overlayTitle);
  }
}
function VideoComponent_div_0_video_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "video", 6);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const data_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", data_r1.videoContainerHeight, "px");
    i0.ɵɵproperty("poster", ctx_r1.thumbnail == null ? null : ctx_r1.thumbnail.src, i0.ɵɵsanitizeUrl)("loop", ctx_r1.loop)("autoplay", ctx_r1.autoPlay)("muted", ctx_r1.mute)("src", ctx_r1.source, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 8, "player.label"));
  }
}
function VideoComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, VideoComponent_div_0_a_1_Template, 2, 2, "a", 3)(2, VideoComponent_div_0_video_2_Template, 2, 10, "video", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const data_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", data_r1.overlayTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.source);
  }
}
function VideoComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c45 = ["element"];
const _c46 = () => ["/my-account/notification-preference"];
function MyCouponsComponent_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23)(1, "cx-coupon-card", 24);
    i0.ɵɵlistener("notificationChanged", function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_div_12_Template_cx_coupon_card_notificationChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.notificationChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const coupon_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("coupon", coupon_r4)("couponSubscriptionLoading$", ctx_r1.couponSubscriptionLoading$);
  }
}
function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8)(2, "label", 9)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cx-sorting", 10);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template_cx_sorting_sortListEvent_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.sortChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 11)(10, "cx-pagination", 12);
    i0.ɵɵlistener("viewPageEvent", function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template_cx_pagination_viewPageEvent_10_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "div", 13);
    i0.ɵɵtemplate(12, MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_div_12_Template, 2, 2, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 15)(14, "label", 16)(15, "span");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "cx-sorting", 17);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵpipe(20, "async");
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template_cx_sorting_sortListEvent_18_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.sortChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 18)(23, "cx-pagination", 19);
    i0.ɵɵlistener("viewPageEvent", function MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template_cx_pagination_viewPageEvent_23_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(24, "div", 20)(25, "span");
    i0.ɵɵelement(26, "cx-icon", 21);
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelementStart(29, "a", 22);
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const couponResult_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 19, "myCoupons.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("sortOptions", ctx_r1.sortOptions)("sortLabels", i0.ɵɵpipeBind1(7, 21, ctx_r1.sortLabels))("selectedOption", ctx_r1.sort)("ariaLabel", i0.ɵɵpipeBind1(8, 23, "myCoupons.sortCoupons"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", couponResult_r5.coupons);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 25, "myCoupons.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 27, "myCoupons.sortBy"));
    i0.ɵɵproperty("sortOptions", ctx_r1.sortOptions)("sortLabels", i0.ɵɵpipeBind1(20, 29, ctx_r1.sortLabels))("selectedOption", ctx_r1.sort)("ariaLabel", i0.ɵɵpipeBind1(21, 31, "myCoupons.sortCoupons"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.INFO);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 33, "myCoupons.notesPreffix"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(39, _c46));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 35, "myCoupons.notesLink"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 37, "myCoupons.notesSuffix"));
  }
}
function MyCouponsComponent_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MyCouponsComponent_ng_container_1_ng_container_2_ng_container_5_Template, 34, 40, "ng-container", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const couponResult_r5 = ctx.ngIf;
    i0.ɵɵnextContext();
    const noCoupons_r6 = i0.ɵɵreference(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "myCoupons.myCoupons"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", couponResult_r5.pagination && couponResult_r5.pagination.totalCount && couponResult_r5.pagination.totalCount > 0)("ngIfElse", noCoupons_r6);
  }
}
function MyCouponsComponent_ng_container_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section")(1, "p", 25);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "myCoupons.noCouponsMessage"), " ");
  }
}
function MyCouponsComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyCouponsComponent_ng_container_1_div_1_Template, 2, 3, "div", 4)(2, MyCouponsComponent_ng_container_1_ng_container_2_Template, 6, 5, "ng-container", 5);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, MyCouponsComponent_ng_container_1_ng_template_4_Template, 4, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 2, ctx_r1.couponResult$));
  }
}
function MyCouponsComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function CouponDialogComponent_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "myCoupons.dialogTitle"), " ");
  }
}
function CouponDialogComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "myCoupons.dialogTitle"), " ");
  }
}
const _c47 = a0 => ({
  label: a0
});
const _c48 = a0 => ({
  cxRoute: "product",
  params: a0
});
const _c49 = a0 => ({
  code: a0
});
const _c50 = a0 => ({
  expirationDate: a0
});
function MyInterestsComponent_div_0_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_thead_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 23)(1, "th", 24);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 24);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 24);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 25);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "myInterests.item"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "myInterests.price"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "myInterests.notifications"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 10, "myInterests.actions"), " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_thead_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 23)(1, "tr")(2, "th");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 4, "myInterests.item"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "myInterests.price"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, "myInterests.notifications"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 10, "myInterests.actions"), " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45)(1, "a", 46);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const product_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 2, i0.ɵɵpureFunction1(4, _c48, product_r4)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", product_r4.name, " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const product_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, "myInterests.productId", i0.ɵɵpureFunction1(4, _c49, product_r4.code)));
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_ng_container_12_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49)(1, "div", 50);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 51);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const variant_r5 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", variant_r5.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", variant_r5.value, " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_ng_container_12_div_1_Template, 5, 2, "div", 48);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const baseOptions_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", baseOptions_r6.selected == null ? null : baseOptions_r6.selected.variantOptionQualifiers);
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 49)(1, "div", 52);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "myInterests.outOfStock"), " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 53)(1, "span", 54);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 55);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxDate");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const interestEntry_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "myInterests." + interestEntry_r7.interestType), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 6, "myInterests.expirationDate", i0.ɵɵpureFunction1(9, _c50, i0.ɵɵpipeBind1(6, 4, interestEntry_r7.expirationDate))), " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 28)(2, "div", 29)(3, "div", 30)(4, "a", 31);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵelement(6, "cx-media", 32);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 33)(8, "div", 34)(9, "div");
    i0.ɵɵtemplate(10, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_10_Template, 4, 6, "div", 35)(11, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_11_Template, 4, 6, "div", 36)(12, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_ng_container_12_Template, 2, 1, "ng-container", 37)(13, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_13_Template, 4, 3, "div", 38);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(14, "td", 28)(15, "div", 39)(16, "div", 40);
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "span");
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(21, "td", 28)(22, "div", 41)(23, "div", 40);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_div_26_Template, 8, 11, "div", 42);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(27, "td", 28)(28, "div", 43)(29, "button", 44);
    i0.ɵɵpipe(30, "cxTranslate");
    i0.ɵɵpipe(31, "async");
    i0.ɵɵlistener("click", function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_Template_button_click_29_listener() {
      i0.ɵɵrestoreView(_r3);
      const interest_r8 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.removeInterest(interest_r8));
    });
    i0.ɵɵtext(32);
    i0.ɵɵpipe(33, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r4 = ctx.ngIf;
    const interest_r8 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 13, i0.ɵɵpureFunction1(25, _c48, product_r4)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", product_r4.images == null ? null : product_r4.images.PRIMARY);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", product_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r4.code);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", product_r4.baseOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (product_r4.stock == null ? null : product_r4.stock.stockLevelStatus) === "outOfStock");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(18, 15, "myInterests.price"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(product_r4.price == null ? null : product_r4.price.formattedValue);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(25, 17, "myInterests.notifications"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", interest_r8.productInterestEntry);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(30, 19, "myInterests.itemRemoved"))("disabled", i0.ɵɵpipeBind1(31, 21, ctx_r1.isRemoveDisabled$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(33, 23, "myInterests.remove"), " ");
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 26);
    i0.ɵɵtemplate(1, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_ng_container_1_Template, 34, 27, "ng-container", 27);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const interest_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, interest_r8.product$));
  }
}
function MyInterestsComponent_div_0_div_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10)(2, "label", 11)(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "cx-sorting", 12);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function MyInterestsComponent_div_0_div_5_ng_container_2_Template_cx_sorting_sortListEvent_6_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.sortChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 13)(11, "cx-pagination", 14);
    i0.ɵɵlistener("viewPageEvent", function MyInterestsComponent_div_0_div_5_ng_container_2_Template_cx_pagination_viewPageEvent_11_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "table", 15)(13, "caption", 16);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, MyInterestsComponent_div_0_div_5_ng_container_2_thead_16_Template, 13, 12, "thead", 17)(17, MyInterestsComponent_div_0_div_5_ng_container_2_thead_17_Template, 14, 12, "thead", 17);
    i0.ɵɵelementStart(18, "tbody");
    i0.ɵɵtemplate(19, MyInterestsComponent_div_0_div_5_ng_container_2_tr_19_Template, 3, 3, "tr", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 19)(21, "label", 20)(22, "span");
    i0.ɵɵtext(23);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "cx-sorting", 12);
    i0.ɵɵpipe(26, "cxTranslate");
    i0.ɵɵpipe(27, "async");
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function MyInterestsComponent_div_0_div_5_ng_container_2_Template_cx_sorting_sortListEvent_25_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.sortChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "div", 21)(30, "cx-pagination", 22);
    i0.ɵɵlistener("viewPageEvent", function MyInterestsComponent_div_0_div_5_ng_container_2_Template_cx_pagination_viewPageEvent_30_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const interests_r9 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 18, "myInterests.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(7, 20, "myInterests.sortBy"));
    i0.ɵɵproperty("sortOptions", ctx_r1.sortOptions)("sortLabels", i0.ɵɵpipeBind1(8, 22, ctx_r1.sortLabels))("selectedOption", ctx_r1.sort)("ariaLabel", i0.ɵɵpipeBind1(9, 24, "myInterests.sortInterests"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 26, "myInterests.caption"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yTableHeaderReadout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTableHeaderReadout");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", interests_r9.results);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(24, 28, "myInterests.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(26, 30, "myInterests.sortBy"));
    i0.ɵɵproperty("sortOptions", ctx_r1.sortOptions)("sortLabels", i0.ɵɵpipeBind1(27, 32, ctx_r1.sortLabels))("selectedOption", ctx_r1.sort)("ariaLabel", i0.ɵɵpipeBind1(28, 34, "myInterests.sortInterests"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
  }
}
function MyInterestsComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, MyInterestsComponent_div_0_div_5_div_1_Template, 2, 3, "div", 7)(2, MyInterestsComponent_div_0_div_5_ng_container_2_Template, 31, 36, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const interests_r9 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵnextContext();
    const noInterest_r10 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", interests_r9.pagination && interests_r9.pagination.totalCount && interests_r9.pagination.totalCount > 0)("ngIfElse", noInterest_r10);
  }
}
function MyInterestsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, MyInterestsComponent_div_0_div_5_Template, 3, 3, "div", 5);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const loading_r11 = i0.ɵɵreference(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "myInterests.header"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(6, 5, ctx_r1.getInterestsloading$))("ngIfElse", loading_r11);
  }
}
function MyInterestsComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "myInterests.noInterests"), " ");
  }
}
function MyInterestsComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function NotificationPreferenceComponent_ng_container_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function NotificationPreferenceComponent_ng_container_0_div_1_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "input", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("change", function NotificationPreferenceComponent_ng_container_0_div_1_ng_container_8_div_1_Template_input_change_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const preference_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.updatePreference(preference_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 13);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const preference_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("id", preference_r2.channel);
    i0.ɵɵproperty("checked", preference_r2.enabled)("disabled", i0.ɵɵpipeBind1(2, 6, ctx_r2.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("for", preference_r2.channel);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(5, 8, "notificationPreference." + preference_r2.channel), " ", preference_r2.value, " ");
  }
}
function NotificationPreferenceComponent_ng_container_0_div_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationPreferenceComponent_ng_container_0_div_1_ng_container_8_div_1_Template, 6, 10, "div", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const preference_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preference_r2.visible);
  }
}
function NotificationPreferenceComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, NotificationPreferenceComponent_ng_container_0_div_1_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "fieldset")(5, "legend", 6);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, NotificationPreferenceComponent_ng_container_0_div_1_ng_container_8_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 8)(10, "strong");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const preferences_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, "notificationPreference.message"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", preferences_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 7, "notificationPreference.note"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(14, 9, "notificationPreference.noteMessage"), " ");
  }
}
function NotificationPreferenceComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function NotificationPreferenceComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NotificationPreferenceComponent_ng_container_0_div_1_Template, 15, 11, "div", 2)(2, NotificationPreferenceComponent_ng_container_0_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const preferences_r4 = ctx.ngIf;
    const loading_r5 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preferences_r4.length > 0)("ngIfElse", loading_r5);
  }
}
function BreadcrumbComponent_li_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelement(1, "a", 2);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const crumb_r1 = ctx.$implicit;
    const crumbList_r2 = ctx.ngForOf;
    const i_r3 = ctx.index;
    const last_r4 = ctx.last;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", crumb_r1.link)("innerHTML", crumb_r1.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", last_r4 ? i0.ɵɵpipeBind1(2, 3, "common.breadcrumbsCurrentPage") + " " + crumb_r1.label + (i_r3 + 1) + i0.ɵɵpipeBind1(3, 5, "common.of") + crumbList_r2.length : crumb_r1.label + (i_r3 + 1) + i0.ɵɵpipeBind1(4, 7, "common.of") + crumbList_r2.length);
  }
}
const _c51 = a0 => ({
  node: a0,
  depth: 0
});
const _c52 = (a0, a1, a2) => ({
  title: a0,
  position: a1,
  listLength: a2
});
const _c53 = a0 => ({
  title: a0
});
const _c54 = (a0, a1, a2, a3) => ({
  node: a0,
  depth: a1,
  listLength: a2,
  position: a3
});
function NavigationUIComponent_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 6)(1, "button", 7);
    i0.ɵɵlistener("click", function NavigationUIComponent_li_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵelement(2, "cx-icon", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r1.iconType.CARET_LEFT);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "common.back"), " ");
  }
}
function NavigationUIComponent_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavigationUIComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NavigationUIComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const child_r3 = ctx.$implicit;
    i0.ɵɵnextContext();
    const nav_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c51, child_r3));
  }
}
function NavigationUIComponent_ng_template_4_cx_generic_link_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-generic-link", 12);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function NavigationUIComponent_ng_template_4_cx_generic_link_1_Template_cx_generic_link_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const node_r6 = i0.ɵɵnextContext().node;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeIfClickedTheSameLink(node_r6));
    })("focus", function NavigationUIComponent_ng_template_4_cx_generic_link_1_Template_cx_generic_link_focus_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const depth_r7 = i0.ɵɵnextContext().depth;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(depth_r7 || ctx_r1.reinitializeMenu());
    })("keydown.space", function NavigationUIComponent_ng_template_4_cx_generic_link_1_Template_cx_generic_link_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleOpen($event));
    })("keydown.esc", function NavigationUIComponent_ng_template_4_cx_generic_link_1_Template_cx_generic_link_keydown_esc_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.back());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const node_r6 = ctx_r7.node;
    const depth_r7 = ctx_r7.depth;
    const listLength_r9 = ctx_r7.listLength;
    const position_r10 = ctx_r7.position;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(node_r6.styleAttributes);
    i0.ɵɵclassMap(node_r6.styleClasses);
    i0.ɵɵproperty("ariaLabel", i0.ɵɵpipeBind2(1, 9, "navigation.linkItemInList", i0.ɵɵpureFunction3(12, _c52, node_r6.title, position_r10, listLength_r9)))("url", node_r6.url)("target", node_r6.target)("tabindex", ctx_r1.getTabIndex(node_r6, depth_r7));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_cx_generic_link_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-generic-link", 16);
    i0.ɵɵlistener("click", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_cx_generic_link_1_Template_cx_generic_link_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const node_r6 = i0.ɵɵnextContext(3).node;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeIfClickedTheSameLink(node_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(3).node;
    i0.ɵɵproperty("url", node_r6.url)("target", node_r6.target);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(4).node;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.toggleOpen($event));
    })("mouseenter", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_mouseenter_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onMouseEnter($event));
    })("keydown.space", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_keydown_space_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onSpace($event));
    })("keydown.enter", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_keydown_enter_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onSpace($event));
    })("keydown.esc", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_keydown_esc_1_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.back());
    })("keydown.arrowDown", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_keydown_arrowDown_1_listener($event) {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.focusOnNode($event));
    })("focus", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template_button_focus_1_listener() {
      i0.ɵɵrestoreView(_r12);
      const depth_r7 = i0.ɵɵnextContext(3).depth;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(depth_r7 || ctx_r1.reinitializeMenu());
    });
    i0.ɵɵtemplate(3, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelement(4, "cx-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    const node_r6 = ctx_r7.node;
    const depth_r7 = ctx_r7.depth;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("role", i0.ɵɵpipeBind1(2, 7, ctx_r1.isDesktop$) && depth_r7 ? "heading" : "button")("aria-haspopup", true)("aria-expanded", false)("aria-controls", node_r6.title)("aria-describedby", "greeting");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !node_r6.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconType.CARET_DOWN);
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_h4_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "h4", 20);
    i0.ɵɵlistener("keydown.arrowDown", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_h4_1_Template_h4_keydown_arrowDown_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.focusOnNode($event));
    })("keydown.space", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_h4_1_Template_h4_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onSpace($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(4).node;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(5).node;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.toggleOpen($event));
    })("mouseenter", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_mouseenter_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onMouseEnter($event));
    })("keydown.space", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onSpace($event));
    })("keydown.enter", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onSpace($event));
    })("keydown.esc", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_keydown_esc_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.back());
    })("keydown.arrowDown", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_keydown_arrowDown_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.focusOnNode($event));
    })("focus", function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template_button_focus_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const depth_r7 = i0.ɵɵnextContext(4).depth;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(depth_r7 || ctx_r1.reinitializeMenu());
    });
    i0.ɵɵtemplate(2, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_ng_container_2_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelement(3, "cx-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(4).node;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-haspopup", true)("aria-expanded", false)("aria-label", node_r6.url ? node_r6.title : null)("aria-controls", ctx_r1.transformIntoValidID(node_r6.title))("title", i0.ɵɵpipeBind2(1, 7, "navigation.menuButonTitle", i0.ɵɵpureFunction1(10, _c53, node_r6.title)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !node_r6.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.iconType.CARET_DOWN);
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_h4_1_Template, 2, 1, "h4", 19);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_ng_template_3_Template, 4, 12, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const dropdownHeader_r15 = i0.ɵɵreference(4);
    const depth_r7 = i0.ɵɵnextContext(3).depth;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.isDesktop$) && depth_r7)("ngIfElse", dropdownHeader_r15);
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_cx_generic_link_1_Template, 2, 3, "cx-generic-link", 14)(2, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_2_Template, 5, 9, "ng-container", 15)(3, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_ng_container_3_Template, 5, 4, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).node;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.url);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yNavigationButtonsAriaFixes");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yNavigationButtonsAriaFixes");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_template_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(3).node;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("tabindex", ctx_r1.focusableNodeTitles ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", node_r6.title, " ");
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NavigationUIComponent_ng_template_4_ng_template_2_ng_template_1_span_0_Template, 2, 2, "span", 22);
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext(2).node;
    i0.ɵɵproperty("ngIf", node_r6.title);
  }
}
function NavigationUIComponent_ng_template_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NavigationUIComponent_ng_template_4_ng_template_2_ng_container_0_Template, 4, 3, "ng-container", 13)(1, NavigationUIComponent_ng_template_4_ng_template_2_ng_template_1_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const title_r16 = i0.ɵɵreference(2);
    const node_r6 = i0.ɵɵnextContext().node;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.flyout && (node_r6.children == null ? null : node_r6.children.length) > 0)("ngIfElse", title_r16);
  }
}
function NavigationUIComponent_ng_template_4_div_4_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NavigationUIComponent_ng_template_4_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, NavigationUIComponent_ng_template_4_div_4_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const child_r17 = ctx.$implicit;
    const i_r18 = ctx.index;
    const ctx_r7 = i0.ɵɵnextContext(2);
    const node_r6 = ctx_r7.node;
    const depth_r7 = ctx_r7.depth;
    i0.ɵɵnextContext();
    const nav_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", nav_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c54, child_r17, depth_r7 + 1, node_r6.children.length, i_r18 + 1));
  }
}
function NavigationUIComponent_ng_template_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "ul", 25);
    i0.ɵɵtemplate(2, NavigationUIComponent_ng_template_4_div_4_ng_container_2_Template, 2, 7, "ng-container", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const node_r6 = i0.ɵɵnextContext().node;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.transformIntoValidID(node_r6.title));
    i0.ɵɵadvance();
    i0.ɵɵattribute("depth", ctx_r1.getTotalDepth(node_r6))("wrap-after", node_r6.children.length > ctx_r1.wrapAfter ? ctx_r1.wrapAfter : null)("columns", ctx_r1.getColumnCount(node_r6.children.length))("aria-label", node_r6.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", node_r6.children);
  }
}
function NavigationUIComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, NavigationUIComponent_ng_template_4_cx_generic_link_1_Template, 3, 16, "cx-generic-link", 10)(2, NavigationUIComponent_ng_template_4_ng_template_2_Template, 3, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, NavigationUIComponent_ng_template_4_div_4_Template, 3, 6, "div", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const node_r6 = ctx.node;
    const depth_r7 = ctx.depth;
    const heading_r19 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("role", !ctx_r1.flyout && !depth_r7 ? "presentation" : "listitem");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", node_r6.url && (!node_r6.children || (node_r6.children == null ? null : node_r6.children.length) === 0))("ngIfElse", heading_r19);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", node_r6.children && node_r6.children.length > 0);
  }
}
function CategoryNavigationComponent_cx_navigation_ui_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-navigation-ui", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_4_0;
    const data_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("node", i0.ɵɵpipeBind1(1, 5, ctx_r1.node$))("ngClass", (tmp_3_0 = data_r1.styleClass) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "")("wrapAfter", +((tmp_4_0 = data_r1.wrapAfter) !== null && tmp_4_0 !== undefined ? tmp_4_0 : ""))("resetMenuOnClose", data_r1.resetMenuOnClose)("navAriaLabel", i0.ɵɵpipeBind1(2, 7, "navigation.categoryNavLabel"));
  }
}
function FooterNavigationComponent_cx_navigation_ui_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-navigation-ui", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "cxTranslate");
  }
  if (rf & 2) {
    let tmp_4_0;
    const node_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("node", node_r1)("flyout", false)("ngClass", (tmp_4_0 = i0.ɵɵpipeBind1(1, 4, ctx_r1.styleClass$)) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "")("navAriaLabel", i0.ɵɵpipeBind1(2, 6, "navigation.footerNavLabel"));
  }
}
const _c55 = ["searchInput"];
const _c56 = ["searchButton"];
const _c57 = a0 => ({
  query: a0
});
const _c58 = a0 => ({
  cxRoute: "search",
  params: a0
});
const _c59 = a0 => ({
  maxTrendingSearches: a0
});
const _c60 = (a0, a1, a2) => ({
  search: a0,
  searchBoxActive: a1,
  maxRecentSearches: a2
});
function SearchBoxComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "label", 7)(3, "input", 8, 0);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_0_Template_input_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const searchInput_r2 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.search(searchInput_r2.value));
    })("input", function SearchBoxComponent_div_0_Template_input_input_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const searchInput_r2 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.search(searchInput_r2.value));
    })("blur", function SearchBoxComponent_div_0_Template_input_blur_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.tab", function SearchBoxComponent_div_0_Template_input_keydown_tab_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.escape", function SearchBoxComponent_div_0_Template_input_keydown_escape_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.enter", function SearchBoxComponent_div_0_Template_input_keydown_enter_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const searchInput_r2 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.close(true);
      ctx_r2.launchSearchResult(searchInput_r2.value);
      return i0.ɵɵresetView(ctx_r2.updateChosenWord(searchInput_r2.value));
    })("keydown.arrowup", function SearchBoxComponent_div_0_Template_input_keydown_arrowup_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusPreviousChild($event));
    })("keydown.arrowdown", function SearchBoxComponent_div_0_Template_input_keydown_arrowdown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusNextChild($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 9);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_0_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const searchInput_r2 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clear(searchInput_r2));
    });
    i0.ɵɵelement(11, "cx-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 11);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelement(14, "cx-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 12, 1);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵpipe(18, "cxTranslate");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_0_Template_button_click_15_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open());
    });
    i0.ɵɵelement(19, "cx-icon", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const searchInput_r2 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 15, "searchBox.productSearch"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("dirty", !!searchInput_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("value", ctx_r2.chosenWord);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(5, 17, "searchBox.placeholder"));
    i0.ɵɵattribute("tabindex", ctx_r2.getTabIndex(i0.ɵɵpipeBind1(6, 19, ctx_r2.isMobile)))("aria-label", i0.ɵɵpipeBind1(7, 21, "searchBox.placeholder"));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(9, 23, "common.reset"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(10, 25, "common.reset"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.RESET);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(13, 27, "common.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.SEARCH);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(17, 29, "common.search"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(18, 31, "common.search"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.SEARCH);
  }
}
function SearchBoxComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "label", 14)(3, "span", 15);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16)(7, "input", 8, 0);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_1_Template_input_click_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open());
    })("input", function SearchBoxComponent_div_1_Template_input_input_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const searchInput_r5 = i0.ɵɵreference(8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.search(searchInput_r5.value));
    })("blur", function SearchBoxComponent_div_1_Template_input_blur_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.tab", function SearchBoxComponent_div_1_Template_input_keydown_tab_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.escape", function SearchBoxComponent_div_1_Template_input_keydown_escape_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    })("keydown.enter", function SearchBoxComponent_div_1_Template_input_keydown_enter_7_listener() {
      i0.ɵɵrestoreView(_r4);
      const searchInput_r5 = i0.ɵɵreference(8);
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.close(true);
      ctx_r2.launchSearchResult(searchInput_r5.value);
      return i0.ɵɵresetView(ctx_r2.updateChosenWord(searchInput_r5.value));
    })("keydown.arrowup", function SearchBoxComponent_div_1_Template_input_keydown_arrowup_7_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusPreviousChild($event));
    })("keydown.arrowdown", function SearchBoxComponent_div_1_Template_input_keydown_arrowdown_7_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.focusNextChild($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 9);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_1_Template_button_click_11_listener() {
      i0.ɵɵrestoreView(_r4);
      const searchInput_r5 = i0.ɵɵreference(8);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clear(searchInput_r5));
    });
    i0.ɵɵelement(14, "cx-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 11);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelement(17, "cx-icon", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(18, "button", 12, 1);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵpipe(21, "cxTranslate");
    i0.ɵɵlistener("click", function SearchBoxComponent_div_1_Template_button_click_18_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.open());
    });
    i0.ɵɵelement(22, "cx-icon", 10);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const searchInput_r5 = i0.ɵɵreference(8);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 15, "searchBox.productSearch"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("dirty", !!(searchInput_r5 == null ? null : searchInput_r5.value));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 17, "common.search"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("value", ctx_r2.chosenWord);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(9, 19, "searchBox.placeholder"));
    i0.ɵɵattribute("tabindex", ctx_r2.getTabIndex(i0.ɵɵpipeBind1(10, 21, ctx_r2.isMobile)));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(12, 23, "common.reset"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(13, 25, "common.reset"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.RESET);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(16, 27, "common.search"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.SEARCH);
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(20, 29, "common.search"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(21, 31, "common.search"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("type", ctx_r2.iconTypes.SEARCH);
  }
}
function SearchBoxComponent_div_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 28);
    i0.ɵɵlistener("keydown.arrowdown", function SearchBoxComponent_div_2_button_1_Template_button_keydown_arrowdown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusPreviousGroup($event));
    })("click", function SearchBoxComponent_div_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "searchBox.closeSearchPanel"), " ");
  }
}
function SearchBoxComponent_div_2_h3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "h3", 29);
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("innerHTML", result_r8.message, i0.ɵɵsanitizeHtml);
  }
}
function SearchBoxComponent_div_2_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "searchBox.suggestions"), " ");
  }
}
function SearchBoxComponent_div_2_div_3_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 33)(1, "a", 34);
    i0.ɵɵpipe(2, "cxHighlight");
    i0.ɵɵpipe(3, "cxUrl");
    i0.ɵɵlistener("keydown.arrowup", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_arrowup_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusPreviousChild($event));
    })("keydown.arrowdown", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_arrowdown_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusNextChild($event));
    })("keydown.arrowleft", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_arrowleft_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusPreviousGroup($event));
    })("keydown.arrowright", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_arrowright_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusNextGroup($event));
    })("keydown.enter", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("keydown.escape", function SearchBoxComponent_div_2_div_3_li_4_Template_a_keydown_escape_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("blur", function SearchBoxComponent_div_2_div_3_li_4_Template_a_blur_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close());
    })("mousedown", function SearchBoxComponent_div_2_div_3_li_4_Template_a_mousedown_1_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.preventDefault($event));
    })("click", function SearchBoxComponent_div_2_div_3_li_4_Template_a_click_1_listener() {
      let tmp_6_0;
      const suggestion_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const result_r8 = i0.ɵɵnextContext(2).ngIf;
      const ctx_r2 = i0.ɵɵnextContext();
      ctx_r2.dispatchSuggestionEvent({
        freeText: ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value,
        selectedSuggestion: suggestion_r10,
        searchSuggestions: (tmp_6_0 = result_r8.suggestions) !== null && tmp_6_0 !== undefined ? tmp_6_0 : []
      });
      return i0.ɵɵresetView(ctx_r2.updateChosenWord(suggestion_r10));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const suggestion_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 2, suggestion_r10, ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value), i0.ɵɵsanitizeHtml)("routerLink", i0.ɵɵpipeBind1(3, 5, i0.ɵɵpureFunction1(9, _c58, i0.ɵɵpureFunction1(7, _c57, suggestion_r10))));
  }
}
function SearchBoxComponent_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_div_3_ng_container_1_Template, 4, 3, "ng-container", 22);
    i0.ɵɵelementStart(2, "ul", 31);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, SearchBoxComponent_div_2_div_3_li_4_Template, 4, 11, "li", 32);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE) || ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("no-headers", !ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE) && !ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 5, "searchBox.ariaLabelSuggestions"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", result_r8.suggestions);
  }
}
function SearchBoxComponent_div_2_ng_container_5_ng_container_1_ng_template_1_Template(rf, ctx) {}
function SearchBoxComponent_div_2_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_ng_container_5_ng_container_1_ng_template_1_Template, 0, 0, "ng-template", 36);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r2.searchBoxOutlets.TRENDING_SEARCHES)("cxOutletContext", i0.ɵɵpureFunction1(2, _c59, ctx_r2.config.maxTrendingSearches));
  }
}
function SearchBoxComponent_div_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_ng_container_5_ng_container_1_Template, 2, 4, "ng-container", 35);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE);
  }
}
function SearchBoxComponent_div_2_6_ng_template_0_Template(rf, ctx) {}
function SearchBoxComponent_div_2_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SearchBoxComponent_div_2_6_ng_template_0_Template, 0, 0, "ng-template", 36);
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cxOutlet", ctx_r2.searchBoxOutlets.RECENT_SEARCHES)("cxOutletContext", i0.ɵɵpureFunction3(2, _c60, (tmp_4_0 = ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "", ctx_r2.searchBoxActive, ctx_r2.config.maxRecentSearches));
  }
}
function SearchBoxComponent_div_2_ng_container_8_h3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "searchBox.products"), " ");
  }
}
function SearchBoxComponent_div_2_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_ng_container_8_h3_1_Template, 3, 3, "h3", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", result_r8.products == null ? null : result_r8.products.length);
  }
}
function SearchBoxComponent_div_2_ul_9_li_2_cx_media_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-media", 42);
  }
  if (rf & 2) {
    const product_r12 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("container", product_r12.images == null ? null : product_r12.images.PRIMARY);
  }
}
function SearchBoxComponent_div_2_ul_9_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 33)(1, "a", 38);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵlistener("keydown.arrowup", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_arrowup_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusPreviousChild($event));
    })("keydown.arrowdown", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_arrowdown_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusNextChild($event));
    })("keydown.arrowleft", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_arrowleft_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusPreviousGroup($event));
    })("keydown.arrowright", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_arrowright_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.focusNextGroup($event));
    })("keydown.enter", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("keydown.escape", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_keydown_escape_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("blur", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_blur_1_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close());
    })("mousedown", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_mousedown_1_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.preventDefault($event));
    })("click", function SearchBoxComponent_div_2_ul_9_li_2_Template_a_click_1_listener() {
      const product_r12 = i0.ɵɵrestoreView(_r11).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dispatchProductEvent({
        freeText: ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value,
        productCode: product_r12.code
      }));
    });
    i0.ɵɵtemplate(3, SearchBoxComponent_div_2_ul_9_li_2_cx_media_3_Template, 1, 1, "cx-media", 39);
    i0.ɵɵelement(4, "div", 40);
    i0.ɵɵelementStart(5, "span", 41);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const product_r12 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("has-media", ctx_r2.config.displayProductImages);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 6, i0.ɵɵpureFunction1(8, _c48, product_r12)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.config.displayProductImages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", product_r12.nameHtml, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(product_r12.price == null ? null : product_r12.price.formattedValue);
  }
}
function SearchBoxComponent_div_2_ul_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 37);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtemplate(2, SearchBoxComponent_div_2_ul_9_li_2_Template, 7, 10, "li", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("hidden", ctx_r2.hasSearchBoxV2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, "searchBox.ariaLabelProducts"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", result_r8.products);
  }
}
function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 44);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵlistener("keydown.enter", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_keydown_enter_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("keydown.escape", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_keydown_escape_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.close(true));
    })("keydown.arrowleft", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_keydown_arrowleft_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.carouselEventPropagator($event));
    })("keydown.arrowright", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_keydown_arrowright_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.carouselEventPropagator($event));
    })("keydown.arrowup", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_keydown_arrowup_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.carouselEventPropagator($event));
    })("mousedown", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_mousedown_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.preventDefault($event));
    })("click", function SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template_a_click_0_listener() {
      const product_r15 = i0.ɵɵrestoreView(_r14).item;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.dispatchProductEvent({
        freeText: ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value,
        productCode: product_r15.code
      }));
    });
    i0.ɵɵelement(2, "cx-media", 45)(3, "h3", 46);
    i0.ɵɵelementStart(4, "div", 41);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 47);
    i0.ɵɵelementContainer(7, 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_10_0;
    const product_r15 = ctx.item;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("has-media", ctx_r2.config.displayProductImages);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 7, i0.ɵɵpureFunction1(9, _c48, product_r15)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", product_r15.images == null ? null : product_r15.images.PRIMARY)("alt", (tmp_10_0 = product_r15.name) !== null && tmp_10_0 !== undefined ? tmp_10_0 : "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", product_r15.nameHtml, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", product_r15.price == null ? null : product_r15.price.formattedValue, " ");
  }
}
function SearchBoxComponent_div_2_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cx-carousel", 43);
    i0.ɵɵlistener("keybordEvent", function SearchBoxComponent_div_2_ng_container_10_Template_cx_carousel_keybordEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.carouselEventPropagator($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, SearchBoxComponent_div_2_ng_container_10_ng_template_2_Template, 8, 11, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const items_r16 = ctx.ngIf;
    const carouselItem_r17 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("items", items_r16)("template", carouselItem_r17);
  }
}
function SearchBoxComponent_div_2_div_12_h3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "h3", 51);
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("innerHTML", result_r8.message, i0.ɵɵsanitizeHtml);
  }
}
function SearchBoxComponent_div_2_div_12_ng_container_2_h3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 56);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "searchBox.trendingSearches"), " ");
  }
}
function SearchBoxComponent_div_2_div_12_ng_container_2_h3_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 57);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "searchBox.products"), " ");
  }
}
function SearchBoxComponent_div_2_div_12_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3", 52);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, SearchBoxComponent_div_2_div_12_ng_container_2_h3_4_Template, 3, 3, "h3", 53);
    i0.ɵɵelementStart(5, "h3", 54);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SearchBoxComponent_div_2_div_12_ng_container_2_h3_8_Template, 3, 3, "h3", 55);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "searchBox.suggestions"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value == null ? null : ctx_r2.searchInputEl.nativeElement.value.length) === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 6, "searchBox.recentSearches"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", result_r8.products == null ? null : result_r8.products.length);
  }
}
function SearchBoxComponent_div_2_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_div_12_h3_1_Template, 1, 1, "h3", 50)(2, SearchBoxComponent_div_2_div_12_ng_container_2_Template, 9, 8, "ng-container", 22);
    i0.ɵɵelementStart(3, "button", 28);
    i0.ɵɵlistener("keydown.arrowdown", function SearchBoxComponent_div_2_div_12_Template_button_keydown_arrowdown_3_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.focusPreviousGroup($event));
    })("click", function SearchBoxComponent_div_2_div_12_Template_button_click_3_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("d-none", !ctx_r2.hasSearchBoxV2)("header-panel-divider", !result_r8.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", result_r8.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !result_r8.message);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "searchBox.closeSearchPanel"), " ");
  }
}
function SearchBoxComponent_div_2_div_16_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "searchBox.initialDescription"), " ");
  }
}
function SearchBoxComponent_div_2_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtemplate(4, SearchBoxComponent_div_2_div_16_ng_container_4_Template, 3, 3, "ng-container", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const result_r8 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(2, 3, "searchBox.suggestionsResult", i0.ɵɵpureFunction1(9, _c33, result_r8.suggestions == null ? null : result_r8.suggestions.length)), " ", i0.ɵɵpipeBind2(3, 6, "searchBox.productsResult", i0.ɵɵpureFunction1(11, _c33, result_r8.products == null ? null : result_r8.products.length)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("cxFeature", "!a11ySearchboxAssistiveMessage");
  }
}
function SearchBoxComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function SearchBoxComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close(true));
    });
    i0.ɵɵtemplate(1, SearchBoxComponent_div_2_button_1_Template, 3, 3, "button", 18)(2, SearchBoxComponent_div_2_h3_2_Template, 1, 1, "h3", 19)(3, SearchBoxComponent_div_2_div_3_Template, 5, 7, "div", 20);
    i0.ɵɵelementStart(4, "div", 21);
    i0.ɵɵtemplate(5, SearchBoxComponent_div_2_ng_container_5_Template, 2, 1, "ng-container", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, SearchBoxComponent_div_2_6_Template, 1, 6, null, 22);
    i0.ɵɵelementStart(7, "div", 23);
    i0.ɵɵtemplate(8, SearchBoxComponent_div_2_ng_container_8_Template, 2, 1, "ng-container", 22)(9, SearchBoxComponent_div_2_ul_9_Template, 3, 6, "ul", 24)(10, SearchBoxComponent_div_2_ng_container_10_Template, 4, 2, "ng-container", 22);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SearchBoxComponent_div_2_div_12_Template, 6, 9, "div", 25);
    i0.ɵɵelementStart(13, "span", 26);
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, SearchBoxComponent_div_2_div_16_Template, 5, 13, "div", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const result_r8 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("no-headers", !ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE) && !ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", result_r8.message);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ((tmp_5_0 = ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "").length > 0);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("d-block", (ctx_r2.searchInputEl == null ? null : ctx_r2.searchInputEl.nativeElement == null ? null : ctx_r2.searchInputEl.nativeElement.value == null ? null : ctx_r2.searchInputEl.nativeElement.value.length) === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.config.recentSearches);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.TRENDING_SEARCHES_FEATURE) || ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", result_r8.products);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 15, ctx_r2.items$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.isEnabledFeature(ctx_r2.searchBoxFeatures.SEARCH_BOX_V2));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 17, "searchBox.initialDescription"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (result_r8.suggestions == null ? null : result_r8.suggestions.length) || (result_r8.products == null ? null : result_r8.products.length));
  }
}
const _c61 = ["button"];
function MyAccountV2NavigationComponent_cx_navigation_ui_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-navigation-ui", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
  }
  if (rf & 2) {
    let tmp_4_0;
    const node_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("node", node_r1)("flyout", false)("ngClass", (tmp_4_0 = i0.ɵɵpipeBind1(1, 5, ctx_r1.styleClass$)) !== null && tmp_4_0 !== undefined ? tmp_4_0 : "")("navAriaLabel", i0.ɵɵpipeBind1(2, 7, ctx_r1.name$))("focusableNodeTitles", true);
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_ng_container_11_label_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 12)(1, "input", 13);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("change", function MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_ng_container_11_label_1_Template_input_change_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const preference_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.updatePreference(preference_r2));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const preference_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", preference_r2.enabled)("disabled", i0.ɵɵpipeBind1(2, 4, ctx_r2.isLoading$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(5, 6, "myAccountV2NotificationPreference." + preference_r2.channel), " ", preference_r2.value, " ");
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_ng_container_11_label_1_Template, 6, 8, "label", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const preference_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preference_r2.visible);
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 7);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 8);
    i0.ɵɵtemplate(11, MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_ng_container_11_Template, 2, 1, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "label")(13, "strong");
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const preferences_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "myAccountV2NotificationPreference.header"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 8, "myAccountV2NotificationPreference.message"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", preferences_r4);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 10, "myAccountV2NotificationPreference.note"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(17, 12, "myAccountV2NotificationPreference.noteMessage"), " ");
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function MyAccountV2NotificationPreferenceComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MyAccountV2NotificationPreferenceComponent_ng_container_0_div_1_Template, 18, 14, "div", 2)(2, MyAccountV2NotificationPreferenceComponent_ng_container_0_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const preferences_r4 = ctx.ngIf;
    const loading_r5 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preferences_r4.length > 0)("ngIfElse", loading_r5);
  }
}
function PaymentMethodsComponent_ng_container_0_div_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function PaymentMethodsComponent_ng_container_0_ng_template_13_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 12)(2, "cx-card", 13);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵlistener("deleteCard", function PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template_cx_card_deleteCard_2_listener() {
      const paymentMethod_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.deletePaymentMethod(paymentMethod_r2));
    })("setDefaultCard", function PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template_cx_card_setDefaultCard_2_listener() {
      const paymentMethod_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.setDefaultPaymentMethod(paymentMethod_r2));
    })("editCard", function PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template_cx_card_editCard_2_listener() {
      const paymentMethod_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.setEdit(paymentMethod_r2));
    })("cancelCard", function PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template_cx_card_cancelCard_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.cancelCard());
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const paymentMethod_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("index", i_r4)("border", true)("fitToContainer", true)("content", i0.ɵɵpipeBind1(3, 5, ctx_r2.getCardContent(paymentMethod_r2)))("editMode", ctx_r2.editCard === paymentMethod_r2.id);
  }
}
function PaymentMethodsComponent_ng_container_0_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PaymentMethodsComponent_ng_container_0_ng_template_13_div_0_Template, 2, 3, "div", 7);
    i0.ɵɵelementStart(1, "div", 8);
    i0.ɵɵtemplate(2, PaymentMethodsComponent_ng_container_0_ng_template_13_div_2_Template, 4, 7, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const paymentMethods_r5 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", paymentMethods_r5);
  }
}
function PaymentMethodsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-form-required-legend");
    i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "h2");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 4)(8, "div", 5);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, PaymentMethodsComponent_ng_container_0_div_11_Template, 2, 0, "div", 6);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵtemplate(13, PaymentMethodsComponent_ng_container_0_ng_template_13_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cards_r6 = i0.ɵɵreference(14);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "paymentMethods.paymentMethods"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 6, "paymentMethods.newPaymentMethodsAreAddedDuringCheckout"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 8, ctx_r2.loading$))("ngIfElse", cards_r6);
  }
}
function ProductViewComponent_cx_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.iconTypes.GRID);
  }
}
function ProductViewComponent_cx_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-icon", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("type", ctx_r0.iconTypes.LIST);
  }
}
const _c62 = a0 => ({
  product: a0
});
function ProductListItemComponent_ng_template_10_cx_star_rating_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-star-rating", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rating", ctx_r0.product == null ? null : ctx_r0.product.averageRating);
  }
}
function ProductListItemComponent_ng_template_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productDetails.noReviews"), " ");
  }
}
function ProductListItemComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductListItemComponent_ng_template_10_cx_star_rating_0_Template, 1, 1, "cx-star-rating", 11)(1, ProductListItemComponent_ng_template_10_div_1_Template, 3, 3, "div", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.product.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.product.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 4, "productDetails.productPrice"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.product.price == null ? null : ctx_r0.product.price.formattedValue, " ");
  }
}
function ProductListItemComponent_ng_template_16_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 17);
    i0.ɵɵelementContainerEnd();
  }
}
function ProductListItemComponent_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductListItemComponent_ng_template_16_ng_container_0_Template, 2, 0, "ng-container", 16);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideAddToCartButton);
  }
}
function ProductGridItemComponent_ng_template_5_cx_star_rating_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-star-rating", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rating", ctx_r0.product == null ? null : ctx_r0.product.averageRating);
  }
}
function ProductGridItemComponent_ng_template_5_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productDetails.noReviews"), " ");
  }
}
function ProductGridItemComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, ProductGridItemComponent_ng_template_5_cx_star_rating_1_Template, 1, 1, "cx-star-rating", 5)(2, ProductGridItemComponent_ng_template_5_div_2_Template, 3, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 7)(4, "div", 8);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.product.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.product.averageRating);
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(5, 4, "productDetails.productPrice"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.product.price == null ? null : ctx_r0.product.price.formattedValue, " ");
  }
}
function ProductGridItemComponent_ng_template_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 10);
    i0.ɵɵelementContainerEnd();
  }
}
function ProductGridItemComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductGridItemComponent_ng_template_6_ng_container_0_Template, 2, 0, "ng-container", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.hideAddToCartButton);
  }
}
function ProductScrollComponent_ng_container_0_cx_product_grid_item_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-grid-item", 8);
  }
  if (rf & 2) {
    const product_r3 = ctx.$implicit;
    i0.ɵɵproperty("product", product_r3);
  }
}
function ProductScrollComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function ProductScrollComponent_ng_container_0_div_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scrollToTop());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productList.backToTopBtn"), " ");
  }
}
function ProductScrollComponent_ng_container_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function ProductScrollComponent_ng_container_0_div_6_Template_div_click_0_listener() {
      let tmp_3_0;
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.loadNextPage(((tmp_3_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0) + 1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productList.showMoreBtn"), " ");
  }
}
function ProductScrollComponent_ng_container_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ProductScrollComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("scrolled", function ProductScrollComponent_ng_container_0_Template_div_scrolled_1_listener() {
      let tmp_2_0;
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollPage(((tmp_2_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0) + 1));
    });
    i0.ɵɵelementStart(2, "div", 2);
    i0.ɵɵtemplate(3, ProductScrollComponent_ng_container_0_cx_product_grid_item_3_Template, 1, 1, "cx-product-grid-item", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, ProductScrollComponent_ng_container_0_div_5_Template, 3, 3, "div", 5)(6, ProductScrollComponent_ng_container_0_div_6_Template, 3, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, ProductScrollComponent_ng_container_0_div_7_Template, 2, 0, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("infiniteScrollDistance", 5)("infiniteScrollThrottle", 50)("infiniteScrollDisabled", ctx_r1.isMaxProducts || ctx_r1.isLastPage || ctx_r1.isEmpty);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.model == null ? null : ctx_r1.model.products);
    i0.ɵɵadvance();
    i0.ɵɵproperty("className", !ctx_r1.isLastPage && ((tmp_5_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_5_0 !== undefined ? tmp_5_0 : 0) > 0 ? "cx-double-btn-container grid-btn-padding" : "cx-single-btn-container grid-btn-padding");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.isMaxProducts || ctx_r1.isLastPage) && ((tmp_6_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_6_0 !== undefined ? tmp_6_0 : 0) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMaxProducts && !ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.appendProducts);
  }
}
function ProductScrollComponent_ng_container_1_cx_product_list_item_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-list-item", 13);
  }
  if (rf & 2) {
    const product_r7 = ctx.$implicit;
    i0.ɵɵproperty("product", product_r7);
  }
}
function ProductScrollComponent_ng_container_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function ProductScrollComponent_ng_container_1_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.scrollToTop());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productList.backToTopBtn"), " ");
  }
}
function ProductScrollComponent_ng_container_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function ProductScrollComponent_ng_container_1_div_5_Template_div_click_0_listener() {
      let tmp_3_0;
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.loadNextPage(((tmp_3_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0) + 1));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productList.showMoreBtn"), " ");
  }
}
function ProductScrollComponent_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function ProductScrollComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵlistener("scrolled", function ProductScrollComponent_ng_container_1_Template_div_scrolled_1_listener() {
      let tmp_2_0;
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.scrollPage(((tmp_2_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0) + 1));
    });
    i0.ɵɵtemplate(2, ProductScrollComponent_ng_container_1_cx_product_list_item_2_Template, 1, 1, "cx-product-list-item", 12);
    i0.ɵɵelementStart(3, "div", 4);
    i0.ɵɵtemplate(4, ProductScrollComponent_ng_container_1_div_4_Template, 3, 3, "div", 5)(5, ProductScrollComponent_ng_container_1_div_5_Template, 3, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, ProductScrollComponent_ng_container_1_div_6_Template, 2, 0, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("infiniteScrollDistance", 3)("infiniteScrollThrottle", 50)("infiniteScrollDisabled", ctx_r1.isMaxProducts || ctx_r1.isLastPage || ctx_r1.isEmpty);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.model == null ? null : ctx_r1.model.products);
    i0.ɵɵadvance();
    i0.ɵɵproperty("className", !ctx_r1.isLastPage && ((tmp_5_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_5_0 !== undefined ? tmp_5_0 : 0) > 0 ? "cx-double-btn-container" : "cx-single-btn-container");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.isMaxProducts || ctx_r1.isLastPage) && ((tmp_6_0 = ctx_r1.model == null ? null : ctx_r1.model.pagination == null ? null : ctx_r1.model.pagination.currentPage) !== null && tmp_6_0 !== undefined ? tmp_6_0 : 0) > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMaxProducts && !ctx_r1.isLastPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.appendProducts);
  }
}
function ProductListComponent_div_0_div_5_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "div", 18);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelement(3, "cx-pagination", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const model_r3 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 3, "productList.productSearchPagination"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pagination", model_r3.pagination)("defaultPage", 0);
  }
}
function ProductListComponent_div_0_div_5_ng_container_14_ng_container_1_cx_product_grid_item_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-grid-item", 22);
  }
  if (rf & 2) {
    const product_r4 = ctx.$implicit;
    i0.ɵɵproperty("product", product_r4);
  }
}
function ProductListComponent_div_0_div_5_ng_container_14_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtemplate(2, ProductListComponent_div_0_div_5_ng_container_14_ng_container_1_cx_product_grid_item_2_Template, 1, 1, "cx-product-grid-item", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const model_r3 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", model_r3 == null ? null : model_r3.products);
  }
}
function ProductListComponent_div_0_div_5_ng_container_14_ng_container_2_cx_product_list_item_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-list-item", 24);
  }
  if (rf & 2) {
    const product_r5 = ctx.$implicit;
    i0.ɵɵproperty("product", product_r5);
  }
}
function ProductListComponent_div_0_div_5_ng_container_14_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductListComponent_div_0_div_5_ng_container_14_ng_container_2_cx_product_list_item_1_Template, 1, 1, "cx-product-list-item", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const model_r3 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", model_r3 == null ? null : model_r3.products);
  }
}
function ProductListComponent_div_0_div_5_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductListComponent_div_0_div_5_ng_container_14_ng_container_1_Template, 3, 1, "ng-container", 20)(2, ProductListComponent_div_0_div_5_ng_container_14_ng_container_2_Template, 2, 1, "ng-container", 20);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const viewMode_r6 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", viewMode_r6 === ctx_r1.ViewModes.Grid);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", viewMode_r6 === ctx_r1.ViewModes.List);
  }
}
function ProductListComponent_div_0_div_5_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-scroll", 25);
  }
  if (rf & 2) {
    const viewMode_r6 = i0.ɵɵnextContext().ngIf;
    const model_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("scrollConfig", ctx_r1.scrollConfig)("model", model_r3)("inputViewMode", viewMode_r6);
  }
}
function ProductListComponent_div_0_div_5_div_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵelement(3, "cx-pagination", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const model_r3 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 3, "productList.productSearchPagination"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("pagination", model_r3.pagination)("defaultPage", 0);
  }
}
function ProductListComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 5)(3, "label", 9)(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "cx-sorting", 10);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function ProductListComponent_div_0_div_5_Template_cx_sorting_sortListEvent_7_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.sortList($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, ProductListComponent_div_0_div_5_div_10_Template, 4, 5, "div", 11);
    i0.ɵɵelementStart(11, "div", 12)(12, "cx-product-view", 13);
    i0.ɵɵlistener("modeChange", function ProductListComponent_div_0_div_5_Template_cx_product_view_modeChange_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    });
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(13, "div", 14);
    i0.ɵɵtemplate(14, ProductListComponent_div_0_div_5_ng_container_14_Template, 3, 2, "ng-container", 15)(15, ProductListComponent_div_0_div_5_ng_template_15_Template, 1, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 16)(18, "div", 5)(19, "label", 9)(20, "span");
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "cx-sorting", 10);
    i0.ɵɵpipe(24, "cxTranslate");
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function ProductListComponent_div_0_div_5_Template_cx_sorting_sortListEvent_23_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.sortList($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(26, ProductListComponent_div_0_div_5_div_26_Template, 4, 5, "div", 11);
    i0.ɵɵelementStart(27, "div", 12)(28, "cx-product-view", 13);
    i0.ɵɵlistener("modeChange", function ProductListComponent_div_0_div_5_Template_cx_product_view_modeChange_28_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setViewMode($event));
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const viewMode_r6 = ctx.ngIf;
    const infiniteScroll_r7 = i0.ɵɵreference(16);
    const model_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 16, "productList.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 18, "productList.sortBy"));
    i0.ɵɵproperty("sortOptions", model_r3.sorts)("selectedOption", model_r3.pagination == null ? null : model_r3.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(9, 20, "productList.sortResults"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isInfiniteScroll);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("mode", viewMode_r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isInfiniteScroll)("ngIfElse", infiniteScroll_r7);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 22, "productList.sortBy"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(24, 24, "productList.sortBy"));
    i0.ɵɵproperty("sortOptions", model_r3.sorts)("selectedOption", model_r3.pagination == null ? null : model_r3.pagination.sort)("ariaLabel", i0.ɵɵpipeBind1(25, 26, "productList.sortResults"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.isInfiniteScroll);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("mode", viewMode_r6);
  }
}
function ProductListComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "section", 3);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementStart(3, "div", 4)(4, "div", 5);
    i0.ɵɵtemplate(5, ProductListComponent_div_0_div_5_Template, 29, 28, "div", 6);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 2, "productList.productListResults"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 4, ctx_r1.viewMode$));
  }
}
const _c63 = a0 => ({
  filter: a0
});
function ActiveFacetsComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productList.appliedFilter"), " ");
  }
}
function ActiveFacetsComponent_ng_container_0_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("keydown.space", function ActiveFacetsComponent_ng_container_0_a_2_Template_a_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeFilterWithSpacebar($event));
    });
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "cx-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const facet_r3 = ctx.$implicit;
    const facetList_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("queryParams", ctx_r1.getLinkParams(facet_r3))("cxFocus", i0.ɵɵpureFunction1(12, _c30, ctx_r1.getFocusKey(facetList_r4, facet_r3)));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 6, "productList.activeFilter", i0.ɵɵpureFunction1(14, _c63, facet_r3.facetValueName)))("title", i0.ɵɵpipeBind2(2, 9, "productList.activeFilter", i0.ɵɵpureFunction1(16, _c63, facet_r3.facetValueName)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(facet_r3.facetValueName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.closeIcon);
  }
}
function ActiveFacetsComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ActiveFacetsComponent_ng_container_0_div_1_Template, 3, 3, "div", 1)(2, ActiveFacetsComponent_ng_container_0_a_2_Template, 6, 18, "a", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const facetList_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", facetList_r4.activeFacets && facetList_r4.activeFacets.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", facetList_r4 == null ? null : facetList_r4.activeFacets);
  }
}
const _c64 = ["facetHeader"];
const _c65 = ["facetValue"];
const _c66 = a0 => ({
  name: a0
});
const _c67 = (a0, a1) => ({
  name: a0,
  count: a1
});
const _c68 = () => ({
  key: "moreorless"
});
function FacetComponent_ng_container_0_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8, 0);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function FacetComponent_ng_container_0_button_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleGroup($event));
    })("keydown", function FacetComponent_ng_container_0_button_1_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeydown($event));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelement(4, "cx-icon", 9);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelement(6, "cx-icon", 10);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("cxFocus", i0.ɵɵpureFunction1(15, _c30, ctx_r1.facet.name));
    i0.ɵɵattribute("aria-expanded", ctx_r1.isExpanded)("aria-label", i0.ɵɵpipeBind2(2, 8, "productFacetNavigation.filterBy.name", i0.ɵɵpureFunction1(17, _c66, ctx_r1.facet.name)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.facet.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(5, 11, "common.collapse"));
    i0.ɵɵproperty("type", ctx_r1.collapseIcon);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 13, "common.expand"));
    i0.ɵɵproperty("type", ctx_r1.expandIcon);
  }
}
function FacetComponent_ng_container_0_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11, 1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("keydown", function FacetComponent_ng_container_0_a_3_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeydown($event));
    })("keydown.space", function FacetComponent_ng_container_0_a_3_Template_a_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openLink($event));
    });
    i0.ɵɵelementStart(3, "span", 12);
    i0.ɵɵtext(4);
    i0.ɵɵelementStart(5, "span", 13);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const value_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("selected", value_r4.selected);
    i0.ɵɵproperty("queryParams", ctx_r1.getLinkParams(value_r4))("cxFocus", i0.ɵɵpureFunction1(12, _c30, value_r4.name));
    i0.ɵɵattribute("role", ctx_r1.facet.multiSelect ? "checkbox" : null)("aria-checked", ctx_r1.facet.multiSelect ? value_r4.selected : null)("aria-label", i0.ɵɵpipeBind2(2, 9, "productFacetNavigation.ariaLabelItemsAvailable", i0.ɵɵpureFunction2(14, _c67, value_r4.name, value_r4.count)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(value_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(value_r4.count);
  }
}
function FacetComponent_ng_container_0_a_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 11, 1);
    i0.ɵɵlistener("keydown", function FacetComponent_ng_container_0_a_6_Template_a_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeydown($event));
    })("keydown.space", function FacetComponent_ng_container_0_a_6_Template_a_keydown_space_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.openLink($event));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const value_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("selected", value_r6.selected);
    i0.ɵɵproperty("queryParams", ctx_r1.getLinkParams(value_r6))("cxFocus", i0.ɵɵpureFunction1(6, _c30, value_r6.name));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(value_r6.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(value_r6.count);
  }
}
function FacetComponent_ng_container_0_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function FacetComponent_ng_container_0_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.decreaseVisibleValues());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(1, 4, "productFacetNavigation.decreaseOptionsVisibility"))("cxFocus", i0.ɵɵpureFunction0(10, _c68));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "productFacetNavigation.ariaLabelShowLess"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "productList.showLess"), " ");
  }
}
function FacetComponent_ng_container_0_button_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function FacetComponent_ng_container_0_button_9_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.increaseVisibleValues());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("cxAtMessage", i0.ɵɵpipeBind1(1, 4, "productFacetNavigation.increaseOptionsVisibility"))("cxFocus", i0.ɵɵpureFunction0(10, _c68));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "productFacetNavigation.ariaLabelShowMore"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "productList.showMore"), " ");
  }
}
function FacetComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FacetComponent_ng_container_0_button_1_Template, 8, 19, "button", 3);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, FacetComponent_ng_container_0_a_3_Template, 7, 17, "a", 4);
    i0.ɵɵpipe(4, "slice");
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtemplate(6, FacetComponent_ng_container_0_a_6_Template, 6, 8, "a", 4);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵtemplate(8, FacetComponent_ng_container_0_button_8_Template, 5, 11, "button", 6)(9, FacetComponent_ng_container_0_button_9_Template, 5, 11, "button", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const state_r9 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yTabComponent");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(4, 5, ctx_r1.facet.values, 0, state_r9.topVisible));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(7, 9, ctx_r1.facet.values, (tmp_4_0 = state_r9.topVisible) !== null && tmp_4_0 !== undefined ? tmp_4_0 : 0, state_r9.maxVisible));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", state_r9.maxVisible && state_r9.topVisible && state_r9.maxVisible > state_r9.topVisible);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", state_r9.maxVisible && ctx_r1.facet.values && state_r9.maxVisible > 0 && state_r9.maxVisible < ctx_r1.facet.values.length);
  }
}
const _c69 = ["backToResultsBtn"];
const _c70 = ["facetsRef"];
function FacetListComponent_section_0_ng_container_10_2_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-facet", 12);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    const facet_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("facet", facet_r3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 2, "productFacetNavigation.ariaLabelItemsAvailable", i0.ɵɵpureFunction2(5, _c67, facet_r3.name, facet_r3 == null ? null : facet_r3.values == null ? null : facet_r3.values.length)));
  }
}
function FacetListComponent_section_0_ng_container_10_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FacetListComponent_section_0_ng_container_10_2_ng_template_0_Template, 2, 8, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
  }
}
function FacetListComponent_section_0_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-tab", 10);
    i0.ɵɵtemplate(2, FacetListComponent_section_0_ng_container_10_2_Template, 2, 0, null, 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const facets_r4 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabs$", ctx_r1.tabs$)("config", ctx_r1.tabConfig);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", facets_r4);
  }
}
function FacetListComponent_section_0_ng_container_11_cx_facet_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-facet", 12, 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "cxTranslate");
  }
  if (rf & 2) {
    const facet_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassProp("expanded", i0.ɵɵpipeBind1(2, 6, ctx_r1.isExpanded(facet_r5)))("collapsed", i0.ɵɵpipeBind1(3, 8, ctx_r1.isCollapsed(facet_r5)));
    i0.ɵɵproperty("facet", facet_r5);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(4, 10, "productFacetNavigation.ariaLabelItemsAvailable", i0.ɵɵpureFunction2(13, _c67, facet_r5.name, facet_r5 == null ? null : facet_r5.values == null ? null : facet_r5.values.length)));
  }
}
function FacetListComponent_section_0_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FacetListComponent_section_0_ng_container_11_cx_facet_1_Template, 5, 16, "cx-facet", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const facets_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", facets_r4);
  }
}
function FacetListComponent_section_0_div_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "button", 15, 2);
    i0.ɵɵlistener("click", function FacetListComponent_section_0_div_12_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "productFacetNavigation.backToResults"), " ");
  }
}
function FacetListComponent_section_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 4);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("esc", function FacetListComponent_section_0_Template_section_esc_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("click", function FacetListComponent_section_0_Template_section_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.block($event));
    });
    i0.ɵɵelementStart(2, "div", 5)(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵlistener("click", function FacetListComponent_section_0_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵelement(9, "cx-icon", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, FacetListComponent_section_0_ng_container_10_Template, 3, 3, "ng-container", 8)(11, FacetListComponent_section_0_ng_container_11_Template, 2, 1, "ng-container", 8)(12, FacetListComponent_section_0_div_12_Template, 5, 3, "div", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cxFocus", ctx_r1.isDialog ? ctx_r1.dialogFocusConfig : i0.ɵɵpureFunction0(18, _c41))("tabindex", -1);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 10, "productFacetNavigation.filterBy.facet"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, "productList.filterBy.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 14, "common.close"));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 16, "common.close"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r1.iconTypes.CLOSE);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTabComponent");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yTabComponent");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isDialog);
  }
}
const _c71 = ["trigger"];
function ProductFacetNavigationComponent_cx_facet_list_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-facet-list", 4);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("closeList", function ProductFacetNavigationComponent_cx_facet_list_6_Template_cx_facet_list_closeList_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.close());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("active", i0.ɵɵpipeBind1(1, 5, ctx_r2.isActive$))("dialog", ctx_r2.hasTrigger);
    i0.ɵɵproperty("isDialog", ctx_r2.hasTrigger);
  }
}
function ProductCarouselComponent_cx_carousel_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 2);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "cxTranslate");
  }
  if (rf & 2) {
    const items_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const carouselItem_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("items", items_r1)("title", i0.ɵɵpipeBind1(1, 4, ctx_r1.title$))("template", carouselItem_r3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(3, 8, "productCarousel.carouselLabel", i0.ɵɵpureFunction1(11, _c53, i0.ɵɵpipeBind1(2, 6, ctx_r1.title$))));
  }
}
function ProductCarouselComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-product-carousel-item", 3);
  }
  if (rf & 2) {
    const item_r4 = ctx.item;
    i0.ɵɵproperty("item", item_r4);
  }
}
function ProductReferencesComponent_cx_carousel_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 2);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const items_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    const carouselItem_r3 = i0.ɵɵreference(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 3, ctx_r1.title$))("items", items_r1)("template", carouselItem_r3);
  }
}
function ProductReferencesComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵpipe(1, "cxUrl");
    i0.ɵɵelement(2, "cx-media", 4);
    i0.ɵɵelementStart(3, "h4");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 5);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = ctx.item;
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 4, i0.ɵɵpureFunction1(6, _c48, item_r4)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("container", item_r4.images == null ? null : item_r4.images.PRIMARY);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.price == null ? null : item_r4.price.formattedValue);
  }
}
function ProductImagesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-media", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const main_r1 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("container", main_r1);
  }
}
function ProductImagesComponent_ng_container_2_cx_carousel_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-carousel", 4);
  }
  if (rf & 2) {
    const thumbs_r2 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵnextContext();
    const thumb_r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("items", thumbs_r2)("hideIndicators", false)("template", thumb_r3);
  }
}
function ProductImagesComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductImagesComponent_ng_container_2_cx_carousel_1_Template, 1, 3, "cx-carousel", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const thumbs_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", thumbs_r2.length);
  }
}
function ProductImagesComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-media", 5);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵlistener("focus", function ProductImagesComponent_ng_template_4_Template_cx_media_focus_0_listener() {
      const item_r5 = i0.ɵɵrestoreView(_r4).item;
      const ctx_r5 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r5.openImage(item_r5.container));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = ctx.item;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 3, ctx_r5.isActive(item_r5.container)));
    i0.ɵɵproperty("container", item_r5.container);
  }
}
const _c72 = (a0, a1) => ({
  rating: a0,
  count: a1
});
function ProductIntroComponent_ng_container_0_div_1_ng_container_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵpipe(1, "number");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ProductIntroComponent_ng_container_0_div_1_ng_container_4_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.showReviews());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 5, "productSummary.showReviewsDetailed", i0.ɵɵpureFunction2(10, _c72, i0.ɵɵpipeBind2(1, 2, product_r3 == null ? null : product_r3.averageRating, "1.0-1"), product_r3 == null ? null : product_r3.numberOfReviews)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "productSummary.showReviews"), " ");
  }
}
function ProductIntroComponent_ng_container_0_div_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductIntroComponent_ng_container_0_div_1_ng_container_4_button_1_Template, 5, 13, "button", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r3 == null ? null : product_r3.averageRating);
  }
}
function ProductIntroComponent_ng_container_0_div_1_ng_container_5_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵpipe(1, "number");
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵlistener("click", function ProductIntroComponent_ng_container_0_div_1_ng_container_5_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.showReviews());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext(3).ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(2, 5, "productSummary.showReviewsDetailed", i0.ɵɵpureFunction2(10, _c72, i0.ɵɵpipeBind2(1, 2, product_r3 == null ? null : product_r3.averageRating, "1.0-1"), product_r3 == null ? null : product_r3.numberOfReviews)));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 8, "productSummary.showReviews"), " ");
  }
}
function ProductIntroComponent_ng_container_0_div_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductIntroComponent_ng_container_0_div_1_ng_container_5_button_1_Template, 5, 13, "button", 9);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.areReviewsAvailable$));
  }
}
function ProductIntroComponent_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "cx-star-rating", 4);
    i0.ɵɵelementStart(2, "div", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProductIntroComponent_ng_container_0_div_1_ng_container_4_Template, 2, 1, "ng-container", 6)(5, ProductIntroComponent_ng_container_0_div_1_ng_container_5_Template, 3, 3, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const product_r3 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("rating", (tmp_3_0 = product_r3 == null ? null : product_r3.averageRating) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", product_r3 == null ? null : product_r3.numberOfReviews, ")");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yLinkBtnsToTertiaryBtns");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yLinkBtnsToTertiaryBtns");
  }
}
function ProductIntroComponent_ng_container_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productDetails.noReviews"), " ");
  }
}
function ProductIntroComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductIntroComponent_ng_container_0_div_1_Template, 6, 4, "div", 1)(2, ProductIntroComponent_ng_container_0_div_2_Template, 3, 3, "div", 1);
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r3 == null ? null : product_r3.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !(product_r3 == null ? null : product_r3.averageRating));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(5, 4, "productSummary.id"), " ", product_r3 == null ? null : product_r3.code, " ");
  }
}
function ProductSummaryComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "cx-promotions", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", product_r1.potentialPromotions);
  }
}
function ProductSummaryComponent_ng_container_0_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "productSummary.newItemPrice"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", product_r1 == null ? null : product_r1.price == null ? null : product_r1.price.formattedValue, " ");
  }
}
function ProductSummaryComponent_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p", 4);
  }
  if (rf & 2) {
    const product_r1 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵproperty("innerHTML", product_r1 == null ? null : product_r1.summary, i0.ɵɵsanitizeHtml);
  }
}
function ProductSummaryComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductSummaryComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 0)(2, ProductSummaryComponent_ng_container_0_ng_template_2_Template, 3, 4, "ng-template", 1)(3, ProductSummaryComponent_ng_container_0_ng_template_3_Template, 1, 1, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", product_r1.potentialPromotions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.outlets.PRICE)("cxOutletContext", i0.ɵɵpureFunction1(5, _c62, product_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r1.outlets.SUMMARY)("cxOutletContext", i0.ɵɵpureFunction1(7, _c62, product_r1));
  }
}
function ProductAttributesComponent_ng_container_0_table_5_tr_4_li_5_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const feature_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", feature_r1.featureUnit == null ? null : feature_r1.featureUnit.symbol, " ");
  }
}
function ProductAttributesComponent_ng_container_0_table_5_tr_4_li_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ProductAttributesComponent_ng_container_0_table_5_tr_4_li_5_span_2_Template, 2, 1, "span", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const featureValue_r2 = ctx.$implicit;
    const feature_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", featureValue_r2 == null ? null : featureValue_r2.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", feature_r1.featureUnit && feature_r1.featureUnit.symbol && feature_r1.featureUnit.symbol.length > 0 && (feature_r1.featureUnit == null ? null : feature_r1.featureUnit.unitType) !== "300");
  }
}
function ProductAttributesComponent_ng_container_0_table_5_tr_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td")(4, "ul");
    i0.ɵɵtemplate(5, ProductAttributesComponent_ng_container_0_table_5_tr_4_li_5_Template, 3, 2, "li", 2);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const feature_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(feature_r1.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", feature_r1 == null ? null : feature_r1.featureValues);
  }
}
function ProductAttributesComponent_ng_container_0_table_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table")(1, "th")(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, ProductAttributesComponent_ng_container_0_table_5_tr_4_Template, 6, 2, "tr", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const class_r3 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(class_r3.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", class_r3.features);
  }
}
function ProductAttributesComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "h2");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ProductAttributesComponent_ng_container_0_table_5_Template, 5, 2, "table", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r4 = ctx.ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "productDetails.specification"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", product_r4 == null ? null : product_r4.classifications);
  }
}
function ProductDetailsTabComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r1 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", product_r1 == null ? null : product_r1.description, i0.ɵɵsanitizeHtml);
  }
}
function ProductDetailsTabComponent_ng_container_2_ng_container_1_ng_container_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementContainer(1, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxComponentWrapper", child_r2);
  }
}
function ProductDetailsTabComponent_ng_container_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductDetailsTabComponent_ng_container_2_ng_container_1_ng_container_1_ng_template_1_Template, 2, 1, "ng-template", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", child_r2.flexType)("cxOutletContext", i0.ɵɵpureFunction0(2, _c41));
  }
}
function ProductDetailsTabComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductDetailsTabComponent_ng_container_2_ng_container_1_ng_container_1_Template, 2, 3, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const child_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", child_r2);
  }
}
function ProductDetailsTabComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductDetailsTabComponent_ng_container_2_ng_container_1_Template, 2, 1, "ng-container", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const children_r3 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", children_r3);
  }
}
const _c73 = ["titleInput"];
const _c74 = ["writeReviewButton"];
function ProductReviewsComponent_div_0_ng_container_4_cx_star_rating_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-star-rating", 10);
  }
  if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("rating", product_r3.averageRating);
  }
}
function ProductReviewsComponent_div_0_ng_container_4_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productDetails.noReviews"), " ");
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "cx-star-rating", 16);
    i0.ɵɵelementStart(4, "div", 17);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxDate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 19);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_11_0;
    const review_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(review_r4.headline);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rating", (tmp_11_0 = review_r4.rating) !== null && tmp_11_0 !== undefined ? tmp_11_0 : 0);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", review_r4.alias ? review_r4.alias : review_r4.principal == null ? null : review_r4.principal.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 5, review_r4.date));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(review_r4.comment);
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵlistener("click", function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const reviews_r6 = i0.ɵɵnextContext(2).ngIf;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.maxListItems === ctx_r1.initialMaxListItems ? ctx_r1.maxListItems = reviews_r6.length : ctx_r1.maxListItems = ctx_r1.initialMaxListItems);
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r1.maxListItems === ctx_r1.initialMaxListItems ? "productReview.more" : "productReview.less"), " ");
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const reviews_r6 = i0.ɵɵnextContext(3).ngIf;
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.maxListItems = reviews_r6.length);
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productReview.more"), " ");
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(7);
      return i0.ɵɵresetView(ctx_r1.maxListItems = ctx_r1.initialMaxListItems);
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "productReview.less"), " ");
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_1_Template, 3, 3, "button", 23)(2, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_button_2_Template, 3, 3, "button", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.maxListItems === ctx_r1.initialMaxListItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.maxListItems !== ctx_r1.initialMaxListItems);
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_button_1_Template, 3, 3, "button", 20)(2, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_ng_container_2_Template, 3, 2, "ng-container", 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yShowMoreReviewsBtnFocus");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yShowMoreReviewsBtnFocus");
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_1_Template, 11, 7, "div", 13);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵtemplate(3, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_div_3_Template, 3, 2, "div", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const reviews_r6 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 2, reviews_r6, 0, ctx_r1.maxListItems));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", reviews_r6.length > ctx_r1.initialMaxListItems);
  }
}
function ProductReviewsComponent_div_0_ng_container_4_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_ng_container_1_Template, 4, 6, "ng-container", 12);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.reviews$));
  }
}
function ProductReviewsComponent_div_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "h3");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 7, 1);
    i0.ɵɵlistener("click", function ProductReviewsComponent_div_0_ng_container_4_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.initiateWriteReview());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ProductReviewsComponent_div_0_ng_container_4_cx_star_rating_9_Template, 1, 1, "cx-star-rating", 8)(10, ProductReviewsComponent_div_0_ng_container_4_div_10_Template, 3, 3, "div", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ProductReviewsComponent_div_0_ng_container_4_ng_container_11_Template, 3, 3, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const product_r3 = i0.ɵɵnextContext().ngIf;
    const writeReview_r9 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 6, "productReview.overallRating"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 8, "productReview.writeReview"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", product_r3.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !product_r3.averageRating);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isWritingReview)("ngIfElse", writeReview_r9);
  }
}
function ProductReviewsComponent_div_0_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "cx-form-required-legend");
    i0.ɵɵelementStart(1, "form", 24);
    i0.ɵɵlistener("ngSubmit", function ProductReviewsComponent_div_0_ng_template_5_Template_form_ngSubmit_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const product_r3 = i0.ɵɵnextContext().ngIf;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitReview(product_r3));
    });
    i0.ɵɵelementStart(2, "div", 25)(3, "label")(4, "span", 26);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 27, 2)(10, "cx-form-errors", 28);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 25)(13, "label")(14, "span", 26);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelement(17, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(18, "textarea", 29)(19, "cx-form-errors", 30);
    i0.ɵɵpipe(20, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 25)(22, "label")(23, "span", 26);
    i0.ɵɵtext(24);
    i0.ɵɵpipe(25, "cxTranslate");
    i0.ɵɵelement(26, "cx-form-required-asterisks");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(27, "input", 31);
    i0.ɵɵelementStart(28, "cx-star-rating", 32);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵlistener("change", function ProductReviewsComponent_div_0_ng_template_5_Template_cx_star_rating_change_28_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setRating($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(30, "cx-form-errors", 33);
    i0.ɵɵpipe(31, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 25)(33, "label")(34, "span", 26);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(37, "input", 34);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(38, "div", 35)(39, "div", 36)(40, "button", 37);
    i0.ɵɵlistener("click", function ProductReviewsComponent_div_0_ng_template_5_Template_button_click_40_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.cancelWriteReview());
    });
    i0.ɵɵtext(41);
    i0.ɵɵpipe(42, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(43, "div", 36)(44, "button", 38);
    i0.ɵɵtext(45);
    i0.ɵɵpipe(46, "cxTranslate");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    let tmp_7_0;
    let tmp_12_0;
    let tmp_17_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.reviewForm);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(6, 21, "productReview.reviewTitle"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-invalid", ((tmp_7_0 = ctx_r1.reviewForm.get("title")) == null ? null : tmp_7_0.touched) && ((tmp_7_0 = ctx_r1.reviewForm.get("title")) == null ? null : tmp_7_0.invalid))("aria-errormessage", "titleError");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(41, _c47, i0.ɵɵpipeBind1(11, 23, "productReview.reviewTitle")))("control", ctx_r1.reviewForm.get("title"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(16, 25, "productReview.writeYourComments"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-invalid", ((tmp_12_0 = ctx_r1.reviewForm.get("comment")) == null ? null : tmp_12_0.touched) && ((tmp_12_0 = ctx_r1.reviewForm.get("comment")) == null ? null : tmp_12_0.invalid))("aria-errormessage", "commentError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(43, _c47, i0.ɵɵpipeBind1(20, 27, "productReview.writeYourComments")))("control", ctx_r1.reviewForm.get("comment"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(25, 29, "productReview.rating"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("aria-invalid", ((tmp_17_0 = ctx_r1.reviewForm.get("rating")) == null ? null : tmp_17_0.touched) && ((tmp_17_0 = ctx_r1.reviewForm.get("rating")) == null ? null : tmp_17_0.invalid))("aria-errormessage", "ratingError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", false);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(29, 31, "productReview.ratingRequired"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(45, _c47, i0.ɵɵpipeBind1(31, 33, "productReview.rating")))("control", ctx_r1.reviewForm.get("rating"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(36, 35, "productReview.reviewerName"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(42, 37, "common.cancel"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(46, 39, "common.submit"), " ");
  }
}
function ProductReviewsComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "h2");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ProductReviewsComponent_div_0_ng_container_4_Template, 12, 10, "ng-container", 5)(5, ProductReviewsComponent_div_0_ng_template_5_Template, 47, 47, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r3 = ctx.ngIf;
    const writeReview_r9 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(3, 4, "productDetails.reviews"), " (", product_r3.numberOfReviews, ") ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWritingReview)("ngIfElse", writeReview_r9);
  }
}
const _c75 = () => ({
  cxRoute: "notificationPreference"
});
const _c76 = () => ({
  cxRoute: "myInterests"
});
function StockNotificationDialogComponent_h3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "stockNotification.subscriptionDialog.header"), " ");
  }
}
function StockNotificationDialogComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "stockNotification.subscriptionDialog.header"), " ");
  }
}
function StockNotificationDialogComponent_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 20);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function StockNotificationDialogComponent_ng_container_9_p_7_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preference_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(": " + preference_r3.value);
  }
}
function StockNotificationDialogComponent_ng_container_9_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 21)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, StockNotificationDialogComponent_ng_container_9_p_7_span_3_Template, 2, 1, "span", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const preference_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(preference_r3.channel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", preference_r3.value);
  }
}
function StockNotificationDialogComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StockNotificationDialogComponent_ng_container_9_div_1_Template, 2, 3, "div", 9);
    i0.ɵɵelementStart(2, "div", 10)(3, "div", 11)(4, "p", 12);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, StockNotificationDialogComponent_ng_container_9_p_7_Template, 4, 2, "p", 13);
    i0.ɵɵelementStart(8, "p", 12);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p", 12);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementStart(14, "a", 14);
    i0.ɵɵpipe(15, "cxUrl");
    i0.ɵɵlistener("click", function StockNotificationDialogComponent_ng_container_9_Template_a_click_14_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.close("Link clicked"));
    });
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(18);
    i0.ɵɵpipe(19, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "p", 12);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "cxTranslate");
    i0.ɵɵelementStart(23, "a", 15);
    i0.ɵɵpipe(24, "cxUrl");
    i0.ɵɵlistener("click", function StockNotificationDialogComponent_ng_container_9_Template_a_click_23_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.close("Link clicked"));
    });
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(27);
    i0.ɵɵpipe(28, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(29, "div", 16)(30, "div", 17)(31, "div", 18)(32, "button", 19);
    i0.ɵɵlistener("click", function StockNotificationDialogComponent_ng_container_9_Template_button_click_32_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.close("Button clicked"));
    });
    i0.ɵɵtext(33);
    i0.ɵɵpipe(34, "cxTranslate");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 13, "stockNotification.subscriptionDialog.notifiedPrefix"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.enabledPrefs);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 15, "stockNotification.subscriptionDialog.notifiedSuffix"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 17, "stockNotification.subscriptionDialog.manageChannelsPrefix"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(15, 19, i0.ɵɵpureFunction0(35, _c75)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 21, "stockNotification.subscriptionDialog.manageChannelsLink"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(19, 23, "stockNotification.subscriptionDialog.manageChannelsSuffix"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 25, "stockNotification.subscriptionDialog.manageSubscriptionsPrefix"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(24, 27, i0.ɵɵpureFunction0(36, _c76)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 29, "stockNotification.subscriptionDialog.manageSubscriptionsLink"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(28, 31, "stockNotification.subscriptionDialog.manageSubscriptionsSuffix"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(34, 33, "stockNotification.subscriptionDialog.okBtn"), " ");
  }
}
function StockNotificationDialogComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 23)(5, "div", 24);
    i0.ɵɵelement(6, "cx-spinner");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "stockNotification.subscriptionDialog.subscribing"), " ");
  }
}
const _c77 = () => ({
  cxRoute: "login"
});
function StockNotificationComponent_ng_container_0_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6)(2, "p");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 7);
    i0.ɵɵlistener("click", function StockNotificationComponent_ng_container_0_ng_container_1_ng_container_1_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.subscribe());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "stockNotification.getNotified"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "stockNotification.notifyMe"), " ");
  }
}
function StockNotificationComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StockNotificationComponent_ng_container_0_ng_container_1_ng_container_1_Template, 8, 6, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const disableNotify_r3 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.prefsEnabled$))("ngIfElse", disableNotify_r3);
  }
}
function StockNotificationComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StockNotificationComponent_ng_container_0_ng_container_1_Template, 3, 4, "ng-container", 5);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const stopNotify_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r1.hasProductInterests$))("ngIfElse", stopNotify_r4);
  }
}
function StockNotificationComponent_ng_template_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 10);
    i0.ɵɵpipe(2, "cxUrl");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "br");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpureFunction0(9, _c77)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "miniLogin.signInRegister"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "stockNotification.getNotifySuffix"), "");
  }
}
function StockNotificationComponent_ng_template_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementStart(5, "a", 10);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 5, "stockNotification.getNotify"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 7, "stockNotification.activateChannelsPrefix"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 9, i0.ɵɵpureFunction0(15, _c75)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 11, "stockNotification.channelsLink"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 13, "stockNotification.activateChannelsSuffix"), " ");
  }
}
function StockNotificationComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "p");
    i0.ɵɵtemplate(2, StockNotificationComponent_ng_template_2_ng_container_2_Template, 8, 10, "ng-container", 5)(3, StockNotificationComponent_ng_template_2_ng_template_3_Template, 11, 16, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "button", 9);
    i0.ɵɵlistener("click", function StockNotificationComponent_ng_template_2_Template_button_click_5_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.subscribe());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const loggedIn_r6 = i0.ɵɵreference(4);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.anonymous)("ngIfElse", loggedIn_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("disabled", ctx_r1.anonymous ? true : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 4, "stockNotification.notifyMe"), " ");
  }
}
function StockNotificationComponent_ng_template_4_ng_container_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 13);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function StockNotificationComponent_ng_template_4_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, StockNotificationComponent_ng_template_4_ng_container_0_div_1_Template, 2, 3, "div", 11);
    i0.ɵɵelementStart(2, "div", 6)(3, "p");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "button", 12);
    i0.ɵɵlistener("click", function StockNotificationComponent_ng_template_4_ng_container_0_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.unsubscribe());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "stockNotification.notified"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 5, "stockNotification.stopNotify"), " ");
  }
}
function StockNotificationComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, StockNotificationComponent_ng_template_4_ng_container_0_Template, 9, 7, "ng-container", 5);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const loading_r8 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 2, ctx_r1.isRemoveInterestLoading$))("ngIfElse", loading_r8);
  }
}
function StockNotificationComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15)(2, "div", 16);
    i0.ɵɵelement(3, "cx-spinner");
    i0.ɵɵelementEnd()()();
  }
}
const FOCUS_ATTR = 'data-cx-focus';
/** The element attribute used to store the focus group state */
const FOCUS_GROUP_ATTR = 'data-cx-focus-group';
var MOVE_FOCUS;
(function (MOVE_FOCUS) {
  MOVE_FOCUS[MOVE_FOCUS["NEXT"] = 1] = "NEXT";
  MOVE_FOCUS[MOVE_FOCUS["PREV"] = -1] = "PREV";
})(MOVE_FOCUS || (MOVE_FOCUS = {}));
var TrapFocus;
(function (TrapFocus) {
  /**
   * Will trap the focus at the start of the focus group.
   */
  TrapFocus["start"] = "start";
  /**
   * Will trap the focus only at the end of the focus group.
   */
  TrapFocus["end"] = "end";
  /**
   * Will not trap the focus in both directions. This is actually not are
   * a great example of focus trap, but it will give the benefit of keyboard
   * tabbing by arrows. Should only be used with `TrapFocusConfig.trap` and not with `TrapFocusConfig.trapTabOnly`
   */
  TrapFocus["both"] = "both";
})(TrapFocus || (TrapFocus = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BaseFocusService {
  static {
    this.ɵfac = function BaseFocusService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BaseFocusService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BaseFocusService,
      factory: BaseFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Abstract directive that provides a common interface for all focus directives:
 * - Block Focus
 * - Persist Focus
 * - Escape Focus
 * - Auto Focus
 * - Tab Focus
 * - Trap Focus
 * - Lock Focus
 */
class BaseFocusDirective {
  constructor(elementRef, service) {
    this.elementRef = elementRef;
    this.service = service;
    /**
     * A default config can be provided for each directive if a specific focus directive
     * is used directly. i.e. `<div cxAutoFocus></div>`
     */
    this.defaultConfig = {};
  }
  ngOnInit() {
    this.setDefaultConfiguration();
    this.requiredTabindex = -1;
  }
  // empty, but sub classes might have an implementation
  /* eslint @angular-eslint/no-empty-lifecycle-method: 1 */
  ngOnChanges(_changes) {
    // Intentional empty method
  }
  /**
   * Override the (input) config if it undefined or an empty string, with the
   * `defaultConfig`. The `defaultConfig` might be specified for each directive
   * differently. If a specific directive is used (i.e. `cxAutoFocus`), the
   * specific (inherited) defaultConfig will be used.
   */
  setDefaultConfiguration() {
    if ((!this.config || this.config === '') && this.defaultConfig) {
      this.config = this.defaultConfig;
    }
  }
  /**
   * Helper method to return the host element for the directive
   * given by the `elementRef`.
   */
  get host() {
    return this.elementRef.nativeElement;
  }
  /**
   * Force a tabindex on the host element if it is _required_ to make the element
   * focusable. If the element is focusable by nature or by a given tabindex, the
   * `tabindex` is not applied.
   *
   * Buttons, active links, etc. do no need an explicit tabindex to receive focus.
   */
  set requiredTabindex(tabindex) {
    if (this.requiresExplicitTabIndex) {
      this.tabindex = tabindex;
    }
  }
  /**
   * Returns true if the host element does not have a tabindex defined
   * and it also doesn't get focus by browsers nature (i.e. button or
   * active link).
   */
  get requiresExplicitTabIndex() {
    return this.tabindex === undefined && ['button', 'input', 'select', 'textarea'].indexOf(this.host.tagName.toLowerCase()) === -1 && !(this.host.tagName === 'A' && (this.host.hasAttribute('href') || this.host.hasAttribute('routerlink') || this.host.getAttribute('ng-reflect-router-link')));
  }
  static {
    this.ɵfac = function BaseFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BaseFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BaseFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BaseFocusDirective,
      hostVars: 1,
      hostBindings: function BaseFocusDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", ctx.tabindex);
        }
      },
      inputs: {
        tabindex: "tabindex"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: BaseFocusService
  }], {
    tabindex: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.tabindex']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive implementation that adds a CSS class to the host element
 * when the moused is used to focus an element. As soon as the keyboard
 * is used, the class is removed.
 *
 * This feature must be explicitly enabled with the `disableMouseFocus` config.
 *
 * The appearance of the visual focus depends on the CSS implementation to
 * begin with. Spartacus styles add a blue border around each focusable element.
 * This can be considered annoying by keyboard users, as they won't need such a
 * strong indication of the selected element.
 */
class VisibleFocusDirective extends BaseFocusDirective {
  // TODO: (CXSPA-5912) Remove usless constructor next major release
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.defaultConfig = {
      disableMouseFocus: true
    };
    /** Controls a css class to hide focus visible CSS rules */
    this.mouseFocus = false;
  }
  handleMousedown() {
    if (this.shouldFocusVisible) {
      this.mouseFocus = true;
    }
  }
  handleKeydown(event) {
    if (this.shouldFocusVisible) {
      this.mouseFocus = !this.isNavigating(event);
    }
  }
  /**
   * Indicates whether the configurations setup to disable visual focus.
   */
  get shouldFocusVisible() {
    return this.config?.disableMouseFocus;
  }
  /**
   * Indicates whether the event is used to navigate the storefront. Some keyboard events
   * are used by mouse users to fill a form or interact with the OS or browser.
   */
  isNavigating(event) {
    // when the cmd or ctrl keys are used, the user doesn't navigate the storefront
    if (event.metaKey) {
      return false;
    }
    // when the tab key is used, users are for navigating away from the current (form) element
    if (event.code === 'Tab') {
      return true;
    }
    // If the user fill in a form, we don't considering it part of storefront navigation.
    if (['INPUT', 'TEXTAREA'].includes(event.target.tagName)) {
      return false;
    }
    return true;
  }
  static {
    this.ɵfac = function VisibleFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VisibleFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BaseFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: VisibleFocusDirective,
      hostVars: 2,
      hostBindings: function VisibleFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mousedown", function VisibleFocusDirective_mousedown_HostBindingHandler() {
            return ctx.handleMousedown();
          })("keydown", function VisibleFocusDirective_keydown_HostBindingHandler($event) {
            return ctx.handleKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("mouse-focus", ctx.mouseFocus);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VisibleFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: BaseFocusService
  }], {
    mouseFocus: [{
      type: HostBinding,
      args: ['class.mouse-focus']
    }],
    handleMousedown: [{
      type: HostListener,
      args: ['mousedown']
    }],
    handleKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// { selector: '[cxBlockFocus]' }
class BlockFocusDirective extends VisibleFocusDirective {
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.defaultConfig = {
      block: true
    };
    // @Input('cxBlockFocus')
    this.config = {};
  }
  ngOnInit() {
    super.ngOnInit();
    if (this.config.block) {
      this.tabindex = -1;
    }
  }
  static {
    this.ɵfac = function BlockFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BlockFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BaseFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BlockFocusDirective,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BlockFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: BaseFocusService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const GLOBAL_GROUP = '_g_';
/**
 * Shared service to persist the focus for an element or a group
 * of elements. The persisted element focus can be used to persist
 * the focus for a DOM tree, so that the focus remains after a repaint
 * or reoccurs when a DOM tree is "unlocked".
 */
class PersistFocusService extends BaseFocusService {
  constructor() {
    super(...arguments);
    // this is going to fail as we have sub services. They will al have their own map.
    // We must bring this to a singleton map.
    this.focus = new Map();
  }
  get(group) {
    return this.focus.get(group || GLOBAL_GROUP);
  }
  /**
   * Persist the keyboard focus state for the given key. The focus is stored globally
   * or for the given group.
   */
  set(key, group) {
    if (key) {
      this.focus.set(group || GLOBAL_GROUP, key);
    }
  }
  /**
   * Clears the persisted keyboard focus state globally or for the given group.
   */
  clear(group) {
    this.focus.delete(group || GLOBAL_GROUP);
  }
  /**
   * Returns the group for the host element based on the configured group or
   * by the `data-cx-focus-group` attribute stored on the host.
   */
  getPersistenceGroup(host, config) {
    return config?.group ? config.group : host?.getAttribute(FOCUS_GROUP_ATTR);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵPersistFocusService_BaseFactory;
      return function PersistFocusService_Factory(__ngFactoryType__) {
        return (ɵPersistFocusService_BaseFactory || (ɵPersistFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(PersistFocusService)))(__ngFactoryType__ || PersistFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PersistFocusService,
      factory: PersistFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PersistFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that provides persistence of the focused state. This is useful
 * when a group of focusable elements got refocused or even recreated. That
 * happens often when the DOM is constructed with an `*ngIf` or `*ngFor`.
 *
 * The focus state is based on a configured _key_, which can be passed in the
 * config input, either by using a string primitive or `PersistFocusConfig.key`:
 *
 * ```html
 * <button cxPersistFocus="myKey"></button>
 * <button cxFocus="myKey"></button>
 * <button [cxFocus]="{{key:'myKey'}"></button>
 * ```
 *
 * The focus state can be part of a focus _group_, so that the state is shared
 * and remember for the given group. In order to detect the persistence for a
 * given element, we store the persistence key as a data attribute (`data-cx-focus`):
 *
 * ```html
 * <button data-cx-focus="myKey"></button>
 * ```
 *
 * Other keyboard focus directives can read the key to understand whether the element
 * should retrieve focus.
 *
 */
class PersistFocusDirective extends BlockFocusDirective {
  handleFocus(event) {
    this.service.set(this.key, this.group);
    event?.preventDefault();
    event?.stopPropagation();
  }
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.defaultConfig = {};
    /**
     * The persistence key can be passed directly or through the `FocusConfig.key`.
     * While this could be considered a global key, the likeliness of conflicts
     * is very small since the key is cleared when the focus is changed.
     */
    // @Input('cxPersistFocus')
    this.config = {};
  }
  ngOnInit() {
    super.ngOnInit();
    this.attr = this.key ? this.key : undefined;
  }
  setDefaultConfiguration() {
    if (typeof this.config === 'string' && this.config !== '') {
      this.config = {
        key: this.config
      };
    }
    super.setDefaultConfiguration();
  }
  /**
   * Focus the element explicitly if it was focused before.
   */
  ngAfterViewInit() {
    if (this.isPersisted) {
      this.host.focus({
        preventScroll: true
      });
    }
  }
  get isPersisted() {
    return !!this.key && this.service.get(this.group) === this.key;
  }
  /**
   * Returns the key for the host element, which is used to persist the
   * focus state. This is useful in cases where the DOM is rebuild.
   */
  get key() {
    return this.config?.key;
  }
  /**
   * returns the persistence group (if any) for the focusable elements.
   */
  get group() {
    return this.service.getPersistenceGroup(this.host, this.config);
  }
  static {
    this.ɵfac = function PersistFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PersistFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(PersistFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PersistFocusDirective,
      hostVars: 1,
      hostBindings: function PersistFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("focus", function PersistFocusDirective_focus_HostBindingHandler($event) {
            return ctx.handleFocus($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("data-cx-focus", ctx.attr);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PersistFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: PersistFocusService
  }], {
    attr: [{
      type: HostBinding,
      args: [`attr.${FOCUS_ATTR}`]
    }],
    handleFocus: [{
      type: HostListener,
      args: ['focus', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SelectFocusUtility {
  constructor() {
    /**
     * Query selectors used to query focusable child elements of the host element.
     * The selectors are supplemented with `:not([disabled])` and `:not([hidden])`.
     */
    this.focusableSelectors = ['a[href]', 'button', '[tabindex]', 'input', 'select', 'textarea'];
    // like to leave out the following as we don't use it, and make this list exensible.
    //   `[contentEditable=true]`, // very unlikely to suport as we're not a business tool
    //   `iframe`, // we really don't like iframes...
    //   `area[href]`, // very debatable!
    this.focusableSelectorSuffix = ':not([disabled]):not([hidden]):not([aria-hidden])';
  }
  query(host, selector) {
    if (!selector || selector === '') {
      return [];
    }
    return Array.from(host?.querySelectorAll(selector));
  }
  findFirstFocusable(host, config = {
    autofocus: true
  }) {
    const selector = typeof config?.autofocus === 'string' ? config.autofocus : '[autofocus]';
    // fallback to first focusable
    return this.query(host, selector).find(el => !this.isHidden(el)) || this.findFocusable(host).find(el => Boolean(el));
  }
  /**
   * returns all focusable child elements of the host element. The element selectors
   * are build from the `focusableSelectors`.
   *
   * @param host the `HTMLElement` used to query focusable elements
   * @param locked indicates whether inactive (`tabindex="-1"`) focusable elements should be returned
   * @param invisible indicates whether hidden focusable elements should be returned
   */
  findFocusable(host, locked = false, invisible = false) {
    let suffix = this.focusableSelectorSuffix;
    if (!locked) {
      suffix += `:not([tabindex='-1'])`;
    }
    const selector = this.focusableSelectors.map(s => s += suffix).join(',');
    return this.query(host, selector).filter(el => !invisible ? !this.isHidden(el) : Boolean(el));
  }
  /**
   * Indicates whether the element is hidden by CSS. There are various CSS rules and
   * HTML structures which can lead to an hidden or invisible element. An `offsetParent`
   * of null indicates that the element or any of it's decendants is hidden (`display:none`).
   *
   * Oother techniques use the visibility (`visibility: hidden`), opacity (`opacity`) or
   * phyisical location on the element itself or any of it's anchestor elements. Those
   * technique require to work with the _computed styles_, which will cause a performance
   * downgrade. We don't do this in the standard implementaton.
   */
  isHidden(el) {
    return el.offsetParent === null;
  }
  static {
    this.ɵfac = function SelectFocusUtility_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SelectFocusUtility)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SelectFocusUtility,
      factory: SelectFocusUtility.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectFocusUtility, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class EscapeFocusService extends PersistFocusService {
  constructor(selectFocusUtil) {
    super();
    this.selectFocusUtil = selectFocusUtil;
  }
  shouldFocus(config) {
    return !!config?.focusOnEscape;
  }
  handleEscape(host, config, event) {
    if (this.shouldFocus(config)) {
      if (host !== event.target) {
        host.focus({
          preventScroll: true
        });
        event.preventDefault();
        event.stopPropagation();
      } else {
        if (config?.focusOnDoubleEscape) {
          this.selectFocusUtil.findFirstFocusable(host, {
            autofocus: true
          })?.focus();
        }
      }
    }
  }
  static {
    this.ɵfac = function EscapeFocusService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EscapeFocusService)(i0.ɵɵinject(SelectFocusUtility));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: EscapeFocusService,
      factory: EscapeFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EscapeFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SelectFocusUtility
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to focus the host element whenever the `escape` key is captured.
 * UiEvents bubble up by nature, which is why the `cxEscGroup` can be used
 * on a tree of elements. Each time the escape key is used, the focus will
 * move up in the DOM tree.
 *
 */
class EscapeFocusDirective extends PersistFocusDirective {
  /**
   * Handles the escape key event.
   * @param event the native keyboard event which contains the escape keydown event
   */
  handleEscape(event) {
    if (this.service.shouldFocus(this.config)) {
      this.service.handleEscape(this.host, this.config, event);
    }
    this.esc.emit(this.service.shouldFocus(this.config));
  }
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.defaultConfig = {
      focusOnEscape: true
    };
    this.esc = new EventEmitter();
  }
  ngOnInit() {
    if (this.service.shouldFocus(this.config)) {
      this.requiredTabindex = -1;
    }
    super.ngOnInit();
  }
  static {
    this.ɵfac = function EscapeFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EscapeFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(EscapeFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: EscapeFocusDirective,
      hostBindings: function EscapeFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.escape", function EscapeFocusDirective_keydown_escape_HostBindingHandler($event) {
            return ctx.handleEscape($event);
          });
        }
      },
      outputs: {
        esc: "esc"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EscapeFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: EscapeFocusService
  }], {
    esc: [{
      type: Output
    }],
    handleEscape: [{
      type: HostListener,
      args: ['keydown.escape', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AutoFocusService extends EscapeFocusService {
  /**
   * Returns the first focusable child element of the host element.
   */
  findFirstFocusable(host, config = {
    autofocus: true
  }) {
    if (config?.autofocus === ':host') {
      return host;
    } else if (this.hasPersistedFocus(host, config)) {
      return this.getPersisted(host, this.getPersistenceGroup(host, config));
    } else {
      return this.selectFocusUtil.findFirstFocusable(host, config) || host;
    }
  }
  /**
   * Indicates whether any of the focusable child elements is focused.
   */
  hasPersistedFocus(host, config) {
    return !!this.getPersisted(host, this.getPersistenceGroup(host, config));
  }
  /**
   * Returns the element that has a persisted focus state.
   *
   * @param host the `HTMLElement` used to query for focusable children
   * @param group the optional group for the persistent state, to separate different focus
   *   groups and remain the persistence
   */
  getPersisted(host, group) {
    if (!this.get(group)) {
      return;
    }
    const focussed = Array.from(host?.querySelectorAll(`[${FOCUS_ATTR}='${this.get(group)}']`));
    return focussed.length > 0 ? focussed[0] : undefined;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵAutoFocusService_BaseFactory;
      return function AutoFocusService_Factory(__ngFactoryType__) {
        return (ɵAutoFocusService_BaseFactory || (ɵAutoFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(AutoFocusService)))(__ngFactoryType__ || AutoFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AutoFocusService,
      factory: AutoFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that focus the first nested _focusable_ element based on state and configuration:
 *
 * 1. focusable element that was left in a focused state (aka _persisted_ focus)
 * 2. focusable element selected by configured CSS selector (i.e. 'button[type=submit]')
 * 3. focusable element marked with the native HTML5 `autofocus` attribute
 * 4. first focusable element
 * 5. the host element, in case the configured CSS selector is `:host`.
 *
 * Example configurations:
 *
 * `<div cxAutoFocus>[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: false}">[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: 'button.active'}">[...]</div>`
 *
 * `<div [cxAutoFocus]="{autofocus: ':host'}">[...]</div>`
 *
 * When your element is added dynamically (ie. by using an *ngIf or after a DOM change), the
 * focus can be refreshed by using the refreshFocus configuration.
 */
class AutoFocusDirective extends EscapeFocusDirective {
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    /** The AutoFocusDirective will be using autofocus by default  */
    this.defaultConfig = {
      autofocus: true
    };
  }
  /**
   * Focus the element explicitly if it was focussed before.
   */
  ngAfterViewInit() {
    if (this.shouldAutofocus) {
      this.handleFocus();
    }
    if (!this.shouldAutofocus || this.hasPersistedFocus) {
      super.ngAfterViewInit();
    }
  }
  ngOnChanges(changes) {
    // responsible for refresh focus based on the configured refresh property name
    if (!!changes.config?.currentValue?.refreshFocus) {
      // ensure the autofocus when it's to provided initially
      if (!this.config.autofocus) {
        this.config.autofocus = true;
      }
      this.handleFocus();
    }
    super.ngOnChanges(changes);
  }
  /**
   * Mimic the focus without setting the actual focus on the host. The first
   * focusable child element will be focussed.
   */
  handleFocus(event) {
    if (this.shouldAutofocus) {
      if (!event?.target || event.target === this.host) {
        this.firstFocusable?.focus();
      } else {
        event.target.focus();
      }
    }
    super.handleFocus(event);
  }
  /**
   * Helper function to get the first focusable child element
   */
  get hasPersistedFocus() {
    return this.service.hasPersistedFocus(this.host, this.config);
  }
  /**
   * Helper function to indicate whether we should use autofocus for the
   * child elements.
   */
  get shouldAutofocus() {
    return !!this.config?.autofocus;
  }
  /**
   * Helper function to get the first focusable child element.
   *
   * We keep this private to not pollute the API.
   */
  get firstFocusable() {
    return this.service.findFirstFocusable(this.host, this.config);
  }
  static {
    this.ɵfac = function AutoFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AutoFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(AutoFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AutoFocusDirective,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AutoFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: AutoFocusService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabFocusService extends AutoFocusService {
  /**
   * Moves to the next (or previous) tab.
   */
  moveTab(host, config, increment, event) {
    if (config?.tab) {
      const next = config.tab === 'scroll' ? this.findNextScrollable(host, config, increment) : this.findNext(host, config, increment);
      next?.focus();
      event.preventDefault();
      event.stopPropagation();
    }
  }
  /**
   * builds out virtual slides out of the full scrollable area, to allow
   * for maximum flexibility for the underlying layout without using hardcoded
   * slide sizes.
   */
  findNextScrollable(host, config, increment) {
    const active = this.getActiveChild(host, config);
    if (!active) {
      return;
    }
    // slide count
    const virtualSlideCount = Math.round(host.scrollWidth / host.clientWidth);
    // find current virtual slide
    const currentVirtualSlide = Math.round(active.offsetLeft / (host.scrollWidth / virtualSlideCount));
    let nextVirtualSlide = currentVirtualSlide + increment;
    if (increment === MOVE_FOCUS.NEXT && nextVirtualSlide >= virtualSlideCount) {
      nextVirtualSlide = 0;
    }
    if (increment === MOVE_FOCUS.PREV && nextVirtualSlide < 0) {
      nextVirtualSlide = virtualSlideCount - 1;
    }
    const firstItemOnNextSlide = this.getChildren(host, config)?.find(tab => tab.offsetLeft >= host.scrollWidth / virtualSlideCount * nextVirtualSlide);
    return firstItemOnNextSlide;
  }
  findNext(host, config, increment) {
    const childs = this.getChildren(host, config);
    let activeIndex = childs?.findIndex(c => c === this.getActiveChild(host, config));
    if (!activeIndex || activeIndex === -1) {
      activeIndex = 0;
    }
    activeIndex += increment;
    if (increment === MOVE_FOCUS.NEXT && activeIndex >= childs?.length) {
      activeIndex = childs.length - 1;
    }
    if (increment === MOVE_FOCUS.PREV && activeIndex < 0) {
      activeIndex = 0;
    }
    return childs ? childs[activeIndex] : undefined;
  }
  /**
   * Returns the active focusable child element. If there's no active
   * focusable child element, the first focusable child is returned.
   */
  getActiveChild(host, config) {
    const persisted = this.getPersisted(host, config?.group);
    if (persisted) {
      return persisted;
    }
    const children = this.getChildren(host, config);
    let index = children.findIndex(tab => this.isActive(tab));
    if (!index || index === -1) {
      index = 0;
    }
    return children[index];
  }
  getChildren(host, config) {
    if (typeof config.tab === 'string' && config.tab !== 'scroll') {
      return this.selectFocusUtil.query(host, config.tab);
    } else {
      return this.findFocusable(host, true);
    }
  }
  /**
   * Returns all focusable child elements of the host element.
   *
   * @param host The host element is used to query child focusable elements.
   * @param locked Indicates if locked elements (tabindex=-1) should be returned, defaults to false.
   * @param invisible Indicates if invisible child elements should be returned, defaults to false.
   */
  findFocusable(host, locked = false, invisible = false) {
    return this.selectFocusUtil.findFocusable(host, locked, invisible);
  }
  isActive(el) {
    const child = document.activeElement;
    const selector = child?.tagName;
    return el === child || !!selector && !!Array.from(el.querySelectorAll(selector)).find(e => e === child);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵTabFocusService_BaseFactory;
      return function TabFocusService_Factory(__ngFactoryType__) {
        return (ɵTabFocusService_BaseFactory || (ɵTabFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(TabFocusService)))(__ngFactoryType__ || TabFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TabFocusService,
      factory: TabFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to move the focus of ("locked") child elements. This is useful
 * for a nested list of tabs, carousel slides or any group of elements that
 * requires horizontal navigation.
 */
class TabFocusDirective extends AutoFocusDirective {
  handleNextTab(event) {
    if (this.config?.tab) {
      this.service.moveTab(this.host, this.config, MOVE_FOCUS.NEXT, event);
    }
  }
  handlePreviousTab(event) {
    if (this.config?.tab) {
      this.service.moveTab(this.host, this.config, MOVE_FOCUS.PREV, event);
    }
  }
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    /** `tab` defaults to true if the directive `cxTabFocus` is used. */
    this.defaultConfig = {
      tab: true
    };
    // @Input('cxTabFocus')
    this.config = {};
  }
  static {
    this.ɵfac = function TabFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TabFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TabFocusDirective,
      hostBindings: function TabFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.arrowRight", function TabFocusDirective_keydown_arrowRight_HostBindingHandler($event) {
            return ctx.handleNextTab($event);
          })("keydown.arrowLeft", function TabFocusDirective_keydown_arrowLeft_HostBindingHandler($event) {
            return ctx.handlePreviousTab($event);
          });
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: TabFocusService
  }], {
    handleNextTab: [{
      type: HostListener,
      args: ['keydown.arrowRight', ['$event']]
    }],
    handlePreviousTab: [{
      type: HostListener,
      args: ['keydown.arrowLeft', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TrapFocusService extends TabFocusService {
  /**
   * Indicates whether any of the child elements of the host are focusable.
   *
   * @param host `HTMLElement` that is used to query the focusable elements.
   */
  hasFocusableChildren(host) {
    return this.findFocusable(host).length > 0;
  }
  /**
   * Focus the next or previous element of all available focusable elements.
   * The focus is _trapped_ in case there's no next or previous available element.
   * The focus will automatically move the start or end of the list.
   */
  moveFocus(host, config, increment, event) {
    const focusable = this.findFocusable(host);
    let index = focusable.findIndex(v => v === event.target) + increment;
    const trap = config.trap || config.trapTabOnly;
    const shouldMoveFocus = index >= 0 && index < focusable.length || index < 0 && this.getTrapStart(trap) || index >= focusable.length && this.getTrapEnd(trap);
    if (shouldMoveFocus) {
      if (index >= focusable.length) {
        index = 0;
      }
      if (index < 0) {
        index = focusable.length - 1;
      }
      event.preventDefault();
      event.stopPropagation();
      const el = focusable[index];
      el.focus();
    }
  }
  getTrapStart(trap) {
    return trap === true || trap === TrapFocus.start;
  }
  getTrapEnd(trap) {
    return trap === true || trap === TrapFocus.end;
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵTrapFocusService_BaseFactory;
      return function TrapFocusService_Factory(__ngFactoryType__) {
        return (ɵTrapFocusService_BaseFactory || (ɵTrapFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(TrapFocusService)))(__ngFactoryType__ || TrapFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TrapFocusService,
      factory: TrapFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrapFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that keeps the focus inside the focusable child elements,
 * also known as a _focus trap_.
 */
class TrapFocusDirective extends TabFocusDirective {
  constructor(elementRef, service) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.defaultConfig = {
      trap: true
    };
    // @Input('cxTrapFocus')
    this.config = {};
    this.handleTrapDown = event => {
      const isTabPressed = event.key === 'Tab';
      if (!!this.config.trap || this.config.trapTabOnly && isTabPressed) {
        this.moveFocus(event, MOVE_FOCUS.NEXT);
      }
    };
    this.handleTrapUp = event => {
      const isTabPressed = event.key === 'Tab';
      if (!!this.config.trap || this.config.trapTabOnly && isTabPressed) {
        this.moveFocus(event, MOVE_FOCUS.PREV);
      }
    };
  }
  /**
   * Moves the focus of the element reference up or down, depending on the increment.
   * The focus of the element is trapped to avoid it from going out of the group.
   *
   * @param event UIEvent that is used to get the target element. The event is blocked
   *   from standard execution and further bubbling.
   * @param increment indicates whether the next or previous is focussed.
   */
  moveFocus(event, increment) {
    if (this.service.hasFocusableChildren(this.host)) {
      this.service.moveFocus(this.host, this.config, increment, event);
    }
  }
  static {
    this.ɵfac = function TrapFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TrapFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(TrapFocusService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TrapFocusDirective,
      hostBindings: function TrapFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.arrowdown", function TrapFocusDirective_keydown_arrowdown_HostBindingHandler($event) {
            return ctx.handleTrapDown($event);
          })("keydown.tab", function TrapFocusDirective_keydown_tab_HostBindingHandler($event) {
            return ctx.handleTrapDown($event);
          })("keydown.arrowup", function TrapFocusDirective_keydown_arrowup_HostBindingHandler($event) {
            return ctx.handleTrapUp($event);
          })("keydown.shift.tab", function TrapFocusDirective_keydown_shift_tab_HostBindingHandler($event) {
            return ctx.handleTrapUp($event);
          });
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrapFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: TrapFocusService
  }], {
    handleTrapDown: [{
      type: HostListener,
      args: ['keydown.arrowdown', ['$event']]
    }, {
      type: HostListener,
      args: ['keydown.tab', ['$event']]
    }],
    handleTrapUp: [{
      type: HostListener,
      args: ['keydown.arrowup', ['$event']]
    }, {
      type: HostListener,
      args: ['keydown.shift.tab', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LockFocusService extends TrapFocusService {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵLockFocusService_BaseFactory;
      return function LockFocusService_Factory(__ngFactoryType__) {
        return (ɵLockFocusService_BaseFactory || (ɵLockFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(LockFocusService)))(__ngFactoryType__ || LockFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LockFocusService,
      factory: LockFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Focusable elements exclude hidden elements by default, but this contradicts with
 * unlocking (hidden) elements.
 */
const UNLOCK_HIDDEN_ELEMENTS = true;
/**
 * Directive that adds persistence for focussed element in case
 * the elements are being rebuild. This happens often when change
 * detection kicks in because of new data set from the backend.
 */
class LockFocusDirective extends TrapFocusDirective {
  /**
   * When the user selects enter or space, the focusable childs are
   * unlocked, which means that the tabindex is set to 0.
   */
  handleEnter(event) {
    if (this.shouldLock && this.host === event.target) {
      this.unlockFocus(event);
      event.preventDefault();
      event.stopPropagation();
    }
  }
  /**
   * In case any of the children elements is touched by the mouse,
   * we unlock the group to not break the mouse-experience.
   */
  handleClick(event) {
    if (this.shouldLock && this.isLocked) {
      this.unlockFocus(event);
      event.stopPropagation();
    }
  }
  constructor(elementRef, service, renderer) {
    super(elementRef, service);
    this.elementRef = elementRef;
    this.service = service;
    this.renderer = renderer;
    this.defaultConfig = {
      lock: true
    };
    // @Input('cxLockFocus')
    this.config = {};
    /**
     * Emits an event when the host is unlocked.
     */
    this.unlock = new EventEmitter();
  }
  lockFocus() {
    this.addTabindexToChildren(-1);
  }
  unlockFocus(event) {
    this.unlock.emit(true);
    this.addTabindexToChildren(0);
    // we focus the host if the event was triggered from a child
    if (event?.target === this.host) {
      // we wait a few milliseconds, mainly because firefox will otherwise apply
      // the mouse event on the new focused child element
      setTimeout(() => {
        super.handleFocus(event);
      }, 100);
    }
  }
  ngOnInit() {
    super.ngOnInit();
    this.shouldLock = this.config?.lock;
    if (this.shouldLock) {
      this.tabindex = 0;
      // Locked elements will be set to `autofocus` by default if it's not
      // been configured. This will ensure that autofocus kicks in upon unlock.
      if (!this.config.hasOwnProperty('autofocus')) {
        this.config.autofocus = true;
      }
      // Locked elements will be set to `focusOnEscape` by default if it's not
      // been configured. This will ensure that  the host gets locked again when
      // `escape` is pressed.
      if (!this.config.hasOwnProperty('focusOnEscape')) {
        this.config.focusOnEscape = !(this.config?.focusOnEscape === false);
      }
    }
  }
  ngAfterViewInit() {
    if (this.shouldLock) {
      /**
       * If the component hosts a group of focusable children elements,
       * we persist the group key to the children, so that they can taken this
       * into account when they persist their focus state.
       */
      if (!!this.group) {
        const group = this.group;
        this.service.findFocusable(this.host).forEach(el =>
        // we must do this in after view init as
        this.renderer.setAttribute(el, FOCUS_GROUP_ATTR, group));
      }
      if (this.shouldAutofocus) {
        this.handleFocus();
      }
    }
    super.ngAfterViewInit();
  }
  handleFocus(event) {
    if (this.shouldLock) {
      if (this.shouldUnlockAfterAutofocus(event)) {
        // Delay unlocking in case the host is using `ChangeDetectionStrategy.Default`
        setTimeout(() => this.unlockFocus(event));
      } else {
        setTimeout(() => this.lockFocus());
        event?.stopPropagation();
        return;
      }
    }
    super.handleFocus(event);
  }
  handleEscape(event) {
    if (this.shouldLock) {
      this.service.clear(this.config.group);
    }
    super.handleEscape(event);
  }
  /**
   * When the handleFocus is called without an actual event, it's coming from Autofocus.
   * In this case we unlock the focusable children in case there's a focusable child that
   * was unlocked before.
   *
   * We keep this private to not polute the API.
   */
  shouldUnlockAfterAutofocus(event) {
    return !event && this.service.hasPersistedFocus(this.host, this.config);
  }
  /**
   * Add the tabindex attribute to the focusable children elements
   */
  addTabindexToChildren(i = 0) {
    if (this.shouldLock) {
      this.isLocked = i === -1;
      if (!(this.hasFocusableChildren && i === 0) || i === 0) {
        this.focusable.forEach(el => this.renderer.setAttribute(el, 'tabindex', i.toString()));
      }
    }
  }
  /**
   * Utility method, returns all focusable children for the host element.
   *
   * We keep this private to not polute the API.
   */
  get hasFocusableChildren() {
    return this.service.hasFocusableChildren(this.host);
  }
  /**
   * Returns the focusable children of the host element. If the host element
   * is configured to be locked, the query is restricted to child elements
   * with a tabindex !== `-1`.
   *
   * We keep this private to not polute the API.
   */
  get focusable() {
    return this.service.findFocusable(this.host, this.shouldLock, UNLOCK_HIDDEN_ELEMENTS);
  }
  static {
    this.ɵfac = function LockFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LockFocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LockFocusService), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: LockFocusDirective,
      hostVars: 4,
      hostBindings: function LockFocusDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.enter", function LockFocusDirective_keydown_enter_HostBindingHandler($event) {
            return ctx.handleEnter($event);
          })("keydown.space", function LockFocusDirective_keydown_space_HostBindingHandler($event) {
            return ctx.handleEnter($event);
          })("click", function LockFocusDirective_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("focus-lock", ctx.shouldLock)("is-locked", ctx.isLocked);
        }
      },
      outputs: {
        unlock: "unlock"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockFocusDirective, [{
    type: Directive
  }], () => [{
    type: i0.ElementRef
  }, {
    type: LockFocusService
  }, {
    type: i0.Renderer2
  }], {
    shouldLock: [{
      type: HostBinding,
      args: ['class.focus-lock']
    }],
    isLocked: [{
      type: HostBinding,
      args: ['class.is-locked']
    }],
    unlock: [{
      type: Output
    }],
    handleEnter: [{
      type: HostListener,
      args: ['keydown.enter', ['$event']]
    }, {
      type: HostListener,
      args: ['keydown.space', ['$event']]
    }],
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class KeyboardFocusService extends LockFocusService {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵKeyboardFocusService_BaseFactory;
      return function KeyboardFocusService_Factory(__ngFactoryType__) {
        return (ɵKeyboardFocusService_BaseFactory || (ɵKeyboardFocusService_BaseFactory = i0.ɵɵgetInheritedFactory(KeyboardFocusService)))(__ngFactoryType__ || KeyboardFocusService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: KeyboardFocusService,
      factory: KeyboardFocusService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeyboardFocusService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FocusDirective extends LockFocusDirective {
  constructor(elementRef, service, renderer) {
    super(elementRef, service, renderer);
    this.elementRef = elementRef;
    this.service = service;
    this.renderer = renderer;
    this.defaultConfig = {};
    this.config = {};
  }
  static {
    this.ɵfac = function FocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FocusDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(KeyboardFocusService), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FocusDirective,
      selectors: [["", "cxFocus", ""]],
      inputs: {
        config: [0, "cxFocus", "config"]
      },
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusDirective, [{
    type: Directive,
    args: [{
      selector: '[cxFocus]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: KeyboardFocusService
  }, {
    type: i0.Renderer2
  }], {
    config: [{
      type: Input,
      args: ['cxFocus']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that removes all visible and focusable elements
 * in a host container from `tab` or `shift-tab` navigation
 * except elements in `activeElementSelectors` config.
 */
class SkipFocusDirective {
  constructor() {
    this.config = {
      isEnabled: false
    };
    this.elementRef = inject(ElementRef);
    this.winRef = inject(WindowRef);
    this.renderer = inject(Renderer2);
  }
  ngOnChanges() {
    this.excludeFromFocus(this.config.isEnabled, this.config.activeElementSelectors);
  }
  excludeFromFocus(isEnabled, skipSelectors = []) {
    if (!this.winRef.isBrowser()) {
      return;
    }
    const tabindex = isEnabled ? '-1' : '0';
    const focusableElementsSelector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"]';
    const focusableElements = this.elementRef.nativeElement.querySelectorAll(focusableElementsSelector);
    Array.from(focusableElements || []).forEach(el => {
      const element = el;
      const shouldSkip = skipSelectors.some(selector => {
        return element.matches(selector);
      });
      if (!shouldSkip && this.isElementVisible(element)) {
        this.renderer.setAttribute(element, 'tabindex', tabindex);
      }
    });
  }
  isElementVisible(element) {
    const style = this.winRef.nativeWindow?.getComputedStyle(element);
    return style?.visibility !== 'hidden' && style?.display !== 'none' && element.offsetWidth > 0 && element.offsetHeight > 0;
  }
  static {
    this.ɵfac = function SkipFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipFocusDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SkipFocusDirective,
      selectors: [["", "cxSkipFocus", ""]],
      inputs: {
        config: [0, "cxSkipFocus", "config"]
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipFocusDirective, [{
    type: Directive,
    args: [{
      selector: '[cxSkipFocus]',
      standalone: false
    }]
  }], null, {
    config: [{
      type: Input,
      args: ['cxSkipFocus']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const directives$1 = [
// PersistFocusDirective,
// VisibleFocusDirective,
// BlockFocusDirective,
// AutoFocusDirective,
// EscapeFocusDirective,
// LockFocusDirective,
// TrapFocusDirective,
// TabFocusDirective,
FocusDirective, SkipFocusDirective];
class KeyboardFocusModule {
  static {
    this.ɵfac = function KeyboardFocusModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || KeyboardFocusModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: KeyboardFocusModule,
      declarations: [
      // PersistFocusDirective,
      // VisibleFocusDirective,
      // BlockFocusDirective,
      // AutoFocusDirective,
      // EscapeFocusDirective,
      // LockFocusDirective,
      // TrapFocusDirective,
      // TabFocusDirective,
      FocusDirective, SkipFocusDirective],
      imports: [CommonModule],
      exports: [
      // PersistFocusDirective,
      // VisibleFocusDirective,
      // BlockFocusDirective,
      // AutoFocusDirective,
      // EscapeFocusDirective,
      // LockFocusDirective,
      // TrapFocusDirective,
      // TabFocusDirective,
      FocusDirective, SkipFocusDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeyboardFocusModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [...directives$1],
      exports: [...directives$1]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MockKeyboardFocusDirective {
  constructor() {
    this.config = {};
  }
  static {
    this.ɵfac = function MockKeyboardFocusDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MockKeyboardFocusDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MockKeyboardFocusDirective,
      selectors: [["", "cxFocus", ""]],
      inputs: {
        config: [0, "cxFocus", "config"]
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MockKeyboardFocusDirective, [{
    type: Directive,
    args: [{
      selector: '[cxFocus]',
      standalone: false
    }]
  }], null, {
    config: [{
      type: Input,
      args: ['cxFocus']
    }]
  });
})();
class KeyboardFocusTestingModule {
  static {
    this.ɵfac = function KeyboardFocusTestingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || KeyboardFocusTestingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: KeyboardFocusTestingModule,
      declarations: [MockKeyboardFocusDirective],
      exports: [MockKeyboardFocusDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(KeyboardFocusTestingModule, [{
    type: NgModule,
    args: [{
      declarations: [MockKeyboardFocusDirective],
      exports: [MockKeyboardFocusDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Temporarily removes elements from the tabbing flow and restores them after a tick.
 *
 * This method sets the `tabIndex` of each element in the provided iterable to `-1`
 * and resets it back to `0` using `requestAnimationFrame`. While using `requestAnimationFrame`
 * may seem like a bad code smell, it is justified here as it ensures a natural tabbing flow
 * in cases where determining the next focusable element is complex, such as when directives
 * like `TrapFocusDirective` modify the DOM's focus behavior.
 *
 * This utility is especially useful for scenarios like menus, lists, or carousels where
 * `Tab` navigation is intentionally disabled, but other keyboard keys (e.g., `Arrow` keys)
 * are used for navigation. It helps prevent these elements from disrupting the tab order
 * while allowing other key-based interactions.
 *
 * @param elements - An iterable of `HTMLElement` objects to temporarily remove from tab navigation.
 */
const disableTabbingForTick = elements => {
  for (const element of elements) {
    element.tabIndex = -1;
  }
  requestAnimationFrame(() => {
    for (const element of elements) {
      element.tabIndex = 0;
    }
  });
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// given that we're likely going to refactor the directives, we're
// NOT exposing all it to the public API.
// export * from './autofocus/index';
// export * from './base/index';
// export * from './block/index';
// export * from './escape/index';
// export * from './lock/index';
// export * from './on-navigate/index';
// export * from './persist/index';
// export * from './tab/index';
// export * from './trap/index';
// export * from './visible/index';
// export * from './keyboard-focus.model';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Types of dialog openings supported
 */
var DIALOG_TYPE;
(function (DIALOG_TYPE) {
  DIALOG_TYPE["POPOVER"] = "POPOVER";
  DIALOG_TYPE["POPOVER_CENTER"] = "POPOVER_CENTER";
  DIALOG_TYPE["POPOVER_CENTER_BACKDROP"] = "POPOVER_CENTER_BACKDROP";
  DIALOG_TYPE["DIALOG"] = "DIALOG";
  DIALOG_TYPE["SIDEBAR_START"] = "SIDEBAR_START";
  DIALOG_TYPE["SIDEBAR_END"] = "SIDEBAR_END";
})(DIALOG_TYPE || (DIALOG_TYPE = {}));
/**
 * List of available callers
 */
var LAUNCH_CALLER;
(function (LAUNCH_CALLER) {
  LAUNCH_CALLER["ASM"] = "ASM";
  LAUNCH_CALLER["SKIP_LINKS"] = "SKIP_LINKS";
  LAUNCH_CALLER["ANONYMOUS_CONSENT"] = "ANONYMOUS_CONSENT";
  LAUNCH_CALLER["REPLENISHMENT_ORDER"] = "REPLENISHMENT_ORDER";
  LAUNCH_CALLER["PLACE_ORDER_SPINNER"] = "PLACE_ORDER_SPINNER";
  LAUNCH_CALLER["SUGGESTED_ADDRESSES"] = "SUGGESTED_ADDRESSES";
  LAUNCH_CALLER["COUPON"] = "COUPON";
  LAUNCH_CALLER["CLAIM_DIALOG"] = "CLAIM_DIALOG";
  LAUNCH_CALLER["STOCK_NOTIFICATION"] = "STOCK_NOTIFICATION";
})(LAUNCH_CALLER || (LAUNCH_CALLER = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let LaunchRenderStrategy = class LaunchRenderStrategy {
  constructor(document, rendererFactory) {
    this.document = document;
    this.rendererFactory = rendererFactory;
    // List of called references; only used for rendered elements
    this.renderedCallers = [];
    /**
     * Classes to apply to the component when the dialog is a DIALOG
     */
    this.dialogClasses = ['d-block', 'fade', 'modal', 'show'];
    /**
     * Classes to apply to the component when the dialog is a POPOVER
     */
    this.popoverClasses = ['cx-dialog-popover'];
    /**
     * Classes to apply to the component when the dialog is a POPOVER_CENTER
     */
    this.popoverCenterClasses = ['cx-dialog-popover-center'];
    /**
     * Classes to apply to the component when the dialog is a POPOVER_CENTER with a backdrop
     */
    this.popoverCenterBackdropClasses = ['cx-dialog-popover-center-backdrop'];
    /**
     * Classes to apply to the component when the dialog is a SIDEBAR_END
     */
    this.sidebarEndClasses = ['cx-sidebar-end'];
    /**
     * Classes to apply to the component when the dialog is a SIDEBAR_START
     */
    this.sidebarStartClasses = ['cx-sidebar-start'];
    this.renderer = rendererFactory.createRenderer(null, null);
  }
  /**
   * Determines if element should render
   *
   * @param caller
   * @param config
   */
  shouldRender(caller, config) {
    return Boolean(config.component) && (this.renderedCallers.some(el => el.caller === caller) ? !!config.multi : true);
  }
  applyClasses(component, dialogType) {
    let classes = [];
    // TODO: make classes configurable
    switch (dialogType) {
      case DIALOG_TYPE.DIALOG:
        classes = this.dialogClasses;
        this.renderer.addClass(this.document.body, 'modal-open');
        break;
      case DIALOG_TYPE.POPOVER:
        classes = this.popoverClasses;
        break;
      case DIALOG_TYPE.POPOVER_CENTER:
        classes = this.popoverCenterClasses;
        break;
      case DIALOG_TYPE.POPOVER_CENTER_BACKDROP:
        classes = this.popoverCenterBackdropClasses;
        break;
      case DIALOG_TYPE.SIDEBAR_END:
        classes = this.sidebarEndClasses;
        break;
      case DIALOG_TYPE.SIDEBAR_START:
        classes = this.sidebarStartClasses;
        break;
    }
    for (const newClass of classes) {
      this.renderer.addClass(component.location.nativeElement, newClass);
    }
  }
  /**
   * Method to call when rendered element is destroyed
   * The element will be removed from the list of rendered elements
   *
   * @param caller
   * @param _config optional parameters used in children strategies
   */
  remove(caller, config) {
    this.renderedCallers = this.renderedCallers.filter(el => el.caller !== caller);
    if (config?.dialogType === DIALOG_TYPE.DIALOG) {
      this.renderer.removeClass(this.document.body, 'modal-open');
    }
  }
  getPriority() {
    return Priority.LOW; // low, as it's a default matcher
  }
};
LaunchRenderStrategy = __decorate([__param(0, Inject(DOCUMENT))], LaunchRenderStrategy);

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `BREAKPOINT` typing defaults to five default screen names:
 * xs, sm, md, lg, xl.
 *
 * The type can be extended to allow for custom screens, such as XLL or `tablet`.
 *
 * While the screen names are fully configurable, other features might have
 * pre-configured layout settings per screen. Page layouts or table configurations,
 * for example, are driven by screen size. In case you change the screen size or
 * introduce new screen names, you might loose out on these configurations.
 */
var BREAKPOINT;
(function (BREAKPOINT) {
  BREAKPOINT["xs"] = "xs";
  BREAKPOINT["sm"] = "sm";
  BREAKPOINT["md"] = "md";
  BREAKPOINT["lg"] = "lg";
  BREAKPOINT["xl"] = "xl";
})(BREAKPOINT || (BREAKPOINT = {}));
/**
 * The LayoutConfig supports the configuration of page slots by page templates
 * or page sections, such as headers and footers. The configuration also supports
 * adaptive design per breakpoint (not per device type), so that the DOM is (re)rendered
 * por a given breakpoint.
 */
class LayoutConfig {
  static {
    this.ɵfac = function LayoutConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LayoutConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LayoutConfig,
      factory: function LayoutConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || LayoutConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LaunchDialogService {
  get data$() {
    return this._dataSubject.asObservable();
  }
  constructor(renderStrategies, layoutConfig) {
    this.renderStrategies = renderStrategies;
    this.layoutConfig = layoutConfig;
    this._dialogClose = new BehaviorSubject(undefined);
    this._dataSubject = new BehaviorSubject(undefined);
    this.logger = inject(LoggerService);
    this.renderStrategies = this.renderStrategies || [];
  }
  /**
   * Open the dialog
   *
   * @param caller LAUNCH_CALLER
   * @param openElement button's Element ref
   * @param vcr View Container Ref of the container for inline rendering
   * @param data optional data which could be passed to dialog
   */
  openDialog(caller, openElement, vcr, data) {
    const component = this.launch(caller, vcr, data);
    if (component) {
      return combineLatest([component, this.dialogClose]).pipe(filter(([, close]) => close !== undefined), tap(([comp]) => {
        openElement?.nativeElement.focus();
        this.clear(caller);
        comp?.destroy();
      }), map(([comp]) => comp));
    }
  }
  /**
   * Render the element based on the strategy from the launch configuration
   *
   * @param caller LAUNCH_CALLER
   * @param vcr View Container Ref of the container for inline rendering
   */
  launch(caller, vcr, data) {
    const config = this.findConfiguration(caller);
    if (config) {
      const renderer = this.getStrategy(config);
      // Render if the strategy exists
      if (renderer) {
        this._dialogClose.next(undefined);
        this._dataSubject.next(data);
        return renderer.render(config, caller, vcr);
      }
    } else if (isDevMode()) {
      this.logger.warn('No configuration provided for caller ' + caller);
    }
  }
  /**
   * Opens dialog and subscribe in the service. Should be used if the trigger component might get destroyed while the component is open.
   *
   * @param caller Launch Caller
   * @param openElement Element to open
   * @param data Data to provide to the rendered element
   */
  openDialogAndSubscribe(caller, openElement, data) {
    this.openDialog(caller, openElement, undefined, data)?.pipe(take(1)).subscribe();
  }
  /**
   * Util method to remove element from rendered elements list
   *
   * @param caller LAUNCH_CALLER
   */
  clear(caller) {
    const config = this.findConfiguration(caller);
    if (config) {
      const renderer = this.getStrategy(config);
      // Render if the strategy exists
      if (renderer) {
        renderer.remove(caller, config);
      }
    }
  }
  get dialogClose() {
    return this._dialogClose.asObservable();
  }
  closeDialog(reason) {
    this._dialogClose.next(reason);
  }
  /**
   * Returns the configuration for the caller
   *
   * @param caller LAUNCH_CALLER
   */
  findConfiguration(caller) {
    if (this.layoutConfig?.launch) {
      return this.layoutConfig.launch[caller];
    }
    return undefined;
  }
  /**
   * Returns the render strategy based on the configuration
   *
   * @param config Configuration for launch
   */
  getStrategy(config) {
    return resolveApplicable(this.renderStrategies, [config]);
  }
  static {
    this.ɵfac = function LaunchDialogService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LaunchDialogService)(i0.ɵɵinject(LaunchRenderStrategy), i0.ɵɵinject(LayoutConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LaunchDialogService,
      factory: LaunchDialogService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LaunchDialogService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LaunchRenderStrategy]
    }]
  }, {
    type: LayoutConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentManagementBannerComponent {
  constructor(anonymousConsentsService, vcr, launchDialogService) {
    this.anonymousConsentsService = anonymousConsentsService;
    this.vcr = vcr;
    this.launchDialogService = launchDialogService;
    this.subscriptions = new Subscription();
    this.bannerVisible$ = this.anonymousConsentsService.isBannerVisible();
    useFeatureStyles('a11yScrollToTopPositioning');
  }
  viewDetails() {
    this.hideBanner();
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ANONYMOUS_CONSENT, undefined, this.vcr);
    if (dialog) {
      this.subscriptions.add(dialog.subscribe());
    }
  }
  allowAll() {
    this.subscriptions.add(this.anonymousConsentsService.giveAllConsents().pipe(tap(() => this.hideBanner())).subscribe());
  }
  hideBanner() {
    this.anonymousConsentsService.toggleBannerDismissed(true);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function AnonymousConsentManagementBannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnonymousConsentManagementBannerComponent)(i0.ɵɵdirectiveInject(i1.AnonymousConsentsService), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AnonymousConsentManagementBannerComponent,
      selectors: [["cx-anonymous-consent-management-banner"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "anonymous-consent-banner", 3, "ngClass"], [1, "container"], ["class", "row", 4, "cxFeature"], [1, "row"], [1, "col-lg-7", "col-xs-12"], [1, "cx-banner-title"], [1, "cx-banner-description"], [1, "col-lg-5", "col-xs-12", "cx-banner-buttons"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-primary", 3, "click"], [1, "col-xl-7", "col-lg-6", "col-xs-12"], [1, "col-xl-5", "col-lg-6", "col-xs-12", "cx-banner-buttons"]],
      template: function AnonymousConsentManagementBannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AnonymousConsentManagementBannerComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.bannerVisible$));
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnonymousConsentManagementBannerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-anonymous-consent-management-banner',
      standalone: false,
      template: "<ng-container *ngIf=\"bannerVisible$ | async as bannerVisible\">\n  <div\n    [ngClass]=\"{ 'anonymous-consent-banner-hidden': !bannerVisible }\"\n    class=\"anonymous-consent-banner\"\n  >\n    <div class=\"container\">\n      <div class=\"row\" *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-lg-7 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-lg-5 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.viewDetails' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row\" *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n        <div class=\"col-xl-7 col-lg-6 col-xs-12\">\n          <div class=\"cx-banner-title\">\n            {{ 'anonymousConsents.banner.title' | cxTranslate }}\n          </div>\n          <div class=\"cx-banner-description\">\n            {{ 'anonymousConsents.banner.description' | cxTranslate }}\n          </div>\n        </div>\n\n        <div class=\"col-xl-5 col-lg-6 col-xs-12 cx-banner-buttons\">\n          <button class=\"btn btn-secondary\" (click)=\"viewDetails()\">\n            {{ 'anonymousConsents.banner.consentManagement' | cxTranslate }}\n          </button>\n          <button class=\"btn btn-primary\" (click)=\"allowAll()\">\n            {{ 'anonymousConsents.banner.allowAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.AnonymousConsentsService
  }, {
    type: i0.ViewContainerRef
  }, {
    type: LaunchDialogService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InlineRenderStrategy extends LaunchRenderStrategy {
  constructor(document, rendererFactory, componentFactoryResolver) {
    super(document, rendererFactory);
    this.document = document;
    this.rendererFactory = rendererFactory;
    this.componentFactoryResolver = componentFactoryResolver;
    this.logger = inject(LoggerService);
  }
  /**
   * Renders the component from the configuration in the view container ref
   *
   * @param config
   * @param caller
   * @param vcr
   */
  render(config, caller, vcr) {
    // Only render if a ViewContainerRef is provided
    if (vcr && this.shouldRender(caller, config)) {
      const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
      const component = vcr.createComponent(template);
      if (config?.dialogType) {
        this.applyClasses(component, config?.dialogType);
      }
      this.renderedCallers.push({
        caller,
        element: vcr.element,
        component
      });
      return of(component);
    } else if (isDevMode()) {
      if (!vcr) {
        this.logger.warn(`No view container ref provided for ${caller}`);
      } else {
        this.logger.warn(`Element for ${caller} already rendered. To allow multi rendering add property multi: true.`);
      }
    }
  }
  hasMatch(config) {
    return Boolean(config.inline);
  }
  static {
    this.ɵfac = function InlineRenderStrategy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InlineRenderStrategy)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i0.ComponentFactoryResolver));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InlineRenderStrategy,
      factory: InlineRenderStrategy.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineRenderStrategy, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.RendererFactory2
  }, {
    type: i0.ComponentFactoryResolver
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InlineRootRenderStrategy extends LaunchRenderStrategy {
  constructor(document, rendererFactory, componentFactoryResolver, injector) {
    super(document, rendererFactory);
    this.document = document;
    this.rendererFactory = rendererFactory;
    this.componentFactoryResolver = componentFactoryResolver;
    this.injector = injector;
  }
  get hostComponent() {
    return this.injector.get(ApplicationRef)?.components?.[0];
  }
  render(config, caller) {
    if (this.shouldRender(caller, config)) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(config.component);
      const contentInjector = Injector.create({
        providers: []
      });
      const componentRef = componentFactory.create(contentInjector);
      this.injector.get(ApplicationRef)?.attachView(componentRef.hostView);
      this.renderer.appendChild(this.hostComponent?.location.nativeElement, componentRef.location.nativeElement);
      if (config?.dialogType) {
        this.applyClasses(componentRef, config?.dialogType);
      }
      this.renderedCallers.push({
        caller,
        component: componentRef
      });
      return of(componentRef);
    }
  }
  hasMatch(config) {
    return Boolean(config.inlineRoot);
  }
  static {
    this.ɵfac = function InlineRootRenderStrategy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InlineRootRenderStrategy)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: InlineRootRenderStrategy,
      factory: InlineRootRenderStrategy.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InlineRootRenderStrategy, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.RendererFactory2
  }, {
    type: i0.ComponentFactoryResolver
  }, {
    type: i0.Injector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var OutletPosition;
(function (OutletPosition) {
  OutletPosition["REPLACE"] = "replace";
  OutletPosition["BEFORE"] = "before";
  OutletPosition["AFTER"] = "after";
})(OutletPosition || (OutletPosition = {}));
const AVOID_STACKED_OUTLETS = false;
const USE_STACKED_OUTLETS = true;
/**
 * Token for injecting outlet related context to the component rendered in the outlet
 */
class OutletContextData {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletService {
  constructor() {
    this.templatesRefs = {
      [OutletPosition.BEFORE]: new Map(),
      [OutletPosition.REPLACE]: new Map(),
      [OutletPosition.AFTER]: new Map()
    };
  }
  /**
   * @param templateOrFactory A `ComponentFactory` that inserts a component dynamically.
   */
  add(outlet, templateOrFactory, position = OutletPosition.REPLACE) {
    const store = this.templatesRefs[position];
    if (store) {
      const existing = store.get(outlet) || [];
      const newValue = existing.concat([templateOrFactory]);
      store.set(outlet, newValue);
    }
  }
  /**
   *
   * Returns a single object or multiple objects for the given outlet reference,
   * depending on the `stacked` argument.
   *
   * @param outlet The outlet reference
   * @param position the outlet position, `OutletPosition.before`, `OutletPosition.AFTER` or `OutletPosition.REPLACE`
   * @param stacked Indicates whether an array of outlet components is returned
   */
  get(outlet, position = OutletPosition.REPLACE, stacked = AVOID_STACKED_OUTLETS) {
    const store = this.templatesRefs[position] || this.templatesRefs[OutletPosition.REPLACE];
    const templateRef = store.get(outlet);
    if (templateRef && !stacked) {
      return templateRef[0];
    }
    return templateRef;
  }
  remove(outlet, position = OutletPosition.REPLACE, value) {
    const store = this.templatesRefs[position] || this.templatesRefs[OutletPosition.REPLACE];
    this.removeValueOrAll(store, outlet, value);
  }
  removeValueOrAll(store, outlet, value) {
    if (!value && store.has(outlet)) {
      store.delete(outlet);
    } else if (value && store.has(outlet)) {
      let existing = store.get(outlet);
      existing = existing?.filter(val => val !== value);
      if (existing) {
        store.set(outlet, existing);
      }
    }
  }
  static {
    this.ɵfac = function OutletService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OutletService,
      factory: OutletService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRefDirective {
  constructor(tpl, outletService) {
    this.tpl = tpl;
    this.outletService = outletService;
  }
  ngOnInit() {
    this.outletService.add(this.cxOutletRef, this.tpl, this.cxOutletPos);
  }
  ngOnDestroy() {
    this.outletService.remove(this.cxOutletRef, this.cxOutletPos, this.tpl);
  }
  static {
    this.ɵfac = function OutletRefDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletRefDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(OutletService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OutletRefDirective,
      selectors: [["", "cxOutletRef", ""]],
      inputs: {
        cxOutletRef: "cxOutletRef",
        cxOutletPos: "cxOutletPos"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletRefDirective, [{
    type: Directive,
    args: [{
      selector: '[cxOutletRef]',
      standalone: false
    }]
  }], () => [{
    type: i0.TemplateRef
  }, {
    type: OutletService
  }], {
    cxOutletRef: [{
      type: Input
    }],
    cxOutletPos: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRefModule {
  static {
    this.ɵfac = function OutletRefModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletRefModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OutletRefModule,
      declarations: [OutletRefDirective],
      imports: [CommonModule],
      exports: [OutletRefDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletRefModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [OutletRefDirective],
      exports: [OutletRefDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRendererService {
  constructor() {
    this.outletRefs = new BehaviorSubject(new Map());
  }
  /**
   * Dynamically render the templates in the specified array
   *
   * @param outlet
   */
  render(outlet) {
    if (this.outletRefs.value.size !== 0) {
      this.outletRefs.value.get(outlet)?.render();
    }
  }
  /**
   * Register outlet to be available to render dynamically
   *
   * @param cxOutlet
   * @param context
   */
  register(cxOutlet, context) {
    this.outletRefs.next(this.outletRefs.value.set(cxOutlet, context));
  }
  /**
   * Returns map of outlets
   *
   */
  getOutletRef(outlet) {
    return this.outletRefs.asObservable().pipe(map(val => val.get(outlet)), filter(isNotNullable));
  }
  static {
    this.ɵfac = function OutletRendererService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletRendererService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OutletRendererService,
      factory: OutletRendererService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletRendererService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The IntersectionService uses the native IntersectionObserver (v2), which
 * can be used to implement pre-loading and deferred loading of DOM content.
 *
 */
class IntersectionService {
  constructor(config) {
    this.config = config;
  }
  /**
   * Returns an Observable that emits only once a boolean value whenever
   * the given element has shown in the view port.
   *
   * The returned observable will only emit the first value. The
   * observable must be cleaned up either way, since the value might never emit; it
   * depends on whether the element appears in the view port.
   *
   * @param element - HTML element
   * @param options - Allows to specify an optional root margin, in order to fire before the element shows up in the viewport
   * @param intersectingCondition - Allows to specify an intersecting condition.
   * If this parameter is not set, then the transition state of the element will be verified whenever the element intersects the view port.
   * @returns Element intersects?
   */
  isIntersected(element, options, intersectingCondition) {
    return this.intersects(element, options, intersectingCondition).pipe(first(v => v === true));
  }
  /**
   * Returns an observable that emits for every change of intersection of a given element.
   *
   * @param element - HTML element
   * @param options - Allows to specify an optional root margin, in order to fire before the element shows up in the viewport
   * @param intersectingCondition - Allows to specify an intersecting condition.
   * If this parameter is not set, then the transition state of the element will be verified whenever the element intersects the view port.
   * @returns Element intersects?
   */
  isIntersecting(element, options, intersectingCondition) {
    return this.intersects(element, options, intersectingCondition);
  }
  /**
   * Indicates whenever the element intersects the view port. An optional margin
   * is used to intersects before the element shows up in the viewport.
   * A value is emitted each time the element intersects.
   */
  intersects(element, options = {}, intersectingCondition) {
    return this.createIntersectionObservable(element, options).pipe(mergeMap(entries => entries), map(entry => intersectingCondition ? intersectingCondition(entry) : entry.isIntersecting), distinctUntilChanged());
  }
  createIntersectionObservable(element, options) {
    return new Observable(observer => {
      const rootMargin = this.getRootMargin(options);
      const intersectOptions = {
        rootMargin,
        threshold: options.threshold
      };
      const intersectionObserver = new IntersectionObserver(entries => {
        observer.next(entries);
      }, intersectOptions);
      intersectionObserver.observe(element);
      return () => {
        intersectionObserver.disconnect();
      };
    });
  }
  getRootMargin(options = {}) {
    if (options.rootMargin) {
      return options.rootMargin;
    }
    const layoutConfig = this.config;
    if (layoutConfig.deferredLoading && layoutConfig.deferredLoading.intersectionMargin) {
      return layoutConfig.deferredLoading.intersectionMargin;
    }
  }
  static {
    this.ɵfac = function IntersectionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IntersectionService)(i0.ɵɵinject(LayoutConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IntersectionService,
      factory: IntersectionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IntersectionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: LayoutConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The defer loading serivce is used to defer loading of DOM elements
 * until the elements are required for the user experience.
 */
class DeferLoaderService {
  constructor(platformId, config, intersectionService) {
    this.platformId = platformId;
    this.config = config;
    this.intersectionService = intersectionService;
    this.globalLoadStrategy = config.deferredLoading?.strategy ?? DeferLoadingStrategy.INSTANT;
  }
  /**
   * Defer loading till the element intersects the viewport.
   *
   * We evaluate whether we instantly load the element for different reasons:
   * - we run in SSR mode
   * - there's no global strategy given
   * - the global loading strategy is set to INSTANT loading,
   *   and the loading strategy in the given is not set to DEFER
   * - the loading strategy in the given options is set to INSTANT
   */
  load(element, options) {
    if (this.shouldLoadInstantly((options || {}).deferLoading)) {
      return of(true);
    } else {
      return this.intersectionService.isIntersected(element, options);
    }
  }
  shouldLoadInstantly(elementLoadingStrategy) {
    return isPlatformServer(this.platformId) || elementLoadingStrategy === DeferLoadingStrategy.INSTANT || elementLoadingStrategy !== DeferLoadingStrategy.DEFER && this.globalLoadStrategy === DeferLoadingStrategy.INSTANT;
  }
  static {
    this.ɵfac = function DeferLoaderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DeferLoaderService)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(LayoutConfig), i0.ɵɵinject(IntersectionService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DeferLoaderService,
      factory: DeferLoaderService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DeferLoaderService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: Object,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }, {
    type: LayoutConfig
  }, {
    type: IntersectionService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletDirective {
  constructor(vcr, templateRef, outletService, deferLoaderService, outletRendererService) {
    this.vcr = vcr;
    this.templateRef = templateRef;
    this.outletService = outletService;
    this.deferLoaderService = deferLoaderService;
    this.outletRendererService = outletRendererService;
    this.renderedTemplate = [];
    this.renderedComponents = new Map();
    /**
     * Observable with current outlet context
     */
    this.outletContext$ = new ReplaySubject(1);
    this.loaded = new EventEmitter(true);
    this.cxComponentRefChange = new EventEmitter();
    this.subscription = new Subscription();
  }
  /**
   * Renders view for outlet or defers it, depending on the input `cxOutletDefer`
   */
  render() {
    this.vcr.clear();
    this.renderedTemplate = [];
    this.renderedComponents.clear();
    this.subscription.unsubscribe();
    this.subscription = new Subscription();
    if (this.cxOutletDefer) {
      this.deferLoading();
    } else {
      this.build();
    }
  }
  ngOnChanges(changes) {
    if (changes.cxOutlet) {
      this.render();
      this.outletRendererService.register(this.cxOutlet, this);
    }
    if (changes.cxOutletContext) {
      this.outletContext$.next(this.cxOutletContext);
    }
  }
  deferLoading() {
    this.loaded.emit(false);
    const hostElement = this.getHostElement(this.vcr.element.nativeElement);
    // Although the deferLoaderService might emit only once, as long as the hostElement
    // isn't being loaded, there's no value being emitted. Therefore we need to clean up
    // the subscription on destroy.
    this.subscription.add(this.deferLoaderService.load(hostElement, this.cxOutletDefer).subscribe(() => {
      this.build();
      this.loaded.emit(true);
    }));
  }
  /**
   * Renders view for outlet
   */
  build() {
    this.buildOutlet(OutletPosition.BEFORE);
    this.buildOutlet(OutletPosition.REPLACE);
    this.buildOutlet(OutletPosition.AFTER);
  }
  /**
   * Renders view in a given position for outlet
   */
  buildOutlet(position) {
    let templates = this.outletService.get(this.cxOutlet, position, USE_STACKED_OUTLETS);
    templates = templates?.filter(el => !this.renderedTemplate.includes(el));
    if (!templates && position === OutletPosition.REPLACE) {
      templates = [this.templateRef];
    }
    // Just in case someone extended the `OutletService` and
    // returns a singular object.
    if (!Array.isArray(templates)) {
      templates = [templates];
    }
    const components = [];
    templates.forEach(obj => {
      const component = this.create(obj, position);
      if (component) {
        components.push(component);
      }
    });
    this.renderedComponents.set(position, components);
  }
  /**
   * Renders view based on the given template or component factory
   */
  create(tmplOrFactory, position) {
    this.renderedTemplate.push(tmplOrFactory);
    if (tmplOrFactory instanceof ComponentFactory) {
      const component = this.vcr.createComponent(tmplOrFactory, undefined, this.getComponentInjector(position));
      this.cxComponentRefChange.emit(component);
      return component;
    } else if (tmplOrFactory instanceof TemplateRef) {
      const view = this.vcr.createEmbeddedView(tmplOrFactory, {
        $implicit: this.cxOutletContext
      });
      // we do not know if content is created dynamically or not
      // so we apply change detection anyway
      view.markForCheck();
      this.cxComponentRefChange.emit(view);
      return view;
    }
  }
  /**
   * Returns injector with OutletContextData that can be injected to the component
   * rendered in the outlet
   */
  getComponentInjector(position) {
    const contextData = {
      reference: this.cxOutlet,
      position,
      context: this.cxOutletContext,
      context$: this.outletContext$.asObservable()
    };
    return Injector.create({
      providers: [{
        provide: OutletContextData,
        useValue: contextData
      }],
      parent: this.vcr.injector
    });
  }
  /**
   * Returns the closest `HtmlElement`, by iterating over the
   * parent nodes of the given element.
   *
   * We avoid traversing the parent _elements_, as this is blocking
   * ie11 implementations. One of the spare exclusions we make to not
   * supporting ie11.
   *
   * @param element
   */
  getHostElement(element) {
    if (element instanceof HTMLElement) {
      return element;
    }
    return this.getHostElement(element.parentNode);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.outletContext$.complete();
  }
  static {
    this.ɵfac = function OutletDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(OutletService), i0.ɵɵdirectiveInject(DeferLoaderService), i0.ɵɵdirectiveInject(OutletRendererService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: OutletDirective,
      selectors: [["", "cxOutlet", ""]],
      inputs: {
        cxOutlet: "cxOutlet",
        cxOutletContext: "cxOutletContext",
        cxOutletDefer: "cxOutletDefer",
        cxComponentRef: "cxComponentRef"
      },
      outputs: {
        loaded: "loaded",
        cxComponentRefChange: "cxComponentRefChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletDirective, [{
    type: Directive,
    args: [{
      selector: '[cxOutlet]',
      standalone: false
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: i0.TemplateRef
  }, {
    type: OutletService
  }, {
    type: DeferLoaderService
  }, {
    type: OutletRendererService
  }], {
    cxOutlet: [{
      type: Input
    }],
    cxOutletContext: [{
      type: Input
    }],
    cxOutletDefer: [{
      type: Input
    }],
    loaded: [{
      type: Output
    }],
    cxComponentRef: [{
      type: Input
    }],
    cxComponentRefChange: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @private We plan to drive the outlets by standard configuration
 */
const PROVIDE_OUTLET_OPTIONS = new InjectionToken('PROVIDE_OUTLET_OPTIONS');
/**
 * Helper function to register a component for an outlet.
 *
 * @param options.id unique id of the outlet
 * @param options.component Component to be registered for the outlet
 * @param options.position Component's position in the outlet (default: `OutletPosition.AFTER`)
 */
function provideOutlet(options) {
  return {
    provide: PROVIDE_OUTLET_OPTIONS,
    useValue: options,
    multi: true
  };
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @private
 */
function registerOutletsFactory(providedOutletOptions, componentFactoryResolver, outletService) {
  const result = () => {
    (providedOutletOptions ?? []).forEach(options => {
      const factory = componentFactoryResolver.resolveComponentFactory(options.component);
      outletService.add(options.id, factory, options.position ?? OutletPosition.AFTER);
    });
  };
  return result;
}
class OutletModule {
  static forRoot() {
    return {
      ngModule: OutletModule,
      providers: [{
        provide: APP_INITIALIZER,
        useFactory: registerOutletsFactory,
        deps: [[new Optional(), PROVIDE_OUTLET_OPTIONS], ComponentFactoryResolver, OutletService],
        multi: true
      }]
    };
  }
  static forChild() {
    return {
      ngModule: OutletModule,
      providers: [{
        provide: MODULE_INITIALIZER,
        useFactory: registerOutletsFactory,
        deps: [[new Optional(), PROVIDE_OUTLET_OPTIONS], ComponentFactoryResolver, OutletService],
        multi: true
      }]
    };
  }
  static {
    this.ɵfac = function OutletModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: OutletModule,
      declarations: [OutletDirective],
      imports: [CommonModule],
      exports: [OutletDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [OutletDirective],
      exports: [OutletDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OutletRenderStrategy extends LaunchRenderStrategy {
  constructor(document, rendererFactory, outletService, componentFactoryResolver, outletRendererService) {
    super(document, rendererFactory);
    this.document = document;
    this.rendererFactory = rendererFactory;
    this.outletService = outletService;
    this.componentFactoryResolver = componentFactoryResolver;
    this.outletRendererService = outletRendererService;
  }
  /**
   * Renders the element in the configured outlet
   *
   * @param config
   * @param caller
   * @param vcr
   */
  render(config, caller) {
    if (this.shouldRender(caller, config)) {
      const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
      this.outletService.add(config.outlet, template, config.position ? config.position : OutletPosition.BEFORE);
      this.outletRendererService.render(config.outlet);
      this.renderedCallers.push({
        caller
      });
      return this.outletRendererService.getOutletRef(config.outlet).pipe(map(outletDirective => {
        const components = outletDirective.renderedComponents.get(config.position ? config.position : OutletPosition.BEFORE);
        return components.reverse().find(component => component.componentType === template.componentType);
      }), tap(component => {
        if (config?.dialogType && component) {
          this.applyClasses(component, config?.dialogType);
        }
      }));
    }
  }
  hasMatch(config) {
    return Boolean(config.outlet);
  }
  remove(caller, config) {
    const template = this.componentFactoryResolver.resolveComponentFactory(config.component);
    this.outletService.remove(config.outlet, config.position ? config.position : OutletPosition.BEFORE, template);
    super.remove(caller, config);
  }
  static {
    this.ɵfac = function OutletRenderStrategy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OutletRenderStrategy)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(OutletService), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(OutletRendererService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OutletRenderStrategy,
      factory: OutletRenderStrategy.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OutletRenderStrategy, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.RendererFactory2
  }, {
    type: OutletService
  }, {
    type: i0.ComponentFactoryResolver
  }, {
    type: OutletRendererService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RoutingRenderStrategy extends LaunchRenderStrategy {
  constructor(document, rendererFactory, routingService) {
    super(document, rendererFactory);
    this.document = document;
    this.rendererFactory = rendererFactory;
    this.routingService = routingService;
  }
  /**
   * Navigates to the route configured for the caller
   */
  render(config, _caller) {
    this.routingService.go(config);
  }
  hasMatch(config) {
    return Boolean(config.cxRoute);
  }
  static {
    this.ɵfac = function RoutingRenderStrategy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RoutingRenderStrategy)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i1.RoutingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RoutingRenderStrategy,
      factory: RoutingRenderStrategy.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoutingRenderStrategy, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }, {
    type: i0.RendererFactory2
  }, {
    type: i1.RoutingService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LaunchDialogModule {
  static forRoot() {
    return {
      ngModule: LaunchDialogModule,
      providers: [{
        provide: LayoutConfig,
        useExisting: Config
      }]
    };
  }
  static {
    this.ɵfac = function LaunchDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LaunchDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LaunchDialogModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: LaunchRenderStrategy,
        useExisting: OutletRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: InlineRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: RoutingRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: InlineRootRenderStrategy,
        multi: true
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LaunchDialogModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: LaunchRenderStrategy,
        useExisting: OutletRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: InlineRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: RoutingRenderStrategy,
        multi: true
      }, {
        provide: LaunchRenderStrategy,
        useExisting: InlineRootRenderStrategy,
        multi: true
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ICON_TYPE;
(function (ICON_TYPE) {
  ICON_TYPE["ACTIVE"] = "ACTIVE";
  ICON_TYPE["ADDRESS_BOOK"] = "ADDRESS_BOOK";
  ICON_TYPE["AMEX"] = "AMEX";
  ICON_TYPE["CARET_DOWN"] = "CARET_DOWN";
  ICON_TYPE["CARET_LEFT"] = "CARET_LEFT";
  ICON_TYPE["CARET_RIGHT"] = "CARET_RIGHT";
  ICON_TYPE["CARET_UP"] = "CARET_UP";
  ICON_TYPE["CART"] = "CART";
  ICON_TYPE["CART_PLUS"] = "CART_PLUS";
  ICON_TYPE["CART_ARROW_DOWN"] = "CART_ARROW_DOWN";
  ICON_TYPE["CHECK"] = "CHECK";
  ICON_TYPE["CIRCLE"] = "CIRCLE";
  ICON_TYPE["CLIPBOARD_LIST"] = "CLIPBOARD_LIST";
  ICON_TYPE["CLOCK"] = "CLOCK";
  ICON_TYPE["CLOSE"] = "CLOSE";
  ICON_TYPE["COLLAPSE"] = "COLLAPSE";
  ICON_TYPE["CREDIT_CARD"] = "CREDIT_CARD";
  ICON_TYPE["DINERS_CLUB"] = "DINERS_CLUB";
  ICON_TYPE["DOWNLOAD"] = "DOWNLOAD";
  ICON_TYPE["EMPTY_HEART"] = "EMPTY_HEART";
  ICON_TYPE["ERROR"] = "ERROR";
  ICON_TYPE["EXPAND"] = "EXPAND";
  ICON_TYPE["EXPAND_ARROWS"] = "EXPAND_ARROWS";
  ICON_TYPE["EYE"] = "EYE";
  ICON_TYPE["EYE_SLASH"] = "EYE_SLASH";
  ICON_TYPE["FILE"] = "FILE";
  ICON_TYPE["FILTER"] = "FILTER";
  ICON_TYPE["GRID"] = "GRID";
  ICON_TYPE["HEART"] = "HEART";
  ICON_TYPE["INFO"] = "INFO";
  ICON_TYPE["LINK_OUT"] = "LINK_OUT";
  ICON_TYPE["LIST"] = "LIST";
  ICON_TYPE["MASTER_CARD"] = "MASTER_CARD";
  ICON_TYPE["OFF"] = "OFF";
  ICON_TYPE["ON"] = "ON";
  ICON_TYPE["ORDER"] = "ORDER";
  ICON_TYPE["PENCIL"] = "PENCIL";
  ICON_TYPE["RESET"] = "RESET";
  ICON_TYPE["REPEAT"] = "REPEAT";
  ICON_TYPE["SEARCH"] = "SEARCH";
  ICON_TYPE["SEARCH_PLUS"] = "SEARCH_PLUS";
  ICON_TYPE["SEARCH_MINUS"] = "SEARCH_MINUS";
  ICON_TYPE["SORT"] = "SORT";
  ICON_TYPE["SORT_AMOUNT_DOWN"] = "SORT_AMOUNT_DOWN";
  ICON_TYPE["SORT_AMOUNT_UP"] = "SORT_AMOUNT_UP";
  ICON_TYPE["SORT_DOWN"] = "SORT_DOWN";
  ICON_TYPE["STAR"] = "STAR";
  ICON_TYPE["SUCCESS"] = "SUCCESS";
  ICON_TYPE["TRASH"] = "TRASH";
  ICON_TYPE["USER_FRIENDS"] = "USER_FRIENDS";
  ICON_TYPE["VISA"] = "VISA";
  ICON_TYPE["WARNING"] = "WARNING";
  ICON_TYPE["HEADSET"] = "HEADSET";
  ICON_TYPE["ATTACHMENT"] = "ATTACHMENT";
  ICON_TYPE["UPLOAD"] = "UPLOAD";
  ICON_TYPE["USER"] = "USER";
  ICON_TYPE["USER_PLUS"] = "USER_PLUS";
  ICON_TYPE["ARROW_LEFT"] = "ARROW_LEFT";
  ICON_TYPE["ARROW_RIGHT"] = "ARROW_RIGHT";
  ICON_TYPE["ARROW_DOWN"] = "ARROW_DOWN";
  ICON_TYPE["ARROW_UP"] = "ARROW_UP";
  ICON_TYPE["C360_CIRCLE_USER"] = "C360_CIRCLE_USER";
  ICON_TYPE["C360_INVOICE"] = "C360_INVOICE";
  ICON_TYPE["HELP"] = "HELP";
})(ICON_TYPE || (ICON_TYPE = {}));
class IconConfig {
  static {
    this.ɵfac = function IconConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IconConfig,
      factory: function IconConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || IconConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();
/**
 * Each ICON type can have an companied resource type, such as SVG, LINK (font) or just TEXT.
 * The resources will be automatically loaded in case they're required for the `ICON_TYPE`.
 */
var IconResourceType;
(function (IconResourceType) {
  /**
   * An svg based icon requires an SVG resource that must be loaded,
   * this is typically a sprite svg file.
   */
  IconResourceType["SVG"] = "svg";
  /**
   * A font based ICON might require an additional CSS file to be loaded.
   */
  IconResourceType["LINK"] = "link";
  /**
   * Text based icons will simply add the ICON string to the DOM. Text icons do not need an image
   * or CSS pseudo class (i.e. :before), as the text itself is the icon (i.e. +)
   */
  IconResourceType["TEXT"] = "text";
})(IconResourceType || (IconResourceType = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const fontawesomeIconConfig = {
  icon: {
    symbols: {
      ACTIVE: 'fas fa-check',
      ADDRESS_BOOK: 'far fa-address-book',
      AMEX: 'fab fa-cc-amex',
      CARET_DOWN: 'fas fa-angle-down',
      CARET_LEFT: 'fas fa-angle-left',
      CARET_RIGHT: 'fas fa-angle-right',
      CARET_UP: 'fas fa-angle-up',
      CART: 'fas fa-shopping-cart',
      CART_PLUS: 'fas fa-cart-plus',
      CART_ARROW_DOWN: 'fas fa-cart-arrow-down',
      CHECK: 'fas fa-check',
      CIRCLE: 'fas fa-circle',
      CLIPBOARD_LIST: 'fas fa-clipboard-list',
      CLOCK: 'far fa-clock',
      CLOSE: 'fas fa-times',
      COLLAPSE: 'fas fa-minus',
      CREDIT_CARD: 'fas fa-credit-card',
      DINERS_CLUB: 'fab fa-cc-diners-club',
      DOWNLOAD: 'fas fa-download',
      EMPTY_HEART: 'far fa-heart',
      ERROR: 'fas fa-exclamation-circle',
      EXPAND_ARROWS: 'fas fa-expand',
      EXPAND: 'fas fa-plus',
      EYE_SLASH: 'fas fa-eye-slash',
      EYE: 'fas fa-eye',
      FILE: 'fas fa-file',
      FILTER: 'fas fa-filter',
      GRID: 'fas fa-th-large',
      HEART: 'fas fa-heart',
      INFO: 'fas fa-info-circle',
      LINK_OUT: 'fas fa-external-link-alt',
      LIST: 'fas fa-bars',
      MASTER_CARD: 'fab fa-cc-mastercard',
      OFF: 'fas fa-toggle-off',
      ON: 'fas fa-toggle-on',
      ORDER: 'fas fa-clipboard-list',
      PDF_FILE: 'fas fa-file-pdf',
      PENCIL: 'fas fa-pencil-alt',
      REPEAT: 'fas fa-retweet',
      RESET: 'fas fa-times-circle',
      SEARCH: 'fas fa-search',
      SEARCH_PLUS: 'fas fa-search-plus',
      SEARCH_MINUS: 'fas fa-search-minus',
      SORT_AMOUNT_DOWN: 'fas fa-sort-amount-down',
      SORT_AMOUNT_UP: 'fas fa-sort-amount-up',
      SORT_DOWN: 'fas fa-sort-down',
      SORT: 'fas fa-sort',
      STAR: 'fas fa-star',
      SUCCESS: 'fas fa-check-circle',
      TRASH: 'fas fa-trash',
      USER_FRIENDS: 'fas fa-user-friends',
      VISA: 'fab fa-cc-visa',
      WARNING: 'fas fa-exclamation-triangle',
      HEADSET: 'fas fa-headset',
      ATTACHMENT: 'fas fa-paperclip',
      UPLOAD: 'fas fa-upload',
      USER: 'fas fa-user',
      USER_PLUS: 'fas fa-user-plus',
      ARROW_LEFT: 'fas fa-arrow-left',
      ARROW_RIGHT: 'fas  fa-arrow-right',
      ARROW_DOWN: 'fas  fa-arrow-down',
      ARROW_UP: 'fas  fa-arrow-up',
      C360_INVOICE: 'fas fa-file-invoice',
      C360_CIRCLE_USER: 'fas fa-circle-user',
      HELP: 'far fa-circle-question'
    },
    resources: [{
      type: IconResourceType.LINK,
      url: ''
    }]
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class IconLoaderService {
  constructor(winRef, iconConfig, sanitizer) {
    this.winRef = winRef;
    this.iconConfig = iconConfig;
    this.sanitizer = sanitizer;
    this.loadedResources = [];
  }
  /**
   * Returns an html fragment which can be added to the DOM in a safe way.
   */
  getHtml(type) {
    if (this.isResourceType(type, IconResourceType.SVG)) {
      const url = this.sanitizer.sanitize(SecurityContext.URL, this.getSvgPath(type) || null);
      if (url) {
        const useElement = this.winRef.document.createElement('use');
        useElement.setAttribute('xlink:href', url);
        const svgElement = this.winRef.document.createElement('svg');
        svgElement.appendChild(useElement);
        return this.sanitizer.bypassSecurityTrustHtml(svgElement.outerHTML);
      }
    }
    if (this.isResourceType(type, IconResourceType.TEXT)) {
      const symbol = this.getSymbol(type);
      if (symbol) {
        const helperDiv = this.winRef.document.createElement('div');
        helperDiv.textContent = symbol;
        return this.sanitizer.bypassSecurityTrustHtml(helperDiv.innerHTML);
      }
    }
  }
  /**
   * Return the direction for which the icon should mirror (ltr vs rtl). The icon direction
   * is configurable, but optional, as only a few icons should be flipped for rtl direction.
   */
  getFlipDirection(type) {
    return this.config?.flipDirection?.[type];
  }
  /**
   *
   * Returns the symbol class(es) for the icon type.
   */
  getStyleClasses(iconType) {
    return this.getSymbol(iconType) || '';
  }
  /**
   * Indicates whether the given `ICON_TYPE` is configured for
   * the given `IconResourceType`.
   */
  isResourceType(iconType, resourceType) {
    return this.config?.resources !== undefined && !!this.config.resources.find(res => res.types && res.type === resourceType && res.types.includes(iconType));
  }
  /**
   * Returns the path to the svg link. The link supports path names
   * as well, if the config a[[s been setup to support a svg file path.
   * Additionally, the icon prefix will be taken into account to prefix the
   * icon IDs in the SVG.
   */
  getSvgPath(iconType) {
    const svgResource = this.config?.resources?.find(res => res.type === IconResourceType.SVG && res.types && res.types.includes(iconType));
    if (svgResource) {
      return svgResource.url ? `${svgResource.url}#${this.getSymbol(iconType)}` : `#${this.getSymbol(iconType)}`;
    }
  }
  /**
   * Loads the resource url (if any) for the given icon.
   * The icon will only be loaded once.
   *
   * NOTE: this is not working when the shadow is used as there's
   * no head element available and the link must be loaded for every
   * web component.
   */
  addLinkResource(iconType) {
    const resource = this.findResource(iconType, IconResourceType.LINK);
    if (resource?.url && !this.loadedResources.includes(resource.url)) {
      this.loadedResources.push(resource.url);
      // using DOM APIs, so need to sanitize our URLs manually
      const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, resource.url);
      if (sanitizedUrl) {
        const head = this.winRef.document.getElementsByTagName('head')[0];
        const link = this.winRef.document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = sanitizedUrl;
        head.appendChild(link);
      }
    }
  }
  findResource(iconType, resourceType) {
    if (!this.config?.resources) {
      return;
    }
    let resource = this.config.resources.find(res => res.type === resourceType && res.types && res.types.includes(iconType));
    // no specific resource found, let's try to find a one-size-fits-all resource
    if (!resource) {
      resource = this.config.resources.find(res => res.type === resourceType && !res.types || res.types && res.types.length === 0);
    }
    return resource;
  }
  getSymbol(iconType) {
    if (this.config && this.config.symbols && this.config.symbols[iconType]) {
      return this.config.symbols[iconType];
    }
  }
  get config() {
    return this.iconConfig.icon;
  }
  static {
    this.ɵfac = function IconLoaderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconLoaderService)(i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(IconConfig), i0.ɵɵinject(i1$1.DomSanitizer));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: IconLoaderService,
      factory: IconLoaderService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconLoaderService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: IconConfig
  }, {
    type: i1$1.DomSanitizer
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The ltr and rtl directions can be used to configure the storefront for a certain direction, both statically
 * or dynamically.
 *
 * The HTML5 "auto" value is not supported in Spartacus, as it's considered to be too fragile for the global
 * direction.
 */
var DirectionMode;
(function (DirectionMode) {
  /**
   * Indicates Left to Right direction.
   */
  DirectionMode["LTR"] = "ltr";
  /**
   * Indicates Right to Left direction.
   */
  DirectionMode["RTL"] = "rtl";
})(DirectionMode || (DirectionMode = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 *
 * The icon component can be added in different ways:
 *
 * With the component selector:
 * `<cx-icon type="SEARCH"></cx-icon>`
 *
 * With the attribute selector:
 * `<span cxIcon="STAR"></span>`
 *
 * Additionally, content can be projected to the icon:
 *
 * `<button cxIcon="HAPPY">happy label</button>`
 *
 * The above button would become (based on a TEXT resource type):
 * `<button>😊happy label</button>`
 *
 * While the content is projected, the icon itself doesn't require an
 * additional DOM node which is an advantage over the component selector.
 */
class IconComponent {
  /**
   * The cxIcon directive is bound to the icon type. You can feed the `ICON_TYPE` to
   * accomplish a configurable button in the UI.
   */
  set cxIcon(type) {
    this.setIcon(type);
  }
  /**
   * The type input parameter is bound to the icon type. You can feed the `ICON_TYPE` to
   * accomplish a configurable button in the UI.
   */
  set type(type) {
    this.setIcon(type);
  }
  constructor(iconLoader, elementRef, renderer) {
    this.iconLoader = iconLoader;
    this.elementRef = elementRef;
    this.renderer = renderer;
  }
  setIcon(type) {
    if (!type || type === '') {
      return;
    }
    this.icon = this.iconLoader.getHtml(type);
    this.addStyleClasses(type);
    this.iconLoader.addLinkResource(type);
    this.flipIcon(type);
  }
  /**
   * The icons supports flipping for some icons to support rtl and ltr directions.
   */
  flipIcon(type) {
    // TODO: this can be dropped with the next major release.
    if (!this.iconLoader.getFlipDirection) {
      return;
    }
    const iconDirection = this.iconLoader.getFlipDirection(type);
    this.flipAtLtr = iconDirection === DirectionMode.LTR;
    this.flipAtRtl = iconDirection === DirectionMode.RTL;
  }
  /**
   * Adds the style classes and the link resource (if available).
   */
  addStyleClasses(type) {
    this.renderer.addClass(this.host, 'cx-icon');
    this.styleClasses?.forEach(cls => this.renderer.removeClass(this.host, cls));
    this.styleClasses = this.iconLoader.getStyleClasses(type)?.split(' ');
    this.styleClasses?.forEach(cls => {
      if (cls !== '') {
        this.renderer.addClass(this.host, cls);
      }
    });
  }
  get host() {
    return this.elementRef.nativeElement;
  }
  static {
    this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconComponent)(i0.ɵɵdirectiveInject(IconLoaderService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IconComponent,
      selectors: [["cx-icon"], ["", "cxIcon", ""]],
      hostVars: 4,
      hostBindings: function IconComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("flip-at-rtl", ctx.flipAtRtl)("flip-at-ltr", ctx.flipAtLtr);
        }
      },
      inputs: {
        cxIcon: "cxIcon",
        type: "type"
      },
      standalone: false,
      ngContentSelectors: _c1,
      decls: 2,
      vars: 1,
      consts: [[3, "outerHTML"]],
      template: function IconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelement(0, "i", 0);
          i0.ɵɵprojection(1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("outerHTML", ctx.icon, i0.ɵɵsanitizeHtml);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconComponent, [{
    type: Component,
    args: [{
      selector: 'cx-icon,[cxIcon]',
      standalone: false,
      template: "<i [outerHTML]=\"icon\"></i><ng-content></ng-content>\n"
    }]
  }], () => [{
    type: IconLoaderService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    cxIcon: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    flipAtRtl: [{
      type: HostBinding,
      args: ['class.flip-at-rtl']
    }],
    flipAtLtr: [{
      type: HostBinding,
      args: ['class.flip-at-ltr']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultIconConfig = {
  icon: {
    flipDirection: {
      CARET_RIGHT: DirectionMode.RTL,
      CARET_LEFT: DirectionMode.RTL
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class IconModule {
  static {
    this.ɵfac = function IconModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IconModule,
      declarations: [IconComponent],
      imports: [CommonModule],
      exports: [IconComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultIconConfig),
      // TODO: move the opinionated fontawesome config to a recipe
      provideDefaultConfig(fontawesomeIconConfig)],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconModule, [{
    type: NgModule,
    args: [{
      declarations: [IconComponent],
      imports: [CommonModule],
      providers: [provideDefaultConfig(defaultIconConfig),
      // TODO: move the opinionated fontawesome config to a recipe
      provideDefaultConfig(fontawesomeIconConfig)],
      exports: [IconComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// PRIVATE TESTING UTIL
class MockIconComponent {
  static {
    this.ɵfac = function MockIconComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MockIconComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MockIconComponent,
      selectors: [["cx-icon"], ["", "cxIcon", ""]],
      inputs: {
        cxIcon: "cxIcon",
        type: "type"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      template: function MockIconComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtext(0);
        }
        if (rf & 2) {
          i0.ɵɵtextInterpolate(ctx.type || ctx.cxIcon);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MockIconComponent, [{
    type: Component,
    args: [{
      selector: 'cx-icon,[cxIcon]',
      template: `{{ type || cxIcon }}`,
      standalone: false
    }]
  }], null, {
    cxIcon: [{
      type: Input
    }],
    type: [{
      type: Input
    }]
  });
})();
const mockComponents = [MockIconComponent];
class MockIconLoaderService {
  getHtml() {
    // Intentional empty method
  }
  getStyleClasses() {
    // Intentional empty method
  }
  addStyleClasses() {
    // Intentional empty method
  }
  addLinkResource() {
    // Intentional empty method
  }
}
class IconTestingModule {
  static {
    this.ɵfac = function IconTestingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IconTestingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: IconTestingModule,
      declarations: [MockIconComponent],
      exports: [MockIconComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: IconLoaderService,
        useClass: MockIconLoaderService
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconTestingModule, [{
    type: NgModule,
    args: [{
      declarations: mockComponents,
      exports: mockComponents,
      providers: [{
        provide: IconLoaderService,
        useClass: MockIconLoaderService
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// TODO: Improve a11y with better text appropriate to usage (example: loading cart spinner)
class SpinnerComponent {
  constructor() {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function SpinnerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpinnerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SpinnerComponent,
      selectors: [["cx-spinner"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["role", "status", 1, "loader-container"], [1, "loader"]],
      template: function SpinnerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtext(2);
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "spinner.loading"));
        }
      },
      dependencies: [i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-spinner',
      standalone: false,
      template: "<div class=\"loader-container\" role=\"status\">\n  <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n</div>\n"
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementFormComponent {
  constructor() {
    this.consentGiven = false;
    this.requiredConsents = [];
    this.disabled = false;
    this.showMandatory = false;
    this.consentChanged = new EventEmitter();
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
    // Intentional empty constructor
  }
  ngOnInit() {
    this.updateConsentGiven();
  }
  ngOnChanges(changes) {
    if (this.featureConfigService?.isEnabled('updateConsentGivenInOnChanges') && (changes.consent || changes.consentTemplate)) {
      this.updateConsentGiven();
    }
  }
  onConsentChange() {
    this.consentGiven = !this.consentGiven;
    this.consentChanged.emit({
      given: this.consentGiven,
      template: this.consentTemplate
    });
  }
  isRequired(templateId) {
    return templateId ? this.requiredConsents.includes(templateId) : false;
  }
  updateConsentGiven() {
    if (this.consent) {
      this.consentGiven = Boolean(this.consent.consentState === ANONYMOUS_CONSENT_STATUS.GIVEN);
    } else {
      if (this.consentTemplate && this.consentTemplate.currentConsent) {
        if (this.consentTemplate.currentConsent.consentWithdrawnDate) {
          this.consentGiven = false;
        } else if (this.consentTemplate.currentConsent.consentGivenDate) {
          this.consentGiven = true;
        }
      }
    }
  }
  static {
    this.ɵfac = function ConsentManagementFormComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsentManagementFormComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ConsentManagementFormComponent,
      selectors: [["cx-consent-management-form"]],
      inputs: {
        consentTemplate: "consentTemplate",
        requiredConsents: "requiredConsents",
        consent: "consent",
        disabled: "disabled",
        showMandatory: "showMandatory"
      },
      outputs: {
        consentChanged: "consentChanged"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 6,
      consts: [["requiredAsterisk", ""], [1, "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "checked", "name", "disabled"], [1, "form-check-label", "cx-be-bold"], [4, "ngIf"], ["class", "form-check-label", 4, "cxFeature"], [1, "form-check-label"], [3, "ngTemplateOutlet"], ["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function ConsentManagementFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1)(1, "label")(2, "input", 2);
          i0.ɵɵlistener("change", function ConsentManagementFormComponent_Template_input_change_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onConsentChange());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "span", 3);
          i0.ɵɵtemplate(4, ConsentManagementFormComponent_ng_container_4_Template, 3, 1, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ConsentManagementFormComponent_span_5_Template, 3, 2, "span", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, ConsentManagementFormComponent_span_6_Template, 3, 2, "span", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, ConsentManagementFormComponent_ng_template_7_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("checked", ctx.consentGiven)("name", ctx.consentTemplate.id)("disabled", ctx.disabled || ctx.isRequired(ctx.consentTemplate == null ? null : ctx.consentTemplate.id));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.consentTemplate == null ? null : ctx.consentTemplate.name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yNotificationsOnConsentChange");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11yNotificationsOnConsentChange");
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet, i1.FeatureDirective, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsentManagementFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-consent-management-form',
      standalone: false,
      template: "<div class=\"form-check\">\n  <label>\n    <input\n      type=\"checkbox\"\n      class=\"form-check-input\"\n      (change)=\"onConsentChange()\"\n      [checked]=\"consentGiven\"\n      [name]=\"consentTemplate.id\"\n      [disabled]=\"disabled || isRequired(consentTemplate?.id)\"\n    />\n    <span class=\"form-check-label cx-be-bold\">\n      <ng-container *ngIf=\"consentTemplate?.name\">\n        {{ consentTemplate?.name }}\n        <br />\n      </ng-container>\n    </span>\n    <span\n      *cxFeature=\"'!a11yNotificationsOnConsentChange'\"\n      class=\"form-check-label\"\n    >\n      {{ consentTemplate?.description }}\n      <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n    </span>\n  </label>\n  <span\n    *cxFeature=\"'a11yNotificationsOnConsentChange'\"\n    class=\"form-check-label\"\n  >\n    {{ consentTemplate?.description }}\n    <ng-template [ngTemplateOutlet]=\"requiredAsterisk\"></ng-template>\n  </span>\n</div>\n\n<ng-template #requiredAsterisk>\n  <ng-container *ngIf=\"showMandatory\">\n    <abbr\n      aria-hidden=\"true\"\n      class=\"text-decoration-none required-asterisk\"\n      title=\"{{ 'common.required' | cxTranslate }}\"\n      >*</abbr\n    >\n  </ng-container>\n</ng-template>\n"
    }]
  }], () => [], {
    consentTemplate: [{
      type: Input
    }],
    requiredConsents: [{
      type: Input
    }],
    consent: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    showMandatory: [{
      type: Input
    }],
    consentChanged: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AtMessageDirective {
  constructor(elementRef, templateRef, globalMessageService) {
    this.elementRef = elementRef;
    this.templateRef = templateRef;
    this.globalMessageService = globalMessageService;
  }
  get host() {
    return !!this.templateRef ? this.templateRef.elementRef.nativeElement.parentElement : this.elementRef.nativeElement;
  }
  /**
   * Emit assistive global meesage to improve screen reader vocalization.
   * @param event
   */
  handleClick(event) {
    event?.preventDefault();
    if (event?.target === this.host && this.cxAtMessage) {
      const message = Array.isArray(this.cxAtMessage) ? this.cxAtMessage.join('\n') : this.cxAtMessage;
      this.globalMessageService.get().pipe(take(1)).subscribe(globalMessageEntities => {
        // Override current assitive message.
        if (globalMessageEntities[GlobalMessageType.MSG_TYPE_ASSISTIVE]) {
          this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ASSISTIVE);
        }
        this.globalMessageService.add(message, GlobalMessageType.MSG_TYPE_ASSISTIVE);
      });
    }
  }
  static {
    this.ɵfac = function AtMessageDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AtMessageDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.TemplateRef, 8), i0.ɵɵdirectiveInject(i1.GlobalMessageService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AtMessageDirective,
      selectors: [["", "cxAtMessage", ""]],
      hostBindings: function AtMessageDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function AtMessageDirective_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      inputs: {
        cxAtMessage: "cxAtMessage"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtMessageDirective, [{
    type: Directive,
    args: [{
      selector: '[cxAtMessage]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.TemplateRef,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i1.GlobalMessageService
  }], {
    cxAtMessage: [{
      type: Input
    }],
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessageComponent {
  constructor() {
    this.showBody = false;
    this.isVisibleCloseButton = true;
    this.closeMessage = new EventEmitter();
    this.buttonAction = new EventEmitter();
    this.iconTypes = ICON_TYPE;
    // Intentional empty constructor
  }
  get getCssClassesForMessage() {
    return {
      'cx-message-success': this.type === GlobalMessageType.MSG_TYPE_CONFIRMATION,
      'cx-message-info': this.type === GlobalMessageType.MSG_TYPE_INFO,
      'cx-message-warning': this.type === GlobalMessageType.MSG_TYPE_WARNING,
      'cx-message-danger': this.type === GlobalMessageType.MSG_TYPE_ERROR
    };
  }
  get getIconType() {
    switch (this.type) {
      case GlobalMessageType.MSG_TYPE_WARNING:
        return ICON_TYPE.WARNING;
      case GlobalMessageType.MSG_TYPE_ERROR:
        return ICON_TYPE.ERROR;
      case GlobalMessageType.MSG_TYPE_INFO:
        return ICON_TYPE.INFO;
      default:
        return ICON_TYPE.SUCCESS;
    }
  }
  ngAfterViewInit() {
    if (this.accordionText || this.actionButtonText) {
      this.messageContainer?.nativeElement.focus();
    }
  }
  static {
    this.ɵfac = function MessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MessageComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MessageComponent,
      selectors: [["cx-message"]],
      viewQuery: function MessageComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
        }
      },
      inputs: {
        text: "text",
        actionButtonText: "actionButtonText",
        actionButtonMessage: "actionButtonMessage",
        accordionText: "accordionText",
        showBody: "showBody",
        isVisibleCloseButton: "isVisibleCloseButton",
        type: "type"
      },
      outputs: {
        closeMessage: "closeMessage",
        buttonAction: "buttonAction"
      },
      standalone: false,
      ngContentSelectors: _c3,
      decls: 2,
      vars: 2,
      consts: [["messageContainer", ""], ["class", "cx-message", "tabindex", "0", 3, "ngClass", 4, "cxFeature"], ["class", "cx-message", 3, "ngClass", 4, "cxFeature"], ["tabindex", "0", 1, "cx-message", 3, "ngClass"], [1, "cx-message-content"], ["role", "presentation", 1, "cx-message-header"], ["role", "presentation", 1, "cx-message-icon"], ["role", "presentation", 3, "type"], [1, "cx-message-text"], ["class", "cx-message-accordion-button link cx-action-link", "type", "button", 3, "click", 4, "ngIf"], ["class", "btn btn-link cx-action-link", "type", "button", 3, "cxAtMessage", "click", 4, "ngIf"], ["class", "close", "type", "button", 3, "cxAtMessage", "title", "click", 4, "ngIf"], ["class", "cx-message-body", 4, "ngIf"], ["type", "button", 1, "cx-message-accordion-button", "link", "cx-action-link", 3, "click"], [1, "cx-message-accordion-icon", 3, "type"], ["type", "button", 1, "btn", "btn-link", "cx-action-link", 3, "click", "cxAtMessage"], ["type", "button", 1, "close", 3, "click", "cxAtMessage", "title"], [3, "type"], [1, "cx-message-body"], [1, "cx-message", 3, "ngClass"], [1, "cx-message-header"], [1, "cx-message-icon"]],
      template: function MessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵtemplate(0, MessageComponent_div_0_Template, 12, 7, "div", 1)(1, MessageComponent_div_1_Template, 11, 7, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "a11yCxMessageFocus");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yCxMessageFocus");
        }
      },
      dependencies: [AtMessageDirective, i3.NgClass, i3.NgIf, IconComponent, i1.FeatureDirective, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageComponent, [{
    type: Component,
    args: [{
      selector: 'cx-message',
      standalone: false,
      template: "<div\n  *cxFeature=\"'a11yCxMessageFocus'\"\n  #messageContainer\n  [ngClass]=\"getCssClassesForMessage\"\n  class=\"cx-message\"\n  tabindex=\"0\"\n>\n  <div class=\"cx-message-content\">\n    <div role=\"presentation\" class=\"cx-message-header\">\n      <span role=\"presentation\" class=\"cx-message-icon\">\n        <cx-icon role=\"presentation\" [type]=\"getIconType\"></cx-icon>\n      </span>\n\n      <span class=\"cx-message-text\">\n        {{ text }}\n      </span>\n\n      <button\n        *ngIf=\"accordionText\"\n        (click)=\"showBody = !showBody\"\n        [attr.aria-expanded]=\"showBody\"\n        [attr.aria-label]=\"accordionText\"\n        class=\"cx-message-accordion-button link cx-action-link\"\n        type=\"button\"\n      >\n        {{ accordionText }}\n        <cx-icon\n          [type]=\"showBody ? 'CARET_UP' : 'CARET_DOWN'\"\n          class=\"cx-message-accordion-icon\"\n        ></cx-icon>\n      </button>\n\n      <button\n        *ngIf=\"actionButtonText\"\n        (click)=\"buttonAction.emit()\"\n        [cxAtMessage]=\"actionButtonMessage\"\n        class=\"btn btn-link cx-action-link\"\n        type=\"button\"\n      >\n        {{ actionButtonText }}\n      </button>\n\n      <button\n        *ngIf=\"isVisibleCloseButton\"\n        (click)=\"closeMessage.emit()\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        [cxAtMessage]=\"'common.close' | cxTranslate\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        class=\"close\"\n        type=\"button\"\n      >\n        <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n      </button>\n    </div>\n\n    <div *ngIf=\"showBody || !accordionText\" class=\"cx-message-body\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n\n<div\n  *cxFeature=\"'!a11yCxMessageFocus'\"\n  [ngClass]=\"getCssClassesForMessage\"\n  class=\"cx-message\"\n>\n  <div class=\"cx-message-content\">\n    <div class=\"cx-message-header\">\n      <span class=\"cx-message-icon\">\n        <cx-icon [type]=\"getIconType\"></cx-icon>\n      </span>\n\n      <span class=\"cx-message-text\">\n        {{ text }}\n        <button\n          *ngIf=\"accordionText\"\n          (click)=\"showBody = !showBody\"\n          [attr.aria-expanded]=\"showBody\"\n          [attr.aria-label]=\"accordionText\"\n          class=\"cx-message-accordion-button link cx-action-link\"\n          type=\"button\"\n        >\n          {{ accordionText }}\n          <cx-icon\n            [type]=\"showBody ? 'CARET_UP' : 'CARET_DOWN'\"\n            class=\"cx-message-accordion-icon\"\n          ></cx-icon>\n        </button>\n\n        <button\n          *ngIf=\"actionButtonText\"\n          (click)=\"buttonAction.emit()\"\n          [cxAtMessage]=\"actionButtonMessage\"\n          class=\"btn btn-link cx-action-link\"\n          type=\"button\"\n        >\n          {{ actionButtonText }}\n        </button>\n      </span>\n\n      <button\n        *ngIf=\"isVisibleCloseButton\"\n        (click)=\"closeMessage.emit()\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        [cxAtMessage]=\"'common.close' | cxTranslate\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        class=\"close\"\n        type=\"button\"\n      >\n        <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n      </button>\n    </div>\n\n    <div *ngIf=\"showBody || !accordionText\" class=\"cx-message-body\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [], {
    text: [{
      type: Input
    }],
    actionButtonText: [{
      type: Input
    }],
    actionButtonMessage: [{
      type: Input
    }],
    accordionText: [{
      type: Input
    }],
    showBody: [{
      type: Input
    }],
    isVisibleCloseButton: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    closeMessage: [{
      type: Output
    }],
    buttonAction: [{
      type: Output
    }],
    messageContainer: [{
      type: ViewChild,
      args: ['messageContainer']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentDialogComponent {
  handleClick(event) {
    // Close on click outside the dialog window
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(config, anonymousConsentsService, el, launchDialogService) {
    this.config = config;
    this.anonymousConsentsService = anonymousConsentsService;
    this.el = el;
    this.launchDialogService = launchDialogService;
    this.subscriptions = new Subscription();
    this.featureConfigService = inject(FeatureConfigService);
    this.showLegalDescription = true;
    this.iconTypes = ICON_TYPE;
    this.requiredConsents = [];
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'input[type="checkbox"]',
      focusOnEscape: true
    };
    this.globalMessageService = inject(GlobalMessageService, {
      optional: true
    });
    this.globalMessageType = GlobalMessageType;
    this.message$ = new Subject();
    if (this.config.anonymousConsents) {
      this.showLegalDescription = this.config.anonymousConsents.showLegalDescriptionInDialog;
      if (this.config.anonymousConsents.requiredConsents) {
        this.requiredConsents = this.config.anonymousConsents.requiredConsents;
      }
    }
    useFeatureStyles('a11yAnonymousConsentMessageInDialog');
  }
  ngOnInit() {
    this.templates$ = this.anonymousConsentsService.getTemplates();
    this.consents$ = this.anonymousConsentsService.getConsents();
    this.loading$ = this.anonymousConsentsService.getLoadTemplatesLoading();
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  rejectAll() {
    this.subscriptions.add(combineLatest([this.templates$, this.consents$]).pipe(take(1), distinctUntilChanged(), tap(([templates, consents]) => templates.forEach(template => {
      const consent = this.getCorrespondingConsent(template, consents);
      if (consent && this.anonymousConsentsService.isConsentGiven(consent)) {
        if (this.isRequiredConsent(template)) {
          return;
        }
        if (template.id) {
          this.anonymousConsentsService.withdrawConsent(template.id);
        }
      }
    }))).subscribe(() => this.onConsentWithdrawnSuccess()));
    if (!this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
      this.close('rejectAll');
    }
  }
  allowAll() {
    this.subscriptions.add(combineLatest([this.templates$, this.consents$]).pipe(take(1), distinctUntilChanged(), tap(([templates, consents]) => templates.forEach(template => {
      const consent = this.getCorrespondingConsent(template, consents);
      if (consent && (consent.consentState == null || this.anonymousConsentsService.isConsentWithdrawn(consent))) {
        if (this.isRequiredConsent(template)) {
          return;
        }
        if (template.id) {
          this.anonymousConsentsService.giveConsent(template.id);
        }
      }
    }))).subscribe(() => this.onConsentGivenSuccess()));
    if (!this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
      this.close('allowAll');
    }
  }
  isRequiredConsent(template) {
    return Boolean(template.id && this.config.anonymousConsents?.requiredConsents && this.config.anonymousConsents.requiredConsents.includes(template.id));
  }
  onConsentChange({
    given,
    template
  }) {
    if (template.id) {
      if (given) {
        this.anonymousConsentsService.giveConsent(template.id);
        this.onConsentGivenSuccess();
      } else {
        this.anonymousConsentsService.withdrawConsent(template.id);
        this.onConsentWithdrawnSuccess();
      }
    }
  }
  getCorrespondingConsent(template, consents = []) {
    for (const consent of consents) {
      if (template.id === consent.templateCode) {
        return consent;
      }
    }
    return null;
  }
  onConsentGivenSuccess() {
    if (this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
      this.message$.next({
        type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
        key: 'consentManagementForm.message.success.given'
      });
    } else if (this.featureConfigService.isEnabled('a11yNotificationsOnConsentChange')) {
      this.globalMessageService?.add({
        key: 'consentManagementForm.message.success.given'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  onConsentWithdrawnSuccess() {
    if (this.featureConfigService.isEnabled('a11yAnonymousConsentMessageInDialog')) {
      this.message$.next({
        type: GlobalMessageType.MSG_TYPE_CONFIRMATION,
        key: 'consentManagementForm.message.success.withdrawn'
      });
    } else if (this.featureConfigService.isEnabled('a11yNotificationsOnConsentChange')) {
      this.globalMessageService?.add({
        key: 'consentManagementForm.message.success.withdrawn'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  closeMessage() {
    this.message$.next(null);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function AnonymousConsentDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnonymousConsentDialogComponent)(i0.ɵɵdirectiveInject(i1.AnonymousConsentsConfig), i0.ɵɵdirectiveInject(i1.AnonymousConsentsService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AnonymousConsentDialogComponent,
      selectors: [["cx-anonymous-consent-dialog"]],
      hostBindings: function AnonymousConsentDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function AnonymousConsentDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 6,
      vars: 5,
      consts: [["dialogBody", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "modal-lg", "cx-anonymous-consent-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-dialog-content"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "modal-header", "cx-dialog-header"], ["id", "dialogTitle"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], ["class", "cx-dialog-description", 4, "ngIf"], [4, "cxFeature"], [1, "cx-dialog-buttons"], [1, "btn", "btn-link", "cx-action-link", 3, "click"], ["class", "modal-body cx-dialog-body", 4, "ngIf"], ["role", "status"], [1, "cx-dialog-description"], [1, "cx-dialog-separator", "col-sm-12", "d-xs-block", "d-sm-block", "d-md-none"], ["aria-live", "assertive", "aria-atomic", "true", 1, "cx-dialog-message"], [3, "text", "type", "isVisibleCloseButton", "cxFocus", "closeMessage", 4, "ngIf"], [3, "closeMessage", "text", "type", "isVisibleCloseButton", "cxFocus"], [1, "modal-body", "cx-dialog-body"], [4, "ngIf"], ["class", "cx-dialog-row col-sm-12 col-md-6", 4, "ngFor", "ngForOf"], [1, "cx-dialog-row", "col-sm-12", "col-md-6"], [3, "consentChanged", "consentTemplate", "requiredConsents", "consent"]],
      template: function AnonymousConsentDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("esc", function AnonymousConsentDialogComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 2);
          i0.ɵɵtemplate(2, AnonymousConsentDialogComponent_div_2_Template, 2, 0, "div", 3);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵtemplate(4, AnonymousConsentDialogComponent_ng_template_4_Template, 21, 22, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const dialogBody_r10 = i0.ɵɵreference(5);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx.loading$))("ngIfElse", dialogBody_r10);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, IconComponent, SpinnerComponent, ConsentManagementFormComponent, FocusDirective, i1.FeatureDirective, MessageComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnonymousConsentDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-anonymous-consent-dialog',
      standalone: false,
      template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg cx-anonymous-consent-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-dialog-content\">\n    <div *ngIf=\"loading$ | async; else dialogBody\">\n      <cx-spinner></cx-spinner>\n    </div>\n    <ng-template #dialogBody>\n      <div\n        *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n        role=\"status\"\n        [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n      ></div>\n      <div class=\"modal-header cx-dialog-header\">\n        <h3 id=\"dialogTitle\">\n          {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n        </h3>\n        <button\n          type=\"button\"\n          class=\"close\"\n          title=\"{{ 'common.close' | cxTranslate }}\"\n          [attr.aria-label]=\"'common.close' | cxTranslate\"\n          (click)=\"close('Cross click')\"\n        >\n          <span aria-hidden=\"true\">\n            <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n          </span>\n        </button>\n      </div>\n      <!-- Separator -->\n      <div class=\"cx-dialog-description\" *ngIf=\"showLegalDescription\">\n        {{ 'anonymousConsents.dialog.legalDescription' | cxTranslate }}\n        <div\n          class=\"cx-dialog-separator col-sm-12 d-xs-block d-sm-block d-md-none\"\n        ></div>\n      </div>\n\n      <ng-container *cxFeature=\"'a11yAnonymousConsentMessageInDialog'\">\n        <div class=\"cx-dialog-message\" aria-live=\"assertive\" aria-atomic=\"true\">\n          <cx-message\n            *ngIf=\"message$ | async as message\"\n            [text]=\"message.key | cxTranslate\"\n            [type]=\"message.type\"\n            [isVisibleCloseButton]=\"true\"\n            (closeMessage)=\"closeMessage()\"\n            [cxFocus]=\"{ autofocus: '.cx-message' }\"\n          ></cx-message>\n        </div>\n      </ng-container>\n      <!-- Actions -->\n      <div class=\"cx-dialog-buttons\">\n        <button class=\"btn btn-link cx-action-link\" (click)=\"rejectAll()\">\n          {{ 'anonymousConsents.dialog.clearAll' | cxTranslate }}\n        </button>\n        <button class=\"btn btn-link cx-action-link\" (click)=\"allowAll()\">\n          {{ 'anonymousConsents.dialog.selectAll' | cxTranslate }}\n        </button>\n      </div>\n      <!-- Modal Body -->\n      <div\n        class=\"modal-body cx-dialog-body\"\n        *ngIf=\"templates$ | async as templates\"\n      >\n        <ng-container *ngIf=\"consents$ | async as consents\">\n          <div\n            class=\"cx-dialog-row col-sm-12 col-md-6\"\n            *ngFor=\"let template of templates\"\n          >\n            <cx-consent-management-form\n              [consentTemplate]=\"template\"\n              [requiredConsents]=\"requiredConsents\"\n              [consent]=\"getCorrespondingConsent(template, consents)\"\n              (consentChanged)=\"onConsentChange($event)\"\n            ></cx-consent-management-form>\n          </div>\n        </ng-container>\n      </div>\n    </ng-template>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.AnonymousConsentsConfig
  }, {
    type: i1.AnonymousConsentsService
  }, {
    type: i0.ElementRef
  }, {
    type: LaunchDialogService
  }], {
    globalMessageService: [{
      type: Optional
    }],
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultAnonymousConsentLayoutConfig = {
  launch: {
    ANONYMOUS_CONSENT: {
      inlineRoot: true,
      component: AnonymousConsentDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentOpenDialogComponent {
  constructor(vcr, anonymousConsentsService, launchDialogService) {
    this.vcr = vcr;
    this.anonymousConsentsService = anonymousConsentsService;
    this.launchDialogService = launchDialogService;
    this.bannerVisible$ = this.anonymousConsentsService.isBannerVisible();
    useFeatureStyles('a11yHideConsentButtonWhenBannerVisible');
  }
  openDialog() {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.ANONYMOUS_CONSENT, this.openElement, this.vcr);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  static {
    this.ɵfac = function AnonymousConsentOpenDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnonymousConsentOpenDialogComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i1.AnonymousConsentsService), i0.ɵɵdirectiveInject(LaunchDialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AnonymousConsentOpenDialogComponent,
      selectors: [["cx-anonymous-consent-open-dialog"]],
      viewQuery: function AnonymousConsentOpenDialogComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.openElement = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [["open", ""], [4, "cxFeature"], [1, "btn", "btn-link", 3, "click"], ["class", "btn btn-link", 3, "click", 4, "ngIf"]],
      template: function AnonymousConsentOpenDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AnonymousConsentOpenDialogComponent_ng_container_0_Template, 5, 3, "ng-container", 1)(1, AnonymousConsentOpenDialogComponent_ng_container_1_Template, 3, 3, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "!a11yHideConsentButtonWhenBannerVisible");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11yHideConsentButtonWhenBannerVisible");
        }
      },
      dependencies: [i3.NgIf, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnonymousConsentOpenDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-anonymous-consent-open-dialog',
      standalone: false,
      template: "<ng-container *cxFeature=\"'!a11yHideConsentButtonWhenBannerVisible'\">\n  <button #open class=\"btn btn-link\" (click)=\"openDialog()\">\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n\n<ng-container *cxFeature=\"'a11yHideConsentButtonWhenBannerVisible'\">\n  <button\n    *ngIf=\"!(bannerVisible$ | async)\"\n    #open\n    class=\"btn btn-link\"\n    (click)=\"openDialog()\"\n  >\n    {{ 'anonymousConsents.dialog.title' | cxTranslate }}\n  </button>\n</ng-container>\n"
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: i1.AnonymousConsentsService
  }, {
    type: LaunchDialogService
  }], {
    openElement: [{
      type: ViewChild,
      args: ['open']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentManagementBannerModule {
  static {
    this.ɵfac = function AnonymousConsentManagementBannerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnonymousConsentManagementBannerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AnonymousConsentManagementBannerModule,
      declarations: [AnonymousConsentManagementBannerComponent, AnonymousConsentOpenDialogComponent],
      imports: [CommonModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [AnonymousConsentManagementBannerComponent, AnonymousConsentOpenDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultAnonymousConsentLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          AnonymousConsentManagementBannerComponent: {
            component: AnonymousConsentManagementBannerComponent,
            deferLoading: DeferLoadingStrategy.INSTANT
          },
          AnonymousConsentOpenDialogComponent: {
            component: AnonymousConsentOpenDialogComponent
          }
        }
      })],
      imports: [CommonModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnonymousConsentManagementBannerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule],
      providers: [provideDefaultConfig(defaultAnonymousConsentLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          AnonymousConsentManagementBannerComponent: {
            component: AnonymousConsentManagementBannerComponent,
            deferLoading: DeferLoadingStrategy.INSTANT
          },
          AnonymousConsentOpenDialogComponent: {
            component: AnonymousConsentOpenDialogComponent
          }
        }
      })],
      declarations: [AnonymousConsentManagementBannerComponent, AnonymousConsentOpenDialogComponent],
      exports: [AnonymousConsentManagementBannerComponent, AnonymousConsentOpenDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Utility service for running multiple guards and composing their results
 * into a single result observable.
 */
class GuardsComposer {
  /**
   * Executes guards, returning an Observable that:
   * - emits `true` if all those guards pass (emit `true`)
   * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
   *
   * This is in line with the default Angular behavior.
   */
  canActivate(guards, route, state) {
    if (guards.length) {
      const canActivateObservables = guards.map(guard => this.canActivateGuard(guard, route, state));
      return this.composeCanActivateObservables(canActivateObservables);
    }
    return of(true);
  }
  /**
   * Executes a guard's `canActivate` method with `route` and `state`,
   * returning its result as an Observable.
   *
   * Converts non-Observable results (Promise or static value) into Observable.
   */
  canActivateGuard(guard, route, state) {
    if (this.isCanActivate(guard)) {
      return wrapIntoObservable(guard.canActivate(route, state)).pipe(first$1());
    } else {
      throw new Error('Invalid CanActivate guard');
    }
  }
  /**
   * Composes the given observables into a single observable that emits a boolean or an UrlTree.
   *
   * The returned composed observable:
   * - emits `true` after all the given observables emit `true`.
   * - emits `false` or `UrlTree` as soon as any of the given observables emit such a value (`false` or `UrlTree`).
   */
  composeCanActivateObservables(canActivateObservables) {
    return concat(...canActivateObservables).pipe(skipWhile(canActivate => canActivate === true), endWith(true), first$1());
  }
  /**
   * Tells whether the given object has a `canActivate` method.
   */
  isCanActivate(guard) {
    return guard && typeof guard.canActivate === 'function';
  }
  static {
    this.ɵfac = function GuardsComposer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GuardsComposer)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GuardsComposer,
      factory: GuardsComposer.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GuardsComposer, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards that run on all CMS-driven routes before executing `{@link CmsPageGuard}`'s main logic.
 *
 *  **CAUTION**: Suitable for global guards ONLY! For route-specific guards, configure them under `cmsComponents`:
 * ```ts
 * provideConfig({
 *   cmsComponents: {
 *     [SomeCmsComponentType]: { guards: [MyGuard] }
 *   }
 * })
 * ```
 */
const BEFORE_CMS_PAGE_GUARD = new InjectionToken('BEFORE_CMS_PAGE_GUARD', {
  providedIn: 'root',
  factory: () => []
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service that executes guards provided via the injection token `BEFORE_CMS_PAGE_GUARD`.
 */
class BeforeCmsPageGuardService {
  constructor() {
    this.guards = inject(BEFORE_CMS_PAGE_GUARD);
    this.guardsComposer = inject(GuardsComposer);
  }
  /**
   * Executes guards from `BEFORE_CMS_PAGE_GUARD` token, returning an Observable that:
   * - emits `true` if all those guards pass (emit `true`)
   * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
   */
  canActivate(route, state) {
    return this.guardsComposer.canActivate(this.guards, route, state);
  }
  static {
    this.ɵfac = function BeforeCmsPageGuardService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BeforeCmsPageGuardService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BeforeCmsPageGuardService,
      factory: BeforeCmsPageGuardService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BeforeCmsPageGuardService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const PAGE_LAYOUT_HANDLER = new InjectionToken('PageLayoutHandler');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `BreakpointService` resolves the various screen sizes that are used in
 * the storefront. The screen sizes are globally configurable based on your
 * layout requirements. You can adjust the screen sizes by setting the minimum
 * and/or maximum size for a breakpoint, as well as extending the configuration
 * with new screens.
 *
 * By default, the `BreakpointService` is based on the breakpoints from the
 * Bootstrap ui library:
 * - `xs`: < 576px
 * - `sm`: 576px - 767px
 * - `md`: 768px - 991px
 * - `lg`: 992px - 1199px
 * - `xl`: >= 1200px
 */
class BreakpointService {
  constructor(winRef, layoutConfig, platform) {
    this.winRef = winRef;
    this.layoutConfig = layoutConfig;
    this.platform = platform;
    this.breakpoint$ = isPlatformBrowser(this.platform) ? this.winRef.resize$.pipe(map(event => this.getBreakpoint(event.target.innerWidth)), distinctUntilChanged(), shareReplay({
      refCount: true,
      bufferSize: 1
    })) : of(this.fallbackBreakpoint);
  }
  /**
   * Returns the breakpoints for the storefront layout.
   *
   * The breakpoints are driven by the `LayoutConfig.breakpoints` and sorted based on
   * the given screen size.
   */
  get breakpoints() {
    if (!this._breakpoints) {
      this._breakpoints = this.resolveBreakpointsFromConfig();
    }
    return this._breakpoints;
  }
  /**
   * Returns the _maximum_ size for the breakpoint, given by the `LayoutConfig.breakpoints`
   * configuration.
   */
  getSize(breakpoint) {
    return this.getMaxSize(breakpoint) ??
    // if there's no direct max value or explicit max value
    // we must derive the max value from the previous min
    this.getMinSize(this.breakpoints?.[this.breakpoints.indexOf(breakpoint) + 1]);
  }
  /**
   * Indicates whether the current screen size is smaller than the maximum size of the
   * given breakpoint.
   *
   * If the given breakpoint is `BREAKPOINT.md`, the method returns `true` when the
   * window innerWidth is smaller than the configured size of `BREAKPOINT.md`.
   */
  isDown(breakpoint) {
    return this.breakpoint$.pipe(map(br => this.breakpoints.slice(0, this.breakpoints.indexOf(breakpoint) + 1).includes(br)));
  }
  /**
   * Indicates whether the current screen size is larger than the minimum size of the
   * given breakpoint.
   *
   * If the given breakpoint is `BREAKPOINT.md`, the method returns `true` when the
   * window innerWidth is larger than the configured size of `BREAKPOINT.sm`.
   */
  isUp(breakpoint) {
    return this.breakpoint$.pipe(map(br => this.breakpoints.slice(this.breakpoints.indexOf(breakpoint)).includes(br)));
  }
  /**
   * Indicates whether the given breakpoint fits in the current screen size.
   */
  isEqual(breakpoint) {
    return this.breakpoint$.pipe(map(br => br === breakpoint));
  }
  /**
   * Returns the fallback breakpoint in case no breakpoint can be resolved. This is
   * typically the case when we're on SSR without an actual window.
   *
   * Returns the smallest screen size (mobile first).
   */
  get fallbackBreakpoint() {
    return this.breakpoints?.[0];
  }
  /**
   * Resolves the breakpoints and sorts them according to the configured size.
   *
   * The sort order is by small to large screens.
   */
  resolveBreakpointsFromConfig() {
    const sortByScreenSize = (next, prev) => {
      const nextMinSize = this.getMinSize(next);
      const maxNext = Math.max(nextMinSize ? nextMinSize + 1 : 0, this.getMaxSize(next) || 0);
      const preMinSize = this.getMinSize(prev);
      const maxPrev = Math.max(preMinSize ? preMinSize + 1 : 0, this.getMaxSize(prev) || 0);
      return maxNext < maxPrev ? -1 : 0;
    };
    return Object.keys(this.config).sort(sortByScreenSize);
  }
  /**
   * Returns the _maximum_ size for the breakpoint, given by the
   * `LayoutConfig.breakpoints` configuration. We will try to resolve the
   * max size form the current breakpoint, but if this is not available, we
   * resolve it form the next breakpoint
   */
  getMaxSize(breakpoint) {
    const breakpointConfig = this.config[breakpoint];
    if (!breakpointConfig) {
      return null;
    }
    // we treat numbers as the max number by default
    if (typeof breakpointConfig === 'number') {
      return breakpointConfig;
    } else if (breakpointConfig.max) {
      return breakpointConfig.max;
    } else {
      return null;
    }
  }
  getMinSize(breakpoint) {
    return this.config[breakpoint]?.min ?? null;
  }
  /**
   * Returns a `BREAKPOINT` for the given window size.
   *
   * This method tries to match the closest breakpoint for the given
   * window size. We'll fallback to the `largest` size in case the window
   * is greater than the largest configurable breakpoint.
   *
   * The windowWidth should be smaller than the maximum size of any of the
   * screen sizes defined in the `LayoutConfig.breakpoints`.
   */
  getBreakpoint(windowWidth) {
    return this.breakpoints.find(br => {
      const size = this.getSize(br);
      return size !== null && windowWidth < size;
    }) ?? this.breakpoints?.[this.breakpoints.length - 1];
  }
  /**
   * Helper method to return the breakpoint configuration.
   */
  get config() {
    return this.layoutConfig?.breakpoints || {};
  }
  static {
    this.ɵfac = function BreakpointService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreakpointService)(i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(LayoutConfig), i0.ɵɵinject(PLATFORM_ID));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BreakpointService,
      factory: BreakpointService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreakpointService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: LayoutConfig
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutService {
  constructor(cms, config, breakpointService, unifiedInjector) {
    this.cms = cms;
    this.config = config;
    this.breakpointService = breakpointService;
    this.unifiedInjector = unifiedInjector;
    this.subscription = new Subscription();
    this.logger = inject(LoggerService);
    // Prints warn messages for missing layout configs.
    // The warnings are only printed once per config
    // to not pollute the console log.
    this.warnLogMessages = {};
    this.logSlots = {};
    this.subscription.add(this.unifiedInjector.getMulti(PAGE_LAYOUT_HANDLER).subscribe(handlers => this.handlers = handlers));
  }
  getSlots(section) {
    return combineLatest([this.page$, this.breakpointService.breakpoint$]).pipe(map(([page, breakpoint]) => {
      const pageTemplate = page.template;
      const slots = this.resolveSlots(page, section, breakpoint);
      return {
        slots,
        pageTemplate,
        breakpoint
      };
    }), switchMap(({
      slots,
      pageTemplate,
      breakpoint
    }) => {
      let result = of(slots);
      for (const handler of this.handlers || []) {
        result = handler.handle(result, pageTemplate, section, breakpoint);
      }
      return result;
    }), distinctUntilChanged((a, b) => {
      if (a.length !== b.length) {
        return false;
      }
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    }));
  }
  /**
   * Returns an observable with the last page slot above-the-fold
   * for the given pageTemplate / breakpoint.
   *
   * The page fold is configurable in the `LayoutConfig` for each page layout.
   */
  getPageFoldSlot(pageTemplate) {
    return this.breakpointService.breakpoint$.pipe(map(breakpoint => {
      if (!this.config.layoutSlots) {
        // no layout config available
        return undefined;
      }
      const pageTemplateConfig = this.config.layoutSlots[pageTemplate];
      const config = this.getResponsiveSlotConfig(pageTemplateConfig, 'pageFold', breakpoint);
      return config ? config.pageFold : undefined;
    }));
  }
  resolveSlots(page, section, breakpoint) {
    const config = this.getSlotConfig(page.template ?? '', 'slots', section, breakpoint);
    if (config && config.slots) {
      const pageSlots = page.slots ? Object.keys(page.slots) : [];
      return config.slots.filter(slot => pageSlots.includes(slot));
    } else if (!section) {
      this.logMissingLayoutConfig(page);
      return page.slots ? Object.keys(page.slots) : [];
    } else {
      this.logMissingLayoutConfig(page, section);
      return [];
    }
  }
  get page$() {
    return this.cms.getCurrentPage().pipe(filter(page => !!page));
  }
  get templateName$() {
    return this.page$.pipe(map(page => page.template), filter(isNotUndefined));
  }
  /**
   * load slots from the layout configuration. The breakpoint is used
   * to load a specific configuration for the given breakpoint. If there's
   * no configuration available for the given breakpoint the default slot
   * configuration is returned.
   */
  getSlotConfig(templateUid, configAttribute, section, breakpoint) {
    if (!this.config.layoutSlots) {
      return undefined;
    }
    const pageTemplateConfig = this.config.layoutSlots[templateUid];
    if (section) {
      return this.getSlotConfigForSection(templateUid, configAttribute, section, breakpoint);
    }
    if (pageTemplateConfig) {
      return this.getResponsiveSlotConfig(pageTemplateConfig, configAttribute, breakpoint);
    }
  }
  getSlotConfigForSection(templateUid, configAttribute, section, breakpoint) {
    const pageTemplateConfig = this.config.layoutSlots?.[templateUid];
    if (!pageTemplateConfig || !section) {
      return undefined;
    }
    // if there's no section config on the page layout
    // we fall back to the global section config
    const sectionConfig = pageTemplateConfig[section] ? pageTemplateConfig[section] : this.config.layoutSlots?.[section];
    if (!sectionConfig) {
      return undefined;
    }
    const responsiveConfig = this.getResponsiveSlotConfig(sectionConfig, configAttribute, breakpoint);
    if (responsiveConfig.hasOwnProperty(configAttribute)) {
      return responsiveConfig;
    } else if (pageTemplateConfig[section].hasOwnProperty(configAttribute)) {
      return pageTemplateConfig[section];
    } else if (this.config.layoutSlots?.[section]) {
      return this.config.layoutSlots[section];
    }
  }
  /**
   * Returns a list of slots for a breakpoint specific configuration
   * If there's no specific configuration for the breakpoint,
   * the closest available configuration will be returned.
   */
  getResponsiveSlotConfig(layoutSlotConfig, configAttribute, breakpoint) {
    let slotConfig = layoutSlotConfig;
    // fallback to default slot config
    if (!layoutSlotConfig || !breakpoint) {
      return slotConfig;
    }
    // we have a config for the specific breakpoint
    if (layoutSlotConfig[breakpoint] && layoutSlotConfig[breakpoint].hasOwnProperty(configAttribute)) {
      return layoutSlotConfig[breakpoint];
    }
    // find closest config
    const all = this.breakpointService.breakpoints;
    for (const br of all.slice(0, all.indexOf(breakpoint))) {
      if (layoutSlotConfig[br] && layoutSlotConfig[br].hasOwnProperty(configAttribute)) {
        slotConfig = layoutSlotConfig[br];
      }
    }
    return slotConfig;
  }
  /**
   * In order to help developers, we print some detailed log information in
   * case there's no layout configuration available for the given page template
   * or section. Additionally, the slot positions are printed in the console
   * in a format that can be copied / paste to the configuration.
   */
  logMissingLayoutConfig(page, section) {
    if (!isDevMode()) {
      return;
    }
    if (page.template && !this.logSlots[page.template]) {
      // the info log is not printed in production
      this.logger.info(`Available CMS page slots: '${(page.slots ? Object.keys(page.slots) : []).join(`','`)}'`);
      this.logSlots[page.template] = true;
    }
    const cacheKey = section || page.template;
    if (cacheKey && !this.warnLogMessages[cacheKey]) {
      this.logger.warn(`No layout config found for ${cacheKey}, you can configure a 'LayoutConfig' to control the rendering of page slots.`);
      this.warnLogMessages[cacheKey] = true;
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function PageLayoutService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLayoutService)(i0.ɵɵinject(i1.CmsService), i0.ɵɵinject(LayoutConfig), i0.ɵɵinject(BreakpointService), i0.ɵɵinject(i1.UnifiedInjector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PageLayoutService,
      factory: PageLayoutService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLayoutService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.CmsService
  }, {
    type: LayoutConfig
  }, {
    type: BreakpointService
  }, {
    type: i1.UnifiedInjector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service responsible for resolving cms config based feature modules.
 */
class CmsFeaturesService {
  constructor(configInitializer, featureModules) {
    this.configInitializer = configInitializer;
    this.featureModules = featureModules;
    // maps componentType to feature
    this.componentFeatureMap = new Map();
    /*
     * Contains either FeatureInstance or FeatureInstance resolver for not yet
     * resolved feature modules
     */
    this.featureInstances = new Map();
    this.initFeatureMap();
  }
  initFeatureMap() {
    this.configInitializer.getStable('featureModules').subscribe(config => {
      this.featureModulesConfig = config.featureModules ?? {};
      for (const [featureName, featureConfig] of Object.entries(this.featureModulesConfig)) {
        if (typeof featureConfig !== 'string' && featureConfig?.module && featureConfig?.cmsComponents?.length) {
          for (const component of featureConfig.cmsComponents) {
            this.componentFeatureMap.set(component, featureName);
          }
        }
      }
    });
  }
  /**
   * Check if there is feature module configuration that covers specified
   * component type
   */
  hasFeatureFor(componentType) {
    return this.componentFeatureMap.has(componentType);
  }
  /**
   * Return full CmsComponent mapping defined in feature module
   */
  getCmsMapping(componentType) {
    const feature = this.componentFeatureMap.get(componentType);
    if (!feature) {
      return of(undefined);
    }
    return this.resolveFeatureInstance(feature).pipe(map(featureInstance => featureInstance.componentsMappings?.[componentType]));
  }
  /**
   * Resolves feature module for provided component type
   *
   * @param componentType
   */
  getModule(componentType) {
    const feature = this.componentFeatureMap.get(componentType);
    if (!feature) {
      return undefined;
    }
    let module;
    // we are returning injectors only for already resolved features
    this.featureInstances.get(feature)?.subscribe(featureInstance => {
      module = featureInstance.moduleRef;
    }).unsubscribe();
    return module;
  }
  /**
   * Resolve feature based on feature name, if feature was not yet resolved
   *
   * It will first resolve all module dependencies if defined
   */
  resolveFeatureInstance(featureName) {
    return defer(() => {
      if (!this.featureInstances.has(featureName)) {
        this.featureInstances.set(featureName, this.featureModules.resolveFeature(featureName).pipe(map(moduleRef => this.createFeatureInstance(moduleRef, featureName)), shareReplay()));
      }
      return this.featureInstances.get(featureName) ?? EMPTY;
    });
  }
  /**
   * Create feature instance from feature's moduleRef
   */
  createFeatureInstance(moduleRef, feature) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const featureConfig = this.featureModulesConfig[feature];
    const featureInstance = {
      moduleRef,
      componentsMappings: {}
    };
    // resolve configuration for feature module
    const resolvedConfiguration = this.resolveFeatureConfiguration(moduleRef.injector);
    // extract cms components configuration from feature config
    for (const componentType of featureConfig.cmsComponents ?? []) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      featureInstance.componentsMappings[componentType] = resolvedConfiguration.cmsComponents?.[componentType] ?? {};
    }
    return featureInstance;
  }
  /**
   * Returns configuration provided in feature module
   */
  resolveFeatureConfiguration(featureInjector) {
    // get config chunks from feature lib
    const featureConfigChunks = featureInjector.get(ConfigChunk, [], {
      self: true
    });
    // get default config chunks from feature lib
    const featureDefaultConfigChunks = featureInjector.get(DefaultConfigChunk, [], {
      self: true
    });
    return deepMerge({}, ...(featureDefaultConfigChunks ?? []), ...(featureConfigChunks ?? []));
  }
  static {
    this.ɵfac = function CmsFeaturesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsFeaturesService)(i0.ɵɵinject(i1.ConfigInitializerService), i0.ɵɵinject(i1.FeatureModulesService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsFeaturesService,
      factory: CmsFeaturesService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsFeaturesService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ConfigInitializerService
  }, {
    type: i1.FeatureModulesService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service with logic related to resolving component from cms mapping
 */
class CmsComponentsService {
  constructor(config, platformId, featureModules, configInitializer) {
    this.config = config;
    this.platformId = platformId;
    this.featureModules = featureModules;
    this.configInitializer = configInitializer;
    // Component mappings that were identified as missing
    this.missingComponents = [];
    // Already resolved mappings
    this.mappings = {};
    // Contains already initialized resolvers for specified component typez
    this.mappingResolvers = new Map();
    this.logger = inject(LoggerService);
    this.configInitializer.getStable('cmsComponents').subscribe(cmsConfig => {
      // we want to grab cms configuration available at config initialization phase
      // as lazy-loaded modules can affect global configuration resulting in
      // non-deterministic state
      this.staticCmsConfig = {
        ...cmsConfig.cmsComponents
      };
    });
  }
  /**
   * Should be called to make sure all component mappings are determined,
   * especially lazy loaded ones.
   *
   * It's recommended way to make sure all other methods of CmsComponentService
   * will be able to work synchronously for asked component types and avoid risk
   * of potential errors that could be thrown otherwise.
   */
  determineMappings(componentTypes) {
    return defer(() => {
      // we use defer, to be sure the logic below used to compose final observable
      // will be executed at subscription time (with up to date state at the time,
      // when it will be needed)
      const featureResolvers = [];
      for (const componentType of componentTypes) {
        if (!this.mappings[componentType]) {
          const staticConfig = (this.staticCmsConfig ?? this.config.cmsComponents)?.[componentType];
          // check if this component type is managed by feature module
          if (this.featureModules.hasFeatureFor(componentType)) {
            featureResolvers.push(
            // we delegate populating this.mappings to feature resolver
            this.getFeatureMappingResolver(componentType, staticConfig));
          } else {
            // simply use only static config
            if (staticConfig) {
              this.mappings[componentType] = staticConfig;
            }
          }
        }
      }
      if (featureResolvers.length) {
        return forkJoin(featureResolvers).pipe(map(() => componentTypes));
      } else {
        return of(componentTypes);
      }
    });
  }
  getFeatureMappingResolver(componentType, staticConfig) {
    if (!this.mappingResolvers.has(componentType)) {
      const mappingResolver$ = this.featureModules.getCmsMapping(componentType).pipe(filter(isNotUndefined), tap(featureComponentMapping => {
        // We treat cms mapping configuration from a feature as a default,
        // that can be overridden by app/static configuration
        this.mappings[componentType] = deepMerge({}, featureComponentMapping, staticConfig);
        this.mappingResolvers.delete(componentType);
      }), share());
      this.mappingResolvers.set(componentType, mappingResolver$);
    }
    return this.mappingResolvers.get(componentType);
  }
  /**
   * Returns the feature module for a cms component.
   * It will only work for cms components provided by feature modules.
   *
   * @param componentType
   */
  getModule(componentType) {
    if (this.featureModules.hasFeatureFor(componentType)) {
      return this.featureModules.getModule(componentType);
    }
  }
  /**
   * Return collection of component mapping configuration for specified list of
   * component types.
   *
   * If component mapping can't be determined synchronously, for example, lazy
   * loaded one, it will throw an error.
   *
   * To make sure component mapping is available, determineMappings()
   * should be called and completed first.
   */
  getMapping(componentType) {
    const componentConfig = this.mappings[componentType] ?? (this.staticCmsConfig ?? this.config.cmsComponents)?.[componentType];
    if (isDevMode() && !componentConfig) {
      if (!this.missingComponents.includes(componentType)) {
        this.missingComponents.push(componentType);
        this.logger.warn(`No component implementation found for the CMS component type '${componentType}'.\n`, `Make sure you implement a component and register it in the mapper.`);
      }
    }
    return componentConfig;
  }
  /**
   * Checks, if component should be rendered as some components
   * could be disabled for server side renderings
   */
  shouldRender(componentType) {
    const isSSR = isPlatformServer(this.platformId);
    return !(isSSR && this.getMapping(componentType)?.disableSSR);
  }
  /**
   * Return DeferLoadingStrategy for component type.
   */
  getDeferLoadingStrategy(componentType) {
    return (this.staticCmsConfig ?? this.config.cmsComponents)?.[componentType]?.deferLoading;
  }
  /**
   * Get cms driven child routes for components
   */
  getChildRoutes(componentTypes) {
    const configs = [];
    for (const componentType of componentTypes) {
      if (this.shouldRender(componentType)) {
        configs.push(this.getMapping(componentType)?.childRoutes ?? []);
      }
    }
    return this.standardizeChildRoutes(configs);
  }
  /**
   * Returns the static data for the component type.
   */
  getStaticData(componentType) {
    return this.getMapping(componentType)?.data;
  }
  /**
   * Standardizes the format of `childRoutes` config.
   *
   * Some `childRoutes` configs are simple arrays of Routes (without the notion of the parent route).
   * But some configs can be an object with children routes and their parent defined in separate property.
   */
  standardizeChildRoutes(childRoutesConfigs) {
    const result = {
      children: []
    };
    (childRoutesConfigs || []).forEach(config => {
      if (Array.isArray(config)) {
        result.children?.push(...config);
      } else {
        result.children?.push(...(config.children || []));
        if (config.parent) {
          result.parent = config.parent;
        }
      }
    });
    return result;
  }
  /**
   * Get cms driven guards for components
   */
  getGuards(componentTypes) {
    const guards = new Set();
    for (const componentType of componentTypes) {
      this.getMapping(componentType)?.guards?.forEach(guard => guards.add(guard));
    }
    return Array.from(guards);
  }
  /**
   * Get i18n keys associated with components
   */
  getI18nKeys(componentTypes) {
    const i18nKeys = new Set();
    for (const componentType of componentTypes) {
      if (this.shouldRender(componentType)) {
        this.getMapping(componentType)?.i18nKeys?.forEach(key => i18nKeys.add(key));
      }
    }
    return Array.from(i18nKeys);
  }
  static {
    this.ɵfac = function CmsComponentsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsComponentsService)(i0.ɵɵinject(i1.CmsConfig), i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(CmsFeaturesService), i0.ɵɵinject(i1.ConfigInitializerService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsComponentsService,
      factory: CmsComponentsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsComponentsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.CmsConfig
  }, {
    type: Object,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }, {
    type: CmsFeaturesService
  }, {
    type: i1.ConfigInitializerService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageSlotService {
  constructor(cmsComponentsService, platformId, document) {
    this.cmsComponentsService = cmsComponentsService;
    this.platformId = platformId;
    this.document = document;
    this.resolvePrerenderedSlots();
  }
  /**
   * Finds all slots visible in the SSR pre-rendered DOM
   */
  resolvePrerenderedSlots() {
    if (isPlatformBrowser(this.platformId)) {
      this.prerenderedSlots = Array.from(this.document.querySelectorAll('cx-page-slot')).filter(el => el.getBoundingClientRect().top < this.document.documentElement.clientHeight).map(el => el.getAttribute('position'));
    }
  }
  /**
   * Indicates if certain slot should be rendered instantly.
   *
   * It's especially useful when transitioning from SSR to CSR application,
   * where we don't want to apply deferring logic to slots that are visible
   * to avoid unnecessary flickering.
   */
  shouldNotDefer(slot) {
    if (this.prerenderedSlots?.includes(slot)) {
      this.prerenderedSlots.splice(this.prerenderedSlots.indexOf(slot), 1);
      return true;
    }
    return false;
  }
  /**
   * Returns the defer options for the given component. If the wrapping
   * page slot is prerendered, we would ignore the defer options altogether.
   */
  getComponentDeferOptions(slot, componentType) {
    if (slot && this.shouldNotDefer(slot)) {
      return {
        deferLoading: DeferLoadingStrategy.INSTANT
      };
    }
    const deferLoading = this.cmsComponentsService.getDeferLoadingStrategy(componentType);
    return {
      deferLoading
    };
  }
  static {
    this.ɵfac = function PageSlotService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageSlotService)(i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(DOCUMENT));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PageSlotService,
      factory: PageSlotService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageSlotService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CmsComponentsService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }, {
    type: Document,
    decorators: [{
      type: Inject,
      args: [DOCUMENT]
    }]
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Lifecycle events for the creation and removal of CMS components.
 *
 * Triggers when the component is added or removed from the DOM, using
 * sub event `ComponentCreateEvent` and `ComponentDestroyEvent`.
 */
class ComponentEvent extends CxEvent {}
/**
 * Indicates that the component is added to the DOM.
 */
class ComponentCreateEvent extends ComponentEvent {
  /**
   * Event's type
   */
  static {
    this.type = 'ComponentCreate';
  }
}
/**
 * Indicates that the component is removed from the DOM.
 */
class ComponentDestroyEvent extends ComponentEvent {
  /**
   * Event's type
   */
  static {
    this.type = 'ComponentDestroy';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * ComponentHandler implementations can be used for instantiating and launching
 * different types of CMS mapped components
 */
class ComponentHandler {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Responsible for obtaining component handler for specified component mapping
 */
class ComponentHandlerService {
  constructor(handlers) {
    this.handlers = handlers;
    this.logger = inject(LoggerService);
    this.invalidMappings = new Set();
  }
  /**
   * Get best matching component handler
   *
   * @param componentMapping
   */
  resolve(componentMapping) {
    const handler = resolveApplicable(this.handlers, [componentMapping]);
    if (isDevMode() && !handler) {
      if (!this.invalidMappings.has(componentMapping)) {
        this.invalidMappings.add(componentMapping);
        this.logger.warn("Can't resolve handler for component mapping: ", componentMapping);
      }
    }
    return handler;
  }
  /**
   * Get launcher for specified component mapping
   *
   * @param componentMapping
   * @param viewContainerRef
   * @param elementInjector
   */
  getLauncher(componentMapping, viewContainerRef, elementInjector, module) {
    return this.resolve(componentMapping)?.launcher(componentMapping, viewContainerRef, elementInjector, module);
  }
  static {
    this.ɵfac = function ComponentHandlerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentHandlerService)(i0.ɵɵinject(ComponentHandler, 8));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ComponentHandlerService,
      factory: ComponentHandlerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentHandlerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [ComponentHandler]
    }]
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsComponentData {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides data for `CmsComponentData`. This is used while component is injected
 * dynamically, so that the component implementation can access the data.
 *
 * The data is resolved from dynamic data (CMS api) as well as static configured data.
 */
class ComponentDataProvider {
  constructor(componentsService, cmsService) {
    this.componentsService = componentsService;
    this.cmsService = cmsService;
  }
  /**
   * Return the component data for a component given by the `uid`.
   *
   * If the `type` is provided, static component data (if available) is
   * merged into the component data. The static data is complemented and
   * overridden with data retrieved from the cms service.
   */
  get(uid, type) {
    return defer(() => {
      let staticComponentData;
      if (type) {
        staticComponentData = this.componentsService.getStaticData(type);
      }
      if (uid) {
        if (staticComponentData) {
          return this.cmsService.getComponentData(uid).pipe(map(data => ({
            ...staticComponentData,
            ...data
          })), startWith(staticComponentData));
        } else {
          return this.cmsService.getComponentData(uid);
        }
      } else {
        return staticComponentData ? of(staticComponentData) : EMPTY;
      }
    });
  }
  static {
    this.ɵfac = function ComponentDataProvider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentDataProvider)(i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(i1.CmsService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ComponentDataProvider,
      factory: ComponentDataProvider.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentDataProvider, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CmsComponentsService
  }, {
    type: i1.CmsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Used to prepare injector for CMS components.
 *
 * Injector will take into account configured providers and provides CmsComponentData
 * for specified component's uid
 */
class CmsInjectorService {
  constructor(cmsComponentsService, injector) {
    this.cmsComponentsService = cmsComponentsService;
    this.injector = injector;
  }
  getInjector(type, uid, parentInjector) {
    const configProviders = this.cmsComponentsService.getMapping(type)?.providers ?? [];
    return Injector.create({
      providers: [{
        provide: CmsComponentData,
        useFactory: dataProvider => ({
          uid,
          data$: dataProvider.get(uid, type)
        }),
        deps: [ComponentDataProvider]
      }, ...configProviders],
      parent: parentInjector ?? this.injector
    });
  }
  static {
    this.ɵfac = function CmsInjectorService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsInjectorService)(i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsInjectorService,
      factory: CmsInjectorService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsInjectorService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CmsComponentsService
  }, {
    type: i0.Injector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive used to facilitate instantiation of CMS driven dynamic components
 */
class ComponentWrapperDirective {
  constructor(vcr, cmsComponentsService, injector, dynamicAttributeService, renderer, componentHandler, cmsInjector, eventService) {
    this.vcr = vcr;
    this.cmsComponentsService = cmsComponentsService;
    this.injector = injector;
    this.dynamicAttributeService = dynamicAttributeService;
    this.renderer = renderer;
    this.componentHandler = componentHandler;
    this.cmsInjector = cmsInjector;
    this.eventService = eventService;
    this.cxComponentRef = new EventEmitter();
  }
  ngOnInit() {
    this.cmsComponentsService.determineMappings([this.cxComponentWrapper.flexType ?? '']).subscribe(() => {
      if (this.cmsComponentsService.shouldRender(this.cxComponentWrapper.flexType ?? '')) {
        this.launchComponent();
      }
    });
  }
  launchComponent() {
    const componentMapping = this.cmsComponentsService.getMapping(this.cxComponentWrapper.flexType ?? '');
    if (!componentMapping) {
      return;
    }
    this.launcherResource = this.componentHandler.getLauncher(componentMapping, this.vcr, this.cmsInjector.getInjector(this.cxComponentWrapper.flexType ?? '', this.cxComponentWrapper.uid ?? '', this.injector), this.cmsComponentsService.getModule(this.cxComponentWrapper.flexType ?? ''))?.pipe(filter(isNotUndefined), tap(({
      elementRef,
      componentRef
    }) => {
      this.cmpRef = componentRef;
      this.cxComponentRef.emit(componentRef);
      this.dispatchEvent(ComponentCreateEvent, elementRef);
      this.decorate(elementRef);
      this.injector.get(ChangeDetectorRef).markForCheck();
    }), finalize(() => this.dispatchEvent(ComponentDestroyEvent))).subscribe();
  }
  /**
   * Dispatch the component event.
   *
   * The event is dispatched during creation and removal of the component.
   */
  dispatchEvent(event, elementRef) {
    const payload = {
      typeCode: this.cxComponentWrapper.typeCode,
      id: this.cxComponentWrapper.uid
    };
    if (event === ComponentCreateEvent) {
      payload.host = elementRef?.nativeElement;
    }
    this.eventService.dispatch(payload, event);
  }
  decorate(elementRef) {
    this.dynamicAttributeService.addAttributesToComponent(elementRef.nativeElement, this.renderer, this.cxComponentWrapper);
  }
  ngOnDestroy() {
    if (this.launcherResource) {
      this.launcherResource.unsubscribe();
    }
  }
  static {
    this.ɵfac = function ComponentWrapperDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ComponentWrapperDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(CmsComponentsService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.DynamicAttributeService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(ComponentHandlerService), i0.ɵɵdirectiveInject(CmsInjectorService), i0.ɵɵdirectiveInject(i1.EventService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ComponentWrapperDirective,
      selectors: [["", "cxComponentWrapper", ""]],
      inputs: {
        cxComponentWrapper: "cxComponentWrapper"
      },
      outputs: {
        cxComponentRef: "cxComponentRef"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentWrapperDirective, [{
    type: Directive,
    args: [{
      selector: '[cxComponentWrapper]',
      standalone: false
    }]
  }], () => [{
    type: i0.ViewContainerRef
  }, {
    type: CmsComponentsService
  }, {
    type: i0.Injector
  }, {
    type: i1.DynamicAttributeService
  }, {
    type: i0.Renderer2
  }, {
    type: ComponentHandlerService
  }, {
    type: CmsInjectorService
  }, {
    type: i1.EventService
  }], {
    cxComponentWrapper: [{
      type: Input
    }],
    cxComponentRef: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `PageSlotComponent` is used to render the CMS page slot and it's components.
 *
 * The Page slot host element will be supplemented with css classes so that the layout
 * can be fully controlled by customers:
 * - The page slot _position_ is added as a css class by default.
 * - The `cx-pending` is added for as long as the slot hasn't start loading.
 * - The `page-fold` style class is added for the page slot which is configured as the page fold.
 */
class PageSlotComponent {
  /**
   * The position represents the unique key for a page slot on a single page, but can
   * be reused cross pages.
   *
   * The position is used to find the CMS components for the page slot. It is also
   * added as an additional CSS class so that layout can be applied.
   */
  set position(value) {
    this.position$.next(value);
  }
  get position() {
    return this.position$.value;
  }
  constructor(cmsService, dynamicAttributeService, renderer, elementRef, cd, pageSlotService) {
    this.cmsService = cmsService;
    this.dynamicAttributeService = dynamicAttributeService;
    this.renderer = renderer;
    this.elementRef = elementRef;
    this.cd = cd;
    this.pageSlotService = pageSlotService;
    /**
     * Indicates that the page slot is the last page slot above the fold.
     */
    this.isPageFold = false;
    /**
     * Indicates that the components of the page slot haven't been loaded as long
     * as the isPending state is true.
     */
    this.isPending = true;
    /**
     * Indicates that the page slot doesn't contain any components. This is no
     * longer used in spartacus, but kept for backwards compatibility.
     */
    this.hasComponents = false;
    this.position$ = new BehaviorSubject(undefined);
    this.slot$ = this.position$.pipe(filter(isNotUndefined), switchMap(position => this.cmsService.getContentSlot(position)), distinctUntilChanged(this.isDistinct));
    /** Observes the components for the given page slot. */
    this.components$ = this.slot$.pipe(map(slot => slot?.components ?? []));
    this.subscription = new Subscription();
    /** Keeps track of the pending components that must be loaded for the page slot */
    this.pendingComponentCount = 0;
  }
  ngOnInit() {
    this.subscription.add(this.slot$.pipe(tap(slot => this.decorate(slot))).subscribe(value => {
      this.components = value?.components || [];
      this.cd.markForCheck();
    }));
  }
  decorate(slot) {
    let cls = this.class || '';
    if (this.lastPosition && cls.indexOf(this.lastPosition) > -1) {
      cls = cls.replace(this.lastPosition, '');
    }
    if (this.position$.value) {
      cls += ` ${this.position$.value}`;
      this.lastPosition = this.position$.value;
    }
    // host bindings
    this.pending = slot?.components?.length || 0;
    this.hasComponents = slot?.components ? slot?.components?.length > 0 : false;
    if (cls && cls !== this.class) {
      this.class = cls;
    }
    if (slot) {
      this.dynamicAttributeService.addAttributesToSlot(this.elementRef.nativeElement, this.renderer, slot);
    }
  }
  /**
   * Sets the pending count for the page slot components. Once all pending components are
   * loaded, the `isPending` flag is updated, so that the associated class can be updated
   */
  set pending(count) {
    this.pendingComponentCount = count;
    this.isPending = this.pendingComponentCount > 0;
  }
  get pending() {
    return this.pendingComponentCount;
  }
  /*
   * Is triggered when a component is added to the view. This is used to
   * update the pending count
   */
  isLoaded(loadState) {
    if (loadState) {
      this.pending--;
      this.cd.markForCheck();
    }
  }
  /**
   * The `DeferLoadingStrategy` indicates whether the component should be
   * rendered instantly or whether it should be deferred.
   */
  getComponentDeferOptions(componentType) {
    return this.pageSlotService.getComponentDeferOptions(this.position, componentType);
  }
  isDistinct(old, current) {
    return Boolean(current.components && old.components && old.components.length === current.components.length && !old.components.find((el, index) => el.uid !== current.components?.[index].uid));
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function PageSlotComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageSlotComponent)(i0.ɵɵdirectiveInject(i1.CmsService), i0.ɵɵdirectiveInject(i1.DynamicAttributeService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PageSlotService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PageSlotComponent,
      selectors: [["cx-page-slot"], ["", "cx-page-slot", ""]],
      hostVars: 9,
      hostBindings: function PageSlotComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("position", ctx.position);
          i0.ɵɵclassMap(ctx.class);
          i0.ɵɵclassProp("page-fold", ctx.isPageFold)("cx-pending", ctx.isPending)("has-components", ctx.hasComponents);
        }
      },
      inputs: {
        position: "position",
        class: "class",
        isPageFold: "isPageFold",
        hasComponents: "hasComponents"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "cxOutlet", "cxOutletContext"], [4, "ngFor", "ngForOf"], [3, "loaded", "cxOutlet", "cxOutletContext", "cxOutletDefer"], [3, "cxComponentWrapper"]],
      template: function PageSlotComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PageSlotComponent_0_Template, 1, 4, null, 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.position);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, OutletDirective, ComponentWrapperDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageSlotComponent, [{
    type: Component,
    args: [{
      selector: 'cx-page-slot,[cx-page-slot]',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-template\n  *ngIf=\"position\"\n  [cxOutlet]=\"position\"\n  [cxOutletContext]=\"{ components$: components$ }\"\n>\n  <ng-container *ngFor=\"let component of components\">\n    <ng-template\n      *ngIf=\"component.flexType\"\n      [cxOutlet]=\"component.flexType\"\n      [cxOutletContext]=\"{ component: component }\"\n      [cxOutletDefer]=\"getComponentDeferOptions(component.flexType)\"\n      (loaded)=\"isLoaded($event)\"\n    >\n      <ng-container [cxComponentWrapper]=\"component\"></ng-container>\n    </ng-template>\n  </ng-container>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.CmsService
  }, {
    type: i1.DynamicAttributeService
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: PageSlotService
  }], {
    position: [{
      type: HostBinding,
      args: ['attr.position']
    }, {
      type: Input
    }],
    class: [{
      type: Input
    }, {
      type: HostBinding
    }],
    isPageFold: [{
      type: HostBinding,
      args: ['class.page-fold']
    }, {
      type: Input
    }],
    isPending: [{
      type: HostBinding,
      args: ['class.cx-pending']
    }],
    hasComponents: [{
      type: HostBinding,
      args: ['class.has-components']
    }, {
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive that Adds a style class to the host element based on the cms page
 * template. The CMS page template is driven by the CMS structure, which is configurable
 * in the backend.
 *
 * The style class is added to the host element of the directive. The host element is resolved
 * from the `elementRef`, or, in case the directive is used in an `ng-template`, by the
 * `TemplateRef`.
 *
 * An example of the usage is given below:
 *
 * ```html
 * <cx-storefront class="LandingPageTemplate">
 *   <ng-template cxPageTemplateStyle>...</ng-template>
 * <cx-storefront>
 * ```
 *
 * The style class can also be provided by an input:
 *
 * ```html
 * <ng-template [cxPageTemplateStyle]="pageTemplateName">
 * ```
 *
 */
class PageTemplateDirective {
  /**
   * Adds a style class to the host element based on the cms page template, unless
   * the class is given as an input.
   *
   * The host element is either the actual host, or the parent element in case this
   * is used inside an `ng-template`.
   */
  set setTemplate(template) {
    if (template && template !== '') {
      this.useTemplateFromInput = true;
      this.addStyleClass(template);
    } else if (this.useTemplateFromInput) {
      // we only clear the template if it has been provided by the input before
      this.clear();
    }
  }
  constructor(pageLayoutService, elementRef, templateRef, cd) {
    this.pageLayoutService = pageLayoutService;
    this.elementRef = elementRef;
    this.templateRef = templateRef;
    this.cd = cd;
    // Maintains the page template subscription
    this.subscription = new Subscription();
  }
  ngOnInit() {
    if (!this.useTemplateFromInput) {
      this.subscription.add(this.pageLayoutService.templateName$.subscribe(template => this.addStyleClass(template)));
    }
  }
  /**
   * Adds the page template as a style class to the given element. If any
   * page template was added before, we clean it up.
   *
   * We'll not use hostBinding for the style class, as it will potential drop
   * an existing class name on the host. This is why we need to work with
   * the lower level change detection api.
   */
  addStyleClass(template, el) {
    this.clear(el);
    if (template) {
      this.currentTemplate = template;
      (el ?? this.host).classList.add(this.currentTemplate);
      this.cd.markForCheck();
    }
  }
  /**
   * Cleans up the class host binding, if a template class was assigned before.
   */
  clear(el) {
    if (this.currentTemplate) {
      (el ?? this.host).classList?.remove(this.currentTemplate);
      this.cd.markForCheck();
    }
  }
  /**
   * Returns the host element (`HTMLElement`).
   *
   * If the directive is used on an `ng-template`, we take the parent element,
   * to ensure that we're not ending up with a comment.
   */
  get host() {
    return !!this.templateRef ? this.templateRef.elementRef.nativeElement.parentElement : this.elementRef.nativeElement;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function PageTemplateDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageTemplateDirective)(i0.ɵɵdirectiveInject(PageLayoutService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.TemplateRef, 8), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PageTemplateDirective,
      selectors: [["", "cxPageTemplateStyle", ""]],
      inputs: {
        setTemplate: [0, "cxPageTemplateStyle", "setTemplate"]
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageTemplateDirective, [{
    type: Directive,
    args: [{
      selector: '[cxPageTemplateStyle]',
      standalone: false
    }]
  }], () => [{
    type: PageLayoutService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.TemplateRef,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i0.ChangeDetectorRef
  }], {
    setTemplate: [{
      type: Input,
      args: ['cxPageTemplateStyle']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutComponent {
  set section(value) {
    this.section$.next(value);
  }
  constructor(pageLayoutService) {
    this.pageLayoutService = pageLayoutService;
    this.section$ = new BehaviorSubject(undefined);
    this.templateName$ = this.pageLayoutService.templateName$;
    this.layoutName$ = this.section$.pipe(switchMap(section => section ? of(section) : this.templateName$));
    this.slots$ = this.section$.pipe(switchMap(section => this.pageLayoutService.getSlots(section)));
    this.pageFoldSlot$ = this.templateName$.pipe(switchMap(templateName => this.pageLayoutService.getPageFoldSlot(templateName)), distinctUntilChanged());
  }
  static {
    this.ɵfac = function PageLayoutComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLayoutComponent)(i0.ɵɵdirectiveInject(PageLayoutService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PageLayoutComponent,
      selectors: [["cx-page-layout"]],
      inputs: {
        section: "section"
      },
      standalone: false,
      ngContentSelectors: _c1,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [3, "cxPageTemplateStyle", "cxOutlet", "cxOutletContext"], [3, "position", "isPageFold", 4, "ngFor", "ngForOf"], [3, "position", "isPageFold"]],
      template: function PageLayoutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, PageLayoutComponent_0_Template, 1, 7, null, 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.layoutName$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, OutletDirective, PageSlotComponent, PageTemplateDirective, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLayoutComponent, [{
    type: Component,
    args: [{
      selector: 'cx-page-layout',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-template\n  *ngIf=\"layoutName$ | async as layoutName\"\n  [cxPageTemplateStyle]=\"layoutName\"\n  [cxOutlet]=\"layoutName\"\n  [cxOutletContext]=\"{\n    templateName$: templateName$,\n    slots$: slots$,\n    section$: section$,\n  }\"\n>\n  <ng-content></ng-content>\n\n  <cx-page-slot\n    *ngFor=\"let slot of slots$ | async\"\n    [position]=\"slot\"\n    [isPageFold]=\"slot === (pageFoldSlot$ | async)\"\n  ></cx-page-slot>\n</ng-template>\n"
    }]
  }], () => [{
    type: PageLayoutService
  }], {
    section: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsGuardsService {
  constructor(cmsComponentsService,
  // TODO:#checkout - handle breaking changes in schematics
  unifiedInjector) {
    this.cmsComponentsService = cmsComponentsService;
    this.unifiedInjector = unifiedInjector;
    /**
     * @deprecated since 2211.41 - not needed anymore
     */
    this.featureConfigService = inject(FeatureConfigService);
    this.guardsComposer = inject(GuardsComposer);
  }
  /**
   * Executes all guards for the given `componentTypes` and returns an Observable that:
   * - emits `true` if all those guards pass (emit `true`)
   * - emits `false` or `UrlTree` immediately if any those guards fails (returns `false` or `UrlTree`)
   */
  cmsPageCanActivate(componentTypes, route, state) {
    const guards = this.cmsComponentsService.getGuards(componentTypes);
    const guardsInstances = guards.map(guardClass => getLastValueSync(this.unifiedInjector.get(guardClass))).filter(isCanActivate);
    return this.guardsComposer.canActivate(guardsInstances, route, state);
  }
  /**
   * Executes a guard's `canActivate` method with `route` and `state`,
   * returning its result as an Observable.
   *
   * Converts non-Observable results (Promise or static value) into Observable.
   *
   * NOTE: It injects the guard on demand from the {@link UnifiedInjector}
   *
   * @deprecated since 2211.24 - instead use the util {@link GuardsComposer}
   */
  canActivateGuard(guardClass, route, state) {
    const guard = getLastValueSync(this.unifiedInjector.get(guardClass));
    if (isCanActivate(guard)) {
      return wrapIntoObservable(guard.canActivate(route, state)).pipe(first());
    } else {
      throw new Error('Invalid CanActivate guard in cmsMapping');
    }
  }
  static {
    this.ɵfac = function CmsGuardsService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsGuardsService)(i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(i1.UnifiedInjector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsGuardsService,
      factory: CmsGuardsService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsGuardsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CmsComponentsService
  }, {
    type: i1.UnifiedInjector
  }], null);
})();
function isCanActivate(guard) {
  return guard && typeof guard.canActivate === 'function';
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// This service should be exposed in public API only after the refactor planned in https://github.com/SAP/spartacus/issues/7070
class CmsRoutesImplService {
  constructor(router, cmsComponentsService, cmsGuardsService) {
    this.router = router;
    this.cmsComponentsService = cmsComponentsService;
    this.cmsGuardsService = cmsGuardsService;
  }
  cmsRouteExists(url) {
    const isCmsDrivenRoute = url.startsWith('/');
    if (!isCmsDrivenRoute) {
      return false;
    }
    const routePath = url.substring(1);
    return isCmsDrivenRoute && !!this.router.config.find(route => route.data && route.data.cxCmsRouteContext && route.path === routePath);
  }
  /**
   * Contains Cms driven routing logic intended for use use in guards, especially in canActivate method.
   *
   * Will return true, when logic wont have to modify routing (so canActivate could be easily resolved to true)
   * or will return false, when routing configuration was updated and redirection to newly generated route was initiated.
   *
   * @param pageContext
   * @param currentUrl
   */
  handleCmsRoutesInGuard(pageContext, componentTypes, currentUrl, currentPageLabel) {
    if (this.cmsRouteExists(currentPageLabel)) {
      return true;
    }
    const childRoutesConfig = this.cmsComponentsService.getChildRoutes(componentTypes);
    if (childRoutesConfig?.children?.length) {
      if (this.updateRouting(pageContext, currentPageLabel, childRoutesConfig)) {
        this.router.navigateByUrl(currentUrl);
        return false;
      }
    }
    return true;
  }
  updateRouting(pageContext, pageLabel, childRoutesConfig) {
    if (pageContext.type === PageType.CONTENT_PAGE && pageLabel.startsWith('/') && pageLabel.length > 1) {
      const children = this.wrapCmsGuardsRecursively(childRoutesConfig.children ?? []);
      const newRoute = {
        path: pageLabel.substring(1),
        component: PageLayoutComponent,
        children: children,
        data: deepMerge({}, childRoutesConfig?.parent?.data ?? {}, {
          cxCmsRouteContext: {
            type: pageContext.type,
            id: pageLabel
          }
        })
      };
      this.router.resetConfig([newRoute, ...this.router.config]);
      return true;
    }
    return false;
  }
  /**
   * Traverses recursively the given Routes and wraps each `canActivate`
   * guard of each Route with a special `CanActivateFn` function.
   *
   * This special wrapper function allows for resolving
   * those guards by the Angular Router using the `UnifiedInjector`
   * instead of only root injector.
   *
   * This allows Angular Router to inject the guards (and their dependencies)
   * even when they are provided only in a child injector of a lazy-loaded module.
   */
  wrapCmsGuardsRecursively(routes) {
    return routes.map(route => {
      if (route.children) {
        route.children = this.wrapCmsGuardsRecursively(route.children);
      }
      if (route?.canActivate?.length) {
        const canActivate = route.canActivate.map(guard => this.wrapCmsGuard(guard));
        return {
          ...route,
          canActivate
        };
      }
      return route;
    });
  }
  /**
   * Returns a wrapper function `CanActivateFn` (https://angular.io/api/router/CanActivateFn)
   * that injects the given guard instance and runs its method `.canActivate()`.
   *
   * It allows to inject the guard's instance (and it's dependencies)
   * even if it's 'provided only in a child injector of a lazy-loaded module.
   */
  wrapCmsGuard(guardClass) {
    return (route, state) => {
      return this.cmsGuardsService.canActivateGuard(guardClass, route, state);
    };
  }
  static {
    this.ɵfac = function CmsRoutesImplService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsRoutesImplService)(i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(CmsGuardsService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsRoutesImplService,
      factory: CmsRoutesImplService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsRoutesImplService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$2.Router
  }, {
    type: CmsComponentsService
  }, {
    type: CmsGuardsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// Public injection token for the private implementation of the service `CmsRoutesImplService`.
// After #7070, this class should be replaced with a real implementation.
class CmsRoutesService {
  static {
    this.ɵfac = function CmsRoutesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsRoutesService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsRoutesService,
      factory: function CmsRoutesService_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || CmsRoutesService)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(CmsRoutesImplService);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsRoutesService, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: CmsRoutesImplService
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsI18nService {
  constructor(cmsComponentsService, translation, translationChunk) {
    this.cmsComponentsService = cmsComponentsService;
    this.translation = translation;
    this.translationChunk = translationChunk;
  }
  loadForComponents(componentTypes) {
    const i18nKeys = this.cmsComponentsService.getI18nKeys(componentTypes);
    const i18nChunks = new Set();
    for (const key of i18nKeys) {
      i18nChunks.add(this.translationChunk.getChunkNameForKey(key));
    }
    this.translation.loadChunks(Array.from(i18nChunks));
  }
  static {
    this.ɵfac = function CmsI18nService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsI18nService)(i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(i1.TranslationService), i0.ɵɵinject(i1.TranslationChunkService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsI18nService,
      factory: CmsI18nService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsI18nService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CmsComponentsService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.TranslationChunkService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Helper service for `CmsPageGuard`
 */
class CmsPageGuardService {
  constructor(semanticPathService, cmsService, cmsRoutes, cmsI18n, cmsGuards, cmsComponentsService, routing) {
    this.semanticPathService = semanticPathService;
    this.cmsService = cmsService;
    this.cmsRoutes = cmsRoutes;
    this.cmsI18n = cmsI18n;
    this.cmsGuards = cmsGuards;
    this.cmsComponentsService = cmsComponentsService;
    this.routing = routing;
  }
  /**
   * Takes CMS components types in the current CMS page, triggers (configurable) side effects and returns a boolean - whether the route can be activated.
   *
   * Based on `cmsComponents` config for the components in the page:
   * - Evaluates components' guards; if one of them emits false or UrlTree - the route cannot be activated or redirects to the given UrlTree, respectively.
   * - If all components' guards emitted true, then the route can be activated
   * - Then we trigger loading of configured i18n chunks in parallel
   * - And we register the configured children routes of cms components
   *
   * @param pageContext current cms page context
   * @param pageData cms page data
   * @param route activated route snapshot
   * @param state router state snapshot
   *
   * @returns boolean observable - whether the route can be activated
   */
  canActivatePage(pageContext, pageData, route, state) {
    return this.cmsService.getPageComponentTypes(pageContext).pipe(take(1), switchMap(componentTypes => this.cmsComponentsService.determineMappings(componentTypes)), switchMap(componentTypes => this.cmsGuards.cmsPageCanActivate(componentTypes, route, state).pipe(withLatestFrom(of(componentTypes)))), tap(([canActivate, componentTypes]) => {
      if (canActivate === true) {
        this.cmsI18n.loadForComponents(componentTypes);
      }
    }), map(([canActivate, componentTypes]) => {
      const pageLabel = pageData.label || pageContext.id; // for content pages the page label returned from backend can be different than ID initially assumed from route
      if (canActivate === true && !route?.data?.cxCmsRouteContext) {
        return this.cmsRoutes.handleCmsRoutesInGuard(pageContext, componentTypes, state.url, pageLabel);
      }
      return canActivate;
    }));
  }
  /**
   * Activates the "NOT FOUND" cms page.
   *
   * It loads cms page data for the "NOT FOUND" page and puts it in the state of the the requested page label.
   * Then it processes its CMS components with the method `canActivatePage()` of this service. For more, see its docs.
   */
  canActivateNotFoundPage(pageContext, route, state) {
    const notFoundLabel = this.semanticPathService.get('notFound');
    if (!notFoundLabel) {
      return of(false);
    }
    const notFoundCmsPageContext = {
      type: PageType.CONTENT_PAGE,
      id: notFoundLabel
    };
    return this.cmsService.getPage(notFoundCmsPageContext).pipe(switchMap(notFoundPage => {
      if (notFoundPage) {
        return this.cmsService.getPageIndex(notFoundCmsPageContext).pipe(tap(notFoundIndex => {
          this.cmsService.setPageFailIndex(pageContext, notFoundIndex);
          this.routing.changeNextPageContext(notFoundCmsPageContext);
        }), switchMap(notFoundIndex => this.cmsService.getPageIndex(pageContext).pipe(
        // we have to wait for page index update
        filter(index => index === notFoundIndex))), switchMap(() => this.canActivatePage(pageContext, notFoundPage, route, state)));
      }
      return of(false);
    }));
  }
  static {
    this.ɵfac = function CmsPageGuardService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsPageGuardService)(i0.ɵɵinject(i1.SemanticPathService), i0.ɵɵinject(i1.CmsService), i0.ɵɵinject(CmsRoutesService), i0.ɵɵinject(CmsI18nService), i0.ɵɵinject(CmsGuardsService), i0.ɵɵinject(CmsComponentsService), i0.ɵɵinject(i1.RoutingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsPageGuardService,
      factory: CmsPageGuardService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsPageGuardService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SemanticPathService
  }, {
    type: i1.CmsService
  }, {
    type: CmsRoutesService
  }, {
    type: CmsI18nService
  }, {
    type: CmsGuardsService
  }, {
    type: CmsComponentsService
  }, {
    type: i1.RoutingService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsPageGuard {
  static {
    this.guardName = 'CmsPageGuard';
  }
  constructor(routingService, cmsService, /** since 2211.24 not used anymore, but called indirectly via {@link BeforeCmsPageGuardService} */
  protectedRoutesGuard, service, routingConfig) {
    this.routingService = routingService;
    this.cmsService = cmsService;
    this.protectedRoutesGuard = protectedRoutesGuard;
    this.service = service;
    this.routingConfig = routingConfig;
    this.beforeCmsPageGuardService = inject(BeforeCmsPageGuardService);
  }
  /**
   * Tries to load the CMS page data for the anticipated route and returns:
   * - `true` - if it can be activated
   * - `false` - if it cannot be activated
   * - `UrlTree` - if user should be redirected to a given `UrlTree`
   *
   * If the route can be activated, it fires additional calculations on the CMS components present on this CMS page,
   * based on their configuration (`cmsComponents` config).
   *
   * For more, see docs of the `CmsPageGuardService.canActivatePage`.
   */
  canActivate(route, state) {
    return this.beforeCmsPageGuardService.canActivate(route, state).pipe(switchMap(canActivate => canActivate === true ? this.routingService.getNextPageContext().pipe(filter(isNotUndefined), take(1), switchMap(pageContext => this.cmsService.getPage(pageContext, this.shouldReload()).pipe(first(), switchMap(pageData => pageData ? this.service.canActivatePage(pageContext, pageData, route, state) : this.service.canActivateNotFoundPage(pageContext, route, state))))) : of(canActivate)));
  }
  /**
   * Returns whether we should reload the CMS page data, even when it was loaded before.
   */
  shouldReload() {
    return this.routingConfig.getLoadStrategy() !== RouteLoadStrategy.ONCE;
  }
  static {
    this.ɵfac = function CmsPageGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsPageGuard)(i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1.CmsService), i0.ɵɵinject(i1.ProtectedRoutesGuard), i0.ɵɵinject(CmsPageGuardService), i0.ɵɵinject(i1.RoutingConfigService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CmsPageGuard,
      factory: CmsPageGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsPageGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.RoutingService
  }, {
    type: i1.CmsService
  }, {
    type: i1.ProtectedRoutesGuard
  }, {
    type: CmsPageGuardService
  }, {
    type: i1.RoutingConfigService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Default component handler used for dynamically launching cms components implemented
 * as native Angular components.
 */
class DefaultComponentHandler {
  hasMatch(componentMapping) {
    return typeof componentMapping.component === 'function';
  }
  getPriority() {
    return Priority.FALLBACK;
  }
  launcher(componentMapping, viewContainerRef, elementInjector, module) {
    return new Observable(subscriber => {
      let componentRef;
      const injector = elementInjector ?? viewContainerRef.injector;
      const dispose = () => {
        if (componentRef) {
          componentRef.destroy();
        }
      };
      const factory = this.getComponentFactory(injector, componentMapping.component);
      if (factory) {
        componentRef = viewContainerRef.createComponent(factory, undefined, injector, undefined, module);
        subscriber.next({
          elementRef: componentRef.location,
          componentRef
        });
      }
      return dispose;
    });
  }
  getComponentFactory(injector, component) {
    if (!component) {
      return null;
    }
    const factory = injector.get(ComponentFactoryResolver).resolveComponentFactory(component);
    return factory;
  }
  static {
    this.ɵfac = function DefaultComponentHandler_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DefaultComponentHandler)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DefaultComponentHandler,
      factory: DefaultComponentHandler.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DefaultComponentHandler, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Lazy component handler used for launching lazy loaded cms components implemented
 * as native Angular components.
 */
class LazyComponentHandler {
  constructor(defaultHandler) {
    this.defaultHandler = defaultHandler;
  }
  /**
   * We want to mach dynamic import signature () => import('')
   */
  hasMatch(componentMapping) {
    return typeof componentMapping.component === 'function' && this.isNotClass(componentMapping.component);
  }
  isNotClass(symbol) {
    const signature = symbol.toString().substring(0, 20).replace(' ', '');
    return signature.startsWith('function()') || signature.startsWith('()=>');
  }
  getPriority() {
    return Priority.LOW;
  }
  launcher(componentMapping, viewContainerRef, elementInjector, module) {
    return from(componentMapping.component()).pipe(switchMap(component => this.defaultHandler.launcher({
      ...componentMapping,
      component
    }, viewContainerRef, elementInjector, module)));
  }
  static {
    this.ɵfac = function LazyComponentHandler_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LazyComponentHandler)(i0.ɵɵinject(DefaultComponentHandler));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LazyComponentHandler,
      factory: LazyComponentHandler.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LazyComponentHandler, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: DefaultComponentHandler
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class InnerComponentsHostDirective {
  constructor(data, vcr,
  // dependencies required for ComponentWrapper directive
  cmsComponentsService, injector, dynamicAttributeService, renderer, componentHandler, cmsInjector, eventService) {
    this.data = data;
    this.vcr = vcr;
    this.cmsComponentsService = cmsComponentsService;
    this.injector = injector;
    this.dynamicAttributeService = dynamicAttributeService;
    this.renderer = renderer;
    this.componentHandler = componentHandler;
    this.cmsInjector = cmsInjector;
    this.eventService = eventService;
    this.innerComponents$ = this.data.data$.pipe(map(data => data?.composition?.inner ?? []), distinctUntilChanged());
    this.componentWrappers = [];
  }
  ngOnInit() {
    this.subscription = this.innerComponents$.subscribe(x => {
      this.renderComponents(x);
    });
  }
  renderComponents(components) {
    this.clearComponents();
    components.forEach(component => this.renderComponent(component));
  }
  renderComponent(component) {
    const componentWrapper = new ComponentWrapperDirective(this.vcr, this.cmsComponentsService, this.injector, this.dynamicAttributeService, this.renderer, this.componentHandler, this.cmsInjector, this.eventService);
    componentWrapper.cxComponentWrapper = {
      flexType: component,
      uid: ''
    };
    componentWrapper.ngOnInit();
    this.componentWrappers.push(componentWrapper);
  }
  clearComponents() {
    this.componentWrappers.forEach(wrapper => wrapper.ngOnDestroy());
    this.componentWrappers = [];
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.clearComponents();
  }
  static {
    this.ɵfac = function InnerComponentsHostDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InnerComponentsHostDirective)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(CmsComponentsService), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1.DynamicAttributeService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(ComponentHandlerService), i0.ɵɵdirectiveInject(CmsInjectorService), i0.ɵɵdirectiveInject(i1.EventService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: InnerComponentsHostDirective,
      selectors: [["", "cxInnerComponentsHost", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InnerComponentsHostDirective, [{
    type: Directive,
    args: [{
      selector: '[cxInnerComponentsHost]',
      standalone: false
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i0.ViewContainerRef
  }, {
    type: CmsComponentsService
  }, {
    type: i0.Injector
  }, {
    type: i1.DynamicAttributeService
  }, {
    type: i0.Renderer2
  }, {
    type: ComponentHandlerService
  }, {
    type: CmsInjectorService
  }, {
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageComponentModule {
  static forRoot() {
    return {
      ngModule: PageComponentModule,
      providers: [{
        provide: ComponentHandler,
        useExisting: DefaultComponentHandler,
        multi: true
      }, {
        provide: ComponentHandler,
        useExisting: LazyComponentHandler,
        multi: true
      }]
    };
  }
  static {
    this.ɵfac = function PageComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageComponentModule,
      declarations: [ComponentWrapperDirective, InnerComponentsHostDirective],
      imports: [CommonModule],
      exports: [ComponentWrapperDirective, InnerComponentsHostDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageComponentModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ComponentWrapperDirective, InnerComponentsHostDirective],
      exports: [ComponentWrapperDirective, InnerComponentsHostDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageSlotModule {
  // instantiate PageSlotService ASAP, so it can examine SSR pre-rendered DOM
  constructor(_pageSlot) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function PageSlotModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageSlotModule)(i0.ɵɵinject(PageSlotService));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageSlotModule,
      declarations: [PageSlotComponent],
      imports: [CommonModule, OutletModule, PageComponentModule],
      exports: [PageSlotComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, OutletModule, PageComponentModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageSlotModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OutletModule, PageComponentModule],
      declarations: [PageSlotComponent],
      exports: [PageSlotComponent]
    }]
  }], () => [{
    type: PageSlotService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageLayoutModule {
  static {
    this.ɵfac = function PageLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageLayoutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageLayoutModule,
      declarations: [PageLayoutComponent, PageTemplateDirective],
      imports: [CommonModule, OutletModule, PageSlotModule],
      exports: [PageLayoutComponent, PageTemplateDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, OutletModule, PageSlotModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLayoutModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OutletModule, PageSlotModule],
      declarations: [PageLayoutComponent, PageTemplateDirective],
      exports: [PageLayoutComponent, PageTemplateDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PWAModuleConfig {
  static {
    this.ɵfac = function PWAModuleConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PWAModuleConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PWAModuleConfig,
      factory: function PWAModuleConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || PWAModuleConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PWAModuleConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();
const defaultPWAModuleConfig = {
  pwa: {
    enabled: false,
    addToHomeScreen: false
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenService {
  constructor(config, globalMessageService, winRef) {
    this.config = config;
    this.globalMessageService = globalMessageService;
    this.winRef = winRef;
    this.canPrompt = new BehaviorSubject(false);
    this.canPrompt$ = this.canPrompt.asObservable();
    if (this.config.pwa?.addToHomeScreen) {
      this.init();
    }
  }
  init() {
    if (this.winRef.nativeWindow) {
      this.winRef.nativeWindow.addEventListener('beforeinstallprompt', event => {
        event.preventDefault();
        this.deferredEvent = event;
        this.enableAddToHomeScreen();
      });
      this.winRef.nativeWindow.addEventListener('appinstalled', () => {
        this.globalMessageService.add({
          key: 'pwa.addedToHomeScreen'
        }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        this.disableAddToHomeScreen();
        this.deferredEvent = null;
      });
    }
  }
  enableAddToHomeScreen() {
    this.canPrompt.next(true);
  }
  disableAddToHomeScreen() {
    this.canPrompt.next(false);
  }
  firePrompt() {
    if (this.deferredEvent) {
      this.deferredEvent.prompt();
    }
  }
  static {
    this.ɵfac = function AddToHomeScreenService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToHomeScreenService)(i0.ɵɵinject(PWAModuleConfig), i0.ɵɵinject(i1.GlobalMessageService), i0.ɵɵinject(i1.WindowRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddToHomeScreenService,
      factory: AddToHomeScreenService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToHomeScreenService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: PWAModuleConfig
  }, {
    type: i1.GlobalMessageService
  }, {
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class AddToHomeScreenComponent {
  constructor(addToHomeScreenService) {
    this.addToHomeScreenService = addToHomeScreenService;
  }
  ngOnInit() {
    this.canPrompt$ = this.addToHomeScreenService.canPrompt$;
  }
  prompt() {
    this.addToHomeScreenService.firePrompt();
  }
  static {
    this.ɵfac = function AddToHomeScreenComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToHomeScreenComponent)(i0.ɵɵdirectiveInject(AddToHomeScreenService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: AddToHomeScreenComponent
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToHomeScreenComponent, [{
    type: Directive
  }], () => [{
    type: AddToHomeScreenService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenBannerComponent extends AddToHomeScreenComponent {
  constructor(addToHomeScreenService) {
    super(addToHomeScreenService);
    this.addToHomeScreenService = addToHomeScreenService;
  }
  static {
    this.ɵfac = function AddToHomeScreenBannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToHomeScreenBannerComponent)(i0.ɵɵdirectiveInject(AddToHomeScreenService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddToHomeScreenBannerComponent,
      selectors: [["cx-add-to-home-screen-banner"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-add-to-home-screen-banner"], [1, "cx-add-to-home-screen-banner-inner"], [1, "btn", "btn-primary", 3, "click"]],
      template: function AddToHomeScreenBannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AddToHomeScreenBannerComponent_div_0_Template, 16, 12, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.canPrompt$));
        }
      },
      dependencies: [i3.NgIf, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToHomeScreenBannerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-add-to-home-screen-banner',
      standalone: false,
      template: "<div *ngIf=\"canPrompt$ | async\">\n  <div class=\"cx-add-to-home-screen-banner\">\n    <div class=\"cx-add-to-home-screen-banner-inner\">\n      <p>\n        {{ 'pwa.addToHomeScreenDescription' | cxTranslate }}\n      </p>\n      <ul>\n        <li>{{ 'pwa.noInstallationNeeded' | cxTranslate }}</li>\n        <li>{{ 'pwa.fastAccessToApplication' | cxTranslate }}</li>\n      </ul>\n      <button (click)=\"prompt()\" class=\"btn btn-primary\">\n        {{ 'pwa.addToHomeScreen' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: AddToHomeScreenService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AddToHomeScreenBtnComponent extends AddToHomeScreenComponent {
  constructor(addToHomeScreenService) {
    super(addToHomeScreenService);
    this.addToHomeScreenService = addToHomeScreenService;
  }
  static {
    this.ɵfac = function AddToHomeScreenBtnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddToHomeScreenBtnComponent)(i0.ɵɵdirectiveInject(AddToHomeScreenService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddToHomeScreenBtnComponent,
      selectors: [["cx-add-to-home-screen-btn"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 3,
      vars: 3,
      consts: [[3, "click"], [4, "ngIf"]],
      template: function AddToHomeScreenBtnComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵlistener("click", function AddToHomeScreenBtnComponent_Template_span_click_0_listener() {
            return ctx.prompt();
          });
          i0.ɵɵtemplate(1, AddToHomeScreenBtnComponent_ng_content_1_Template, 1, 0, "ng-content", 1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.canPrompt$));
        }
      },
      dependencies: [i3.NgIf, i3.AsyncPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddToHomeScreenBtnComponent, [{
    type: Component,
    args: [{
      selector: 'cx-add-to-home-screen-btn',
      standalone: false,
      template: "<span (click)=\"prompt()\">\n  <ng-content *ngIf=\"canPrompt$ | async\"></ng-content>\n</span>\n"
    }]
  }], () => [{
    type: AddToHomeScreenService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function pwaConfigurationFactory(pwaConfig) {
  return {
    enabled: !isDevMode() && pwaConfig.pwa?.enabled || false
  };
}
function pwaFactory(addToHomeScreenService) {
  const result = () => addToHomeScreenService;
  return result;
}
class PwaModule {
  static {
    this.ɵfac = function PwaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PwaModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PwaModule,
      declarations: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent],
      imports: [CommonModule, i1$3.ServiceWorkerModule, I18nModule],
      exports: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultPWAModuleConfig), {
        provide: SwRegistrationOptions,
        useFactory: pwaConfigurationFactory,
        deps: [Config]
      }, {
        provide: APP_INITIALIZER,
        useFactory: pwaFactory,
        deps: [AddToHomeScreenService],
        multi: true
      }],
      imports: [CommonModule, ServiceWorkerModule.register('ngsw-worker.js'), I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PwaModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ServiceWorkerModule.register('ngsw-worker.js'), I18nModule],
      providers: [provideDefaultConfig(defaultPWAModuleConfig), {
        provide: SwRegistrationOptions,
        useFactory: pwaConfigurationFactory,
        deps: [Config]
      }, {
        provide: APP_INITIALIZER,
        useFactory: pwaFactory,
        deps: [AddToHomeScreenService],
        multi: true
      }],
      declarations: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent],
      exports: [AddToHomeScreenBtnComponent, AddToHomeScreenBannerComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const cmsRoute = {
  path: '**',
  canActivate: [CmsPageGuard],
  component: PageLayoutComponent
};
function addCmsRoute(injector) {
  const result = () => {
    // Router could not be injected via `deps[]` due to a cyclic dependency with APP_INITIALIZER:
    const router = injector.get(Router);
    router.config.push(cmsRoute);
  };
  return result;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsRouteModule {
  static {
    this.ɵfac = function CmsRouteModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsRouteModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CmsRouteModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: APP_INITIALIZER,
        multi: true,
        deps: [Injector],
        useFactory: addCmsRoute
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsRouteModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: APP_INITIALIZER,
        multi: true,
        deps: [Injector],
        useFactory: addCmsRoute
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultRoutesConfigFactory = () => {
  const enableProductPageRouteAllowsNoProductName = inject(FeatureToggles).defaultProductPageRouteAllowsNoProductName;
  return {
    routing: {
      routes: {
        home: {
          paths: ['']
        },
        notFound: {
          paths: ['not-found']
        },
        // semantic links for login related pages
        login: {
          paths: ['login'],
          protected: false,
          authFlow: true
        },
        verifyToken: {
          paths: ['login/verify-token'],
          protected: false,
          authFlow: true
        },
        verifyTokenForRegistration: {
          paths: ['register/verify-token'],
          protected: false,
          authFlow: true
        },
        register: {
          paths: ['login/register'],
          protected: false,
          authFlow: true
        },
        forgotPassword: {
          paths: ['login/forgot-password'],
          protected: false,
          authFlow: true
        },
        resetPassword: {
          paths: ['login/pw/change'],
          protected: false,
          authFlow: true
        },
        logout: {
          paths: ['logout'],
          protected: false,
          authFlow: true
        },
        // plp routes
        search: {
          paths: ['search/:query']
        },
        category: {
          paths: ['category/:categoryCode'],
          paramsMapping: {
            categoryCode: 'code'
          }
        },
        brand: {
          paths: ['Brands/:brandName/c/:brandCode']
        },
        // pdp routes
        product: {
          paths: enableProductPageRouteAllowsNoProductName ? ['product/:productCode/:name', 'product/:productCode'] : ['product/:productCode/:name'],
          paramsMapping: {
            productCode: 'code'
          }
        },
        termsAndConditions: {
          paths: ['terms-and-conditions']
        },
        coupons: {
          paths: ['my-account/coupons']
        },
        couponClaim: {
          paths: ['my-account/coupon/claim/:couponCode'],
          paramsMapping: {
            couponCode: 'code'
          }
        },
        myInterests: {
          paths: ['my-account/my-interests']
        },
        notificationPreference: {
          paths: ['my-account/notification-preference']
        }
      }
    }
  };
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class RoutingModule {
  static forRoot() {
    return {
      ngModule: RoutingModule,
      providers: [provideDefaultConfigFactory(defaultRoutesConfigFactory), {
        provide: BEFORE_CMS_PAGE_GUARD,
        useExisting: ProtectedRoutesGuard,
        multi: true
      }]
    };
  }
  static {
    this.ɵfac = function RoutingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RoutingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: RoutingModule,
      imports: [i1.RoutingModule, CmsRouteModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [RoutingModule$1.forRoot(), CmsRouteModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoutingModule, [{
    type: NgModule,
    args: [{
      imports: [RoutingModule$1.forRoot(), CmsRouteModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Matches the pattern '[ ** / ] marker / :paramName'
 *
 * @param marker phrase that indicates the start of the match
 * @param paramName name of the parameter present after the marker
 * @param precedingParamName name of the parameter for every preceding url segment
 *        i.e. `param` will result in `param0`, `param1`, ...
 */
function getSuffixUrlMatcher({
  marker,
  paramName,
  precedingParamName
}) {
  precedingParamName = precedingParamName || 'param';
  const matcher = function suffixUrlMatcher(segments) {
    const markerIndex = findLastIndex(segments, ({
      path
    }) => path === marker);
    const isMarkerLastSegment = markerIndex === segments.length - 1;
    if (markerIndex === -1 || isMarkerLastSegment) {
      return null;
    }
    const paramIndex = markerIndex + 1;
    const posParams = {
      [paramName]: segments[paramIndex]
    };
    for (let i = 0; i < markerIndex; i++) {
      posParams[`${precedingParamName}${i}`] = segments[i];
    }
    return {
      consumed: segments.slice(0, paramIndex + 1),
      posParams
    };
  };
  if (isDevMode()) {
    matcher['_suffixRouteConfig'] = {
      marker,
      paramName,
      precedingParamName
    }; // property added for easier debugging of routes
  }
  return matcher;
}
function findLastIndex(elements, predicate) {
  for (let index = elements.length - 1; index >= 0; index--) {
    if (predicate(elements[index])) {
      return index;
    }
  }
  return -1;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageMetaLinkService {
  constructor(winRef, rendererFactory) {
    this.winRef = winRef;
    this.rendererFactory = rendererFactory;
  }
  /**
   * Adds a canonical link element to the document head.
   *
   * If an id is provided, the link will be updated.
   * If no url is provided, the link element will be deleted.
   */
  setCanonicalLink(url) {
    let link = this.winRef.document.querySelector('link[rel="canonical"]');
    if (!url) {
      // Removing the link is an edge case, but useful if the canonical url
      // is created in CSR while developing/testing.
      link?.remove();
      return;
    }
    if (!link) {
      link = this.renderer.createElement('link');
      link.rel = 'canonical';
      link.href = url;
      this.renderer.appendChild(this.winRef.document.head, link);
    } else {
      link?.setAttribute('href', url);
    }
  }
  get renderer() {
    return this.rendererFactory.createRenderer(null, null);
  }
  static {
    this.ɵfac = function PageMetaLinkService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageMetaLinkService)(i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(i0.RendererFactory2));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PageMetaLinkService,
      factory: PageMetaLinkService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageMetaLinkService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: i0.RendererFactory2
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SeoMetaService {
  constructor(ngTitle, ngMeta, pageMetaService, pageMetaLinkService) {
    this.ngTitle = ngTitle;
    this.ngMeta = ngMeta;
    this.pageMetaService = pageMetaService;
    this.pageMetaLinkService = pageMetaLinkService;
  }
  init() {
    this.subscription = this.pageMetaService.getMeta().pipe(filter(isNotNullable)).subscribe(meta => this.meta = meta);
  }
  set meta(meta) {
    this.title = meta.title;
    this.description = meta.description;
    this.image = meta.image;
    this.robots = meta.robots;
    this.canonicalUrl = meta.canonicalUrl;
  }
  set title(title) {
    this.ngTitle.setTitle(title || '');
  }
  set description(value) {
    if (value) {
      this.addTag({
        name: 'description',
        content: value || ''
      });
    } else {
      this.ngMeta.removeTag('name="description"');
    }
  }
  set image(imageUrl) {
    if (imageUrl) {
      this.addTag({
        name: 'og:image',
        content: imageUrl
      });
    } else {
      this.ngMeta.removeTag('name="og:image"');
    }
  }
  set robots(value) {
    if (value && value.length > 0) {
      this.addTag({
        name: 'robots',
        content: value.join(', ')
      });
    }
  }
  /**
   * Add the canonical Url to the head of the page.
   *
   * If the canonical url already exists the link is removed. This is quite
   * unlikely though, since canonical links are (typically) only added in SSR.
   */
  set canonicalUrl(url) {
    this.pageMetaLinkService?.setCanonicalLink(url);
  }
  addTag(meta) {
    if (meta.content) {
      this.ngMeta.updateTag(meta);
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function SeoMetaService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SeoMetaService)(i0.ɵɵinject(i1$1.Title), i0.ɵɵinject(i1$1.Meta), i0.ɵɵinject(i1.PageMetaService), i0.ɵɵinject(PageMetaLinkService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SeoMetaService,
      factory: SeoMetaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeoMetaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.Title
  }, {
    type: i1$1.Meta
  }, {
    type: i1.PageMetaService
  }, {
    type: PageMetaLinkService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSeoConfig = {
  seo: {
    structuredData: {
      disableInDevMode: true
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SeoConfig {
  static {
    this.ɵfac = function SeoConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SeoConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SeoConfig,
      factory: function SeoConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || SeoConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeoConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const htmlLangProvider = {
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: setHtmlLangAttribute,
  deps: [WindowRef, LanguageService]
};
/**
 * Sets active language in <html lang="">
 */
function setHtmlLangAttribute(winRef, languageService) {
  const result = () => {
    languageService.getActive().subscribe(lang => {
      winRef.document.documentElement.lang = lang.replace(/_/g, '-');
    });
  };
  return result;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class JsonLdScriptFactory {
  constructor(platformId, winRef, rendererFactory, config) {
    this.platformId = platformId;
    this.winRef = winRef;
    this.rendererFactory = rendererFactory;
    this.config = config;
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }
  build(schema) {
    if (schema && this.isJsonLdRequired()) {
      this.getJsonLdScriptElement().textContent = this.escapeHtml(schema);
    }
  }
  /**
   * Indicates whether json ld data should be generated.
   *
   * This is only required on the server, but can be enabled in dev mode.
   */
  isJsonLdRequired() {
    return !isPlatformBrowser(this.platformId) || isDevMode() && !this.config.seo?.structuredData?.disableInDevMode;
  }
  /**
   * Creates a json-ld script element. The element is created one, and appended
   * to the html body element.
   *
   * ```html
   * <script id="json-ld" type="application/ld+json">
   * </script>
   * ```
   */
  getJsonLdScriptElement() {
    const id = 'json-ld';
    let scriptElement = this.winRef.document.getElementById(id);
    if (!scriptElement) {
      const script = this.renderer.createElement('script');
      script.id = id;
      script.type = 'application/ld+json';
      this.renderer.appendChild(this.winRef.document.body, script);
      scriptElement = script;
    }
    return scriptElement;
  }
  /**
   * Secure the given json-ld schema by encoding html characters (aka escaping), eg: <script> becomes &lt;script&gt;
   *
   * The given schema is not trusted, as malicious code could be injected (XSS)
   * into the json-ld script.
   */
  escapeHtml(schema) {
    const div = this.renderer.createElement('div');
    div.textContent = JSON.stringify(schema);
    return div.innerHTML;
  }
  static {
    this.ɵfac = function JsonLdScriptFactory_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdScriptFactory)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(SeoConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: JsonLdScriptFactory,
      factory: JsonLdScriptFactory.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdScriptFactory, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  }, {
    type: i1.WindowRef
  }, {
    type: i0.RendererFactory2
  }, {
    type: SeoConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Low level directive that adds a json-ld script tag to the component.
 * This code bypasses the strict XSS security, as otherwise we're not able
 * to append a script tag with JS inside.
 *
 * This helper directive is actually not used in Spartacus, as Spartacus
 * appends json-ld the data to the document body.
 *
 * This directive can however be used by merchants to write static schema data
 * to the DOM in a save way.
 */
class JsonLdDirective {
  /**
   * Writes the schema data to a json-ld script element.
   */
  set cxJsonLd(schema) {
    this.generateJsonLdScript(schema);
  }
  constructor(renderer, jsonLdScriptFactory, element) {
    this.renderer = renderer;
    this.jsonLdScriptFactory = jsonLdScriptFactory;
    this.element = element;
  }
  /**
   * attach the json-ld script tag to DOM with the schema data secured by encoding html tags (aka escaping)
   */
  generateJsonLdScript(schema) {
    if (schema && this.jsonLdScriptFactory.isJsonLdRequired()) {
      const script = this.renderer.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = this.jsonLdScriptFactory.escapeHtml(schema);
      this.renderer.appendChild(this.element.nativeElement, script);
    }
  }
  static {
    this.ɵfac = function JsonLdDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(JsonLdScriptFactory), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: JsonLdDirective,
      selectors: [["", "cxJsonLd", ""]],
      inputs: {
        cxJsonLd: "cxJsonLd"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdDirective, [{
    type: Directive,
    args: [{
      selector: '[cxJsonLd]',
      standalone: false
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: JsonLdScriptFactory
  }, {
    type: i0.ElementRef
  }], {
    cxJsonLd: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Injection token to extend schema builders for adding structural data (json-ld).
 *
 * Some builders (i.e. `JSONLD_PRODUCT_BUILDER`) might have additional
 * lower level builder to further extend the schema.
 */
const SCHEMA_BUILDER = new InjectionToken('SchemaBuilderToken');
/**
 * Injection token to add specific json-ld builders for product related schemas.
 * See see https://schema.org/product for more information.
 */
const JSONLD_PRODUCT_BUILDER = new InjectionToken('JsonLdProductBuilderToken');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Factory service that is used to build the structured data for
 * all configured schema builders.
 */
class StructuredDataFactory {
  constructor(scriptBuilder, builders) {
    this.scriptBuilder = scriptBuilder;
    this.builders = builders;
    this.subscription = new Subscription();
  }
  /**
   * Initiates the build of structured data by collecting all schema
   * builders.
   */
  build() {
    if (this.scriptBuilder.isJsonLdRequired() && this.builders) {
      this.subscription.add(this.collectSchemas().subscribe(schema => {
        this.scriptBuilder.build(schema);
      }));
    }
  }
  /**
   * Collects all schema builders and observe their structured data.
   */
  collectSchemas() {
    return combineLatest(this.builders.map(builder => builder.build()));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function StructuredDataFactory_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StructuredDataFactory)(i0.ɵɵinject(JsonLdScriptFactory), i0.ɵɵinject(SCHEMA_BUILDER, 8));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: StructuredDataFactory,
      factory: StructuredDataFactory.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StructuredDataFactory, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: JsonLdScriptFactory
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [SCHEMA_BUILDER]
    }]
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Factory to build the structure data
 * without any interaction with the UI.
 */
function getStructuredDataFactory(injector) {
  const result = () => {
    const factory = injector.get(StructuredDataFactory);
    factory.build();
  };
  return result;
}
class StructuredDataModule {
  static {
    this.ɵfac = function StructuredDataModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StructuredDataModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StructuredDataModule,
      declarations: [JsonLdDirective],
      imports: [CommonModule],
      exports: [JsonLdDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: APP_INITIALIZER,
        useFactory: getStructuredDataFactory,
        deps: [Injector],
        multi: true
      }],
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StructuredDataModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [JsonLdDirective],
      exports: [JsonLdDirective],
      providers: [{
        provide: APP_INITIALIZER,
        useFactory: getStructuredDataFactory,
        deps: [Injector],
        multi: true
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initSeoService(injector) {
  const result = () => {
    const service = injector.get(SeoMetaService);
    service.init();
  };
  return result;
}
class SeoModule {
  static {
    this.ɵfac = function SeoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SeoModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SeoModule,
      imports: [StructuredDataModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultSeoConfig), {
        provide: APP_INITIALIZER,
        useFactory: initSeoService,
        deps: [Injector],
        multi: true
      }, htmlLangProvider],
      imports: [StructuredDataModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SeoModule, [{
    type: NgModule,
    args: [{
      imports: [StructuredDataModule],
      providers: [provideDefaultConfig(defaultSeoConfig), {
        provide: APP_INITIALIZER,
        useFactory: initSeoService,
        deps: [Injector],
        multi: true
      }, htmlLangProvider]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbSchemaBuilder {
  constructor(pageMetaService) {
    this.pageMetaService = pageMetaService;
  }
  build() {
    return this.pageMetaService.getMeta().pipe(map(pageMeta => this.collect(pageMeta)));
  }
  collect(pageMeta) {
    if (!pageMeta?.breadcrumbs) {
      return;
    }
    const crumbs = pageMeta.breadcrumbs.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': crumb.link,
          name: crumb.label
        }
      };
    });
    if (pageMeta.title) {
      crumbs.push({
        '@type': 'ListItem',
        position: crumbs.length + 1,
        item: {
          '@id': pageMeta.title,
          name: pageMeta.title
        }
      });
    }
    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs
    };
  }
  static {
    this.ɵfac = function BreadcrumbSchemaBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbSchemaBuilder)(i0.ɵɵinject(i1.PageMetaService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BreadcrumbSchemaBuilder,
      factory: BreadcrumbSchemaBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbSchemaBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.PageMetaService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the basic structured data for the product, see https://schema.org/product.
 * This builder includes data for sku number, name, description, brand and main image.
 */
class JsonLdBaseProductBuilder {
  build(product) {
    return of({
      ...this.getProductBase(product),
      ...this.getProductBrand(product),
      ...this.getProductImage(product)
    });
  }
  /**
   * Returns the product sku, name and description.
   */
  getProductBase(product) {
    const result = {
      sku: product.code
    };
    if (product.name) {
      result.name = product.name;
    }
    if (product.summary) {
      result.description = product.summary;
    }
    return result;
  }
  /**
   * Returns the image object with the main product image url.
   *
   * If the image is not available, an empty object is returned.
   */
  getProductImage(product) {
    const image = product.images?.PRIMARY?.zoom?.url;
    return image ? {
      image
    } : {};
  }
  /**
   * Returns the brand object with the product manufacturer.
   *
   * If the brand is not available, an empty object is returned.
   */
  getProductBrand(product) {
    const brand = product.manufacturer;
    return brand ? {
      brand
    } : {};
  }
  static {
    this.ɵfac = function JsonLdBaseProductBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdBaseProductBuilder)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: JsonLdBaseProductBuilder,
      factory: JsonLdBaseProductBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdBaseProductBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the structured data for the product offer, see https://schema.org/offers.
 * The data includes the price, currency and availability level.
 */
class JsonLdProductOfferBuilder {
  build(product) {
    const schema = {
      '@type': 'Offer'
    };
    if (product.price?.value) {
      schema.price = product.price.value;
      if (product.price.currencyIso) {
        schema.priceCurrency = product.price.currencyIso;
      }
    }
    if (product.stock && product.stock.stockLevelStatus) {
      schema.availability = product.stock.stockLevelStatus === 'inStock' ? 'InStock' : 'OutOfStock';
    }
    return of({
      offers: schema
    });
  }
  static {
    this.ɵfac = function JsonLdProductOfferBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdProductOfferBuilder)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: JsonLdProductOfferBuilder,
      factory: JsonLdProductOfferBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdProductOfferBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Builds the structured data for the product reviews, see https://schema.org/Review.
 * The data includes the aggregated product rating and the individual reviews.
 */
class JsonLdProductReviewBuilder {
  constructor(reviewService, config) {
    this.reviewService = reviewService;
    this.config = config;
  }
  build(product) {
    return this.reviewService.getByProductCode(product.code ?? '').pipe(map(reviews => reviews?.length > 0 ? {
      aggregateRating: this.buildAggregatedReviews(product, reviews),
      review: reviews.map(review => this.buildReviews(review))
    } : {}));
  }
  buildAggregatedReviews(product, reviews) {
    const aggregated = {
      '@type': 'AggregateRating'
    };
    if (product.averageRating) {
      aggregated.ratingValue = product.averageRating;
    }
    if (reviews) {
      aggregated.ratingCount = reviews.filter(rev => !!rev.rating).length;
      aggregated.reviewCount = reviews.filter(rev => !!rev.comment).length;
    }
    return aggregated;
  }
  buildReviews(review) {
    const reviewSchema = {
      '@type': 'review'
    };
    if (review.principal && review.principal.name) {
      reviewSchema.author = review.principal.name;
    }
    if (review.date) {
      const date = new Date(review.date);
      reviewSchema.datePublished = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }
    if (review.headline) {
      reviewSchema.name = review.headline;
    }
    if (review.comment) {
      reviewSchema.description = review.comment;
    }
    if (review.rating) {
      reviewSchema.reviewRating = {
        '@type': 'Rating',
        ratingValue: review.rating.toString()
      };
    }
    return reviewSchema;
  }
  static {
    this.ɵfac = function JsonLdProductReviewBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdProductReviewBuilder)(i0.ɵɵinject(i1.ProductReviewService), i0.ɵɵinject(SeoConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: JsonLdProductReviewBuilder,
      factory: JsonLdProductReviewBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdProductReviewBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ProductReviewService
  }, {
    type: SeoConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CurrentProductService {
  constructor(routingService, productService) {
    this.routingService = routingService;
    this.productService = productService;
    this.DEFAULT_PRODUCT_SCOPE = ProductScope.DETAILS;
  }
  /**
   * Returns an observable for the current product
   * @returns Product
   * @returns null if product can't be found
   *
   * @param scopes
   */
  getProduct(scopes) {
    return this.getCode().pipe(distinctUntilChanged(), switchMap(productCode => {
      return productCode ? this.productService.get(productCode, scopes || this.DEFAULT_PRODUCT_SCOPE) : of(null);
    }), filter(isNotUndefined));
  }
  getCode() {
    return this.routingService.getRouterState().pipe(map(state => state.state.params['productCode']));
  }
  static {
    this.ɵfac = function CurrentProductService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CurrentProductService)(i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1.ProductService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CurrentProductService,
      factory: CurrentProductService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CurrentProductService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.RoutingService
  }, {
    type: i1.ProductService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Adds the minimal structured data for the product, see https://schema.org/product.
 * The actual data collection is delegated to `JsonLdBuilder`s, which can be injected
 * using the `JSONLD_PRODUCT_BUILDER` token.
 */
class ProductSchemaBuilder {
  constructor(currentProduct, builders) {
    this.currentProduct = currentProduct;
    this.builders = builders;
  }
  build() {
    return this.currentProduct.getProduct().pipe(switchMap(product => {
      if (product) {
        return combineLatest(this.collect(product)).pipe(map(res => Object.assign({}, ...res)));
      }
      return of({});
    }));
  }
  collect(product) {
    if (!product || !product.code) {
      return [];
    }
    const builders = this.builders ? this.builders.map(builder => builder.build(product)) : [];
    return [of({
      '@context': 'http://schema.org',
      '@type': 'Product'
    }), ...builders];
  }
  static {
    this.ɵfac = function ProductSchemaBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductSchemaBuilder)(i0.ɵɵinject(CurrentProductService), i0.ɵɵinject(JSONLD_PRODUCT_BUILDER, 8));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductSchemaBuilder,
      factory: ProductSchemaBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductSchemaBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: CurrentProductService
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [JSONLD_PRODUCT_BUILDER]
    }]
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides several standard json-ld builders that contribute
 * to collecting and building json-ld data.
 */
class JsonLdBuilderModule {
  static {
    this.ɵfac = function JsonLdBuilderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || JsonLdBuilderModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: JsonLdBuilderModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: SCHEMA_BUILDER,
        useExisting: ProductSchemaBuilder,
        multi: true
      }, {
        provide: SCHEMA_BUILDER,
        useExisting: BreadcrumbSchemaBuilder,
        multi: true
      },
      // lower level json-ld builder classes offering fine-grained control
      // for product related schemas
      {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdBaseProductBuilder,
        multi: true
      }, {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdProductOfferBuilder,
        multi: true
      }, {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdProductReviewBuilder,
        multi: true
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JsonLdBuilderModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: SCHEMA_BUILDER,
        useExisting: ProductSchemaBuilder,
        multi: true
      }, {
        provide: SCHEMA_BUILDER,
        useExisting: BreadcrumbSchemaBuilder,
        multi: true
      },
      // lower level json-ld builder classes offering fine-grained control
      // for product related schemas
      {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdBaseProductBuilder,
        multi: true
      }, {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdProductOfferBuilder,
        multi: true
      }, {
        provide: JSONLD_PRODUCT_BUILDER,
        useExisting: JsonLdProductReviewBuilder,
        multi: true
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var PageSection;
(function (PageSection) {
  PageSection["HEADER"] = "header";
  PageSection["FOOTER"] = "footer";
  PageSection["NAVIGATION"] = "navigation";
})(PageSection || (PageSection = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Helper function to simplify the creation of static CMS structure (`CmsStructureConfig`).
 * The helper function leverage the `provideConfig`, and is only providing an easy way to
 * generate the cms structure. The function creates a configuration structure for components,
 * page slot and page template. The following example adds a component to a page slot:
 *
 * ```ts
 * provideCmsStructure({
 *   componentId: 'LoginComponent',
 *   pageSlotPosition: 'SiteLogin'
 * })
 * ```
 *
 * @param options.componentId component identifier is used to provide component structure
 * @param options.pageSlotPosition page slot position is used to provide the slot configuration
 * @param options.pageTemplate the page template is used to provide the page slot to the given page template
 * @param options.section the section is used to provide the page slot to the given section
 * @param options.breakpoint the breakpoint is used to provide the page slot for a specific breakpoint
 */
function provideCmsStructure(options) {
  return provideConfig({
    ...buildCmsStructure(options),
    ...buildLayoutConfig(options)
  });
}
/**
 * @private
 */
function buildCmsStructure({
  componentId,
  pageSlotPosition
} = {}) {
  const config = {
    cmsStructure: {}
  };
  if (componentId) {
    config.cmsStructure = {
      components: {
        [componentId]: {
          typeCode: componentId,
          flexType: componentId
        }
      }
    };
  }
  if (componentId && pageSlotPosition && config.cmsStructure) {
    config.cmsStructure.slots = {
      [pageSlotPosition]: {
        componentIds: [componentId]
      }
    };
  }
  return config;
}
/**
 * @private
 */
function buildLayoutConfig({
  pageTemplate,
  pageSlotPosition,
  breakpoint,
  section
} = {}) {
  const layoutConfig = {};
  if (pageTemplate && pageSlotPosition) {
    const pageTemplateSlots = {};
    if (breakpoint) {
      pageTemplateSlots[breakpoint] = {
        slots: [pageSlotPosition]
      };
    } else {
      pageTemplateSlots.slots = [pageSlotPosition];
    }
    layoutConfig.layoutSlots = {
      [pageTemplate]: pageTemplateSlots
    };
  }
  if (section && pageSlotPosition) {
    const sectionSlots = {};
    if (breakpoint) {
      sectionSlots[breakpoint] = {
        slots: [pageSlotPosition]
      };
    } else {
      sectionSlots.slots = [pageSlotPosition];
    }
    if (layoutConfig.layoutSlots) {
      layoutConfig.layoutSlots[section] = sectionSlots;
    } else {
      layoutConfig.layoutSlots = {
        [section]: sectionSlots
      };
    }
  }
  return layoutConfig;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkConfig {
  static {
    this.ɵfac = function SkipLinkConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipLinkConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SkipLinkConfig,
      factory: function SkipLinkConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || SkipLinkConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipLinkConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();
class SkipLink {}
var SkipLinkScrollPosition;
(function (SkipLinkScrollPosition) {
  SkipLinkScrollPosition["BEFORE"] = "BEFORE";
  SkipLinkScrollPosition["AFTER"] = "AFTER";
})(SkipLinkScrollPosition || (SkipLinkScrollPosition = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkService {
  constructor(config, keyboardFocusService) {
    this.config = config;
    this.keyboardFocusService = keyboardFocusService;
    this.skipLinks$ = new BehaviorSubject([]);
  }
  getSkipLinks() {
    return this.skipLinks$;
  }
  add(key, target) {
    const found = this.config.skipLinks?.find(skipLink => skipLink.key === key);
    if (found) {
      const existing = this.skipLinks$.value;
      existing.splice(this.getSkipLinkIndexInArray(key), 0, {
        target,
        i18nKey: found.i18nKey,
        position: found.position,
        key
      });
      this.skipLinks$.next(existing);
    }
  }
  remove(key) {
    const found = this.config.skipLinks?.find(skipLink => skipLink.key === key);
    if (found) {
      let existing = this.skipLinks$.value;
      existing = existing.filter(skipLink => skipLink.key !== key);
      this.skipLinks$.next(existing);
    }
  }
  scrollToTarget(scrollTo) {
    const skipLink = typeof scrollTo === 'string' ? this.findSkipLinkByKey(scrollTo) : scrollTo;
    if (!skipLink) {
      return;
    }
    const target = skipLink.target instanceof HTMLElement ? skipLink.target : skipLink.target?.parentElement;
    // focus first focusable element in the
    const firstFocusable = this.keyboardFocusService.findFirstFocusable(target) || target;
    // we force a tabindex if not available, to ensure we can focus into the element
    const hasTabindex = firstFocusable?.hasAttribute('tabindex');
    if (!hasTabindex) {
      firstFocusable?.setAttribute('tabindex', '-1');
    }
    firstFocusable?.focus();
    // drop the tmp tabindex
    if (!hasTabindex) {
      firstFocusable?.removeAttribute('tabindex');
    }
  }
  findSkipLinkByKey(key) {
    return this.skipLinks$.value.find(skipLink => skipLink.key === key);
  }
  getSkipLinkIndexInArray(key) {
    let index = this.config.skipLinks?.findIndex(skipLink => skipLink.key === key) ?? 0;
    while (index > 0) {
      index--;
      const previous = this.config.skipLinks?.[index];
      if (previous) {
        const existing = this.skipLinks$.value;
        const found = existing.findIndex(skipLink => skipLink.key === previous.key);
        if (found > -1) {
          return found + 1;
        }
      }
    }
    return 0;
  }
  static {
    this.ɵfac = function SkipLinkService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipLinkService)(i0.ɵɵinject(SkipLinkConfig), i0.ɵɵinject(KeyboardFocusService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SkipLinkService,
      factory: SkipLinkService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipLinkService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: SkipLinkConfig
  }, {
    type: KeyboardFocusService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkComponent {
  constructor(skipLinkService) {
    this.skipLinkService = skipLinkService;
    this.skipLinks$ = this.skipLinkService.getSkipLinks();
  }
  scrollToTarget(skipLink) {
    this.skipLinkService.scrollToTarget(skipLink);
  }
  static {
    this.ɵfac = function SkipLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipLinkComponent)(i0.ɵɵdirectiveInject(SkipLinkService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SkipLinkComponent,
      selectors: [["cx-skip-link"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "cxFocus", 4, "ngIf"], [3, "cxFocus"], [3, "click", 4, "ngFor", "ngForOf"], [3, "click"]],
      template: function SkipLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SkipLinkComponent_div_0_Template, 2, 3, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.skipLinks$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, FocusDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipLinkComponent, [{
    type: Component,
    args: [{
      selector: 'cx-skip-link',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div [cxFocus]=\"{ tab: true }\" *ngIf=\"skipLinks$ | async as links\">\n  <button *ngFor=\"let link of links\" (click)=\"scrollToTarget(link)\">\n    {{ 'skipLink.skipTo' | cxTranslate }}\n    {{ link.i18nKey | cxTranslate }}\n  </button>\n</div>\n"
    }]
  }], () => [{
    type: SkipLinkService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultSkipLinkConfig = {
  skipLinks: [{
    key: 'cx-header',
    i18nKey: 'skipLink.labels.header'
  }, {
    key: 'cx-main',
    i18nKey: 'skipLink.labels.main'
  }, {
    key: 'cx-footer',
    i18nKey: 'skipLink.labels.footer'
  }]
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkDirective {
  constructor(elementRef, skipLinkService) {
    this.elementRef = elementRef;
    this.skipLinkService = skipLinkService;
  }
  ngOnInit() {
    this.skipLinkService.add(this.cxSkipLink, this.elementRef.nativeElement);
  }
  ngOnDestroy() {
    this.skipLinkService.remove(this.cxSkipLink);
  }
  static {
    this.ɵfac = function SkipLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipLinkDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SkipLinkService));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: SkipLinkDirective,
      selectors: [["", "cxSkipLink", ""]],
      inputs: {
        cxSkipLink: "cxSkipLink"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipLinkDirective, [{
    type: Directive,
    args: [{
      selector: '[cxSkipLink]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: SkipLinkService
  }], {
    cxSkipLink: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SkipLinkModule {
  static {
    this.ɵfac = function SkipLinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SkipLinkModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SkipLinkModule,
      declarations: [SkipLinkComponent, SkipLinkDirective],
      imports: [CommonModule, I18nModule, i1.ConfigModule, KeyboardFocusModule],
      exports: [SkipLinkDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultSkipLinkConfig), {
        provide: APP_INITIALIZER,
        useFactory: skipLinkFactory,
        deps: [ComponentFactoryResolver, OutletService],
        multi: true
      }],
      imports: [CommonModule, I18nModule, ConfigModule.withConfig(defaultSkipLinkConfig), KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SkipLinkModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, ConfigModule.withConfig(defaultSkipLinkConfig), KeyboardFocusModule],
      declarations: [SkipLinkComponent, SkipLinkDirective],
      exports: [SkipLinkDirective],
      providers: [provideDefaultConfig(defaultSkipLinkConfig), {
        provide: APP_INITIALIZER,
        useFactory: skipLinkFactory,
        deps: [ComponentFactoryResolver, OutletService],
        multi: true
      }]
    }]
  }], null, null);
})();
/**
 * Adds the skip link component before the cx-storefront.
 */
function skipLinkFactory(componentFactoryResolver, outletService) {
  const isReady = () => {
    const factory = componentFactoryResolver.resolveComponentFactory(SkipLinkComponent);
    outletService.add('cx-storefront', factory, OutletPosition.BEFORE);
  };
  return isReady;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive used for making links styled as a buttons (using .btn class)
 * act as a real buttons a11y wise (meaning making them reactive to both
 * enter and spacebar clicks).
 *
 * Note: This is done as a11y optimization for old button like link compoennts
 * and shouldn't be used other than for those. Whenever you find yourself in a need
 * to be using this consider it as a good 'code smell' for using BUttons instead of links.
 */
class BtnLikeLinkDirective {
  static {
    this.ɵfac = function BtnLikeLinkDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BtnLikeLinkDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BtnLikeLinkDirective,
      selectors: [["a", "cxBtnLikeLink", "", 8, "btn"]],
      hostAttrs: ["tabindex", "0", "role", "button"],
      hostBindings: function BtnLikeLinkDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.enter", function BtnLikeLinkDirective_keydown_enter_HostBindingHandler($event) {
            $event.preventDefault();
            return $event.target.click();
          })("keydown.space", function BtnLikeLinkDirective_keydown_space_HostBindingHandler($event) {
            $event.preventDefault();
            return $event.target.click();
          });
        }
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BtnLikeLinkDirective, [{
    type: Directive,
    args: [{
      selector: 'a[cxBtnLikeLink].btn',
      // 'a.btn'
      host: {
        // Adding [tabindex] allows tab-based access to this element.
        tabindex: '0',
        // Adding [role] tells screen reatders that this "link" is really a "button"
        role: 'button',
        // Add Enter keydown click mimic native Button's behaviour
        '(keydown.enter)': '$event.preventDefault() ; $event.target.click() ;',
        // Add Space keydown click mimic native Button's behaviour
        '(keydown.space)': '$event.preventDefault() ; $event.target.click() ;'
      },
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const directives = [BtnLikeLinkDirective];
class BtnLikeLinkModule {
  static {
    this.ɵfac = function BtnLikeLinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BtnLikeLinkModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BtnLikeLinkModule,
      declarations: [BtnLikeLinkDirective],
      imports: [CommonModule],
      exports: [BtnLikeLinkDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BtnLikeLinkModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [...directives],
      exports: [...directives]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Custom Directive used to enable clients to track (react to) Host's Element DOM changes.
 *
 * Whenever the mutation (Host's element DOM subthree change) is detected it will trigger the
 * _cxDomChange_ Output allowing clients to react to the Host's element DOM changes.
 *
 * Optional _cxDomChangeTargetSelector_ Input enables clients to be more specifixc when reacting to
 * the Host's element DOM changes by allowing them to specify css selector (relative to Host Element)
 * that narrows down the number of _cxDomChange_ Output executions to be triggered only when
 * _cxDomChangeTargetSelector_ Input relevant elements changes are detected.
 */
class DomChangeDirective {
  constructor() {
    this.cxDomChange = new EventEmitter();
    this.elementRef = inject(ElementRef);
    this.changes = new MutationObserver(mutations => {
      const affectedMutations = this.cxDomChangeTargetSelector ? mutations.filter(mutation => mutation.target === this.elementRef.nativeElement.querySelector(this.cxDomChangeTargetSelector)) : mutations;
      affectedMutations.forEach(mutation => this.cxDomChange.emit(mutation));
    });
    this.changes.observe(this.elementRef.nativeElement, {
      subtree: true,
      childList: true
    });
  }
  ngOnDestroy() {
    this.changes.disconnect();
  }
  static {
    this.ɵfac = function DomChangeDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DomChangeDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: DomChangeDirective,
      selectors: [["", "cxDomChange", ""]],
      inputs: {
        cxDomChangeTargetSelector: "cxDomChangeTargetSelector"
      },
      outputs: {
        cxDomChange: "cxDomChange"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DomChangeDirective, [{
    type: Directive,
    args: [{
      selector: '[cxDomChange]',
      standalone: false
    }]
  }], () => [], {
    cxDomChangeTargetSelector: [{
      type: Input
    }],
    cxDomChange: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DomChangeModule {
  static {
    this.ɵfac = function DomChangeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DomChangeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DomChangeModule,
      declarations: [DomChangeDirective],
      imports: [CommonModule],
      exports: [DomChangeDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DomChangeModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [DomChangeDirective],
      exports: [DomChangeDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CarouselService {
  constructor(winRef) {
    this.winRef = winRef;
  }
  /**
   * The number of items per slide is calculated by the help of
   * the item width and the available width of the host element.
   * This appoach makes it possible to place the carousel in different
   * layouts. Instead of using the page breakpoints, the host size is
   * taken into account.
   *
   * Since there's no element resize API available, we use the
   * window `resize` event, so that we can adjust the number of items
   * whenever the window got resized.
   */
  getItemsPerSlide(nativeElement, itemWidth) {
    return this.winRef.resize$.pipe(map(() => nativeElement.clientWidth), map(totalWidth => this.calculateItems(totalWidth, itemWidth)));
  }
  /**
   * Calculates the number of items per given hostSize.  calculated based on the given
   * intended size in pixels or percentages. The
   *
   * @param availableWidth The available width in pixels for the carousel items.
   * @param itemWidth The width per carousel item, in px or percentage.
   */
  calculateItems(availableWidth, itemWidth) {
    let calculatedItems = 0;
    if (itemWidth.endsWith('px')) {
      const num = itemWidth.substring(0, itemWidth.length - 2);
      calculatedItems = availableWidth / num;
    }
    if (itemWidth.endsWith('%')) {
      const perc = itemWidth.substring(0, itemWidth.length - 1);
      calculatedItems = availableWidth / (availableWidth * (perc / 100));
    }
    return Math.floor(calculatedItems) || 1;
  }
  static {
    this.ɵfac = function CarouselService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselService)(i0.ɵɵinject(i1.WindowRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CarouselService,
      factory: CarouselService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic carousel component that can be used to render any carousel items,
 * such as products, images, banners, or any component. Carousel items are
 * rendered in so-called carousel slides, and the previous/next buttons as well as
 * the indicator-buttons can used to navigate the slides.
 *
 * The component uses an array of Observables (`items$`) as an input, to allow
 * for lazy loading of items.
 *
 * The number of items per slide is calculated with the `itemWidth`, which can given
 * in pixels or percentage.
 *
 * To allow for flexible rendering of items, the rendering is delegated to the
 * given `template`. This allows for maximum flexibility.
 */
class CarouselComponent {
  set setItems(inputItems) {
    this.items = inputItems;
    //Reset slider when changing products
    this.activeSlide = 0;
  }
  constructor(el, service) {
    this.el = el;
    this.service = service;
    this.keybordEvent = new BehaviorSubject(null);
    /**
     * Specifies the minimum size of the carousel item, either in px or %.
     * This value is used for the calculation of numbers per carousel, so that
     * the number of carousel items is dynamic. The calculation uses the `itemWidth`
     * and the host element `clientWidth`, so that the carousel is reusable in
     * different layouts (for example in a 50% grid).
     */
    this.itemWidth = '300px';
    /**
     * Indicates whether the visual indicators are used.
     */
    this.hideIndicators = false;
    this.indicatorIcon = ICON_TYPE.CIRCLE;
    this.previousIcon = ICON_TYPE.CARET_LEFT;
    this.nextIcon = ICON_TYPE.CARET_RIGHT;
    this.logger = inject(LoggerService);
    useFeatureStyles('a11yAddPaddingToCarouselPanel');
  }
  ngOnInit() {
    if (!this.template && isDevMode()) {
      this.logger.error('No template reference provided to render the carousel items for the `cx-carousel`');
    }
  }
  ngOnChanges() {
    this.size$ = this.service.getItemsPerSlide(this.el.nativeElement, this.itemWidth).pipe(tap(() => this.activeSlide = 0));
  }
  onItemKeydown(event, size) {
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowLeft':
        event.preventDefault();
        this.focusNextPrevItem(event.target, event.key === 'ArrowRight' ? 1 : -1, size);
        break;
      case 'Tab':
        this.skipTabForCarouselItems();
        break;
    }
  }
  /**
   * Handles Tab key on carousel items. If the carousel items have `ArrowRight`/`ArrowLeft`
   * navigation enabled, it temporarily disables tab navigation for these items.
   * The `cxFocusableCarouselItem` selector is used because it identifies carousel
   * items that have `ArrowRight`/`ArrowLeft` navigation enabled. These items should not
   * use tab navigation according to a11y requirements.
   */
  skipTabForCarouselItems() {
    const carouselElements = Array.from(this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]'));
    if (!carouselElements.length) {
      return;
    }
    disableTabbingForTick(carouselElements);
  }
  /**
   * Focuses the next or previous item in the carousel based on keyboard navigation.
   *
   * This method determines the next focusable carousel item, identified by the
   * `cxFocusableCarouselItem` directive, based on the current focus and the direction
   * given. It adjusts the carousel's active slide if the next focusable item is
   * outside the currently visible items.
   *
   * @param currentItem - The currently focused carousel item.
   * @param direction - The navigation direction (1 for right, -1 for left).
   * @param size - The number of items per slide, used to determine slide change is needed
   */
  focusNextPrevItem(currentItem, direction, size) {
    const focusableElements = this.el.nativeElement.querySelectorAll('[cxFocusableCarouselItem]');
    const currentIndex = Array.from(focusableElements).indexOf(currentItem);
    const nextIndex = currentIndex + direction;
    if (nextIndex < 0 || nextIndex >= focusableElements.length) {
      return;
    }
    const targetElement = focusableElements[nextIndex];
    const shouldChangeSlide = nextIndex < this.activeSlide || nextIndex >= this.activeSlide + size;
    if (shouldChangeSlide) {
      this.activeSlide = nextIndex - nextIndex % size;
      // After changing slides carousel items has CSS transition,
      // which prevents them from being focused
      targetElement.addEventListener('transitionend', () => {
        targetElement.focus();
      }, {
        once: true
      });
    } else {
      targetElement.focus();
    }
  }
  getSlideNumber(size, currentIndex) {
    const normalizedCurrentIndex = currentIndex + 1;
    return Math.ceil(normalizedCurrentIndex / size);
  }
  shareEvent(event) {
    if (!event) {
      throw new Error('Missing Event');
    }
    this.keybordEvent.next(event);
  }
  static {
    this.ɵfac = function CarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(CarouselService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CarouselComponent,
      selectors: [["cx-carousel"]],
      inputs: {
        title: "title",
        setItems: [0, "items", "setItems"],
        template: "template",
        itemWidth: "itemWidth",
        hideIndicators: "hideIndicators",
        indicatorIcon: "indicatorIcon",
        previousIcon: "previousIcon",
        nextIcon: "nextIcon"
      },
      outputs: {
        keybordEvent: "keybordEvent"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "carousel-panel", 3, "ngClass"], ["class", "previous", 3, "click", "keydown.arrowleft", "keydown.arrowright", "keydown.arrowup", "keydown.arrowdown", 4, "ngIf"], [1, "slides"], [4, "ngFor", "ngForOf"], ["class", "next", 3, "click", "keydown.arrowleft", "keydown.arrowright", "keydown.arrowup", "keydown.arrowdown", 4, "ngIf"], ["class", "indicators", 4, "ngIf"], [1, "previous", 3, "click", "keydown.arrowleft", "keydown.arrowright", "keydown.arrowup", "keydown.arrowdown"], [3, "type"], ["class", "slide", 3, "active", 4, "ngIf"], [1, "slide"], ["class", "item", 3, "active", "keydown", 4, "ngIf"], [1, "item", 3, "keydown"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "next", 3, "click", "keydown.arrowleft", "keydown.arrowright", "keydown.arrowup", "keydown.arrowdown"], [1, "indicators"], [3, "click", 4, "ngIf"], [3, "click"], ["aria-hidden", "true", 3, "type"]],
      template: function CarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CarouselComponent_ng_container_0_Template, 8, 6, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.items && ctx.items.length > 0 && i0.ɵɵpipeBind1(1, 1, ctx.size$));
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, IconComponent, i3.AsyncPipe, i3.SlicePipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselComponent, [{
    type: Component,
    args: [{
      selector: 'cx-carousel',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"items && items.length > 0 && (size$ | async) as size\">\n  <h2 *ngIf=\"title\">{{ title }}</h2>\n\n  <div class=\"carousel-panel\" [ngClass]=\"'size-' + size\">\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"previous\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide === 0 ? null : (activeSlide = activeSlide - size)\n      \"\n      [attr.aria-disabled]=\"activeSlide === 0\"\n      [attr.aria-label]=\"'carousel.previousSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.previousSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"previousIcon\"></cx-icon>\n    </button>\n    <div class=\"slides\">\n      <ng-container *ngFor=\"let _ of items; let i = index\">\n        <div\n          class=\"slide\"\n          *ngIf=\"i % size === 0\"\n          [class.active]=\"i === activeSlide\"\n        >\n          <ng-container\n            *ngFor=\"let item of items | slice: i : i + size; let j = index\"\n          >\n            <div\n              *ngIf=\"item | async as data\"\n              class=\"item\"\n              [class.active]=\"i === activeSlide\"\n              (keydown)=\"onItemKeydown($event, size)\"\n            >\n              <ng-container\n                *ngTemplateOutlet=\"template; context: { item: data }\"\n              ></ng-container>\n            </div>\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n\n    <button\n      *ngIf=\"size < items.length\"\n      class=\"next\"\n      (click)=\"\n        $event.stopPropagation();\n        activeSlide > items.length - size - 1\n          ? null\n          : (activeSlide = activeSlide + size)\n      \"\n      [attr.aria-disabled]=\"activeSlide > items.length - size - 1\"\n      [attr.aria-label]=\"'carousel.nextSlide' | cxTranslate\"\n      [attr.title]=\"'carousel.nextSlide' | cxTranslate\"\n      (keydown.arrowleft)=\"shareEvent($any($event))\"\n      (keydown.arrowright)=\"shareEvent($any($event))\"\n      (keydown.arrowup)=\"shareEvent($any($event))\"\n      (keydown.arrowdown)=\"shareEvent($any($event))\"\n    >\n      <cx-icon [type]=\"nextIcon\"></cx-icon>\n    </button>\n  </div>\n\n  <div *ngIf=\"!hideIndicators && size < items.length\" class=\"indicators\">\n    <ng-container *ngFor=\"let _ of items; let i = index\">\n      <button\n        *ngIf=\"i % size === 0\"\n        (click)=\"$event.stopPropagation(); activeSlide = i\"\n        [attr.aria-current]=\"i === activeSlide\"\n        [attr.aria-disabled]=\"i === activeSlide\"\n        [attr.aria-label]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n        [attr.title]=\"\n          'carousel.slideNumber'\n            | cxTranslate\n              : {\n                  currentSlideNumber: getSlideNumber(size, i),\n                  numberOfSlides: size,\n                }\n        \"\n      >\n        <cx-icon [type]=\"indicatorIcon\" aria-hidden=\"true\"></cx-icon>\n      </button>\n    </ng-container>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: CarouselService
  }], {
    keybordEvent: [{
      type: Output
    }],
    title: [{
      type: Input
    }],
    setItems: [{
      type: Input,
      args: ['items']
    }],
    template: [{
      type: Input
    }],
    itemWidth: [{
      type: Input
    }],
    hideIndicators: [{
      type: Input
    }],
    indicatorIcon: [{
      type: Input
    }],
    previousIcon: [{
      type: Input
    }],
    nextIcon: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic carousel that renders CMS Components.
 */
class BannerCarouselComponent {
  constructor(componentData, cmsService) {
    this.componentData = componentData;
    this.cmsService = cmsService;
    this.componentData$ = this.componentData.data$.pipe(filter(data => Boolean(data)), tap(d => this.theme = `${d.effect}-theme`));
    this.items$ = this.componentData$.pipe(map(data => data.banners?.trim().split(' ') ?? []), map(codes => codes.map(code => this.cmsService.getComponentData(code))));
    /**
     * Adds a specific theme for the carousel. The effect can be
     * used in CSS customisations.
     */
    this.theme = '';
  }
  /**
   * Returns an Obervable with an Array of Observables. This is done, so that
   * the component UI could consider to lazy load the UI components when they're
   * in the viewpoint.
   */
  getItems() {
    return this.items$;
  }
  static {
    this.ɵfac = function BannerCarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BannerCarouselComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.CmsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BannerCarouselComponent,
      selectors: [["cx-banner-carousel"]],
      hostVars: 2,
      hostBindings: function BannerCarouselComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.theme);
        }
      },
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["template", ""], ["itemWidth", "100%", "class", "inline-navigation", 3, "items", "template", 4, "ngIf"], ["itemWidth", "100%", 1, "inline-navigation", 3, "items", "template"], [3, "cxComponentWrapper"]],
      template: function BannerCarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, BannerCarouselComponent_cx_carousel_0_Template, 1, 2, "cx-carousel", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, BannerCarouselComponent_ng_template_2_Template, 1, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.getItems()));
        }
      },
      dependencies: [i3.NgIf, ComponentWrapperDirective, CarouselComponent, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerCarouselComponent, [{
    type: Component,
    args: [{
      selector: 'cx-banner-carousel',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-carousel\n  *ngIf=\"getItems() | async as items\"\n  [items]=\"items\"\n  [template]=\"template\"\n  itemWidth=\"100%\"\n  class=\"inline-navigation\"\n></cx-carousel>\n\n<ng-template #template let-item=\"item\">\n  <ng-container\n    [cxComponentWrapper]=\"{\n      flexType: item.typeCode,\n      typeCode: item.typeCode,\n      uid: item?.uid,\n    }\"\n  >\n  </ng-container>\n</ng-template>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.CmsService
  }], {
    theme: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SpinnerModule {
  static {
    this.ɵfac = function SpinnerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SpinnerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SpinnerModule,
      declarations: [SpinnerComponent],
      imports: [CommonModule, I18nModule],
      exports: [SpinnerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SpinnerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule],
      declarations: [SpinnerComponent],
      exports: [SpinnerComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementComponentService {
  constructor(anonymousConsentsConfig) {
    this.anonymousConsentsConfig = anonymousConsentsConfig;
  }
  /**
   * Returns the list of mandatory consents
   * @param _templateList - list of all active consents. This parameter is not needed in core
   * implementation. But is needed in CDC implementation to fetch only the required consents
   * from this list
   * @returns array of consent IDs
   */
  getRequiredConsents(_templateList) {
    return this.anonymousConsentsConfig?.anonymousConsents?.requiredConsents || [];
  }
  static {
    this.ɵfac = function ConsentManagementComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsentManagementComponentService)(i0.ɵɵinject(i1.AnonymousConsentsConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ConsentManagementComponentService,
      factory: ConsentManagementComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsentManagementComponentService, [{
    type: Injectable
  }], () => [{
    type: i1.AnonymousConsentsConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ConsentManagementComponent {
  get allConsentsLoading$() {
    return this.allConsentsLoading.asObservable();
  }
  constructor(userConsentService, globalMessageService, anonymousConsentsConfig, anonymousConsentsService, authService, consentManagementComponentService) {
    this.userConsentService = userConsentService;
    this.globalMessageService = globalMessageService;
    this.anonymousConsentsConfig = anonymousConsentsConfig;
    this.anonymousConsentsService = anonymousConsentsService;
    this.authService = authService;
    this.consentManagementComponentService = consentManagementComponentService;
    this.subscriptions = new Subscription();
    this.allConsentsLoading = new BehaviorSubject(false);
    this.requiredConsents = [];
  }
  ngOnInit() {
    this.loading$ = combineLatest([this.userConsentService.getConsentsResultLoading(), this.userConsentService.getGiveConsentResultLoading(), this.userConsentService.getWithdrawConsentResultLoading(), this.authService.isUserLoggedIn(), this.allConsentsLoading]).pipe(map(([consentLoading, giveConsentLoading, withdrawConsentLoading, isUserLoggedIn, allConsentsLoading]) => consentLoading || giveConsentLoading || withdrawConsentLoading || !isUserLoggedIn || allConsentsLoading));
    this.consentListInit();
    this.giveConsentInit();
    this.withdrawConsentInit();
  }
  consentListInit() {
    this.templateList$ = this.userConsentService.getConsents().pipe(withLatestFrom(this.anonymousConsentsService.getTemplates(), this.authService.isUserLoggedIn()), filter(([_templateList, _anonymousTemplates, isUserLoggedIn]) => isUserLoggedIn), tap(([templateList, _anonymousTemplates]) => {
      if (!this.consentsExists(templateList)) {
        this.userConsentService.loadConsents();
      }
    }), map(([templateList, anonymousTemplates]) => {
      this.requiredConsents = this.consentManagementComponentService ? this.consentManagementComponentService.getRequiredConsents(templateList) : [];
      if (this.anonymousConsentsConfig.anonymousConsents) {
        if (this.anonymousConsentsConfig.anonymousConsents.consentManagementPage) {
          return this.hideAnonymousConsents(templateList, anonymousTemplates);
        }
      }
      return templateList;
    }));
  }
  hideAnonymousConsents(templateList, anonymousTemplates = []) {
    let hideTemplateIds = [];
    if (!this.anonymousConsentsConfig.anonymousConsents?.consentManagementPage?.showAnonymousConsents) {
      hideTemplateIds = anonymousTemplates.map(template => template.id ?? '');
      return this.userConsentService.filterConsentTemplates(templateList, hideTemplateIds);
    }
    if (this.anonymousConsentsConfig.anonymousConsents.consentManagementPage.hideConsents && this.anonymousConsentsConfig.anonymousConsents.consentManagementPage.hideConsents.length > 0) {
      hideTemplateIds = this.anonymousConsentsConfig.anonymousConsents.consentManagementPage.hideConsents;
    }
    return this.userConsentService.filterConsentTemplates(templateList, hideTemplateIds);
  }
  giveConsentInit() {
    this.userConsentService.resetGiveConsentProcessState();
    this.subscriptions.add(this.userConsentService.getGiveConsentResultSuccess().subscribe(success => this.onConsentGivenSuccess(success)));
  }
  withdrawConsentInit() {
    this.userConsentService.resetWithdrawConsentProcessState();
    this.subscriptions.add(this.userConsentService.getWithdrawConsentResultLoading().pipe(skipWhile$1(Boolean), withLatestFrom(this.userConsentService.getWithdrawConsentResultSuccess()), map(([, withdrawalSuccess]) => withdrawalSuccess), tap(withdrawalSuccess => {
      if (withdrawalSuccess) {
        this.userConsentService.loadConsents();
      }
    })).subscribe(withdrawalSuccess => this.onConsentWithdrawnSuccess(withdrawalSuccess)));
  }
  consentsExists(templateList) {
    return Boolean(templateList) && templateList.length > 0;
  }
  onConsentChange({
    given,
    template
  }) {
    if (given && template.id && template.version !== undefined) {
      this.userConsentService.giveConsent(template.id, template.version);
    } else if (template.currentConsent?.code) {
      this.userConsentService.withdrawConsent(template.currentConsent.code, template?.id);
    }
  }
  onConsentGivenSuccess(success) {
    if (success) {
      this.userConsentService.resetGiveConsentProcessState();
      this.globalMessageService.add({
        key: 'consentManagementForm.message.success.given'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  onConsentWithdrawnSuccess(success) {
    if (success) {
      this.userConsentService.resetWithdrawConsentProcessState();
      this.globalMessageService.add({
        key: 'consentManagementForm.message.success.withdrawn'
      }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }
  rejectAll(templates = []) {
    const consentsToWithdraw = [];
    templates.forEach(template => {
      if (template.currentConsent && this.userConsentService.isConsentGiven(template.currentConsent)) {
        if (this.isRequiredConsent(template)) {
          return;
        }
        consentsToWithdraw.push(template);
      }
    });
    this.allConsentsLoading.next(true);
    this.subscriptions.add(this.setupWithdrawalStream(consentsToWithdraw).pipe(tap(_timesLoaded => this.allConsentsLoading.next(false))).subscribe());
  }
  setupWithdrawalStream(consentsToWithdraw = []) {
    const loading$ = concat(this.userConsentService.getWithdrawConsentResultLoading()).pipe(distinctUntilChanged(), filter(loading => !loading));
    const count$ = loading$.pipe(scan((acc, _value) => acc + 1, -1));
    const withdraw$ = count$.pipe(tap(i => {
      if (i < consentsToWithdraw.length) {
        const code = consentsToWithdraw[i].currentConsent?.code;
        const id = consentsToWithdraw[i]?.id;
        if (code) {
          this.userConsentService.withdrawConsent(code, id);
        }
      }
    }));
    const checkTimesLoaded$ = withdraw$.pipe(filter(timesLoaded => timesLoaded === consentsToWithdraw.length));
    return checkTimesLoaded$;
  }
  allowAll(templates = []) {
    const consentsToGive = [];
    templates.forEach(template => {
      const givenDate = template.currentConsent?.consentGivenDate;
      const withdrawnDate = template.currentConsent?.consentWithdrawnDate;
      const isConsentGiven = givenDate && !withdrawnDate || givenDate && withdrawnDate && givenDate > withdrawnDate;
      if (isConsentGiven) {
        return;
      }
      if (template.currentConsent && this.userConsentService.isConsentWithdrawn(template.currentConsent)) {
        if (this.isRequiredConsent(template)) {
          return;
        }
      }
      consentsToGive.push(template);
    });
    this.allConsentsLoading.next(true);
    this.subscriptions.add(this.setupGiveStream(consentsToGive).pipe(tap(_timesLoaded => this.allConsentsLoading.next(false))).subscribe());
  }
  setupGiveStream(consentsToGive = []) {
    const loading$ = concat(this.userConsentService.getGiveConsentResultLoading()).pipe(distinctUntilChanged(), filter(loading => !loading));
    const count$ = loading$.pipe(scan((acc, _value) => acc + 1, -1));
    const giveConsent$ = count$.pipe(tap(i => {
      if (i < consentsToGive.length) {
        const consent = consentsToGive[i];
        if (consent.id && consent.version !== undefined) {
          this.userConsentService.giveConsent(consent.id, consent.version);
        }
      }
    }));
    const checkTimesLoaded$ = giveConsent$.pipe(filter(timesLoaded => timesLoaded === consentsToGive.length));
    return checkTimesLoaded$;
  }
  isRequiredConsent(template) {
    return Boolean(template.id && this.anonymousConsentsConfig.anonymousConsents && this.anonymousConsentsConfig.anonymousConsents?.requiredConsents && this.anonymousConsentsConfig.anonymousConsents.requiredConsents.includes(template.id));
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.allConsentsLoading.unsubscribe();
    this.userConsentService.resetGiveConsentProcessState();
    this.userConsentService.resetWithdrawConsentProcessState();
  }
  static {
    this.ɵfac = function ConsentManagementComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsentManagementComponent)(i0.ɵɵdirectiveInject(i1.UserConsentService), i0.ɵɵdirectiveInject(i1.GlobalMessageService), i0.ɵɵdirectiveInject(i1.AnonymousConsentsConfig), i0.ɵɵdirectiveInject(i1.AnonymousConsentsService), i0.ɵɵdirectiveInject(i1.AuthService), i0.ɵɵdirectiveInject(ConsentManagementComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ConsentManagementComponent,
      selectors: [["cx-consent-management"]],
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["consentManagementForm", ""], [4, "cxFeature"], [4, "ngIf"], [1, "cx-consent-action-links"], [1, "col-sm-12", "col-md-8", "col-lg-6"], [1, "btn", "btn-link", "cx-action-link", 3, "click", "disabled"], ["class", "cx-spinner", 4, "ngIf"], [1, "cx-spinner"], ["role", "status", 4, "cxFeature"], [1, "cx-consent-toggles"], [3, "consentTemplate", "requiredConsents", "disabled", "consentChanged", 4, "ngFor", "ngForOf"], ["role", "status"], [3, "consentChanged", "consentTemplate", "requiredConsents", "disabled"], [4, "ngIf", "ngIfElse"], ["tabindex", "0", 1, "btn", "btn-link", "cx-action-link", 3, "click"], [3, "consentTemplate", "requiredConsents", "consentChanged", 4, "ngFor", "ngForOf"], [3, "consentChanged", "consentTemplate", "requiredConsents"]],
      template: function ConsentManagementComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ConsentManagementComponent_ng_container_0_Template, 6, 12, "ng-container", 1);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "a11yNotificationsOnConsentChange");
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SpinnerComponent, i1.FeatureDirective, ConsentManagementFormComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsentManagementComponent, [{
    type: Component,
    args: [{
      selector: 'cx-consent-management',
      standalone: false,
      template: "<ng-container *cxFeature=\"'a11yNotificationsOnConsentChange'\">\n  <ng-container\n    *ngIf=\"{\n      loading: loading$ | async,\n      templateList: templateList$ | async,\n      allConsentsLoading: allConsentsLoading$ | async,\n    } as data\"\n  >\n    <ng-container *ngIf=\"data.templateList as templateList\">\n      <div class=\"cx-consent-action-links\">\n        <div class=\"col-sm-12 col-md-8 col-lg-6\">\n          <button\n            class=\"btn btn-link cx-action-link\"\n            [disabled]=\"data.loading\"\n            (click)=\"rejectAll(templateList)\"\n          >\n            {{ 'consentManagementForm.clearAll' | cxTranslate }}\n          </button>\n          <button\n            class=\"btn btn-link cx-action-link\"\n            [disabled]=\"data.loading\"\n            (click)=\"allowAll(templateList)\"\n          >\n            {{ 'consentManagementForm.selectAll' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div\n        class=\"cx-spinner\"\n        *ngIf=\"\n          data.allConsentsLoading || (data.loading && !templateList?.length)\n        \"\n      >\n        <cx-spinner></cx-spinner>\n      </div>\n\n      <ng-container *ngIf=\"!data.allConsentsLoading\">\n        <div\n          *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n          role=\"status\"\n          [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n        ></div>\n\n        <div class=\"cx-consent-toggles\">\n          <div class=\"col-sm-12 col-md-8 col-lg-6\">\n            <cx-consent-management-form\n              *ngFor=\"let consentTemplate of templateList\"\n              [consentTemplate]=\"consentTemplate\"\n              [requiredConsents]=\"requiredConsents\"\n              [disabled]=\"!!data.loading\"\n              (consentChanged)=\"onConsentChange($event)\"\n            ></cx-consent-management-form>\n          </div>\n        </div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!a11yNotificationsOnConsentChange'\">\n    <div *ngIf=\"loading$ | async; else consentManagementForm\">\n      <div class=\"cx-spinner\">\n        <cx-spinner></cx-spinner>\n      </div>\n    </div>\n\n    <ng-template #consentManagementForm>\n      <div\n        *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n        role=\"status\"\n        [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n      ></div>\n      <ng-container *ngIf=\"templateList$ | async as templateList\">\n        <div class=\"cx-consent-action-links\">\n          <div class=\"col-sm-12 col-md-8 col-lg-6\">\n            <button\n              tabindex=\"0\"\n              class=\"btn btn-link cx-action-link\"\n              (click)=\"rejectAll(templateList)\"\n            >\n              {{ 'consentManagementForm.clearAll' | cxTranslate }}\n            </button>\n            <button\n              tabindex=\"0\"\n              class=\"btn btn-link cx-action-link\"\n              (click)=\"allowAll(templateList)\"\n            >\n              {{ 'consentManagementForm.selectAll' | cxTranslate }}\n            </button>\n          </div>\n          <div class=\"cx-consent-toggles\">\n            <div class=\"col-sm-12 col-md-8 col-lg-6\">\n              <cx-consent-management-form\n                *ngFor=\"let consentTemplate of templateList\"\n                [consentTemplate]=\"consentTemplate\"\n                [requiredConsents]=\"requiredConsents\"\n                (consentChanged)=\"onConsentChange($event)\"\n              ></cx-consent-management-form>\n            </div>\n          </div>\n        </div>\n      </ng-container>\n    </ng-template>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.UserConsentService
  }, {
    type: i1.GlobalMessageService
  }, {
    type: i1.AnonymousConsentsConfig
  }, {
    type: i1.AnonymousConsentsService
  }, {
    type: i1.AuthService
  }, {
    type: ConsentManagementComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE = new InjectionToken('feature flag to enable enhanced UI for notification preference pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});
const USE_MY_ACCOUNT_V2_CONSENT = new InjectionToken('feature flag to enable enhanced UI for Consent Management pages under My-Account', {
  providedIn: 'root',
  factory: () => false
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementFormComponent extends ConsentManagementFormComponent {
  ngOnInit() {
    if (this.consent) {
      this.consentGiven = Boolean(this.consent.consentState === ANONYMOUS_CONSENT_STATUS.GIVEN);
    } else {
      if (this.consentTemplate && this.consentTemplate.currentConsent) {
        if (this.consentTemplate.currentConsent.consentWithdrawnDate) {
          this.consentGiven = false;
        } else if (this.consentTemplate.currentConsent.consentGivenDate) {
          this.consentGiven = true;
          const date = new Date(this.consentTemplate.currentConsent.consentGivenDate);
          this.consentApprovedTime = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        }
      }
    }
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2ConsentManagementFormComponent_BaseFactory;
      return function MyAccountV2ConsentManagementFormComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2ConsentManagementFormComponent_BaseFactory || (ɵMyAccountV2ConsentManagementFormComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2ConsentManagementFormComponent)))(__ngFactoryType__ || MyAccountV2ConsentManagementFormComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2ConsentManagementFormComponent,
      selectors: [["cx-my-account-v2-consent-management-form"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 8,
      consts: [[1, "form-check", "consent-container"], [1, ""], ["type", "checkbox", 1, "checkbox-input", 3, "change", "id", "name", "checked", "disabled"], [3, "for"], [1, "name"], [4, "ngIf"], [1, "description"], ["class", "description", 4, "ngIf"]],
      template: function MyAccountV2ConsentManagementFormComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "label")(3, "input", 2);
          i0.ɵɵlistener("change", function MyAccountV2ConsentManagementFormComponent_Template_input_change_3_listener() {
            return ctx.onConsentChange();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(4, "label", 3);
          i0.ɵɵelementStart(5, "span", 4);
          i0.ɵɵtemplate(6, MyAccountV2ConsentManagementFormComponent_ng_container_6_Template, 2, 1, "ng-container", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "span", 6);
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, MyAccountV2ConsentManagementFormComponent_span_9_Template, 3, 4, "span", 7);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("id", ctx.consentTemplate.id)("name", ctx.consentTemplate.id)("checked", ctx.consentGiven)("disabled", ctx.isRequired(ctx.consentTemplate == null ? null : ctx.consentTemplate.id));
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.consentTemplate.id);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.consentTemplate == null ? null : ctx.consentTemplate.name);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.consentTemplate == null ? null : ctx.consentTemplate.description, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.consentGiven);
        }
      },
      dependencies: [i3.NgIf, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ConsentManagementFormComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-consent-management-form',
      standalone: false,
      template: "<div class=\"form-check consent-container\">\n  <div class=\"\">\n    <label>\n      <input\n        type=\"checkbox\"\n        class=\"checkbox-input\"\n        [id]=\"consentTemplate.id\"\n        [name]=\"consentTemplate.id\"\n        [checked]=\"consentGiven\"\n        (change)=\"onConsentChange()\"\n        [disabled]=\"isRequired(consentTemplate?.id)\"\n      />\n      <label [for]=\"consentTemplate.id\"></label>\n      <span class=\"name\">\n        <ng-container *ngIf=\"consentTemplate?.name\">\n          {{ consentTemplate?.name }}\n        </ng-container>\n      </span>\n      <span class=\"description\">\n        {{ consentTemplate?.description }}\n      </span>\n      <span class=\"description\" *ngIf=\"consentGiven\">\n        {{ 'myAccountV2Consent.dateDescription' | cxTranslate\n        }}{{ consentApprovedTime }}\n      </span>\n    </label>\n  </div>\n</div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementComponent extends ConsentManagementComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2ConsentManagementComponent_BaseFactory;
      return function MyAccountV2ConsentManagementComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2ConsentManagementComponent_BaseFactory || (ɵMyAccountV2ConsentManagementComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2ConsentManagementComponent)))(__ngFactoryType__ || MyAccountV2ConsentManagementComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2ConsentManagementComponent,
      selectors: [["cx-my-account-v2-consent-management"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 4,
      vars: 4,
      consts: [["consentManagementForm", ""], [4, "ngIf", "ngIfElse"], [1, "cx-spinner"], ["role", "status", 4, "cxFeature"], [4, "ngIf"], ["role", "status"], [1, "cx-consent-toggles"], [1, "consent-form-container"], [1, "header"], [1, "cx-consent-action-links"], ["tabindex", "0", 1, "btn", "btn-link", "cx-action-link", 3, "click"], [3, "consentTemplate", "requiredConsents", "consentChanged", 4, "ngFor", "ngForOf"], [3, "consentChanged", "consentTemplate", "requiredConsents"]],
      template: function MyAccountV2ConsentManagementComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2ConsentManagementComponent_div_0_Template, 3, 0, "div", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, MyAccountV2ConsentManagementComponent_ng_template_2_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const consentManagementForm_r6 = i0.ɵɵreference(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.loading$))("ngIfElse", consentManagementForm_r6);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SpinnerComponent, i1.FeatureDirective, MyAccountV2ConsentManagementFormComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ConsentManagementComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-consent-management',
      standalone: false,
      template: "<div *ngIf=\"loading$ | async; else consentManagementForm\">\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</div>\n<ng-template #consentManagementForm>\n  <div\n    *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n    role=\"status\"\n    [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n  ></div>\n  <ng-container *ngIf=\"templateList$ | async as templateList\">\n    <div class=\"cx-consent-toggles\">\n      <div class=\"consent-form-container\">\n        <div class=\"header\">\n          {{ 'myAccountV2Consent.header' | cxTranslate }}\n        </div>\n        <div class=\"cx-consent-action-links\">\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"rejectAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.clearAll' | cxTranslate }}\n          </button>\n          <button\n            tabindex=\"0\"\n            class=\"btn btn-link cx-action-link\"\n            (click)=\"allowAll(templateList)\"\n          >\n            {{ 'myAccountV2Consent.selectAll' | cxTranslate }}\n          </button>\n        </div>\n        <cx-my-account-v2-consent-management-form\n          *ngFor=\"let consentTemplate of templateList\"\n          [consentTemplate]=\"consentTemplate\"\n          [requiredConsents]=\"requiredConsents\"\n          (consentChanged)=\"onConsentChange($event)\"\n        ></cx-my-account-v2-consent-management-form>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2ConsentManagementModule {
  static {
    this.ɵfac = function MyAccountV2ConsentManagementModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2ConsentManagementModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2ConsentManagementModule,
      declarations: [MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule],
      exports: [MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ConsentManagementComponentService],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2ConsentManagementModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule],
      providers: [ConsentManagementComponentService],
      declarations: [MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent],
      exports: [MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2CmsMapping$1 = {
  cmsComponents: {
    ConsentManagementComponent: {
      component: MyAccountV2ConsentManagementComponent
      //guards: inherited from standard config,
    }
  }
};
class ConsentManagementModule {
  static {
    this.ɵfac = function ConsentManagementModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ConsentManagementModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ConsentManagementModule,
      declarations: [ConsentManagementComponent, ConsentManagementFormComponent],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule],
      exports: [ConsentManagementComponent, ConsentManagementFormComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ConsentManagementComponentService, provideDefaultConfig({
        cmsComponents: {
          ConsentManagementComponent: {
            component: ConsentManagementComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_CONSENT) ? myAccountV2CmsMapping$1 : {})],
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConsentManagementModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, SpinnerModule, I18nModule, IconModule, FeaturesConfigModule],
      providers: [ConsentManagementComponentService, provideDefaultConfig({
        cmsComponents: {
          ConsentManagementComponent: {
            component: ConsentManagementComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_CONSENT) ? myAccountV2CmsMapping$1 : {})],
      declarations: [ConsentManagementComponent, ConsentManagementFormComponent],
      exports: [ConsentManagementComponent, ConsentManagementFormComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AtMessageModule {
  static {
    this.ɵfac = function AtMessageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AtMessageModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AtMessageModule,
      declarations: [AtMessageDirective],
      exports: [AtMessageDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AtMessageModule, [{
    type: NgModule,
    args: [{
      declarations: [AtMessageDirective],
      exports: [AtMessageDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessageComponentModule {
  static {
    this.ɵfac = function MessageComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MessageComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MessageComponentModule,
      declarations: [MessageComponent],
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, FeaturesConfigModule],
      exports: [MessageComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessageComponentModule, [{
    type: NgModule,
    args: [{
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, FeaturesConfigModule],
      declarations: [MessageComponent],
      exports: [MessageComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AnonymousConsentsDialogModule {
  static {
    this.ɵfac = function AnonymousConsentsDialogModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnonymousConsentsDialogModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AnonymousConsentsDialogModule,
      declarations: [AnonymousConsentDialogComponent],
      imports: [CommonModule, I18nModule, IconModule, SpinnerModule, ConsentManagementModule, KeyboardFocusModule, FeaturesConfigModule, MessageComponentModule],
      exports: [AnonymousConsentDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, IconModule, SpinnerModule, ConsentManagementModule, KeyboardFocusModule, FeaturesConfigModule, MessageComponentModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AnonymousConsentsDialogModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, IconModule, SpinnerModule, ConsentManagementModule, KeyboardFocusModule, FeaturesConfigModule, MessageComponentModule],
      declarations: [AnonymousConsentDialogComponent],
      exports: [AnonymousConsentDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var PopoverEvent;
(function (PopoverEvent) {
  PopoverEvent["INSIDE_CLICK"] = "insideClick";
  PopoverEvent["OUTSIDE_CLICK"] = "outsideClick";
  PopoverEvent["ESCAPE_KEYDOWN"] = "escapeKeydown";
  PopoverEvent["CLOSE_BUTTON_CLICK"] = "closeButtonClick";
  PopoverEvent["CLOSE_BUTTON_KEYDOWN"] = "closeButtonKeydown";
  PopoverEvent["ROUTE_CHANGE"] = "routeChange";
  PopoverEvent["OPEN"] = "open";
  PopoverEvent["OPEN_BY_KEYBOARD"] = "openByKeyboard";
})(PopoverEvent || (PopoverEvent = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PositioningService {
  constructor(winRef) {
    this.winRef = winRef;
  }
  get allowedPlacements() {
    return ['top', 'bottom', 'left', 'right', 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'left-top', 'left-bottom', 'right-top', 'right-bottom'];
  }
  get placementSeparator() {
    return /\s+/;
  }
  get window() {
    return this.winRef.nativeWindow;
  }
  get document() {
    return this.winRef.document;
  }
  getAllStyles(element) {
    return this.window?.getComputedStyle(element);
  }
  getPositionStyleProperty(element) {
    const styles = this.getAllStyles(element);
    if (styles) {
      return styles['position'] || undefined;
    }
  }
  isStaticPositioned(element) {
    return (this.getPositionStyleProperty(element) || 'static') === 'static';
  }
  offsetParent(element) {
    let offsetParentEl = element.offsetParent || this.document.documentElement;
    while (offsetParentEl && offsetParentEl !== this.document.documentElement && this.isStaticPositioned(offsetParentEl)) {
      offsetParentEl = offsetParentEl.offsetParent;
    }
    return offsetParentEl || this.document.documentElement;
  }
  position(element, round = true) {
    let elPosition;
    let parentOffset = {
      width: 0,
      height: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
    if (this.getPositionStyleProperty(element) === 'fixed') {
      elPosition = element.getBoundingClientRect();
      elPosition = {
        top: elPosition.top,
        bottom: elPosition.bottom,
        left: elPosition.left,
        right: elPosition.right,
        height: elPosition.height,
        width: elPosition.width
      };
    } else {
      const offsetParentEl = this.offsetParent(element);
      elPosition = this.offset(element, false);
      if (offsetParentEl !== this.document.documentElement) {
        parentOffset = this.offset(offsetParentEl, false);
      }
      parentOffset.top += offsetParentEl.clientTop;
      parentOffset.left += offsetParentEl.clientLeft;
    }
    elPosition.top -= parentOffset.top;
    elPosition.bottom -= parentOffset.top;
    elPosition.left -= parentOffset.left;
    elPosition.right -= parentOffset.left;
    if (round) {
      elPosition.top = Math.round(elPosition.top);
      elPosition.bottom = Math.round(elPosition.bottom);
      elPosition.left = Math.round(elPosition.left);
      elPosition.right = Math.round(elPosition.right);
    }
    return elPosition;
  }
  offset(element, round = true) {
    const elBcr = element.getBoundingClientRect();
    const viewportOffset = {
      top: this.window && this.window.pageYOffset - this.document.documentElement.clientTop || 0,
      left: this.window && this.window.pageXOffset - this.document.documentElement.clientLeft || 0
    };
    const elOffset = {
      height: elBcr.height || element.offsetHeight,
      width: elBcr.width || element.offsetWidth,
      top: elBcr.top + viewportOffset.top,
      bottom: elBcr.bottom + viewportOffset.top,
      left: elBcr.left + viewportOffset.left,
      right: elBcr.right + viewportOffset.left
    };
    if (round) {
      elOffset.height = Math.round(elOffset.height);
      elOffset.width = Math.round(elOffset.width);
      elOffset.top = Math.round(elOffset.top);
      elOffset.bottom = Math.round(elOffset.bottom);
      elOffset.left = Math.round(elOffset.left);
      elOffset.right = Math.round(elOffset.right);
    }
    return elOffset;
  }
  /*
    Return false if the element to position is outside the viewport.
  */
  _positionElements(hostElement, targetElement, placement, appendToBody) {
    const [placementPrimary = 'top', placementSecondary = 'center'] = placement.split('-');
    const hostElPosition = appendToBody ? this.offset(hostElement, false) : this.position(hostElement, false);
    const targetElStyles = this.getAllStyles(targetElement);
    if (targetElStyles) {
      const marginTop = parseFloat(targetElStyles.marginTop);
      const marginBottom = parseFloat(targetElStyles.marginBottom);
      const marginLeft = parseFloat(targetElStyles.marginLeft);
      const marginRight = parseFloat(targetElStyles.marginRight);
      let topPosition = 0;
      let leftPosition = 0;
      switch (placementPrimary) {
        case 'top':
          topPosition = hostElPosition.top - (targetElement.offsetHeight + marginTop + marginBottom);
          break;
        case 'bottom':
          topPosition = hostElPosition.top + hostElPosition.height;
          break;
        case 'left':
          leftPosition = hostElPosition.left - (targetElement.offsetWidth + marginLeft + marginRight);
          break;
        case 'right':
          leftPosition = hostElPosition.left + hostElPosition.width;
          break;
      }
      switch (placementSecondary) {
        case 'top':
          topPosition = hostElPosition.top;
          break;
        case 'bottom':
          topPosition = hostElPosition.top + hostElPosition.height - targetElement.offsetHeight;
          break;
        case 'left':
          leftPosition = hostElPosition.left;
          break;
        case 'right':
          leftPosition = hostElPosition.left + hostElPosition.width - targetElement.offsetWidth;
          break;
        case 'center':
          if (placementPrimary === 'top' || placementPrimary === 'bottom') {
            leftPosition = hostElPosition.left + hostElPosition.width / 2 - targetElement.offsetWidth / 2;
          } else {
            topPosition = hostElPosition.top + hostElPosition.height / 2 - targetElement.offsetHeight / 2;
          }
          break;
      }
      targetElement.style.transform = `translate(${Math.round(leftPosition)}px, ${Math.round(topPosition)}px)`;
      // Check if the targetElement is inside the viewport
      const targetElBCR = targetElement.getBoundingClientRect();
      const html = this.document.documentElement;
      const windowHeight = this.window?.innerHeight || html.clientHeight;
      const windowWidth = this.window?.innerWidth || html.clientWidth;
      return targetElBCR.left >= 0 && targetElBCR.top >= 0 && targetElBCR.right <= windowWidth && targetElBCR.bottom <= windowHeight;
    }
    return false;
  }
  /*
   * Accept the placement array and applies the appropriate placement dependent on the viewport.
   * Returns the applied placement.
   * In case of auto placement, placements are selected in order
   *   'top', 'bottom', 'left', 'right',
   *   'top-left', 'top-right',
   *   'bottom-left', 'bottom-right',
   *   'left-top', 'left-bottom',
   *   'right-top', 'right-bottom'.
   * */
  positionElements(hostElement, targetElement, placement, appendToBody) {
    const placementVals = Array.isArray(placement) ? placement : placement.split(this.placementSeparator);
    let hasAuto = placementVals.findIndex(val => val === 'auto');
    if (hasAuto >= 0) {
      this.allowedPlacements.forEach(obj => {
        if (placementVals.find(val => val.search('^' + obj) !== -1) == null) {
          placementVals.splice(hasAuto++, 1, obj);
        }
      });
    }
    const style = targetElement.style;
    style.position = 'absolute';
    style.top = '0';
    style.left = '0';
    let testPlacement = 'auto';
    let isInViewport = false;
    for (testPlacement of placementVals) {
      if (this._positionElements(hostElement, targetElement, testPlacement, appendToBody)) {
        isInViewport = true;
        break;
      }
    }
    if (!isInViewport) {
      this._positionElements(hostElement, targetElement, testPlacement, appendToBody);
    }
    return testPlacement;
  }
  getPositioningClass(position, autoPositioning) {
    let positionClass = `${position || 'top'}`;
    if (autoPositioning && positionClass !== 'auto') {
      positionClass = `${positionClass} auto`;
    }
    return positionClass;
  }
  static {
    this.ɵfac = function PositioningService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PositioningService)(i0.ɵɵinject(i1.WindowRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PositioningService,
      factory: PositioningService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PositioningService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverComponent {
  /**
   * Listens for click inside popover component wrapper.
   */
  insideClick() {
    this.eventSubject.next(PopoverEvent.INSIDE_CLICK);
  }
  /**
   * Listens for every document click and ignores clicks
   * inside component.
   */
  outsideClick(event) {
    if (!this.isClickedOnPopover(event) && !this.isClickedOnDirective(event)) {
      this.eventSubject.next(PopoverEvent.OUTSIDE_CLICK);
    }
  }
  /**
   * Listens for `escape` keydown event.
   */
  escapeKeydown() {
    this.eventSubject.next(PopoverEvent.ESCAPE_KEYDOWN);
  }
  isClickedOnPopover(event) {
    return this.popoverInstance.location.nativeElement.contains(event.target);
  }
  isClickedOnDirective(event) {
    return this.triggerElement.nativeElement.contains(event.target);
  }
  /**
   * Emits close event trigger.
   */
  close(event) {
    event.preventDefault();
    if (event instanceof MouseEvent) {
      this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_CLICK);
    } else {
      this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
    }
  }
  /**
   * Method uses `Renderer2` service to listen window scroll event.
   *
   * Registered only if property `positionOnScroll` is set to `true`.
   */
  triggerScrollEvent() {
    this.scrollEventUnlistener = this.renderer.listen(this.winRef.nativeWindow, 'scroll', () => this.positionPopover());
  }
  /**
   * Method uses positioning service calculation and based on that
   * updates class name for popover component instance.
   */
  positionPopover() {
    this.popoverClass = this.positioningService.positionElements(this.triggerElement.nativeElement, this.popoverInstance.location.nativeElement, this.positioningService.getPositioningClass(this.position, this.autoPositioning), this.appendToBody);
    this.changeDetectionRef.markForCheck();
    this.baseClass = `${this.customClass} ${this.popoverClass} opened`;
  }
  ngOnInit() {
    if (!this.customClass) {
      this.customClass = 'cx-popover';
    }
    if (!this.position) {
      this.position = 'top';
    }
    if (this.autoPositioning === undefined) {
      this.autoPositioning = true;
    }
    this.baseClass = `${this.customClass}`;
    this.resizeSub = this.winRef.resize$.subscribe(() => {
      this.positionPopover();
    });
    this.routeChangeSub = this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.eventSubject.next(PopoverEvent.ROUTE_CHANGE);
    });
    if (this.positionOnScroll) {
      this.triggerScrollEvent();
    }
  }
  /**
   * indicates if passed content is a TemplateRef or string.
   */
  isTemplate(content) {
    return content instanceof TemplateRef;
  }
  isString(content) {
    return !(content instanceof TemplateRef);
  }
  ngAfterViewChecked() {
    this.positionPopover();
  }
  ngOnDestroy() {
    if (this.resizeSub) {
      this.resizeSub.unsubscribe();
    }
    if (this.routeChangeSub) {
      this.routeChangeSub.unsubscribe();
    }
    if (this.scrollEventUnlistener) {
      this.scrollEventUnlistener();
    }
  }
  constructor(positioningService, winRef, changeDetectionRef, renderer, router) {
    this.positioningService = positioningService;
    this.winRef = winRef;
    this.changeDetectionRef = changeDetectionRef;
    this.renderer = renderer;
    this.router = router;
    /**
     * Icon types for close button icon.
     */
    this.iconTypes = ICON_TYPE;
  }
  static {
    this.ɵfac = function PopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverComponent)(i0.ɵɵdirectiveInject(PositioningService), i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$2.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PopoverComponent,
      selectors: [["cx-popover"]],
      hostVars: 1,
      hostBindings: function PopoverComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function PopoverComponent_click_HostBindingHandler() {
            return ctx.insideClick();
          })("click", function PopoverComponent_click_HostBindingHandler($event) {
            return ctx.outsideClick($event);
          }, false, i0.ɵɵresolveDocument)("keydown.escape", function PopoverComponent_keydown_escape_HostBindingHandler() {
            return ctx.escapeKeydown();
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("className", ctx.baseClass);
        }
      },
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [[1, "arrow"], [1, "popover-body", 3, "cxFocus"], [1, "cx-close-row"], ["type", "button", "class", "close", 3, "title", "keydown.enter", "keydown.space", "click", 4, "ngIf"], [4, "ngIf"], ["type", "button", 1, "close", 3, "keydown.enter", "keydown.space", "click", "title"], [3, "type"], [4, "ngTemplateOutlet"]],
      template: function PopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, PopoverComponent_button_3_Template, 4, 7, "button", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, PopoverComponent_ng_container_4_Template, 2, 1, "ng-container", 4)(5, PopoverComponent_span_5_Template, 2, 1, "span", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.displayCloseButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isTemplate(ctx.content));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isString(ctx.content));
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet, FocusDirective, IconComponent, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverComponent, [{
    type: Component,
    args: [{
      selector: 'cx-popover',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"arrow\"></div>\n<div class=\"popover-body\" [cxFocus]=\"focusConfig\">\n  <div class=\"cx-close-row\">\n    <button\n      *ngIf=\"displayCloseButton\"\n      type=\"button\"\n      class=\"close\"\n      attr.aria-label=\"{{ 'common.close' | cxTranslate }}\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (keydown.enter)=\"close($event)\"\n      (keydown.space)=\"close($event)\"\n      (click)=\"close($event)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <ng-container *ngIf=\"isTemplate(content)\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </ng-container>\n  <span *ngIf=\"isString(content)\">{{ content }}</span>\n</div>\n"
    }]
  }], () => [{
    type: PositioningService
  }, {
    type: i1.WindowRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }, {
    type: i1$2.Router
  }], {
    baseClass: [{
      type: HostBinding,
      args: ['className']
    }],
    insideClick: [{
      type: HostListener,
      args: ['click']
    }],
    outsideClick: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }],
    escapeKeydown: [{
      type: HostListener,
      args: ['keydown.escape']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverService {
  /**
   * For a11y improvements method returns different `FocusConfig`
   * based on which event popover was triggered.
   */
  getFocusConfig(event, appendToBody) {
    let config = {};
    if (event === PopoverEvent.OPEN_BY_KEYBOARD && appendToBody) {
      config = {
        trap: true,
        block: true,
        focusOnEscape: false,
        autofocus: true
      };
    }
    return config;
  }
  setFocusOnElement(element) {
    setTimeout(() => {
      element.nativeElement.focus();
    }, 0);
  }
  static {
    this.ɵfac = function PopoverService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PopoverService,
      factory: PopoverService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to bind popover with any DOM element.
 */
class PopoverDirective {
  /**
   * Listen events fired on element binded to popover directive.
   *
   * Based on event type some a11y improvements can be made.
   * For example if popover was opened by `space` or `enter` key
   * dedicated `FocusConfig` can be set to autofocus first
   * focusable element in popover container.
   */
  handlePress(event) {
    event?.preventDefault();
    if (event?.target === this.element.nativeElement && !this.isOpen) {
      this.eventSubject.next(PopoverEvent.OPEN_BY_KEYBOARD);
    } else if (this.isOpen) {
      this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
    }
  }
  handleTab() {
    if (!this.focusConfig?.trap && this.isOpen) {
      this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_KEYDOWN);
    }
  }
  handleEscape() {
    this.eventSubject.next(PopoverEvent.ESCAPE_KEYDOWN);
  }
  handleClick(event) {
    event?.preventDefault();
    if (event?.target === this.element.nativeElement && !this.isOpen) {
      this.eventSubject.next(PopoverEvent.OPEN);
    } else if (this.isOpen) {
      this.eventSubject.next(PopoverEvent.CLOSE_BUTTON_CLICK);
    }
  }
  /**
   * Method performs open action for popover component.
   */
  open(event) {
    if (!this.cxPopoverOptions?.disable) {
      this.isOpen = true;
      this.focusConfig = this.popoverService.getFocusConfig(event, this.cxPopoverOptions?.appendToBody || false);
      this.renderPopover();
      this.openPopover.emit();
    }
  }
  /**
   * Method performs close action for popover component.
   */
  close() {
    this.isOpen = false;
    this.viewContainer.clear();
    this.closePopover.emit();
  }
  /**
   * Method subscribes for events emitted by popover component
   * and based on event performs specific action.
   */
  handlePopoverEvents() {
    this.eventSubject.subscribe(event => {
      if (this.openTriggerEvents.includes(event)) {
        this.open(event);
      }
      if (this.focusPopoverTriggerEvents.includes(event)) {
        this.popoverContainer.location.nativeElement.focus();
      }
      if (this.closeTriggerEvents.includes(event)) {
        this.close();
      }
      if (this.focusDirectiveTriggerEvents.includes(event)) {
        this.popoverService.setFocusOnElement(this.element);
      }
    });
  }
  /**
   * Method creates instance and pass parameters to popover component.
   */
  renderPopover() {
    const containerFactory = this.componentFactoryResolver.resolveComponentFactory(PopoverComponent);
    this.popoverContainer = this.viewContainer.createComponent(containerFactory);
    const componentInstance = this.popoverContainer.instance;
    if (componentInstance) {
      componentInstance.content = this.cxPopover;
      componentInstance.triggerElement = this.element;
      componentInstance.popoverInstance = this.popoverContainer;
      componentInstance.focusConfig = this.focusConfig;
      componentInstance.eventSubject = this.eventSubject;
      componentInstance.position = this.cxPopoverOptions?.placement;
      componentInstance.customClass = this.cxPopoverOptions?.class;
      componentInstance.appendToBody = this.cxPopoverOptions?.appendToBody;
      componentInstance.positionOnScroll = this.cxPopoverOptions?.positionOnScroll;
      componentInstance.displayCloseButton = this.cxPopoverOptions?.displayCloseButton;
      componentInstance.autoPositioning = this.cxPopoverOptions?.autoPositioning;
      if (this.cxPopoverOptions?.appendToBody) {
        const body = this.winRef.document.body;
        const element = this.featureConfigService?.isEnabled('a11yPopoverHighContrast') ?
        // we need to select first child element if exists,
        // otherwise HCT theming in popover will not be picked up.
        body.firstElementChild ?? body : body;
        this.renderer.appendChild(element, this.popoverContainer.location.nativeElement);
      }
      this.popoverContainer.changeDetectorRef.detectChanges();
    }
  }
  ngOnInit() {
    this.handlePopoverEvents();
  }
  constructor(element, viewContainer, componentFactoryResolver, renderer, changeDetectorRef, popoverService, winRef) {
    this.element = element;
    this.viewContainer = viewContainer;
    this.componentFactoryResolver = componentFactoryResolver;
    this.renderer = renderer;
    this.changeDetectorRef = changeDetectorRef;
    this.popoverService = popoverService;
    this.winRef = winRef;
    /**
     * An event emitted when the popover is opened.
     */
    this.openPopover = new EventEmitter();
    /**
     * An event emitted when the popover is closed.
     */
    this.closePopover = new EventEmitter();
    /**
     * Subject which emits specific type of `PopoverEvent`.
     */
    this.eventSubject = new Subject();
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
    this.openTriggerEvents = [PopoverEvent.OPEN, PopoverEvent.OPEN_BY_KEYBOARD];
    this.focusPopoverTriggerEvents = [PopoverEvent.OPEN_BY_KEYBOARD];
    this.closeTriggerEvents = [PopoverEvent.ROUTE_CHANGE, PopoverEvent.ESCAPE_KEYDOWN, PopoverEvent.OUTSIDE_CLICK, PopoverEvent.CLOSE_BUTTON_KEYDOWN, PopoverEvent.CLOSE_BUTTON_CLICK];
    this.focusDirectiveTriggerEvents = [PopoverEvent.ESCAPE_KEYDOWN, PopoverEvent.CLOSE_BUTTON_KEYDOWN];
  }
  static {
    this.ɵfac = function PopoverDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PopoverService), i0.ɵɵdirectiveInject(i1.WindowRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PopoverDirective,
      selectors: [["", "cxPopover", ""]],
      hostBindings: function PopoverDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.enter", function PopoverDirective_keydown_enter_HostBindingHandler($event) {
            return ctx.handlePress($event);
          })("keydown.space", function PopoverDirective_keydown_space_HostBindingHandler($event) {
            return ctx.handlePress($event);
          })("keydown.tab", function PopoverDirective_keydown_tab_HostBindingHandler() {
            return ctx.handleTab();
          })("keydown.shift.tab", function PopoverDirective_keydown_shift_tab_HostBindingHandler() {
            return ctx.handleTab();
          })("keydown.escape", function PopoverDirective_keydown_escape_HostBindingHandler() {
            return ctx.handleEscape();
          })("click", function PopoverDirective_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      inputs: {
        cxPopover: "cxPopover",
        cxPopoverOptions: "cxPopoverOptions"
      },
      outputs: {
        openPopover: "openPopover",
        closePopover: "closePopover"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverDirective, [{
    type: Directive,
    args: [{
      selector: '[cxPopover]',
      standalone: false
    }]
  }], () => [{
    type: i0.ElementRef
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i0.ComponentFactoryResolver
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: PopoverService
  }, {
    type: i1.WindowRef
  }], {
    cxPopover: [{
      type: Input
    }],
    cxPopoverOptions: [{
      type: Input
    }],
    openPopover: [{
      type: Output
    }],
    closePopover: [{
      type: Output
    }],
    handlePress: [{
      type: HostListener,
      args: ['keydown.enter', ['$event']]
    }, {
      type: HostListener,
      args: ['keydown.space', ['$event']]
    }],
    handleTab: [{
      type: HostListener,
      args: ['keydown.tab']
    }, {
      type: HostListener,
      args: ['keydown.shift.tab']
    }],
    handleEscape: [{
      type: HostListener,
      args: ['keydown.escape']
    }],
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }],
    featureConfigService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultLimit = 20;
class TruncatePipe {
  /**
   * example usage {{ exampleString | cxTruncate: [1, ''] }}
   */
  transform(value, args) {
    if (!args) {
      return value;
    }
    let trail = '...';
    const limit = args.length > 0 && args[0] && Number.isInteger(+args[0]) ? args[0] : defaultLimit;
    if (args.length > 1 && args[1] !== undefined) {
      trail = args[1];
    }
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
  static {
    this.ɵfac = function TruncatePipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TruncatePipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cxTruncate",
      type: TruncatePipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncatePipe, [{
    type: Pipe,
    args: [{
      name: 'cxTruncate',
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TruncateTextPopoverComponent {
  constructor() {
    /**
     * The maximum length of the characters after which the text will be truncated
     */
    this.charactersLimit = 100;
  }
  get isTruncated() {
    return this.content.length > +this.charactersLimit;
  }
  static {
    this.ɵfac = function TruncateTextPopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TruncateTextPopoverComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TruncateTextPopoverComponent,
      selectors: [["cx-truncate-text-popover"]],
      inputs: {
        content: "content",
        charactersLimit: "charactersLimit",
        customClass: "customClass"
      },
      standalone: false,
      decls: 8,
      vars: 8,
      consts: [["fullText", ""], [1, "truncated-text", 3, "ngClass"], ["class", "ml-1 link cx-action-link", 3, "cxPopover", "cxPopoverOptions", 4, "ngIf"], [1, "ml-1", "link", "cx-action-link", 3, "cxPopover", "cxPopoverOptions"]],
      template: function TruncateTextPopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementContainerStart(0)(1);
          i0.ɵɵelementStart(2, "span", 1);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTruncate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementContainerEnd();
          i0.ɵɵtemplate(5, TruncateTextPopoverComponent_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(7, TruncateTextPopoverComponent_button_7_Template, 3, 6, "button", 2);
          i0.ɵɵelementContainerEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", ctx.customClass);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 3, ctx.content, i0.ɵɵpureFunction1(6, _c14, ctx.charactersLimit)), " ");
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.isTruncated);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, PopoverDirective, i1.TranslatePipe, TruncatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncateTextPopoverComponent, [{
    type: Component,
    args: [{
      selector: 'cx-truncate-text-popover',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container>\n  <ng-container>\n    <span class=\"truncated-text\" [ngClass]=\"customClass\">\n      {{ content | cxTruncate: [charactersLimit] }}\n    </span>\n  </ng-container>\n\n  <ng-template #fullText>\n    {{ content }}\n  </ng-template>\n\n  <button\n    *ngIf=\"isTruncated\"\n    [cxPopover]=\"fullText\"\n    [cxPopoverOptions]=\"{\n      placement: 'auto',\n      appendToBody: true,\n      displayCloseButton: true,\n    }\"\n    class=\"ml-1 link cx-action-link\"\n  >\n    {{ 'common.more' | cxTranslate }}\n  </button>\n</ng-container>\n"
    }]
  }], null, {
    content: [{
      type: Input
    }],
    charactersLimit: [{
      type: Input
    }],
    customClass: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GenericLinkComponentService {
  constructor() {
    /**
     * Pattern matching string starting with `http://` or `https://`.
     */
    this.HTTP_PROTOCOL_REGEX = /^https?:\/\//i;
    /**
     * Pattern matching string starting with `mailto:`.
     */
    this.MAILTO_PROTOCOL_REGEX = /^mailto:/i;
    /**
     * Pattern matching string starting with `tel:`.
     */
    this.TEL_PROTOCOL_REGEX = /^tel:/i;
  }
  /**
   * Returns true when the @Input `url` is a string starting with `http://`, `https://`, `mailto:`, `tel:`.
   */
  isExternalUrl(url) {
    return typeof url === 'string' && (this.HTTP_PROTOCOL_REGEX.test(url) || this.MAILTO_PROTOCOL_REGEX.test(url) || this.TEL_PROTOCOL_REGEX.test(url));
  }
  static {
    this.ɵfac = function GenericLinkComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GenericLinkComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GenericLinkComponentService,
      factory: GenericLinkComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericLinkComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * This component navigates using [routerLink] attribute when input 'url' is a relative url. Otherwise (when it's absolute), [href] is used.
 */
class GenericLinkComponent {
  constructor(router, service) {
    this.router = router;
    this.service = service;
    /**
     * Used to split url into 2 parts:
     * 1. the path
     * 2. query params + hash fragment
     */
    this.URL_SPLIT = /(^[^#?]*)(.*)/;
    /**
     * Parsed parts of the @Input `url`, when it's a local URL.
     * It should not be used when the `url` is external.
     * @see `url`
     */
    this.routeParts = {};
    this.tabindex = 0;
  }
  isExternalUrl() {
    return this.service.isExternalUrl(this.url);
  }
  get rel() {
    return this.target === '_blank' ? 'noopener' : null;
  }
  ngOnChanges(changes) {
    if (changes['url']) {
      this.setUrlParts(changes['url'].currentValue);
    }
  }
  /**
   * The part with the path of the local url.
   */
  get routerUrl() {
    return this.routeParts.path;
  }
  /**
   * The part with the query params of the local url.
   */
  get queryParams() {
    return this.routeParts.queryParams;
  }
  /**
   * The part with the hash fragment of the local url.
   */
  get fragment() {
    return this.routeParts.fragment ?? undefined;
  }
  /**
   * Parses the given url and sets the property `urlParts` accordingly.
   */
  setUrlParts(url) {
    if (typeof url === 'string') {
      url = this.getAbsoluteUrl(url); // string links in CMS sometimes don't have the leading slash, so fix it here
      this.routeParts = this.splitUrl(url);
    } else {
      this.routeParts = {
        path: url
      };
    }
  }
  /**
   * Parses the given string into 3 parts:
   * - string path (wrapped in an array to be compatible with Angular syntax for the `routerLink`)
   * - query params (as an object)
   * - hash fragment (string)
   */
  splitUrl(url = '') {
    const {
      queryParams,
      fragment
    } = this.router.parseUrl(url);
    const [, path] = url.match(this.URL_SPLIT) ?? [, ''];
    // wrap path in an array, to have the Angular-like path format
    return {
      path: [path ?? ''],
      queryParams,
      fragment
    };
  }
  /**
   * Prepends a leading slash to the given URL string, in case it doesn't have it.
   */
  getAbsoluteUrl(url) {
    return url.startsWith('/') ? url : '/' + url;
  }
  static {
    this.ɵfac = function GenericLinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GenericLinkComponent)(i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(GenericLinkComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GenericLinkComponent,
      selectors: [["cx-generic-link"]],
      inputs: {
        url: "url",
        target: "target",
        id: "id",
        class: "class",
        style: "style",
        title: "title",
        ariaLabel: "ariaLabel",
        tabindex: "tabindex"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c1,
      decls: 5,
      vars: 2,
      consts: [["isLocalUrl", ""], ["content", ""], [4, "ngIf", "ngIfElse"], [3, "href", "tabindex"], [4, "ngTemplateOutlet"], [3, "routerLink", "queryParams", "fragment", "target", "tabindex"]],
      template: function GenericLinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, GenericLinkComponent_ng_container_0_Template, 3, 10, "ng-container", 2)(1, GenericLinkComponent_ng_template_1_Template, 2, 11, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, GenericLinkComponent_ng_template_3_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const isLocalUrl_r3 = i0.ɵɵreference(2);
          i0.ɵɵproperty("ngIf", ctx.isExternalUrl())("ngIfElse", isLocalUrl_r3);
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet, i1$2.RouterLink],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericLinkComponent, [{
    type: Component,
    args: [{
      selector: 'cx-generic-link',
      standalone: false,
      template: "<!-- https://github.com/angular/angular/issues/24567 -->\n\n<ng-container *ngIf=\"isExternalUrl(); else isLocalUrl\">\n  <a\n    [href]=\"url\"\n    [attr.target]=\"target\"\n    [attr.rel]=\"rel\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-container>\n\n<ng-template #isLocalUrl>\n  <a\n    [routerLink]=\"routerUrl\"\n    [queryParams]=\"queryParams\"\n    [fragment]=\"fragment\"\n    [target]=\"target || undefined\"\n    [attr.id]=\"id\"\n    [attr.class]=\"class\"\n    [attr.style]=\"style\"\n    [attr.title]=\"title\"\n    [attr.aria-label]=\"ariaLabel ? ariaLabel : null\"\n    [tabindex]=\"tabindex\"\n  >\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n  </a>\n</ng-template>\n\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$2.Router
  }, {
    type: GenericLinkComponentService
  }], {
    url: [{
      type: Input
    }],
    target: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    style: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    tabindex: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CardComponent {
  // ACTIONS
  setEditMode() {
    this.editMode = true;
  }
  cancelEdit() {
    this.editMode = false;
    this.cancelCard.emit(5);
  }
  delete() {
    this.deleteCard.emit(1);
  }
  setDefault() {
    this.isDefault = true;
    this.setDefaultCard.emit(2);
  }
  send() {
    this.sendCard.emit(3);
  }
  edit() {
    this.editCard.emit(4);
  }
  isCardAction(action) {
    return action.event !== undefined;
  }
  isCardLinkAction(action) {
    return action.link !== undefined;
  }
  trackByIndex(index) {
    return index;
  }
  constructor() {
    this.iconTypes = ICON_TYPE;
    this.deleteCard = new EventEmitter();
    this.setDefaultCard = new EventEmitter();
    this.sendCard = new EventEmitter();
    this.editCard = new EventEmitter();
    this.cancelCard = new EventEmitter();
    this.border = false;
    this.editMode = false;
    this.isDefault = false;
    this.fitToContainer = false;
    this.truncateText = false;
    this.truncateParagraphText = false;
    this.charactersLimit = 100;
    // Intentional empty constructor
  }
  /* eslint @angular-eslint/no-empty-lifecycle-method: 1 */
  ngOnInit() {
    // Intentional empty method
  }
  get isHeaderVisible() {
    return !!this.content?.header && !this.editMode;
  }
  /**
   * ariaDescribedBy: Computes the value for the 'aria-describedby' attribute.
   * If `content` has a `title`, it returns a string including the title and container IDs, with index if available.
   * If no title, it returns only the container ID with the index if available.
   *
   * @returns {string} The 'aria-describedby' value.
   */
  get ariaDescribedBy() {
    if (this.content && this.content.title) {
      return `${this.getLabel('content-title')} ${this.getLabel('cx-card-container')}`;
    }
    return `${this.getLabel('cx-card-container')}`;
  }
  /**
   * getLabel: Computes a label string by concatenating the provided prefix with the index.
   * If the index is greater than or equal to 0, it appends the index to the prefix; otherwise, it just returns the prefix.
   *
   * @param {string} prefix - The string to prefix to the label.
   * @returns {string} The computed label, including the index if it's available.
   */
  getLabel(prefix) {
    return prefix + (this.index >= 0 ? '-' + this.index : '');
  }
  static {
    this.ɵfac = function CardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CardComponent,
      selectors: [["cx-card"]],
      inputs: {
        border: "border",
        editMode: "editMode",
        isDefault: "isDefault",
        content: "content",
        fitToContainer: "fitToContainer",
        truncateText: "truncateText",
        truncateParagraphText: "truncateParagraphText",
        charactersLimit: "charactersLimit",
        index: "index",
        role: "role"
      },
      outputs: {
        deleteCard: "deleteCard",
        setDefaultCard: "setDefaultCard",
        sendCard: "sendCard",
        editCard: "editCard",
        cancelCard: "cancelCard"
      },
      standalone: false,
      ngContentSelectors: _c17,
      decls: 3,
      vars: 1,
      consts: [["showText", ""], ["class", "cx-card", 3, "tabindex", "cx-card-border", "cx-card-fit-to-container", 4, "ngIf"], [1, "cx-card", 3, "tabindex"], ["class", "card-header", 3, "id", 4, "ngIf"], [1, "card-body", "cx-card-body"], ["role", "alert", "class", "cx-card-delete-msg", 4, "ngIf"], ["class", "cx-card-title", 3, "id", 4, "ngIf"], [1, "cx-card-container", 3, "id"], [1, "cx-card-label-container"], ["class", "cx-card-label-bold", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "cx-card-paragraph", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "cx-card-img-container", "role", "img", 4, "ngIf"], ["class", "row cx-card-body-delete", 4, "ngIf"], ["class", "cx-card-actions", 4, "ngIf"], [1, "card-header", 3, "id"], ["role", "alert", 1, "cx-card-delete-msg"], [1, "cx-card-title", 3, "id"], [1, "cx-card-label-bold"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cx-card-paragraph"], [1, "cx-card-paragraph-title"], ["role", "img", 1, "cx-card-img-container"], [3, "type"], [1, "row", "cx-card-body-delete"], ["class", "row col-md-12", 4, "cxFeature"], [1, "row", "col-md-12"], [1, "col-md-6", 3, "cxFocus"], [1, "btn", "btn-block", "btn-primary", 3, "click"], [1, "col-md-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click", "cxAtMessage"], [1, "cx-card-actions"], [4, "cxFeature"], [3, "ngSwitch", 4, "ngIf"], ["class", "link cx-action-link", 3, "href", 4, "ngIf"], [3, "ngSwitch"], ["type", "button", "class", "link cx-action-link", 3, "click", 4, "ngSwitchCase"], ["type", "button", 1, "link", "cx-action-link", 3, "click"], [1, "link", "cx-action-link", 3, "href"], ["class", "cx-card-action-item", 4, "ngFor", "ngForOf"], [1, "cx-card-action-item"], [3, "url", "ariaLabel", "target", 4, "ngIf"], ["type", "button", "class", "btn btn-tertiary", 3, "click", 4, "ngSwitchCase"], ["type", "button", 1, "btn", "btn-tertiary", 3, "click"], [3, "url", "ariaLabel", "target"], [3, "class", "ngClass", 4, "ngIf"], [3, "charactersLimit", "content", "customClass", 4, "ngIf"], [3, "ngClass"], [3, "charactersLimit", "content", "customClass"]],
      template: function CardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c16);
          i0.ɵɵtemplate(0, CardComponent_div_0_Template, 14, 21, "div", 1)(1, CardComponent_ng_template_1_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.content);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgSwitch, i3.NgSwitchCase, AtMessageDirective, IconComponent, TruncateTextPopoverComponent, FocusDirective, i1.FeatureDirective, GenericLinkComponent, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardComponent, [{
    type: Component,
    args: [{
      selector: 'cx-card',
      standalone: false,
      template: "<div\n  *ngIf=\"content\"\n  class=\"cx-card\"\n  [tabindex]=\"border ? 0 : -1\"\n  [attr.role]=\"role\"\n  [attr.aria-labelledby]=\"isHeaderVisible ? getLabel('content-header') : null\"\n  [attr.aria-describedby]=\"ariaDescribedBy\"\n  [class.cx-card-border]=\"border\"\n  [class.cx-card-fit-to-container]=\"fitToContainer\"\n>\n  <!-- Card Header -->\n  <div\n    *ngIf=\"isHeaderVisible\"\n    class=\"card-header\"\n    [id]=\"getLabel('content-header')\"\n  >\n    {{ content.header }}\n  </div>\n  <!-- Card Body -->\n  <div class=\"card-body cx-card-body\" [class.cx-card-delete]=\"editMode\">\n    <!-- Edit message -->\n    <div *ngIf=\"editMode\" role=\"alert\" class=\"cx-card-delete-msg\">\n      {{ content.deleteMsg }}\n    </div>\n    <!-- Card title -->\n    <span\n      *ngIf=\"content.title\"\n      class=\"cx-card-title\"\n      [id]=\"getLabel('content-title')\"\n    >\n      {{ content.title }}\n    </span>\n    <!-- Card Content -->\n    <div class=\"cx-card-container\" [id]=\"getLabel('cx-card-container')\">\n      <!-- Card Label -->\n      <div class=\"cx-card-label-container\">\n        <div *ngIf=\"content.textBold\" class=\"cx-card-label-bold\">\n          {{ content.textBold }}\n        </div>\n        <div *ngFor=\"let line of content.text\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              showText;\n              context: {\n                content: content,\n                truncateText: truncateText,\n                charactersLimit: charactersLimit,\n                class: 'cx-card-label',\n                text: line,\n              }\n            \"\n          >\n          </ng-container>\n        </div>\n        <div\n          class=\"cx-card-paragraph\"\n          *ngFor=\"let item of content.paragraphs; trackBy: trackByIndex\"\n        >\n          <div class=\"cx-card-paragraph-title\">{{ item.title }}</div>\n          <div *ngFor=\"let text of item.text\">\n            <ng-container\n              *ngTemplateOutlet=\"\n                showText;\n                context: {\n                  content: content,\n                  truncateText: truncateParagraphText,\n                  charactersLimit: charactersLimit,\n                  class: 'cx-card-paragraph-text',\n                  text: text,\n                }\n              \"\n            >\n            </ng-container>\n          </div>\n        </div>\n        <ng-content select=\"[label_container_bottom]\"></ng-content>\n      </div>\n      <!-- Image -->\n      <div\n        *ngIf=\"content.img\"\n        class=\"cx-card-img-container\"\n        [attr.aria-label]=\"\n          content.imgLabel ?? 'paymentCard.credit' | cxTranslate\n        \"\n        role=\"img\"\n        [attr.title]=\"content.imgLabel ?? 'paymentCard.credit' | cxTranslate\"\n      >\n        <cx-icon [type]=\"content.img\"></cx-icon>\n      </div>\n    </div>\n    <!-- Edit Mode Actions -->\n    <div *ngIf=\"editMode\" class=\"row cx-card-body-delete\">\n      <div class=\"row col-md-12\" *cxFeature=\"'a11yDeleteButton2First'\">\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n      <div class=\"row col-md-12\" *cxFeature=\"'!a11yDeleteButton2First'\">\n        <div class=\"col-md-6\">\n          <button\n            [cxAtMessage]=\"'assistiveMessage.actionCancelled' | cxTranslate\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelEdit()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-md-6\" [cxFocus]=\"{ autofocus: true }\">\n          <button class=\"btn btn-block btn-primary\" (click)=\"delete()\">\n            {{ 'common.delete' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n    <!-- Actions -->\n    <div *ngIf=\"content.actions && !editMode\" class=\"cx-card-actions\">\n      <ng-container *cxFeature=\"'!a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"link cx-action-link\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"link cx-action-link\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"link cx-action-link\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"link cx-action-link\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <a\n              *ngIf=\"isCardLinkAction(action)\"\n              href=\"{{ action.link }}\"\n              class=\"link cx-action-link\"\n            >\n              {{ action.name }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n      <ng-container *cxFeature=\"'a11yImproveButtonsInCardComponent'\">\n        <div *ngFor=\"let action of content.actions\" class=\"cx-card-action-item\">\n          <div>\n            <ng-container\n              *ngIf=\"isCardAction(action)\"\n              [ngSwitch]=\"action.event\"\n            >\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'delete'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"delete()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'default'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"setDefault()\"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'send'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"send()\"\n                [attr.aria-describedby]=\"\n                  index >= 0 && content.header && !editMode\n                    ? 'content-header-' + index\n                    : null\n                \"\n              >\n                {{ action.name }}\n              </button>\n              <button\n                type=\"button\"\n                *ngSwitchCase=\"'edit'\"\n                class=\"btn btn-tertiary\"\n                (click)=\"edit()\"\n              >\n                {{ action.name }}\n              </button>\n            </ng-container>\n            <cx-generic-link\n              *ngIf=\"isCardLinkAction(action)\"\n              [url]=\"action.link\"\n              [ariaLabel]=\"\n                action.ariaLabel ? (action.ariaLabel | cxTranslate) : undefined\n              \"\n              [target]=\"action.target ?? null\"\n              >{{ action.name }}</cx-generic-link\n            >\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n</div>\n\n<ng-template\n  #showText\n  let-content=\"content\"\n  let-truncateText=\"truncateText\"\n  let-charactersLimit=\"charactersLimit\"\n  let-class=\"class\"\n  let-text=\"text\"\n>\n  <div *ngIf=\"!truncateText\" [class]=\"class\" [ngClass]=\"content.customClass\">\n    {{ text }}\n  </div>\n\n  <cx-truncate-text-popover\n    *ngIf=\"truncateText\"\n    [charactersLimit]=\"charactersLimit\"\n    [content]=\"text\"\n    [customClass]=\"content.customClass || class\"\n  ></cx-truncate-text-popover>\n</ng-template>\n"
    }]
  }], () => [], {
    deleteCard: [{
      type: Output
    }],
    setDefaultCard: [{
      type: Output
    }],
    sendCard: [{
      type: Output
    }],
    editCard: [{
      type: Output
    }],
    cancelCard: [{
      type: Output
    }],
    border: [{
      type: Input
    }],
    editMode: [{
      type: Input
    }],
    isDefault: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    fitToContainer: [{
      type: Input
    }],
    truncateText: [{
      type: Input
    }],
    truncateParagraphText: [{
      type: Input
    }],
    charactersLimit: [{
      type: Input
    }],
    index: [{
      type: Input
    }],
    role: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PopoverModule {
  static {
    this.ɵfac = function PopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PopoverModule,
      declarations: [PopoverDirective, PopoverComponent],
      imports: [CommonModule, RouterModule, KeyboardFocusModule, IconModule, I18nModule],
      exports: [PopoverDirective, PopoverComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, KeyboardFocusModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PopoverModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, KeyboardFocusModule, IconModule, I18nModule],
      declarations: [PopoverDirective, PopoverComponent],
      exports: [PopoverDirective, PopoverComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TruncateTextPopoverModule {
  static {
    this.ɵfac = function TruncateTextPopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TruncateTextPopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TruncateTextPopoverModule,
      declarations: [TruncateTextPopoverComponent, TruncatePipe],
      imports: [CommonModule, I18nModule, PopoverModule],
      exports: [TruncateTextPopoverComponent, TruncatePipe]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, PopoverModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TruncateTextPopoverModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, PopoverModule],
      declarations: [TruncateTextPopoverComponent, TruncatePipe],
      exports: [TruncateTextPopoverComponent, TruncatePipe]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GenericLinkModule {
  static {
    this.ɵfac = function GenericLinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GenericLinkModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GenericLinkModule,
      declarations: [GenericLinkComponent],
      imports: [CommonModule, RouterModule],
      exports: [GenericLinkComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenericLinkModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule],
      declarations: [GenericLinkComponent],
      exports: [GenericLinkComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CardModule {
  static {
    this.ɵfac = function CardModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CardModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CardModule,
      declarations: [CardComponent],
      imports: [CommonModule, AtMessageModule, I18nModule, IconModule, TruncateTextPopoverModule, KeyboardFocusModule, FeaturesConfigModule, GenericLinkModule],
      exports: [CardComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, AtMessageModule, I18nModule, IconModule, TruncateTextPopoverModule, KeyboardFocusModule, FeaturesConfigModule, GenericLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CardModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, AtMessageModule, I18nModule, IconModule, TruncateTextPopoverModule, KeyboardFocusModule, FeaturesConfigModule, GenericLinkModule],
      declarations: [CardComponent],
      exports: [CardComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MediaSourcesPipe {
  transform(sizes) {
    const sources = [];
    return sizes.split(/,\s*/).reduceRight((acc, set) => {
      let [srcset, media] = set.split(' ');
      if (!srcset || !media) {
        return acc;
      }
      media = `(min-width: ${media.replace('w', 'px')})`;
      acc.push({
        srcset,
        media
      });
      return acc;
    }, sources);
  }
  static {
    this.ɵfac = function MediaSourcesPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MediaSourcesPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cxMediaSources",
      type: MediaSourcesPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaSourcesPipe, [{
    type: Pipe,
    args: [{
      name: 'cxMediaSources',
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates how the browser should load the image.
 *
 * While this might not add too much value in some scenarios, as we have other
 * optimizations to defer loading of larger pieces of the DOM, there might be
 * components who haven't implemented other lazy loading techniques. Moreover,
 * a server sides rendered page that lands directly in the browser could benefit
 * enormously from the lazy loading of images.
 */
var ImageLoadingStrategy;
(function (ImageLoadingStrategy) {
  /**
   * Loads the image immediately, regardless of whether or not the image
   * is currently within the visible viewport (this is the default value).
   */
  ImageLoadingStrategy["EAGER"] = "eager";
  /**
   * Defers loading the image until it reaches a calculated distance from the viewport,
   * as defined by the browser. The intent is to avoid the network and storage bandwidth
   * needed to handle the image until it's reasonably certain that it will be needed.
   * This generally improves the performance of the content in most typical use cases.
   */
  ImageLoadingStrategy["LAZY"] = "lazy";
})(ImageLoadingStrategy || (ImageLoadingStrategy = {}));
/**
 * Indicates the priority of the image fetching.
 * This is used to inform the browser about the relative priority of the image
 * fetching. It can be used to optimize the loading of images based on their
 * importance in the layout or user interaction.
 */
var ImageFetchPriority;
(function (ImageFetchPriority) {
  /**
   * Fetch the image at a high priority relative to other images with the same internal prioritization.
   */
  ImageFetchPriority["HIGH"] = "high";
  /**
   * Fetch the image at a low priority relative to other images with the same internal prioritization.
   */
  ImageFetchPriority["LOW"] = "low";
  /**
   * The browser will decide the priority of the image based on its own heuristics.
   */
  ImageFetchPriority["AUTO"] = "auto";
})(ImageFetchPriority || (ImageFetchPriority = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * @deprecated since 2211.31. It will be eventually removed in the future
 */
const USE_LEGACY_MEDIA_COMPONENT = new InjectionToken('USE_LEGACY_MEDIA_COMPONENT');

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service which generates media URLs. It leverage the MediaContainer and MediaFormats so
 * that URLs and sizes are generated for the same media. This helps to improve performance
 * across difference devices and layouts.
 *
 * Media formats are optional, but highly recommended. The format will help the browser to
 * identify the right media for the right experience.
 *
 * The MediaService will generate absolute URLs in case relative URLs are provided for the Media.
 * The baseUrl is read from the `occConfig.backend.media.baseUrl` or
 * `occConfig.backend.occ.baseUrl`.
 */
class MediaService {
  constructor(config) {
    this.config = config;
    this.featureConfigService = inject(FeatureConfigService);
  }
  getMediaBasedOnHTMLElementType(elementType, mediaContainer, format, alt, role) {
    const shouldGetMediaForPictureElement = this.featureConfigService.isEnabled('useExtendedMediaComponentConfiguration') && elementType !== 'img';
    return shouldGetMediaForPictureElement ? this.getMediaForPictureElement(mediaContainer, format, alt, role) : this.getMedia(mediaContainer, format, alt, role);
  }
  /**
   * Returns a `Media` object with the main media (`src`) and various media (`src`)
   * for specific formats.
   *
   * This method is used for creating `Media` object that is used in `img` HTML element
   */
  getMedia(mediaContainer, format, alt, role) {
    if (!mediaContainer) {
      return;
    }
    const commonMediaProperties = this.getCommonMediaObject(mediaContainer, format, alt, role);
    return {
      ...commonMediaProperties,
      srcset: this.resolveSrcSet(mediaContainer, format)
    };
  }
  /**
   * Returns a `Media` object with the main media (`src`) and various sources
   * for specific formats for HTML `<picture>` element.
   */
  getMediaForPictureElement(mediaContainer, format, alt, role) {
    if (!mediaContainer) {
      return;
    }
    const commonMediaProperties = this.getCommonMediaObject(mediaContainer, format, alt, role);
    return {
      ...commonMediaProperties,
      sources: this.resolveSources(mediaContainer, format)
    };
  }
  /**
   * Generates attributes common for `<img>` ang `<picture>`.
   */
  getCommonMediaObject(mediaContainer, format, alt, role) {
    const mainMedia = mediaContainer.url ? mediaContainer : this.resolveMedia(mediaContainer, format);
    return {
      src: this.resolveAbsoluteUrl(mainMedia?.url ?? ''),
      alt: alt ?? mainMedia?.altText,
      role: role ?? mainMedia?.role,
      ...this.getWidthAndHeight(mediaContainer, format)
    };
  }
  /**
   * Returns width and height for Image.
   *
   * Width and height are not coming from CMS so it should be
   * manually added to the Container | Image object
   */
  getWidthAndHeight(mediaContainer, format) {
    const mainMedia = mediaContainer.url ? mediaContainer : this.resolveMedia(mediaContainer, format);
    return {
      width: mainMedia?.width,
      height: mainMedia?.height
    };
  }
  /**
   * Reads the loading strategy from the `MediaConfig`.
   *
   * Defaults to `ImageLoadingStrategy.EAGER`.
   */
  get loadingStrategy() {
    return this.config?.imageLoadingStrategy ?? ImageLoadingStrategy.EAGER;
  }
  /**
   * Creates the media formats in a logical sorted order. The map contains the
   * format key and the format size information. We do this only once for performance
   * benefits.
   */
  get sortedFormats() {
    const mediaFormats = this.config?.mediaFormats;
    if (!this._sortedFormats && mediaFormats) {
      this._sortedFormats = Object.keys(mediaFormats).map(key => ({
        code: key,
        size: mediaFormats[key]
      })).sort((a, b) => a.size.width && b.size.width && a.size.width > b.size.width ? 1 : -1);
    }
    return this._sortedFormats ?? [];
  }
  /**
   * Creates the media formats in a logical sorted order. The map contains the
   * format key and the format media query information. We do this only once for performance
   * benefits.
   */
  get sortedPictureFormats() {
    const pictureElementMediaFormats = this.config?.media?.pictureElementFormats;
    const pictureFormatsOrder = this.config?.media?.pictureFormatsOrder;
    if (!pictureElementMediaFormats) {
      return [];
    }
    if (!this._sortedPictureFormats && pictureElementMediaFormats) {
      this._sortedPictureFormats = Object.keys(pictureElementMediaFormats).map(key => ({
        code: key,
        mediaQuery: pictureElementMediaFormats[key]?.mediaQueries || ''
      }));
      if (pictureFormatsOrder) {
        this._sortedPictureFormats.sort((a, b) => {
          const orderA = pictureFormatsOrder.indexOf(a.code);
          const orderB = pictureFormatsOrder.indexOf(b.code);
          return (orderA !== -1 ? orderA : Infinity) - (orderB !== -1 ? orderB : Infinity);
        });
      }
    }
    return this._sortedPictureFormats ?? [];
  }
  /**
   * Creates the media formats in a reversed sorted order.
   */
  get reversedFormats() {
    if (!this._reversedFormats) {
      this._reversedFormats = this.sortedFormats.slice().reverse();
    }
    return this._reversedFormats;
  }
  /**
   * Resolves the right media for the given format. The fo
   */
  resolveMedia(media, format) {
    return media[this.resolveFormat(media, format)];
  }
  /**
   * Validates the format against the given mediaContainer. If there is no format available,
   * or if the mediaContainer doesn't contain a media for the given media, the most optimal
   * format is resolved. If even that is not possible, the first format is returned.
   */
  resolveFormat(mediaContainer, format) {
    if (format && mediaContainer[format]) {
      return format;
    }
    return this.resolveBestFormat(mediaContainer) || Object.keys(mediaContainer)[0];
  }
  /**
   * Returns the media format code with the best size.
   */
  resolveBestFormat(media) {
    return this.reversedFormats.find(format => media.hasOwnProperty(format.code))?.code;
  }
  /**
   * Returns a set of media for the available media formats. Additionally, the configured media
   * format width is added to the srcset, so that browsers can select the appropriate media.
   *
   * The optional maxFormat indicates that only sources till a certain format should be added
   * to the srcset.
   */
  resolveSrcSet(media, maxFormat) {
    if (!media) {
      return undefined;
    }
    const formats = this.getFormatsUpToMaxFormat(this.sortedFormats, maxFormat);
    const srcset = formats.reduce((set, format) => {
      const image = media[format.code];
      if (!!image) {
        if (set) {
          set += ', ';
        }
        set += `${this.resolveAbsoluteUrl(image.url ?? '')} ${format.size.width}w`;
      }
      return set;
    }, '');
    return srcset === '' ? undefined : srcset;
  }
  /**
   * Resolves the sources for a picture element based on the provided media container and maximum format.
   *
   * This method generates an array of picture element attributes (`srcset` and `media`) by filtering
   * the sorted picture formats up to the specified maximum format. It then maps the corresponding
   * media sources from the provided media container.
   *
   * The method will return an array of picture element attributes suitable for use
   * in a `<picture>` element, or `undefined` if no media is provided.
   */
  resolveSources(media, maxFormat) {
    if (!media) {
      return undefined;
    }
    const pictureFormats = this.getFormatsUpToMaxFormat(this.sortedPictureFormats, maxFormat);
    return pictureFormats.reduce((sources, format) => {
      const image = media[format.code];
      if (image?.url) {
        sources.push({
          srcset: this.resolveAbsoluteUrl(image.url),
          media: format.mediaQuery,
          ...this.getWidthAndHeight(image, maxFormat)
        });
      }
      return sources;
    }, []);
  }
  /**
   * Retrieves a list of formats up to and including the specified max format.
   *
   * @template T - A type that extends an object containing a `code` property of type `string`.
   * @param {T[]} formats - An array of format objects, each containing at least a `code` property.
   * @param {string} [maxFormat] - The maximum format code to include in the returned list.
   * @returns {T[]} An array of formats up to and including the specified max format. If `maxFormat` is not found, returns the entire list.
   *
   * This method filters the provided list of formats to include only those up to and including
   * the specified max format. If the `maxFormat` is not found, the entire list of formats is returned.
   */
  getFormatsUpToMaxFormat(formats, maxFormat) {
    let pictureFormats = formats;
    const maxIndex = pictureFormats.findIndex(f => f.code === maxFormat);
    if (maxIndex > -1) {
      pictureFormats = pictureFormats.slice(0, maxIndex + 1);
    }
    return pictureFormats;
  }
  /**
   * Resolves the absolute URL for the given url. In most cases, this URL represents
   * the relative URL on the backend. In that case, we prefix the url with the baseUrl.
   *
   * When we have receive an absolute URL, we return the URL as-is. An absolute URL might also
   * start with double slash, which is used to resolve media cross from http and https.
   */
  resolveAbsoluteUrl(url) {
    return !url || url.startsWith('http') || url.startsWith('//') ? url : this.getBaseUrl() + url;
  }
  /**
   * The base URL is either driven by a specific `backend.media.baseUrl`, or by the
   * `backend.occ.baseUrl`.
   *
   * The `backend.media.baseUrl` can be used to load media from a different location.
   *
   * In Commerce Cloud, a different location could mean a different "aspect".
   *
   * Defaults to empty string in case no config is provided.
   */
  getBaseUrl() {
    return this.config.backend?.media?.baseUrl ?? this.config.backend?.occ?.baseUrl ?? '';
  }
  static {
    this.ɵfac = function MediaService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MediaService)(i0.ɵɵinject(i1.Config));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MediaService,
      factory: MediaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Config
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The HTML element rendered in the template can be either `<img>` or `<picture>`,
 * depending on the input value of `elementType`, which defaults to `'img'`.
 *
 * In the case of a `<picture>` element, each `<source>` element will contain `srcset` attribute with exactly one URL.
 *
 * If you need multiple URLs per `<source>` (e.g. for different pixel densities),
 * split it into multiple media queries (e.g. with `min-device-pixel-ratio`). See the following example:
 *
 * Instead of:
 *
 * ```html
 * <source media="(min-width: 960px)" srcset="image-1400.jpg 1x, image-2800.jpg 2x">
 * ```
 *
 * Use additional formats and additional media queries, such as:
 *
 * ```html
 * <source media="(min-width: 960px) and (-webkit-min-device-pixel-ratio: 2)" srcset="image-2800.jpg">
 * <source media="(min-width: 960px)" srcset="image-1400.jpg">
 * ```
 */
class MediaComponent {
  constructor(mediaService) {
    this.mediaService = mediaService;
    /**
     * Set the loading strategy of the media. Defaults to global loading strategy.
     * Use 'lazy' or 'eager' strategies.
     */
    this.loading = this.loadingStrategy;
    /**
     * Works only when `useExtendedMediaComponentConfiguration` toggle is true
     *
     * @default img
     */
    this.elementType = 'img';
    /**
     * Once the media is loaded, we emit an event.
     */
    this.loaded = new EventEmitter();
    /**
     * The `cx-media` component has an `is-initialized` class as long as the
     * media is being initialized.
     */
    this.isInitialized = false;
    /**
     * The `cx-media` component has a `is-loading` class as long as the
     * media is loaded. Wehn the media is loaded, the `is-initialized` class
     * is added.
     */
    this.isLoading = true;
    /**
     * When there's no media provided for the content, or in case an error
     * happened during loading, we add the `is-missing` class. Visual effects
     * can be controlled by CSS.
     */
    this.isMissing = false;
    this.trackByMedia = (_, item) => item.media;
    /**
     * @deprecated since 2211.31. It will be eventually removed in the future
     *
     * To use `img` HTML element instead of `picture`
     * use `useExtendedMediaComponentConfiguration` feature flag
     * and pass `[elementType]="'img'"` input to the component
     */
    this.isLegacy = inject(USE_LEGACY_MEDIA_COMPONENT, {
      optional: true
    }) || inject(Config)['useLegacyMediaComponent'] || false;
  }
  ngOnChanges() {
    this.create();
  }
  /**
   * Creates the `Media` object
   */
  create() {
    this.media = this.mediaService.getMediaBasedOnHTMLElementType(this.elementType, this.container instanceof Array ? this.container[0] : this.container, this.format, this.alt, this.role);
    if (!this.media?.src) {
      this.handleMissing();
    }
  }
  /**
   * This handler is called from the UI when the image is loaded.
   */
  loadHandler() {
    this.isLoading = false;
    this.isInitialized = true;
    this.isMissing = false;
    this.loaded.emit(true);
  }
  /**
   * Indicates whether the browser should lazy load the image.
   */
  get loadingStrategy() {
    return this.mediaService.loadingStrategy === ImageLoadingStrategy.LAZY ? ImageLoadingStrategy.LAZY : null;
  }
  /**
   * Whenever an error happens during load, we mark the component
   * with css classes to have a missing media.
   */
  errorHandler() {
    this.handleMissing();
  }
  handleMissing() {
    this.isLoading = false;
    this.isInitialized = true;
    this.isMissing = true;
    this.loaded.emit(false);
  }
  /**
   * If the media has a high fetch priority, we load the image eagerly,
   * no matter what the explicit loading strategy is.
   *
   * It's for convenience to not set explicitly `loading="eager"`,
   * when we already know that the image has a high fetch priority.
   */
  get effectiveLoadingStrategy() {
    if (this.fetchPriority === ImageFetchPriority.HIGH) {
      return ImageLoadingStrategy.EAGER;
    }
    return this.loading ?? this.loadingStrategy;
  }
  static {
    this.ɵfac = function MediaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MediaComponent)(i0.ɵɵdirectiveInject(MediaService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MediaComponent,
      selectors: [["cx-media"]],
      hostVars: 6,
      hostBindings: function MediaComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("is-initialized", ctx.isInitialized)("is-loading", ctx.isLoading)("is-missing", ctx.isMissing);
        }
      },
      inputs: {
        container: "container",
        format: "format",
        alt: "alt",
        role: "role",
        loading: "loading",
        fetchPriority: "fetchPriority",
        elementType: "elementType",
        sizesForImgElement: "sizesForImgElement"
      },
      outputs: {
        loaded: "loaded"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [["imageElementTmp", ""], ["legacyImgTmp", ""], [4, "ngIf"], [4, "cxFeature"], [4, "ngIf", "ngIfElse"], [3, "media", "srcset", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "load", "error", "loading", "alt", "title", "src"], [3, "media", "srcset"], [3, "loading", "alt", "title", "src", "srcset", "load", "error", 4, "ngIf"], [3, "load", "error", "loading", "alt", "title", "src", "srcset"], [3, "srcset", "media", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "srcset", "media"]],
      template: function MediaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MediaComponent_ng_container_0_Template, 3, 2, "ng-container", 2);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", !!ctx.media);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i1.FeatureDirective, MediaSourcesPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaComponent, [{
    type: Component,
    args: [{
      selector: 'cx-media',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"!!media\">\n  <ng-container *cxFeature=\"'useExtendedMediaComponentConfiguration'\">\n    <picture\n      *ngIf=\"\n        !!media?.sources?.length && elementType !== 'img';\n        else imageElementTmp\n      \"\n    >\n      <source\n        *ngFor=\"let source of media.sources; trackBy: trackByMedia\"\n        [media]=\"source.media\"\n        [srcset]=\"source.srcset\"\n        [attr.width]=\"source.width\"\n        [attr.height]=\"source.height\"\n      />\n\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #imageElementTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        [attr.width]=\"media.width\"\n        [attr.height]=\"media.height\"\n        [attr.sizes]=\"sizesForImgElement\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!useExtendedMediaComponentConfiguration'\">\n    <picture *ngIf=\"media.srcset && !isLegacy; else legacyImgTmp\">\n      <source\n        *ngFor=\"\n          let source of media!.srcset! | cxMediaSources;\n          trackBy: trackByMedia\n        \"\n        [srcset]=\"source.srcset\"\n        [media]=\"source.media\"\n      />\n      <img\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </picture>\n\n    <ng-template #legacyImgTmp>\n      <img\n        *ngIf=\"media.src\"\n        [loading]=\"effectiveLoadingStrategy\"\n        [attr.fetchpriority]=\"fetchPriority\"\n        [alt]=\"media.alt\"\n        [title]=\"media.alt\"\n        [src]=\"media.src\"\n        [srcset]=\"media?.srcset || media.src\"\n        [attr.role]=\"media.role\"\n        (load)=\"loadHandler()\"\n        (error)=\"errorHandler()\"\n      />\n    </ng-template>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: MediaService
  }], {
    container: [{
      type: Input
    }],
    format: [{
      type: Input
    }],
    alt: [{
      type: Input
    }],
    role: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    fetchPriority: [{
      type: Input
    }],
    elementType: [{
      type: Input
    }],
    sizesForImgElement: [{
      type: Input
    }],
    loaded: [{
      type: Output
    }],
    isInitialized: [{
      type: HostBinding,
      args: ['class.is-initialized']
    }],
    isLoading: [{
      type: HostBinding,
      args: ['class.is-loading']
    }],
    isMissing: [{
      type: HostBinding,
      args: ['class.is-missing']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MediaModule {
  static forRoot() {
    return {
      ngModule: MediaModule
    };
  }
  static {
    this.ɵfac = function MediaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MediaModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MediaModule,
      declarations: [MediaComponent, MediaSourcesPipe],
      imports: [CommonModule, FeaturesConfigModule],
      exports: [MediaComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FeaturesConfigModule],
      declarations: [MediaComponent, MediaSourcesPipe],
      exports: [MediaComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to enhance carousel item accessibility by ensuring they can receive focus,
 * enabling keyboard navigation using Arrow keys between carousel items.
 *
 * Upon initialization, the directive verifies if the host element is inherently focusable
 * or if it has an appropriately set tabindex. If an element cannot receive focus and the
 * application is running in development mode, a warning is logged to help identify and
 * correct accessibility issues during development.
 *
 * Usage example:
 * ```
 * <ng-container>
 *   <cx-carousel [template]="thumb">
 *     ...
 *   </cx-carousel>
 * </ng-container>
 *
 * <ng-template #thumb let-item="item">
 *   <cx-media cxFocusableCarouselItem tabindex="0">
 *     ...
 *   </cx-media>
 * </ng-template>
 * ```
 */
class FocusableCarouselItemDirective {
  constructor(logger, el) {
    this.logger = logger;
    this.el = el;
    if (isDevMode() && !this.canElementReceiveFocus()) {
      this.logger.warn(`cxFocusableCarouselItem: Element cannot receive focus: ${this.el.nativeElement.tagName}. Either use one of the focusable elements, or add a non-negative tabindex.`);
    }
  }
  canElementReceiveFocus() {
    const focusableTags = ['INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'A'];
    const element = this.el.nativeElement;
    const hasTabIndex = element.hasAttribute('tabindex') && element.getAttribute('tabindex') !== '-1';
    const isFocusableTag = focusableTags.includes(element.tagName);
    const isDisabled = element.hasAttribute('disabled');
    return (hasTabIndex || isFocusableTag) && !isDisabled;
  }
  static {
    this.ɵfac = function FocusableCarouselItemDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FocusableCarouselItemDirective)(i0.ɵɵdirectiveInject(i1.LoggerService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: FocusableCarouselItemDirective,
      selectors: [["", "cxFocusableCarouselItem", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FocusableCarouselItemDirective, [{
    type: Directive,
    args: [{
      selector: '[cxFocusableCarouselItem]',
      standalone: false
    }]
  }], () => [{
    type: i1.LoggerService
  }, {
    type: i0.ElementRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CarouselModule {
  static {
    this.ɵfac = function CarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CarouselModule,
      declarations: [CarouselComponent, FocusableCarouselItemDirective],
      imports: [CommonModule, RouterModule, IconModule, MediaModule, UrlModule, I18nModule],
      exports: [CarouselComponent, FocusableCarouselItemDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, IconModule, MediaModule, UrlModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CarouselModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, IconModule, MediaModule, UrlModule, I18nModule],
      declarations: [CarouselComponent, FocusableCarouselItemDirective],
      exports: [CarouselComponent, FocusableCarouselItemDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Service that provides the placeholder and input pattern for date pickers. This is
 * used in Spartacus to support browser that won't support the native html5 date picker
 * using `<input type="date">`.
 *
 * While the placeholder is configurable, you should be aware that the placeholder format
 * defaults to `yyyy-mm-dd` to align with Safaris limited support of ISO 8601.
 * Another consideration is the support of date formats in the backend. In case you change
 * this format, you might need to serialize the date to the supported date format in the
 * backend.
 *
 */
class DatePickerService {
  get placeholder() {
    return 'yyyy-mm-dd';
  }
  /**
   * The default date pattern is based on the placeholder string;
   */
  get pattern() {
    return this.placeholder.replace('yyyy', '\\d{4}').replace('mm', '\\d{1,2}').replace('dd', '\\d{1,2}');
  }
  /**
   * Validates if the string based date value is a valid date.
   */
  isValidFormat(date, pattern) {
    const patternRegex = new RegExp(`^${pattern ?? this.pattern}$`);
    return patternRegex.test(date);
  }
  /**
   * Since Safari doesn't support proper date formats (ISO 8601), we need to do this
   * ourselves. We cannot rely on `new Date('2020-1-1')`. This will fail, only
   * `new Date('2020-01-01')` works.
   */
  getDate(value) {
    if (!value) {
      return;
    }
    const delimiter = this.placeholder.replace('yyyy', '').replace('mm', '').replace('dd', '').substring(0, 1);
    const dateParts = value.split(delimiter);
    const placeholderParts = this.placeholder.split(delimiter);
    const y = placeholderParts.indexOf('yyyy');
    const m = placeholderParts.indexOf('mm');
    const d = placeholderParts.indexOf('dd');
    return new Date(Number(dateParts[y]), Number(dateParts[m]) - 1, Number(dateParts[d]));
  }
  static {
    this.ɵfac = function DatePickerService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatePickerService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DatePickerService,
      factory: DatePickerService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form errors for a given form control, based on its `errors` property.
 *
 * The translation key consists of the optional input `prefix`
 * concatenated with the error key.
 *
 * And the translation params object consist of the error details
 * (if only it's an object) merged with the optional input object `translationParams`.
 */
class FormErrorsComponent {
  constructor(ChangeDetectionRef) {
    this.ChangeDetectionRef = ChangeDetectionRef;
    this.featureConfigService = inject(FeatureConfigService);
    this.elementRef = inject(ElementRef, {
      optional: true
    });
    this.ariaLiveToken = inject(new HostAttributeToken('aria-live'), {
      optional: true
    });
    /**
     * Prefix prepended to the translation key.
     */
    this.prefix = 'formErrors.labeled';
    /**
     * Fallback prefix prepended to the translation key.
     */
    this.fallbackPrefix = 'formErrors';
    this.previousTouchedState = false;
    this.role = this.featureConfigService.isEnabled('a11yImprovedErrorMessage') ? null : 'alert';
    this.ariaLive = !this.featureConfigService.isEnabled('a11yImprovedErrorMessage') ? this.ariaLiveToken :
    // If no aria-live value is set add 'polite' as a default. This is preferred over setting
    // role='alert' so that screen readers do not interrupt the current task to read this aloud.
    this.ariaLiveToken ?? 'polite';
    this.atomic = true;
    useFeatureStyles('a11yFormErrorMuteIcon');
  }
  set control(control) {
    if (!control) {
      return;
    }
    this._control = control;
    this.errorsDetails$ = control?.statusChanges.pipe(startWith({}), map(() => control.errors || {}), map(errors => Object.entries(errors).filter(([_key, details]) => details)));
  }
  get control() {
    return this._control;
  }
  ngDoCheck() {
    if (this.control.touched !== this.previousTouchedState) {
      if (this.featureConfigService.isEnabled('a11yImprovedErrorMessage') && this.elementRef?.nativeElement?.getAttribute('aria-live') === 'polite') {
        // due to the way we detect changes here, JAWS doesn't always respect
        // aria live `polite`, so we need to move this in the next event-loop queue
        setTimeout(() => {
          this.previousTouchedState = this.control.touched;
          this.ChangeDetectionRef.markForCheck();
        });
      } else {
        this.previousTouchedState = this.control.touched;
        this.ChangeDetectionRef.markForCheck();
      }
    }
  }
  /**
   * Returns translation params composed of
   * the argument `errorDetails` (if only is an object) merged with
   * the component input object `translationParams`.
   *
   * In case of a conflicting object key, the value from
   * `translationParams` takes precedence.
   */
  getTranslationParams(errorDetails) {
    errorDetails = isObject(errorDetails) ? errorDetails : {};
    return {
      ...errorDetails,
      ...this.translationParams
    };
  }
  get invalid() {
    return this.control?.invalid;
  }
  get dirty() {
    return this.control?.dirty;
  }
  get touched() {
    return this.control?.touched;
  }
  get hidden() {
    return !(this.invalid && (this.touched || this.dirty));
  }
  static {
    this.ɵfac = function FormErrorsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormErrorsComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormErrorsComponent,
      selectors: [["cx-form-errors"]],
      hostVars: 11,
      hostBindings: function FormErrorsComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role)("aria-live", ctx.ariaLive)("aria-atomic", ctx.atomic);
          i0.ɵɵclassProp("control-invalid", ctx.invalid)("control-dirty", ctx.dirty)("control-touched", ctx.touched)("cx-visually-hidden", ctx.hidden);
        }
      },
      inputs: {
        prefix: "prefix",
        fallbackPrefix: "fallbackPrefix",
        translationParams: "translationParams",
        control: "control"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"]],
      template: function FormErrorsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FormErrorsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.errorsDetails$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormErrorsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-form-errors',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"errorsDetails$ | async as errorDetails\">\n  <ng-container *ngIf=\"!hidden\">\n    <p *ngFor=\"let error of errorDetails\">\n      {{\n        [prefix + '.' + error[0], fallbackPrefix + '.' + error[0]]\n          | cxTranslate: getTranslationParams(error[1])\n      }}\n    </p>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    prefix: [{
      type: Input
    }],
    fallbackPrefix: [{
      type: Input
    }],
    translationParams: [{
      type: Input
    }],
    control: [{
      type: Input
    }],
    invalid: [{
      type: HostBinding,
      args: ['class.control-invalid']
    }],
    dirty: [{
      type: HostBinding,
      args: ['class.control-dirty']
    }],
    touched: [{
      type: HostBinding,
      args: ['class.control-touched']
    }],
    hidden: [{
      type: HostBinding,
      args: ['class.cx-visually-hidden']
    }],
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    ariaLive: [{
      type: HostBinding,
      args: ['attr.aria-live']
    }],
    atomic: [{
      type: HostBinding,
      args: ['attr.aria-atomic']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component that adds a date control. While the native date picker works in most
 * modern browsers, some browsers need more guidance (placeholder), validation and
 * date conversion.
 *
 * The data picker supports (optional) min and max form controls, so that you can
 * limit the start and/or end date.
 *
 * Most of the implementation is done in the `DatePickerFallbackDirective`.
 */
class DatePickerComponent {
  constructor(service) {
    this.service = service;
    this.label = 'Date';
    this.update = new EventEmitter();
  }
  change() {
    this.update.emit();
  }
  get placeholder() {
    return this.service.placeholder;
  }
  get pattern() {
    return this.service.pattern;
  }
  /**
   * Only returns the date if we have a valid format. We do this to avoid
   * loads of console errors coming from the datePipe while the user is typing
   * (in those browsers where the date picker isn't supported).
   */
  getDate(date) {
    return date && this.service.isValidFormat(date) ? date : undefined;
  }
  static {
    this.ɵfac = function DatePickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatePickerComponent)(i0.ɵɵdirectiveInject(DatePickerService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatePickerComponent,
      selectors: [["cx-date-picker"]],
      inputs: {
        control: "control",
        min: "min",
        max: "max",
        required: "required",
        label: "label"
      },
      outputs: {
        update: "update"
      },
      standalone: false,
      decls: 5,
      vars: 20,
      consts: [["type", "date", 1, "form-control", 3, "change", "formControl", "placeholder", "pattern"], ["id", "controlError", "prefix", "formErrors.labeled.date", "fallbackPrefix", "formErrors.date", 3, "control", "translationParams"]],
      template: function DatePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "input", 0);
          i0.ɵɵlistener("change", function DatePickerComponent_Template_input_change_0_listener() {
            return ctx.change();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelement(1, "cx-form-errors", 1);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵpipe(3, "cxDate");
          i0.ɵɵpipe(4, "cxDate");
        }
        if (rf & 2) {
          let tmp_9_0;
          i0.ɵɵproperty("formControl", ctx.control)("placeholder", ctx.placeholder)("pattern", ctx.pattern);
          i0.ɵɵattribute("min", ctx.min)("max", ctx.max)("required", ctx.required === false ? undefined : ctx.required)("aria-invalid", !ctx.control.untouched && ctx.control.invalid)("aria-errormessage", "controlError");
          i0.ɵɵadvance();
          i0.ɵɵproperty("control", ctx.control)("translationParams", i0.ɵɵpureFunction3(16, _c22, i0.ɵɵpipeBind1(2, 10, (tmp_9_0 = ctx.label) !== null && tmp_9_0 !== undefined ? tmp_9_0 : ""), i0.ɵɵpipeBind1(3, 12, ctx.getDate(ctx.max)), i0.ɵɵpipeBind1(4, 14, ctx.getDate(ctx.min))));
        }
      },
      dependencies: [i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.PatternValidator, i1$4.FormControlDirective, FormErrorsComponent, i1.TranslatePipe, i1.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-date-picker',
      standalone: false,
      template: "<input\n  class=\"form-control\"\n  type=\"date\"\n  [formControl]=\"control\"\n  [attr.min]=\"min\"\n  [attr.max]=\"max\"\n  [attr.required]=\"required === false ? undefined : required\"\n  (change)=\"change()\"\n  [placeholder]=\"placeholder\"\n  [pattern]=\"pattern\"\n  [attr.aria-invalid]=\"!control.untouched && control.invalid\"\n  [attr.aria-errormessage]=\"'controlError'\"\n/>\n\n<cx-form-errors\n  id=\"controlError\"\n  [control]=\"control\"\n  prefix=\"formErrors.labeled.date\"\n  fallbackPrefix=\"formErrors.date\"\n  [translationParams]=\"{\n    label: label ?? '' | cxTranslate,\n    max: getDate(max) | cxDate,\n    min: getDate(min) | cxDate,\n  }\"\n></cx-form-errors>\n"
    }]
  }], () => [{
    type: DatePickerService
  }], {
    control: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    update: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FormErrorsModule {
  static {
    this.ɵfac = function FormErrorsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormErrorsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FormErrorsModule,
      declarations: [FormErrorsComponent],
      imports: [CommonModule, I18nModule, FeaturesConfigModule],
      exports: [FormErrorsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormErrorsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, FeaturesConfigModule],
      declarations: [FormErrorsComponent],
      exports: [FormErrorsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class DatePickerModule {
  static {
    this.ɵfac = function DatePickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DatePickerModule,
      declarations: [DatePickerComponent],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, FeaturesConfigModule],
      exports: [DatePickerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatePickerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, FeaturesConfigModule],
      declarations: [DatePickerComponent],
      exports: [DatePickerComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component that adds a file upload control.
 */
class FileUploadComponent {
  constructor() {
    /**
     * Allowed file types. It's setting attribute used for OS window for choosing files.
     */
    this.accept = '*';
    /**
     * Allows selecting multiple files.
     */
    this.multiple = false;
    // TODO: remove this event. Now it's used only to trigger some logic in the parent component.
    // Prerequisites (changes in the parent component):
    // - use an async validator that "opens file" using the value of the form control
    // - "open file" on form submit, but not on the form control change
    this.update = new EventEmitter();
    // ControlValueAccessor START
    this.onChangeCallback = () => {
      // Intentional empty arrow function
    };
    this.onTouchedCallback = () => {
      // Intentional empty arrow function
    };
  }
  selectFile($event) {
    const files = $event.target?.files;
    this.onChangeCallback(files);
    this.update.emit(files);
  }
  removeFile() {
    this.fileInput.nativeElement.value = '';
  }
  get selectedFiles() {
    if (this.fileInput.nativeElement.files) {
      return Array.from(this.fileInput.nativeElement.files);
    }
    return undefined;
  }
  registerOnChange(callback) {
    this.onChangeCallback = callback;
  }
  registerOnTouched(callback) {
    this.onTouchedCallback = callback;
  }
  setDisabledState(disabled) {
    this.fileInput.nativeElement.disabled = disabled;
  }
  writeValue(value) {
    if (value instanceof FileList) {
      this.fileInput.nativeElement.files = value;
    }
  }
  static {
    this.ɵfac = function FileUploadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUploadComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FileUploadComponent,
      selectors: [["cx-file-upload"]],
      contentQueries: function FileUploadComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customButton = _t.first);
        }
      },
      viewQuery: function FileUploadComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c23, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileInput = _t.first);
        }
      },
      inputs: {
        accept: "accept",
        multiple: "multiple"
      },
      outputs: {
        update: "update"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FileUploadComponent),
        multi: true
      }])],
      ngContentSelectors: _c1,
      decls: 5,
      vars: 5,
      consts: [["fileInput", ""], ["type", "file", "aria-hidden", "true", 3, "change", "accept", "multiple"], ["class", "btn btn-secondary", "type", "button", 3, "click", 4, "ngIf"], ["class", "link cx-action-link", 3, "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], [1, "link", "cx-action-link", 3, "click"], [4, "ngTemplateOutlet"]],
      template: function FileUploadComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "input", 1, 0);
          i0.ɵɵlistener("change", function FileUploadComponent_Template_input_change_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.selectFile($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, FileUploadComponent_button_2_Template, 3, 3, "button", 2)(3, FileUploadComponent_button_3_Template, 2, 1, "button", 3)(4, FileUploadComponent_p_4_Template, 2, 1, "p", 4);
        }
        if (rf & 2) {
          i0.ɵɵproperty("accept", ctx.accept)("multiple", ctx.multiple);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.customButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.customButton);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.selectedFiles);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadComponent, [{
    type: Component,
    args: [{
      selector: 'cx-file-upload',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FileUploadComponent),
        multi: true
      }],
      standalone: false,
      template: "<input\n  type=\"file\"\n  aria-hidden=\"true\"\n  [accept]=\"accept\"\n  [multiple]=\"multiple\"\n  (change)=\"selectFile($event)\"\n  #fileInput\n/>\n<button\n  *ngIf=\"!customButton\"\n  [attr.aria-label]=\"'common.selectFile' | cxTranslate\"\n  class=\"btn btn-secondary\"\n  type=\"button\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-content></ng-content>\n</button>\n<!-- TODO(Brian-Parth): CXEC-17196 -->\n<button\n  class=\"link cx-action-link\"\n  *ngIf=\"customButton\"\n  (click)=\"fileInput.click()\"\n>\n  <ng-container *ngTemplateOutlet=\"customButton\"> </ng-container>\n</button>\n<p *ngFor=\"let file of selectedFiles\">\n  {{ file?.name }}\n</p>\n"
    }]
  }], null, {
    accept: [{
      type: Input
    }],
    multiple: [{
      type: Input
    }],
    customButton: [{
      type: ContentChild,
      args: [TemplateRef]
    }],
    update: [{
      type: Output
    }],
    fileInput: [{
      type: ViewChild,
      args: ['fileInput', {
        static: true
      }]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileUploadModule {
  static {
    this.ɵfac = function FileUploadModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileUploadModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FileUploadModule,
      declarations: [FileUploadComponent],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, KeyboardFocusModule],
      exports: [FileUploadComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileUploadModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, KeyboardFocusModule],
      declarations: [FileUploadComponent],
      exports: [FileUploadComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PasswordVisibilityToggleComponent {
  constructor() {
    this.showState = {
      icon: ICON_TYPE.EYE_SLASH,
      inputType: 'text',
      ariaLabel: 'passwordVisibility.hidePassword'
    };
    this.hideState = {
      icon: ICON_TYPE.EYE,
      inputType: 'password',
      ariaLabel: 'passwordVisibility.showPassword'
    };
    this.state = this.hideState;
  }
  /**
   * Toggle the visibility of the text of the input field.
   */
  toggle() {
    this.state = this.state === this.hideState ? this.showState : this.hideState;
    this.inputElement.setAttribute('type', this.state.inputType);
  }
  static {
    this.ɵfac = function PasswordVisibilityToggleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PasswordVisibilityToggleComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PasswordVisibilityToggleComponent,
      selectors: [["cx-password-visibility-toggle"]],
      inputs: {
        inputElement: "inputElement"
      },
      standalone: false,
      decls: 5,
      vars: 8,
      consts: [["type", "button", 3, "click"], ["aria-hidden", "true"], [3, "type"]],
      template: function PasswordVisibilityToggleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵpipe(1, "cxTranslate");
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵlistener("click", function PasswordVisibilityToggleComponent_Template_button_click_0_listener() {
            return ctx.toggle();
          });
          i0.ɵɵelementStart(3, "span", 1);
          i0.ɵɵelement(4, "cx-icon", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 4, ctx.state.ariaLabel))("title", i0.ɵɵpipeBind1(2, 6, ctx.state.ariaLabel))("aria-pressed", ctx.state.inputType === ctx.showState.inputType);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.state.icon);
        }
      },
      dependencies: [IconComponent, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordVisibilityToggleComponent, [{
    type: Component,
    args: [{
      selector: 'cx-password-visibility-toggle',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  type=\"button\"\n  (click)=\"toggle()\"\n  [attr.aria-label]=\"state.ariaLabel | cxTranslate\"\n  [attr.title]=\"state.ariaLabel | cxTranslate\"\n  [attr.aria-pressed]=\"state.inputType === showState.inputType\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon [type]=\"state.icon\"></cx-icon>\n  </span>\n</button>\n"
    }]
  }], null, {
    inputElement: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FormConfig {
  static {
    this.ɵfac = function FormConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormConfig,
      factory: function FormConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || FormConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Directive to bind a PasswordVisibilityToggleDirective to a password input field. This
 * toggle while alternate the appearance of the input between dots and plain text.
 */
class PasswordVisibilityToggleDirective {
  constructor(winRef, config, elementRef, viewContainerRef, changeDetectorRef) {
    this.winRef = winRef;
    this.config = config;
    this.elementRef = elementRef;
    this.viewContainerRef = viewContainerRef;
    this.changeDetectorRef = changeDetectorRef;
  }
  ngAfterViewInit() {
    if (this.config.form?.passwordVisibilityToggle) {
      this.wrapInput();
      this.insertComponent();
      this.changeDetectorRef.detectChanges();
    }
  }
  insertComponent() {
    const component = this.viewContainerRef.createComponent(PasswordVisibilityToggleComponent);
    component.instance.inputElement = this.elementRef.nativeElement;
    this.inputWrapper?.appendChild(component.location.nativeElement);
  }
  /**
   * We need to wrap the input element in a div to be able to position the toggle button in the right place.
   */
  wrapInput() {
    const input = this.elementRef.nativeElement;
    const parent = input.parentNode;
    this.inputWrapper = this.winRef.document.createElement('div');
    this.inputWrapper.setAttribute('class', 'cx-password-input-wrapper');
    // set the wrapper as child (instead of the element)
    parent.replaceChild(this.inputWrapper, input);
    this.inputWrapper.appendChild(input);
  }
  static {
    this.ɵfac = function PasswordVisibilityToggleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PasswordVisibilityToggleDirective)(i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(FormConfig), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: PasswordVisibilityToggleDirective,
      selectors: [["", "cxPasswordVisibilitySwitch", "", "type", "password"]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordVisibilityToggleDirective, [{
    type: Directive,
    args: [{
      selector: '[cxPasswordVisibilitySwitch][type="password"]',
      standalone: false
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: FormConfig
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ViewContainerRef
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultFormConfig = {
  form: {
    passwordVisibilityToggle: true
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PasswordVisibilityToggleModule {
  static {
    this.ɵfac = function PasswordVisibilityToggleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PasswordVisibilityToggleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PasswordVisibilityToggleModule,
      declarations: [PasswordVisibilityToggleDirective, PasswordVisibilityToggleComponent],
      imports: [CommonModule, IconModule, I18nModule],
      exports: [PasswordVisibilityToggleDirective, PasswordVisibilityToggleComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultFormConfig)],
      imports: [CommonModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordVisibilityToggleModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, IconModule, I18nModule],
      providers: [provideDefaultConfig(defaultFormConfig)],
      declarations: [PasswordVisibilityToggleDirective, PasswordVisibilityToggleComponent],
      exports: [PasswordVisibilityToggleDirective, PasswordVisibilityToggleComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form required asteriks component.
 */
class FormRequiredAsterisksComponent {
  constructor() {
    /**
     * Component Title translation (defaulted to common.required)
     */
    this.titleTranslation = 'common.required';
  }
  static {
    this.ɵfac = function FormRequiredAsterisksComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRequiredAsterisksComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormRequiredAsterisksComponent,
      selectors: [["cx-form-required-asterisks"]],
      inputs: {
        titleTranslation: "titleTranslation"
      },
      decls: 3,
      vars: 3,
      consts: [["aria-hidden", "true", 1, "text-decoration-none", "required-asterisk", 3, "title"]],
      template: function FormRequiredAsterisksComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "abbr", 0);
          i0.ɵɵpipe(1, "cxTranslate");
          i0.ɵɵtext(2, "*");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, ctx.titleTranslation));
        }
      },
      dependencies: [CommonModule, I18nModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRequiredAsterisksComponent, [{
    type: Component,
    args: [{
      selector: 'cx-form-required-asterisks',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [CommonModule, I18nModule],
      template: "<abbr\n  class=\"text-decoration-none required-asterisk\"\n  aria-hidden=\"true\"\n  title=\"{{ titleTranslation! | cxTranslate }}\"\n  >*</abbr\n>\n"
    }]
  }], null, {
    titleTranslation: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Renders translated form required asteriks component.
 */
class FormRequiredLegendComponent {
  constructor() {
    /**
     * Form Legend translation (defaulted to 'formLegend.required')
     */
    this.formLegendTranslation = 'formLegend.required';
  }
  static {
    this.ɵfac = function FormRequiredLegendComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormRequiredLegendComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FormRequiredLegendComponent,
      selectors: [["cx-form-required-legend"]],
      inputs: {
        formLegendTranslation: "formLegendTranslation"
      },
      decls: 3,
      vars: 3,
      consts: [[1, "form-legend"]],
      template: function FormRequiredLegendComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "p", 0);
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx.formLegendTranslation), "\n");
        }
      },
      dependencies: [CommonModule, I18nModule, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormRequiredLegendComponent, [{
    type: Component,
    args: [{
      selector: 'cx-form-required-legend',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [CommonModule, I18nModule],
      template: "<p class=\"form-legend\">\n  {{ formLegendTranslation! | cxTranslate }}\n</p>\n"
    }]
  }], null, {
    formLegendTranslation: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides a UI to manage the count of the quantity, typically by using
 * increase and decrease functionality. The item counter expects an input `FormControl`
 * so that the state of the control can be managed outside of this component.
 */
class ItemCounterComponent {
  constructor() {
    /**
     * This can be used in case an item has a minmum order quantity.
     * @default 1
     */
    this.min = 1;
    /**
     * The step is used to increment the count. It is supposed to be a
     * positive integer or float.
     * @default 1
     */
    this.step = 1;
    /**
     * Indicates that the input can be manually set to zero,
     * despite the fact that the input controls will be limited to
     * the minimum. The zero value can be used to remove an item.
     */
    this.allowZero = false;
    /**
     * ID of the element associated with the number input,
     * so it gets narrated by a screen reader
     */
    this.ariaDescribedById = '';
    /**
     * In readonly mode the item counter will only be shown as a label,
     * the form controls are not rendered.
     * Please not that readonly is different from the `disabled` form state.
     * @default false
     */
    this.readonly = false;
    useFeatureStyles('a11yItemCounterFocus');
  }
  ngOnInit() {
    this.sub = this.control.valueChanges.pipe(startWith(this.control.value)).subscribe(value => this.control.setValue(this.getValidCount(value), {
      emitEvent: false
    }));
  }
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  /**
   * Updates the form control value with the input value.
   * It is used to improve keyboard controls of the component.
   */
  updateValue() {
    // Convert string value to number(prevents us from having '1' + 1 = '11' on increment)
    this.control.setValue(+this.input.nativeElement.value);
    this.control.markAsDirty();
  }
  increment() {
    // it's too early to use the `stepUp` and `stepDown` API...
    // let's wait for FF: https://caniuse.com/#search=stepUp
    this.control.setValue(this.control.value + this.step);
    this.control.markAsDirty();
  }
  decrement() {
    this.control.setValue(this.control.value - this.step);
    this.control.markAsDirty();
  }
  /**
   * Validate that the given value is in between
   * the `min` and `max` value. If the value is out
   * of  the min/max range, it will be altered.
   * If `allowZero` is set to true, the 0 value is ignored.
   *
   */
  getValidCount(value) {
    if (value < this.min && !(value === 0 && this.allowZero)) {
      value = this.min;
    }
    if (this.max && value > this.max) {
      value = this.max;
    }
    return value;
  }
  static {
    this.ɵfac = function ItemCounterComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItemCounterComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ItemCounterComponent,
      selectors: [["cx-item-counter"]],
      viewQuery: function ItemCounterComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c24, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function ItemCounterComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("readonly", ctx.readonly);
        }
      },
      inputs: {
        control: "control",
        min: "min",
        max: "max",
        step: "step",
        allowZero: "allowZero",
        ariaDescribedById: "ariaDescribedById",
        readonly: "readonly"
      },
      standalone: false,
      decls: 7,
      vars: 16,
      consts: [["qty", ""], ["type", "button", 3, "tabindex", "cxFocus", "title", "click", 4, "cxFeature"], ["type", "button", 3, "disabled", "tabindex", "cxFocus", "title", "click", 4, "cxFeature"], ["type", "number", 3, "keyup.enter", "min", "max", "step", "readonly", "tabindex", "formControl", "cxFocus"], ["type", "button", 3, "cxFocus", "title", "click", 4, "cxFeature"], ["type", "button", 3, "disabled", "cxFocus", "title", "click", 4, "cxFeature"], ["type", "button", 3, "click", "tabindex", "cxFocus", "title"], ["type", "button", 3, "click", "disabled", "tabindex", "cxFocus", "title"], ["type", "button", 3, "click", "cxFocus", "title"], ["type", "button", 3, "click", "disabled", "cxFocus", "title"]],
      template: function ItemCounterComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, ItemCounterComponent_button_0_Template, 4, 10, "button", 1)(1, ItemCounterComponent_button_1_Template, 4, 10, "button", 2);
          i0.ɵɵelementStart(2, "input", 3, 0);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵlistener("keyup.enter", function ItemCounterComponent_Template_input_keyup_enter_2_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.updateValue());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, ItemCounterComponent_button_5_Template, 4, 9, "button", 4)(6, ItemCounterComponent_button_6_Template, 4, 9, "button", 5);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "a11yItemCounterFocus");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yItemCounterFocus");
          i0.ɵɵadvance();
          i0.ɵɵproperty("min", ctx.min)("max", ctx.max)("step", ctx.step)("readonly", ctx.readonly)("tabindex", ctx.readonly ? -1 : 0)("formControl", ctx.control)("cxFocus", i0.ɵɵpureFunction0(15, _c25));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(4, 13, "itemCounter.quantity"))("aria-describedby", ctx.ariaDescribedById);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "a11yItemCounterFocus");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yItemCounterFocus");
        }
      },
      dependencies: [i1$4.DefaultValueAccessor, i1$4.NumberValueAccessor, i1$4.NgControlStatus, i1$4.MinValidator, i1$4.MaxValidator, i1$4.FormControlDirective, FocusDirective, i1.FeatureDirective, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItemCounterComponent, [{
    type: Component,
    args: [{
      selector: 'cx-item-counter',
      standalone: false,
      template: "<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [attr.aria-disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"decrement()\"\n  [disabled]=\"control.disabled || control.value <= min\"\n  [tabindex]=\"control.disabled || control.value <= min ? -1 : 0\"\n  [cxFocus]=\"{ key: 'decrement' }\"\n  attr.aria-label=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.removeOne' | cxTranslate }}\"\n>\n  -\n</button>\n<input\n  #qty\n  type=\"number\"\n  [min]=\"min\"\n  [max]=\"max\"\n  [step]=\"step\"\n  [readonly]=\"readonly\"\n  [tabindex]=\"readonly ? -1 : 0\"\n  [formControl]=\"control\"\n  (keyup.enter)=\"updateValue()\"\n  [cxFocus]=\"{ key: 'qty' }\"\n  attr.aria-label=\"{{ 'itemCounter.quantity' | cxTranslate }}\"\n  [attr.aria-describedby]=\"ariaDescribedById\"\n/>\n<button\n  *cxFeature=\"'a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [attr.aria-disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n<button\n  *cxFeature=\"'!a11yItemCounterFocus'\"\n  type=\"button\"\n  (click)=\"increment()\"\n  [disabled]=\"control.disabled || control.value >= max\"\n  [cxFocus]=\"{ key: 'increment' }\"\n  attr.aria-label=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n  title=\"{{ 'itemCounter.addOneMore' | cxTranslate }}\"\n>\n  +\n</button>\n"
    }]
  }], () => [], {
    control: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    step: [{
      type: Input
    }],
    allowZero: [{
      type: Input
    }],
    ariaDescribedById: [{
      type: Input
    }],
    readonly: [{
      type: HostBinding,
      args: ['class.readonly']
    }, {
      type: Input
    }],
    input: [{
      type: ViewChild,
      args: ['qty']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ItemCounterModule {
  static {
    this.ɵfac = function ItemCounterModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ItemCounterModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ItemCounterModule,
      declarations: [ItemCounterComponent],
      imports: [CommonModule, ReactiveFormsModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [ItemCounterComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, ReactiveFormsModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ItemCounterModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, I18nModule, KeyboardFocusModule, FeaturesConfigModule],
      declarations: [ItemCounterComponent],
      exports: [ItemCounterComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultLayoutConfig = {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: {
      min: 1200
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The direction config provides an easy way to configure "ltr" versus "rtl" direction
 * for the storefront. The direction can be configured to detect the direction by language.
 *
 * The following configuration detects rtl languages by isoCode for Arabic and Hebrew:
 *
 * ```typescript
 * direction: {
 *   detect: true,
 *   default: DirectionMode.LTR,
 *   rtlLanguages: ['ar', 'he']
 * }
 * ```
 */
class DirectionConfig {
  static {
    this.ɵfac = function DirectionConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DirectionConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DirectionConfig,
      factory: function DirectionConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || DirectionConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirectionConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultDirectionConfig = {
  direction: {
    detect: true,
    default: DirectionMode.LTR,
    // we're not polluting the system with all defaults for ltr, but add 2 common used
    // languages (hebrew and arabic) to easily demo directionality
    // see https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
    rtlLanguages: ['he', 'ar']
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `DirectionService` can be used to add the direction to the overall storefront or individual elements.
 * By default, the direction is added to the `html` element (i.e. `<html dir="ltr">`). The API of this service
 * does however provide methods to add direction to individual elements if needed.
 *
 * The direction is configurable and allows for language driven direction configuration.
 *
 * To react to the active language, the service subscribes to the active language in the initialize method. This
 * is called from an APP_INITIALIZER method and should only happen once.
 */
class DirectionService {
  constructor(configInit, languageService, winRef) {
    this.configInit = configInit;
    this.languageService = languageService;
    this.winRef = winRef;
    this.startsDetecting = false;
    this.subscription = new Subscription();
  }
  /**
   * Initializes the layout direction for the storefront.
   */
  initialize() {
    return lastValueFrom(this.configInit.getStable('direction').pipe(tap(config => {
      this.config = config?.direction;
      if (this.config?.detect) {
        this.detect();
      } else {
        this.setDirection(this.winRef.document.documentElement, this.config?.default);
      }
    })));
  }
  /**
   * Observes the _active_ language and set the required direction for the given language.
   * The method is guarded to ensure that the active language is observed only once.
   */
  detect() {
    if (this.startsDetecting) {
      return;
    }
    this.subscription.add(this.languageService.getActive().subscribe(isoCode => this.setDirection(this.winRef.document.documentElement, this.getDirection(isoCode))));
    this.startsDetecting = true;
  }
  /**
   * Sets the direction attribute for the given element. If the direction is undefined, the `dir`
   * attribute is removed.
   */
  setDirection(el, direction) {
    if (direction) {
      el.setAttribute('dir', direction);
    } else {
      el.removeAttribute('dir');
    }
  }
  /**
   * Gets the `DirectionMode` for the given language isoCode. The language isoCode is compared
   * to the configured list of languages(`direction.rtlLanguages` vs `direction.ltrLanguages`).
   *
   * If no language is given, or no language mapping could be found, we fallback to the default
   * `direction.mode`.
   */
  getDirection(language) {
    if (language && this.config?.rtlLanguages?.includes(language)) {
      return DirectionMode.RTL;
    }
    if (language && this.config?.ltrLanguages?.includes(language)) {
      return DirectionMode.LTR;
    }
    return this.config?.default;
  }
  ngOnDestroy() {
    // Cleans up the subscription, to avoid memory leaks in SSR.
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function DirectionService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DirectionService)(i0.ɵɵinject(i1.ConfigInitializerService), i0.ɵɵinject(i1.LanguageService), i0.ɵɵinject(i1.WindowRef));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DirectionService,
      factory: DirectionService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirectionService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ConfigInitializerService
  }, {
    type: i1.LanguageService
  }, {
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initHtmlDirAttribute(directionService) {
  const result = () => {
    return directionService.initialize();
  };
  return result;
}
/**
 * Provides a configuration and APP_INITIALIZER to add the correct (language drive) html direction.
 */
class DirectionModule {
  static {
    this.ɵfac = function DirectionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DirectionModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DirectionModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: APP_INITIALIZER,
        multi: true,
        useFactory: initHtmlDirAttribute,
        deps: [DirectionService]
      }, provideDefaultConfig(defaultDirectionConfig)]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DirectionModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: APP_INITIALIZER,
        multi: true,
        useFactory: initHtmlDirAttribute,
        deps: [DirectionService]
      }, provideDefaultConfig(defaultDirectionConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuService {
  constructor(router) {
    this.isExpanded = new BehaviorSubject(false);
    router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe(() => {
      this.toggle(true);
    });
  }
  /**
   * toggles the expand state of the hamburger menu
   */
  toggle(forceCollapse) {
    if (forceCollapse) {
      this.isExpanded.next(false);
    } else {
      this.isExpanded.next(!this.isExpanded.value);
    }
  }
  static {
    this.ɵfac = function HamburgerMenuService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HamburgerMenuService)(i0.ɵɵinject(i1$2.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HamburgerMenuService,
      factory: HamburgerMenuService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HamburgerMenuService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$2.Router
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuComponent {
  constructor(hamburgerMenuService) {
    this.hamburgerMenuService = hamburgerMenuService;
  }
  toggle() {
    this.hamburgerMenuService.toggle();
  }
  get isExpanded() {
    return this.hamburgerMenuService.isExpanded;
  }
  static {
    this.ɵfac = function HamburgerMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HamburgerMenuComponent)(i0.ɵɵdirectiveInject(HamburgerMenuService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: HamburgerMenuComponent,
      selectors: [["cx-hamburger-menu"]],
      standalone: false,
      decls: 11,
      vars: 21,
      consts: [["type", "button", "aria-controls", "cx-header", 1, "cx-hamburger", 3, "click"], [1, "hamburger-box"], [1, "hamburger-inner"]],
      template: function HamburgerMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
          i0.ɵɵpipe(3, "async");
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵpipe(6, "async");
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵlistener("click", function HamburgerMenuComponent_Template_button_click_0_listener() {
            return ctx.toggle();
          });
          i0.ɵɵelementStart(9, "span", 1);
          i0.ɵɵelement(10, "span", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("is-active", i0.ɵɵpipeBind1(1, 5, ctx.isExpanded));
          i0.ɵɵattribute("aria-expanded", i0.ɵɵpipeBind1(2, 7, ctx.isExpanded))("aria-label", i0.ɵɵpipeBind1(3, 9, ctx.isExpanded) ? i0.ɵɵpipeBind1(4, 11, "common.close") : i0.ɵɵpipeBind1(5, 13, "common.menu"))("title", i0.ɵɵpipeBind1(6, 15, ctx.isExpanded) ? i0.ɵɵpipeBind1(7, 17, "common.close") : i0.ɵɵpipeBind1(8, 19, "common.menu"));
        }
      },
      dependencies: [i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HamburgerMenuComponent, [{
    type: Component,
    args: [{
      selector: 'cx-hamburger-menu',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  class=\"cx-hamburger\"\n  type=\"button\"\n  (click)=\"toggle()\"\n  [class.is-active]=\"isExpanded | async\"\n  [attr.aria-expanded]=\"isExpanded | async\"\n  [attr.aria-label]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  [attr.title]=\"\n    (isExpanded | async)\n      ? ('common.close' | cxTranslate)\n      : ('common.menu' | cxTranslate)\n  \"\n  aria-controls=\"cx-header\"\n>\n  <span class=\"hamburger-box\">\n    <span class=\"hamburger-inner\"></span>\n  </span>\n</button>\n"
    }]
  }], () => [{
    type: HamburgerMenuService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HamburgerMenuModule {
  static {
    this.ɵfac = function HamburgerMenuModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HamburgerMenuModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: HamburgerMenuModule,
      declarations: [HamburgerMenuComponent],
      imports: [CommonModule, I18nModule],
      exports: [HamburgerMenuComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          HamburgerMenuComponent: {
            component: HamburgerMenuComponent
          }
        }
      })],
      imports: [CommonModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HamburgerMenuModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          HamburgerMenuComponent: {
            component: HamburgerMenuComponent
          }
        }
      })],
      declarations: [HamburgerMenuComponent],
      exports: [HamburgerMenuComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ThemeService {
  constructor(config, rendererFactory) {
    this.config = config;
    this.rendererFactory = rendererFactory;
    this.siteThemeService = inject(SiteThemeService);
    this.featureConfigService = inject(FeatureConfigService);
    this.subscription = new Subscription();
  }
  /**
   * This function is to be called for the root component that is
   * bootstrapped.
   */
  init(rootComponent) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.rootComponent = rootComponent;
    // Theme value is a string. It is put in the generic multi-value
    // property of the SiteContextConfig. So the array's first item
    // is the theme value.
    if (this.featureConfigService.isEnabled('useSiteThemeService')) {
      this.subscription.add(this.siteThemeService.getActive().subscribe(activeTheme => this.setTheme(activeTheme)));
    } else {
      this.setTheme(this.config.context?.[THEME_CONTEXT_ID]?.[0]);
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  setTheme(theme) {
    const element = this.rootComponent.location.nativeElement;
    if (this.featureConfigService.isEnabled('useSiteThemeService')) {
      if (this.existingTheme) {
        this.renderer.removeClass(element, this.existingTheme);
      }
      if (theme) {
        this.renderer.addClass(element, theme);
        this.existingTheme = theme;
      }
    } else {
      if (theme) {
        this.renderer.removeClass(element, this.existingTheme);
        this.renderer.addClass(element, theme);
        this.existingTheme = theme;
      }
    }
  }
  static {
    this.ɵfac = function ThemeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThemeService)(i0.ɵɵinject(i1.SiteContextConfig), i0.ɵɵinject(i0.RendererFactory2));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ThemeService,
      factory: ThemeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SiteContextConfig
  }, {
    type: i0.RendererFactory2
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function initTheme(themeService) {
  const result = component => themeService.init(component);
  return result;
}
class ThemeModule {
  static {
    this.ɵfac = function ThemeModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ThemeModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ThemeModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: APP_BOOTSTRAP_LISTENER,
        multi: true,
        useFactory: initTheme,
        deps: [ThemeService]
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ThemeModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: APP_BOOTSTRAP_LISTENER,
        multi: true,
        useFactory: initTheme,
        deps: [ThemeService]
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LayoutModule {
  static {
    this.ɵfac = function LayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LayoutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LayoutModule,
      imports: [OutletRefModule, LaunchDialogModule, DirectionModule, ThemeModule],
      exports: [OutletRefModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultLayoutConfig)],
      imports: [OutletRefModule, LaunchDialogModule.forRoot(), DirectionModule, ThemeModule, OutletRefModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LayoutModule, [{
    type: NgModule,
    args: [{
      imports: [OutletRefModule, LaunchDialogModule.forRoot(), DirectionModule, ThemeModule],
      providers: [provideDefaultConfig(defaultLayoutConfig)],
      exports: [OutletRefModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var StorefrontOutlets;
(function (StorefrontOutlets) {
  StorefrontOutlets["STOREFRONT"] = "cx-storefront";
})(StorefrontOutlets || (StorefrontOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GlobalMessageComponent {
  constructor(globalMessageService) {
    this.globalMessageService = globalMessageService;
    this.iconTypes = ICON_TYPE;
    this.messageType = GlobalMessageType;
  }
  ngOnInit() {
    this.messages$ = this.globalMessageService.get();
  }
  clear(type, index) {
    this.globalMessageService.remove(type, index);
  }
  static {
    this.ɵfac = function GlobalMessageComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalMessageComponent)(i0.ɵɵdirectiveInject(i1.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GlobalMessageComponent,
      selectors: [["cx-global-message"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["class", "cx-visually-hidden", 4, "ngFor", "ngForOf"], ["class", "alert alert-success", 4, "ngFor", "ngForOf"], ["class", "alert alert-info", 4, "ngFor", "ngForOf"], ["class", "alert alert-warning", 4, "ngFor", "ngForOf"], ["class", "alert alert-danger", 4, "ngFor", "ngForOf"], [1, "cx-visually-hidden"], [1, "alert", "alert-success"], [1, "alert-icon"], [3, "type"], [1, "close", 3, "click", "title"], [1, "alert", "alert-info"], [1, "alert", "alert-warning"], [1, "alert", "alert-danger"]],
      template: function GlobalMessageComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, GlobalMessageComponent_div_0_Template, 6, 5, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.messages$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, IconComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalMessageComponent, [{
    type: Component,
    args: [{
      selector: 'cx-global-message',
      standalone: false,
      template: "<div *ngIf=\"messages$ | async as messages\">\n  <div\n    class=\"cx-visually-hidden\"\n    *ngFor=\"let assistiveMsg of messages[messageType.MSG_TYPE_ASSISTIVE]\"\n  >\n    <span>{{ assistiveMsg | cxTranslate }}</span>\n  </div>\n  <div\n    class=\"alert alert-success\"\n    *ngFor=\"\n      let confMsg of messages[messageType.MSG_TYPE_CONFIRMATION];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.SUCCESS\"></cx-icon>\n    </span>\n    <span>{{ confMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_CONFIRMATION, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-info\"\n    *ngFor=\"let infoMsg of messages[messageType.MSG_TYPE_INFO]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_INFO, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-warning\"\n    *ngFor=\"\n      let infoMsg of messages[messageType.MSG_TYPE_WARNING];\n      let i = index\n    \"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.WARNING\"></cx-icon>\n    </span>\n    <span>{{ infoMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_WARNING, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n  <div\n    class=\"alert alert-danger\"\n    *ngFor=\"let errorMsg of messages[messageType.MSG_TYPE_ERROR]; let i = index\"\n  >\n    <span class=\"alert-icon\">\n      <cx-icon [type]=\"iconTypes.ERROR\"></cx-icon>\n    </span>\n    <span>{{ errorMsg | cxTranslate }}</span>\n    <button\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      (click)=\"clear(messageType.MSG_TYPE_ERROR, i)\"\n    >\n      <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: i1.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StorefrontComponent {
  handleEscape(event) {
    this.keyboardFocusService.handleEscape(this.elementRef.nativeElement, this.keyboardFocusConfig, event);
  }
  constructor(hamburgerMenuService, routingService, elementRef, keyboardFocusService) {
    this.hamburgerMenuService = hamburgerMenuService;
    this.routingService = routingService;
    this.elementRef = elementRef;
    this.keyboardFocusService = keyboardFocusService;
    this.focusConfig = {
      disableMouseFocus: true,
      trap: false
    };
    this.skipFocusConfig = {
      isEnabled: false,
      activeElementSelectors: ['button.cx-hamburger']
    };
    this.isExpanded$ = this.hamburgerMenuService.isExpanded;
    this.StorefrontOutlets = StorefrontOutlets;
    this.featureConfigService = inject(FeatureConfigService);
    this.destroyRef = inject(DestroyRef);
    this.document = inject(DOCUMENT, {
      optional: true
    });
    this.skipLinkService = inject(SkipLinkService, {
      optional: true
    });
    // required by esc focus
    this.tabindex = '-1';
    this.keyboardFocusConfig = {
      focusOnEscape: true,
      focusOnDoubleEscape: true
    };
    useFeatureStyles('cmsBottomHeaderSlotUsingFlexStyles');
    useFeatureStyles('headerLayoutForSmallerViewports');
    useFeatureStyles('a11yPdpGridArrangement');
    useFeatureStyles('a11yKeyboardFocusInSearchBox');
    useFeatureStyles('a11yNgSelectLayering');
    useFeatureStyles('topProgressBarUseTransformAnimation');
  }
  ngOnInit() {
    this.navigateSubscription = this.routingService.isNavigating().subscribe(val => this.onNavigation(val));
    if (this.featureConfigService.isEnabled('a11yMobileFocusOnFirstNavigationItem')) {
      this.isExpanded$ = this.hamburgerMenuService.isExpanded.pipe(tap$1(isExpanded => {
        if (isExpanded) {
          this.focusOnFirstNavigationItem();
        }
      }));
    }
    if (this.featureConfigService.isEnabled('a11yHamburgerMenuTrapFocus')) {
      this.trapFocusOnMenuIfExpanded();
    }
  }
  collapseMenuIfClickOutside(event) {
    const element = event.target;
    if (element.nodeName.toLowerCase() === 'header' && element.className.includes('is-expanded')) {
      this.collapseMenu();
    }
  }
  collapseMenu() {
    this.hamburgerMenuService.toggle(true);
  }
  trapFocusOnMenuIfExpanded() {
    this.isExpanded$.pipe(distinctUntilChanged(), takeUntilDestroyed(this.destroyRef)).subscribe(isExpanded => {
      this.focusConfig = {
        ...this.focusConfig,
        trap: isExpanded
      };
      this.skipFocusConfig = {
        ...this.skipFocusConfig,
        isEnabled: isExpanded
      };
    });
  }
  focusOnFirstNavigationItem() {
    const closestNavigationUi = this.elementRef.nativeElement.querySelector('header cx-navigation-ui');
    const focusable = closestNavigationUi?.querySelector('li:not(.back) button, [tabindex="0"]');
    if (focusable) {
      setTimeout(() => focusable.focus());
    }
  }
  ngOnDestroy() {
    if (this.navigateSubscription) {
      this.navigateSubscription.unsubscribe();
    }
  }
  onNavigation(isNavigating) {
    this.startNavigating = isNavigating === true;
    this.stopNavigating = isNavigating === false;
    // After clicking a link the focus should move to the first available item in the main content area.
    if (this.featureConfigService.isEnabled('a11yResetFocusAfterNavigating') && this.stopNavigating && this.document?.activeElement !== this.document?.body) {
      this.skipLinkService?.scrollToTarget('cx-main');
    }
  }
  static {
    this.ɵfac = function StorefrontComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StorefrontComponent)(i0.ɵɵdirectiveInject(HamburgerMenuService), i0.ɵɵdirectiveInject(i1.RoutingService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(KeyboardFocusService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StorefrontComponent,
      selectors: [["cx-storefront"]],
      viewQuery: function StorefrontComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(SkipLinkComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.child = _t.first);
        }
      },
      hostVars: 5,
      hostBindings: function StorefrontComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.escape", function StorefrontComponent_keydown_escape_HostBindingHandler($event) {
            return ctx.handleEscape($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵhostProperty("tabindex", ctx.tabindex);
          i0.ɵɵclassProp("start-navigating", ctx.startNavigating)("stop-navigating", ctx.stopNavigating);
        }
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["cxPageTemplateStyle", "", 3, "cxOutlet"], ["cxOutlet", "cx-header"], ["cxSkipLink", "cx-main", 3, "cxFocus"], ["cxOutlet", "cx-footer"], ["id", "cx-header", "cxSkipLink", "cx-header", 3, "keydown.escape", "click", "cxFocus"], ["section", "header", 3, "cxSkipFocus"], ["section", "navigation"], ["position", "BottomHeaderSlot", 1, "cx-bottom-header-slot"], ["aria-atomic", "true", "aria-live", "assertive"], ["cxSkipLink", "cx-footer", 3, "cxFocus"], ["section", "footer"]],
      template: function StorefrontComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, StorefrontComponent_ng_template_0_Template, 4, 2, "ng-template", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxOutlet", ctx.StorefrontOutlets.STOREFRONT);
        }
      },
      dependencies: [i1$2.RouterOutlet, GlobalMessageComponent, OutletDirective, PageLayoutComponent, PageTemplateDirective, PageSlotComponent, FocusDirective, SkipFocusDirective, SkipLinkDirective, i3.AsyncPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorefrontComponent, [{
    type: Component,
    args: [{
      selector: 'cx-storefront',
      standalone: false,
      template: "<ng-template [cxOutlet]=\"StorefrontOutlets.STOREFRONT\" cxPageTemplateStyle>\n  <ng-template cxOutlet=\"cx-header\">\n    <header\n      id=\"cx-header\"\n      cxSkipLink=\"cx-header\"\n      [cxFocus]=\"focusConfig\"\n      [class.is-expanded]=\"isExpanded$ | async\"\n      (keydown.escape)=\"collapseMenu()\"\n      (click)=\"collapseMenuIfClickOutside($event)\"\n    >\n      <cx-page-layout\n        section=\"header\"\n        [cxSkipFocus]=\"skipFocusConfig\"\n      ></cx-page-layout>\n\n      <cx-page-layout section=\"navigation\"></cx-page-layout>\n    </header>\n    <cx-page-slot\n      position=\"BottomHeaderSlot\"\n      class=\"cx-bottom-header-slot\"\n    ></cx-page-slot>\n    <cx-global-message\n      aria-atomic=\"true\"\n      aria-live=\"assertive\"\n    ></cx-global-message>\n  </ng-template>\n\n  <main cxSkipLink=\"cx-main\" [cxFocus]=\"{ disableMouseFocus: true }\">\n    <router-outlet></router-outlet>\n  </main>\n\n  <ng-template cxOutlet=\"cx-footer\">\n    <footer cxSkipLink=\"cx-footer\" [cxFocus]=\"{ disableMouseFocus: true }\">\n      <cx-page-layout section=\"footer\"></cx-page-layout>\n    </footer>\n  </ng-template>\n</ng-template>\n"
    }]
  }], () => [{
    type: HamburgerMenuService
  }, {
    type: i1.RoutingService
  }, {
    type: i0.ElementRef
  }, {
    type: KeyboardFocusService
  }], {
    document: [{
      type: Optional
    }],
    skipLinkService: [{
      type: Optional
    }],
    startNavigating: [{
      type: HostBinding,
      args: ['class.start-navigating']
    }],
    stopNavigating: [{
      type: HostBinding,
      args: ['class.stop-navigating']
    }],
    tabindex: [{
      type: HostBinding,
      args: ['tabindex']
    }],
    child: [{
      type: ViewChild,
      args: [SkipLinkComponent]
    }],
    handleEscape: [{
      type: HostListener,
      args: ['keydown.escape', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class GlobalMessageComponentModule {
  static {
    this.ɵfac = function GlobalMessageComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GlobalMessageComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GlobalMessageComponentModule,
      declarations: [GlobalMessageComponent],
      imports: [CommonModule, IconModule, I18nModule],
      exports: [GlobalMessageComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GlobalMessageComponentModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, IconModule, I18nModule],
      declarations: [GlobalMessageComponent],
      exports: [GlobalMessageComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StorefrontComponentModule {
  static {
    this.ɵfac = function StorefrontComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StorefrontComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StorefrontComponentModule,
      declarations: [StorefrontComponent],
      imports: [CommonModule, RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PageLayoutModule, PageSlotModule, KeyboardFocusModule, SkipLinkModule],
      exports: [StorefrontComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PageLayoutModule, PageSlotModule, KeyboardFocusModule, SkipLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StorefrontComponentModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PageLayoutModule, PageSlotModule, KeyboardFocusModule, SkipLinkModule],
      declarations: [StorefrontComponent],
      exports: [StorefrontComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ARIA_LABEL = 'aria-label';
class NgSelectA11yDirective {
  //TODO: CXSPA-9005: Remove this method in next major release
  /**
   * @deprecated since 2211.33
   */
  onOpen() {
    if (!this.featureConfigService?.isEnabled('a11yNgSelectOptionsCount')) {
      return;
    }
    const observer = new MutationObserver((changes, observerInstance) => this.appendAriaLabelToOptions(changes, observerInstance));
    observer.observe(this.elementRef.nativeElement, {
      childList: true
    });
  }
  /**
   * When we inside a combo box using JAWS screen reader and press escape key
   * an escape keyboard event doesn't get fired, instead an AltLeft is fired.
   */
  onKeyUp(event) {
    if (!this.featureConfigService?.isEnabled('a11yNgSelectCloseDropdownOnEscape')) {
      return;
    }
    const jawsEscapeCode = 'AltLeft';
    if (event.code === jawsEscapeCode) {
      this.selectComponent.close();
    }
  }
  onEscape() {
    setTimeout(() => {
      this.elementRef.nativeElement.querySelector('input').focus();
    });
  }
  constructor(renderer, elementRef) {
    this.renderer = renderer;
    this.elementRef = elementRef;
    this.translationService = inject(TranslationService);
    this.domSanitizer = inject(DomSanitizer);
    this.selectComponent = inject(NgSelectComponent);
    this.destroyRef = inject(DestroyRef);
    this.featureConfigService = inject(FeatureConfigService);
    this.breakpointService = inject(BreakpointService, {
      optional: true
    });
  }
  ngAfterViewInit() {
    const inputCombobox = this.elementRef.nativeElement.querySelector('[role="combobox"]');
    this.renderer.setAttribute(inputCombobox, 'role', 'combobox');
    this.renderer.setAttribute(inputCombobox, 'aria-expanded', 'false');
    if (this.featureConfigService?.isEnabled('a11yNgSelectAriaLabelDropdownCustomized')) {
      this.customizeNgSelectAriaLabelDropdown();
    }
    const isOpened$ = this.selectComponent.openEvent.pipe(map(() => 'true'));
    const isClosed$ = this.selectComponent.closeEvent.pipe(map(() => 'false'));
    merge(isOpened$, isClosed$).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(state => {
      this.renderer.setAttribute(inputCombobox, 'aria-expanded', state);
      if (ariaControls && this.featureConfigService.isEnabled('a11yNgSelectAriaControls')) {
        // Delay execution to come after the ng-select's own 'aria-controls' logic
        setTimeout(() => {
          this.renderer.setAttribute(inputCombobox, 'aria-controls', ariaControls);
        });
      }
    });
    const ariaLabel = this.cxNgSelectA11y.ariaLabel;
    const elementId = this.elementRef.nativeElement.id;
    const ariaControls = this.cxNgSelectA11y.ariaControls ?? elementId;
    if (ariaLabel) {
      this.renderer.setAttribute(inputCombobox, ARIA_LABEL, ariaLabel);
    }
    if (ariaControls) {
      this.renderer.setAttribute(inputCombobox, 'aria-controls', ariaControls);
    }
    if (this.featureConfigService.isEnabled('a11yNgSelectMobileReadout') && inputCombobox.readOnly && isPlatformBrowser(this.platformId)) {
      this.breakpointService?.isDown(BREAKPOINT.md).pipe(filter$1(Boolean), take$1(1)).subscribe(() => {
        const selectObserver = new MutationObserver((changes, observer) => {
          this.appendValueToAriaLabel(changes, observer, inputCombobox);
        });
        selectObserver.observe(this.elementRef.nativeElement, {
          subtree: true,
          characterData: true
        });
      });
    }
  }
  //TODO: CXSPA-9005: Remove this method in next major release
  /**
   * @deprecated since 2211.33
   */
  appendAriaLabelToOptions(_changes, observerInstance) {
    const options = this.elementRef?.nativeElement.querySelectorAll('.ng-option');
    if (options?.length) {
      this.translationService.translate('common.of').pipe(take$1(1)).subscribe(translation => {
        options.forEach((option, index) => {
          const sanitizedOptionText = this.domSanitizer.sanitize(SecurityContext.HTML, option.innerText);
          const ariaLabel = `${sanitizedOptionText}, ${+index + 1} ${translation} ${options.length}`;
          this.renderer.setAttribute(option, ARIA_LABEL, ariaLabel);
        });
      });
    }
    observerInstance.disconnect();
  }
  /**
   * Hides the input value from the screen reader and provides it as part of the aria-label instead.
   * This improves the screen reader output on mobile devices.
   */
  appendValueToAriaLabel(_changes, observer, divCombobox) {
    const sanitizedValueLabel = this.domSanitizer.sanitize(SecurityContext.HTML, this.elementRef.nativeElement.querySelector('.ng-value-label')?.innerText);
    if (sanitizedValueLabel) {
      const comboboxAriaLabel = divCombobox?.getAttribute(ARIA_LABEL) || '';
      const valueElement = this.elementRef.nativeElement.querySelector('.ng-value');
      this.renderer.setAttribute(valueElement, 'aria-hidden', 'true');
      this.renderer.setAttribute(divCombobox, ARIA_LABEL, comboboxAriaLabel + ', ' + sanitizedValueLabel);
    }
    observer.disconnect();
  }
  customizeNgSelectAriaLabelDropdown() {
    this.translationService.translate('common.ngSelectDropdownOptionsList').pipe(take$1(1)).subscribe(translation => {
      this.selectComponent.ariaLabelDropdown = translation;
    });
  }
  static {
    this.ɵfac = function NgSelectA11yDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgSelectA11yDirective)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NgSelectA11yDirective,
      selectors: [["", "cxNgSelectA11y", ""]],
      hostBindings: function NgSelectA11yDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("open", function NgSelectA11yDirective_open_HostBindingHandler() {
            return ctx.onOpen();
          })("keyup", function NgSelectA11yDirective_keyup_HostBindingHandler($event) {
            return ctx.onKeyUp($event);
          })("keydown.escape", function NgSelectA11yDirective_keydown_escape_HostBindingHandler() {
            return ctx.onEscape();
          });
        }
      },
      inputs: {
        cxNgSelectA11y: "cxNgSelectA11y"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgSelectA11yDirective, [{
    type: Directive,
    args: [{
      selector: '[cxNgSelectA11y]',
      standalone: false
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }], {
    cxNgSelectA11y: [{
      type: Input
    }],
    //TODO: CXSPA-9005: Remove this method in next major release
    /**
     * @deprecated since 2211.33
     */
    onOpen: [{
      type: HostListener,
      args: ['open']
    }],
    onKeyUp: [{
      type: HostListener,
      args: ['keyup', ['$event']]
    }],
    onEscape: [{
      type: HostListener,
      args: ['keydown.escape']
    }],
    breakpointService: [{
      type: Optional
    }],
    platformId: [{
      type: Inject,
      args: [PLATFORM_ID]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SortingComponent {
  constructor() {
    this.sortListEvent = new EventEmitter();
  }
  sortList(sortCode) {
    this.sortListEvent.emit(sortCode);
  }
  get selectedLabel() {
    if (this.selectedOption) {
      return this.sortOptions?.find(sort => sort.code === this.selectedOption)?.name ?? this.sortLabels?.[this.selectedOption];
    }
  }
  static {
    this.ɵfac = function SortingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortingComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SortingComponent,
      selectors: [["cx-sorting"]],
      inputs: {
        sortOptions: "sortOptions",
        ariaControls: "ariaControls",
        ariaLabel: "ariaLabel",
        selectedOption: "selectedOption",
        placeholder: "placeholder",
        sortLabels: "sortLabels"
      },
      outputs: {
        sortListEvent: "sortListEvent"
      },
      standalone: false,
      decls: 3,
      vars: 11,
      consts: [[3, "change", "searchable", "clearable", "placeholder", "ngModel", "cxNgSelectA11y"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]],
      template: function SortingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "ng-select", 0);
          i0.ɵɵpipe(1, "cxTranslate");
          i0.ɵɵlistener("change", function SortingComponent_Template_ng_select_change_0_listener($event) {
            return ctx.sortList($event);
          });
          i0.ɵɵtemplate(2, SortingComponent_ng_option_2_Template, 2, 2, "ng-option", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
          i0.ɵɵproperty("searchable", false)("clearable", false)("ngModel", ctx.selectedOption)("cxNgSelectA11y", i0.ɵɵpureFunction2(8, _c29, ctx.ariaLabel || i0.ɵɵpipeBind1(1, 6, "productList.sortResults"), ctx.ariaControls));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.sortOptions);
        }
      },
      dependencies: [i3.NgForOf, i2.NgSelectComponent, i2.NgOptionComponent, i1$4.NgControlStatus, i1$4.NgModel, NgSelectA11yDirective, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-sorting',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-select\n  [searchable]=\"false\"\n  [clearable]=\"false\"\n  placeholder=\"{{ placeholder }}\"\n  (change)=\"sortList($event)\"\n  [ngModel]=\"selectedOption\"\n  [cxNgSelectA11y]=\"{\n    ariaLabel: ariaLabel || ('productList.sortResults' | cxTranslate),\n    ariaControls: ariaControls,\n  }\"\n>\n  <ng-option *ngFor=\"let sort of sortOptions\" [value]=\"sort.code\">{{\n    sort.name ? sort.name : sortLabels && sort.code ? sortLabels[sort.code] : ''\n  }}</ng-option>\n</ng-select>\n"
    }]
  }], () => [], {
    sortOptions: [{
      type: Input
    }],
    ariaControls: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    selectedOption: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    sortLabels: [{
      type: Input
    }],
    sortListEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NgSelectA11yModule {
  static {
    this.ɵfac = function NgSelectA11yModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NgSelectA11yModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NgSelectA11yModule,
      declarations: [NgSelectA11yDirective],
      exports: [NgSelectA11yDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgSelectA11yModule, [{
    type: NgModule,
    args: [{
      declarations: [NgSelectA11yDirective],
      exports: [NgSelectA11yDirective]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SortingModule {
  static {
    this.ɵfac = function SortingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SortingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SortingModule,
      declarations: [SortingComponent],
      imports: [CommonModule, NgSelectModule, FormsModule, NgSelectA11yModule, I18nModule],
      exports: [SortingComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NgSelectModule, FormsModule, NgSelectA11yModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SortingModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NgSelectModule, FormsModule, NgSelectA11yModule, I18nModule],
      declarations: [SortingComponent],
      exports: [SortingComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultPaginationConfig = {
  pagination: {
    addStart: true,
    addEnd: true
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaginationConfig {
  static {
    this.ɵfac = function PaginationConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PaginationConfig,
      factory: function PaginationConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || PaginationConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The item type is used to add semantic structure to the
 * PaginationItem, so that the UI understands the usage.
 */
var PaginationItemType;
(function (PaginationItemType) {
  PaginationItemType["GAP"] = "gap";
  PaginationItemType["FIRST"] = "first";
  PaginationItemType["LAST"] = "last";
  PaginationItemType["PREVIOUS"] = "previous";
  PaginationItemType["NEXT"] = "next";
  PaginationItemType["START"] = "start";
  PaginationItemType["END"] = "end";
  PaginationItemType["PAGE"] = "page";
})(PaginationItemType || (PaginationItemType = {}));
var PaginationNavigationPosition;
(function (PaginationNavigationPosition) {
  PaginationNavigationPosition["ASIDE"] = "aside";
  PaginationNavigationPosition["BEFORE"] = "before";
  PaginationNavigationPosition["AFTER"] = "after";
})(PaginationNavigationPosition || (PaginationNavigationPosition = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const FALLBACK_PAGINATION_OPTIONS = {
  rangeCount: 3,
  dotsLabel: '...',
  startLabel: '«',
  previousLabel: '‹',
  nextLabel: '›',
  endLabel: '»'
};
/**
 * Builds a pagination structures based on a pageCount and current page number.
 * There are various {@link PaginationConfig} options which can be used to configure
 * the behavior of the build. Alternatively, CSS can be used to further customize
 * the pagination.
 *
 * Examples:
 * The full blown pagination items contain the follow elements:
 *
 * `« ‹ 1 ... 4 (5) 6 ... 9 › »`
 *
 * This includes pagination items to the following pages:
 * - start page
 * - previous page
 * - first page
 * - page range
 * - last page
 * - next page
 * - end page
 *
 * All of those links are configurable, including the size of the page range.
 * The current page will always be centered in the page range to provide direct access
 * to the previous and next page.
 */
class PaginationBuilder {
  constructor(paginationConfig) {
    this.paginationConfig = paginationConfig;
  }
  /**
   * Builds a list of `PaginationItem`. The give pageCount and current are used
   * to build out the full pagination. There are various {@link PaginationConfig} options
   * which can be used to configure the behavior of the build. Alternatively, CSS
   * can be used to further specialize visibility of the pagination.
   *
   * @param pageCount The total number of pages
   * @param current The current page number, 0-index based
   * @returns An array of `PaginationItem`
   */
  paginate(pageCount, current) {
    const pages = [];
    if (!pageCount || pageCount < 2) {
      return pages;
    }
    this.addPages(pages, pageCount, current);
    this.addDots(pages, pageCount);
    this.addFirstLast(pages, pageCount);
    this.addNavigation(pages, pageCount, current);
    return pages;
  }
  /**
   * Returns the current page with surrounding pages (based on the `config.rangeCount`).
   * The current page is always centered to provide direct access to the previous and next page.
   *
   * @param pages The list of page items that is used to amend
   * @param pageCount The total number of pages
   * @param current The current page number, 0-index based
   */
  addPages(pages, pageCount, current) {
    const start = this.getStartOfRange(pageCount, current);
    if (this.config.rangeCount !== undefined && start !== null) {
      const max = Math.min(this.config.rangeCount, pageCount);
      Array.from(Array(max)).forEach((_, i) => {
        pages.push({
          number: i + start,
          label: String(i + start + 1),
          type: PaginationItemType.PAGE
        });
      });
    }
  }
  /**
   * Adds dots before and after the given pages, if configured (defaults to true).
   * If the dots only represent a single page, the page number is added instead of
   * the dots, unless the configuration requires dots always.
   *
   * @param pages The list of page items that is used to amend
   * @param pageCount The total number of pages
   */
  addDots(pages, pageCount) {
    if (!this.config.addDots) {
      return;
    }
    pages.unshift(...this.addFirstGapToDots(pages));
    pages.push(...this.addLastGapToDots(pages, pageCount));
  }
  /**
   * Helper method for addDots() whether to add the first gap.
   */
  addFirstGapToDots(pages) {
    const firstItemNumber = pages[0].number;
    const gapNumber = Number(this.config.addFirst);
    if (firstItemNumber !== undefined && firstItemNumber > gapNumber) {
      const isGap = !this.config.substituteDotsForSingularPage || firstItemNumber !== gapNumber + 1;
      const isSubstituted = this.config.addFirst && this.config.substituteDotsForSingularPage && gapNumber === 0;
      const type = isGap ? PaginationItemType.GAP : isSubstituted ? PaginationItemType.FIRST : PaginationItemType.PAGE;
      return [Object.assign({
        label: isGap ? this.config.dotsLabel : String(gapNumber + 1),
        type
      }, isGap ? null : {
        number: gapNumber
      })];
    } else {
      return [];
    }
  }
  /**
   * Helper method for addDots() whether to add the last gap.
   */
  addLastGapToDots(pages, pageCount) {
    const pageNumber = pages[pages.length - 1].number;
    const nextPageNumber = pageNumber ? pageNumber + 1 : undefined;
    const last = pageCount - (Number(this.config.addLast) + 1);
    if (nextPageNumber && nextPageNumber <= last) {
      const isSubstituted = this.config.addLast && this.config.substituteDotsForSingularPage && nextPageNumber === last;
      const isGap = nextPageNumber < pageCount - Number(this.config.substituteDotsForSingularPage) - Number(this.config.addLast);
      const type = isGap ? PaginationItemType.GAP : isSubstituted ? PaginationItemType.LAST : PaginationItemType.PAGE;
      return [Object.assign({
        label: isGap ? this.config.dotsLabel : String(nextPageNumber + 1),
        type
      }, isGap ? null : {
        number: nextPageNumber
      })];
    } else {
      return [];
    }
  }
  /**
   * Add links to the first and last page, if configured to do so.
   *
   * @param pages The list of page items that is used to amend
   * @param pageCount The total number of pages
   *
   */
  addFirstLast(pages, pageCount) {
    if (this.config.addFirst && pages[0].number !== 0) {
      pages.unshift({
        number: 0,
        label: '1',
        type: PaginationItemType.FIRST
      });
    }
    if (this.config.addLast && pages[pages.length - 1].number !== pageCount - 1) {
      pages.push({
        number: pageCount - 1,
        label: String(pageCount),
        type: PaginationItemType.LAST
      });
    }
  }
  /**
   * Add links to the start, previous, next and last page, if configured to do so.
   * The order of the links can be configured by using the {@link PaginationConfig},
   * using the `PaginationNavigationPosition` (`BEFORE` or `AFTER`).
   * The `PaginationNavigationPosition` allows for 3 flavours:
   *
   * - by default the pagination starts with start and previous and ends with the next and end links
   * - BEFORE – all navigation links are added in the front of the pagination list
   * - AFTER – all navigation links are pushed to the end of the pagination list
   *
   * @param pages The list of page items that is used to amend
   * @param pageCount The total number of pages
   * @param current The current page number, 0-index based
   *
   */
  addNavigation(pages, pageCount, current) {
    const before = this.getBeforeLinks(current);
    const after = this.getAfterLinks(pageCount, current);
    const pos = this.config.navigationPosition;
    if (!pos || pos === PaginationNavigationPosition.ASIDE) {
      pages.unshift(...before);
      pages.push(...after);
    } else {
      if (pos === PaginationNavigationPosition.BEFORE) {
        pages.unshift(...before, ...after);
      }
      if (pos === PaginationNavigationPosition.AFTER) {
        pages.push(...before, ...after);
      }
    }
  }
  /**
   * Returns the start and previous links, if applicable.
   */
  getBeforeLinks(current) {
    const list = [];
    if (this.config.addStart) {
      const start = () => {
        return Object.assign({
          label: this.config.startLabel,
          type: PaginationItemType.START
        }, current > 0 ? {
          number: 0
        } : null);
      };
      list.push(start());
    }
    if (this.config.addPrevious) {
      const previous = () => {
        return Object.assign({
          label: this.config.previousLabel,
          type: PaginationItemType.PREVIOUS
        }, current > 0 ? {
          number: current - 1
        } : null);
      };
      list.push(previous());
    }
    return list;
  }
  /**
   * Returns the next and end links, if applicable.
   */
  getAfterLinks(pageCount, current) {
    const list = [];
    if (this.config.addNext) {
      const next = () => {
        return Object.assign({
          label: this.config.nextLabel,
          type: PaginationItemType.NEXT
        }, current < pageCount - 1 ? {
          number: current + 1
        } : null);
      };
      list.push(next());
    }
    if (this.config.addEnd) {
      const end = () => {
        return Object.assign({
          label: this.config.endLabel,
          type: PaginationItemType.END
        }, current < pageCount - 1 ? {
          number: pageCount - 1
        } : null);
      };
      list.push(end());
    }
    return list;
  }
  /**
   * Resolves the first page of the range we need to build.
   * This is the page that is leading up to the range of the
   * current page.
   *
   * @param pageCount The total number of pages.
   * @param current The current page number, 0-index based.
   */
  getStartOfRange(pageCount, current) {
    if (this.config.rangeCount !== undefined) {
      const count = this.config.rangeCount - 1;
      // the least number of pages before and after the current
      const delta = Math.round(count / 2);
      // ensure that we start with at least the first page
      const minStart = Math.max(0, current - delta);
      // ensures that we start with at least 1 and do not pass the last range
      const maxStart = Math.max(0, pageCount - count - 1);
      // ensure that we get at least a full range at the end
      return Math.min(maxStart, minStart);
    }
    return null;
  }
  /**
   * Returns the pagination configuration. The configuration is driven by the
   * (default) application configuration.
   *
   * The default application is limited to adding the start and end link:
   * ```ts
   *   addStart: true,
   *   addEnd: true
   * ```
   *
   * The application configuration is however merged into the following static configuration:
   * ```ts
   * {
   *   rangeCount: 3,
   *   dotsLabel: '...',
   *   startLabel: '«',
   *   previousLabel: '‹',
   *   nextLabel: '›',
   *   endLabel: '»'
   * }
   * ```
   */
  get config() {
    return Object.assign(FALLBACK_PAGINATION_OPTIONS, this.paginationConfig.pagination);
  }
  static {
    this.ɵfac = function PaginationBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationBuilder)(i0.ɵɵinject(PaginationConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PaginationBuilder,
      factory: PaginationBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: PaginationConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `PaginationComponent` is a generic component that is used for
 * all lists in Spartacus that require pagination. The component supports
 * all common features, which can be configured or hidden by CSS.
 */
class PaginationComponent {
  get pagination() {
    return this._pagination;
  }
  set pagination(value) {
    if (value) {
      this._pagination = value;
      this.render(value);
    }
  }
  constructor(paginationBuilder, activatedRoute) {
    this.paginationBuilder = paginationBuilder;
    this.activatedRoute = activatedRoute;
    /** The (optional) pageRoute used for the anchor links created in the pagination   */
    this.pageRoute = '.';
    /**
     * If more than one pagination is present on a page, a unique id should be set for each instance.
     * This ensures the focus can be preserved after navigating to a different page.
     */
    this.paginationID = 'pagination';
    this.viewPageEvent = new EventEmitter();
    this.pages = [];
    this.translationService = inject(TranslationService);
  }
  render(pagination) {
    if (!pagination) {
      return;
    }
    this.pages = this.paginationBuilder.paginate(pagination.totalPages ?? 0, pagination.currentPage ?? 0);
  }
  /**
   * Format aria-label based on pagination item type.
   *
   * @param item PaginationItem
   * @returns Observable
   */
  getAriaLabel$(item) {
    // Convert 'Start' to First, and 'End' to Last for a more natural screen read.
    let type = item.type;
    type = type === PaginationItemType.START ? PaginationItemType.FIRST : type;
    type = type === PaginationItemType.END ? PaginationItemType.LAST : type;
    const initialLabel = type === PaginationItemType.PAGE ? `${type} ${item.label}` : `${type} ${PaginationItemType.PAGE}`;
    if (!this.translationService) {
      return of(initialLabel);
    }
    return combineLatest([this.translationService?.translate('navigation.goTo', {
      location: initialLabel
    }), this.translationService?.translate('common.selected')]).pipe(map$1(([goToTranslation, selectedTranslation]) => {
      return this.isCurrent(item) ? `${goToTranslation}, ${selectedTranslation}` : goToTranslation;
    }));
  }
  /**
   * Indicates whether the given item is the current item.
   *
   * @param item PaginationItem
   * @returns boolean
   */
  isCurrent(item) {
    return item.type === PaginationItemType.PAGE && item.number === this.pagination.currentPage;
  }
  /**
   * Indicates whether the pagination item is inactive. This is used
   * to disabled a link or set the tabindex to `-1`.
   *
   * Defaults to true
   *
   * @param item PaginationItem
   * @returns returns -1 in case of a disabled
   */
  isInactive(item) {
    return !item.hasOwnProperty('number') || item.number === this.pagination.currentPage;
  }
  getQueryParams(item) {
    const queryParams = Object.assign({}, this.activatedRoute.snapshot.queryParams);
    if (this.queryParam && item.number !== undefined && this.pagination.totalPages !== undefined && item.number < this.pagination.totalPages && !this.isCurrent(item)) {
      queryParams[this.queryParam] = item.number;
    }
    // omit the page number from the query parameters in case it's the default
    // to clean up the experience and avoid unnecessary polluting of the URL
    if (queryParams[this.queryParam] === this.defaultPage) {
      delete queryParams[this.queryParam];
    }
    return queryParams;
  }
  pageChange(page) {
    this.viewPageEvent.emit(page.number);
  }
  static {
    this.ɵfac = function PaginationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationComponent)(i0.ɵɵdirectiveInject(PaginationBuilder), i0.ɵɵdirectiveInject(i1$2.ActivatedRoute));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PaginationComponent,
      selectors: [["cx-pagination"]],
      inputs: {
        pageRoute: "pageRoute",
        queryParam: "queryParam",
        defaultPage: "defaultPage",
        pagination: "pagination",
        paginationID: "paginationID"
      },
      outputs: {
        viewPageEvent: "viewPageEvent"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[3, "class", "disabled", "current", "routerLink", "queryParams", "tabIndex", "cxFocus", "click", 4, "ngFor", "ngForOf"], [3, "click", "routerLink", "queryParams", "tabIndex", "cxFocus"]],
      template: function PaginationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PaginationComponent_a_0_Template, 4, 21, "a", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngForOf", ctx.pages);
        }
      },
      dependencies: [i3.NgForOf, i1$2.RouterLink, FocusDirective, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-pagination',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<a\n  *ngFor=\"let item of pages; let i = index\"\n  [class]=\"item.type\"\n  [class.disabled]=\"isInactive(item)\"\n  [class.current]=\"isCurrent(item)\"\n  [routerLink]=\"pageRoute\"\n  [queryParams]=\"getQueryParams(item)\"\n  [tabIndex]=\"isInactive(item) ? -1 : 0\"\n  [attr.aria-current]=\"isCurrent(item)\"\n  [attr.aria-disabled]=\"isInactive(item)\"\n  (click)=\"pageChange(item)\"\n  [attr.aria-label]=\"getAriaLabel$(item) | async\"\n  [attr.title]=\"getAriaLabel$(item) | async\"\n  [cxFocus]=\"{ key: paginationID + i.toString() }\"\n>\n  {{ item.label }}\n</a>\n"
    }]
  }], () => [{
    type: PaginationBuilder
  }, {
    type: i1$2.ActivatedRoute
  }], {
    pageRoute: [{
      type: Input
    }],
    queryParam: [{
      type: Input
    }],
    defaultPage: [{
      type: Input
    }],
    pagination: [{
      type: Input
    }],
    paginationID: [{
      type: Input
    }],
    viewPageEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaginationModule {
  static {
    this.ɵfac = function PaginationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaginationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PaginationModule,
      declarations: [PaginationComponent],
      imports: [CommonModule, RouterModule, I18nModule, FeaturesConfigModule, KeyboardFocusModule],
      exports: [PaginationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultPaginationConfig)],
      imports: [CommonModule, RouterModule, I18nModule, FeaturesConfigModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaginationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, FeaturesConfigModule, KeyboardFocusModule],
      providers: [provideDefaultConfig(defaultPaginationConfig)],
      declarations: [PaginationComponent],
      exports: [PaginationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TotalComponent {
  get pagination() {
    return this._pagination;
  }
  set pagination(paginationModel) {
    this._pagination = paginationModel ?? {
      totalResults: 0
    };
  }
  /**
   * Current page, starting form page 0
   * */
  get currentPage() {
    return this.pagination?.currentPage ?? 0;
  }
  get pageSize() {
    return this.pagination?.pageSize ?? 0;
  }
  get totalResults() {
    return this.pagination?.totalResults ?? 0;
  }
  get fromItem() {
    return this.currentPage * this.pageSize + 1;
  }
  get toItem() {
    const lastItem = (this.currentPage + 1) * this.pageSize;
    return lastItem > this.totalResults ? this.totalResults : lastItem;
  }
  static {
    this.ɵfac = function TotalComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TotalComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TotalComponent,
      selectors: [["cx-total"]],
      inputs: {
        pagination: "pagination"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [1, "cx-vertical-line-separator"]],
      template: function TotalComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TotalComponent_ng_container_0_Template, 8, 10, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.totalResults > 0);
        }
      },
      dependencies: [i3.NgIf, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TotalComponent, [{
    type: Component,
    args: [{
      selector: 'cx-total',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"totalResults > 0\">\n  <div>{{ totalResults }} {{ 'common.results' | cxTranslate }}</div>\n  <div class=\"cx-vertical-line-separator\"></div>\n  <div>\n    {{ fromItem }}-{{ toItem }} {{ 'common.of' | cxTranslate }}\n    {{ totalResults }}\n  </div>\n</ng-container>\n"
    }]
  }], null, {
    pagination: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TotalModule {
  static {
    this.ɵfac = function TotalModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TotalModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TotalModule,
      declarations: [TotalComponent],
      imports: [CommonModule, FormsModule, I18nModule],
      exports: [TotalComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TotalModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, I18nModule],
      declarations: [TotalComponent],
      exports: [TotalComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ListNavigationModule {
  static {
    this.ɵfac = function ListNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ListNavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ListNavigationModule,
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, IconModule, PaginationModule, SortingModule, TotalModule],
      exports: [SortingComponent, PaginationComponent, TotalComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, IconModule, PaginationModule, SortingModule, TotalModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ListNavigationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NgSelectModule, FormsModule, ReactiveFormsModule, IconModule, PaginationModule, SortingModule, TotalModule],
      exports: [SortingComponent, PaginationComponent, TotalComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides configuration specific to Media, such as images. This is used to optimize
 * rendering of the media, SEO and performance.
 */
class MediaConfig {
  static {
    this.ɵfac = function MediaConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MediaConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MediaConfig,
      factory: function MediaConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || MediaConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MediaConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProgressButtonComponent {
  constructor() {
    this.ariaLabel = '';
    this.class = '';
    this.disabled = false;
    this.loading = false;
    this.clickEvent = new EventEmitter();
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function ProgressButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressButtonComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProgressButtonComponent,
      selectors: [["cx-progress-button"]],
      inputs: {
        ariaLabel: "ariaLabel",
        class: "class",
        disabled: "disabled",
        loading: "loading"
      },
      outputs: {
        clickEvent: "clickEvent"
      },
      standalone: false,
      ngContentSelectors: _c1,
      decls: 4,
      vars: 4,
      consts: [[1, "btn", "btn-primary", 3, "click", "disabled", "ngClass"], [1, "cx-progress-button-container"], ["class", "loader-container", 4, "ngIf"], [1, "loader-container"], [1, "loader"]],
      template: function ProgressButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵlistener("click", function ProgressButtonComponent_Template_button_click_0_listener() {
            return ctx.clickEvent.emit();
          });
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵtemplate(2, ProgressButtonComponent_div_2_Template, 4, 3, "div", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("disabled", ctx.disabled || ctx.loading)("ngClass", ctx.class);
          i0.ɵɵattribute("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.loading);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressButtonComponent, [{
    type: Component,
    args: [{
      selector: 'cx-progress-button',
      standalone: false,
      template: "<button\n  (click)=\"clickEvent.emit()\"\n  [attr.aria-label]=\"ariaLabel\"\n  [disabled]=\"disabled || loading\"\n  [ngClass]=\"class\"\n  class=\"btn btn-primary\"\n>\n  <div class=\"cx-progress-button-container\">\n    <div *ngIf=\"loading\" class=\"loader-container\">\n      <div class=\"loader\">{{ 'spinner.loading' | cxTranslate }}</div>\n    </div>\n    <ng-content></ng-content>\n  </div>\n</button>\n"
    }]
  }], () => [], {
    ariaLabel: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    clickEvent: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProgressButtonModule {
  static {
    this.ɵfac = function ProgressButtonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProgressButtonModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProgressButtonModule,
      declarations: [ProgressButtonComponent],
      imports: [CommonModule, I18nModule],
      exports: [ProgressButtonComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProgressButtonModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule],
      declarations: [ProgressButtonComponent],
      exports: [ProgressButtonComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Supposed to be injected in the split view component, so that the split view state
 * is maintained for a single split view.
 */
class SplitViewService {
  constructor() {
    /**
     * Newly added views are hidden by default, unless it is the first view of the split view.
     * The default hide mode can be overridden.
     */
    this.defaultHideMode = true;
    this.splitViewCount = 1;
    this._views$ = new BehaviorSubject([]);
  }
  /**
   * Adds a view to the list of views. The view is initialized with the `SplitViewState`
   * state. If no state is provided, the state is created with the hidden property. The hidden
   * property is provided by the `defaultHideMode`, unless it's the first view (position: 0).
   */
  add(position, initialState) {
    const state = {
      ...{
        hidden: position === 0 ? false : this.defaultHideMode
      },
      ...initialState
    };
    if (!this.views[position]) {
      this.views[position] = state;
      this.updateState(position, state.hidden);
      this._views$.next(this.views);
    }
  }
  /**
   * The split view is based on a number of views that can be used next to each other.
   * When the number changes (i.e. if the screen goes from wide to small), the visibility state
   * of the views should be updated.
   */
  updateSplitView(splitViewCount) {
    if (splitViewCount !== this.splitViewCount) {
      this.splitViewCount = splitViewCount;
      this.updateState();
    }
  }
  /**
   * Returns an observable with the active view number. The active view number
   * represents the last visible view.
   */
  getActiveView() {
    return this._views$.pipe(map(views => this.getActive(views)), distinctUntilChanged());
  }
  /**
   * Returns an observable with the SplitViewState for the given view position.
   */
  getViewState(position) {
    return this._views$.pipe(map(views => views[position]),
    // we must filter here, since outlet driven views will destroyed the view
    filter(view => Boolean(view)));
  }
  /**
   * Removes a view from the list of views.
   *
   * Removing a view is different from hiding a view. Removing a view is typically done
   * when a component is destroyed.
   *
   * When the view is removed, the SplitViewState is updated to reflect that new organization
   * of views.
   */
  remove(position) {
    const activePosition = this.getActive(this.views);
    this._views$.next(this.views.splice(0, position));
    if (activePosition >= position) {
      this.updateState(position);
    }
  }
  /**
   * Returns the next view position. This is useful for views that do not want to be bothered
   * with controlling view numbers.
   */
  get nextPosition() {
    return this.views.length || 0;
  }
  /**
   * Toggles the visibility of the views based on the given view position. If the view
   * is already visible, we close the view and active the former view. Unless the hide flag
   * is used, to force the view.
   *
   * The view state of other views in the split view are updated as well.
   *
   * @param position The zero-based position number of the view.
   * @param forceHide The (optional) hide state for the view position.
   */
  toggle(position, forceHide) {
    // add the view if it hasn't been added before.
    if (!this.views[position]) {
      this.add(position, {
        hidden: forceHide ?? false
      });
    }
    // If the position is already visible, we move to a previous position. Only if the hide
    // state is forced, we keep the current position.
    if (this.views[position] && forceHide === undefined && !this.views[position].hidden) {
      position--;
    }
    this.updateState(position, forceHide === true);
  }
  /**
   * Updates the hidden state of all the views.
   */
  updateState(position, hide) {
    const views = [...this.views];
    if (hide !== undefined && position && views[position]) {
      views[position].hidden = hide;
    }
    let lastVisible = views.length - [...views].reverse().findIndex(view => !view.hidden) - 1;
    if (lastVisible === views.length) {
      if (position) {
        // When there's only 1 view (mobile), we might not find any active
        // if the user navigates back.
        lastVisible = position - 1;
      } else {
        lastVisible = views.length - 1;
      }
    }
    views.forEach((view, pos) => {
      if (view && pos !== position) {
        // hide other views that are outside the split view
        view.hidden = pos > lastVisible || pos < lastVisible - (this.splitViewCount - 1);
      }
    });
    this._views$.next(views);
  }
  /**
   * Returns the active view count for the list of views.
   */
  getActive(views) {
    // we reverse the list to find the last visible view
    const l = [...views].reverse().findIndex(view => !view.hidden);
    const last = l === -1 ? 0 : views.length - l - 1;
    return last;
  }
  /**
   * Utility method that resolves all views from the subject.
   */
  get views() {
    return this._views$.value;
  }
  static {
    this.ɵfac = function SplitViewService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SplitViewService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SplitViewService,
      factory: SplitViewService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitViewService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The split-view component supports an unlimited number of nested views. The component
 * is a host to those view components and doesn't add any restrictions to it's content;
 * content is projected as-is.
 *
 * ```html
 * <cx-split-view>
 *   <cx-view></cx-view>
 *   <cx-view></cx-view>
 *   <any-wrapper>
 *     <cx-view></cx-view>
 *   </any-wrapper>
 * </cx-split-view>
 * ```
 *
 * The split view component is only concerned with tracking the underlying _visible_
 * view components, so that the `lastVisibleView` can be updated accordingly. The actual
 * visibility of views is controlled by CSS. To allow for maximum flexibility, the CSS
 * implementation is using CSS variables. The `lastVisibleView` is bind to the
 * `--cx-active-view` on the host, so that all descendants views will inherit the
 * property conveniently.
 */
class SplitViewComponent {
  /**
   * Sets the default hide mode for views. This mode is useful in case views are dynamically being created,
   * for example when they are created by router components.
   *
   * The mode defaults to true, unless this is the first view; the first view is never hidden.
   */
  set hideMode(mode) {
    this.splitService.defaultHideMode = mode;
  }
  constructor(splitService, breakpointService, elementRef) {
    this.splitService = splitService;
    this.breakpointService = breakpointService;
    this.elementRef = elementRef;
    this.subscription = new Subscription();
    /**
     * Indicates the last visible view in the range of views that is visible. This
     * is bind to a css variable `--cx-active-view` so that the experience
     * can be fully controlled by css.
     */
    this.lastVisibleView = 1;
  }
  ngOnInit() {
    this.subscription.add(this.splitService.getActiveView().subscribe(lastVisible => this.lastVisibleView = lastVisible + 1));
    this.subscription.add(this.breakpointService.breakpoint$.subscribe(() => {
      this.splitService.updateSplitView(this.splitViewCount);
    }));
  }
  /**
   * Returns the maximum number of views per split-view. The number is based on the
   * CSS custom property `--cx-max-views`.
   */
  get splitViewCount() {
    return Number(getComputedStyle(this.elementRef.nativeElement).getPropertyValue('--cx-max-views'));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function SplitViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SplitViewComponent)(i0.ɵɵdirectiveInject(SplitViewService), i0.ɵɵdirectiveInject(BreakpointService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SplitViewComponent,
      selectors: [["cx-split-view"]],
      hostVars: 3,
      hostBindings: function SplitViewComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("active-view", ctx.lastVisibleView);
          i0.ɵɵstyleProp("--cx-active-view", ctx.lastVisibleView);
        }
      },
      inputs: {
        hideMode: "hideMode"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([SplitViewService])],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function SplitViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitViewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-split-view',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [SplitViewService],
      standalone: false,
      template: "<ng-content></ng-content>\n"
    }]
  }], () => [{
    type: SplitViewService
  }, {
    type: BreakpointService
  }, {
    type: i0.ElementRef
  }], {
    hideMode: [{
      type: Input
    }],
    lastVisibleView: [{
      type: HostBinding,
      args: ['style.--cx-active-view']
    }, {
      type: HostBinding,
      args: ['attr.active-view']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The view component is part of the `SplitViewComponent`. The view
 * contains the navigable content that should be split up. It maintains
 * a view position and allows to show or hide the view.
 *
 * The ViewComponent interacts with the `SplitViewService` for handing over the
 * view state, so that the overarching `SplitViewComponent` can manage the
 * overall experience.
 */
class ViewComponent {
  /**
   * The hidden input is used to set the initial visible state of the view.
   * The hidden state defaults to false.
   *
   * The hidden input supports 2-way binding, see `hiddenChange` property.
   */
  set hidden(hidden) {
    this._hidden = hidden;
    this.splitService.toggle(this.viewPosition, hidden);
  }
  constructor(splitService, elementRef, cd) {
    this.splitService = splitService;
    this.elementRef = elementRef;
    this.cd = cd;
    /**
     * The disappeared flag is added to the
     */
    this.disappeared = true;
    /**
     * An update of the view visibility is emitted to the hiddenChange output.
     */
    this.hiddenChange = new EventEmitter();
    this.globalMessageService = inject(GlobalMessageService);
  }
  ngOnInit() {
    const hidden = this._hidden ? {
      hidden: this._hidden
    } : {};
    this.splitService.add(this.viewPosition, hidden);
    this.subscription = this.splitService.getViewState(this.viewPosition)
    // delay the disappeared state, so that the (CSS driven) animation has time to finish
    .pipe(delayWhen(view => timer(view.hidden ? this.duration * 1.25 : 0))).subscribe(view => {
      this.hiddenChange.emit(view.hidden);
      this._hidden = view.hidden;
      this.disappeared = view.hidden;
      this.cd.markForCheck();
    });
    this.onViewChangeShowAssistiveMessage();
  }
  /**
   * Toggles the visibility of the view.
   *
   * An optional force flag can be used to explicitly show or hide view component.
   */
  toggle(force) {
    this.splitService.toggle(this.viewPosition, force);
  }
  /**
   * Returns the position for the view.
   *
   * The position is either taken from the input `position` or generated by the `SplitService`.
   */
  get viewPosition() {
    if (!(Number(this.position) >= 0)) {
      this.position = this.splitService.nextPosition.toString();
    }
    return Number(this.position);
  }
  /**
   * Returns the duration in milliseconds. The duration is based on the CSS custom property
   * `--cx-transition-duration`. Defaults to 300 milliseconds.
   */
  get duration() {
    const duration = getComputedStyle(this.elementRef.nativeElement).getPropertyValue('--cx-transition-duration').trim();
    if (duration.indexOf('ms') > -1) {
      return Number(duration.split('ms')[0]);
    } else if (duration.indexOf('s') > -1) {
      return Number(duration.split('s')[0]) * 1000;
    } else {
      return 300;
    }
  }
  onViewChangeShowAssistiveMessage() {
    this.subscription.add(this.splitService.getActiveView().pipe(distinctUntilChanged()).subscribe(activeView => {
      if (this.viewPosition !== activeView || !this.viewTitle) {
        return;
      }
      this.globalMessageService?.add(this.viewTitle, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500);
    }));
  }
  /**
   * The view is removed from the `SplitService` so that the view no longer
   * plays a role in the overall split view.
   */
  ngOnDestroy() {
    this.splitService.remove(this.viewPosition);
    this.subscription?.unsubscribe();
  }
  static {
    this.ɵfac = function ViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewComponent)(i0.ɵɵdirectiveInject(SplitViewService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ViewComponent,
      selectors: [["cx-view"]],
      hostVars: 4,
      hostBindings: function ViewComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("position", ctx.position)("disappeared", ctx.disappeared);
          i0.ɵɵstyleProp("--cx-view-position", ctx.position);
        }
      },
      inputs: {
        position: "position",
        hidden: "hidden",
        viewTitle: "viewTitle"
      },
      outputs: {
        hiddenChange: "hiddenChange"
      },
      standalone: false,
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function ViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-view',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-content></ng-content>\n"
    }]
  }], () => [{
    type: SplitViewService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }], {
    position: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.position']
    }, {
      type: HostBinding,
      args: ['style.--cx-view-position']
    }],
    disappeared: [{
      type: HostBinding,
      args: ['attr.disappeared']
    }],
    hidden: [{
      type: Input
    }],
    hiddenChange: [{
      type: Output
    }],
    viewTitle: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The split-view component supports an unlimited number of nested views. Nested views are rendered
 * next to each other. The views can be rendered next to each other, but the max number of visible
 * views can be limisted as well. This is configurable in the CSS layer, so that the max number of views
 * per split-view can be different for each component.
 *
 * The basic structure of the split-view component is shown below:
 *
 *
 * ```
 * <cx-split-view>
 * </cx-split-view>
 * ```
 *
 * The UX pattern used for the split-view is driven by an initial view, which gets splitted into
 * more views as soon as the user starts interacting with the initial and subsequantial views.
 * The views can be driven by routes, which means that you can navigate through the splitted views
 * by using the browser history as well as share or bookmark splitted views.
 *
 * The UI is implemented in the style layer, with only a few generic style rules. Most of the split
 * view style is driven by CSS properties, so that alternative split-view styles can be introduced
 * per page or component.
 *
 * The max number of views per split-view on mobile is limited to 1 by default, where as on tablet
 * (and higher) it is set to 2. Spartacus has a pretty narrow layout, which is why 2 is maximum,
 * but customers could alter the layout to bring in more views in the same split-view at the time.
 *
 */
class SplitViewModule {
  static {
    this.ɵfac = function SplitViewModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SplitViewModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SplitViewModule,
      declarations: [SplitViewComponent, ViewComponent],
      imports: [CommonModule, RouterModule],
      exports: [SplitViewComponent, ViewComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SplitViewModule, [{
    type: NgModule,
    args: [{
      declarations: [SplitViewComponent, ViewComponent],
      imports: [CommonModule, RouterModule],
      exports: [SplitViewComponent, ViewComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PromotionsComponent {
  constructor() {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function PromotionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PromotionsComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PromotionsComponent,
      selectors: [["cx-promotions"]],
      inputs: {
        promotions: "promotions"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "cx-promotions", 4, "ngIf"], [1, "cx-promotions"], [4, "ngIf"], [4, "ngFor", "ngForOf"]],
      template: function PromotionsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PromotionsComponent_div_0_Template, 3, 2, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.promotions);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PromotionsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-promotions',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"cx-promotions\" *ngIf=\"promotions\">\n  <ng-container *ngIf=\"promotions.length === 1\">\n    <p>{{ promotions[0].description }}</p>\n  </ng-container>\n  <ng-container *ngIf=\"promotions.length > 1\">\n    <ul>\n      <li *ngFor=\"let promotion of promotions\">\n        {{ promotion.description }}\n      </li>\n    </ul>\n  </ng-container>\n</div>\n"
    }]
  }], () => [], {
    promotions: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PromotionsModule {
  static {
    this.ɵfac = function PromotionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PromotionsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PromotionsModule,
      declarations: [PromotionsComponent],
      imports: [CommonModule],
      exports: [PromotionsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PromotionsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [PromotionsComponent],
      exports: [PromotionsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SiteContextType;
(function (SiteContextType) {
  SiteContextType["LANGUAGE"] = "LANGUAGE";
  SiteContextType["CURRENCY"] = "CURRENCY";
})(SiteContextType || (SiteContextType = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const LABELS = {
  [LANGUAGE_CONTEXT_ID]: 'Language',
  [CURRENCY_CONTEXT_ID]: 'Currency'
};
class SiteContextComponentService {
  constructor(componentData, contextServiceMap, injector) {
    this.componentData = componentData;
    this.contextServiceMap = contextServiceMap;
    this.injector = injector;
  }
  getItems(context) {
    return this.getService(context).pipe(switchMap(service => service.getAll()), switchMap(items => this.getContext(context).pipe(switchMap(ctx => {
      const itemsCopy = [];
      for (const item of items) {
        itemsCopy.push({
          ...item,
          label: this.getOptionLabel(item, ctx)
        });
      }
      return of(itemsCopy);
    }))));
  }
  getActiveItem(context) {
    return this.getService(context).pipe(switchMap(service => service.getActive()));
  }
  getLabel(context) {
    return this.getContext(context).pipe(map(ctx => {
      if (ctx) {
        return LABELS[ctx];
      }
    }));
  }
  setActive(value, context) {
    this.getService(context).pipe(take(1)).subscribe(service => {
      service.setActive(value);
    });
  }
  getService(context) {
    return this.getContext(context).pipe(map(ctx => ctx ? this.getInjectedService(ctx) : undefined), filter(isNotUndefined));
  }
  getContext(context) {
    if (context) {
      if (context === SiteContextType.CURRENCY) {
        return of(CURRENCY_CONTEXT_ID);
      } else if (context === SiteContextType.LANGUAGE) {
        return of(LANGUAGE_CONTEXT_ID);
      } else {
        return of(context);
      }
    } else if (this.componentData) {
      return this.componentData.data$.pipe(map(data => data.context), map(ctx => {
        switch (ctx) {
          case 'LANGUAGE':
            return LANGUAGE_CONTEXT_ID;
          case 'CURRENCY':
            return CURRENCY_CONTEXT_ID;
          default:
            return ctx;
        }
      }));
    }
    return of(undefined);
  }
  getInjectedService(context) {
    return this.injector.get(this.contextServiceMap[context], undefined);
  }
  getOptionLabel(item, context) {
    switch (context) {
      case LANGUAGE_CONTEXT_ID:
        return item.nativeName;
      case CURRENCY_CONTEXT_ID:
        return item.symbol + ' ' + item.isocode;
      default:
        return item.isocode;
    }
  }
  static {
    this.ɵfac = function SiteContextComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteContextComponentService)(i0.ɵɵinject(CmsComponentData, 8), i0.ɵɵinject(i1.ContextServiceMap), i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SiteContextComponentService,
      factory: SiteContextComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteContextComponentService, [{
    type: Injectable
  }], () => [{
    type: CmsComponentData,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i1.ContextServiceMap
  }, {
    type: i0.Injector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteContextSelectorComponent {
  constructor(componentService) {
    this.componentService = componentService;
    this.iconTypes = ICON_TYPE;
    this.translationService = inject(TranslationService);
    useFeatureStyles('a11yShowDownArrowOnFocusedSelectMenu');
  }
  get items$() {
    return this.componentService.getItems(this.context);
  }
  get activeItem$() {
    return this.componentService.getActiveItem(this.context);
  }
  set active(value) {
    this.componentService.setActive(value, this.context);
  }
  get label$() {
    return this.componentService.getLabel(this.context);
  }
  ariaLabel$(label, index, length) {
    return this.translationService.translate('common.of').pipe(map$1(translation => {
      return `${label}, ${index + 1} ${translation} ${length}`;
    }));
  }
  static {
    this.ɵfac = function SiteContextSelectorComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteContextSelectorComponent)(i0.ɵɵdirectiveInject(SiteContextComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SiteContextSelectorComponent,
      selectors: [["cx-site-context-selector"]],
      inputs: {
        context: "context"
      },
      standalone: false,
      decls: 3,
      vars: 5,
      consts: [[4, "ngIf"], [3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "small", 3, "type"], [3, "value", "selected"]],
      template: function SiteContextSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SiteContextSelectorComponent_label_0_Template, 7, 5, "label", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵproperty("ngIf", ((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.items$)) == null ? null : tmp_0_0.length) > 1 && i0.ɵɵpipeBind1(2, 3, ctx.items$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, IconComponent, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteContextSelectorComponent, [{
    type: Component,
    args: [{
      selector: 'cx-site-context-selector',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<label *ngIf=\"(items$ | async)?.length > 1 && (items$ | async) as items\">\n  <span>{{ label$ | async }}:</span>\n  <select (change)=\"active = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(item.label, i, items.length) | async\"\n      *ngFor=\"let item of items; index as i\"\n      value=\"{{ item.isocode }}\"\n      [selected]=\"(activeItem$ | async) === item.isocode\"\n    >\n      {{ item.label }}\n    </option>\n  </select>\n  <cx-icon\n    aria-hidden=\"true\"\n    [type]=\"iconTypes.CARET_DOWN\"\n    class=\"small\"\n  ></cx-icon>\n</label>\n"
    }]
  }], () => [{
    type: SiteContextComponentService
  }], {
    context: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LanguageCurrencyComponent {
  constructor() {
    this.siteContextType = SiteContextType;
  }
  static {
    this.ɵfac = function LanguageCurrencyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LanguageCurrencyComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LanguageCurrencyComponent,
      selectors: [["cx-language-currency-selector"]],
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[3, "context"]],
      template: function LanguageCurrencyComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "cx-site-context-selector", 0)(1, "cx-site-context-selector", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("context", ctx.siteContextType.LANGUAGE);
          i0.ɵɵadvance();
          i0.ɵɵproperty("context", ctx.siteContextType.CURRENCY);
        }
      },
      dependencies: [SiteContextSelectorComponent],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LanguageCurrencyComponent, [{
    type: Component,
    args: [{
      selector: 'cx-language-currency-selector',
      template: `
    <cx-site-context-selector
      [context]="siteContextType.LANGUAGE"
    ></cx-site-context-selector>
    <cx-site-context-selector
      [context]="siteContextType.CURRENCY"
    ></cx-site-context-selector>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteContextSelectorModule {
  static {
    this.ɵfac = function SiteContextSelectorModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteContextSelectorModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SiteContextSelectorModule,
      declarations: [SiteContextSelectorComponent, LanguageCurrencyComponent],
      imports: [CommonModule, RouterModule, SiteContextModule, IconModule],
      exports: [SiteContextSelectorComponent, LanguageCurrencyComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSSiteContextComponent: {
            component: SiteContextSelectorComponent,
            providers: [{
              provide: SiteContextComponentService,
              useClass: SiteContextComponentService,
              deps: [CmsComponentData, ContextServiceMap, Injector]
            }]
          },
          LanguageCurrencyComponent: {
            component: LanguageCurrencyComponent
          }
        }
      }), SiteContextComponentService],
      imports: [CommonModule, RouterModule, SiteContextModule, IconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteContextSelectorModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, SiteContextModule, IconModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSSiteContextComponent: {
            component: SiteContextSelectorComponent,
            providers: [{
              provide: SiteContextComponentService,
              useClass: SiteContextComponentService,
              deps: [CmsComponentData, ContextServiceMap, Injector]
            }]
          },
          LanguageCurrencyComponent: {
            component: LanguageCurrencyComponent
          }
        }
      }), SiteContextComponentService],
      declarations: [SiteContextSelectorComponent, LanguageCurrencyComponent],
      exports: [SiteContextSelectorComponent, LanguageCurrencyComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteThemeSwitcherComponentService {
  constructor() {
    this.siteThemeService = inject(SiteThemeService);
  }
  getItems() {
    return this.siteThemeService.getAll();
  }
  getActiveItem() {
    return this.siteThemeService.getActive();
  }
  setActive(value) {
    this.siteThemeService.setActive(value);
  }
  static {
    this.ɵfac = function SiteThemeSwitcherComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteThemeSwitcherComponentService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SiteThemeSwitcherComponentService,
      factory: SiteThemeSwitcherComponentService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteThemeSwitcherComponentService, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Component for switching themes.
 */
class SiteThemeSwitcherComponent {
  constructor() {
    this.translationService = inject(TranslationService);
    this.iconTypes = ICON_TYPE;
    this.themeSwitcherComponentService = inject(SiteThemeSwitcherComponentService);
    useFeatureStyles('a11yShowDownArrowOnFocusedSelectMenu');
  }
  get items$() {
    return this.themeSwitcherComponentService.getItems();
  }
  get activeItem$() {
    return this.themeSwitcherComponentService.getActiveItem();
  }
  set activeItem(value) {
    this.themeSwitcherComponentService.setActive(value);
  }
  ariaLabel$(theme, index, length) {
    const themeTranslation$ = theme.i18nNameKey ? this.translationService.translate(theme.i18nNameKey) : of(theme.className);
    const ofTranslation$ = this.translationService.translate('common.of');
    return combineLatest([themeTranslation$, ofTranslation$]).pipe(take(1), map(([themeTranslation, ofTranslation]) => {
      return `${themeTranslation}, ${index + 1} ${ofTranslation} ${length}`;
    }));
  }
  static {
    this.ɵfac = function SiteThemeSwitcherComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteThemeSwitcherComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SiteThemeSwitcherComponent,
      selectors: [["cx-site-theme-switcher"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "small", 3, "type"], [3, "value", "selected"]],
      template: function SiteThemeSwitcherComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SiteThemeSwitcherComponent_label_0_Template, 7, 5, "label", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.items$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, IconComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteThemeSwitcherComponent, [{
    type: Component,
    args: [{
      selector: 'cx-site-theme-switcher',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<label *ngIf=\"items$ | async as themes\">\n  <span> {{ 'siteThemeSwitcher.theme' | cxTranslate }}:</span>\n  <select (change)=\"activeItem = $any($event).target.value\">\n    <option\n      [attr.aria-label]=\"ariaLabel$(theme, i, themes.length) | async\"\n      *ngFor=\"let theme of themes; index as i\"\n      value=\"{{ theme.className }}\"\n      [selected]=\"(activeItem$ | async) === theme.className\"\n    >\n      {{\n        theme.i18nNameKey ? (theme.i18nNameKey | cxTranslate) : theme.className\n      }}\n    </option>\n  </select>\n  <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CARET_DOWN\" class=\"small\" />\n</label>\n"
    }]
  }], () => [], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SiteThemeSwitcherModule {
  static {
    this.ɵfac = function SiteThemeSwitcherModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SiteThemeSwitcherModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SiteThemeSwitcherModule,
      declarations: [SiteThemeSwitcherComponent],
      imports: [CommonModule, I18nModule, IconModule, SiteThemeModule],
      exports: [SiteThemeSwitcherComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          SiteThemeSwitcherComponent: {
            component: SiteThemeSwitcherComponent
          }
        }
      }), SiteThemeSwitcherComponentService],
      imports: [CommonModule, I18nModule, IconModule, SiteThemeModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SiteThemeSwitcherModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, IconModule, SiteThemeModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          SiteThemeSwitcherComponent: {
            component: SiteThemeSwitcherComponent
          }
        }
      }), SiteThemeSwitcherComponentService],
      declarations: [SiteThemeSwitcherComponent],
      exports: [SiteThemeSwitcherComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Star rating component can be used to view existing ratings as well
 * as create new ratings. The component can be used for any ratings.
 */
class StarRatingComponent {
  constructor() {
    this.initialRate = 0;
    this.icon = ICON_TYPE.STAR;
    /**
     * The rating component can be used in disabled mode,
     * so that the interaction is not provided.
     *
     * Defaults to true.
     */
    this.disabled = true;
    /**
     * The rating is used to color the rating stars. It can have a
     * precise number. The rating number is used for a CSS custom property
     * (AKA css variable) value. The actually coloring is done in CSS.
     */
    this.rating = this.initialRate;
    /**
     * Emits the given rating when the user clicks on a star.
     */
    // eslint-disable-next-line @angular-eslint/no-output-native
    this.change = new EventEmitter();
    useFeatureStyles('reserveHorizontalSpaceStarRating');
  }
  setRate(value) {
    if (this.disabled) {
      return;
    }
    this.rating = value;
  }
  reset() {
    if (this.disabled) {
      return;
    }
    this.rating = this.initialRate ?? 0;
  }
  saveRate(rating) {
    if (this.disabled) {
      return;
    }
    this.initialRate = rating;
    this.setRate(rating);
    this.change.emit(rating);
  }
  static {
    this.ɵfac = function StarRatingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StarRatingComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StarRatingComponent,
      selectors: [["cx-star-rating"]],
      hostVars: 3,
      hostBindings: function StarRatingComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseout", function StarRatingComponent_mouseout_HostBindingHandler() {
            return ctx.reset();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("disabled", ctx.disabled);
          i0.ɵɵstyleProp("--star-fill", ctx.rating);
        }
      },
      inputs: {
        disabled: "disabled",
        rating: "rating"
      },
      outputs: {
        change: "change"
      },
      standalone: false,
      decls: 3,
      vars: 2,
      consts: [["starRating", ""], ["role", "img", 3, "title", 4, "ngIf", "ngIfElse"], ["role", "img", 3, "title"], [4, "ngTemplateOutlet"], ["class", "star", 3, "type", "mouseover", "click", "keydown.space", 4, "ngFor", "ngForOf"], [1, "star", 3, "mouseover", "click", "keydown.space", "type"]],
      template: function StarRatingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, StarRatingComponent_div_0_Template, 4, 13, "div", 1)(1, StarRatingComponent_ng_template_1_Template, 1, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const starRating_r2 = i0.ɵɵreference(2);
          i0.ɵɵproperty("ngIf", ctx.disabled)("ngIfElse", starRating_r2);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, IconComponent, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StarRatingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-star-rating',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  *ngIf=\"disabled; else starRating\"\n  role=\"img\"\n  [title]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n  [attr.aria-label]=\"\n    'productReview.ratedOutOf' | cxTranslate: { rating: rating.toFixed(1) }\n  \"\n>\n  <ng-container *ngTemplateOutlet=\"starRating\"></ng-container>\n</div>\n\n<ng-template #starRating>\n  <cx-icon\n    *ngFor=\"let i of [1, 2, 3, 4, 5]\"\n    [type]=\"icon\"\n    class=\"star\"\n    (mouseover)=\"setRate(i)\"\n    (click)=\"saveRate(i)\"\n    (keydown.space)=\"saveRate(i)\"\n    [attr.aria-current]=\"!disabled && i === rating\"\n    [attr.tabindex]=\"disabled ? null : 0\"\n    [attr.role]=\"disabled ? null : 'button'\"\n    [attr.aria-label]=\"\n      !disabled ? ('productReview.addRate' | cxTranslate: { count: i }) : null\n    \"\n    [attr.aria-hidden]=\"disabled\"\n  ></cx-icon>\n</ng-template>\n"
    }]
  }], () => [], {
    disabled: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.disabled']
    }],
    rating: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['style.--star-fill']
    }],
    change: [{
      type: Output
    }],
    reset: [{
      type: HostListener,
      args: ['mouseout']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StarRatingModule {
  static {
    this.ɵfac = function StarRatingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StarRatingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StarRatingModule,
      declarations: [StarRatingComponent],
      imports: [CommonModule, IconModule, I18nModule],
      exports: [StarRatingComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StarRatingModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, IconModule, I18nModule],
      declarations: [StarRatingComponent],
      exports: [StarRatingComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableDataCellComponent {
  constructor(outlet) {
    this.outlet = outlet;
  }
  get value() {
    return this.model[this.field];
  }
  get model() {
    return this.outlet?.context;
  }
  get field() {
    return this.outlet?.context?._field;
  }
  static {
    this.ɵfac = function TableDataCellComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableDataCellComponent)(i0.ɵɵdirectiveInject(OutletContextData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableDataCellComponent,
      selectors: [["cx-table-data-cell"]],
      hostVars: 1,
      hostBindings: function TableDataCellComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("title", ctx.value);
        }
      },
      standalone: false,
      decls: 1,
      vars: 1,
      template: function TableDataCellComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtext(0);
        }
        if (rf & 2) {
          i0.ɵɵtextInterpolate(ctx.value);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDataCellComponent, [{
    type: Component,
    args: [{
      selector: 'cx-table-data-cell',
      template: `{{ value }}`,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false
    }]
  }], () => [{
    type: OutletContextData
  }], {
    value: [{
      type: HostBinding,
      args: ['attr.title']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableHeaderCellComponent {
  constructor(outlet) {
    this.outlet = outlet;
  }
  /**
   * Returns the static label for the given field, if available.
   */
  get header() {
    if (typeof this.fieldOptions?.label === 'string') {
      return this.fieldOptions.label;
    }
  }
  /**
   * Returns the localized label for the given field.
   *
   * The localized label is either driven by the configured `label.i18nKey`
   * or concatenated by the table `type` and field `key`:
   *
   * `[tableType].[fieldKey]`
   *
   * The localized header can be translated with the `cxTranslate` pipe or `TranslationService`.
   */
  get localizedHeader() {
    return this.fieldOptions?.label?.i18nKey || `${this.i18nRoot}.${this.field}`;
  }
  get fieldOptions() {
    return this.outlet?.context._options?.cells?.[this.field];
  }
  get field() {
    return this.outlet?.context?._field;
  }
  get type() {
    return this.outlet?.context?._type;
  }
  get i18nRoot() {
    return this.outlet?.context?._i18nRoot;
  }
  static {
    this.ɵfac = function TableHeaderCellComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableHeaderCellComponent)(i0.ɵɵdirectiveInject(OutletContextData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableHeaderCellComponent,
      selectors: [["cx-table-header-cell"]],
      standalone: false,
      decls: 2,
      vars: 3,
      template: function TableHeaderCellComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtext(0);
          i0.ɵɵpipe(1, "cxTranslate");
        }
        if (rf & 2) {
          i0.ɵɵtextInterpolate(ctx.header || i0.ɵɵpipeBind1(1, 1, ctx.localizedHeader));
        }
      },
      dependencies: [i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableHeaderCellComponent, [{
    type: Component,
    args: [{
      selector: 'cx-table-header-cell',
      template: `{{ header || (localizedHeader | cxTranslate) }}`,
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false
    }]
  }], () => [{
    type: OutletContextData
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultTableConfig = {
  tableOptions: {
    headerComponent: TableHeaderCellComponent,
    dataComponent: TableDataCellComponent
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `TableConfig` provides a table configurations for specific table types. You can define
 * an all-screen table structure as well as a breakpoint specific table structure. The various
 * table structures are merged from small to large screen configurations, depending on the users
 * screen size.
 *
 * The `table.type` is used as a key to distinguish the various table configurations in the application.
 */
class TableConfig {
  static {
    this.ɵfac = function TableConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TableConfig,
      factory: function TableConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || TableConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableDataCellModule {
  static {
    this.ɵfac = function TableDataCellModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableDataCellModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TableDataCellModule,
      declarations: [TableDataCellComponent],
      imports: [CommonModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableDataCellModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [TableDataCellComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TableHeaderCellModule {
  static {
    this.ɵfac = function TableHeaderCellModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableHeaderCellModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TableHeaderCellModule,
      declarations: [TableHeaderCellComponent],
      imports: [CommonModule, I18nModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableHeaderCellModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule],
      declarations: [TableHeaderCellComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The table renderer service adds a component for each table cells (th and td)
 * based on a fine grained configuration. Each table type can configure both global
 * components for headers and cells as well as individual components for field
 * specific cells.
 *
 * The components are added to the outlet slots for the corresponding cells. The table
 * structure and data is added to the outlet context.
 */
class TableRendererService {
  constructor(outletService, componentFactoryResolver, config) {
    this.outletService = outletService;
    this.componentFactoryResolver = componentFactoryResolver;
    this.config = config;
    // keep a list of outletRefs to avoid recreation
    this.outletRefs = new Map();
  }
  /**
   * Adds the configured table component for the header and data.
   */
  add(structure) {
    structure?.cells?.forEach(field => {
      const thRenderer = this.getHeaderRenderer(structure, field);
      if (thRenderer) {
        const ref = this.getHeaderOutletRef(structure.type, field);
        this.render(ref, thRenderer);
      }
      const tdRenderer = this.getDataRenderer(structure, field);
      if (tdRenderer) {
        const ref = this.getDataOutletRef(structure.type, field);
        this.render(ref, tdRenderer);
      }
    });
  }
  render(outletRef, renderer) {
    if (this.outletRefs.has(outletRef)) {
      return;
    }
    this.outletRefs.set(outletRef, true);
    const template = this.componentFactoryResolver.resolveComponentFactory(renderer);
    this.outletService.add(outletRef, template);
  }
  /**
   * Returns the header render component for the given field.
   */
  getHeaderRenderer(structure, field) {
    return structure.options?.cells?.[field]?.headerComponent || structure.options?.headerComponent || this.config.tableOptions?.headerComponent;
  }
  /**
   * Returns the data render component for the given field.
   */
  getDataRenderer(structure, field) {
    return structure.options?.cells?.[field]?.dataComponent || structure.options?.dataComponent || this.config.tableOptions?.dataComponent;
  }
  /**
   * Returns the header (th) outlet reference for the given field.
   *
   * The outlet reference is generated as:
   * `table.[tableType].header.[field]`
   */
  getHeaderOutletRef(type, field) {
    return `table.${type}.header.${field}`;
  }
  /**
   * Returns the header (th) outlet context for the given field.
   */
  getHeaderOutletContext(type, options, i18nRoot, field) {
    return {
      _type: type,
      _options: options,
      _field: field,
      _i18nRoot: i18nRoot
    };
  }
  /**
   * Returns the data (td) outlet reference for the given field.
   *
   * The field is generated as:
   * `table.[tableType].data.[tableField]`
   */
  getDataOutletRef(type, field) {
    return `table.${type}.data.${field}`;
  }
  /**
   * Returns the data (td) outlet context for the given field.
   */
  getDataOutletContext(type, options, i18nRoot, field, data) {
    return {
      ...data,
      _type: type,
      _options: options,
      _field: field,
      _i18nRoot: i18nRoot
    };
  }
  static {
    this.ɵfac = function TableRendererService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableRendererService)(i0.ɵɵinject(OutletService), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(TableConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TableRendererService,
      factory: TableRendererService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableRendererService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OutletService
  }, {
    type: i0.ComponentFactoryResolver
  }, {
    type: TableConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Layout orientation for the table configuration.
 */
var TableLayout;
(function (TableLayout) {
  /**
   * Renders the table vertically, with a heading on top of the table.
   *
   * Vertical layout is most common and the default layout.
   */
  TableLayout[TableLayout["VERTICAL"] = 1] = "VERTICAL";
  /**
   * Stacks items in a tables by generating a `tbody` for each item.
   */
  TableLayout[TableLayout["VERTICAL_STACKED"] = 2] = "VERTICAL_STACKED";
  /**
   * Horizontal oriented table layout renders the table headers in the first column of the table.
   */
  TableLayout[TableLayout["HORIZONTAL"] = 3] = "HORIZONTAL";
})(TableLayout || (TableLayout = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The table component provides a generic table DOM structure, with 3 layout types:
 * horizontal, vertical and _stacked vertical_ layout. The layout is driven by the
 * table structure.
 *
 * The implementation is fairly "dumb" and only renders string based content for TH
 * and TD elements. The actual cell rendering is delegated to a (configurable) cell
 * component. Additionally, each cell is registered as an outlet, so that customizations
 * can be done by both outlet templates and components.
 *
 * The outlet references are concatenated from the table `type` and header `key`. The
 * following snippet shows an outlet generated for a table header, for the table type
 * "cost-center" with a header key "name":
 *
 * ```
 * <th>
 *   <template cxOutlet="table.cost-center.header.name">
 *   </template>
 * </th>
 * ```
 *
 * Similarly, the data cells (`<td>`) are generated with the outlet template reference
 * `table.cost-center.data.name`.
 */
class TableComponent {
  set structure(structure) {
    this._structure = structure;
    this.init();
  }
  get structure() {
    return this._structure;
  }
  constructor(rendererService) {
    this.rendererService = rendererService;
    this.launch = new EventEmitter();
  }
  init() {
    this.verticalLayout = !this.layout || this.layout === TableLayout.VERTICAL;
    this.verticalStackedLayout = this.layout === TableLayout.VERTICAL_STACKED;
    this.horizontalLayout = this.layout === TableLayout.HORIZONTAL;
    this.rendererService.add(this.structure);
    this.addTableDebugInfo();
  }
  launchItem(item) {
    this.launch.emit(item);
  }
  /**
   * Indicates whether the given item is the current item.
   *
   * The current item is driven by the `currentItem`, that holds a
   * property and value to compare.
   */
  isCurrentItem(item) {
    if (!this.currentItem || !this.currentItem.value) {
      return false;
    }
    return this.currentItem?.value === item?.[this.currentItem?.property];
  }
  /**
   * Returns the header (th) outlet reference for the given field.
   */
  getHeaderOutletRef(field) {
    return this.rendererService.getHeaderOutletRef(this.type, field);
  }
  /**
   * Returns the header (th) outlet context for the given field.
   */
  getHeaderOutletContext(field) {
    return this.rendererService.getHeaderOutletContext(this.type, this.options, this.i18nRoot, field);
  }
  /**
   * Returns the data (td) outlet reference for the given field.
   */
  getDataOutletRef(field) {
    return this.rendererService.getDataOutletRef(this.type, field);
  }
  /**
   * Returns the data (td) outlet context for the given field.
   */
  getDataOutletContext(field, data) {
    return this.rendererService.getDataOutletContext(this.type, this.options, this.i18nRoot, field, data);
  }
  trackData(_i, item) {
    return JSON.stringify(item);
  }
  /**
   * Generates the table type into the UI in devMode, so that developers
   * can easily get the notion of the table type.
   */
  addTableDebugInfo() {
    if (isDevMode() && this.type) {
      this.tableType = this.type;
    }
  }
  /**
   * Helper method to return the deeply nested orientation configuration.
   */
  get layout() {
    return this.structure?.options?.layout;
  }
  /**
   * Helper method to return the deeply nested type.
   */
  get type() {
    return this.structure?.type;
  }
  get options() {
    return this.structure?.options;
  }
  static {
    this.ɵfac = function TableComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableComponent)(i0.ɵɵdirectiveInject(TableRendererService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TableComponent,
      selectors: [["cx-table"]],
      hostVars: 7,
      hostBindings: function TableComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("__cx-table-type", ctx.tableType);
          i0.ɵɵclassProp("horizontal", ctx.horizontalLayout)("vertical", ctx.verticalLayout)("vertical-stacked", ctx.verticalStackedLayout);
        }
      },
      inputs: {
        structure: "structure",
        data: "data",
        i18nRoot: "i18nRoot",
        currentItem: "currentItem"
      },
      outputs: {
        launch: "launch"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [[4, "ngIf"], [3, "is-current", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "click"], [3, "class", 4, "ngFor", "ngForOf"], [3, "cxOutlet", "cxOutletContext"], ["scope", "col", 3, "class", 4, "ngFor", "ngForOf"], ["scope", "col"]],
      template: function TableComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TableComponent_table_0_Template, 4, 3, "table", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.structure);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, OutletDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableComponent, [{
    type: Component,
    args: [{
      selector: 'cx-table',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<table *ngIf=\"structure\">\n  <ng-container *ngIf=\"verticalStackedLayout\">\n    <tbody\n      *ngFor=\"let item of data; trackBy: trackData\"\n      (click)=\"launchItem(item)\"\n      [class.is-current]=\"isCurrentItem(item)\"\n    >\n      <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n        <th>\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n        <td>\n          <ng-template\n            [cxOutlet]=\"getDataOutletRef(cell)\"\n            [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n          >\n            {{ $any(item)[cell] }}\n          </ng-template>\n        </td>\n      </tr>\n    </tbody>\n  </ng-container>\n\n  <!-- vertical tables render the item  -->\n  <ng-container *ngIf=\"verticalLayout\">\n    <thead>\n      <tr>\n        <th scope=\"col\" *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n          <ng-template\n            [cxOutlet]=\"getHeaderOutletRef(cell)\"\n            [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n          >\n            {{ cell }}\n          </ng-template>\n        </th>\n      </tr>\n    </thead>\n\n    <tr\n      *ngFor=\"let item of data; trackBy: trackData\"\n      [class.is-current]=\"isCurrentItem(item)\"\n      (click)=\"launchItem(item)\"\n    >\n      <td *ngFor=\"let cell of structure.cells; let i = index\" [class]=\"cell\">\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n\n  <ng-container *ngIf=\"horizontalLayout\">\n    <tr *ngFor=\"let cell of structure.cells\" [class]=\"cell\">\n      <th scope=\"col\">\n        <ng-template\n          [cxOutlet]=\"getHeaderOutletRef(cell)\"\n          [cxOutletContext]=\"getHeaderOutletContext(cell)\"\n        >\n          {{ cell }}\n        </ng-template>\n      </th>\n      <td\n        *ngFor=\"let item of data; trackBy: trackData\"\n        [class.is-current]=\"isCurrentItem(item)\"\n        (click)=\"launchItem(item)\"\n      >\n        <ng-template\n          [cxOutlet]=\"getDataOutletRef(cell)\"\n          [cxOutletContext]=\"getDataOutletContext(cell, item)\"\n        >\n          {{ $any(item)[cell] }}\n        </ng-template>\n      </td>\n    </tr>\n  </ng-container>\n</table>\n"
    }]
  }], () => [{
    type: TableRendererService
  }], {
    tableType: [{
      type: HostBinding,
      args: ['attr.__cx-table-type']
    }],
    horizontalLayout: [{
      type: HostBinding,
      args: ['class.horizontal']
    }],
    verticalLayout: [{
      type: HostBinding,
      args: ['class.vertical']
    }],
    verticalStackedLayout: [{
      type: HostBinding,
      args: ['class.vertical-stacked']
    }],
    structure: [{
      type: Input
    }],
    data: [{
      type: Input
    }],
    i18nRoot: [{
      type: Input
    }],
    currentItem: [{
      type: Input
    }],
    launch: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The TableModule provides a table component that is driven by (responsible) configuration.
 */
class TableModule {
  static {
    this.ɵfac = function TableModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TableModule,
      declarations: [TableComponent],
      imports: [CommonModule, OutletModule, TableHeaderCellModule, TableDataCellModule],
      exports: [TableComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultTableConfig)],
      imports: [CommonModule, OutletModule, TableHeaderCellModule, TableDataCellModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OutletModule, TableHeaderCellModule, TableDataCellModule],
      declarations: [TableComponent],
      exports: [TableComponent],
      providers: [provideDefaultConfig(defaultTableConfig)]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Responsive table service.
 *
 * The `TableService` is used to build a `TableStructure` by configuration. The configuration
 * allows for breakpoint specific configuration, so that the table can differentiate for
 * various screen sizes.
 *
 * While there are some global options, the configuration is mainly driven by the table _type_.
 *
 * If there is no table configuration for the given type found, a table header structure
 * is generated based on the actual data (if available) or randomly by generating 5 random headers.
 */
class TableService {
  constructor(breakpointService, config) {
    this.breakpointService = breakpointService;
    this.config = config;
    this.logger = inject(LoggerService);
  }
  /**
   * Builds the table structure.
   *
   * @param tableType The table type is used  to find the specific table configuration.
   * @param defaultStructure (optional) Default table structure that contains fallback options. More specific options are merged with the default structure.
   * @param data$ (optional) The actual data can be passed in to generate the table structure based on actual data.
   */
  buildStructure(tableType, defaultStructure) {
    if (this.hasTableConfig(tableType)) {
      return this.buildStructureFromConfig(tableType, defaultStructure);
    } else {
      return this.buildRandomStructure(tableType);
    }
  }
  /**
   * Returns the table structure by configuration. The configuration can be
   * breakpoint-driven, which means that an alternative header structure can
   * be created per screen size.
   *
   * The breakpoint is resolved by teh `BreakpointService`.
   */
  buildStructureFromConfig(type, defaultStructure) {
    return this.breakpointService.breakpoint$.pipe(map(breakpoint => ({
      ...this.getTableConfig(type, breakpoint, defaultStructure),
      type
    })));
  }
  /**
   * Finds all applicable table configuration for the given type and breakpoint.
   * The default table configuration is merged with all relevant breakpoint
   * configurations.
   *
   * This allows to have some default configurations that apply to all screens, and
   * add configuration options for some screens.
   */
  getTableConfig(type, breakpoint, defaultStructure) {
    if (!this.config.table?.[type]) {
      return null;
    }
    const relevant = this.findRelevantBreakpoints(breakpoint);
    const closestBreakpoint = [...relevant].reverse().find(br => !!this.config.table?.[type][br]?.cells);
    const cells = closestBreakpoint && this.config.table[type][closestBreakpoint]?.cells || this.config.table[type].cells || defaultStructure?.cells;
    // add all default table configurations
    let options = {
      ...defaultStructure?.options,
      ...this.config.table[type].options
    };
    // We merge all table options for smaller breakpoints into the global
    // options, so we inherit options.
    relevant.forEach(br => {
      options = {
        ...options,
        ...defaultStructure?.[br]?.options,
        ...this.config.table?.[type]?.[br]?.options
      };
    });
    return {
      cells,
      options
    };
  }
  /**
   * Generates the table structure by the help of the first data row.
   */
  buildStructureFromData(type, data$) {
    this.logWarning(`No table configuration found to render table with type "${type}". The table header for "${type}" is generated by the help of the first data item`);
    return data$.pipe(map(data => {
      const cells = Object.keys(data?.[0]).map(key => key);
      return {
        type,
        cells
      };
    }));
  }
  /**
   * As a last resort, the table structure is randomly created. The random structure
   * contains 5 headers, so that some of the unknown data is visualized.
   */
  buildRandomStructure(type) {
    this.logWarning(`No data available for "${type}", a random structure is generated (with hidden table headers).`);
    return of({
      type,
      cells: ['unknown', 'unknown', 'unknown', 'unknown', 'unknown']
    });
  }
  /**
   * Finds all the breakpoints can contribute to the table configuration, from small
   * to current.
   *
   * For example, if the current breakpoint is `MD`, this returns `[XS, SM, MD]`.
   */
  findRelevantBreakpoints(breakpoint) {
    const current = this.breakpointService.breakpoints.indexOf(breakpoint);
    return this.breakpointService.breakpoints.slice(0, current + 1);
  }
  /**
   * Indicates if the there is a configuration for the table available.
   */
  hasTableConfig(tableType) {
    return !!this.config.table?.[tableType];
  }
  /**
   * Logs a message in the console to increase developer experience.
   *
   * The message is only logged in dev mode.
   */
  logWarning(message) {
    if (isDevMode()) {
      this.logger.warn(message);
    }
  }
  static {
    this.ɵfac = function TableService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TableService)(i0.ɵɵinject(BreakpointService), i0.ɵɵinject(TableConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TableService,
      factory: TableService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: BreakpointService
  }, {
    type: TableConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Configuration for the frontend: This class defines how to render the captcha component
 * and obtain the appropriate token.
 *
 * @property {Type<CaptchaRenderer>} - An implementation of the CaptchaRenderer
 * interface that renders the UI and interacts with the user.
 * @property {string} [apiUrl] - An optional parameter specifying the API endpoint for captcha validation.
 * @property {Object} [fields] - An optional parameter that holds additional fields needed for the captcha configuration.
 */
class CaptchaApiConfig {
  static {
    this.ɵfac = function CaptchaApiConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CaptchaApiConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CaptchaApiConfig,
      factory: function CaptchaApiConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || CaptchaApiConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaApiConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaComponent {
  constructor(config, injector) {
    this.config = config;
    this.injector = injector;
    // Emits true if user confirms captcha
    this.confirmed = new EventEmitter();
    this.subscription = new Subscription();
  }
  /**
   * Add fields from CaptchaApiConfig. Call backend to get captcha
   * config.
   */
  ngAfterViewInit() {
    if (this.config?.captchaRenderer) {
      const captchaRenderer = this.injector.get(this.config.captchaRenderer);
      this.subscription.add(captchaRenderer.getCaptchaConfig().pipe(concatMap(captchaConfig => {
        if (captchaConfig?.enabled) {
          return captchaRenderer.renderCaptcha({
            element: this.captchaRef.nativeElement
          });
        } else {
          return of(null);
        }
      })).subscribe(() => {
        this.confirmed.emit(true);
      }));
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function CaptchaComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CaptchaComponent)(i0.ɵɵdirectiveInject(CaptchaApiConfig), i0.ɵɵdirectiveInject(i0.Injector));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CaptchaComponent,
      selectors: [["cx-captcha"]],
      viewQuery: function CaptchaComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c34, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.captchaRef = _t.first);
        }
      },
      outputs: {
        confirmed: "confirmed"
      },
      standalone: false,
      decls: 2,
      vars: 0,
      consts: [["captcha", ""]],
      template: function CaptchaComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", null, 0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaComponent, [{
    type: Component,
    args: [{
      selector: 'cx-captcha',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div #captcha></div>\n"
    }]
  }], () => [{
    type: CaptchaApiConfig
  }, {
    type: i0.Injector
  }], {
    confirmed: [{
      type: Output
    }],
    captchaRef: [{
      type: ViewChild,
      args: ['captcha', {
        static: false
      }]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaService {
  constructor(adapter, apiConfig, languageService, scriptLoader, baseSiteService) {
    this.adapter = adapter;
    this.apiConfig = apiConfig;
    this.languageService = languageService;
    this.scriptLoader = scriptLoader;
    this.baseSiteService = baseSiteService;
    this.subscription = new Subscription();
    this.captchaConfigSubject$ = new ReplaySubject(1);
    this.initialize();
  }
  /**
   * Retrieve captcha configuration from the backend, and if enabled
   * call @function loadScript with active language
   */
  initialize() {
    this.subscription.add(this.fetchCaptchaConfigFromServer().subscribe(config => {
      if (config?.enabled) {
        this.captchaConfig = config;
        this.loadResource();
      } else {
        this.captchaConfigSubject$.next({
          enabled: false
        });
      }
    }));
  }
  fetchCaptchaConfigFromServer() {
    return forkJoin([this.languageService.getActive().pipe(take(1)), this.baseSiteService.getActive().pipe(concatMap(value => this.adapter.loadBaseSite(value)), take(1))]).pipe(map$1(result => result[1]?.captchaConfig));
  }
  getCaptchaConfig() {
    return this.captchaConfigSubject$.asObservable();
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  getToken() {
    return this.token;
  }
  /**
   * Load external resource if needed with dependencies to be added to <head>.
   * @param - Language and configuration read from server
   */
  loadResource() {
    this.captchaConfigSubject$.next(this.captchaConfig);
  }
  static {
    this.ɵfac = function CaptchaService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CaptchaService)(i0.ɵɵinject(i1.SiteAdapter), i0.ɵɵinject(CaptchaApiConfig), i0.ɵɵinject(i1.LanguageService), i0.ɵɵinject(i1.ScriptLoader), i0.ɵɵinject(i1.BaseSiteService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CaptchaService,
      factory: CaptchaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SiteAdapter
  }, {
    type: CaptchaApiConfig
  }, {
    type: i1.LanguageService
  }, {
    type: i1.ScriptLoader
  }, {
    type: i1.BaseSiteService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MockCaptchaService extends CaptchaService {
  initialize() {
    super.initialize();
    // creating mock elements for captcha.
    this.container = document.createElement('div');
    this.container.className = 'form-check';
    this.checkbox = document.createElement('input');
    this.checkbox.type = 'checkbox';
    this.checkbox.className = 'mock-captcha';
    this.label = document.createElement('label');
    this.label.textContent = "I'm not a robot";
    this.container.appendChild(this.checkbox);
    this.container.appendChild(this.label);
    this.spinner = document.createElement('icon');
    this.spinner.className = 'fa-solid fa-spinner';
    this.checkbox.addEventListener('change', this.onCheckBoxClicked.bind(this));
  }
  onCheckBoxClicked() {
    this.label.textContent = '';
    this.container.appendChild(this.spinner);
    this.checkbox.disabled = true;
    this.checkbox.checked = true;
    setTimeout(() => {
      this.container.removeChild(this.spinner);
      this.retVal.next('succeed');
      this.retVal.complete();
      this.token = 'myToken';
      this.label.textContent = 'Verified';
    }, 500);
  }
  /**
   * Add element to page.
   * @param {HTMLElement} element - HTML element to render captcha widget within.
   */
  renderCaptcha(renderParams) {
    if (renderParams.element instanceof HTMLElement) {
      // Reset checkbox state before rendering
      this.checkbox.disabled = false;
      this.checkbox.checked = false;
      this.label.textContent = "I'm not a robot";
      this.token = '';
      this.retVal = new Subject();
      renderParams.element.appendChild(this.container);
    }
    return this.retVal.asObservable();
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMockCaptchaService_BaseFactory;
      return function MockCaptchaService_Factory(__ngFactoryType__) {
        return (ɵMockCaptchaService_BaseFactory || (ɵMockCaptchaService_BaseFactory = i0.ɵɵgetInheritedFactory(MockCaptchaService)))(__ngFactoryType__ || MockCaptchaService);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MockCaptchaService,
      factory: MockCaptchaService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MockCaptchaService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const MockCaptchaApiConfig = {
  captchaRenderer: MockCaptchaService
};

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CaptchaModule {
  static {
    this.ɵfac = function CaptchaModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CaptchaModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CaptchaModule,
      declarations: [CaptchaComponent],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule],
      exports: [CaptchaComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(MockCaptchaApiConfig)],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CaptchaModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule],
      declarations: [CaptchaComponent],
      providers: [provideDefaultConfig(MockCaptchaApiConfig)],
      exports: [CaptchaComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FilesFormValidators {
  constructor() {
    this.CONVERT_TO_MB = 1000000;
    this.extenstionRegEx = /\.([0-9a-z]+)(?:[\?#]|$)/i;
  }
  /**
   * Checks max size of file
   *
   * @param {number} maxSize Max size [MB]
   * @returns Uses 'tooLarge' validator error with maxSize property
   * @memberOf FilesFormValidators
   */
  maxSize(maxSize) {
    return control => {
      const errors = {};
      if (maxSize && control.value) {
        const files = Array.from(control.value);
        files.forEach(({
          size,
          name
        }) => {
          if (size > maxSize * this.CONVERT_TO_MB) {
            const invalidFiles = errors.tooLarge?.invalidFiles ?? [];
            errors.tooLarge = {
              maxSize,
              invalidFiles: [...invalidFiles, name]
            };
          }
        });
      }
      return Object.keys(errors).length === 0 ? null : errors;
    };
  }
  /**
   * Checks maximum entries
   *
   * @param {number} maxEntries Max number of entries
   * @returns Uses 'tooManyEntries' validator error with maxEntries property
   * @memberOf FilesFormValidators
   */
  maxEntries(maxEntries) {
    return control => {
      const errors = {};
      if (maxEntries && control.value) {
        const files = Array.from(control.value);
        if (files.length > maxEntries) {
          errors.tooManyEntries = {
            maxEntries
          };
        }
      }
      return Object.keys(errors).length === 0 ? null : errors;
    };
  }
  /**
   * Checks allowed types
   *
   * @param {Array<string>} allowedTypes Allowed types of files
   * @returns Uses 'notParsable' validator error with allowedTypes property
   * @memberOf FilesFormValidators
   */
  allowedTypes(allowedTypes) {
    return control => {
      const errors = {};
      if (allowedTypes && control.value) {
        const files = Array.from(control.value);
        errors.fileNotAllowed = files.some(({
          name
        }) => !allowedTypes.includes(this.getExtension(name)));
      }
      return errors[Object.keys(errors)?.[0]] ? errors : null;
    };
  }
  getExtension(filename) {
    return (filename?.match(this.extenstionRegEx) || [])[0] || '';
  }
  static {
    this.ɵfac = function FilesFormValidators_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FilesFormValidators)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FilesFormValidators,
      factory: FilesFormValidators.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FilesFormValidators, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AvatarComponent {
  constructor() {
    this.iconTypes = ICON_TYPE;
  }
  getInitials(author) {
    return author.split(' ').map(string => string[0]).join('');
  }
  static {
    this.ɵfac = function AvatarComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AvatarComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AvatarComponent,
      selectors: [["cx-avatar"]],
      inputs: {
        message: "message"
      },
      standalone: false,
      decls: 1,
      vars: 1,
      consts: [["class", "cx-avatar", 3, "ngClass", 4, "ngIf"], [1, "cx-avatar", 3, "ngClass"], [4, "ngIf"], [3, "type", 4, "ngIf"], [3, "type"]],
      template: function AvatarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, AvatarComponent_div_0_Template, 4, 6, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.message);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, IconComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AvatarComponent, [{
    type: Component,
    args: [{
      selector: 'cx-avatar',
      standalone: false,
      template: "<div\n  *ngIf=\"message\"\n  class=\"cx-avatar\"\n  [ngClass]=\"{ 'right-align': message.rightAlign }\"\n>\n  <span *ngIf=\"!message.rightAlign && message?.author\">\n    {{ getInitials(message?.author || '') }}\n  </span>\n\n  <cx-icon\n    *ngIf=\"!message.rightAlign && !message?.author\"\n    [type]=\"iconTypes.USER\"\n  ></cx-icon>\n\n  <cx-icon *ngIf=\"message.rightAlign\" [type]=\"iconTypes.HEADSET\"></cx-icon>\n</div>\n"
    }]
  }], null, {
    message: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MessagingComponent {
  get inputCharacterLeft() {
    return (this.messagingConfigs?.charactersLimit || this.MAX_INPUT_CHARACTERS) - (this.form.get('message')?.value?.length || 0);
  }
  get maxSize() {
    return this.messagingConfigs?.attachmentRestrictions?.maxSize || this.MAX_SIZE;
  }
  get maxEntries() {
    return this.messagingConfigs?.attachmentRestrictions?.maxEntries || this.MAX_ENTRIES;
  }
  get allowedTypes() {
    return this.messagingConfigs?.attachmentRestrictions?.allowedTypes || [];
  }
  constructor(windowRef, filesFormValidators) {
    this.windowRef = windowRef;
    this.filesFormValidators = filesFormValidators;
    this.scrollToInput = true;
    this.send = new EventEmitter();
    this.itemClicked = new EventEmitter();
    this.downloadAttachment = new EventEmitter();
    this.iconTypes = ICON_TYPE;
    this.MAX_INPUT_CHARACTERS = 2000;
    this.MAX_SIZE = 10;
    this.MAX_ENTRIES = 1;
    this.dateFormat = 'MMMM d, YYYY h:mm aa';
    this.scrollOnceOnLoad = true;
    useFeatureStyles('a11yCroppedFocusRing');
  }
  ngOnInit() {
    this.buildForm();
  }
  ngAfterViewChecked() {
    if (this.scrollToInput) {
      this.observeScroll();
      if (this.scrollOnceOnLoad) {
        this.scrollOnLoad();
      }
    }
  }
  onSend() {
    if (this.form.valid) {
      const event = {
        files: this.form.get('file')?.value,
        message: this.form.get('message')?.value
      };
      const itemId = this.form.get('item')?.value;
      if (itemId) {
        event.itemId = itemId;
      }
      this.send.emit(event);
    }
  }
  resetForm() {
    this.form.reset({
      item: this.messagingConfigs?.defaultItemId
    });
    this.fileUploadComponent?.removeFile();
  }
  triggerDownload(messageCode, attachmentId, fileName) {
    this.downloadAttachment.emit({
      messageCode: messageCode,
      attachmentId: attachmentId,
      fileName: fileName
    });
  }
  buildForm() {
    const form = new UntypedFormGroup({});
    form.setControl('message', new UntypedFormControl('', [Validators.required, Validators.maxLength(this.messagingConfigs?.charactersLimit || this.MAX_INPUT_CHARACTERS)]));
    form.setControl('file', new UntypedFormControl('', [this.filesFormValidators.maxSize(this.maxSize), this.filesFormValidators.maxEntries(this.maxEntries), this.filesFormValidators.allowedTypes(this.allowedTypes)]));
    form.setControl('item', new UntypedFormControl(this.messagingConfigs?.defaultItemId));
    this.form = form;
  }
  focusNextChild(event) {
    event.preventDefault();
    const [results, focusedIndex] = [this.getResultElements(), this.getFocusedIndex()];
    if (results.length) {
      if (focusedIndex >= results.length - 1) {
        results[0].focus();
      } else {
        results[focusedIndex + 1].focus();
      }
    }
  }
  focusPreviousChild(event) {
    if (!this.windowRef.isBrowser()) {
      return;
    }
    event.preventDefault();
    const [results, focusedIndex] = [this.getResultElements(), this.getFocusedIndex()];
    if (results.length) {
      if (focusedIndex < 1) {
        results[results.length - 1].focus();
      } else {
        results[focusedIndex - 1].focus();
      }
    }
  }
  /**
   * A message can be linked to an item. In this case the item name will be prefixed to the message text.
   *
   * @param {MessageEvent} message message
   * @returns {string | undefined} message text prefixed with item name, in case its given.
   */
  getMessageText(message) {
    return message.item ? message.item.name + ': ' + message.text : message.text;
  }
  onItemClicked(item) {
    this.itemClicked.emit({
      item: item
    });
  }
  observeScroll() {
    const element = this.windowRef.document.querySelector('.cx-messages');
    if (element) {
      const resizeObserver = new ResizeObserver(entries => {
        this.scrollToBottom(element, entries[0].target.scrollHeight);
        this.updatedScrollHeight = entries[0].target.scrollHeight;
      });
      resizeObserver.observe(element);
    }
  }
  scrollToBottom(element, previousScrollHeight) {
    if (this.heightChanged(previousScrollHeight)) {
      element?.scroll({
        top: element?.scrollHeight,
        behavior: 'auto'
      });
    }
  }
  heightChanged(previousScrollHeight) {
    return this.updatedScrollHeight !== previousScrollHeight;
  }
  scrollOnLoad() {
    const element = this.windowRef.document.getElementById('cx-message-footer');
    const resizeObserver = new ResizeObserver(() => {
      element?.scrollIntoView({
        behavior: 'auto',
        block: 'end'
      });
      this.scrollOnceOnLoad = false;
    });
    if (element) {
      resizeObserver.observe(element);
    }
  }
  getResultElements() {
    return Array.from(this.windowRef.document.querySelectorAll('[role="listitem"]'));
  }
  getFocusedIndex() {
    return this.getResultElements().indexOf(this.getFocusedElement());
  }
  getFocusedElement() {
    return this.windowRef.document.activeElement;
  }
  static {
    this.ɵfac = function MessagingComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MessagingComponent)(i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(FilesFormValidators));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MessagingComponent,
      selectors: [["cx-messaging"]],
      viewQuery: function MessagingComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FileUploadComponent, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUploadComponent = _t.first);
        }
      },
      inputs: {
        messageEvents$: "messageEvents$",
        scrollToInput: "scrollToInput",
        messagingConfigs: "messagingConfigs"
      },
      outputs: {
        send: "send",
        itemClicked: "itemClicked",
        downloadAttachment: "downloadAttachment"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "container"], [1, "cx-avatar-line"], ["role", "list", "id", "cx-messages", 1, "cx-messages", 3, "keydown.arrowdown", "keydown.arrowup"], [4, "ngFor", "ngForOf"], ["class", "cx-message-footer", 3, "formGroup", 4, "ngIf"], ["role", "listitem", 1, "cx-message-card", 3, "ngClass"], [3, "message"], [3, "ngClass", "tabindex"], ["class", "cx-message-item-link", 3, "click", 4, "ngIf"], ["class", "cx-attachment", "target", "_blank", "rel", "noopener noreferrer", 3, "click", 4, "ngFor", "ngForOf"], [1, "cx-message-item-link", 3, "click"], ["target", "_blank", "rel", "noopener noreferrer", 1, "cx-attachment", 3, "click"], [3, "type"], [1, "cx-message-footer", 3, "formGroup"], [1, "cx-message-box"], ["id", "cx-messaging-footer-label", 1, "cx-footer-label"], ["class", "cx-message-item-selection", "formControlName", "item", 4, "ngIf"], [1, "cx-message-input"], ["aria-labelledby", "cx-messaging-footer-label", "formControlName", "message", "type", "text", 1, "form-control", 3, "keydown.enter", "maxLength", "placeholder"], ["class", "cx-visually-hidden", "role", "alert", 4, "ngIf"], ["aria-labelledby", "cx-messaging-footer-label", 1, "btn", "btn-block", "cx-send", 3, "click", "ngClass"], ["id", "cx-message-footer", 1, "cx-message-footer-info"], [3, "formControl", "accept", 4, "ngIf"], [1, "cx-message-footer-info-text"], ["prefix", "formErrors.file", 3, "control"], ["formControlName", "item", 1, "cx-message-item-selection"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], ["role", "alert", 1, "cx-visually-hidden"], [3, "formControl", "accept"], [1, "cx-message-footer-text"]],
      template: function MessagingComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MessagingComponent_ng_container_0_Template, 8, 7, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.messageEvents$));
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, IconComponent, i1$4.NgSelectOption, i1$4.ɵNgSelectMultipleOption, i1$4.DefaultValueAccessor, i1$4.SelectControlValueAccessor, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.FormControlDirective, i1$4.FormGroupDirective, i1$4.FormControlName, FileUploadComponent, FormErrorsComponent, AvatarComponent, i3.AsyncPipe, i1.TranslatePipe, i1.CxDatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MessagingComponent, [{
    type: Component,
    args: [{
      selector: 'cx-messaging',
      standalone: false,
      template: "<ng-container *ngIf=\"messageEvents$ | async as messageEvents\">\n  <div class=\"container\">\n    <div class=\"cx-avatar-line\"></div>\n    <div\n      role=\"list\"\n      class=\"cx-messages\"\n      id=\"cx-messages\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      [attr.aria-label]=\"'chatMessaging.messages' | cxTranslate\"\n    >\n      <ng-container *ngFor=\"let message of messageEvents; let i = index\">\n        <div\n          class=\"cx-message-card\"\n          role=\"listitem\"\n          [ngClass]=\"{ 'cx-message-display': message.rightAlign ?? false }\"\n        >\n          <cx-avatar [message]=\"message\"> </cx-avatar>\n\n          <div>\n            <label>{{\n              (message.createdAt | cxDate: messagingConfigs?.dateFormat) ??\n                dateFormat\n            }}</label>\n            <div\n              [ngClass]=\"\n                (message.rightAlign ?? false)\n                  ? 'cx-message-right-align-text'\n                  : 'cx-message-left-align-text'\n              \"\n              [tabindex]=\"i ? -1 : 0\"\n              [attr.aria-label]=\"\n                'chatMessaging.informationLabel'\n                  | cxTranslate\n                    : {\n                        author: message.author,\n                        text: getMessageText(message),\n                        date:\n                          (message.createdAt\n                            | cxDate: messagingConfigs?.dateFormat) ??\n                          dateFormat,\n                      }\n              \"\n            >\n              <a\n                *ngIf=\"message.item\"\n                class=\"cx-message-item-link\"\n                (click)=\"onItemClicked(message.item)\"\n                >{{ message.item.name }}:</a\n              >\n              {{ message.text }}\n            </div>\n            <a\n              *ngFor=\"let attachment of message.attachments ?? []\"\n              class=\"cx-attachment\"\n              (click)=\"\n                triggerDownload(\n                  message.code,\n                  attachment.id,\n                  attachment.filename\n                )\n              \"\n              target=\"_blank\"\n              rel=\"noopener noreferrer\"\n            >\n              <cx-icon [type]=\"iconTypes.ATTACHMENT\"></cx-icon>\n              {{ attachment.filename }}\n            </a>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n  </div>\n\n  <div\n    [formGroup]=\"form\"\n    class=\"cx-message-footer\"\n    *ngIf=\"messagingConfigs?.displayAddMessageSection | async\"\n  >\n    <div class=\"cx-message-box\">\n      <label class=\"cx-footer-label\" id=\"cx-messaging-footer-label\">\n        <span>\n          {{ 'chatMessaging.addNewMessage' | cxTranslate }}\n          <select\n            [attr.aria-label]=\"\n              'chatMessaging.a11y.itemListBoxLabel' | cxTranslate\n            \"\n            *ngIf=\"messagingConfigs?.itemList$ | async as itemList\"\n            class=\"cx-message-item-selection\"\n            formControlName=\"item\"\n          >\n            <option *ngFor=\"let item of itemList\" value=\"{{ item.id }}\">\n              {{ item.name }}\n            </option>\n          </select>\n        </span>\n        <div class=\"cx-message-input\">\n          <input\n            aria-labelledby=\"cx-messaging-footer-label\"\n            formControlName=\"message\"\n            type=\"text\"\n            class=\"form-control\"\n            (keydown.enter)=\"onSend()\"\n            [maxLength]=\"\n              messagingConfigs?.charactersLimit || MAX_INPUT_CHARACTERS\n            \"\n            placeholder=\"{{\n              messagingConfigs?.newMessagePlaceHolder ||\n                ('chatMessaging.addMessagePlaceHolder' | cxTranslate)\n            }}\"\n          />\n          <span\n            class=\"cx-visually-hidden\"\n            *ngIf=\"inputCharacterLeft === 0\"\n            role=\"alert\"\n          >\n            {{ 'chatMessaging.characterLimitAlert' | cxTranslate }}\n          </span>\n          <button\n            aria-labelledby=\"cx-messaging-footer-label\"\n            class=\"btn btn-block cx-send\"\n            [ngClass]=\"\n              !!messagingConfigs?.sendBtnIsNotPrimary\n                ? 'btn-secondary'\n                : 'btn-primary'\n            \"\n            (click)=\"onSend()\"\n          >\n            {{ 'chatMessaging.send' | cxTranslate }}\n          </button>\n        </div>\n      </label>\n      <div class=\"cx-message-footer-info\" id=\"cx-message-footer\">\n        <cx-file-upload\n          [formControl]=\"$any(form.get('file'))\"\n          [accept]=\"allowedTypes\"\n          *ngIf=\"messagingConfigs?.enableFileUploadOption\"\n        >\n          <ng-template>\n            <cx-icon [type]=\"iconTypes.UPLOAD\"></cx-icon>\n            <span class=\"cx-message-footer-text\"\n              >{{ 'chatMessaging.uploadFile' | cxTranslate }}\n            </span>\n          </ng-template>\n        </cx-file-upload>\n\n        <p class=\"cx-message-footer-info-text\">\n          {{\n            'chatMessaging.charactersLeft'\n              | cxTranslate: { count: inputCharacterLeft }\n          }}\n        </p>\n      </div>\n      <cx-form-errors\n        [control]=\"form.get('file')\"\n        prefix=\"formErrors.file\"\n      ></cx-form-errors>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: FilesFormValidators
  }], {
    fileUploadComponent: [{
      type: ViewChild,
      args: [FileUploadComponent]
    }],
    messageEvents$: [{
      type: Input
    }],
    scrollToInput: [{
      type: Input
    }],
    messagingConfigs: [{
      type: Input
    }],
    send: [{
      type: Output
    }],
    itemClicked: [{
      type: Output
    }],
    downloadAttachment: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ChatMessagingModule {
  static {
    this.ɵfac = function ChatMessagingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ChatMessagingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ChatMessagingModule,
      declarations: [AvatarComponent, MessagingComponent],
      imports: [CommonModule, I18nModule, IconModule, FormsModule, ReactiveFormsModule, FileUploadModule, FormErrorsModule],
      exports: [AvatarComponent, MessagingComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, IconModule, FormsModule, ReactiveFormsModule, FileUploadModule, FormErrorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChatMessagingModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, IconModule, FormsModule, ReactiveFormsModule, FileUploadModule, FormErrorsModule],
      declarations: [AvatarComponent, MessagingComponent],
      exports: [AvatarComponent, MessagingComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerCarouselModule {
  static {
    this.ɵfac = function BannerCarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BannerCarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BannerCarouselModule,
      declarations: [BannerCarouselComponent],
      imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule],
      exports: [BannerCarouselComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          RotatingImagesComponent: {
            component: BannerCarouselComponent
          }
        }
      })],
      imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerCarouselModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, PageComponentModule, CarouselModule, MediaModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          RotatingImagesComponent: {
            component: BannerCarouselComponent
          }
        }
      })],
      declarations: [BannerCarouselComponent],
      exports: [BannerCarouselComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerComponent {
  constructor(component, urlService, cmsService) {
    this.component = component;
    this.urlService = urlService;
    this.cmsService = cmsService;
    this.data$ = this.component.data$.pipe(tap(data => {
      this.setRouterLink(data);
      this.styleClasses = data.styleClasses;
    }));
  }
  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.external` flag is set to true.
   */
  getTarget(data) {
    return data.external === 'true' || data.external === true ? '_blank' : null;
  }
  setRouterLink(data) {
    if (data.urlLink) {
      this.routerLink = data.urlLink;
    } else if (data.contentPage) {
      this.cmsService.getPage({
        id: data.contentPage,
        type: PageType.CONTENT_PAGE
      }).pipe(take(1)).subscribe(page => {
        this.routerLink = page?.label;
      });
    } else if (data.product) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'product',
        params: {
          code: data.product
        }
      });
    } else if (data.category) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'category',
        params: {
          code: data.category
        }
      });
    }
  }
  getImage(data) {
    if (data.media) {
      if ('url' in data.media) {
        return data.media;
      } else {
        return data.media;
      }
    }
  }
  getImageAltText(data) {
    const img = this.getImage(data);
    if (!img) {
      return;
    }
    // assuming all media formats share the same alt text
    return 'url' in img ? img.altText : Object.values(img)[0]?.altText;
  }
  getLinkAriaLabel(data) {
    const imgAltText = this.getImageAltText(data);
    return data.headline ?? imgAltText;
  }
  static {
    this.ɵfac = function BannerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BannerComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.SemanticPathService), i0.ɵɵdirectiveInject(i1.CmsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BannerComponent,
      selectors: [["cx-banner"]],
      hostVars: 2,
      hostBindings: function BannerComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClasses);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [3, "url", "target", "ariaLabel"], ["class", "headline", 3, "innerHTML", 4, "ngIf"], [3, "container", "elementType", 4, "cxFeature"], [3, "container", 4, "cxFeature"], ["class", "content", 3, "innerHTML", 4, "ngIf"], [1, "headline", 3, "innerHTML"], [3, "container", "elementType"], [3, "container"], [1, "content", 3, "innerHTML"], [1, "no-link"]],
      template: function BannerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, BannerComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.data$));
        }
      },
      dependencies: [i3.NgIf, GenericLinkComponent, MediaComponent, i1.FeatureDirective, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-banner',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"data$ | async as data\">\n  <ng-container *ngIf=\"routerLink\">\n    <cx-generic-link\n      [url]=\"routerLink\"\n      [target]=\"getTarget(data)\"\n      [ariaLabel]=\"getLinkAriaLabel(data)\"\n      [attr.title]=\"!data.headline ? getImageAltText(data) : null\"\n    >\n    </cx-generic-link>\n    <p class=\"headline\" *ngIf=\"data.headline\" [innerHTML]=\"data.headline\"></p>\n    <cx-media\n      *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n      [container]=\"getImage(data)\"\n      [elementType]=\"'picture'\"\n    ></cx-media>\n    <cx-media\n      *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n      [container]=\"getImage(data)\"\n    ></cx-media>\n    <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n  </ng-container>\n\n  <ng-container *ngIf=\"!routerLink\">\n    <div class=\"no-link\">\n      <p class=\"headline\" *ngIf=\"data.headline\" [innerHTML]=\"data.headline\"></p>\n      <cx-media\n        *cxFeature=\"'useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n        [elementType]=\"'picture'\"\n      ></cx-media>\n      <cx-media\n        *cxFeature=\"'!useExtendedMediaComponentConfiguration'\"\n        [container]=\"getImage(data)\"\n      ></cx-media>\n      <p class=\"content\" *ngIf=\"data.content\" [innerHTML]=\"data.content\"></p>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.SemanticPathService
  }, {
    type: i1.CmsService
  }], {
    styleClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BannerModule {
  static {
    this.ɵfac = function BannerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BannerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BannerModule,
      declarations: [BannerComponent],
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, FeaturesConfigModule],
      exports: [BannerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          SimpleResponsiveBannerComponent: {
            component: BannerComponent
          },
          BannerComponent: {
            component: BannerComponent
          },
          SimpleBannerComponent: {
            component: BannerComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BannerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          SimpleResponsiveBannerComponent: {
            component: BannerComponent
          },
          BannerComponent: {
            component: BannerComponent
          },
          SimpleBannerComponent: {
            component: BannerComponent
          }
        }
      })],
      declarations: [BannerComponent],
      exports: [BannerComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LinkComponent {
  constructor(component) {
    this.component = component;
    this.data$ = this.component.data$;
    this.subscriptions = new Subscription();
  }
  ngOnInit() {
    this.subscriptions.add(this.data$.subscribe(data => {
      this.styleClasses = data?.styleClasses;
    }));
  }
  /**
   * Returns `_blank` to force opening the link in a new window whenever the
   * `data.target` flag is set to `true`.
   */
  getTarget(data) {
    return data.target === 'true' || data.target === true ? '_blank' : null;
  }
  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
  static {
    this.ɵfac = function LinkComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LinkComponent)(i0.ɵɵdirectiveInject(CmsComponentData));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: LinkComponent,
      selectors: [["cx-link"]],
      hostVars: 2,
      hostBindings: function LinkComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClasses);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "url", "style", "target", 4, "ngIf"], [3, "url", "target"]],
      template: function LinkComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, LinkComponent_cx_generic_link_0_Template, 2, 5, "cx-generic-link", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.data$));
        }
      },
      dependencies: [i3.NgIf, GenericLinkComponent, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkComponent, [{
    type: Component,
    args: [{
      selector: 'cx-link',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-generic-link\n  *ngIf=\"data$ | async as data\"\n  [url]=\"data.url ?? ''\"\n  [style]=\"data.styleAttributes\"\n  [target]=\"getTarget(data)\"\n  >{{ data.linkName }}</cx-generic-link\n>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }], {
    styleClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LinkModule {
  static {
    this.ɵfac = function LinkModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LinkModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LinkModule,
      declarations: [LinkComponent],
      imports: [CommonModule, RouterModule, GenericLinkModule],
      exports: [LinkComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSLinkComponent: {
            component: LinkComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, GenericLinkModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LinkModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, GenericLinkModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSLinkComponent: {
            component: LinkComponent
          }
        }
      })],
      declarations: [LinkComponent],
      exports: [LinkComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Supplements the anchor links that contain only the hash fragment in the `href` attribute,
 * (e.g. `<a href="#someId">`), by prepending the current location (path and query params),
 * so it becomes a link to a full url
 * e.g. `<a href="https://domain.com/current/path?and=query-params#someId">`.
 *
 * This helps to avoid the undesirable navigation to the homepage URL (`/#someId`)
 * when clicking the original link.
 *
 * It's useful for example for cms-provided content passed to the [innerHTML] directive.
 */
class SupplementHashAnchorsPipe {
  constructor(renderer, winRef) {
    this.renderer = renderer;
    this.winRef = winRef;
  }
  getPath(anchorId) {
    const currentUrlWithoutFragment = this.winRef.location.href?.replace(/#.*$/, '');
    return `${currentUrlWithoutFragment}${anchorId}`;
  }
  transform(html = '') {
    const template = this.renderer.createElement('template');
    template.innerHTML = html.trim();
    const linkNodes = template.content.querySelectorAll('a');
    Array.from(linkNodes).forEach(link => {
      const href = link.getAttribute('href');
      if (href?.indexOf('#') === 0) {
        this.renderer.setProperty(link, 'href', this.getPath(href));
      }
    });
    return template.innerHTML;
  }
  static {
    this.ɵfac = function SupplementHashAnchorsPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SupplementHashAnchorsPipe)(i0.ɵɵdirectiveInject(i0.Renderer2, 16), i0.ɵɵdirectiveInject(i1.WindowRef, 16));
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cxSupplementHashAnchors",
      type: SupplementHashAnchorsPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplementHashAnchorsPipe, [{
    type: Pipe,
    args: [{
      name: 'cxSupplementHashAnchors',
      standalone: false
    }]
  }], () => [{
    type: i0.Renderer2
  }, {
    type: i1.WindowRef
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ParagraphComponent {
  handleClick(event) {
    if (event.target instanceof HTMLAnchorElement) {
      const element = event.target;
      const href = element?.getAttribute('href');
      const documentUrlObject = new URL(element.ownerDocument.URL);
      // Use router for internal link navigation
      if (href && documentUrlObject.host === element.host) {
        event.preventDefault();
        this.router.navigateByUrl(href.replace(documentUrlObject.origin, ''));
      }
    }
  }
  constructor(component, router) {
    this.component = component;
    this.router = router;
    this.sanitizer = inject(DomSanitizer);
  }
  bypassSecurityTrustHtml(html = '') {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  static {
    this.ɵfac = function ParagraphComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ParagraphComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1$2.Router));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ParagraphComponent,
      selectors: [["cx-paragraph"]],
      hostBindings: function ParagraphComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function ParagraphComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]],
      template: function ParagraphComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ParagraphComponent_div_0_Template, 2, 3, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.component.data$));
        }
      },
      dependencies: [i3.NgIf, i3.AsyncPipe, SupplementHashAnchorsPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ParagraphComponent, [{
    type: Component,
    args: [{
      selector: 'cx-paragraph',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  *ngIf=\"component.data$ | async as data\"\n  [innerHTML]=\"bypassSecurityTrustHtml(data.content | cxSupplementHashAnchors)\"\n></div>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1$2.Router
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SupplementHashAnchorsModule {
  static {
    this.ɵfac = function SupplementHashAnchorsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SupplementHashAnchorsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SupplementHashAnchorsModule,
      declarations: [SupplementHashAnchorsPipe],
      exports: [SupplementHashAnchorsPipe]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SupplementHashAnchorsModule, [{
    type: NgModule,
    args: [{
      declarations: [SupplementHashAnchorsPipe],
      exports: [SupplementHashAnchorsPipe]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CmsParagraphModule {
  static {
    this.ɵfac = function CmsParagraphModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CmsParagraphModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CmsParagraphModule,
      declarations: [ParagraphComponent],
      imports: [CommonModule, RouterModule, SupplementHashAnchorsModule],
      exports: [ParagraphComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSParagraphComponent: {
            component: ParagraphComponent
          },
          CMSTabParagraphComponent: {
            component: ParagraphComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, SupplementHashAnchorsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CmsParagraphModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, SupplementHashAnchorsModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSParagraphComponent: {
            component: ParagraphComponent
          },
          CMSTabParagraphComponent: {
            component: ParagraphComponent
          }
        }
      })],
      declarations: [ParagraphComponent],
      exports: [ParagraphComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PDFComponent {
  constructor(component, mediaService) {
    this.component = component;
    this.mediaService = mediaService;
    this.data$ = this.component.data$.pipe(tap(data => {
      if (data?.pdfFile?.url) {
        this.url = this.mediaService.getMedia(data.pdfFile)?.src;
      }
    }));
  }
  addPdfExtension(title) {
    if (!title) {
      return '';
    }
    const trimTitle = title.trim();
    return trimTitle.endsWith('.pdf') ? trimTitle : `${trimTitle}.pdf`;
  }
  static {
    this.ɵfac = function PDFComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PDFComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(MediaService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PDFComponent,
      selectors: [["cx-pdf"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "pdf-container"], ["target", "_blank", "rel", "noopener noreferrer", 3, "href"], ["aria-hidden", "true"], [3, "type"]],
      template: function PDFComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PDFComponent_ng_container_0_Template, 8, 5, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.data$));
        }
      },
      dependencies: [i3.NgIf, IconComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PDFComponent, [{
    type: Component,
    args: [{
      selector: 'cx-pdf',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"data$ | async as data\">\n  <div class=\"pdf-container\">\n    <a [href]=\"url\" target=\"_blank\" rel=\"noopener noreferrer\">\n      <span>{{\n        addPdfExtension(\n          data?.title ||\n            data?.pdfFile?.altText ||\n            ('pdf.defaultTitle' | cxTranslate)\n        )\n      }}</span>\n      <span aria-hidden=\"true\">\n        <cx-icon [type]=\"'PDF_FILE'\"></cx-icon>\n      </span>\n    </a>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: MediaService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PDFModule {
  static {
    this.ɵfac = function PDFModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PDFModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PDFModule,
      declarations: [PDFComponent],
      imports: [CommonModule, IconModule, I18nModule],
      exports: [PDFComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          PDFDocumentComponent: {
            component: PDFComponent
          }
        }
      })],
      imports: [CommonModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PDFModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, IconModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          PDFDocumentComponent: {
            component: PDFComponent
          }
        }
      })],
      declarations: [PDFComponent],
      exports: [PDFComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var TAB_MODE;
(function (TAB_MODE) {
  TAB_MODE["TAB"] = "TAB";
  TAB_MODE["ACCORDIAN"] = "ACCORDIAN";
})(TAB_MODE || (TAB_MODE = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * If the passed index its outside of the min and max boundaries,
 * wrap the index exceeding the max boundary to the min boundary or vice versa.
 * Return the index if it does not exceed any boundary.
 */
function wrapIntoBounds(index, max, min = 0) {
  if (index < min) {
    return max;
  } else if (index > max) {
    return min;
  }
  return index;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabPanelComponent {
  constructor() {
    this.TAB_MODE = TAB_MODE;
    /**
     * In which layout to set the component (ie. Tab or Accordian).
     * Defaults to "Tab" mode.
     */
    this.mode = TAB_MODE.TAB;
  }
  static {
    this.ɵfac = function TabPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabPanelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabPanelComponent,
      selectors: [["cx-tab-panel"]],
      inputs: {
        tab: "tab",
        mode: "mode"
      },
      standalone: false,
      decls: 2,
      vars: 8,
      consts: [[1, "active", 3, "tabindex", "cxFocus"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"]],
      template: function TabPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TabPanelComponent_ng_container_1_Template, 1, 1, "ng-container", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_3_0;
          i0.ɵɵproperty("tabindex", ctx.tab.disableBorderFocus ? -1 : 0)("cxFocus", i0.ɵɵpureFunction1(6, _c39, !ctx.tab.disableBorderFocus));
          i0.ɵɵattribute("role", ctx.mode === ctx.TAB_MODE.ACCORDIAN ? "region" : "tabpanel")("aria-labelledby", (tmp_3_0 = ctx.tab.id) !== null && tmp_3_0 !== undefined ? tmp_3_0 : null)("id", ctx.tab.id !== null && ctx.tab.id !== undefined ? "section-" + ctx.tab.id : null);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.tab.content);
        }
      },
      dependencies: [i3.NgIf, i3.NgTemplateOutlet, FocusDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPanelComponent, [{
    type: Component,
    args: [{
      selector: 'cx-tab-panel',
      standalone: false,
      template: "<div\n  [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'region' : 'tabpanel'\"\n  [tabindex]=\"tab.disableBorderFocus ? -1 : 0\"\n  [attr.aria-labelledby]=\"tab.id ?? null\"\n  [attr.id]=\"\n    tab.id !== null && tab.id !== undefined ? 'section-' + tab.id : null\n  \"\n  class=\"active\"\n  [cxFocus]=\"{ focusOnEscape: !tab.disableBorderFocus }\"\n>\n  <ng-container\n    *ngIf=\"tab.content\"\n    [ngTemplateOutlet]=\"tab.content\"\n  ></ng-container>\n</div>\n"
    }]
  }], null, {
    tab: [{
      type: Input
    }],
    mode: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabComponent {
  constructor() {
    this.disabled = false;
    this.TAB_MODE = TAB_MODE;
    this.breakpointService = inject(BreakpointService);
    this.translationService = inject(TranslationService);
    this.cd = inject(ChangeDetectorRef);
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
    this.subscriptions = new Subscription();
    useFeatureStyles('a11yCroppedFocusRing');
  }
  ngOnInit() {
    this.openTabs$ = new BehaviorSubject(this.config?.openTabs ?? []);
    this.mode$ = this.getMode();
  }
  ngAfterViewInit() {
    /**
     * We subscribe to the tabs observable if added and use this to set
     * the `tabs` property. The input `tabs` property should not be
     * initialized. It will be overwritten by this otherwise.
     */
    this.subscriptions.add(this.tabs$?.subscribe(tabs => {
      this.tabs = tabs;
      this.cd.detectChanges();
    }));
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  /**
   * Tab selection works differently depending on the given mode.
   *
   * Modes:
   * - Tab: Closes all other tabs and opens the given tab.
   * - Accordian: Toggles the given tab open or closed.
   */
  select(tabNum, mode) {
    this.focus(tabNum);
    switch (mode) {
      case TAB_MODE.TAB:
        return this.openTabs$.next([tabNum]);
      case TAB_MODE.ACCORDIAN:
        return this.toggleTab(tabNum);
    }
  }
  /**
   * Focuses the given tab according to the number.
   */
  focus(tabNum) {
    this.tabHeaders.toArray()[tabNum].nativeElement.focus();
  }
  /**
   * Calls select or focus methods depending on the tab mode.
   */
  selectOrFocus(tabNum, mode, event) {
    event.preventDefault();
    if (this.featureConfigService?.isEnabled('a11yTabsManualActivation')) {
      switch (mode) {
        case TAB_MODE.TAB:
        case TAB_MODE.ACCORDIAN:
          return this.focus(tabNum);
      }
    } else {
      switch (mode) {
        case TAB_MODE.TAB:
          return this.select(tabNum, mode);
        case TAB_MODE.ACCORDIAN:
          return this.focus(tabNum);
      }
    }
  }
  /**
   * Handles keydown events made on tabs.
   *
   * Keys:
   * - ArrowUp / ArrowLeft: Select or focus the previous tab.
   * - ArrowRight / ArrowDown: Select or focus the next tab.
   * - Home: Select or focus the first tab.
   * - End: Select or focus the last tab.
   */
  handleKeydownEvent(tabNum, tabs, mode, event) {
    const FIRST_TAB = 0;
    const LAST_TAB = tabs.length - 1;
    const PREVIOUS_TAB = wrapIntoBounds(tabNum - 1, LAST_TAB);
    const NEXT_TAB = wrapIntoBounds(tabNum + 1, LAST_TAB);
    // Disable some keys is `restrictDirectionKeys` is enabled.
    if (this.config.restrictDirectionKeys && this.shouldRestrictKeys(mode, event)) {
      return;
    }
    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        return this.selectOrFocus(PREVIOUS_TAB, mode, event);
      case 'ArrowRight':
      case 'ArrowDown':
        return this.selectOrFocus(NEXT_TAB, mode, event);
      case 'Home':
        return this.selectOrFocus(FIRST_TAB, mode, event);
      case 'End':
        return this.selectOrFocus(LAST_TAB, mode, event);
    }
  }
  shouldRestrictKeys(mode, event) {
    if (mode === TAB_MODE.TAB && ['ArrowUp', 'ArrowDown'].includes(event.key)) {
      return true;
    }
    if (mode === TAB_MODE.ACCORDIAN && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
      return true;
    }
    return false;
  }
  /**
   * Indicates whether a tab is open (in the open tabs array).
   */
  isOpen(tabNum) {
    return this.getOpenTabs().find(open => open === tabNum) !== undefined;
  }
  /**
   * Inverts the state of the given tab between open and closed.
   */
  toggleTab(tabNum) {
    const openTabs = this.getOpenTabs();
    const openTabIndex = openTabs.indexOf(tabNum);
    openTabIndex > -1 ? openTabs.splice(openTabIndex, 1) : openTabs.push(tabNum);
    this.openTabs$.next(openTabs);
  }
  /**
   * Returns index 0 if the tab is already open,
   * no tabs are open and its the first tab (ie. 0),
   * or in 'ACCORDIAN' mode.
   * Otherwise returns -1.
   */
  getTabIndex(tabNum, mode) {
    return this.isOpen(tabNum) || tabNum === 0 && this.getOpenTabs().length === 0 || mode === 'ACCORDIAN' ? 0 : -1;
  }
  getTitle(mode, index) {
    const tab = this.tabs[index];
    // Not required in Tab mode.
    if (mode === TAB_MODE.TAB) {
      return null;
    }
    let header = tab.header;
    if (tab.headerKey) {
      this.translationService.translate(tab.headerKey).pipe(take(1)).subscribe(val => {
        header = val;
      });
    }
    return (
      // Show expanded or collapsed.
      (this.isOpen(index) ? 'Collapse' : 'Expand') + ' ' + header
    );
  }
  getOpenTabs() {
    return this.openTabs$.value;
  }
  /**
   * Returns the mode specified by the config.
   * If unspecified mode, return 'TAB' or 'ACCORDIAN' modes responsively using the specified breakpoint in the config.
   * If unspecified breakpoint, return 'TAB' mode by default.
   */
  getMode() {
    if (this.config.mode) {
      return of(this.config.mode);
    }
    if (this.config.breakpoint) {
      return this.breakpointService.isUp(this.config.breakpoint).pipe(map(isUp => isUp ? TAB_MODE.TAB : TAB_MODE.ACCORDIAN));
    }
    return of(TAB_MODE.TAB);
  }
  static {
    this.ɵfac = function TabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabComponent,
      selectors: [["cx-tab"]],
      viewQuery: function TabComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c40, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabHeaders = _t);
        }
      },
      inputs: {
        tabs$: "tabs$",
        tabs: "tabs",
        config: "config",
        disabled: "disabled"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["tabPanel", ""], ["tabHeader", ""], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "button", 1, "tab-btn", 3, "click", "keydown", "disabled"], ["class", "tab-icon", "aria-hidden", "true", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["aria-hidden", "true", 1, "tab-icon"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf"], [3, "tab", "mode", 4, "ngIf"], [3, "tab", "mode"]],
      template: function TabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TabComponent_ng_container_0_Template, 7, 8, "ng-container", 2);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.mode$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, TabPanelComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabComponent, [{
    type: Component,
    args: [{
      selector: 'cx-tab',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"mode$ | async as mode\">\n  <!-- Tab List is the list of buttons to open tabs -->\n  <div\n    [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? null : 'tablist'\"\n    [attr.aria-label]=\"config.label | cxTranslate\"\n    [class]=\"mode.toLowerCase()\"\n  >\n    <ng-container *ngFor=\"let tab of tabs; let i = index\">\n      <button\n        type=\"button\"\n        class=\"tab-btn\"\n        [attr.role]=\"mode === TAB_MODE.ACCORDIAN ? 'button' : 'tab'\"\n        (click)=\"select(i, mode)\"\n        (keydown)=\"handleKeydownEvent(i, tabs, mode, $event)\"\n        [attr.aria-selected]=\"mode === TAB_MODE.ACCORDIAN ? null : isOpen(i)\"\n        [attr.aria-expanded]=\"mode === TAB_MODE.TAB ? null : isOpen(i)\"\n        [attr.aria-controls]=\"isOpen(i) ? 'section-' + i : null\"\n        [attr.tabindex]=\"getTabIndex(i, mode)\"\n        [attr.id]=\"tab.id\"\n        [attr.title]=\"getTitle(mode, i)\"\n        [class.active]=\"isOpen(i)\"\n        [disabled]=\"disabled\"\n        #tabHeader\n      >\n        {{\n          tab.headerKey\n            ? (tab.headerKey | cxTranslate: tab.headerParams || {})\n            : tab.header\n        }}\n        <span\n          *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n          class=\"tab-icon\"\n          aria-hidden=\"true\"\n        >\n          {{ isOpen(i) ? '\u2013' : '+' }}\n        </span>\n      </button>\n\n      <!-- Show tab panels under selected button in Accordian mode -->\n      <ng-container\n        *ngIf=\"mode === TAB_MODE.ACCORDIAN\"\n        [ngTemplateOutlet]=\"tabPanel\"\n        [ngTemplateOutletContext]=\"{ tabNum: i }\"\n      ></ng-container>\n    </ng-container>\n  </div>\n\n  <!-- Show selected tab panel under all buttons in Tab mode -->\n  <ng-container *ngIf=\"mode === TAB_MODE.TAB\">\n    <ng-container\n      *ngFor=\"let tab of tabs; let i = index\"\n      [ngTemplateOutlet]=\"tabPanel\"\n      [ngTemplateOutletContext]=\"{ tabNum: i }\"\n    >\n    </ng-container>\n  </ng-container>\n\n  <!-- Tab Panel shows the content of the given tab -->\n  <ng-template #tabPanel let-tabNum=\"tabNum\">\n    <cx-tab-panel\n      [tab]=\"tabs[tabNum]\"\n      [mode]=\"mode\"\n      *ngIf=\"isOpen(tabNum)\"\n    ></cx-tab-panel>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [], {
    tabs$: [{
      type: Input
    }],
    tabs: [{
      type: Input
    }],
    config: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    tabHeaders: [{
      type: ViewChildren,
      args: ['tabHeader']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultTabConfig = {
  openTabs: [0],
  breakpoint: BREAKPOINT.md
};
class TabParagraphContainerComponent {
  constructor(componentData, cmsService, winRef) {
    this.componentData = componentData;
    this.cmsService = cmsService;
    this.winRef = winRef;
    this.cdr = inject(ChangeDetectorRef);
    /**
     * @deprecated This method will be removed.
     */
    this.activeTabNum = 0;
    /**
     * @deprecated This method will be removed.
     */
    this.tabTitleParams = [];
    this.tabConfig$ = new BehaviorSubject(defaultTabConfig);
    /**
     * Map with key as the component uid and value as the observable of the title parameters.
     */
    this.tabTitleParams$ = new BehaviorSubject(new Map());
    this.components$ = this.componentData.data$.pipe(distinctUntilChanged((x, y) => x?.components === y?.components), tap(data => {
      this.ariaLabel = `${data?.uid}.tabPanelContainerRegion`;
    }), switchMap(data => combineLatest((data?.components ?? '').split(' ').map(component => this.cmsService.getComponentData(component).pipe(distinctUntilChanged(), map(tab => {
      if (!tab) {
        return undefined;
      }
      if (!tab.flexType) {
        tab = {
          ...tab,
          flexType: tab.typeCode
        };
      }
      return {
        ...tab,
        title: `${data.uid}.tabs.${tab.uid}`
      };
    })))).pipe(
    // Update tablist label with name from CMS
    tap(() => {
      this.tabConfig$.next({
        label: `${data?.uid}.tabPanelContainerRegionGroup`,
        ...defaultTabConfig
      });
    }))));
  }
  /**
   * @deprecated This method will be removed.
   */
  select(tabNum, event) {
    this.activeTabNum = this.activeTabNum === tabNum ? -1 : tabNum;
    if (event && event?.target) {
      const target = event.target;
      const parentNode = target.parentNode;
      this.winRef?.nativeWindow?.scrollTo({
        left: 0,
        top: parentNode.offsetTop,
        behavior: 'smooth'
      });
    }
  }
  /**
   * @deprecated This method will be removed.
   */
  ngOnInit() {
    this.cdr.markForCheck();
    this.activeTabNum = this.winRef?.nativeWindow?.history?.state?.activeTab ?? this.activeTabNum;
  }
  ngAfterViewInit() {
    // If the sub cms components data exist, the components created before ngAfterViewInit are called.
    // In this case, the title parameters are directly pulled from them.
    if (this.children.length > 0) {
      this.getTitleParams(this.children);
    }
    // Render the tabs after the templates have completed loading in the view.
    this.tabs$ = combineLatest([this.components$, this.tabRefs.changes.pipe(startWith(this.tabRefs)), this.tabTitleParams$]).pipe(switchMap(([components, refs, params]) => {
      const paramObservables = components.map(component => params.get(component.uid) || of(null));
      return combineLatest(paramObservables).pipe(map(resolvedParams => components.map((component, index) => ({
        headerKey: component.title,
        content: refs.get(index),
        id: index,
        headerParams: {
          param: resolvedParams[index]
        }
      }))));
    }));
    this.cdr.detectChanges();
  }
  tabCompLoaded(componentRef, componentId) {
    this.tabTitleParams.push(componentRef.instance.tabTitleParam$);
    if (componentId) {
      const currentParams = this.tabTitleParams$.getValue();
      // We need to check if the componentId is already in the map
      // to avoid infinite loop(tabs$ emit -> component load -> tabTitleParams$ emit -> tabs$ emit)
      if (!currentParams.has(componentId)) {
        currentParams.set(componentId, componentRef.instance.tabTitleParam$);
        this.tabTitleParams$.next(currentParams);
      }
    }
  }
  getTitleParams(children) {
    children.forEach(comp => {
      this.tabTitleParams.push(comp['cmpRef']?.instance.tabTitleParam$ ?? null);
    });
  }
  static {
    this.ɵfac = function TabParagraphContainerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabParagraphContainerComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.CmsService), i0.ɵɵdirectiveInject(i1.WindowRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TabParagraphContainerComponent,
      selectors: [["cx-tab-paragraph-container"]],
      viewQuery: function TabParagraphContainerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(ComponentWrapperDirective, 5);
          i0.ɵɵviewQuery(_c43, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabRefs = _t);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["tabRef", ""], [4, "ngIf"], ["role", "region", "tabindex", "-1", "class", "container", 4, "cxFeature"], [4, "cxFeature"], ["role", "region", "tabindex", "-1", 1, "container"], [4, "ngFor", "ngForOf"], [3, "click"], ["aria-hidden", "true", 1, "accordion-icon", 3, "title"], ["tabindex", "0", "role", "presentation", 1, "cx-tab-paragraph-content"], [3, "cxOutlet", "cxOutletContext"], [3, "cxComponentRef", "cxComponentWrapper"], [3, "tabs", "config"], [3, "cxOutlet"]],
      template: function TabParagraphContainerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TabParagraphContainerComponent_ng_container_0_Template, 3, 2, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.components$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, ComponentWrapperDirective, OutletDirective, TabComponent, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabParagraphContainerComponent, [{
    type: Component,
    args: [{
      selector: 'cx-tab-paragraph-container',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"components$ | async as components\">\n  <div\n    *cxFeature=\"'!a11yTabComponent'\"\n    role=\"region\"\n    tabindex=\"-1\"\n    [attr.aria-label]=\"ariaLabel | cxTranslate\"\n    class=\"container\"\n  >\n    <ng-container *ngFor=\"let component of components; let i = index\">\n      <ng-container *ngIf=\"component\">\n        <button\n          [class.active]=\"i === activeTabNum\"\n          (click)=\"select(i, $event)\"\n          [attr.aria-expanded]=\"i === activeTabNum\"\n        >\n          {{\n            component.title | cxTranslate: { param: tabTitleParams[i] | async }\n          }}\n\n          <span\n            title=\"{{\n              i === activeTabNum\n                ? ('common.collapse' | cxTranslate)\n                : ('common.expand' | cxTranslate)\n            }}\"\n            class=\"accordion-icon\"\n            aria-hidden=\"true\"\n          ></span>\n        </button>\n\n        <div\n          [class.active]=\"i === activeTabNum\"\n          class=\"cx-tab-paragraph-content\"\n          tabindex=\"0\"\n          role=\"presentation\"\n        >\n          <ng-template [cxOutlet]=\"component.flexType\" [cxOutletContext]=\"{}\">\n            <ng-container\n              [cxComponentWrapper]=\"component\"\n              (cxComponentRef)=\"tabCompLoaded($event)\"\n            ></ng-container>\n          </ng-template>\n        </div>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs]=\"tabs$ | async\" [config]=\"tabConfig$ | async\">\n      <ng-template\n        *ngFor=\"let component of components; let i = index\"\n        [cxOutlet]=\"component.flexType\"\n        #tabRef\n      >\n        <ng-container\n          [cxComponentWrapper]=\"component\"\n          (cxComponentRef)=\"tabCompLoaded($event, component.uid)\"\n        ></ng-container>\n      </ng-template>\n    </cx-tab>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.CmsService
  }, {
    type: i1.WindowRef
  }], {
    children: [{
      type: ViewChildren,
      args: [ComponentWrapperDirective]
    }],
    tabRefs: [{
      type: ViewChildren,
      args: ['tabRef']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabPanelModule {
  static {
    this.ɵfac = function TabPanelModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabPanelModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabPanelModule,
      declarations: [TabPanelComponent],
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, KeyboardFocusModule],
      exports: [TabPanelComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabPanelModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, KeyboardFocusModule],
      declarations: [TabPanelComponent],
      exports: [TabPanelComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabModule {
  static {
    this.ɵfac = function TabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabModule,
      declarations: [TabComponent],
      imports: [CommonModule, I18nModule, TabPanelModule],
      exports: [TabComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, TabPanelModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, TabPanelModule],
      declarations: [TabComponent],
      exports: [TabComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class TabParagraphContainerModule {
  static {
    this.ɵfac = function TabParagraphContainerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TabParagraphContainerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TabParagraphContainerModule,
      declarations: [TabParagraphContainerComponent],
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, TabModule, FeaturesConfigModule],
      exports: [TabParagraphContainerComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSTabParagraphContainer: {
            component: TabParagraphContainerComponent
          }
        }
      })],
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, TabModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TabParagraphContainerModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, PageComponentModule, OutletModule, I18nModule, TabModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CMSTabParagraphContainer: {
            component: TabParagraphContainerComponent
          }
        }
      })],
      declarations: [TabParagraphContainerComponent],
      exports: [TabParagraphContainerComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VideoComponent {
  constructor(component, mediaService, urlService, cmsService, cd) {
    this.component = component;
    this.mediaService = mediaService;
    this.urlService = urlService;
    this.cmsService = cmsService;
    this.cd = cd;
    this.data$ = this.component.data$.pipe(distinctUntilChanged(), tap(data => {
      this.styleClasses = data.styleClasses;
      this.setMedia(data);
      this.setControls(data);
      this.setRouting(data);
    }));
  }
  setMedia(data) {
    if (data.video) {
      this.source = this.mediaService.getMedia(data.video)?.src;
    }
    if (data?.containerBackground === ContainerBackgroundOptions.UPLOAD_RESPONSIVE_IMAGE && data?.videoMedia) {
      this.thumbnail = this.mediaService.getMedia(data.videoMedia);
    } else if (data?.thumbnailSelector === ContainerBackgroundOptions.UPLOAD_THUMBNAIL && data?.thumbnail) {
      this.thumbnail = this.mediaService.getMedia(data.thumbnail);
    } else {
      this.thumbnail = undefined;
    }
  }
  setControls(data) {
    this.autoPlay = data.autoPlay === 'true';
    this.loop = data.loop === 'true';
    this.mute = data.mute === 'true' ? 'muted' : undefined;
  }
  setRouting(data) {
    if (data.url) {
      this.routerLink = data.url;
    } else if (data.contentPage) {
      this.cmsService.getPage({
        id: data.contentPage,
        type: PageType.CONTENT_PAGE
      }).pipe(take(1)).subscribe(page => {
        this.routerLink = page?.label;
        this.cd.markForCheck();
      });
    } else if (data.product) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'product',
        params: {
          code: data.product
        }
      });
    } else if (data.category) {
      this.routerLink = this.urlService.transform({
        cxRoute: 'category',
        params: {
          code: data.category
        }
      });
    }
  }
  static {
    this.ɵfac = function VideoComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VideoComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(MediaService), i0.ɵɵdirectiveInject(i1.SemanticPathService), i0.ɵɵdirectiveInject(i1.CmsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: VideoComponent,
      selectors: [["cx-video"]],
      hostVars: 2,
      hostBindings: function VideoComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.styleClasses);
        }
      },
      standalone: false,
      decls: 4,
      vars: 4,
      consts: [["loading", ""], ["class", "video-container", "tabindex", "-1", 4, "ngIf", "ngIfElse"], ["tabindex", "-1", 1, "video-container"], [3, "routerLink", 4, "ngIf"], ["controls", "", 3, "height", "poster", "loop", "autoplay", "muted", "src", 4, "ngIf"], [3, "routerLink"], ["controls", "", 3, "poster", "loop", "autoplay", "muted", "src"], [1, "cx-spinner"]],
      template: function VideoComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, VideoComponent_div_0_Template, 3, 2, "div", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, VideoComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const loading_r3 = i0.ɵɵreference(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.data$))("ngIfElse", loading_r3);
        }
      },
      dependencies: [i3.NgIf, i1$2.RouterLink, SpinnerComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VideoComponent, [{
    type: Component,
    args: [{
      selector: 'cx-video',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  *ngIf=\"data$ | async as data; else loading\"\n  class=\"video-container\"\n  tabindex=\"-1\"\n>\n  <a *ngIf=\"data.overlayTitle\" [routerLink]=\"routerLink\">{{\n    data.overlayTitle\n  }}</a>\n  <video\n    *ngIf=\"source\"\n    [style.height.px]=\"data.videoContainerHeight\"\n    controls\n    [poster]=\"thumbnail?.src\"\n    [loop]=\"loop\"\n    [autoplay]=\"autoPlay\"\n    [muted]=\"mute\"\n    [attr.aria-label]=\"'player.label' | cxTranslate\"\n    [src]=\"source\"\n  ></video>\n</div>\n\n<ng-template #loading>\n  <div class=\"cx-spinner\"><cx-spinner></cx-spinner></div>\n</ng-template>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: MediaService
  }, {
    type: i1.SemanticPathService
  }, {
    type: i1.CmsService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    styleClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class VideoModule {
  static {
    this.ɵfac = function VideoModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || VideoModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: VideoModule,
      declarations: [VideoComponent],
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, I18nModule, SpinnerModule],
      exports: [VideoComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          VideoComponent: {
            component: VideoComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, I18nModule, SpinnerModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VideoModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, GenericLinkModule, MediaModule, I18nModule, SpinnerModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          VideoComponent: {
            component: VideoComponent
          }
        }
      })],
      declarations: [VideoComponent],
      exports: [VideoComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsComponentService {
  constructor(routingService, translation) {
    this.routingService = routingService;
    this.translation = translation;
    this.RELEVANCE = ':relevance';
    this.CUSTOMER_COUPON_CODE = ':customerCouponCode:';
  }
  launchSearchPage(coupon) {
    this.routingService.go({
      cxRoute: 'search',
      params: {
        query: this.buildSearchParam(coupon)
      }
    }, {
      queryParams: {
        couponcode: coupon.couponId
      }
    });
  }
  buildSearchParam(coupon) {
    return coupon.allProductsApplicable ? this.RELEVANCE : this.RELEVANCE + this.CUSTOMER_COUPON_CODE + coupon.couponId;
  }
  getSortLabels() {
    return combineLatest([this.translation.translate('myCoupons.startDateAsc'), this.translation.translate('myCoupons.startDateDesc'), this.translation.translate('myCoupons.endDateAsc'), this.translation.translate('myCoupons.endDateDesc')]).pipe(map(([textByStartDateAsc, textByStartDateDesc, textByEndDateAsc, textByEndDateDesc]) => {
      return {
        byStartDateAsc: textByStartDateAsc,
        byStartDateDesc: textByStartDateDesc,
        byEndDateAsc: textByEndDateAsc,
        byEndDateDesc: textByEndDateDesc
      };
    }));
  }
  static {
    this.ɵfac = function MyCouponsComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyCouponsComponentService)(i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1.TranslationService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MyCouponsComponentService,
      factory: MyCouponsComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyCouponsComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.RoutingService
  }, {
    type: i1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponCardComponent {
  constructor(myCouponsComponentService, launchDialogService, vcr) {
    this.myCouponsComponentService = myCouponsComponentService;
    this.launchDialogService = launchDialogService;
    this.vcr = vcr;
    this.notificationChanged = new EventEmitter();
  }
  onSubscriptionChange() {
    this.notificationChanged.emit({
      couponId: this.coupon.couponId ?? '',
      notification: !this.coupon.notificationOn
    });
  }
  readMore() {
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.COUPON, this.element, this.vcr, {
      coupon: this.coupon
    });
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  findProducts() {
    this.myCouponsComponentService.launchSearchPage(this.coupon);
  }
  static {
    this.ɵfac = function CouponCardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CouponCardComponent)(i0.ɵɵdirectiveInject(MyCouponsComponentService), i0.ɵɵdirectiveInject(LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CouponCardComponent,
      selectors: [["cx-coupon-card"]],
      viewQuery: function CouponCardComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c45, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      inputs: {
        coupon: "coupon",
        couponSubscriptionLoading$: "couponSubscriptionLoading$"
      },
      outputs: {
        notificationChanged: "notificationChanged"
      },
      standalone: false,
      decls: 40,
      vars: 38,
      consts: [[1, "card"], [1, "card-body", "cx-card-body"], [1, "cx-coupon-data"], [1, "cx-coupon-card-row", "top"], [1, "cx-coupon-card-head"], [1, "card-label-bold", "cx-coupon-card-id"], [1, "cx-coupon-card-date"], [1, "cx-coupon-date"], [1, "cx-coupon-date-start"], [1, "cx-coupon-date-end"], [1, "cx-card-read-more", "link", "cx-action-link", 3, "click"], [1, "cx-coupon-card-row", "bottom"], [1, "cx-coupon-notification", "form-check"], ["type", "checkbox", 1, "form-check-input", 3, "change", "checked", "disabled"], [1, "form-check-label"], [1, "cx-coupon-find-product", "col-lg-6", "col-md-12", "col-sm-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"]],
      template: function CouponCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "span", 5);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "span");
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(9, "div");
          i0.ɵɵpipe(10, "lowercase");
          i0.ɵɵtext(11);
          i0.ɵɵpipe(12, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(13, "div", 6)(14, "p");
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 7)(18, "div", 8);
          i0.ɵɵtext(19);
          i0.ɵɵpipe(20, "cxDate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(21, "div", 9);
          i0.ɵɵtext(22);
          i0.ɵɵpipe(23, "cxDate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(24, "button", 10);
          i0.ɵɵlistener("click", function CouponCardComponent_Template_button_click_24_listener() {
            return ctx.readMore();
          });
          i0.ɵɵtext(25);
          i0.ɵɵpipe(26, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(27, "div", 11)(28, "div", 12)(29, "label")(30, "input", 13);
          i0.ɵɵpipe(31, "async");
          i0.ɵɵpipe(32, "async");
          i0.ɵɵlistener("change", function CouponCardComponent_Template_input_change_30_listener() {
            return ctx.onSubscriptionChange();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(33, "span", 14);
          i0.ɵɵtext(34);
          i0.ɵɵpipe(35, "cxTranslate");
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(36, "div", 15)(37, "button", 16);
          i0.ɵɵlistener("click", function CouponCardComponent_Template_button_click_37_listener() {
            return ctx.findProducts();
          });
          i0.ɵɵtext(38);
          i0.ɵɵpipe(39, "cxTranslate");
          i0.ɵɵelementEnd()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate(ctx.coupon == null ? null : ctx.coupon.couponId);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(": ", ctx.coupon == null ? null : ctx.coupon.name, "");
          i0.ɵɵadvance();
          i0.ɵɵclassMapInterpolate1("cx-coupon-status ", i0.ɵɵpipeBind1(10, 16, ctx.coupon == null ? null : ctx.coupon.status), "");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 18, "myCoupons." + (ctx.coupon == null ? null : ctx.coupon.status)), " ");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(16, 20, "myCoupons.effectiveTitle"));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(20, 22, ctx.coupon == null ? null : ctx.coupon.startDate, "medium"), " -\xA0 ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(23, 25, ctx.coupon == null ? null : ctx.coupon.endDate, "medium"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 28, "myCoupons.readMore"), " ");
          i0.ɵɵadvance(5);
          i0.ɵɵclassProp("disabled", i0.ɵɵpipeBind1(31, 30, ctx.couponSubscriptionLoading$));
          i0.ɵɵproperty("checked", ctx.coupon == null ? null : ctx.coupon.notificationOn)("disabled", i0.ɵɵpipeBind1(32, 32, ctx.couponSubscriptionLoading$));
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 34, "myCoupons.notification"), " ");
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(39, 36, "myCoupons.findProducts"), " ");
        }
      },
      dependencies: [i3.AsyncPipe, i3.LowerCasePipe, i1.TranslatePipe, i1.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CouponCardComponent, [{
    type: Component,
    args: [{
      selector: 'cx-coupon-card',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"card\">\n  <div class=\"card-body cx-card-body\">\n    <div class=\"cx-coupon-data\">\n      <div class=\"cx-coupon-card-row top\">\n        <div class=\"cx-coupon-card-head\">\n          <span class=\"card-label-bold cx-coupon-card-id\">{{\n            coupon?.couponId\n          }}</span>\n          <span>: {{ coupon?.name }}</span>\n        </div>\n\n        <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n          {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n        </div>\n      </div>\n\n      <div class=\"cx-coupon-card-date\">\n        <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n        <div class=\"cx-coupon-date\">\n          <div class=\"cx-coupon-date-start\">\n            {{ coupon?.startDate | cxDate: 'medium' }} -&nbsp;\n          </div>\n          <div class=\"cx-coupon-date-end\">\n            {{ coupon?.endDate | cxDate: 'medium' }}\n          </div>\n        </div>\n      </div>\n      <button\n        class=\"cx-card-read-more link cx-action-link\"\n        (click)=\"readMore()\"\n      >\n        {{ 'myCoupons.readMore' | cxTranslate }}\n      </button>\n      <div class=\"cx-coupon-card-row bottom\">\n        <div class=\"cx-coupon-notification form-check\">\n          <label>\n            <input\n              type=\"checkbox\"\n              class=\"form-check-input\"\n              [checked]=\"coupon?.notificationOn\"\n              [class.disabled]=\"couponSubscriptionLoading$ | async\"\n              [disabled]=\"couponSubscriptionLoading$ | async\"\n              (change)=\"onSubscriptionChange()\"\n            />\n            <span class=\"form-check-label\">\n              {{ 'myCoupons.notification' | cxTranslate }}\n            </span>\n          </label>\n        </div>\n\n        <div class=\"cx-coupon-find-product col-lg-6 col-md-12 col-sm-6\">\n          <button class=\"btn btn-block btn-secondary\" (click)=\"findProducts()\">\n            {{ 'myCoupons.findProducts' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: MyCouponsComponentService
  }, {
    type: LaunchDialogService
  }, {
    type: i0.ViewContainerRef
  }], {
    coupon: [{
      type: Input
    }],
    couponSubscriptionLoading$: [{
      type: Input
    }],
    notificationChanged: [{
      type: Output
    }],
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsComponent {
  constructor(couponService, myCouponsComponentService) {
    this.couponService = couponService;
    this.myCouponsComponentService = myCouponsComponentService;
    this.iconTypes = ICON_TYPE;
    this.subscriptions = new Subscription();
    this.PAGE_SIZE = 10;
    this.sortMapping = {
      byStartDateAsc: 'startDate:asc',
      byStartDateDesc: 'startDate:desc',
      byEndDateAsc: 'endDate:asc',
      byEndDateDesc: 'endDate:desc'
    };
    this.sort = 'byStartDateAsc';
    this.sortOptions = [{
      code: 'byStartDateAsc',
      selected: false
    }, {
      code: 'byStartDateDesc',
      selected: false
    }, {
      code: 'byEndDateAsc',
      selected: false
    }, {
      code: 'byEndDateDesc',
      selected: false
    }];
    this.launchDialogService = inject(LaunchDialogService);
  }
  ngOnInit() {
    this.couponResult$ = this.couponService.getCustomerCoupons(this.PAGE_SIZE).pipe(tap(coupons => this.pagination = {
      currentPage: coupons.pagination?.page,
      pageSize: coupons.pagination?.count,
      totalPages: coupons.pagination?.totalPages,
      totalResults: coupons.pagination?.totalCount,
      sort: this.sort
    }));
    this.couponsLoading$ = this.couponService.getCustomerCouponsLoading();
    this.couponSubscriptionLoading$ = combineLatest([this.couponService.getSubscribeCustomerCouponResultLoading(), this.couponService.getUnsubscribeCustomerCouponResultLoading()]).pipe(map(([subscribing, unsubscribing]) => subscribing || unsubscribing));
    this.sortLabels = this.myCouponsComponentService.getSortLabels();
    this.subscriptions.add(this.couponService.getSubscribeCustomerCouponResultError().subscribe(error => {
      this.subscriptionFail(error);
    }));
    this.subscriptions.add(this.couponService.getUnsubscribeCustomerCouponResultError().subscribe(error => {
      this.subscriptionFail(error);
    }));
    const resultStr = decodeURIComponent(this.getHashStr());
    const index = resultStr.indexOf('#');
    if (index !== -1) {
      const couponCode = resultStr.substring(index + 1);
      if (couponCode !== undefined && couponCode.length > 0) {
        this.launchDialogService.openDialogAndSubscribe(LAUNCH_CALLER.CLAIM_DIALOG, undefined, {
          coupon: couponCode,
          pageSize: this.PAGE_SIZE
        });
      }
    }
  }
  getHashStr() {
    return location.hash;
  }
  subscriptionFail(error) {
    if (error) {
      this.couponService.loadCustomerCoupons(this.PAGE_SIZE);
    }
  }
  sortChange(sort) {
    this.sort = sort;
    this.couponService.loadCustomerCoupons(this.PAGE_SIZE, this.pagination.currentPage, this.sortMapping[sort]);
  }
  pageChange(page) {
    this.couponService.loadCustomerCoupons(this.PAGE_SIZE, page, this.sortMapping[this.sort]);
  }
  notificationChange({
    couponId,
    notification
  }) {
    if (notification) {
      this.couponService.subscribeCustomerCoupon(couponId);
    } else {
      this.couponService.unsubscribeCustomerCoupon(couponId);
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function MyCouponsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyCouponsComponent)(i0.ɵɵdirectiveInject(i1.CustomerCouponService), i0.ɵɵdirectiveInject(MyCouponsComponentService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyCouponsComponent,
      selectors: [["cx-my-coupons"]],
      standalone: false,
      decls: 5,
      vars: 4,
      consts: [["loading", ""], ["noCoupons", ""], [1, "cx-section"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [4, "ngIf"], ["role", "status"], [1, "cx-my-coupons-header"], [1, "cx-my-coupons-sort", "top", "row"], [1, "cx-my-coupons-form-group", "form-group", "col-sm-12", "col-md-4", "col-lg-4"], ["ariaControls", "coupon-deck", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "ariaLabel"], [1, "cx-my-coupons-pagination", "cx-mycoupon-thead-mobile"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], ["id", "coupon-deck", 1, "row", "cx-coupon-deck"], ["class", "col-md-6 cx-coupon-card", 4, "ngFor", "ngForOf"], [1, "cx-my-coupons-sort", "bottom", "row"], [1, "cx-my-coupons-form-group", "form-group", "cx-mycoupon-thead-mobile", "col-sm-12", "col-md-4", "col-lg-4"], ["ariaControls", "coupon-deck", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "placeholder", "ariaLabel"], [1, "cx-my-coupons-pagination"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"], [1, "cx-my-coupons-notes"], [3, "type"], [3, "routerLink"], [1, "col-md-6", "cx-coupon-card"], [3, "notificationChanged", "coupon", "couponSubscriptionLoading$"], [1, "cx-section-msg"], [1, "col-md-12", "cx-coupon-spinner"]],
      template: function MyCouponsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 2);
          i0.ɵɵtemplate(1, MyCouponsComponent_ng_container_1_Template, 6, 4, "ng-container", 3);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵtemplate(3, MyCouponsComponent_ng_template_3_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const loading_r7 = i0.ɵɵreference(4);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx.couponsLoading$))("ngIfElse", loading_r7);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SpinnerComponent, i1$2.RouterLink, IconComponent, SortingComponent, PaginationComponent, i1.FeatureDirective, CouponCardComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyCouponsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-coupons',
      standalone: false,
      template: "<div class=\"cx-section\">\n  <ng-container *ngIf=\"!(couponsLoading$ | async); else loading\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <ng-container *ngIf=\"couponResult$ | async as couponResult\">\n      <div class=\"cx-my-coupons-header\">\n        <h2>\n          {{ 'myCoupons.myCoupons' | cxTranslate }}\n        </h2>\n      </div>\n      <ng-container\n        *ngIf=\"\n          couponResult.pagination &&\n            couponResult.pagination.totalCount &&\n            couponResult.pagination.totalCount > 0;\n          else noCoupons\n        \"\n      >\n        <div class=\"cx-my-coupons-sort top row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination cx-mycoupon-thead-mobile\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n\n        <div id=\"coupon-deck\" class=\"row cx-coupon-deck\">\n          <div\n            *ngFor=\"let coupon of couponResult.coupons\"\n            class=\"col-md-6 cx-coupon-card\"\n          >\n            <cx-coupon-card\n              [coupon]=\"coupon\"\n              [couponSubscriptionLoading$]=\"couponSubscriptionLoading$\"\n              (notificationChanged)=\"notificationChange($event)\"\n            ></cx-coupon-card>\n          </div>\n        </div>\n\n        <div class=\"cx-my-coupons-sort bottom row\">\n          <label\n            class=\"cx-my-coupons-form-group form-group cx-mycoupon-thead-mobile col-sm-12 col-md-4 col-lg-4\"\n          >\n            <span>{{ 'myCoupons.sortBy' | cxTranslate }}</span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              [sortLabels]=\"sortLabels | async\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              placeholder=\"{{ 'myCoupons.sortBy' | cxTranslate }}\"\n              [ariaLabel]=\"'myCoupons.sortCoupons' | cxTranslate\"\n              ariaControls=\"coupon-deck\"\n            >\n            </cx-sorting>\n          </label>\n          <div class=\"cx-my-coupons-pagination\">\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n        <div class=\"cx-my-coupons-notes\">\n          <span>\n            <cx-icon [type]=\"iconTypes.INFO\"></cx-icon>\n            {{ 'myCoupons.notesPreffix' | cxTranslate\n            }}<a [routerLink]=\"['/my-account/notification-preference']\">{{\n              'myCoupons.notesLink' | cxTranslate\n            }}</a\n            >{{ 'myCoupons.notesSuffix' | cxTranslate }}</span\n          >\n        </div>\n      </ng-container>\n    </ng-container>\n\n    <ng-template #noCoupons>\n      <section>\n        <p class=\"cx-section-msg\">\n          {{ 'myCoupons.noCouponsMessage' | cxTranslate }}\n        </p>\n      </section>\n    </ng-template>\n  </ng-container>\n\n  <ng-template #loading>\n    <div class=\"col-md-12 cx-coupon-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</div>\n"
    }]
  }], () => [{
    type: i1.CustomerCouponService
  }, {
    type: MyCouponsComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponDialogComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(launchDialogService, el) {
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.subscription = new Subscription();
    this.iconTypes = ICON_TYPE;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
  }
  ngOnInit() {
    this.subscription.add(this.launchDialogService.data$.subscribe(data => {
      if (data) {
        this.coupon = data.coupon;
      }
    }));
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  static {
    this.ɵfac = function CouponDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CouponDialogComponent)(i0.ɵɵdirectiveInject(LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CouponDialogComponent,
      selectors: [["cx-coupon-dialog"]],
      hostBindings: function CouponDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function CouponDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 36,
      vars: 35,
      consts: [["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "cx-coupon-dialog", 3, "esc", "cxFocus"], [1, "modal-content", "cx-coupon-container"], [1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", "class", "cx-dialog-title modal-title", 4, "cxFeature"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "cx-dialog-item", "col-sm-12", "col-md-12"], [1, "cx-coupon-card-head"], [1, "card-label-bold", "cx-coupon-card-id"], [1, "cx-coupon-description"], [1, "cx-coupon-dialog-date"], [1, "cx-coupon-date"], [1, "cx-coupon-dialog-status"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"]],
      template: function CouponDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function CouponDialogComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
          i0.ɵɵtemplate(3, CouponDialogComponent_h3_3_Template, 3, 3, "h3", 3)(4, CouponDialogComponent_div_4_Template, 3, 3, "div", 3);
          i0.ɵɵelementStart(5, "button", 4);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵlistener("click", function CouponDialogComponent_Template_button_click_5_listener() {
            return ctx.close("Cross click");
          });
          i0.ɵɵelementStart(8, "span", 5);
          i0.ɵɵelement(9, "cx-icon", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(10, "div", 7)(11, "div", 8)(12, "div", 9)(13, "div", 10)(14, "span", 11);
          i0.ɵɵtext(15);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(16, "span");
          i0.ɵɵtext(17);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(18, "div", 12);
          i0.ɵɵtext(19);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(20, "div", 13)(21, "p");
          i0.ɵɵtext(22);
          i0.ɵɵpipe(23, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(24, "div", 14);
          i0.ɵɵtext(25);
          i0.ɵɵpipe(26, "cxDate");
          i0.ɵɵpipe(27, "cxDate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(28, "div", 15)(29, "p");
          i0.ɵɵtext(30);
          i0.ɵɵpipe(31, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(32, "div");
          i0.ɵɵpipe(33, "lowercase");
          i0.ɵɵtext(34);
          i0.ɵɵpipe(35, "cxTranslate");
          i0.ɵɵelementEnd()()()()()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(6, 17, "common.close"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(7, 19, "common.close"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(6);
          i0.ɵɵtextInterpolate(ctx.coupon == null ? null : ctx.coupon.couponId);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(": ", ctx.coupon == null ? null : ctx.coupon.name, "");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.coupon == null ? null : ctx.coupon.description);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(23, 21, "myCoupons.effectiveTitle"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(26, 23, ctx.coupon == null ? null : ctx.coupon.startDate, "medium"), " - ", i0.ɵɵpipeBind2(27, 26, ctx.coupon == null ? null : ctx.coupon.endDate, "medium"), " ");
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(31, 29, "myCoupons.status"));
          i0.ɵɵadvance(2);
          i0.ɵɵclassMapInterpolate1("cx-coupon-status ", i0.ɵɵpipeBind1(33, 31, ctx.coupon == null ? null : ctx.coupon.status), "");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(35, 33, "myCoupons." + (ctx.coupon == null ? null : ctx.coupon.status)), " ");
        }
      },
      dependencies: [IconComponent, FocusDirective, i1.FeatureDirective, i3.LowerCasePipe, i1.TranslatePipe, i1.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CouponDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-coupon-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  class=\"modal-dialog modal-dialog-centered cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3\n        *cxFeature=\"'a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n      >\n        {{ 'myCoupons.dialogTitle' | cxTranslate }}\n      </h3>\n      <div\n        *cxFeature=\"'!a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n      >\n        {{ 'myCoupons.dialogTitle' | cxTranslate }}\n      </div>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <div class=\"cx-dialog-row\">\n        <div class=\"cx-dialog-item col-sm-12 col-md-12\">\n          <div class=\"cx-coupon-card-head\">\n            <span class=\"card-label-bold cx-coupon-card-id\">{{\n              coupon?.couponId\n            }}</span>\n            <span>: {{ coupon?.name }}</span>\n          </div>\n          <div class=\"cx-coupon-description\">{{ coupon?.description }}</div>\n\n          <div class=\"cx-coupon-dialog-date\">\n            <p>{{ 'myCoupons.effectiveTitle' | cxTranslate }}</p>\n            <div class=\"cx-coupon-date\">\n              {{ coupon?.startDate | cxDate: 'medium' }} -\n              {{ coupon?.endDate | cxDate: 'medium' }}\n            </div>\n          </div>\n\n          <div class=\"cx-coupon-dialog-status\">\n            <p>{{ 'myCoupons.status' | cxTranslate }}</p>\n            <div class=\"cx-coupon-status {{ coupon?.status | lowercase }}\">\n              {{ 'myCoupons.' + coupon?.status | cxTranslate }}\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CouponClaimComponent {
  constructor(couponService, routingService, messageService) {
    this.couponService = couponService;
    this.routingService = routingService;
    this.messageService = messageService;
  }
  ngOnInit() {
    this.routingService.getRouterState().subscribe(k => {
      const couponCode = k.state.params.couponCode;
      if (couponCode) {
        this.couponService.claimCustomerCoupon(couponCode);
        this.subscription = this.couponService.getClaimCustomerCouponResultSuccess().subscribe(success => {
          if (success) {
            this.messageService.add({
              key: 'myCoupons.claimCustomerCoupon'
            }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
          }
          this.routingService.go({
            cxRoute: 'coupons'
          });
        });
      } else {
        this.routingService.go({
          cxRoute: 'notFound'
        });
      }
    }).unsubscribe();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  static {
    this.ɵfac = function CouponClaimComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CouponClaimComponent)(i0.ɵɵdirectiveInject(i1.CustomerCouponService), i0.ɵɵdirectiveInject(i1.RoutingService), i0.ɵɵdirectiveInject(i1.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CouponClaimComponent,
      selectors: [["cx-coupon-claim"]],
      standalone: false,
      decls: 0,
      vars: 0,
      template: function CouponClaimComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CouponClaimComponent, [{
    type: Component,
    args: [{
      template: '',
      selector: 'cx-coupon-claim',
      standalone: false
    }]
  }], () => [{
    type: i1.CustomerCouponService
  }, {
    type: i1.RoutingService
  }, {
    type: i1.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ClaimDialogComponent {
  constructor() {
    this.subscription = new Subscription();
    this.iconTypes = ICON_TYPE;
    this.pageSize = 10;
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
    this.form = new FormGroup({
      couponCode: new FormControl('', [Validators.required])
    });
    this.couponService = inject(CustomerCouponService);
    this.routingService = inject(RoutingService);
    this.messageService = inject(GlobalMessageService);
    this.launchDialogService = inject(LaunchDialogService);
  }
  ngOnInit() {
    this.subscription.add(this.launchDialogService.data$.subscribe(data => {
      if (data) {
        this.couponCode = data.coupon;
        this.pageSize = data.pageSize;
        this.form.get('couponCode').setValue(this.couponCode);
      }
    }));
  }
  onSubmit() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const couponVal = this.form.get('couponCode').value;
    if (couponVal) {
      this.couponService.claimCustomerCoupon(couponVal);
      this.subscription = this.couponService.getClaimCustomerCouponResultSuccess().subscribe(success => {
        if (success) {
          this.messageService.add({
            key: 'myCoupons.claimCustomerCoupon'
          }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
        }
        this.routingService.go({
          cxRoute: 'coupons'
        });
        this.couponService.loadCustomerCoupons(this.pageSize);
        this.close('Cross click');
      });
    } else {
      this.routingService.go({
        cxRoute: 'notFound'
      });
    }
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  cancelEdit() {
    this.form.get('couponCode').setValue(this.couponCode);
  }
  static {
    this.ɵfac = function ClaimDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ClaimDialogComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ClaimDialogComponent,
      selectors: [["cx-claim-dialog"]],
      standalone: false,
      decls: 31,
      vars: 33,
      consts: [["role", "dialog", "aria-labelledby", "dialogTitle", 1, "cx-coupon-dialog", 3, "esc", "cxFocus"], [1, "cx-coupon-container"], [1, "cx-dialog-header", "modal-header"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true"], [3, "type"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-item", 3, "ngSubmit", "formGroup"], [1, "label-content"], ["required", "true", "type", "text", "name", "couponCode", "formControlName", "couponCode", 1, "form-control", 3, "placeholder"], ["id", "couponCodeError", 3, "translationParams", "control"], [1, "cx-dialog-row"], [1, "col-md-6", "cx-dialog-row--reset-button"], ["role", "button", 1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "col-md-6", "cx-dialog-row-submit-button"], [1, "btn", "btn-block", "btn-primary", 3, "disabled"]],
      template: function ClaimDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("esc", function ClaimDialogComponent_Template_div_esc_0_listener() {
            return ctx.close("Escape clicked");
          });
          i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "h3", 3);
          i0.ɵɵtext(4);
          i0.ɵɵpipe(5, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "button", 4);
          i0.ɵɵpipe(7, "cxTranslate");
          i0.ɵɵpipe(8, "cxTranslate");
          i0.ɵɵlistener("click", function ClaimDialogComponent_Template_button_click_6_listener() {
            return ctx.close("Cross click");
          });
          i0.ɵɵelementStart(9, "span", 5);
          i0.ɵɵelement(10, "cx-icon", 6);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(11, "div", 7)(12, "form", 8);
          i0.ɵɵlistener("ngSubmit", function ClaimDialogComponent_Template_form_ngSubmit_12_listener() {
            return ctx.onSubmit();
          });
          i0.ɵɵelementStart(13, "label")(14, "span", 9);
          i0.ɵɵtext(15);
          i0.ɵɵpipe(16, "cxTranslate");
          i0.ɵɵelement(17, "cx-form-required-asterisks");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(18, "input", 10);
          i0.ɵɵpipe(19, "cxTranslate");
          i0.ɵɵelement(20, "cx-form-errors", 11);
          i0.ɵɵpipe(21, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(22, "div", 12)(23, "div", 13)(24, "a", 14);
          i0.ɵɵlistener("click", function ClaimDialogComponent_Template_a_click_24_listener() {
            return ctx.cancelEdit();
          });
          i0.ɵɵtext(25);
          i0.ɵɵpipe(26, "cxTranslate");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(27, "div", 15)(28, "button", 16);
          i0.ɵɵtext(29);
          i0.ɵɵpipe(30, "cxTranslate");
          i0.ɵɵelementEnd()()()()()()();
        }
        if (rf & 2) {
          let tmp_8_0;
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 15, "myCoupons.claimCoupondialogTitle"), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(7, 17, "common.close"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(8, 19, "common.close"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("type", ctx.iconTypes.CLOSE);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formGroup", ctx.form);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(16, 21, "myCoupons.claimCouponCode.label"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 23, "myCoupons.claimCouponCode.placeholder"));
          i0.ɵɵattribute("aria-invalid", ((tmp_8_0 = ctx.form.get("couponCode")) == null ? null : tmp_8_0.touched) && ((tmp_8_0 = ctx.form.get("couponCode")) == null ? null : tmp_8_0.invalid))("aria-errormessage", "couponCodeError");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("translationParams", i0.ɵɵpureFunction1(31, _c47, i0.ɵɵpipeBind1(21, 25, "myCoupons.claimCouponCode.label")))("control", ctx.form.get("couponCode"));
          i0.ɵɵadvance(5);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(26, 27, "myCoupons.reset"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", ctx.form.disabled);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(30, 29, "myCoupons.claim"), " ");
        }
      },
      dependencies: [i1$4.ɵNgNoValidate, i1$4.DefaultValueAccessor, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.RequiredValidator, i1$4.FormGroupDirective, i1$4.FormControlName, FormErrorsComponent, FormRequiredAsterisksComponent, IconComponent, FocusDirective, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ClaimDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-claim-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  class=\"cx-coupon-dialog\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"cx-coupon-container\">\n    <!-- Modal Header -->\n\n    <div class=\"cx-dialog-header modal-header\">\n      <h3 id=\"dialogTitle\" class=\"cx-dialog-title modal-title\">\n        {{ 'myCoupons.claimCoupondialogTitle' | cxTranslate }}\n      </h3>\n      <button\n        type=\"button\"\n        class=\"close\"\n        title=\"{{ 'common.close' | cxTranslate }}\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        (click)=\"close('Cross click')\"\n      >\n        <span aria-hidden=\"true\">\n          <cx-icon [type]=\"iconTypes.CLOSE\"></cx-icon>\n        </span>\n      </button>\n    </div>\n    <!-- Modal Body -->\n    <div class=\"cx-dialog-body modal-body\">\n      <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" class=\"cx-dialog-item\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'myCoupons.claimCouponCode.label' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"text\"\n            name=\"couponCode\"\n            formControlName=\"couponCode\"\n            placeholder=\"{{\n              'myCoupons.claimCouponCode.placeholder' | cxTranslate\n            }}\"\n            class=\"form-control\"\n            [attr.aria-invalid]=\"\n              form.get('couponCode')?.touched && form.get('couponCode')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'couponCodeError'\"\n          />\n          <cx-form-errors\n            id=\"couponCodeError\"\n            [translationParams]=\"{\n              label: 'myCoupons.claimCouponCode.label' | cxTranslate,\n            }\"\n            [control]=\"form.get('couponCode')\"\n          ></cx-form-errors>\n        </label>\n        <div class=\"cx-dialog-row\">\n          <div class=\"col-md-6 cx-dialog-row--reset-button\">\n            <a\n              role=\"button\"\n              class=\"btn btn-block btn-secondary\"\n              (click)=\"cancelEdit()\"\n            >\n              {{ 'myCoupons.reset' | cxTranslate }}\n            </a>\n          </div>\n          <div class=\"col-md-6 cx-dialog-row-submit-button\">\n            <button\n              class=\"btn btn-block btn-primary\"\n              [disabled]=\"form.disabled\"\n            >\n              {{ 'myCoupons.claim' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCouponLayoutConfig = {
  launch: {
    COUPON: {
      inlineRoot: true,
      component: CouponDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    },
    CLAIM_DIALOG: {
      inlineRoot: true,
      component: ClaimDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyCouponsModule {
  static {
    this.ɵfac = function MyCouponsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyCouponsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyCouponsModule,
      declarations: [MyCouponsComponent, CouponCardComponent, CouponDialogComponent, CouponClaimComponent, ClaimDialogComponent],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, FormRequiredAsterisksComponent, CardModule, SpinnerModule, I18nModule, RouterModule, UrlModule, IconModule, ListNavigationModule, i1$2.RouterModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [MyCouponsComponent, CouponClaimComponent, ClaimDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyCouponsComponent: {
            component: MyCouponsComponent,
            guards: [AuthGuard]
          },
          CouponClaimComponent: {
            component: CouponClaimComponent,
            guards: [AuthGuard]
          },
          ClaimDialogComponent: {
            component: ClaimDialogComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultCouponLayoutConfig)],
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, FormRequiredAsterisksComponent, CardModule, SpinnerModule, I18nModule, RouterModule, UrlModule, IconModule, ListNavigationModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'couponClaim'
        }
      }]), KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyCouponsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, FormRequiredAsterisksComponent, CardModule, SpinnerModule, I18nModule, RouterModule, UrlModule, IconModule, ListNavigationModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'couponClaim'
        }
      }]), KeyboardFocusModule, FeaturesConfigModule],
      declarations: [MyCouponsComponent, CouponCardComponent, CouponDialogComponent, CouponClaimComponent, ClaimDialogComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyCouponsComponent: {
            component: MyCouponsComponent,
            guards: [AuthGuard]
          },
          CouponClaimComponent: {
            component: CouponClaimComponent,
            guards: [AuthGuard]
          },
          ClaimDialogComponent: {
            component: ClaimDialogComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfig(defaultCouponLayoutConfig)],
      exports: [MyCouponsComponent, CouponClaimComponent, ClaimDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyInterestsComponent {
  constructor(productInterestService, translationService, productService, globalMessageService) {
    this.productInterestService = productInterestService;
    this.translationService = translationService;
    this.productService = productService;
    this.globalMessageService = globalMessageService;
    this.DEFAULT_PAGE_SIZE = 10;
    this.sortMapping = {
      byNameAsc: 'name:asc',
      byNameDesc: 'name:desc'
    };
    this.sortChanged = false;
    this.sort = 'byNameAsc';
    this.sortOptions = [{
      code: 'byNameAsc',
      selected: false
    }, {
      code: 'byNameDesc',
      selected: false
    }];
  }
  ngOnInit() {
    this.interests$ = this.productInterestService.getAndLoadProductInterests(this.DEFAULT_PAGE_SIZE).pipe(tap(interests => this.pagination = {
      currentPage: interests.pagination?.page,
      pageSize: interests.pagination?.count,
      totalPages: interests.pagination?.totalPages,
      totalResults: interests.pagination?.totalCount,
      sort: 'byNameAsc'
    }), tap(() => {
      if (this.sortChanged) {
        this.sortChanged = false;
        this.globalMessageService?.add({
          key: 'sorting.pageViewUpdated'
        }, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500);
      }
    }), map(interest => ({
      ...interest,
      results: interest.results ? interest.results.map(result => ({
        ...result,
        product$: this.getProduct(result)
      })) : interest.results
    })));
    this.getInterestsloading$ = this.productInterestService.getProdutInterestsLoading();
    this.isRemoveDisabled$ = combineLatest([this.getInterestsloading$, this.productInterestService.getRemoveProdutInterestLoading()]).pipe(map(([getLoading, removeLoading]) => getLoading || removeLoading));
    this.sortLabels = this.getSortLabels();
  }
  getSortLabels() {
    return combineLatest([this.translationService.translate('myInterests.sorting.byNameAsc'), this.translationService.translate('myInterests.sorting.byNameDesc')]).pipe(map(([asc, desc]) => {
      return {
        byNameAsc: asc,
        byNameDesc: desc
      };
    }));
  }
  getProduct(interest) {
    return this.productService.get(interest.product?.code ?? '', ProductScope.DETAILS);
  }
  removeInterest(relation) {
    this.productInterestService.removeProdutInterest({
      product: relation.product,
      productInterestEntry: relation.productInterestEntry
    });
  }
  sortChange(sort) {
    this.sort = sort;
    this.sortChanged = true;
    this.productInterestService.loadProductInterests(this.DEFAULT_PAGE_SIZE, 0, this.sortMapping[sort]);
  }
  pageChange(page) {
    this.productInterestService.loadProductInterests(this.DEFAULT_PAGE_SIZE, page, this.sortMapping[this.sort]);
  }
  ngOnDestroy() {
    this.productInterestService.clearProductInterests();
    this.productInterestService.resetRemoveInterestState();
  }
  static {
    this.ɵfac = function MyInterestsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyInterestsComponent)(i0.ɵɵdirectiveInject(i1.UserInterestsService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i1.ProductService), i0.ɵɵdirectiveInject(i1.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyInterestsComponent,
      selectors: [["cx-my-interests"]],
      standalone: false,
      decls: 6,
      vars: 3,
      consts: [["noInterest", ""], ["loading", ""], ["class", "container", 4, "ngIf"], [1, "container"], [1, "cx-product-interests-title"], ["class", "cx-product-interests-body", 4, "ngIf", "ngIfElse"], [1, "cx-product-interests-body"], ["role", "status", 4, "cxFeature"], [4, "ngIf", "ngIfElse"], ["role", "status"], [1, "cx-product-interests-sort", "top", "row"], [1, "cx-product-interests-form-group", "form-group", "col-sm-12", "col-md-4", "col-lg-4"], ["ariaControls", "product-interests-table", 3, "sortListEvent", "sortOptions", "sortLabels", "selectedOption", "placeholder", "ariaLabel"], [1, "cx-product-interests-pagination", "cx-product-interests-thead-mobile"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], ["id", "product-interests-table", 1, "table", "cx-product-interests-table", "cx-product-interests-table-list"], [1, "cx-visually-hidden"], ["class", "cx-product-interests-thead-mobile cx-product-interests-header", 4, "cxFeature"], ["class", "cx-product-interests-product-item", "role", "row", 4, "ngFor", "ngForOf"], [1, "cx-product-interests-sort", "bottom", "row"], [1, "cx-product-interests-form-group", "cx-product-interests-thead-mobile", "form-group", "col-sm-12", "col-md-4", "col-lg-4"], [1, "cx-product-interests-pagination"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"], [1, "cx-product-interests-thead-mobile", "cx-product-interests-header"], ["role", "columnheader"], ["srole", "columnheader"], ["role", "row", 1, "cx-product-interests-product-item"], [4, "ngIf"], ["role", "cell"], [1, "cx-product-interests-cell-wrapper"], [1, "cx-product-interests-label"], ["tabindex", "-1", 1, "cx-product-interests-product-image-link", 3, "routerLink"], ["format", "thumbnail", 3, "container"], [1, "cx-info", "col-10"], [1, "cx-info-container", "row"], ["class", "cx-name", 4, "ngIf"], ["class", "cx-code", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["class", "cx-property", 4, "ngIf"], [1, "cx-product-interests-product-price"], [1, "d-md-none", "cx-product-interests-label"], [1, "cx-product-interests-subscriptions"], ["class", "cx-product-interests-notification", 4, "ngFor", "ngForOf"], [1, "cx-actions", "cx-product-interests-remove-button"], ["type", "button", 1, "cx-product-interests-remove-btn", "link", "cx-action-link", "cx-remove-btn", 3, "click", "cxAtMessage", "disabled"], [1, "cx-name"], [1, "cx-link", "cx-product-interests-product-code-link", 3, "routerLink"], [1, "cx-code"], ["class", "cx-property", 4, "ngFor", "ngForOf"], [1, "cx-property"], [1, "cx-label", "cx-product-interests-variant-name"], [1, "cx-value", "cx-product-interests-variant-value"], [1, "cx-label", "cx-product-interests-product-stock"], [1, "cx-product-interests-notification"], [1, "cx-product-interests-type"], [1, "cx-product-interests-expiration-date"], [1, "cx-product-interests-message"], [1, "cx-spinner"]],
      template: function MyInterestsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyInterestsComponent_div_0_Template, 7, 7, "div", 2);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, MyInterestsComponent_ng_template_2_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MyInterestsComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.interests$));
        }
      },
      dependencies: [AtMessageDirective, i3.NgForOf, i3.NgIf, SortingComponent, PaginationComponent, MediaComponent, SpinnerComponent, i1$2.RouterLink, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe, i1.CxDatePipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyInterestsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-interests',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div *ngIf=\"interests$ | async as interests\" class=\"container\">\n  <div class=\"cx-product-interests-title\">\n    <h2>{{ 'myInterests.header' | cxTranslate }}</h2>\n  </div>\n  <div\n    class=\"cx-product-interests-body\"\n    *ngIf=\"!(getInterestsloading$ | async); else loading\"\n  >\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <ng-container\n      *ngIf=\"\n        interests.pagination &&\n          interests.pagination.totalCount &&\n          interests.pagination.totalCount > 0;\n        else noInterest\n      \"\n    >\n      <div class=\"cx-product-interests-sort top row\">\n        <label\n          class=\"cx-product-interests-form-group form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div\n          class=\"cx-product-interests-pagination cx-product-interests-thead-mobile\"\n        >\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-top\"\n          ></cx-pagination>\n        </div>\n      </div>\n\n      <table\n        id=\"product-interests-table\"\n        class=\"table cx-product-interests-table cx-product-interests-table-list\"\n      >\n        <caption class=\"cx-visually-hidden\">\n          {{\n            'myInterests.caption' | cxTranslate\n          }}\n        </caption>\n        <thead\n          *cxFeature=\"'!a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <th role=\"columnheader\">\n            {{ 'myInterests.item' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.price' | cxTranslate }}\n          </th>\n          <th role=\"columnheader\">\n            {{ 'myInterests.notifications' | cxTranslate }}\n          </th>\n          <th srole=\"columnheader\">\n            {{ 'myInterests.actions' | cxTranslate }}\n          </th>\n        </thead>\n        <thead\n          *cxFeature=\"'a11yTableHeaderReadout'\"\n          class=\"cx-product-interests-thead-mobile cx-product-interests-header\"\n        >\n          <tr>\n            <th>\n              {{ 'myInterests.item' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.price' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.notifications' | cxTranslate }}\n            </th>\n            <th>\n              {{ 'myInterests.actions' | cxTranslate }}\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr\n            *ngFor=\"let interest of interests.results\"\n            class=\"cx-product-interests-product-item\"\n            role=\"row\"\n          >\n            <ng-container *ngIf=\"interest.product$ | async as product\">\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-cell-wrapper\">\n                  <div class=\"cx-product-interests-label\">\n                    <a\n                      class=\"cx-product-interests-product-image-link\"\n                      tabindex=\"-1\"\n                      [routerLink]=\"\n                        { cxRoute: 'product', params: product } | cxUrl\n                      \"\n                    >\n                      <cx-media\n                        [container]=\"product.images?.PRIMARY\"\n                        format=\"thumbnail\"\n                      ></cx-media>\n                    </a>\n                  </div>\n\n                  <div class=\"cx-info col-10\">\n                    <div class=\"cx-info-container row\">\n                      <div>\n                        <div *ngIf=\"product.name\" class=\"cx-name\">\n                          <a\n                            class=\"cx-link cx-product-interests-product-code-link\"\n                            [routerLink]=\"\n                              { cxRoute: 'product', params: product } | cxUrl\n                            \"\n                          >\n                            {{ product.name }}\n                          </a>\n                        </div>\n                        <div *ngIf=\"product.code\" class=\"cx-code\">\n                          <span>{{\n                            'myInterests.productId'\n                              | cxTranslate: { code: product.code }\n                          }}</span>\n                        </div>\n\n                        <ng-container\n                          *ngFor=\"let baseOptions of product.baseOptions\"\n                        >\n                          <div\n                            *ngFor=\"\n                              let variant of baseOptions.selected\n                                ?.variantOptionQualifiers\n                            \"\n                            class=\"cx-property\"\n                          >\n                            <div\n                              class=\"cx-label cx-product-interests-variant-name\"\n                            >\n                              {{ variant.name }}\n                            </div>\n                            <div\n                              class=\"cx-value cx-product-interests-variant-value\"\n                            >\n                              {{ variant.value }}\n                            </div>\n                          </div>\n                        </ng-container>\n                        <div\n                          class=\"cx-property\"\n                          *ngIf=\"\n                            product.stock?.stockLevelStatus === 'outOfStock'\n                          \"\n                        >\n                          <div\n                            class=\"cx-label cx-product-interests-product-stock\"\n                          >\n                            {{ 'myInterests.outOfStock' | cxTranslate }}\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-product-price\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.price' | cxTranslate }}\n                  </div>\n                  <span>{{ product.price?.formattedValue }}</span>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-product-interests-subscriptions\">\n                  <div class=\"d-md-none cx-product-interests-label\">\n                    {{ 'myInterests.notifications' | cxTranslate }}\n                  </div>\n                  <div\n                    class=\"cx-product-interests-notification\"\n                    *ngFor=\"let interestEntry of interest.productInterestEntry\"\n                  >\n                    <span class=\"cx-product-interests-type\">\n                      {{\n                        'myInterests.' + interestEntry.interestType\n                          | cxTranslate\n                      }}\n                    </span>\n                    <span class=\"cx-product-interests-expiration-date\">\n                      {{\n                        'myInterests.expirationDate'\n                          | cxTranslate\n                            : {\n                                expirationDate:\n                                  interestEntry.expirationDate | cxDate,\n                              }\n                      }}\n                    </span>\n                  </div>\n                </div>\n              </td>\n              <td role=\"cell\">\n                <div class=\"cx-actions cx-product-interests-remove-button\">\n                  <button\n                    type=\"button\"\n                    class=\"cx-product-interests-remove-btn link cx-action-link cx-remove-btn\"\n                    [cxAtMessage]=\"'myInterests.itemRemoved' | cxTranslate\"\n                    [disabled]=\"isRemoveDisabled$ | async\"\n                    (click)=\"removeInterest(interest)\"\n                  >\n                    {{ 'myInterests.remove' | cxTranslate }}\n                  </button>\n                </div>\n              </td>\n            </ng-container>\n          </tr>\n        </tbody>\n      </table>\n\n      <div class=\"cx-product-interests-sort bottom row\">\n        <label\n          class=\"cx-product-interests-form-group cx-product-interests-thead-mobile form-group col-sm-12 col-md-4 col-lg-4\"\n          ><span>{{ 'myInterests.sortBy' | cxTranslate }}</span>\n          <cx-sorting\n            [sortOptions]=\"sortOptions\"\n            [sortLabels]=\"sortLabels | async\"\n            (sortListEvent)=\"sortChange($event)\"\n            [selectedOption]=\"sort\"\n            placeholder=\"{{ 'myInterests.sortBy' | cxTranslate }}\"\n            [ariaLabel]=\"'myInterests.sortInterests' | cxTranslate\"\n            ariaControls=\"product-interests-table\"\n          >\n          </cx-sorting>\n        </label>\n        <div class=\"cx-product-interests-pagination\">\n          <cx-pagination\n            [pagination]=\"pagination\"\n            (viewPageEvent)=\"pageChange($event)\"\n            paginationID=\"pagination-bottom\"\n          ></cx-pagination>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n</div>\n<ng-template #noInterest>\n  <div class=\"cx-product-interests-message\">\n    {{ 'myInterests.noInterests' | cxTranslate }}\n  </div>\n</ng-template>\n<ng-template #loading>\n  <div class=\"cx-spinner\">\n    <cx-spinner></cx-spinner>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1.UserInterestsService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.ProductService
  }, {
    type: i1.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyInterestsModule {
  static {
    this.ɵfac = function MyInterestsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyInterestsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyInterestsModule,
      declarations: [MyInterestsComponent],
      imports: [AtMessageModule, CommonModule, I18nModule, ListNavigationModule, I18nModule, UrlModule, MediaModule, SpinnerModule, i1$2.RouterModule, FeaturesConfigModule],
      exports: [MyInterestsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyInterestsComponent: {
            component: MyInterestsComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [AtMessageModule, CommonModule, I18nModule, ListNavigationModule, I18nModule, UrlModule, MediaModule, SpinnerModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'myInterests'
        }
      }]), FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyInterestsModule, [{
    type: NgModule,
    args: [{
      declarations: [MyInterestsComponent],
      imports: [AtMessageModule, CommonModule, I18nModule, ListNavigationModule, I18nModule, UrlModule, MediaModule, SpinnerModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'myInterests'
        }
      }]), FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyInterestsComponent: {
            component: MyInterestsComponent,
            guards: [AuthGuard]
          }
        }
      })],
      exports: [MyInterestsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NotificationPreferenceComponent {
  constructor(notificationPreferenceService) {
    this.notificationPreferenceService = notificationPreferenceService;
    this.preferences = [];
  }
  ngOnInit() {
    this.notificationPreferenceService.resetNotificationPreferences();
    this.preferences$ = this.notificationPreferenceService.getPreferences().pipe(tap(preferences => this.preferences = preferences));
    this.notificationPreferenceService.loadPreferences();
    this.isLoading$ = combineLatest([this.notificationPreferenceService.getPreferencesLoading(), this.notificationPreferenceService.getUpdatePreferencesResultLoading()]).pipe(map(([prefsLoading, updateLoading]) => prefsLoading || updateLoading));
  }
  updatePreference(preference) {
    const updatedPreferences = [];
    this.preferences.forEach(p => {
      if (p.channel === preference.channel) {
        updatedPreferences.push({
          ...p,
          enabled: !p.enabled
        });
      } else {
        updatedPreferences.push(p);
      }
    });
    this.notificationPreferenceService.updatePreferences(updatedPreferences);
  }
  static {
    this.ɵfac = function NotificationPreferenceComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationPreferenceComponent)(i0.ɵɵdirectiveInject(i1.UserNotificationPreferenceService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NotificationPreferenceComponent,
      selectors: [["cx-notification-preference"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["loading", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "row", "d-flex", "justify-content-center"], [1, "col-md-8"], [1, "pref-header"], [4, "ngFor", "ngForOf"], [1, "pref-note"], ["role", "status"], ["class", "form-check pref-channel", 4, "ngIf"], [1, "form-check", "pref-channel"], ["role", "checkbox", "type", "checkbox", 1, "form-check-input", "cx-np-checkbox", 3, "change", "id", "checked", "disabled"], [1, "form-check-label", 3, "for"], [1, "cx-spinner"]],
      template: function NotificationPreferenceComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, NotificationPreferenceComponent_ng_container_0_Template, 4, 2, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.preferences$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SpinnerComponent, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationPreferenceComponent, [{
    type: Component,
    args: [{
      selector: 'cx-notification-preference',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <div class=\"row d-flex justify-content-center\">\n      <div class=\"col-md-8\">\n        <fieldset>\n          <legend class=\"pref-header\">\n            {{ 'notificationPreference.message' | cxTranslate }}\n          </legend>\n          <ng-container *ngFor=\"let preference of preferences\">\n            <div *ngIf=\"preference.visible\" class=\"form-check pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                id=\"{{ preference.channel }}\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <label for=\"{{ preference.channel }}\" class=\"form-check-label\">\n                {{\n                  'notificationPreference.' + preference.channel | cxTranslate\n                }}\n                {{ preference.value }}\n              </label>\n            </div>\n          </ng-container>\n        </fieldset>\n        <p class=\"pref-note\">\n          <strong>{{ 'notificationPreference.note' | cxTranslate }}</strong\n          >{{ 'notificationPreference.noteMessage' | cxTranslate }}\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.UserNotificationPreferenceService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageTitleComponent {
  constructor(component, pageMetaService) {
    this.component = component;
    this.pageMetaService = pageMetaService;
  }
  ngOnInit() {
    this.setTitle();
  }
  ngAfterViewInit() {
    this.lastestTitle$ = this.title$;
  }
  setTitle() {
    this.title$ = this.pageMetaService.getMeta().pipe(filter(isNotNullable), map(meta => (meta.heading || meta.title) ?? ''));
  }
  static {
    this.ɵfac = function PageTitleComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageTitleComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.PageMetaService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PageTitleComponent,
      selectors: [["cx-page-title"]],
      standalone: false,
      decls: 3,
      vars: 3,
      consts: [[1, "cx-visually-hidden"]],
      template: function PageTitleComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "h1", 0);
          i0.ɵɵtext(1);
          i0.ɵɵpipe(2, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx.title$));
        }
      },
      dependencies: [i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageTitleComponent, [{
    type: Component,
    args: [{
      selector: 'cx-page-title',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<h1 class=\"cx-visually-hidden\">{{ title$ | async }}</h1>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.PageMetaService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbComponent extends PageTitleComponent {
  constructor(component, pageMetaService, translation) {
    super(component, pageMetaService);
    this.component = component;
    this.pageMetaService = pageMetaService;
    this.translation = translation;
    this.router = inject(Router);
    this.featureConfigService = inject(FeatureConfigService);
    this.ariaLive$ = this.featureConfigService.isEnabled('a11yRepeatedPageTitleFix') ? this.router.events.pipe(filter(e => e instanceof NavigationEnd), map(() => {
      return document.activeElement !== document.body;
    })) : of(true);
  }
  ngOnInit() {
    super.ngOnInit();
    this.setCrumbs();
  }
  setCrumbs() {
    this.crumbs$ = combineLatest([this.pageMetaService.getMeta(), this.translation.translate('common.home')]).pipe(map(([meta, textHome]) => meta?.breadcrumbs ? meta.breadcrumbs : [{
      label: textHome,
      link: '/'
    }]));
  }
  static {
    this.ɵfac = function BreadcrumbComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.PageMetaService), i0.ɵɵdirectiveInject(i1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BreadcrumbComponent,
      selectors: [["cx-breadcrumb"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 15,
      consts: [["tabindex", "-1"], [4, "ngFor", "ngForOf"], [3, "routerLink", "innerHTML"]],
      template: function BreadcrumbComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "nav", 0);
          i0.ɵɵpipe(1, "cxTranslate");
          i0.ɵɵelementStart(2, "ol");
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵtemplate(4, BreadcrumbComponent_li_4_Template, 5, 9, "li", 1);
          i0.ɵɵpipe(5, "async");
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "h1");
          i0.ɵɵpipe(7, "async");
          i0.ɵɵtext(8);
          i0.ɵɵpipe(9, "async");
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 5, "common.breadcrumbs"));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 7, "common.breadcrumbs"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(5, 9, ctx.crumbs$));
          i0.ɵɵadvance(2);
          i0.ɵɵattribute("aria-live", i0.ɵɵpipeBind1(7, 11, ctx.ariaLive$) ? "polite" : null);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 13, ctx.title$), "\n");
        }
      },
      dependencies: [i3.NgForOf, i1$2.RouterLink, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbComponent, [{
    type: Component,
    args: [{
      selector: 'cx-breadcrumb',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<nav [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\" tabindex=\"-1\">\n  <ol [attr.aria-label]=\"'common.breadcrumbs' | cxTranslate\">\n    <li\n      *ngFor=\"\n        let crumb of crumbs$ | async as crumbList;\n        let i = index;\n        let last = last\n      \"\n    >\n      <a\n        [routerLink]=\"crumb.link\"\n        [innerHTML]=\"crumb.label\"\n        [attr.aria-label]=\"\n          last\n            ? ('common.breadcrumbsCurrentPage' | cxTranslate) +\n              ' ' +\n              crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n            : crumb.label +\n              (i + 1) +\n              ('common.of' | cxTranslate) +\n              crumbList.length\n        \"\n      ></a>\n    </li>\n  </ol>\n</nav>\n\n<h1 [attr.aria-live]=\"(ariaLive$ | async) ? 'polite' : null\">\n  {{ title$ | async }}\n</h1>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.PageMetaService
  }, {
    type: i1.TranslationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BreadcrumbModule {
  static {
    this.ɵfac = function BreadcrumbModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BreadcrumbModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BreadcrumbModule,
      declarations: [BreadcrumbComponent],
      imports: [CommonModule, RouterModule, PageMetaModule, I18nModule, FeaturesConfigModule],
      exports: [BreadcrumbComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          BreadcrumbComponent: {
            component: BreadcrumbComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, PageMetaModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BreadcrumbModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, PageMetaModule, I18nModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          BreadcrumbComponent: {
            component: BreadcrumbComponent
          }
        }
      })],
      declarations: [BreadcrumbComponent],
      exports: [BreadcrumbComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationService {
  constructor(cmsService, semanticPathService) {
    this.cmsService = cmsService;
    this.semanticPathService = semanticPathService;
  }
  createNavigation(data$) {
    return combineLatest([data$, this.getNavigationNode(data$)]).pipe(map(([data, nav]) => {
      return {
        title: data.name,
        children: [nav]
      };
    }));
  }
  /**
   * returns an observable with the `NavigationNode` for the given `CmsNavigationComponent`.
   * This function will load the navigation underlying entries and children if they haven't been
   * loaded so far.
   */
  getNavigationNode(data$) {
    if (!data$) {
      return EMPTY;
    }
    return data$.pipe(filter(data => !!data), switchMap(data => {
      const navigation = data.navigationNode ? data.navigationNode : data;
      return this.cmsService.getNavigationEntryItems(navigation.uid ?? '').pipe(tap(items => {
        if (items === undefined) {
          this.loadNavigationEntryItems(navigation, true);
          return;
        }
        // we should check whether the existing node items are what expected
        const expectedItems = [];
        this.loadNavigationEntryItems(navigation, false, expectedItems);
        const existingItems = Object.keys(items).map(key => items[key].uid ?? '');
        const missingItems = expectedItems.filter(it => it.id && !existingItems.includes(it.id));
        if (missingItems.length > 0) {
          this.cmsService.loadNavigationItems(navigation.uid ?? '', missingItems);
        }
      }), filter(Boolean), map(items => this.populateNavigationNode(navigation, items) ?? {}));
    }));
  }
  /**
   * Loads all navigation entry items' type and id. Dispatch action to load all these items
   * @param nodeData
   * @param root
   * @param itemsList
   */
  loadNavigationEntryItems(nodeData, root, itemsList = []) {
    if (nodeData.entries && nodeData.entries.length > 0) {
      nodeData.entries.forEach(entry => {
        itemsList.push({
          superType: entry.itemSuperType,
          id: entry.itemId
        });
      });
    }
    if (nodeData.children && nodeData.children.length > 0) {
      nodeData.children.forEach(child => this.loadNavigationEntryItems(child, false, itemsList));
    }
    if (root && nodeData.uid) {
      this.cmsService.loadNavigationItems(nodeData.uid, itemsList);
    }
  }
  /**
   * Create a new node tree for the view
   * @param nodeData
   * @param items
   */
  populateNavigationNode(nodeData, items) {
    const node = {};
    if (nodeData.title) {
      // the node title will be populated by the first entry (if any)
      // if there's no nodeData.title available
      node.title = nodeData.title;
    }
    // populate style classes to apply CMS driven styling
    if (nodeData.styleClasses) {
      node.styleClasses = nodeData.styleClasses;
    }
    // populate style attributes to apply CMS driven styling
    if (nodeData.styleAttributes) {
      node.styleAttributes = nodeData.styleAttributes;
    }
    if (nodeData.entries && nodeData.entries.length > 0) {
      this.populateLink(node, nodeData.entries[0], items);
    }
    if (nodeData.children?.length > 0) {
      const children = nodeData.children.map(child => this.populateNavigationNode(child, items)).filter(Boolean);
      if (children.length > 0) {
        node.children = children;
      }
    }
    // return null in case there are no children
    return Object.keys(node).length === 0 ? null : node;
  }
  /**
   * The node link is driven by the first entry.
   */
  populateLink(node, entry, items) {
    const item = items[`${entry.itemId}_${entry.itemSuperType}`];
    // now we only consider CMSLinkComponent
    if (item && entry.itemType === 'CMSLinkComponent') {
      if (!node.title) {
        node.title = item.linkName;
      }
      const url = this.getLink(item);
      // only populate the node link if we have a visible node
      if (node.title && url) {
        node.url = url;
        // the backend provide boolean value for the target
        // in case the link should be opened in a new window
        if (item.target === 'true' || item.target === true) {
          node.target = '_blank';
        }
      }
      // populate style classes to apply CMS driven styling
      if (item.styleClasses) {
        node.styleClasses = item.styleClasses;
      }
      // populate style attributes to apply CMS driven styling
      if (item.styleAttributes) {
        node.styleAttributes = item.styleAttributes;
      }
    }
  }
  /**
   *
   * Gets the URL or link to a related item (category),
   * also taking into account content pages (contentPageLabelOrId)
   * and product pages (productCode)
   */
  getLink(item) {
    if (item.url) {
      return item.url;
    } else if (item.contentPageLabelOrId) {
      return item.contentPageLabelOrId;
    } else if (item.categoryCode) {
      return this.semanticPathService.transform({
        cxRoute: 'category',
        params: {
          code: item.categoryCode,
          name: item.name
        }
      });
    } else if (item.productCode) {
      return this.semanticPathService.transform({
        cxRoute: 'product',
        params: {
          code: item.productCode,
          name: item.name
        }
      });
    }
  }
  static {
    this.ɵfac = function NavigationService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationService)(i0.ɵɵinject(i1.CmsService), i0.ɵɵinject(i1.SemanticPathService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NavigationService,
      factory: NavigationService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.CmsService
  }, {
    type: i1.SemanticPathService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const ARIA_EXPANDED_ATTR = 'aria-expanded';
class NavigationUIComponent {
  onResize() {
    this.resize.next(undefined);
  }
  onArrow(e) {
    this.arrowControls.next(e);
  }
  constructor(router, renderer, elemRef, hamburgerMenuService, winRef, featureConfigService) {
    this.router = router;
    this.renderer = renderer;
    this.elemRef = elemRef;
    this.hamburgerMenuService = hamburgerMenuService;
    this.winRef = winRef;
    this.featureConfigService = featureConfigService;
    /**
     * Include non intractable node titles within the tabbing order.
     */
    this.focusableNodeTitles = false;
    /**
     * the icon type that will be used for navigation nodes
     * with children.
     */
    this.iconType = ICON_TYPE;
    /**
     * Indicates whether the navigation should support flyout.
     * If flyout is set to true, the
     * nested child navigation nodes will only appear on hover or focus.
     */
    this.flyout = true;
    this.isOpen = false;
    this.openNodes = [];
    this.subscriptions = new Subscription();
    this.resize = new EventEmitter();
    this.arrowControls = new Subject();
    this.breakpointService = inject(BreakpointService);
    this.isDesktop$ = this.breakpointService.isUp(BREAKPOINT.lg);
    this.subscriptions.add(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => this.clear()));
    this.subscriptions.add(this.resize.pipe(debounceTime(50)).subscribe(() => {
      this.alignWrappersToRightIfStickOut();
    }));
    useFeatureStyles('a11yOptimizedMenuSpacing');
    useFeatureStyles('a11yNavigationButtonsAriaFixes');
  }
  /**
   * During initialization of this component, we will check the resetMenuOnClose flag and attach a menu reset listener if needed.
   */
  ngOnInit() {
    if (this.resetMenuOnClose) {
      this.resetOnMenuCollapse();
    }
  }
  /**
   * This method performs the action of resetting the menu (close all sub menus and return to main options)
   * when the menu is closed.
   */
  resetOnMenuCollapse() {
    this.subscriptions.add(this.hamburgerMenuService?.isExpanded.pipe(distinctUntilChanged(), filter(Boolean)).subscribe(() => {
      this.reinitializeMenu();
    }));
  }
  closeIfClickedTheSameLink(navNode) {
    if (typeof navNode.url === 'string' && this.winRef.nativeWindow?.location.href.includes(navNode.url)) {
      this.reinitializeMenu();
      this.hamburgerMenuService.toggle();
    }
  }
  /**
   * This method performs the actions required to reset the state of the menu and reset any visual components.
   */
  reinitializeMenu() {
    const a11yNavMenuExpandStateReadout = this.featureConfigService?.isEnabled('a11yNavMenuExpandStateReadout');
    const listItems = this.elemRef.nativeElement.querySelectorAll('li.is-open:not(.back), li.is-opened');
    if (a11yNavMenuExpandStateReadout) {
      listItems.forEach(el => {
        Array.from(el.children).filter(childNode => childNode?.tagName === 'BUTTON').forEach(childNode => {
          this.renderer.setAttribute(childNode, ARIA_EXPANDED_ATTR, 'false');
        });
      });
    }
    listItems.forEach(el => {
      this.renderer.removeClass(el, 'is-open');
      this.renderer.removeClass(el, 'is-opened');
    });
    this.clear();
    this.renderer.removeClass(this.elemRef.nativeElement, 'is-open');
    this.updateClasses();
  }
  ariaCollapseNodes() {
    this.openNodes.forEach(parentNode => {
      Array.from(parentNode.children).filter(childNode => childNode?.tagName === 'BUTTON').forEach(childNode => {
        this.renderer.setAttribute(childNode, ARIA_EXPANDED_ATTR, 'false');
      });
    });
  }
  toggleOpen(event) {
    if (event.type === 'keydown') {
      event.preventDefault();
    }
    this.ariaCollapseNodes();
    const node = event.currentTarget;
    const parentNode = node.parentNode;
    if (this.openNodes.includes(parentNode)) {
      if (event.type === 'keydown') {
        this.back();
      } else {
        this.openNodes = this.openNodes.filter(n => n !== parentNode);
        this.renderer.removeClass(parentNode, 'is-open');
      }
    } else {
      this.openNodes.push(parentNode);
      this.renderer.setAttribute(node, ARIA_EXPANDED_ATTR, 'true');
    }
    this.updateClasses();
    event.stopImmediatePropagation();
    event.stopPropagation();
  }
  /**
   * Opens dropdown and starts keyboard navigation
   */
  onSpace(event) {
    this.hamburgerMenuService.isExpanded.pipe(take(1)).subscribe(isExpanded => {
      if (isExpanded) {
        this.toggleOpen(event);
        return;
      }
      if (!this.openNodes.length) {
        this.toggleOpen(event);
        return;
      }
      event.preventDefault();
    });
    this.focusOnNode(event);
    this.setupArrowControls();
  }
  /**
   * Subscribes to arrow keys and enables navigation between dropdown items
   */
  setupArrowControls() {
    this.subscriptions.add(this.arrowControls.subscribe(e => {
      e.preventDefault();
      const parentElement = e.target.parentElement?.parentElement;
      const nextLink = parentElement?.nextElementSibling?.querySelector('a');
      const previousLink = parentElement?.previousElementSibling?.querySelector('a');
      e.code === 'ArrowDown' ? nextLink?.focus() : previousLink?.focus();
    }));
  }
  /**
   * Focuses on the first focusable element in the dropdown
   */
  focusOnNode(event) {
    if (this.featureConfigService?.isEnabled('a11yNavigationButtonsAriaFixes')) {
      const firstFocusableNode = event.target?.nextElementSibling?.querySelector('button, h4, a');
      firstFocusableNode?.focus();
    } else {
      const firstFocusableElement = event.target.nextElementSibling?.querySelector('button') || event.target.nextElementSibling?.querySelector('a');
      firstFocusableElement?.focus();
    }
  }
  back() {
    if (this.openNodes[this.openNodes.length - 1]) {
      this.renderer.removeClass(this.openNodes[this.openNodes.length - 1], 'is-open');
      const removedNode = this.openNodes.pop();
      setTimeout(() => {
        (removedNode?.querySelector('[aria-haspopup="true"]')).focus();
      }, 0);
      this.updateClasses();
    }
  }
  clear() {
    this.openNodes = [];
    this.updateClasses();
  }
  onMouseEnter(event) {
    this.alignWrapperToRightIfStickOut(event.currentTarget);
    this.focusAfterPreviousClicked(event);
  }
  getTotalDepth(node, depth = 0) {
    if (node.children && node.children.length > 0) {
      return Math.max(...node.children.map(n => this.getTotalDepth(n, depth + 1)));
    } else {
      return depth;
    }
  }
  getColumnCount(length) {
    if (!this.wrapAfter || length <= 0) {
      return 1;
    }
    let subSectionColumns = Math.floor(length / this.wrapAfter);
    if (subSectionColumns >= 1 && length % this.wrapAfter > 0) {
      subSectionColumns += 1;
    }
    return subSectionColumns;
  }
  focusAfterPreviousClicked(event) {
    const target = event.target || event.relatedTarget;
    if (target.ownerDocument.activeElement?.matches('nav[tabindex]') && target.parentElement?.matches('.flyout')) {
      target.focus();
    }
    return target.ownerDocument;
  }
  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  alignWrapperToRightIfStickOut(node) {
    const wrapper = node.querySelector('.wrapper');
    const body = node.closest('body');
    if (wrapper) {
      this.renderer.removeStyle(wrapper, 'margin-left');
      if (wrapper.offsetLeft + wrapper.offsetWidth > body.offsetLeft + body.offsetWidth) {
        this.renderer.setStyle(wrapper, 'margin-left', `${node.offsetWidth - wrapper.offsetWidth}px`);
      }
    }
  }
  alignWrappersToRightIfStickOut() {
    const navs = this.elemRef.nativeElement.childNodes;
    Array.from(navs).filter(node => node.tagName === 'LI').forEach(nav => this.alignWrapperToRightIfStickOut(nav));
  }
  updateClasses() {
    this.openNodes.forEach((node, i) => {
      if (i + 1 < this.openNodes.length) {
        this.renderer.addClass(node, 'is-opened');
        this.renderer.removeClass(node, 'is-open');
      } else {
        this.renderer.removeClass(node, 'is-opened');
        this.renderer.addClass(node, 'is-open');
      }
    });
    this.isOpen = this.openNodes.length > 0;
  }
  /**
   * Restores default tabbing order for non flyout navigation.
   */
  getTabIndex(node, depth) {
    if (!this.flyout) {
      return 0;
    }
    return depth > 0 && !node?.children ? -1 : 0;
  }
  // TODO: Delete deprecated methods once `a11yNavigationButtonsAriaFixes` feature flag is removed.
  /**
   * Replace spaces with hyphens and convert to lowercase
   * @deprecated
   */
  getSanitizedTitle(title) {
    return title ? title.replace(/\s+/g, '-').toLowerCase() : null;
  }
  /**
   * Returns the value for the `aria-control` and the `aria-label` attribute of a button.
   * @deprecated
   */
  getAriaLabelAndControl(node) {
    return this.getSanitizedTitle(node.title) || null;
  }
  transformIntoValidID(string) {
    return string?.replace(/[^a-zA-Z0-9-_]/g, '-') || null;
  }
  static {
    this.ɵfac = function NavigationUIComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationUIComponent)(i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(HamburgerMenuService), i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(i1.FeatureConfigService, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavigationUIComponent,
      selectors: [["cx-navigation-ui"]],
      hostVars: 4,
      hostBindings: function NavigationUIComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("resize", function NavigationUIComponent_resize_HostBindingHandler() {
            return ctx.onResize();
          }, false, i0.ɵɵresolveWindow)("keyDown.arrowUp", function NavigationUIComponent_keyDown_arrowUp_HostBindingHandler($event) {
            return ctx.onArrow($event);
          }, false, i0.ɵɵresolveDocument)("keyDown.arrowDown", function NavigationUIComponent_keyDown_arrowDown_HostBindingHandler($event) {
            return ctx.onArrow($event);
          }, false, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("flyout", ctx.flyout)("is-open", ctx.isOpen);
        }
      },
      inputs: {
        node: "node",
        wrapAfter: "wrapAfter",
        resetMenuOnClose: "resetMenuOnClose",
        focusableNodeTitles: "focusableNodeTitles",
        navAriaLabel: "navAriaLabel",
        flyout: "flyout",
        isOpen: "isOpen"
      },
      standalone: false,
      decls: 6,
      vars: 4,
      consts: [["nav", ""], ["heading", ""], ["title", ""], ["dropdownHeader", ""], ["class", "back is-open", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "back", "is-open"], [3, "click"], [3, "type"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ariaLabel", "url", "target", "style", "class", "tabindex", "click", "focus", "keydown.space", "keydown.esc", 4, "ngIf", "ngIfElse"], ["class", "wrapper", 3, "id", 4, "ngIf"], [3, "click", "focus", "keydown.space", "keydown.esc", "ariaLabel", "url", "target", "tabindex"], [4, "ngIf", "ngIfElse"], [3, "url", "target", "click", 4, "ngIf"], [4, "cxFeature"], [3, "click", "url", "target"], ["aria-level", "4", 3, "click", "mouseenter", "keydown.space", "keydown.enter", "keydown.esc", "keydown.arrowDown", "focus"], [4, "ngIf"], ["tabindex", "0", 3, "keydown.arrowDown", "keydown.space", 4, "ngIf", "ngIfElse"], ["tabindex", "0", 3, "keydown.arrowDown", "keydown.space"], [3, "click", "mouseenter", "keydown.space", "keydown.enter", "keydown.esc", "keydown.arrowDown", "focus"], ["role", "heading", "aria-level", "4", 4, "ngIf"], ["role", "heading", "aria-level", "4"], [1, "wrapper", 3, "id"], [1, "childs"]],
      template: function NavigationUIComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "nav")(1, "ul");
          i0.ɵɵtemplate(2, NavigationUIComponent_li_2_Template, 5, 4, "li", 4)(3, NavigationUIComponent_ng_container_3_Template, 2, 4, "ng-container", 5);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(4, NavigationUIComponent_ng_template_4_Template, 5, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          let tmp_2_0;
          let tmp_3_0;
          i0.ɵɵattribute("aria-label", ctx.navAriaLabel);
          i0.ɵɵadvance();
          i0.ɵɵattribute("role", ctx.flyout && ((tmp_2_0 = ctx.node == null ? null : ctx.node.children == null ? null : ctx.node.children.length) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0) > 1 ? "list" : "presentation");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.flyout && ((tmp_3_0 = ctx.node == null ? null : ctx.node.children == null ? null : ctx.node.children.length) !== null && tmp_3_0 !== undefined ? tmp_3_0 : 0) > 1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.node == null ? null : ctx.node.children);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, IconComponent, GenericLinkComponent, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationUIComponent, [{
    type: Component,
    args: [{
      selector: 'cx-navigation-ui',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<nav [attr.aria-label]=\"navAriaLabel\">\n  <ul\n    [attr.role]=\"\n      flyout && (node?.children?.length ?? 0) > 1 ? 'list' : 'presentation'\n    \"\n  >\n    <li\n      *ngIf=\"flyout && (node?.children?.length ?? 0) > 1\"\n      class=\"back is-open\"\n    >\n      <button (click)=\"back()\">\n        <cx-icon [type]=\"iconType.CARET_LEFT\"></cx-icon>\n        {{ 'common.back' | cxTranslate }}\n      </button>\n    </li>\n\n    <ng-container *ngFor=\"let child of node?.children\">\n      <ng-container *ngTemplateOutlet=\"nav; context: { node: child, depth: 0 }\">\n      </ng-container>\n    </ng-container>\n  </ul>\n</nav>\n<!-- we generate links in a recursive manner -->\n\n<ng-template\n  #nav\n  let-node=\"node\"\n  let-depth=\"depth\"\n  let-listLength=\"listLength\"\n  let-position=\"position\"\n>\n  <li [attr.role]=\"!flyout && !depth ? 'presentation' : 'listitem'\">\n    <cx-generic-link\n      *ngIf=\"\n        node.url && (!node.children || node.children?.length === 0);\n        else heading\n      \"\n      [ariaLabel]=\"\n        'navigation.linkItemInList'\n          | cxTranslate\n            : {\n                title: node.title,\n                position,\n                listLength,\n              }\n      \"\n      [url]=\"node.url\"\n      [target]=\"node.target\"\n      [style]=\"node.styleAttributes\"\n      [class]=\"node.styleClasses\"\n      (click)=\"closeIfClickedTheSameLink(node)\"\n      [tabindex]=\"getTabIndex(node, depth)\"\n      (focus)=\"depth || reinitializeMenu()\"\n      (keydown.space)=\"toggleOpen($any($event))\"\n      (keydown.esc)=\"back()\"\n    >\n      {{ node.title }}\n    </cx-generic-link>\n\n    <ng-template #heading>\n      <ng-container *ngIf=\"flyout && node.children?.length > 0; else title\">\n        <cx-generic-link\n          *ngIf=\"node.url\"\n          [url]=\"node.url\"\n          [target]=\"node.target\"\n          (click)=\"closeIfClickedTheSameLink(node)\"\n        >\n          {{ node.title }}\n        </cx-generic-link>\n        <ng-container *cxFeature=\"'!a11yNavigationButtonsAriaFixes'\">\n          <button\n            aria-level=\"4\"\n            [attr.role]=\"(isDesktop$ | async) && depth ? 'heading' : 'button'\"\n            [attr.aria-haspopup]=\"true\"\n            [attr.aria-expanded]=\"false\"\n            [attr.aria-controls]=\"node.title\"\n            [attr.aria-describedby]=\"'greeting'\"\n            (click)=\"toggleOpen($any($event))\"\n            (mouseenter)=\"onMouseEnter($event)\"\n            (keydown.space)=\"onSpace($any($event))\"\n            (keydown.enter)=\"onSpace($any($event))\"\n            (keydown.esc)=\"back()\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (focus)=\"depth || reinitializeMenu()\"\n          >\n            <ng-container *ngIf=\"!node.url\">\n              {{ node.title }}\n            </ng-container>\n            <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n          </button>\n        </ng-container>\n        <ng-container *cxFeature=\"'a11yNavigationButtonsAriaFixes'\">\n          <h4\n            *ngIf=\"(isDesktop$ | async) && depth; else dropdownHeader\"\n            (keydown.arrowDown)=\"focusOnNode($any($event))\"\n            (keydown.space)=\"onSpace($any($event))\"\n            tabindex=\"0\"\n          >\n            {{ node.title }}\n          </h4>\n          <ng-template #dropdownHeader>\n            <button\n              [attr.aria-haspopup]=\"true\"\n              [attr.aria-expanded]=\"false\"\n              [attr.aria-label]=\"node.url ? node.title : null\"\n              [attr.aria-controls]=\"transformIntoValidID(node.title)\"\n              [attr.title]=\"\n                'navigation.menuButonTitle' | cxTranslate: { title: node.title }\n              \"\n              (click)=\"toggleOpen($any($event))\"\n              (mouseenter)=\"onMouseEnter($event)\"\n              (keydown.space)=\"onSpace($any($event))\"\n              (keydown.enter)=\"onSpace($any($event))\"\n              (keydown.esc)=\"back()\"\n              (keydown.arrowDown)=\"focusOnNode($any($event))\"\n              (focus)=\"depth || reinitializeMenu()\"\n            >\n              <ng-container *ngIf=\"!node.url\">\n                {{ node.title }}\n              </ng-container>\n              <cx-icon [type]=\"iconType.CARET_DOWN\"></cx-icon>\n            </button>\n          </ng-template>\n        </ng-container>\n      </ng-container>\n      <ng-template #title>\n        <span\n          role=\"heading\"\n          aria-level=\"4\"\n          *ngIf=\"node.title\"\n          [attr.tabindex]=\"focusableNodeTitles ? 0 : -1\"\n        >\n          {{ node.title }}\n        </span>\n      </ng-template>\n    </ng-template>\n\n    <!-- we add a wrapper to allow for better layout handling in CSS -->\n    <div\n      [id]=\"transformIntoValidID(node.title)\"\n      class=\"wrapper\"\n      *ngIf=\"node.children && node.children.length > 0\"\n    >\n      <ul\n        class=\"childs\"\n        [attr.depth]=\"getTotalDepth(node)\"\n        [attr.wrap-after]=\"node.children.length > wrapAfter ? wrapAfter : null\"\n        [attr.columns]=\"getColumnCount(node.children.length)\"\n        [attr.aria-label]=\"node.title\"\n      >\n        <ng-container *ngFor=\"let child of node.children; index as i\">\n          <ng-container\n            *ngTemplateOutlet=\"\n              nav;\n              context: {\n                node: child,\n                depth: depth + 1,\n                listLength: node.children.length,\n                position: i + 1,\n              }\n            \"\n          >\n          </ng-container>\n        </ng-container>\n      </ul>\n    </div>\n  </li>\n</ng-template>\n"
    }]
  }], () => [{
    type: i1$2.Router
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }, {
    type: HamburgerMenuService
  }, {
    type: i1.WindowRef
  }, {
    type: i1.FeatureConfigService,
    decorators: [{
      type: Optional
    }]
  }], {
    node: [{
      type: Input
    }],
    wrapAfter: [{
      type: Input
    }],
    resetMenuOnClose: [{
      type: Input
    }],
    focusableNodeTitles: [{
      type: Input
    }],
    navAriaLabel: [{
      type: Input
    }],
    flyout: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.flyout']
    }],
    isOpen: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class.is-open']
    }],
    onResize: [{
      type: HostListener,
      args: ['window:resize']
    }],
    onArrow: [{
      type: HostListener,
      args: ['document:keyDown.arrowUp', ['$event']]
    }, {
      type: HostListener,
      args: ['document:keyDown.arrowDown', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CategoryNavigationComponent {
  constructor(componentData, service) {
    this.componentData = componentData;
    this.service = service;
    this.node$ = this.service.getNavigationNode(this.componentData.data$);
    this.data$ = this.componentData.data$;
  }
  static {
    this.ɵfac = function CategoryNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CategoryNavigationComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(NavigationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CategoryNavigationComponent,
      selectors: [["cx-category-navigation"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "node", "ngClass", "wrapAfter", "resetMenuOnClose", "navAriaLabel", 4, "ngIf"], [3, "node", "ngClass", "wrapAfter", "resetMenuOnClose", "navAriaLabel"]],
      template: function CategoryNavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, CategoryNavigationComponent_cx_navigation_ui_0_Template, 3, 9, "cx-navigation-ui", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.data$));
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, NavigationUIComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CategoryNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-category-navigation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-navigation-ui\n  *ngIf=\"data$ | async as data\"\n  [node]=\"node$ | async\"\n  [ngClass]=\"data.styleClass ?? ''\"\n  [wrapAfter]=\"+(data.wrapAfter ?? '')\"\n  [resetMenuOnClose]=\"data.resetMenuOnClose\"\n  [navAriaLabel]=\"'navigation.categoryNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: NavigationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationComponent {
  constructor(componentData, service) {
    this.componentData = componentData;
    this.service = service;
    this.node$ = this.service.createNavigation(this.componentData.data$);
    this.name$ = this.componentData.data$.pipe(map(d => d?.navigationNode?.title));
    this.styleClass$ = this.componentData.data$.pipe(map(d => d?.styleClass));
  }
  static {
    this.ɵfac = function NavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(NavigationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NavigationComponent,
      selectors: [["cx-navigation"]],
      standalone: false,
      decls: 4,
      vars: 9,
      consts: [[3, "node", "ngClass", "navAriaLabel"]],
      template: function NavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "cx-navigation-ui", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵpipe(2, "async");
          i0.ɵɵpipe(3, "async");
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵproperty("node", i0.ɵɵpipeBind1(1, 3, ctx.node$))("ngClass", (tmp_1_0 = i0.ɵɵpipeBind1(2, 5, ctx.styleClass$)) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "")("navAriaLabel", i0.ɵɵpipeBind1(3, 7, ctx.name$));
        }
      },
      dependencies: [i3.NgClass, NavigationUIComponent, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-navigation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-navigation-ui\n  [node]=\"node$ | async\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n>\n</cx-navigation-ui>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: NavigationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationModule {
  static {
    this.ɵfac = function NavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NavigationModule,
      declarations: [NavigationComponent, NavigationUIComponent],
      imports: [CommonModule, RouterModule, IconModule, GenericLinkModule, I18nModule, FeaturesConfigModule],
      exports: [NavigationComponent, NavigationUIComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          NavigationComponent: {
            component: NavigationComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, IconModule, GenericLinkModule, I18nModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, IconModule, GenericLinkModule, I18nModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          NavigationComponent: {
            component: NavigationComponent
          }
        }
      })],
      declarations: [NavigationComponent, NavigationUIComponent],
      exports: [NavigationComponent, NavigationUIComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CategoryNavigationModule {
  static {
    this.ɵfac = function CategoryNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CategoryNavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CategoryNavigationModule,
      declarations: [CategoryNavigationComponent],
      imports: [CommonModule, NavigationModule, I18nModule],
      exports: [CategoryNavigationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          CategoryNavigationComponent: {
            component: CategoryNavigationComponent,
            data: {
              resetMenuOnClose: true
            }
          }
        }
      })],
      imports: [CommonModule, NavigationModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CategoryNavigationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, NavigationModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          CategoryNavigationComponent: {
            component: CategoryNavigationComponent,
            data: {
              resetMenuOnClose: true
            }
          }
        }
      })],
      declarations: [CategoryNavigationComponent],
      exports: [CategoryNavigationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FooterNavigationComponent {
  constructor(componentData, service) {
    this.componentData = componentData;
    this.service = service;
    this.node$ = this.service.getNavigationNode(this.componentData.data$);
    this.styleClass$ = this.componentData.data$.pipe(map(d => d?.styleClass));
  }
  static {
    this.ɵfac = function FooterNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FooterNavigationComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(NavigationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FooterNavigationComponent,
      selectors: [["cx-footer-navigation"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[3, "node", "flyout", "ngClass", "navAriaLabel", 4, "ngIf"], [3, "node", "flyout", "ngClass", "navAriaLabel"]],
      template: function FooterNavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FooterNavigationComponent_cx_navigation_ui_0_Template, 3, 8, "cx-navigation-ui", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.node$));
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, NavigationUIComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-footer-navigation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"'navigation.footerNavLabel' | cxTranslate\"\n></cx-navigation-ui>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: NavigationService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FooterNavigationModule {
  static {
    this.ɵfac = function FooterNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FooterNavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FooterNavigationModule,
      declarations: [FooterNavigationComponent],
      imports: [CommonModule, RouterModule, NavigationModule, GenericLinkModule, I18nModule],
      exports: [FooterNavigationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          FooterNavigationComponent: {
            component: FooterNavigationComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, NavigationModule, GenericLinkModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FooterNavigationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, NavigationModule, GenericLinkModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          FooterNavigationComponent: {
            component: FooterNavigationComponent
          }
        }
      })],
      declarations: [FooterNavigationComponent],
      exports: [FooterNavigationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PageTitleModule {
  static {
    this.ɵfac = function PageTitleModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PageTitleModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PageTitleModule,
      declarations: [PageTitleComponent],
      imports: [CommonModule, RouterModule, PageMetaModule],
      exports: [PageTitleComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          PageTitleComponent: {
            component: PageTitleComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, PageMetaModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageTitleModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, PageMetaModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          PageTitleComponent: {
            component: PageTitleComponent
          }
        }
      })],
      declarations: [PageTitleComponent],
      exports: [PageTitleComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HighlightPipe {
  transform(text, match, caseSensitive = true) {
    if (!match) {
      return text;
    }
    if (!caseSensitive) {
      const textStartIndex = text.toLowerCase().indexOf(match.toLowerCase());
      const matchLength = match.length;
      return text.replaceAll(text.substring(textStartIndex, textStartIndex + matchLength), `<span class="highlight">${text.substring(textStartIndex, textStartIndex + matchLength)}</span>`);
    }
    return text.replace(match.trim(), `<span class="highlight">${match.trim()}</span>`);
  }
  static {
    this.ɵfac = function HighlightPipe_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HighlightPipe)();
    };
  }
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "cxHighlight",
      type: HighlightPipe,
      pure: true,
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe, [{
    type: Pipe,
    args: [{
      name: 'cxHighlight',
      standalone: false
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that the user chose a suggestion
 */
class SearchBoxSuggestionSelectedEvent extends CxEvent {
  /**
   * Event's type
   */
  static {
    this.type = 'SearchBoxSuggestionSelectedEvent';
  }
}
/**
 * Indicates that the user chose a product suggestion
 */
class SearchBoxProductSelectedEvent extends CxEvent {
  /**
   * Event's type
   */
  static {
    this.type = 'SearchBoxProductSelectedEvent';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const HAS_SEARCH_RESULT_CLASS = 'has-searchbox-results';
class SearchBoxComponentService {
  constructor(searchService, routingService, translationService, winRef, eventService) {
    this.searchService = searchService;
    this.routingService = routingService;
    this.translationService = translationService;
    this.winRef = winRef;
    this.eventService = eventService;
    this.chosenWord = new ReplaySubject();
    this.sharedEvent = new ReplaySubject();
    this.searchCompleted = new BehaviorSubject(false);
    this.enableRecentSearches = false;
    this.enableTrendingSearches = false;
    this.currentQueryLength = 0;
    this.hasKeywordRedirect = false;
  }
  /**
   * Executes the search for products and suggestions,
   * unless the configuration is setup to not search for
   * products or suggestions.
   */
  search(query, config) {
    this.hasKeywordRedirect = false;
    this.currentQueryLength = query ? query.length : 0;
    this.searchCompleted.next(false);
    if (!this.enableRecentSearches && !this.enableTrendingSearches && (!query || query === '')) {
      this.clearResults();
      return;
    }
    if (config.minCharactersBeforeRequest && query.length < config.minCharactersBeforeRequest) {
      return;
    }
    let productsComplete = !config.displayProducts;
    let suggestionsComplete = !config.displaySuggestions;
    if (config.displayProducts) {
      this.searchService.searchWithCompletion(query, {
        pageSize: config.maxProducts
      }).subscribe(result => {
        if (result?.type === ProductActions.SEARCH_PRODUCTS_SUCCESS && result?.payload?.keywordRedirectUrl) {
          this.hasKeywordRedirect = true;
        }
        productsComplete = true;
        this.checkSearchCompletion(productsComplete, suggestionsComplete);
      });
    }
    if (config.displaySuggestions) {
      this.searchService.searchSuggestionsWithCompletion(query, {
        pageSize: config.maxSuggestions
      }).subscribe(result => {
        if (result?.type === ProductActions.GET_PRODUCT_SUGGESTIONS_SUCCESS && result?.payload?.keywordRedirectUrl) {
          this.hasKeywordRedirect = true;
        }
        suggestionsComplete = true;
        this.checkSearchCompletion(productsComplete, suggestionsComplete);
      });
    }
  }
  /**
   * Check if search operations are complete based on actual completion flags
   */
  checkSearchCompletion(productsComplete, suggestionsComplete) {
    if (productsComplete && suggestionsComplete && this.currentQueryLength > 0) {
      this.searchCompleted.next(true);
    }
  }
  /**
   * Returns an observable with the SearchResults. When there's any
   * result, the body tag will get a classname, so that specific style
   * rules can be applied.
   */
  getResults(config) {
    return combineLatest([this.getProductResults(config), this.getProductSuggestions(config), this.getSearchMessage(config)]).pipe(map(([productResults, suggestions, message]) => {
      return {
        products: productResults ? productResults.products : undefined,
        suggestions,
        message
      };
    }), tap(results => this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, this.hasResults(results))));
  }
  /**
   * Clears the searchbox results, so that old values are
   * no longer emited upon next search.
   */
  clearResults() {
    this.searchService.clearResults();
    this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, false);
    // Reset search completion state
    this.hasKeywordRedirect = false;
    this.currentQueryLength = 0;
  }
  hasBodyClass(className) {
    return this.winRef.document.body.classList.contains(className);
  }
  toggleBodyClass(className, add) {
    if (add === undefined) {
      this.winRef.document.body.classList.toggle(className);
    } else {
      add ? this.winRef.document.body.classList.add(className) : this.winRef.document.body.classList.remove(className);
    }
  }
  /**
   * Dispatches a searchbox event for product selected
   *
   * @param eventData data for the "SearchBoxProductSelectedEvent"
   */
  dispatchProductSelectedEvent(eventData) {
    this.eventService.dispatch({
      freeText: eventData.freeText,
      productCode: eventData.productCode
    }, SearchBoxProductSelectedEvent);
  }
  /**
   * Dispatches a searchbox event for suggestion selected
   *
   * @param eventData data for the "SearchBoxSuggestionSelectedEvent"
   */
  dispatchSuggestionSelectedEvent(eventData) {
    this.eventService.dispatch({
      freeText: eventData.freeText,
      selectedSuggestion: eventData.selectedSuggestion,
      searchSuggestions: eventData.searchSuggestions
    }, SearchBoxSuggestionSelectedEvent);
  }
  /**
   * For search results model, it returns true when:
   * * there is any product OR
   * * the is any search suggestion OR
   * * there is a message.
   *
   * Otherwise it returns false.
   */
  hasResults(results) {
    return !!results.products && results.products.length > 0 || !!results.suggestions && results.suggestions.length > 0 || !!results.message || !!results.recentSearches;
  }
  /**
   * Emits product search results in case when the config property `displayProducts` is true.
   * Otherwise it emits an empty object.
   */
  getProductResults(config) {
    if (config.displayProducts) {
      return this.searchService.getResults();
    } else {
      return of({});
    }
  }
  /**
   * Loads suggestions from the backend. In case there's no suggestion
   * available, we try to get an exact match suggestion.
   */
  getProductSuggestions(config) {
    if (!config.displaySuggestions) {
      return of([]);
    } else {
      return this.searchService.getSuggestionResults().pipe(map(res => res.map(suggestion => suggestion.value).filter(isNotUndefined)), switchMap(suggestions => {
        if (suggestions.length === 0) {
          return this.getExactSuggestion(config).pipe(map(match => match ? [match] : []));
        } else {
          return of(suggestions);
        }
      }));
    }
  }
  /**
   * Whenever there is at least 1 product, we simulate
   * a suggestion to provide easy access to the search result page
   */
  getExactSuggestion(config) {
    return this.getProductResults(config).pipe(switchMap(productResult => {
      return productResult.products && productResult.products.length > 0 ? this.fetchTranslation('searchBox.help.exactMatch', {
        term: productResult.freeTextSearch
      }) : of(undefined);
    }));
  }
  /**
   * Emits a 'no match' message, in case the product search results and search suggestions are empty.
   * Otherwise it emits null.
   */
  getSearchMessage(config) {
    return combineLatest([this.getProductResults(config), this.getProductSuggestions(config)]).pipe(switchMap(([productResult, suggestions]) => {
      if (productResult && productResult.products && productResult.products.length === 0 && suggestions && suggestions.length === 0) {
        return this.fetchTranslation('searchBox.help.noMatch');
      } else {
        return of(undefined);
      }
    }));
  }
  /**
   * Navigates to the search result page with a given query
   * after waiting for all search operations to complete
   */
  launchSearchPage(query) {
    // Reset the completed state before starting new search
    this.searchCompleted.pipe(filter(complete => complete),
    // Only proceed when true
    take(1) // Take only the first completion
    ).subscribe(() => {
      if (!this.hasKeywordRedirect) {
        this.routingService.go({
          cxRoute: 'search',
          params: {
            query
          }
        });
      }
    });
  }
  fetchTranslation(translationKey, options) {
    return this.translationService.translate(translationKey, options);
  }
  changeSelectedWord(selectedWord) {
    this.chosenWord.next(selectedWord);
  }
  shareEvent($event) {
    this.sharedEvent.next($event);
  }
  setTrendingSearches(enabled = false) {
    this.enableTrendingSearches = enabled;
  }
  setRecentSearches(enabled = false) {
    this.enableRecentSearches = enabled;
  }
  static {
    this.ɵfac = function SearchBoxComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SearchBoxComponentService)(i0.ɵɵinject(i1.SearchboxService), i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1.TranslationService), i0.ɵɵinject(i1.WindowRef), i0.ɵɵinject(i1.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: SearchBoxComponentService,
      factory: SearchBoxComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBoxComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.SearchboxService
  }, {
    type: i1.RoutingService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.WindowRef
  }, {
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SearchBoxOutlets;
(function (SearchBoxOutlets) {
  SearchBoxOutlets["RECENT_SEARCHES"] = "SearchBoxOutlets.RECENT_SEARCHES";
  SearchBoxOutlets["TRENDING_SEARCHES"] = "SearchBoxOutlets.TRENDING_SEARCHES";
})(SearchBoxOutlets || (SearchBoxOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var SearchBoxFeatures;
(function (SearchBoxFeatures) {
  SearchBoxFeatures["SEARCH_BOX_V2"] = "searchBoxV2";
  SearchBoxFeatures["TRENDING_SEARCHES_FEATURE"] = "trendingSearches";
})(SearchBoxFeatures || (SearchBoxFeatures = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const DEFAULT_SEARCH_BOX_CONFIG = {
  minCharactersBeforeRequest: 1,
  displayProducts: true,
  displaySuggestions: true,
  maxProducts: 5,
  maxSuggestions: 5,
  displayProductImages: true,
  recentSearches: true,
  maxRecentSearches: 5,
  trendingSearches: true,
  maxTrendingSearches: 5
};
const SEARCHBOX_IS_ACTIVE = 'searchbox-is-active';
class SearchBoxComponent {
  /**
   * Sets the search box input field
   */
  set queryText(value) {
    if (value) {
      this.updateChosenWord(value);
      this.search(value);
    }
  }
  get searchBoxV2() {
    return this.isEnabledFeature(SearchBoxFeatures.SEARCH_BOX_V2);
  }
  get hasSearchBoxV2() {
    const hostElement = this.elementRef.nativeElement;
    return hostElement.classList.contains('search-box-v2');
  }
  /**
   * Listener for clickout out of searchInput and searchPanel
   * */
  clickout(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.softClose();
    }
  }
  onEscape() {
    if (this.featureConfigService?.isEnabled('a11ySearchBoxFocusOnEscape') && this.winRef.document.activeElement !== this.searchInputEl?.nativeElement || this.searchBoxActive) {
      setTimeout(() => {
        this.searchInputEl.nativeElement.focus();
      });
    }
  }
  get isMobile() {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }
  constructor(searchBoxComponentService, componentData, winRef, routingService) {
    this.searchBoxComponentService = searchBoxComponentService;
    this.componentData = componentData;
    this.winRef = winRef;
    this.routingService = routingService;
    this.elementRef = inject(ElementRef);
    this.renderer = inject(Renderer2);
    this.searchBoxOutlets = SearchBoxOutlets;
    this.searchBoxFeatures = SearchBoxFeatures;
    this.iconTypes = ICON_TYPE;
    this.searchBoxActive = false;
    /**
     * In some occasions we need to ignore the close event,
     * for example when we click inside the search result section.
     */
    this.ignoreCloseEvent = false;
    this.chosenWord = '';
    this.subscriptions = new Subscription();
    // TODO: (CXSPA-6929) - Make dependencies no longer optional next major release
    this.changeDetecorRef = inject(ChangeDetectorRef, {
      optional: true
    });
    this.breakpointService = inject(BreakpointService, {
      optional: true
    });
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
    /**
     * Returns the SearchBox configuration. The configuration is driven by multiple
     * layers: default configuration, (optional) backend configuration and (optional)
     * input configuration.
     */
    this.config$ = (this.componentData?.data$ || of({})).pipe(map(config => {
      const isBool = (obj, prop) => obj[prop] !== 'false' && obj[prop] !== false;
      return {
        ...DEFAULT_SEARCH_BOX_CONFIG,
        ...config,
        displayProducts: isBool(config, 'displayProducts'),
        displayProductImages: isBool(config, 'displayProductImages'),
        displaySuggestions: isBool(config, 'displaySuggestions'),
        // we're merging the (optional) input of this component, but write the merged
        // result back to the input property, as the view logic depends on it.
        ...this.config
      };
    }), tap(config => this.config = config));
    this.results$ = this.config$.pipe(switchMap(config => this.searchBoxComponentService.getResults(config)));
    this.items$ = this.results$.pipe(map(result => result.products?.map(prod => of(prod))));
    useFeatureStyles('a11ySearchboxLabel');
    useFeatureStyles('a11yKeyboardFocusInSearchBox');
  }
  ngOnInit() {
    const routeStateSubscription = this.routingService.getRouterState().pipe(filter(data => !data.nextState)).subscribe(data => {
      if (!(data.state.context?.id === 'search' && data.state.context?.type === PageType.CONTENT_PAGE)) {
        this.updateChosenWord('');
      }
    });
    this.subscriptions.add(routeStateSubscription);
    const chosenWordSubscription = this.searchBoxComponentService.chosenWord.subscribe(chosenWord => {
      this.updateChosenWord(chosenWord);
    });
    this.subscriptions.add(chosenWordSubscription);
    const UIEventSubscription = this.searchBoxComponentService.sharedEvent.subscribe(event => {
      this.propagateEvent(event);
    });
    this.subscriptions.add(UIEventSubscription);
  }
  /**
   * The Searchbox should not be focusable while not visible.
   */
  getTabIndex(isMobile) {
    if (isMobile) {
      return this.searchBoxActive ? 0 : -1;
    }
    return 0;
  }
  /**
   * Closes the searchBox and opens the search result page.
   */
  search(query) {
    this.searchBoxComponentService.search(query, this.config);
    this.checkOuterResults();
    // force the searchBox to open
    this.open();
  }
  /**
   * Opens the type-ahead searchBox
   */
  open() {
    if (!this.searchBoxActive) {
      this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, true);
      this.searchBoxActive = true;
      this.searchInputEl?.nativeElement.focus();
    }
  }
  /**
   * Dispatch UI events for Suggestion selected
   *
   * @param eventData the data for the event
   */
  dispatchSuggestionEvent(eventData) {
    this.searchBoxComponentService.dispatchSuggestionSelectedEvent(eventData);
  }
  /**
   * Dispatch UI events for Product selected
   *
   * @param eventData the data for the event
   */
  dispatchProductEvent(eventData) {
    this.searchBoxComponentService.dispatchProductSelectedEvent(eventData);
  }
  /**
   * Closes the type-ahead searchBox.
   */
  close(force = false) {
    // Use timeout to detect changes
    setTimeout(() => {
      if (!this.ignoreCloseEvent && !this.isSearchBoxFocused() || force) {
        this.blurSearchBox();
      }
    });
  }
  softClose() {
    this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, false);
    this.searchBoxActive = false;
  }
  blurSearchBox() {
    this.softClose();
    this.searchBoxComponentService.toggleBodyClass(SEARCHBOX_IS_ACTIVE, false);
    this.searchBoxActive = false;
    this.changeDetecorRef?.detectChanges();
    this.searchButton?.nativeElement.focus();
  }
  // Check if focus is on searchbox or result list elements
  isSearchBoxFocused() {
    return this.getResultElements().includes(this.getFocusedElement()) || this.winRef.document.querySelector('input[aria-label="Search"]') === this.getFocusedElement();
  }
  checkOuterResults() {
    const recentSearches = this.elementRef.nativeElement.querySelector('cx-recent-searches .recent-searches');
    const trendingSearches = this.elementRef.nativeElement.querySelector('cx-trending-searches .trending-searches');
    const results = this.elementRef.nativeElement.querySelector('.results');
    if (recentSearches || trendingSearches) {
      this.renderer.addClass(results, 'has-outer-results');
    }
  }
  /**
   * Especially in mobile we do not want the search icon
   * to focus the input again when it's already open.
   * */
  avoidReopen(event) {
    if (this.searchBoxComponentService.hasBodyClass(SEARCHBOX_IS_ACTIVE)) {
      this.close();
      event.preventDefault();
    }
  }
  // Return result list as HTMLElement array
  getResultElements() {
    return Array.from(this.winRef.document.querySelectorAll('.products ul:not(.hidden) > li a, .suggestions ul  > li a, .recent-searches ul > li a,.trending-searches ul > li a, .carousel-panel .item.active > a, .products .carousel-panel > button:not([disabled])'));
  }
  // Return group list as HTMLElement array
  getGroupElements() {
    const groups = [];
    groups.push(Array.from(this.winRef.document.querySelectorAll('.products ul:not(.hidden) > li a')));
    groups.push(Array.from(this.winRef.document.querySelectorAll('.suggestions ul  > li a')));
    groups.push(Array.from(this.winRef.document.querySelectorAll('.trending-searches-container.d-block .trending-searches ul > li a')));
    groups.push(Array.from(this.winRef.document.querySelectorAll('.recent-searches ul > li a')));
    groups.push(Array.from(this.winRef.document.querySelectorAll('.carousel-panel .item.active > a, .carousel-panel > button:not([disabled])')));
    groups.push(Array.from(this.winRef.document.querySelectorAll('.search-panel-close-btn')));
    return groups.filter(group => group.length);
  }
  // Return focused element as HTMLElement
  getFocusedElement() {
    return this.winRef.document.activeElement;
  }
  updateChosenWord(chosenWord) {
    this.chosenWord = chosenWord;
    if (this.searchInputEl) {
      this.searchInputEl.nativeElement.value = this.chosenWord;
    }
  }
  getFocusedIndex() {
    return this.getResultElements().indexOf(this.getFocusedElement());
  }
  getFocusedGroupIndex() {
    return this.getGroupElements().findIndex(group => group.indexOf(this.getFocusedElement()) !== -1) ?? 0;
  }
  propagateEvent(event) {
    if (event.code) {
      switch (event.code) {
        case 'Escape':
        case 'Enter':
          this.close(true);
          return;
        case 'ArrowUp':
          this.focusPreviousChild(event);
          return;
        case 'ArrowDown':
          this.focusNextChild(event);
          return;
        case 'ArrowLeft':
          this.focusPreviousGroup(event);
          return;
        case 'ArrowRight':
          this.focusNextGroup(event);
          return;
        default:
          return;
      }
    } else if (event.type === 'blur') {
      this.close();
    }
  }
  // Focus on previous item in results list
  focusPreviousChild(event) {
    event.preventDefault(); // Negate normal keyscroll
    const [results, focusedIndex] = [this.getResultElements(), this.getFocusedIndex()];
    // Focus on last index moving to first
    if (results.length) {
      if (focusedIndex < 1) {
        results[results.length - 1].focus();
      } else {
        results[focusedIndex - 1].focus();
      }
    }
  }
  // Focus on next item in results list
  focusNextChild(event) {
    this.open();
    event.preventDefault(); // Negate normal keyscroll
    const [results, focusedIndex] = [this.getResultElements(), this.getFocusedIndex()];
    // Focus on first index moving to last
    if (results.length) {
      if (this.featureConfigService?.isEnabled('a11ySearchableDropdownFirstElementFocus')) {
        this.winRef.document.querySelector('header')?.classList.remove('mouse-focus');
      }
      if (focusedIndex >= results.length - 1) {
        results[0].focus();
      } else {
        results[focusedIndex + 1].focus();
      }
    }
  }
  // Focus on previous item in results list
  focusPreviousGroup(event) {
    event.preventDefault(); // Prevent default key scrolling behavior
    const results = this.getGroupElements(); // Get all group elements
    const focusedGroupIndex = this.getFocusedGroupIndex(); // Get the currently focused group index
    // Check if there are any groups and if the focused index is valid
    if (!results.length || focusedGroupIndex < 0 || focusedGroupIndex >= results.length) {
      return; // Exit if no groups or invalid focused index
    }
    // Check if the current group contains any elements
    const currentGroup = results[focusedGroupIndex];
    if (currentGroup.length === 0) {
      return; // If the current group is empty, exit the function
    }
    // Set focus on the appropriate group
    const previousGroupIndex = focusedGroupIndex > 0 ? focusedGroupIndex - 1 : 0;
    const previousGroup = results[previousGroupIndex];
    // Check if the previous group contains any elements
    if (previousGroup.length > 0) {
      previousGroup[0].focus(); // Focus on the first element of the previous group
    }
  }
  // Focus on next item in results list
  focusNextGroup(event) {
    this.open(); // Ensure the dropdown or UI is open before navigating
    event.preventDefault(); // Prevent default key scrolling behavior
    const results = this.getGroupElements(); // Get all group elements
    const focusedGroupIndex = this.getFocusedGroupIndex(); // Get the current focused group index
    // Check if there are any groups and if the focused index is valid
    if (!results.length || focusedGroupIndex < 0 || focusedGroupIndex >= results.length) {
      return; // Exit if no groups or invalid focused index
    }
    // Find the next group that contains elements
    let nextGroupIndex = focusedGroupIndex + 1;
    // Loop forward through groups until a non-empty group is found
    while (nextGroupIndex < results.length && results[nextGroupIndex].length === 0) {
      nextGroupIndex++; // Keep moving to the next group if current one is empty
    }
    // If no next group with elements was found, wrap around to the first group
    if (nextGroupIndex >= results.length) {
      nextGroupIndex = 0; // Move focus to the first group
      if (results[nextGroupIndex].length === 0) {
        return; // Exit if the first group is also empty
      }
    }
    // Set focus on the first element of the next (or first) non-empty group
    results[nextGroupIndex][0].focus();
  }
  carouselEventPropagator(event) {
    if (!event || !event?.code) {
      return;
    }
    switch (event.code) {
      case 'ArrowRight':
        this.focusNextChild(event);
        return;
      case 'ArrowLeft':
        {
          this.getGroupElements().forEach(group => {
            if (group.indexOf(this.getFocusedElement()) !== -1) {
              if (group.indexOf(this.getFocusedElement()) === 0) {
                this.focusPreviousGroup(event);
              } else {
                this.focusPreviousChild(event);
              }
            }
          });
          return;
        }
      case 'ArrowUp':
        this.focusNextGroup(event);
        return;
      default:
        return;
    }
  }
  /**
   * Opens the PLP with the given query.
   *
   * TODO: if there's a single product match, we could open the PDP.
   */
  launchSearchResult(query) {
    if (!query || query.trim().length === 0) {
      return;
    }
    this.close();
    this.searchBoxComponentService.launchSearchPage(query);
  }
  /**
   * Disables closing the search result list.
   */
  disableClose() {
    this.ignoreCloseEvent = true;
  }
  preventDefault(ev) {
    ev.preventDefault();
  }
  /**
   * Clears the search box input field
   */
  clear(el) {
    this.disableClose();
    el.value = '';
    this.searchBoxComponentService.clearResults();
    // Use Timeout to run after blur event to prevent the searchbox from closing on mobile
    setTimeout(() => {
      // Retain focus on input lost by clicking on icon
      el.focus();
      this.ignoreCloseEvent = false;
    });
  }
  isEnabledFeature(feature) {
    return this.featureConfigService?.isEnabled(feature);
  }
  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
  }
  static {
    this.ɵfac = function SearchBoxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SearchBoxComponent)(i0.ɵɵdirectiveInject(SearchBoxComponentService), i0.ɵɵdirectiveInject(CmsComponentData, 8), i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(i1.RoutingService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SearchBoxComponent,
      selectors: [["cx-searchbox"]],
      viewQuery: function SearchBoxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c55, 5);
          i0.ɵɵviewQuery(_c56, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchInputEl = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchButton = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function SearchBoxComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function SearchBoxComponent_click_HostBindingHandler($event) {
            return ctx.clickout($event);
          }, false, i0.ɵɵresolveDocument)("keydown.escape", function SearchBoxComponent_keydown_escape_HostBindingHandler() {
            return ctx.onEscape();
          });
        }
        if (rf & 2) {
          i0.ɵɵclassProp("search-box-v2", ctx.searchBoxV2);
        }
      },
      inputs: {
        config: "config",
        queryText: "queryText"
      },
      standalone: false,
      decls: 4,
      vars: 5,
      consts: [["searchInput", ""], ["searchButton", ""], ["carouselItem", ""], ["role", "search", 4, "cxFeature"], ["role", "search", "class", "cx-searchbox-container", 4, "cxFeature"], ["class", "results", "id", "results", 3, "no-headers", "click", 4, "ngIf"], ["role", "search"], [1, "searchbox"], ["autocomplete", "off", "aria-describedby", "initialDescription", "aria-controls", "results", 3, "click", "input", "blur", "keydown.tab", "keydown.escape", "keydown.enter", "keydown.arrowup", "keydown.arrowdown", "placeholder", "value"], [1, "reset", 3, "click", "title"], [3, "type"], ["role", "presentation", 1, "search-icon", 3, "title"], [1, "search", 3, "click", "title"], ["role", "search", 1, "cx-searchbox-container"], [1, "searchbox", "cxFeat_a11ySearchboxLabel"], [1, "cx-input-label"], [1, "cx-label-inner-container"], ["id", "results", 1, "results", 3, "click"], ["class", "btn btn-tertiary search-panel-close-btn", 3, "keydown.arrowdown", "click", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], ["class", "suggestions", 4, "ngIf"], [1, "trending-searches-container"], [4, "ngIf"], [1, "products"], ["role", "listbox", 3, "hidden", 4, "ngIf"], ["class", "search-panel-header", 3, "d-none", "header-panel-divider", 4, "ngIf"], ["id", "initialDescription", 1, "cx-visually-hidden"], ["aria-live", "assertive", "class", "cx-visually-hidden", 4, "ngIf"], [1, "btn", "btn-tertiary", "search-panel-close-btn", 3, "keydown.arrowdown", "click"], [3, "innerHTML"], [1, "suggestions"], ["tabindex", "0", "role", "listbox"], ["role", "option", 4, "ngFor", "ngForOf"], ["role", "option"], ["role", "option", 3, "keydown.arrowup", "keydown.arrowdown", "keydown.arrowleft", "keydown.arrowright", "keydown.enter", "keydown.escape", "blur", "mousedown", "click", "innerHTML", "routerLink"], [4, "cxFeature"], [3, "cxOutlet", "cxOutletContext"], ["role", "listbox"], ["role", "option", 3, "keydown.arrowup", "keydown.arrowdown", "keydown.arrowleft", "keydown.arrowright", "keydown.enter", "keydown.escape", "blur", "mousedown", "click", "routerLink"], ["format", "thumbnail", "role", "presentation", 3, "container", 4, "ngIf"], [1, "name", 3, "innerHTML"], [1, "price"], ["format", "thumbnail", "role", "presentation", 3, "container"], ["role", "region", "itemWidth", "160px", 3, "keybordEvent", "items", "template"], ["tabindex", "0", 3, "keydown.enter", "keydown.escape", "keydown.arrowleft", "keydown.arrowright", "keydown.arrowup", "mousedown", "click", "routerLink"], ["tabindex", "0", "format", "product", 3, "container", "alt"], [1, "cx-product-name", 3, "innerHtml"], [1, "actions"], ["cxInnerComponentsHost", ""], [1, "search-panel-header"], ["class", "search-panel-message", 3, "innerHTML", 4, "ngIf"], [1, "search-panel-message", 3, "innerHTML"], [1, "suggestions-header"], ["class", "trendingSearches-header", 4, "ngIf"], [1, "recentSearches-header"], ["class", "products-header", 4, "ngIf"], [1, "trendingSearches-header"], [1, "products-header"], ["aria-live", "assertive", 1, "cx-visually-hidden"]],
      template: function SearchBoxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, SearchBoxComponent_div_0_Template, 20, 33, "div", 3)(1, SearchBoxComponent_div_1_Template, 23, 33, "div", 4)(2, SearchBoxComponent_div_2_Template, 17, 19, "div", 5);
          i0.ɵɵpipe(3, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("cxFeature", "!a11ySearchboxLabel");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "a11ySearchboxLabel");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 3, ctx.results$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i1$2.RouterLink, MediaComponent, IconComponent, OutletDirective, i1.FeatureDirective, CarouselComponent, i3.AsyncPipe, i1.UrlPipe, i1.TranslatePipe, HighlightPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBoxComponent, [{
    type: Component,
    args: [{
      selector: 'cx-searchbox',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  *cxFeature=\"'!a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n>\n  <label class=\"searchbox\" [class.dirty]=\"!!searchInput.value\">\n    <input\n      #searchInput\n      [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n      autocomplete=\"off\"\n      aria-describedby=\"initialDescription\"\n      aria-controls=\"results\"\n      [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n      [attr.aria-label]=\"'searchBox.placeholder' | cxTranslate\"\n      (click)=\"search(searchInput.value)\"\n      (input)=\"search(searchInput.value)\"\n      (blur)=\"close()\"\n      (keydown.tab)=\"close()\"\n      (keydown.escape)=\"close()\"\n      (keydown.enter)=\"\n        close(true);\n        launchSearchResult(searchInput.value);\n        updateChosenWord(searchInput.value)\n      \"\n      (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n      (keydown.arrowdown)=\"focusNextChild($any($event))\"\n      value=\"{{ chosenWord }}\"\n    />\n\n    <button\n      [attr.aria-label]=\"'common.reset' | cxTranslate\"\n      [title]=\"'common.reset' | cxTranslate\"\n      (click)=\"clear(searchInput)\"\n      class=\"reset\"\n    >\n      <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n    </button>\n\n    <div\n      role=\"presentation\"\n      class=\"search-icon\"\n      [title]=\"'common.search' | cxTranslate\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </div>\n\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n<div\n  *cxFeature=\"'a11ySearchboxLabel'\"\n  [attr.aria-label]=\"'searchBox.productSearch' | cxTranslate\"\n  role=\"search\"\n  class=\"cx-searchbox-container\"\n>\n  <label\n    class=\"searchbox cxFeat_a11ySearchboxLabel\"\n    [class.dirty]=\"!!searchInput?.value\"\n  >\n    <span class=\"cx-input-label\">{{ 'common.search' | cxTranslate }}</span>\n    <div class=\"cx-label-inner-container\">\n      <input\n        #searchInput\n        [placeholder]=\"'searchBox.placeholder' | cxTranslate\"\n        autocomplete=\"off\"\n        aria-describedby=\"initialDescription\"\n        aria-controls=\"results\"\n        [attr.tabindex]=\"getTabIndex(isMobile | async)\"\n        (click)=\"open()\"\n        (input)=\"search(searchInput.value)\"\n        (blur)=\"close()\"\n        (keydown.tab)=\"close()\"\n        (keydown.escape)=\"close()\"\n        (keydown.enter)=\"\n          close(true);\n          launchSearchResult(searchInput.value);\n          updateChosenWord(searchInput.value)\n        \"\n        (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n        (keydown.arrowdown)=\"focusNextChild($any($event))\"\n        value=\"{{ chosenWord }}\"\n      />\n\n      <button\n        [attr.aria-label]=\"'common.reset' | cxTranslate\"\n        [title]=\"'common.reset' | cxTranslate\"\n        (click)=\"clear(searchInput)\"\n        class=\"reset\"\n      >\n        <cx-icon [type]=\"iconTypes.RESET\"></cx-icon>\n      </button>\n\n      <div\n        role=\"presentation\"\n        class=\"search-icon\"\n        [title]=\"'common.search' | cxTranslate\"\n      >\n        <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n      </div>\n    </div>\n    <button\n      #searchButton\n      [attr.aria-label]=\"'common.search' | cxTranslate\"\n      [title]=\"'common.search' | cxTranslate\"\n      class=\"search\"\n      (click)=\"open()\"\n    >\n      <cx-icon [type]=\"iconTypes.SEARCH\"></cx-icon>\n    </button>\n  </label>\n</div>\n\n<div\n  *ngIf=\"results$ | async as result\"\n  class=\"results\"\n  id=\"results\"\n  (click)=\"close(true)\"\n  [class.no-headers]=\"\n    !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n    !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n  \"\n>\n  <button\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n    class=\"btn btn-tertiary search-panel-close-btn\"\n    (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n    (click)=\"close()\"\n  >\n    {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n  </button>\n  <h3 *ngIf=\"result.message\" [innerHTML]=\"result.message\"></h3>\n  <!--RESULT SUGGESTIONS-->\n  <div\n    class=\"suggestions\"\n    *ngIf=\"(searchInputEl?.nativeElement?.value ?? '').length > 0\"\n  >\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3>\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      tabindex=\"0\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelSuggestions' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.no-headers]=\"\n        !isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) &&\n        !isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <li *ngFor=\"let suggestion of result.suggestions\" role=\"option\">\n        <a\n          role=\"option\"\n          [innerHTML]=\"\n            suggestion | cxHighlight: searchInputEl?.nativeElement?.value\n          \"\n          [routerLink]=\"\n            {\n              cxRoute: 'search',\n              params: { query: suggestion },\n            } | cxUrl\n          \"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchSuggestionEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              selectedSuggestion: suggestion,\n              searchSuggestions: result.suggestions ?? [],\n            });\n            updateChosenWord(suggestion)\n          \"\n        >\n        </a>\n      </li>\n    </ul>\n  </div>\n\n  <!--  TRENDING SEARCHES-->\n  <div\n    class=\"trending-searches-container\"\n    [class.d-block]=\"searchInputEl?.nativeElement?.value?.length === 0\"\n  >\n    <ng-container *ngIf=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n      <ng-container *cxFeature=\"searchBoxFeatures.TRENDING_SEARCHES_FEATURE\">\n        <ng-template\n          [cxOutlet]=\"searchBoxOutlets.TRENDING_SEARCHES\"\n          [cxOutletContext]=\"{\n            maxTrendingSearches: config.maxTrendingSearches,\n          }\"\n        ></ng-template>\n      </ng-container>\n    </ng-container>\n  </div>\n\n  <!--  RECENT SEARCHES-->\n  <ng-template\n    *ngIf=\"config.recentSearches\"\n    [cxOutlet]=\"searchBoxOutlets.RECENT_SEARCHES\"\n    [cxOutletContext]=\"{\n      search: searchInputEl?.nativeElement?.value ?? '',\n      searchBoxActive: searchBoxActive,\n      maxRecentSearches: config.maxRecentSearches,\n    }\"\n  ></ng-template>\n  <!--RESULT  PRODUCTS-->\n  <div class=\"products\">\n    <ng-container\n      *ngIf=\"\n        isEnabledFeature(searchBoxFeatures.TRENDING_SEARCHES_FEATURE) ||\n        isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\n      \"\n    >\n      <h3 *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <ul\n      *ngIf=\"result.products\"\n      attr.aria-label=\"{{ 'searchBox.ariaLabelProducts' | cxTranslate }}\"\n      role=\"listbox\"\n      [class.hidden]=\"hasSearchBoxV2\"\n    >\n      <li *ngFor=\"let product of result.products\" role=\"option\">\n        <a\n          role=\"option\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.arrowup)=\"focusPreviousChild($any($event))\"\n          (keydown.arrowdown)=\"focusNextChild($any($event))\"\n          (keydown.arrowleft)=\"focusPreviousGroup($any($event))\"\n          (keydown.arrowright)=\"focusNextGroup($any($event))\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (blur)=\"close()\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            *ngIf=\"config.displayProductImages\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"thumbnail\"\n            role=\"presentation\"\n          ></cx-media>\n          <div class=\"name\" [innerHTML]=\"product.nameHtml\"></div>\n          <span class=\"price\">{{ product.price?.formattedValue }}</span>\n        </a>\n      </li>\n    </ul>\n    <ng-container *ngIf=\"items$ | async as items\">\n      <cx-carousel\n        role=\"region\"\n        [items]=\"items\"\n        [template]=\"carouselItem\"\n        itemWidth=\"160px\"\n        (keybordEvent)=\"carouselEventPropagator($event)\"\n      >\n      </cx-carousel>\n\n      <ng-template #carouselItem let-product=\"item\">\n        <a\n          tabindex=\"0\"\n          [routerLink]=\"\n            {\n              cxRoute: 'product',\n              params: product,\n            } | cxUrl\n          \"\n          [class.has-media]=\"config.displayProductImages\"\n          (keydown.enter)=\"close(true)\"\n          (keydown.escape)=\"close(true)\"\n          (keydown.arrowleft)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowright)=\"carouselEventPropagator($any($event))\"\n          (keydown.arrowup)=\"carouselEventPropagator($any($event))\"\n          (mousedown)=\"preventDefault($event)\"\n          (click)=\"\n            dispatchProductEvent({\n              freeText: searchInputEl?.nativeElement?.value,\n              productCode: product.code,\n            })\n          \"\n        >\n          <cx-media\n            tabindex=\"0\"\n            [container]=\"product.images?.PRIMARY\"\n            format=\"product\"\n            [alt]=\"product.name ?? ''\"\n          ></cx-media>\n          <h3 class=\"cx-product-name\" [innerHtml]=\"product.nameHtml\"></h3>\n          <div class=\"price\">\n            {{ product.price?.formattedValue }}\n          </div>\n        </a>\n        <div class=\"actions\">\n          <ng-container cxInnerComponentsHost></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </div>\n\n  <div\n    [class.d-none]=\"!hasSearchBoxV2\"\n    class=\"search-panel-header\"\n    [class.header-panel-divider]=\"!result.message\"\n    *ngIf=\"isEnabledFeature(searchBoxFeatures.SEARCH_BOX_V2)\"\n  >\n    <h3\n      class=\"search-panel-message\"\n      *ngIf=\"result.message\"\n      [innerHTML]=\"result.message\"\n    ></h3>\n    <ng-container *ngIf=\"!result.message\">\n      <h3 class=\"suggestions-header\">\n        {{ 'searchBox.suggestions' | cxTranslate }}\n      </h3>\n      <h3\n        class=\"trendingSearches-header\"\n        *ngIf=\"searchInputEl?.nativeElement?.value?.length === 0\"\n      >\n        {{ 'searchBox.trendingSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"recentSearches-header\">\n        {{ 'searchBox.recentSearches' | cxTranslate }}\n      </h3>\n      <h3 class=\"products-header\" *ngIf=\"result.products?.length\">\n        {{ 'searchBox.products' | cxTranslate }}\n      </h3>\n    </ng-container>\n    <button\n      class=\"btn btn-tertiary search-panel-close-btn\"\n      (keydown.arrowdown)=\"focusPreviousGroup($any($event))\"\n      (click)=\"close()\"\n    >\n      {{ 'searchBox.closeSearchPanel' | cxTranslate }}\n    </button>\n  </div>\n\n  <span id=\"initialDescription\" class=\"cx-visually-hidden\">\n    {{ 'searchBox.initialDescription' | cxTranslate }}\n  </span>\n  <div\n    *ngIf=\"result.suggestions?.length || result.products?.length\"\n    aria-live=\"assertive\"\n    class=\"cx-visually-hidden\"\n  >\n    {{\n      'searchBox.suggestionsResult'\n        | cxTranslate: { count: result.suggestions?.length }\n    }}\n    {{\n      'searchBox.productsResult'\n        | cxTranslate: { count: result.products?.length }\n    }}\n    <ng-container *cxFeature=\"'!a11ySearchboxAssistiveMessage'\">\n      {{ 'searchBox.initialDescription' | cxTranslate }}\n    </ng-container>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: SearchBoxComponentService
  }, {
    type: CmsComponentData,
    decorators: [{
      type: Optional
    }]
  }, {
    type: i1.WindowRef
  }, {
    type: i1.RoutingService
  }], {
    config: [{
      type: Input
    }],
    queryText: [{
      type: Input,
      args: ['queryText']
    }],
    searchBoxV2: [{
      type: HostBinding,
      args: ['class.search-box-v2']
    }],
    clickout: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }],
    searchInputEl: [{
      type: ViewChild,
      args: ['searchInput']
    }],
    searchButton: [{
      type: ViewChild,
      args: ['searchButton']
    }],
    onEscape: [{
      type: HostListener,
      args: ['keydown.escape']
    }],
    changeDetecorRef: [{
      type: Optional
    }],
    breakpointService: [{
      type: Optional
    }],
    featureConfigService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ViewConfig {
  static {
    this.ɵfac = function ViewConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ViewConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ViewConfig,
      factory: function ViewConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || ViewConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileDownloadService {
  /**
   * Triggers the browser downloading of the file from the given URL.
   *
   * @param {string} url URL to file.
   * @param {string} [fileName] The optional parameter for defining filename
   * (including the extension) when saving the file.
   */
  download(url, fileName) {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${fileName}`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  static {
    this.ɵfac = function FileDownloadService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileDownloadService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FileDownloadService,
      factory: FileDownloadService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileDownloadService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ExportCsvFileService {
  constructor(fileDownloadService) {
    this.fileDownloadService = fileDownloadService;
  }
  /**
   * Converts array of objects into CSV data structure.
   *
   * @param objectsArray Array of objects which should be converted to CSV.
   * @param separator Separator for CSV data.
   * @returns Processed string ready to be saved into file.
   */
  convert(objectsArray, separator) {
    return objectsArray.reduce((csvString, row) => {
      const line = row.reduce((currentLine, column) => {
        currentLine += currentLine !== '' ? separator : '';
        const cell = column.includes(separator) ? `"${column}"` : column;
        return `${currentLine}${cell}`;
      }, '');
      return `${csvString}${line}\r\n`;
    }, '');
  }
  /**
   * Creates and download CSV file.
   *
   * @param objectsArray Array of objects which should be converted to CSV.
   * @param separator Separator for CSV data.
   * @param fileOptions Exported file options.
   */
  download(objectsArray, separator, fileOptions) {
    const {
      fileName,
      type,
      extension
    } = fileOptions;
    const fileContent = this.convert(objectsArray, separator);
    const blob = new Blob([fileContent], {
      type
    });
    const url = URL.createObjectURL(blob);
    this.fileDownloadService.download(url, `${fileName}.${extension}`);
  }
  static {
    this.ɵfac = function ExportCsvFileService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ExportCsvFileService)(i0.ɵɵinject(FileDownloadService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ExportCsvFileService,
      factory: ExportCsvFileService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ExportCsvFileService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: FileDownloadService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FileReaderService {
  /**
   * Load text file
   *
   * @param file text file to extract the data
   * @returns Observable from file reader
   */
  loadTextFile(file) {
    return new Observable(observer => {
      const fileReader = new FileReader();
      fileReader.readAsText(file);
      fileReader.onload = () => {
        observer.next(fileReader.result);
        observer.complete();
      };
      fileReader.onerror = error => {
        fileReader.abort();
        observer.error(error);
      };
    });
  }
  static {
    this.ɵfac = function FileReaderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FileReaderService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FileReaderService,
      factory: FileReaderService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FileReaderService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ImportCsvFileService {
  constructor(fileReaderService) {
    this.fileReaderService = fileReaderService;
  }
  /**
   * Load CSV file.
   *
   * @param file File we want to load as CSV.
   * @param separator Separator for CSV data.
   * @return {Observable<string[][]>} Imported file
   */
  loadFile(file, separator) {
    return this.fileReaderService.loadTextFile(file).pipe(map(res => this.parse(res, separator)));
  }
  /**
   * Combined csv validation
   *
   * @param file File we want to load as CSV.
   * @param separator Separator for CSV data.
   * @param isDataParsable (optional) Callback for verify that structure type is proper.
   * @param maxEntries (optional) Limitation for maximum entries count.
   * @return {Observable<CsvFileValidationErrors | null>} Result of validation
   */
  validateFile(file, {
    separator,
    isDataParsable,
    maxEntries
  }) {
    const validationErrors = {};
    return this.fileReaderService.loadTextFile(file).pipe(tap(data => {
      this.validateEmpty(data, validationErrors);
    }), map(res => this.parse(res, separator)), tap(data => {
      this.validateNotParsable(data, validationErrors, isDataParsable);
      this.validateTooManyEntries(data, validationErrors, maxEntries);
    }), catchError(errors => of(errors)), map(() => Object.keys(validationErrors).length === 0 ? null : validationErrors));
  }
  /**
   * Processes the CSV data
   *
   * @param csvString raw extracted data from CSV
   * @param separator for csv data
   * @param ignoreHeader (optional) flag allows for ignore headers row while reading
   * @returns {string[][]} Parsed file
   */
  parse(csvString, separator, ignoreHeader = true) {
    return csvString.split('\n').map(row => row.split(separator).map(cell => cell.replace(/"/g, ''))).filter((value, index) => !(ignoreHeader && index === 0) && value[0] !== '');
  }
  validateEmpty(data, errors) {
    if (data.toString().length === 0) {
      errors.empty = true;
      throw errors;
    }
  }
  validateTooManyEntries(data, errors, maxEntries) {
    if (maxEntries && data.length > maxEntries) {
      errors.tooManyEntries = {
        maxEntries
      };
      throw errors;
    }
  }
  validateNotParsable(data, errors, isDataParsable) {
    if (isDataParsable && !isDataParsable(data)) {
      errors.notParsable = true;
      throw errors;
    }
  }
  static {
    this.ɵfac = function ImportCsvFileService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImportCsvFileService)(i0.ɵɵinject(FileReaderService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ImportCsvFileService,
      factory: ImportCsvFileService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportCsvFileService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: FileReaderService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class CustomFormValidators {
  /**
   * Checks control's value with predefined email regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxInvalidEmail' validator error
   * @memberof CustomFormValidators
   */
  static emailValidator(control) {
    const email = control.value;
    return email && (!email.length || email.match(EMAIL_PATTERN)) ? null : {
      cxInvalidEmail: true
    };
  }
  static securePasswordValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(SECURE_PASSWORD_PATTERN)) ? null : {
      cxInvalidPassword: true
    };
  }
  // TODO: (CXSPA-7567) Remove after removing formErrorsDescriptiveMessages feature toggle
  /**
   * Checks control's value with predefined password regexp
   *
   * NOTE: Use it as a control validator
   *
   * @deprecated Use passwordValidators instead
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxInvalidPassword' validator error
   * @memberof CustomFormValidators
   */
  static strongPasswordValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(STRONG_PASSWORD_PATTERN)) ? null : {
      cxInvalidPassword: true
    };
  }
  /**
   * Checks control's value with predefined  at least one upper case character regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxMinOneUpperCaseCharacter' validator error
   * @memberof CustomFormValidators
   */
  static minOneUpperCaseCharacterValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MIN_ONE_UPPER_CASE_CHARACTER_PATTERN)) ? null : {
      cxMinOneUpperCaseCharacter: true
    };
  }
  /**
   * Checks control's value with predefined  at least one upper case character regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxMinOneDigit' validator error
   * @memberof CustomFormValidators
   */
  static minOneDigitValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MIN_ONE_DIGIT_PATTERN)) ? null : {
      cxMinOneDigit: true
    };
  }
  /**
   * Checks control's value with predefined  at least one upper case character regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxMinOneSpecialCharacter' validator error
   * @memberof CustomFormValidators
   */
  static minOneSpecialCharacterValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MIN_ONE_SPECIAL_CHARACTER_PATTERN)) ? null : {
      cxMinOneSpecialCharacter: true
    };
  }
  /**
   * Checks control's value with predefined  at least one upper case character regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxMinSixCharactersLength' validator error
   * @memberof CustomFormValidators
   */
  static minSixCharactersLengthValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MIN_SIX_CHARACTERS_PATTERN)) ? null : {
      cxMinSixCharactersLength: true
    };
  }
  /**
   * Checks control's value with predefined  at least one upper case character regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxMinEightCharactersLength' validator error
   * @memberof CustomFormValidators
   */
  static minEightCharactersLengthValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MIN_EIGHT_CHARACTERS_PATTERN)) ? null : {
      cxMinEightCharactersLength: true
    };
  }
  static maxCharactersLengthValidator(control) {
    const password = control.value;
    return password && (!password.length || password.match(MAX_CHARACTERS_PATTERN)) ? null : {
      cxMaxCharactersLength: true
    };
  }
  /**
   * Validates that the control's value does not contain consecutive identical characters.
   *
   * NOTE: Use this as a control validator.
   *
   * @static
   * @param {AbstractControl} control The form control to validate.
   * @returns {(ValidationErrors | null)} Returns an error object with the key 'cxNoConsecutiveCharacters'
   * if the value contains consecutive characters, or null if the validation passes.
   * @memberof CustomFormValidators
   */
  static noConsecutiveCharacters(control) {
    const password = control.value;
    return password && (!password.length || password.match(CONSECUTIVE_CHARACTERS)) ? {
      cxNoConsecutiveCharacters: true
    } : null;
  }
  /**
   * Pack of predefined password validators:
   * - at least one upper case character
   * - at least one digit
   * - at least one special character
   * - at least six characters length
   *
   * @memberof CustomFormValidators
   */
  static {
    this.passwordValidators = [this.minOneDigitValidator, this.minOneUpperCaseCharacterValidator, this.minOneSpecialCharacterValidator, this.minSixCharactersLengthValidator];
  }
  static {
    this.securePasswordValidators = [this.minOneDigitValidator, this.minOneUpperCaseCharacterValidator, this.minOneSpecialCharacterValidator, this.minEightCharactersLengthValidator, this.maxCharactersLengthValidator, this.noConsecutiveCharacters];
  }
  /**
   * Checks if control's value is between 1 and 5
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxStarRatingEmpty' validator error
   * @memberof CustomFormValidators
   */
  static starRatingEmpty(control) {
    const rating = control.value;
    return rating >= 1 && rating <= 5 ? null : {
      cxStarRatingEmpty: true
    };
  }
  /**
   * Checks if two password controls match
   *
   * NOTE: Use it as a form validator and pass password control names as parameters
   *
   * @static
   * @param {string} password First password control name
   * @param {string} passwordConfirmation Second password control name
   * @returns Uses 'cxPasswordsMustMatch' validator error
   * @memberof CustomFormValidators
   */
  static passwordsMustMatch(password, passwordConfirmation) {
    const validator = formGroup => controlsMustMatch(formGroup, password, passwordConfirmation, 'cxPasswordsMustMatch');
    return validator;
  }
  /**
   * Checks if two password controls don't match
   *
   * NOTE: Use it as a form validator and pass password control names as parameters
   *
   * @static
   * @param {string} password First password control name
   * @param {string} passwordConfirmation Second password control name
   * @returns Uses 'cxPasswordsCannotMatch' validator error
   * @memberof CustomFormValidators
   */
  static passwordsCannotMatch(password, passwordConfirmation) {
    const validator = formGroup => controlsMustMatch(formGroup, password, passwordConfirmation, 'cxPasswordsCannotMatch', true);
    return validator;
  }
  /**
   * Checks if two email controls match
   *
   * NOTE: Use it as a form validator and pass email control names as parameters
   *
   * @static
   * @param {string} email First email control name
   * @param {string} emailConfirmation Second email control name
   * @returns Uses 'cxEmailsMustMatch' validator error
   * @memberof CustomFormValidators
   */
  static emailsMustMatch(email, emailConfirmation) {
    const validator = formGroup => controlsMustMatch(formGroup, email, emailConfirmation, 'cxEmailsMustMatch');
    return validator;
  }
  /**
   * Checks if control's value is euqal or greater than 0
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxNegativeAmount' validator error
   * @memberof CustomFormValidators
   */
  static mustBePositive(control) {
    const amount = control.value;
    return amount >= 0 ? null : {
      cxNegativeAmount: true
    };
  }
  /**
   * Checks if control's value does not contain any special characters
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxContainsSpecialCharacters' validator error
   * @memberof CustomFormValidators
   */
  static noSpecialCharacters(control) {
    const forbiddenChars = ['/'];
    const str = String(control.value);
    const containsSpecialChars = forbiddenChars.some(char => str.includes(char));
    return !containsSpecialChars ? null : {
      cxContainsSpecialCharacters: true
    };
  }
  /**
   * Checks if control's value passes pattern
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {(date: string) => boolean} isValidFormat Pattern verification function
   * @returns {(control: AbstractControl): ValidationErrors | null} Uses 'pattern' validator error
   * @memberof CustomFormValidators
   */
  static patternValidation(isValidFormat) {
    const validator = control => {
      const errors = {};
      if (control.value && control.value !== '' && !isValidFormat(control.value)) {
        errors.pattern = true;
      }
      return Object.keys(errors).length === 0 ? null : errors;
    };
    return validator;
  }
  /**
   * Checks if two email controls match
   *
   * NOTE: Use it as a form validator and pass dates for range
   *
   * @static
   * @param {string} startDateKey First date control name
   * @param {string} endDateKey Second date control name
   * @param {(value: string) => Date} getDate Converting function
   * @returns Uses 'min' and 'max validator error
   * @memberof CustomFormValidators
   */
  static dateRange(startDateKey, endDateKey, getDate) {
    return formGroup => {
      const startDateControl = formGroup.controls[startDateKey];
      const endDateControl = formGroup.controls[endDateKey];
      const startDate = getDate(startDateControl.value);
      const endDate = getDate(endDateControl.value);
      if (startDate && endDate) {
        if (!startDateControl.errors?.pattern) {
          if (startDate > endDate) {
            startDateControl.setErrors({
              max: true
            });
          }
        }
        if (!endDateControl.errors?.pattern) {
          if (endDate < startDate) {
            endDateControl.setErrors({
              min: true
            });
          }
        }
      }
      return null;
    };
  }
}
/**
 * Generic function for validators, which checks if two passed controls match.
 *
 * @param formGroup
 * @param firstControlName First control to check
 * @param secondControlName Second control to check
 * @param errorName Error which will be returned by validator
 * @param cannotMatch Reverse check
 */
function controlsMustMatch(formGroup, firstControlName, secondControlName, errorName, cannotMatch = false) {
  const firstControl = formGroup.controls[firstControlName];
  const secondControl = formGroup.controls[secondControlName];
  if (secondControl.errors && !secondControl.errors[errorName]) {
    return;
  }
  const shouldSetError = cannotMatch ? firstControl.value === secondControl.value : firstControl.value !== secondControl.value;
  secondControl.setErrors(shouldSetError ? {
    [errorName]: true
  } : null);
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const titleScores = {
  mr: 1,
  mrs: 2,
  miss: 3,
  ms: 4,
  dr: 5,
  rev: 6
};
function sortTitles(title1, title2) {
  if (title1.code && title2.code) {
    if (!titleScores[title1.code] || !titleScores[title2.code]) {
      return 1;
    } else {
      return titleScores[title1.code] - titleScores[title2.code];
    }
  }
  return 1;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class SearchBoxModule {
  static {
    this.ɵfac = function SearchBoxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SearchBoxModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: SearchBoxModule,
      declarations: [SearchBoxComponent, HighlightPipe],
      imports: [CommonModule, RouterModule, MediaModule, IconModule, UrlModule, I18nModule, OutletModule, FeaturesConfigModule, CarouselModule, KeyboardFocusModule],
      exports: [SearchBoxComponent, HighlightPipe]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          SearchBoxComponent: {
            component: SearchBoxComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, MediaModule, IconModule, UrlModule, I18nModule, OutletModule, FeaturesConfigModule, CarouselModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBoxModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, MediaModule, IconModule, UrlModule, I18nModule, OutletModule, FeaturesConfigModule, CarouselModule, KeyboardFocusModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          SearchBoxComponent: {
            component: SearchBoxComponent
          }
        }
      })],
      declarations: [SearchBoxComponent, HighlightPipe],
      exports: [SearchBoxComponent, HighlightPipe]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScrollToTopComponent {
  constructor(winRef, componentData, selectFocusUtility) {
    this.winRef = winRef;
    this.componentData = componentData;
    this.selectFocusUtility = selectFocusUtility;
    this.iconTypes = ICON_TYPE;
    this.window = this.winRef.nativeWindow;
    this.scrollBehavior = ScrollBehavior.SMOOTH;
    this.displayThreshold = (this.window?.innerHeight ?? 400) / 2;
    this.triggedByKeypress = false;
  }
  ngOnInit() {
    this.setConfig();
  }
  onScroll() {
    this.switchDisplay();
  }
  /**
   * Scroll back to the top of the page, and recognize if triggerd by keyboard.
   */
  scrollToTop(event) {
    this.window?.scrollTo({
      top: 0,
      behavior: this.scrollBehavior
    });
    this.triggedByKeypress = event?.detail === 0;
  }
  onFocusOut() {
    if (this.display) {
      this.switchDisplay();
    }
  }
  /**
   * After scrolling to top, pressing Tab should focus first focusable element within body.
   */
  onTab(event) {
    const tabEvent = event;
    const scrollToTopHasFocus = document.activeElement === this.button.nativeElement;
    const isAtTopOfPage = this.window?.scrollY === 0;
    if (scrollToTopHasFocus && isAtTopOfPage && tabEvent.key === 'Tab' && !tabEvent.shiftKey) {
      event.preventDefault();
      this.selectFocusUtility.findFirstFocusable(this.winRef.document.body, {
        autofocus: ''
      })?.focus();
    }
  }
  setConfig() {
    this.componentData.data$.pipe(take(1)).subscribe(data => {
      this.scrollBehavior = data.scrollBehavior ?? this.scrollBehavior;
      this.displayThreshold = data.displayThreshold ?? this.displayThreshold;
    });
  }
  /**
   * This methods decides when the ScrollToTop button should be displayed.
   */
  switchDisplay() {
    const isPastThreshold = this.window && this.window.scrollY > this.displayThreshold;
    const buttonHasFocus = this.button.nativeElement === document.activeElement;
    this.display = isPastThreshold || this.triggedByKeypress && buttonHasFocus;
    if (!this.display) {
      this.triggedByKeypress = false;
    }
  }
  static {
    this.ɵfac = function ScrollToTopComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScrollToTopComponent)(i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(SelectFocusUtility));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ScrollToTopComponent,
      selectors: [["cx-scroll-to-top"]],
      viewQuery: function ScrollToTopComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c61, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
        }
      },
      hostVars: 2,
      hostBindings: function ScrollToTopComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("scroll", function ScrollToTopComponent_scroll_HostBindingHandler($event) {
            return ctx.onScroll($event);
          }, false, i0.ɵɵresolveWindow);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("display", ctx.display);
        }
      },
      standalone: false,
      decls: 6,
      vars: 7,
      consts: [["button", ""], [1, "cx-scroll-to-top-btn", 3, "click", "focusout", "keydown.Tab", "title"], ["aria-hidden", "true"], [1, "caret-up-icon", 3, "type"]],
      template: function ScrollToTopComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "button", 1, 0);
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵlistener("click", function ScrollToTopComponent_Template_button_click_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.scrollToTop($event));
          })("focusout", function ScrollToTopComponent_Template_button_focusout_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onFocusOut());
          })("keydown.Tab", function ScrollToTopComponent_Template_button_keydown_Tab_0_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onTab($event));
          });
          i0.ɵɵelementStart(4, "span", 2);
          i0.ɵɵelement(5, "cx-icon", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 3, "navigation.scrollToTop"));
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(3, 5, "navigation.scrollToTop"));
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("type", ctx.iconTypes.CARET_UP);
        }
      },
      dependencies: [IconComponent, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScrollToTopComponent, [{
    type: Component,
    args: [{
      selector: 'cx-scroll-to-top',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  #button\n  [attr.aria-label]=\"'navigation.scrollToTop' | cxTranslate\"\n  [title]=\"'navigation.scrollToTop' | cxTranslate\"\n  class=\"cx-scroll-to-top-btn\"\n  (click)=\"scrollToTop($event)\"\n  (focusout)=\"onFocusOut()\"\n  (keydown.Tab)=\"onTab($event)\"\n>\n  <span aria-hidden=\"true\">\n    <cx-icon class=\"caret-up-icon\" [type]=\"iconTypes.CARET_UP\"></cx-icon>\n  </span>\n</button>\n"
    }]
  }], () => [{
    type: i1.WindowRef
  }, {
    type: CmsComponentData
  }, {
    type: SelectFocusUtility
  }], {
    display: [{
      type: HostBinding,
      args: ['class.display']
    }],
    button: [{
      type: ViewChild,
      args: ['button']
    }],
    onScroll: [{
      type: HostListener,
      args: ['window:scroll', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ScrollToTopModule {
  static {
    this.ɵfac = function ScrollToTopModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScrollToTopModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ScrollToTopModule,
      declarations: [ScrollToTopComponent],
      imports: [CommonModule, IconModule, I18nModule],
      exports: [ScrollToTopComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ScrollToTopComponent: {
            component: ScrollToTopComponent
          }
        }
      })],
      imports: [CommonModule, IconModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScrollToTopModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, IconModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ScrollToTopComponent: {
            component: ScrollToTopComponent
          }
        }
      })],
      declarations: [ScrollToTopComponent],
      exports: [ScrollToTopComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NavigationComponent extends NavigationComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2NavigationComponent_BaseFactory;
      return function MyAccountV2NavigationComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2NavigationComponent_BaseFactory || (ɵMyAccountV2NavigationComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2NavigationComponent)))(__ngFactoryType__ || MyAccountV2NavigationComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2NavigationComponent,
      selectors: [["cx-my-account-v2-navigation"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 3,
      consts: [[3, "node", "flyout", "ngClass", "navAriaLabel", "focusableNodeTitles", 4, "ngIf"], [3, "node", "flyout", "ngClass", "navAriaLabel", "focusableNodeTitles"]],
      template: function MyAccountV2NavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2NavigationComponent_cx_navigation_ui_0_Template, 3, 9, "cx-navigation-ui", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.node$));
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, NavigationUIComponent, i3.AsyncPipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2NavigationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-navigation',
      standalone: false,
      template: "<cx-navigation-ui\n  *ngIf=\"node$ | async as node\"\n  [node]=\"node\"\n  [flyout]=\"false\"\n  [ngClass]=\"(styleClass$ | async) ?? ''\"\n  [navAriaLabel]=\"name$ | async\"\n  [focusableNodeTitles]=\"true\"\n></cx-navigation-ui>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NavigationModule {
  static {
    this.ɵfac = function MyAccountV2NavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2NavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2NavigationModule,
      declarations: [MyAccountV2NavigationComponent],
      imports: [CommonModule, NavigationModule, I18nModule],
      exports: [MyAccountV2NavigationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountSideNavigationComponent: {
            component: MyAccountV2NavigationComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, NavigationModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2NavigationModule, [{
    type: NgModule,
    args: [{
      providers: [provideDefaultConfig({
        cmsComponents: {
          MyAccountSideNavigationComponent: {
            component: MyAccountV2NavigationComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [MyAccountV2NavigationComponent],
      exports: [MyAccountV2NavigationComponent],
      imports: [CommonModule, NavigationModule, I18nModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2Module {
  static {
    this.ɵfac = function MyAccountV2Module_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2Module)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2Module,
      imports: [MyAccountV2NavigationModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MyAccountV2NavigationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2Module, [{
    type: NgModule,
    args: [{
      imports: [MyAccountV2NavigationModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NotificationPreferenceComponent extends NotificationPreferenceComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵMyAccountV2NotificationPreferenceComponent_BaseFactory;
      return function MyAccountV2NotificationPreferenceComponent_Factory(__ngFactoryType__) {
        return (ɵMyAccountV2NotificationPreferenceComponent_BaseFactory || (ɵMyAccountV2NotificationPreferenceComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MyAccountV2NotificationPreferenceComponent)))(__ngFactoryType__ || MyAccountV2NotificationPreferenceComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MyAccountV2NotificationPreferenceComponent,
      selectors: [["cx-my-account-v2-notification-preference"]],
      standalone: false,
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 2,
      vars: 3,
      consts: [["loading", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "np-row", "np-flex", "np-content-center"], [1, "col-md-8"], [1, "header"], [1, "pref-info"], [1, "form-check", "cx-notification-channels"], [4, "ngFor", "ngForOf"], ["role", "status"], ["class", "pref-channel", 4, "ngIf"], [1, "pref-channel"], ["role", "checkbox", "type", "checkbox", 1, "form-check-input", "cx-np-checkbox", 3, "change", "checked", "disabled"], [1, "form-check-label"], [1, "cx-spinner"]],
      template: function MyAccountV2NotificationPreferenceComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MyAccountV2NotificationPreferenceComponent_ng_container_0_Template, 4, 2, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.preferences$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SpinnerComponent, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2NotificationPreferenceComponent, [{
    type: Component,
    args: [{
      selector: 'cx-my-account-v2-notification-preference',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"preferences$ | async as preferences\">\n  <div *ngIf=\"preferences.length > 0; else loading\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <div class=\"np-row np-flex np-content-center\">\n      <div class=\"col-md-8\">\n        <div class=\"header\">\n          {{ 'myAccountV2NotificationPreference.header' | cxTranslate }}\n        </div>\n        <div class=\"pref-info\">\n          {{ 'myAccountV2NotificationPreference.message' | cxTranslate }}\n        </div>\n        <div class=\"form-check cx-notification-channels\">\n          <ng-container *ngFor=\"let preference of preferences\">\n            <label *ngIf=\"preference.visible\" class=\"pref-channel\">\n              <input\n                class=\"form-check-input cx-np-checkbox\"\n                role=\"checkbox\"\n                type=\"checkbox\"\n                [checked]=\"preference.enabled\"\n                (change)=\"updatePreference(preference)\"\n                [disabled]=\"isLoading$ | async\"\n              />\n              <span class=\"form-check-label\">\n                {{\n                  'myAccountV2NotificationPreference.' + preference.channel\n                    | cxTranslate\n                }}\n                {{ preference.value }}\n              </span>\n            </label>\n          </ng-container>\n        </div>\n        <label\n          ><strong>{{\n            'myAccountV2NotificationPreference.note' | cxTranslate\n          }}</strong\n          >{{ 'myAccountV2NotificationPreference.noteMessage' | cxTranslate }}\n        </label>\n      </div>\n    </div>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </ng-template>\n</ng-container>\n"
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class MyAccountV2NotificationPreferenceModule {
  static {
    this.ɵfac = function MyAccountV2NotificationPreferenceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MyAccountV2NotificationPreferenceModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MyAccountV2NotificationPreferenceModule,
      declarations: [MyAccountV2NotificationPreferenceComponent],
      imports: [CommonModule, SpinnerModule, I18nModule, i1$2.RouterModule, FeaturesConfigModule],
      exports: [MyAccountV2NotificationPreferenceComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SpinnerModule, I18nModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'notificationPreference'
        }
      }]), FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MyAccountV2NotificationPreferenceModule, [{
    type: NgModule,
    args: [{
      declarations: [MyAccountV2NotificationPreferenceComponent],
      imports: [CommonModule, SpinnerModule, I18nModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'notificationPreference'
        }
      }]), FeaturesConfigModule],
      exports: [MyAccountV2NotificationPreferenceComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const myAccountV2CmsMapping = {
  cmsComponents: {
    NotificationPreferenceComponent: {
      component: MyAccountV2NotificationPreferenceComponent
      //guards: inherited from standard config,
    }
  }
};
class NotificationPreferenceModule {
  static {
    this.ɵfac = function NotificationPreferenceModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NotificationPreferenceModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NotificationPreferenceModule,
      declarations: [NotificationPreferenceComponent],
      imports: [CommonModule, SpinnerModule, I18nModule, FeaturesConfigModule, i1$2.RouterModule],
      exports: [NotificationPreferenceComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          NotificationPreferenceComponent: {
            component: NotificationPreferenceComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE) ? myAccountV2CmsMapping : {})],
      imports: [CommonModule, SpinnerModule, I18nModule, FeaturesConfigModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'notificationPreference'
        }
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationPreferenceModule, [{
    type: NgModule,
    args: [{
      declarations: [NotificationPreferenceComponent],
      imports: [CommonModule, SpinnerModule, I18nModule, FeaturesConfigModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'notificationPreference'
        }
      }])],
      providers: [provideDefaultConfig({
        cmsComponents: {
          NotificationPreferenceComponent: {
            component: NotificationPreferenceComponent,
            guards: [AuthGuard]
          }
        }
      }), provideDefaultConfigFactory(() => inject(USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE) ? myAccountV2CmsMapping : {})],
      exports: [NotificationPreferenceComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaymentMethodsComponent {
  constructor(userPaymentService, translation, globalMessageService) {
    this.userPaymentService = userPaymentService;
    this.translation = translation;
    this.globalMessageService = globalMessageService;
    this.iconTypes = ICON_TYPE;
  }
  ngOnInit() {
    this.paymentMethods$ = this.userPaymentService.getPaymentMethods().pipe(tap(paymentDetails => {
      // Set first payment method to DEFAULT if none is set
      if (paymentDetails.length > 0 && !paymentDetails.find(paymentDetail => paymentDetail.defaultPayment)) {
        this.setDefaultPaymentMethod(paymentDetails[0]);
      }
    }));
    this.editCard = undefined;
    this.loading$ = this.userPaymentService.getPaymentMethodsLoading();
    this.userPaymentService.loadPaymentMethods();
  }
  getCardContent({
    defaultPayment,
    accountHolderName,
    expiryMonth,
    expiryYear,
    cardNumber,
    cardType
  }) {
    return combineLatest([this.translation.translate('paymentCard.setAsDefault'), this.translation.translate('common.delete'), this.translation.translate('paymentCard.deleteConfirmation'), this.translation.translate('paymentCard.expires', {
      month: expiryMonth,
      year: expiryYear
    }), this.translation.translate('paymentCard.defaultPaymentMethod')]).pipe(map(([textSetAsDefault, textDelete, textDeleteConfirmation, textExpires, textDefaultPaymentMethod]) => {
      const actions = [];
      if (!defaultPayment) {
        actions.push({
          name: textSetAsDefault,
          event: 'default'
        });
      }
      actions.push({
        name: textDelete,
        event: 'edit'
      });
      const card = {
        role: 'application',
        header: defaultPayment ? textDefaultPaymentMethod : undefined,
        textBold: accountHolderName,
        text: [cardNumber ?? '', textExpires],
        actions,
        deleteMsg: textDeleteConfirmation,
        img: this.getCardIcon(cardType?.code ?? ''),
        imgLabel: this.getCardIconLabel(cardType?.code),
        label: defaultPayment ? 'paymentCard.defaultPaymentLabel' : 'paymentCard.additionalPaymentLabel'
      };
      return card;
    }));
  }
  deletePaymentMethod(paymentMethod) {
    if (paymentMethod.id) {
      this.userPaymentService.deletePaymentMethod(paymentMethod.id);
      this.editCard = undefined;
    }
  }
  setEdit(paymentMethod) {
    this.editCard = paymentMethod.id;
  }
  cancelCard() {
    this.editCard = undefined;
  }
  setDefaultPaymentMethod(paymentMethod) {
    this.userPaymentService.setPaymentMethodAsDefault(paymentMethod.id ?? '');
    this.globalMessageService?.add({
      key: 'paymentMessages.setAsDefaultSuccessfully'
    }, GlobalMessageType.MSG_TYPE_CONFIRMATION);
  }
  getCardIcon(code) {
    let ccIcon;
    if (code === 'visa') {
      ccIcon = this.iconTypes.VISA;
    } else if (code === 'master' || code === 'mastercard_eurocard') {
      ccIcon = this.iconTypes.MASTER_CARD;
    } else if (code === 'diners') {
      ccIcon = this.iconTypes.DINERS_CLUB;
    } else if (code === 'amex') {
      ccIcon = this.iconTypes.AMEX;
    } else {
      ccIcon = this.iconTypes.CREDIT_CARD;
    }
    return ccIcon;
  }
  getCardIconLabel(code) {
    let ccIconLabel;
    if (code === 'visa') {
      ccIconLabel = 'paymentCard.visa';
    } else if (code === 'master') {
      ccIconLabel = 'paymentCard.master';
    } else if (code === 'mastercard_eurocard') {
      ccIconLabel = 'paymentCard.masterEuro';
    } else if (code === 'diners') {
      ccIconLabel = 'paymentCard.dinersClub';
    } else if (code === 'amex') {
      ccIconLabel = 'paymentCard.amex';
    } else if (code === 'switch') {
      ccIconLabel = 'paymentCard.switch';
    } else if (code === 'maestro') {
      ccIconLabel = 'paymentCard.maestro';
    } else {
      ccIconLabel = 'paymentCard.credit';
    }
    return ccIconLabel;
  }
  static {
    this.ɵfac = function PaymentMethodsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentMethodsComponent)(i0.ɵɵdirectiveInject(i1.UserPaymentService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i1.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PaymentMethodsComponent,
      selectors: [["cx-payment-methods"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["cards", ""], [4, "ngIf"], [1, "cx-payment", "container"], [1, "cx-header"], [1, "cx-body"], [1, "cx-msg"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "cx-existing", "row"], ["class", "cx-payment-card col-sm-12 col-md-12 col-lg-6", 4, "ngFor", "ngForOf"], ["role", "status"], [1, "cx-payment-card", "col-sm-12", "col-md-12", "col-lg-6"], [1, "cx-payment-inner"], [3, "deleteCard", "setDefaultCard", "editCard", "cancelCard", "index", "border", "fitToContainer", "content", "editMode"]],
      template: function PaymentMethodsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, PaymentMethodsComponent_ng_container_0_Template, 15, 10, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.paymentMethods$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, CardComponent, SpinnerComponent, i1.FeatureDirective, FormRequiredLegendComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentMethodsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-payment-methods',
      standalone: false,
      template: "<ng-container *ngIf=\"paymentMethods$ | async as paymentMethods\">\n  <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n  <cx-form-required-legend />\n  <div class=\"cx-payment container\">\n    <div class=\"cx-header\">\n      <h2>\n        {{ 'paymentMethods.paymentMethods' | cxTranslate }}\n      </h2>\n    </div>\n\n    <div class=\"cx-body\">\n      <div class=\"cx-msg\">\n        {{\n          'paymentMethods.newPaymentMethodsAreAddedDuringCheckout' | cxTranslate\n        }}\n      </div>\n      <div *ngIf=\"loading$ | async; else cards\"><cx-spinner></cx-spinner></div>\n      <ng-template #cards>\n        <div\n          *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n          role=\"status\"\n          [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n        ></div>\n        <div class=\"cx-existing row\">\n          <div\n            class=\"cx-payment-card col-sm-12 col-md-12 col-lg-6\"\n            *ngFor=\"let paymentMethod of paymentMethods; let i = index\"\n          >\n            <div class=\"cx-payment-inner\">\n              <cx-card\n                [index]=\"i\"\n                [border]=\"true\"\n                [fitToContainer]=\"true\"\n                [content]=\"getCardContent(paymentMethod) | async\"\n                (deleteCard)=\"deletePaymentMethod(paymentMethod)\"\n                (setDefaultCard)=\"setDefaultPaymentMethod(paymentMethod)\"\n                (editCard)=\"setEdit(paymentMethod)\"\n                [editMode]=\"editCard === paymentMethod.id\"\n                (cancelCard)=\"cancelCard()\"\n              ></cx-card>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.UserPaymentService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PaymentMethodsModule {
  static {
    this.ɵfac = function PaymentMethodsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentMethodsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PaymentMethodsModule,
      declarations: [PaymentMethodsComponent],
      imports: [CommonModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule, FormRequiredLegendComponent],
      exports: [PaymentMethodsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountPaymentDetailsComponent: {
            component: PaymentMethodsComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentMethodsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountPaymentDetailsComponent: {
            component: PaymentMethodsComponent,
            guards: [AuthGuard]
          }
        }
      })],
      declarations: [PaymentMethodsComponent],
      exports: [PaymentMethodsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselService {
  constructor(productService, semanticPathService) {
    this.productService = productService;
    this.semanticPathService = semanticPathService;
  }
  /**
   * Loads the product data and converts it `CarouselItem`.
   */
  loadProduct(code) {
    return this.productService.get(code).pipe(filter(isNotUndefined), map(product => this.convertProduct(product)));
  }
  /**
   * Converts the product to a generic CarouselItem
   */
  convertProduct(source, displayTitle = true, displayProductPrices = true) {
    const item = {};
    if (displayTitle) {
      item.title = source.name;
    }
    if (displayProductPrices && source.price && source.price.formattedValue) {
      item.price = source.price.formattedValue;
    }
    if (source.images && source.images.PRIMARY) {
      item.media = {
        container: source.images.PRIMARY,
        format: 'product'
      };
    }
    item.route = this.semanticPathService.transform({
      cxRoute: 'product',
      params: source
    });
    return item;
  }
  static {
    this.ɵfac = function ProductCarouselService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductCarouselService)(i0.ɵɵinject(i1.ProductService), i0.ɵɵinject(i1.SemanticPathService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductCarouselService,
      factory: ProductCarouselService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCarouselService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ProductService
  }, {
    type: i1.SemanticPathService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The `ProductListComponentService` is used to search products. The service is used
 * on the Product Listing Page, for listing products and the facet navigation.
 *
 * The service exposes the product search results based on the category and search
 * route parameters. The route parameters are used to query products by the help of
 * the `ProductSearchService`.
 */
class ProductListComponentService {
  constructor(productSearchService, routing, activatedRoute, currencyService, languageService, router, config) {
    this.productSearchService = productSearchService;
    this.routing = routing;
    this.activatedRoute = activatedRoute;
    this.currencyService = currencyService;
    this.languageService = languageService;
    this.router = router;
    this.config = config;
    this.RELEVANCE_ALLCATEGORIES = ':relevance:allCategories:';
    /**
     * Emits the search results for the current search query.
     *
     * The `searchResults$` is _not_ concerned with querying, it only observes the
     * `productSearchService.getResults()`
     */
    this.searchResults$ = this.productSearchService.getResults().pipe(filter(searchResult => Object.keys(searchResult).length > 0));
    /**
     * Observes the route and performs a search on each route change.
     *
     * Context changes, such as language and currencies are also taken
     * into account, so that the search is performed again.
     */
    this.searchByRouting$ = combineLatest([this.routing.getRouterState().pipe(distinctUntilChanged((x, y) => {
      // router emits new value also when the anticipated `nextState` changes
      // but we want to perform search only when current url changes
      return x.state.url === y.state.url;
    })), ...this.siteContext]).pipe(debounceTime(0), map(([routerState, ..._context]) => routerState.state), tap(state => {
      const criteria = this.getCriteriaFromRoute(state.params, state.queryParams);
      this.searchIfCriteriaHasChanged(criteria);
    }));
    /**
     * This stream is used for the Product Listing and Product Facets.
     *
     * It not only emits search results, but also performs a search on every change
     * of the route (i.e. route params or query params).
     *
     * When a user leaves the PLP route, the PLP component unsubscribes from this stream
     * so no longer the search is performed on route change.
     */
    this.model$ = using(() => this.searchByRouting$.subscribe(), () => this.searchResults$).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
  }
  /**
   * Search only if the previous search criteria does NOT match the new one.
   * This prevents repeating product search calls for queries that already have loaded data.
   */
  searchIfCriteriaHasChanged(criteria) {
    this.productSearchService.getResults().pipe(take(1)).subscribe(results => {
      const previous = {
        query: results?.currentQuery?.query?.value,
        currentPage: results?.pagination?.currentPage,
        pageSize: results?.pagination?.pageSize,
        sortCode: results?.pagination?.sort
      };
      if (checkQueriesDiffer() || checkCurrentPagesDiffer() || checkPageSizesDiffer() || checkSortCodesDiffer()) {
        this.search(criteria);
      }
      function checkQueriesDiffer() {
        const previousQuery = sanitizeQuery(previous.query, previous.sortCode);
        const currentQuery = sanitizeQuery(criteria.query, criteria.sortCode);
        return previousQuery !== currentQuery;
        // Remove sortCode portion from queries.
        function sanitizeQuery(query, sortCode) {
          const DEFAULT_SORT_CODE = 'relevance';
          query = query?.replace(':' + DEFAULT_SORT_CODE, '').replace(DEFAULT_SORT_CODE, '');
          if (sortCode) {
            query = query?.replace(':' + sortCode, '').replace(sortCode, '');
          }
          return query;
        }
      }
      function checkCurrentPagesDiffer() {
        // Can be stored as zero for previousCriteria but undefined as new criteria.
        // We need to set these to the zero-values to perform the equivalency check.
        const previousPage = previous.currentPage && previous.currentPage > 0 ? previous.currentPage : undefined;
        return previousPage?.toString() !== criteria.currentPage?.toString();
      }
      function checkPageSizesDiffer() {
        return previous.pageSize?.toString() !== criteria.pageSize?.toString();
      }
      function checkSortCodesDiffer() {
        // Only check "sortCode" if it is defined in criteria as sortCode is often an undefined queryParam
        // but it will always get defined as a string in previousCriteria if a search was made.
        const previousCode = criteria.sortCode ? previous?.sortCode : undefined;
        return previousCode?.toString() !== criteria.sortCode?.toString();
      }
    });
  }
  /**
   * Expose the `SearchCriteria`. The search criteria are driven by the route parameters.
   *
   * This search route configuration is not yet configurable
   * (see https://github.com/SAP/spartacus/issues/7191).
   */
  getCriteriaFromRoute(routeParams, queryParams) {
    return {
      query: queryParams.query || this.getQueryFromRouteParams(routeParams),
      pageSize: queryParams.pageSize || this.config.view?.defaultPageSize,
      currentPage: queryParams.currentPage,
      sortCode: queryParams.sortCode
    };
  }
  /**
   * Resolves the search query from the given `ProductListRouteParams`.
   */
  getQueryFromRouteParams({
    query,
    categoryCode,
    brandCode
  }) {
    if (query) {
      return query;
    }
    if (categoryCode) {
      return this.RELEVANCE_ALLCATEGORIES + categoryCode;
    }
    // TODO: drop support for brands as they should be treated
    // similarly as any category.
    if (brandCode) {
      return this.RELEVANCE_ALLCATEGORIES + brandCode;
    }
  }
  /**
   * Performs a search based on the given search criteria.
   *
   * The search is delegated to the `ProductSearchService`.
   */
  search(criteria) {
    const currentPage = criteria.currentPage;
    const pageSize = criteria.pageSize;
    const sort = criteria.sortCode;
    this.productSearchService.search(criteria.query,
    // TODO: consider dropping this complex passing of cleaned object
    Object.assign({}, currentPage && {
      currentPage
    }, pageSize && {
      pageSize
    }, sort && {
      sort
    }));
  }
  /**
   * Get items from a given page without using navigation
   */
  getPageItems(pageNumber) {
    this.routing.getRouterState().subscribe(route => {
      const routeCriteria = this.getCriteriaFromRoute(route.state.params, route.state.queryParams);
      const criteria = {
        ...routeCriteria,
        currentPage: pageNumber
      };
      this.search(criteria);
    }).unsubscribe();
  }
  /**
   * Sort the search results by the given sort code.
   */
  sort(sortCode) {
    this.route({
      sortCode
    });
  }
  /**
   * Routes to the next product listing page, using the given `queryParams`. The
   * `queryParams` support sorting, pagination and querying.
   *
   * The `queryParams` are delegated to the Angular router `NavigationExtras`.
   */
  route(queryParams) {
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute
    });
  }
  /**
   * The site context is used to update the search query in case of a
   * changing context. The context will typically influence the search data.
   *
   * We keep this private for now, as we're likely refactoring this in the next
   * major version.
   */
  get siteContext() {
    // TODO: we should refactor this so that custom context will be taken
    // into account automatically. Ideally, we drop the specific context
    // from the constructor, and query a ContextService for all contexts.
    return [this.languageService.getActive(), this.currencyService.getActive()];
  }
  static {
    this.ɵfac = function ProductListComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListComponentService)(i0.ɵɵinject(i1.ProductSearchService), i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(i1$2.ActivatedRoute), i0.ɵɵinject(i1.CurrencyService), i0.ɵɵinject(i1.LanguageService), i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(ViewConfig));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductListComponentService,
      factory: ProductListComponentService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListComponentService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ProductSearchService
  }, {
    type: i1.RoutingService
  }, {
    type: i1$2.ActivatedRoute
  }, {
    type: i1.CurrencyService
  }, {
    type: i1.LanguageService
  }, {
    type: i1$2.Router
  }, {
    type: ViewConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ViewModes;
(function (ViewModes) {
  ViewModes["Grid"] = "grid";
  ViewModes["List"] = "list";
})(ViewModes || (ViewModes = {}));
class ProductViewComponent {
  constructor() {
    this.iconTypes = ICON_TYPE;
    this.modeChange = new EventEmitter();
  }
  get buttonClass() {
    const viewName = this.viewMode?.toLowerCase();
    return `cx-product-${viewName}`;
  }
  /**
   *   Display icons inversely to allow users
   *   to see the view they will navigate to
   */
  get viewMode() {
    if (this.mode === 'list') {
      return this.iconTypes.GRID;
    }
    return this.iconTypes.LIST;
  }
  changeMode() {
    const newMode = this.mode === ViewModes.Grid ? ViewModes.List : ViewModes.Grid;
    this.modeChange.emit(newMode);
  }
  static {
    this.ɵfac = function ProductViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductViewComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductViewComponent,
      selectors: [["cx-product-view"]],
      inputs: {
        mode: "mode"
      },
      outputs: {
        modeChange: "modeChange"
      },
      standalone: false,
      decls: 7,
      vars: 13,
      consts: [["tabindex", "0", 1, "btn", "cx-product-layout", 3, "click", "ngClass"], [3, "type", 4, "ngIf"], [3, "type"]],
      template: function ProductViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "button", 0);
          i0.ɵɵpipe(1, "cxTranslate");
          i0.ɵɵpipe(2, "cxTranslate");
          i0.ɵɵpipe(3, "cxTranslate");
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵlistener("click", function ProductViewComponent_Template_button_click_0_listener() {
            return ctx.changeMode();
          });
          i0.ɵɵtemplate(5, ProductViewComponent_cx_icon_5_Template, 1, 1, "cx-icon", 1)(6, ProductViewComponent_cx_icon_6_Template, 1, 1, "cx-icon", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.buttonClass);
          i0.ɵɵattribute("aria-label", ctx.viewMode === ctx.iconTypes.GRID ? i0.ɵɵpipeBind1(1, 5, "productView.gridView") : ctx.viewMode === ctx.iconTypes.LIST ? i0.ɵɵpipeBind1(2, 7, "productView.listView") : null)("title", ctx.viewMode === ctx.iconTypes.GRID ? i0.ɵɵpipeBind1(3, 9, "productView.gridView") : ctx.viewMode === ctx.iconTypes.LIST ? i0.ɵɵpipeBind1(4, 11, "productView.listView") : null);
          i0.ɵɵadvance(5);
          i0.ɵɵproperty("ngIf", ctx.viewMode === ctx.iconTypes.GRID);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.viewMode === ctx.iconTypes.LIST);
        }
      },
      dependencies: [i3.NgClass, i3.NgIf, IconComponent, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductViewComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-view',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  class=\"btn cx-product-layout\"\n  [ngClass]=\"buttonClass\"\n  (click)=\"changeMode()\"\n  tabindex=\"0\"\n  attr.aria-label=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n  attr.title=\"{{\n    viewMode === iconTypes.GRID\n      ? ('productView.gridView' | cxTranslate)\n      : viewMode === iconTypes.LIST\n        ? ('productView.listView' | cxTranslate)\n        : null\n  }}\"\n>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.GRID\"\n    [type]=\"iconTypes.GRID\"\n  ></cx-icon>\n  <cx-icon\n    *ngIf=\"viewMode === iconTypes.LIST\"\n    [type]=\"iconTypes.LIST\"\n  ></cx-icon>\n</button>\n"
    }]
  }], null, {
    mode: [{
      type: Input
    }],
    modeChange: [{
      type: Output
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var ProductDetailOutlets;
(function (ProductDetailOutlets) {
  ProductDetailOutlets["INTRO"] = "PDP.INTRO";
  ProductDetailOutlets["PRICE"] = "PDP.PRICE";
  ProductDetailOutlets["SHARE"] = "PDP.SHARE";
  ProductDetailOutlets["SUMMARY"] = "PDP.SUMMARY";
})(ProductDetailOutlets || (ProductDetailOutlets = {}));
var ProductListOutlets;
(function (ProductListOutlets) {
  ProductListOutlets["ITEM_ACTIONS"] = "cx-product-list-item.actions";
  ProductListOutlets["ITEM_DETAILS"] = "cx-product-list-item.details";
})(ProductListOutlets || (ProductListOutlets = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context for `ProductListItemComponent`.
 */
class ProductListItemContext {
  static {
    this.ɵfac = function ProductListItemContext_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListItemContext)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductListItemContext,
      factory: ProductListItemContext.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListItemContext, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Context source for `ProductListItemComponent`.
 *
 * `ProductListItemContext` should be injected instead in child components.
 */
class ProductListItemContextSource extends ProductListItemContext {
  constructor() {
    super(...arguments);
    this.product$ = new ReplaySubject(1);
  }
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵProductListItemContextSource_BaseFactory;
      return function ProductListItemContextSource_Factory(__ngFactoryType__) {
        return (ɵProductListItemContextSource_BaseFactory || (ɵProductListItemContextSource_BaseFactory = i0.ɵɵgetInheritedFactory(ProductListItemContextSource)))(__ngFactoryType__ || ProductListItemContextSource);
      };
    })();
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductListItemContextSource,
      factory: ProductListItemContextSource.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListItemContextSource, [{
    type: Injectable
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListService {
  shouldHideAddToCartButton(product) {
    return !product.price || product.purchasable === false;
  }
  static {
    this.ɵfac = function ProductListService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductListService,
      factory: ProductListService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListItemComponent {
  constructor(productListItemContextSource) {
    this.productListItemContextSource = productListItemContextSource;
    this.productListService = inject(ProductListService);
    this.hideAddToCartButton = false;
    this.ProductListOutlets = ProductListOutlets;
  }
  ngOnChanges(changes) {
    if (changes?.product) {
      this.hideAddToCartButton = this.hideAddToCartButton = this.productListService.shouldHideAddToCartButton(this.product);
      this.productListItemContextSource.product$.next(this.product);
    }
  }
  static {
    this.ɵfac = function ProductListItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListItemComponent)(i0.ɵɵdirectiveInject(ProductListItemContextSource));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductListItemComponent,
      selectors: [["cx-product-list-item"]],
      inputs: {
        product: "product"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 17,
      vars: 23,
      consts: [[1, "row"], [1, "col-12", "col-md-4"], [1, "cx-product-image-container", 3, "routerLink"], ["format", "product", 1, "cx-product-image", 3, "container", "alt"], [1, "col-12", "col-md-8"], [1, "cx-product-name"], [3, "routerLink", "innerHtml"], [3, "cxOutlet"], [1, "col-12", "col-md-7", "col-xl-7"], [1, "cx-product-summary", 3, "innerHtml"], [1, "col-12", "col-md-5", "col-xl-5"], [3, "rating", 4, "ngIf"], ["class", "cx-product-no-review", 4, "ngIf"], [1, "cx-product-price"], [3, "rating"], [1, "cx-product-no-review"], [4, "ngIf"], ["cxInnerComponentsHost", ""]],
      template: function ProductListItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "a", 2);
          i0.ɵɵpipe(3, "cxUrl");
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelement(5, "cx-media", 3);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(6, "div", 4)(7, "h2", 5);
          i0.ɵɵelement(8, "a", 6);
          i0.ɵɵpipe(9, "cxUrl");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(10, ProductListItemComponent_ng_template_10_Template, 5, 6, "ng-template", 7);
          i0.ɵɵelementStart(11, "div", 0)(12, "div", 8)(13, "p", 9);
          i0.ɵɵtext(14);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(15, "div", 10);
          i0.ɵɵtemplate(16, ProductListItemComponent_ng_template_16_Template, 1, 1, "ng-template", 7);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(3, 10, i0.ɵɵpureFunction1(17, _c48, ctx.product)));
          i0.ɵɵattribute("aria-label", !(ctx.product.images == null ? null : ctx.product.images.hasOwnProperty("PRIMARY")) ? i0.ɵɵpipeBind2(4, 12, "productDetails.noProductImage", i0.ɵɵpureFunction1(19, _c62, ctx.product.name)) : undefined);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("container", ctx.product.images == null ? null : ctx.product.images.PRIMARY)("alt", ctx.product.name || ctx.product.summary);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(9, 15, i0.ɵɵpureFunction1(21, _c48, ctx.product)))("innerHtml", ctx.product.nameHtml, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxOutlet", ctx.ProductListOutlets.ITEM_DETAILS);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHtml", ctx.product.summary, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.product.summary, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxOutlet", ctx.ProductListOutlets.ITEM_ACTIONS);
        }
      },
      dependencies: [i3.NgIf, MediaComponent, OutletDirective, InnerComponentsHostDirective, i1$2.RouterLink, StarRatingComponent, i1.TranslatePipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListItemComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-list-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }],
      standalone: false,
      template: "<div class=\"row\">\n  <div class=\"col-12 col-md-4\">\n    <a\n      [attr.aria-label]=\"\n        !product.images?.hasOwnProperty('PRIMARY')\n          ? ('productDetails.noProductImage'\n            | cxTranslate: { product: product.name })\n          : undefined\n      \"\n      [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n      class=\"cx-product-image-container\"\n    >\n      <cx-media\n        class=\"cx-product-image\"\n        [container]=\"product.images?.PRIMARY\"\n        format=\"product\"\n        [alt]=\"product.name || product.summary\"\n      ></cx-media>\n    </a>\n  </div>\n  <div class=\"col-12 col-md-8\">\n    <h2 class=\"cx-product-name\">\n      <a\n        [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n        [innerHtml]=\"product.nameHtml\"\n      ></a>\n    </h2>\n\n    <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        [rating]=\"product?.averageRating\"\n      ></cx-star-rating>\n      <div *ngIf=\"!product.averageRating\" class=\"cx-product-no-review\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n      <div\n        class=\"cx-product-price\"\n        [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n      >\n        {{ product.price?.formattedValue }}\n      </div>\n    </ng-template>\n\n    <div class=\"row\">\n      <div class=\"col-12 col-md-7 col-xl-7\">\n        <p class=\"cx-product-summary\" [innerHtml]=\"product.summary\">\n          {{ product.summary }}\n        </p>\n      </div>\n      <div class=\"col-12 col-md-5 col-xl-5\">\n        <ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n          <ng-container *ngIf=\"!hideAddToCartButton\">\n            <ng-container cxInnerComponentsHost></ng-container>\n          </ng-container>\n        </ng-template>\n      </div>\n    </div>\n  </div>\n</div>\n"
    }]
  }], () => [{
    type: ProductListItemContextSource
  }], {
    product: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductGridItemComponent {
  constructor(productListItemContextSource) {
    this.productListItemContextSource = productListItemContextSource;
    this.productListService = inject(ProductListService);
    this.hideAddToCartButton = false;
    this.ProductListOutlets = ProductListOutlets;
  }
  ngOnChanges(changes) {
    if (changes?.product) {
      this.hideAddToCartButton = this.productListService.shouldHideAddToCartButton(this.product);
      this.productListItemContextSource.product$.next(this.product);
    }
  }
  static {
    this.ɵfac = function ProductGridItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductGridItemComponent)(i0.ɵɵdirectiveInject(ProductListItemContextSource));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductGridItemComponent,
      selectors: [["cx-product-grid-item"]],
      inputs: {
        product: "product"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 7,
      vars: 15,
      consts: [["tabindex", "-1", 1, "cx-product-image-container", 3, "routerLink"], ["format", "product", 1, "cx-product-image", 3, "container", "alt"], [1, "cx-product-name", 3, "routerLink", "innerHTML"], [3, "cxOutlet"], [1, "cx-product-rating"], [3, "rating", 4, "ngIf"], [4, "ngIf"], [1, "cx-product-price-container"], [1, "cx-product-price"], [3, "rating"], ["cxInnerComponentsHost", ""]],
      template: function ProductGridItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵpipe(1, "cxUrl");
          i0.ɵɵelement(2, "cx-media", 1);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(3, "a", 2);
          i0.ɵɵpipe(4, "cxUrl");
          i0.ɵɵtemplate(5, ProductGridItemComponent_ng_template_5_Template, 7, 6, "ng-template", 3)(6, ProductGridItemComponent_ng_template_6_Template, 1, 1, "ng-template", 3);
        }
        if (rf & 2) {
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 7, i0.ɵɵpureFunction1(11, _c48, ctx.product)));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("container", ctx.product.images == null ? null : ctx.product.images.PRIMARY)("alt", ctx.product.name || ctx.product.summary);
          i0.ɵɵadvance();
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(4, 9, i0.ɵɵpureFunction1(13, _c48, ctx.product)))("innerHTML", ctx.product.nameHtml, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("cxOutlet", ctx.ProductListOutlets.ITEM_DETAILS);
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxOutlet", ctx.ProductListOutlets.ITEM_ACTIONS);
        }
      },
      dependencies: [i3.NgIf, MediaComponent, OutletDirective, InnerComponentsHostDirective, i1$2.RouterLink, StarRatingComponent, i1.TranslatePipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductGridItemComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-grid-item',
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }],
      standalone: false,
      template: "<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-image-container\"\n  tabindex=\"-1\"\n>\n  <cx-media\n    class=\"cx-product-image\"\n    [container]=\"product.images?.PRIMARY\"\n    format=\"product\"\n    [alt]=\"product.name || product.summary\"\n  ></cx-media>\n</a>\n<a\n  [routerLink]=\"{ cxRoute: 'product', params: product } | cxUrl\"\n  class=\"cx-product-name\"\n  [innerHTML]=\"product.nameHtml\"\n></a>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_DETAILS\">\n  <div class=\"cx-product-rating\">\n    <cx-star-rating\n      *ngIf=\"product.averageRating\"\n      [rating]=\"product?.averageRating\"\n    ></cx-star-rating>\n    <div *ngIf=\"!product.averageRating\">\n      {{ 'productDetails.noReviews' | cxTranslate }}\n    </div>\n  </div>\n  <div class=\"cx-product-price-container\">\n    <div\n      class=\"cx-product-price\"\n      [attr.aria-label]=\"'productDetails.productPrice' | cxTranslate\"\n    >\n      {{ product.price?.formattedValue }}\n    </div>\n  </div>\n</ng-template>\n\n<ng-template [cxOutlet]=\"ProductListOutlets.ITEM_ACTIONS\">\n  <ng-container *ngIf=\"!hideAddToCartButton\">\n    <ng-container cxInnerComponentsHost></ng-container>\n  </ng-container>\n</ng-template>\n"
    }]
  }], () => [{
    type: ProductListItemContextSource
  }], {
    product: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductScrollComponent {
  set setConfig(inputConfig) {
    this.setComponentConfigurations(inputConfig);
  }
  set setModel(inputModel) {
    this.infiniteScrollOperations(inputModel);
  }
  set setViewMode(inputViewMode) {
    this.inputViewMode = inputViewMode;
    //If viewMode is already set (meaning it is not the first load)
    //Reset the product list
    if (this.viewMode) {
      this.resetListOnViewModeChange();
    } else {
      //If viewMode is not set (meaning it is the first load)
      //Set the viewMode
      this.viewMode = inputViewMode;
    }
  }
  constructor(productListComponentService, ref) {
    this.productListComponentService = productListComponentService;
    this.ref = ref;
    this.subscription = new Subscription();
    this.ViewModes = ViewModes;
    this.appendProducts = false;
    this.resetList = false;
    this.isMaxProducts = false;
    this.isLastPage = false;
    this.isEmpty = false;
  }
  scrollPage(pageNumber) {
    this.appendProducts = true;
    this.ref.markForCheck();
    this.productListComponentService.getPageItems(pageNumber);
  }
  loadNextPage(pageNumber) {
    this.isMaxProducts = false;
    this.scrollPage(pageNumber);
  }
  scrollToTop() {
    window.scroll(0, 0);
  }
  setComponentConfigurations(scrollConfig) {
    const isButton = scrollConfig.view?.infiniteScroll?.showMoreButton;
    const configProductLimit = scrollConfig.view?.infiniteScroll?.productLimit;
    //Display "show more" button every time when button configuration is true
    //Otherwise, only display "show more" when the configuration product limit is reached
    this.productLimit = isButton ? 1 : configProductLimit;
  }
  infiniteScrollOperations(inputModel) {
    if (this.appendProducts) {
      this.model = {
        ...inputModel,
        products: this.model.products?.concat(inputModel.products ?? [])
      };
    } else {
      this.model = inputModel;
      this.maxProducts = this.productLimit;
    }
    this.setConditions();
    this.ref.markForCheck();
  }
  resetListOnViewModeChange() {
    this.scrollToTop();
    this.resetList = true;
    this.productListComponentService.getPageItems(0);
  }
  //Set booleans after model has been retrieved
  setConditions() {
    this.isEmpty = !this.model.products || this.model.products.length === 0;
    this.isLastPage = this.model.pagination?.currentPage === (this.model.pagination?.totalPages ?? 0) - 1;
    if (this.model.products) {
      this.isMaxProducts = this.productLimit !== undefined && this.productLimit !== 0 && this.model.products.length >= (this.maxProducts ?? 0);
      //Add the productLimit to the current number of products to determine the next max number of products
      if (this.isMaxProducts) {
        this.maxProducts = this.model.products.length + (this.productLimit ?? 0);
      }
    }
    //Only change viewMode once the new model is set
    //This prevents flickering issues
    if (this.viewMode !== this.inputViewMode) {
      this.viewMode = this.inputViewMode;
    }
    this.resetList = false;
    this.appendProducts = false;
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function ProductScrollComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductScrollComponent)(i0.ɵɵdirectiveInject(ProductListComponentService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductScrollComponent,
      selectors: [["cx-product-scroll"]],
      inputs: {
        setConfig: [0, "scrollConfig", "setConfig"],
        setModel: [0, "model", "setModel"],
        setViewMode: [0, "inputViewMode", "setViewMode"]
      },
      standalone: false,
      decls: 2,
      vars: 2,
      consts: [[4, "ngIf"], ["infiniteScroll", "", 3, "scrolled", "infiniteScrollDistance", "infiniteScrollThrottle", "infiniteScrollDisabled"], [1, "row"], ["class", "col-12 col-sm-6 col-md-4", 3, "product", 4, "ngFor", "ngForOf"], [3, "className"], ["class", "btn btn-block btn-secondary", 3, "click", 4, "ngIf"], ["class", "btn btn-block btn-secondary align-btn", 3, "click", 4, "ngIf"], ["class", "cx-spinner", 4, "ngIf"], [1, "col-12", "col-sm-6", "col-md-4", 3, "product"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-secondary", "align-btn", 3, "click"], [1, "cx-spinner"], ["class", "cx-product-search-list", 3, "product", 4, "ngFor", "ngForOf"], [1, "cx-product-search-list", 3, "product"]],
      template: function ProductScrollComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductScrollComponent_ng_container_0_Template, 8, 8, "ng-container", 0)(1, ProductScrollComponent_ng_container_1_Template, 7, 8, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.viewMode === ctx.ViewModes.Grid);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.viewMode === ctx.ViewModes.List);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3$1.InfiniteScrollDirective, SpinnerComponent, ProductListItemComponent, ProductGridItemComponent, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductScrollComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-scroll',
      standalone: false,
      template: "<ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"5\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <div class=\"row\">\n      <cx-product-grid-item\n        *ngFor=\"let product of model?.products\"\n        [product]=\"product\"\n        class=\"col-12 col-sm-6 col-md-4\"\n      ></cx-product-grid-item>\n    </div>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container grid-btn-padding'\n          : 'cx-single-btn-container grid-btn-padding'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"viewMode === ViewModes.List\">\n  <div\n    infiniteScroll\n    [infiniteScrollDistance]=\"3\"\n    [infiniteScrollThrottle]=\"50\"\n    [infiniteScrollDisabled]=\"isMaxProducts || isLastPage || isEmpty\"\n    (scrolled)=\"scrollPage((model?.pagination?.currentPage ?? 0) + 1)\"\n  >\n    <cx-product-list-item\n      *ngFor=\"let product of model?.products\"\n      [product]=\"product\"\n      class=\"cx-product-search-list\"\n    ></cx-product-list-item>\n    <div\n      [className]=\"\n        !isLastPage && (model?.pagination?.currentPage ?? 0) > 0\n          ? 'cx-double-btn-container'\n          : 'cx-single-btn-container'\n      \"\n    >\n      <div\n        *ngIf=\"\n          (isMaxProducts || isLastPage) &&\n          (model?.pagination?.currentPage ?? 0) > 0\n        \"\n        (click)=\"scrollToTop()\"\n        class=\"btn btn-block btn-secondary\"\n      >\n        {{ 'productList.backToTopBtn' | cxTranslate }}\n      </div>\n      <div\n        *ngIf=\"isMaxProducts && !isLastPage\"\n        (click)=\"loadNextPage((model?.pagination?.currentPage ?? 0) + 1)\"\n        class=\"btn btn-block btn-secondary align-btn\"\n      >\n        {{ 'productList.showMoreBtn' | cxTranslate }}\n      </div>\n    </div>\n    <div *ngIf=\"appendProducts\" class=\"cx-spinner\">\n      <cx-spinner></cx-spinner>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: ProductListComponentService
  }, {
    type: i0.ChangeDetectorRef
  }], {
    setConfig: [{
      type: Input,
      args: ['scrollConfig']
    }],
    setModel: [{
      type: Input,
      args: ['model']
    }],
    setViewMode: [{
      type: Input,
      args: ['inputViewMode']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListComponent {
  constructor(pageLayoutService, productListComponentService, globalMessageService, scrollConfig) {
    this.pageLayoutService = pageLayoutService;
    this.productListComponentService = productListComponentService;
    this.globalMessageService = globalMessageService;
    this.scrollConfig = scrollConfig;
    this.subscription = new Subscription();
    this.model$ = this.productListComponentService.model$;
    this.viewMode$ = new BehaviorSubject(ViewModes.Grid);
    this.ViewModes = ViewModes;
  }
  ngOnInit() {
    this.isInfiniteScroll = this.scrollConfig.view?.infiniteScroll?.active;
    this.subscription.add(this.pageLayoutService.templateName$.pipe(take(1)).subscribe(template => {
      this.viewMode$.next(template === 'ProductGridPageTemplate' ? ViewModes.Grid : ViewModes.List);
    }));
    this.subscription.add(combineLatest([this.model$, this.viewMode$]).pipe(skip(1), filter(([model, mode]) => !!model && !!mode)).subscribe(() => this.globalMessageService.add({
      key: 'sorting.pageViewUpdated'
    }, GlobalMessageType.MSG_TYPE_ASSISTIVE, 500)));
  }
  sortList(sortCode) {
    this.productListComponentService.sort(sortCode);
  }
  setViewMode(mode) {
    this.viewMode$.next(mode);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function ProductListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListComponent)(i0.ɵɵdirectiveInject(PageLayoutService), i0.ɵɵdirectiveInject(ProductListComponentService), i0.ɵɵdirectiveInject(i1.GlobalMessageService), i0.ɵɵdirectiveInject(ViewConfig));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductListComponent,
      selectors: [["cx-product-list"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["infiniteScroll", ""], ["class", "cx-page", 4, "ngIf"], [1, "cx-page"], ["tabindex", "-1", 1, "cx-page-section"], [1, "container"], [1, "row"], ["class", "col-12 col-lg-12", 4, "ngIf"], [1, "col-12", "col-lg-12"], [1, "cx-sorting", "top"], [1, "form-group", "cx-sort-dropdown", "col-12", "col-lg-4", "mr-auto"], ["ariaControls", "product-results-list", 3, "sortListEvent", "sortOptions", "selectedOption", "ariaLabel", "placeholder"], ["class", "col-auto", 4, "ngIf"], [1, "col-auto", "ml-auto", "ml-lg-0"], [3, "modeChange", "mode"], ["id", "product-results-list", 1, "cx-product-container"], [4, "ngIf", "ngIfElse"], [1, "cx-sorting", "bottom"], [1, "col-auto"], [1, "cx-pagination"], ["queryParam", "currentPage", "paginationID", "pagination-top", 3, "pagination", "defaultPage"], [4, "ngIf"], ["class", "col-12 col-sm-6 col-md-4", 3, "product", 4, "ngFor", "ngForOf"], [1, "col-12", "col-sm-6", "col-md-4", 3, "product"], ["class", "cx-product-search-list", 3, "product", 4, "ngFor", "ngForOf"], [1, "cx-product-search-list", 3, "product"], [3, "scrollConfig", "model", "inputViewMode"], ["queryParam", "currentPage", "paginationID", "pagination-bottom", 3, "pagination", "defaultPage"]],
      template: function ProductListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductListComponent_div_0_Template, 7, 6, "div", 1);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.model$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, SortingComponent, PaginationComponent, ProductListItemComponent, ProductGridItemComponent, ProductViewComponent, ProductScrollComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-list',
      standalone: false,
      template: "<div class=\"cx-page\" *ngIf=\"model$ | async as model\">\n  <section\n    tabindex=\"-1\"\n    class=\"cx-page-section\"\n    [attr.aria-label]=\"'productList.productListResults' | cxTranslate\"\n  >\n    <div class=\"container\">\n      <div class=\"row\">\n        <div class=\"col-12 col-lg-12\" *ngIf=\"viewMode$ | async as viewMode\">\n          <div class=\"cx-sorting top\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div *ngIf=\"!isInfiniteScroll\" class=\"col-auto\">\n                <div\n                  class=\"cx-pagination\"\n                  [attr.aria-label]=\"\n                    'productList.productSearchPagination' | cxTranslate\n                  \"\n                >\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-top\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n          <div id=\"product-results-list\" class=\"cx-product-container\">\n            <!-- Product list when using pagination -->\n            <ng-container *ngIf=\"!isInfiniteScroll; else infiniteScroll\">\n              <ng-container *ngIf=\"viewMode === ViewModes.Grid\">\n                <div class=\"row\">\n                  <cx-product-grid-item\n                    *ngFor=\"let product of model?.products\"\n                    [product]=\"product\"\n                    class=\"col-12 col-sm-6 col-md-4\"\n                  ></cx-product-grid-item>\n                </div>\n              </ng-container>\n\n              <ng-container *ngIf=\"viewMode === ViewModes.List\">\n                <cx-product-list-item\n                  *ngFor=\"let product of model?.products\"\n                  [product]=\"product\"\n                  class=\"cx-product-search-list\"\n                ></cx-product-list-item>\n              </ng-container>\n            </ng-container>\n\n            <!-- Product list when using infinite scroll -->\n            <ng-template #infiniteScroll>\n              <cx-product-scroll\n                [scrollConfig]=\"scrollConfig\"\n                [model]=\"model\"\n                [inputViewMode]=\"viewMode\"\n              ></cx-product-scroll>\n            </ng-template>\n          </div>\n          <div class=\"cx-sorting bottom\">\n            <div class=\"row\">\n              <label\n                class=\"form-group cx-sort-dropdown col-12 col-lg-4 mr-auto\"\n              >\n                <span>{{ 'productList.sortBy' | cxTranslate }}</span>\n                <cx-sorting\n                  [sortOptions]=\"model.sorts\"\n                  (sortListEvent)=\"sortList($event)\"\n                  [selectedOption]=\"model.pagination?.sort\"\n                  [ariaLabel]=\"'productList.sortResults' | cxTranslate\"\n                  ariaControls=\"product-results-list\"\n                  placeholder=\"{{ 'productList.sortBy' | cxTranslate }}\"\n                ></cx-sorting>\n              </label>\n              <div\n                *ngIf=\"!isInfiniteScroll\"\n                class=\"col-auto\"\n                [attr.aria-label]=\"\n                  'productList.productSearchPagination' | cxTranslate\n                \"\n              >\n                <div class=\"cx-pagination\">\n                  <cx-pagination\n                    [pagination]=\"model.pagination\"\n                    queryParam=\"currentPage\"\n                    [defaultPage]=\"0\"\n                    paginationID=\"pagination-bottom\"\n                  ></cx-pagination>\n                </div>\n              </div>\n              <div class=\"col-auto ml-auto ml-lg-0\">\n                <cx-product-view\n                  (modeChange)=\"setViewMode($event)\"\n                  [mode]=\"viewMode\"\n                ></cx-product-view>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n"
    }]
  }], () => [{
    type: PageLayoutService
  }, {
    type: ProductListComponentService
  }, {
    type: i1.GlobalMessageService
  }, {
    type: ViewConfig
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var FacetGroupCollapsedState;
(function (FacetGroupCollapsedState) {
  FacetGroupCollapsedState["EXPANDED"] = "EXPANDED";
  FacetGroupCollapsedState["COLLAPSED"] = "COLLAPSED";
})(FacetGroupCollapsedState || (FacetGroupCollapsedState = {}));

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides access to all the facets and active facets for the Product Listing Page.
 */
class ProductFacetService {
  constructor(routing, productListComponentService) {
    this.routing = routing;
    this.productListComponentService = productListComponentService;
    this.routeState$ = this.routing.getRouterState().pipe(map(routerState => routerState.state));
    /**
     * Returns the search results for the current page.
     */
    this.searchResult$ = this.routeState$.pipe(switchMap(state => this.productListComponentService.model$.pipe(filter(page => this.filterForPage(state, page)), map(page => ({
      ...page,
      breadcrumbs: this.filterBreadcrumbs(page?.breadcrumbs ?? [], state.params)
    })))));
    /**
     * Observes the facets and active facets for the given page. The facet data
     * is provided in a `FacetList`.
     */
    this.facetList$ = this.searchResult$.pipe(map(result => ({
      facets: result.facets,
      activeFacets: result.breadcrumbs
    })));
  }
  /**
   * Filters the current result by verifying if the result is related to the page.
   * This is done to avoid a combination of the next page and the current search results.
   */
  filterForPage(state, page) {
    if (!page.currentQuery?.query?.value) {
      return false;
    }
    if (state.context.type === PageType.CATEGORY_PAGE) {
      return page.currentQuery.query.value.indexOf(`allCategories:${state.context.id}`) > -1;
    }
    if (state.context.type === PageType.CONTENT_PAGE && state.context.id === 'search') {
      return page.freeTextSearch === state.params.query.split(':')[0];
    }
    return false;
  }
  /**
   * Filter breadcrumbs which are not actively selected but coming from
   * the route navigation.
   *
   * The breadcrumbs might include the active category page code, which is not actively
   * selected by the user.
   */
  filterBreadcrumbs(breadcrumbs, params) {
    return breadcrumbs ? breadcrumbs.filter(breadcrumb => !(breadcrumb.facetCode === 'allCategories' && (breadcrumb.facetValueCode === params.categoryCode || breadcrumb.facetValueCode === params.brandCode))) : [];
  }
  static {
    this.ɵfac = function ProductFacetService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductFacetService)(i0.ɵɵinject(i1.RoutingService), i0.ɵɵinject(ProductListComponentService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductFacetService,
      factory: ProductFacetService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductFacetService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.RoutingService
  }, {
    type: ProductListComponentService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Provides access to the facets as well as their UI state. The UI state
 * represents user related changes on the facets, such as expanding or
 * collapsing a facet group or expanding the number of _visible_ facet values.
 */
class FacetService {
  constructor(productFacetService) {
    this.productFacetService = productFacetService;
    /**
     * An internal map where we keep the UI state of the facets.
     */
    this.facetState = new Map();
    this.codec = new HttpUrlEncodingCodec();
    /**
     * Observes the facets for the given page and configures the initial UI state.
     *
     * Facets are configured on each emission so that we keep the facet UI state.
     * This is mainly done to keep the state during usage of the facet, but also
     * benefitial when the facets are rebuild while using them.
     */
    this.facetList$ = this.productFacetService.facetList$.pipe(tap(facetList => {
      facetList.facets?.forEach(facet => this.initialize(facet));
    }));
  }
  /**
   * Returns the observed UI state for the facet.
   *
   * The state is initialized using the `initialize` method.
   */
  getState(facet) {
    this.initialize(facet);
    return facet.name ? this.facetState.get(facet.name) ?? of({}) : of({});
  }
  /**
   * Returns the UI state for the facet.
   *
   * The state is initialized using the `initialize` method.
   */
  getStateSnapshot(facet) {
    return this.getState(facet).value;
  }
  /**
   * Toggles the facet expanded state. If the expanded state becomes false,
   * the visible values will decrease to the top values only.
   *
   * If the optional value argument is provided the expanded state will be set
   * to this value, regardless of the current `expanded` state.
   */
  toggle(facet, isExpanded) {
    const state = this.getStateSnapshot(facet);
    const toggledState = {
      toggled: isExpanded ? FacetGroupCollapsedState.COLLAPSED : FacetGroupCollapsedState.EXPANDED
    };
    if (toggledState.toggled === FacetGroupCollapsedState.COLLAPSED) {
      toggledState.maxVisible = state.topVisible;
    }
    this.updateState(facet, toggledState);
  }
  /**
   * Increases the visible values to the maximum values of the facet.
   */
  increaseVisibleValues(facet) {
    this.updateState(facet, {
      maxVisible: facet.values?.length
    });
  }
  /**
   * Decreases the visible values to the topValueCount.
   *
   * The topValueCount defaults to 6, but can be controlled in
   * the backend as well.
   */
  decreaseVisibleValues(facet) {
    this.updateState(facet, {
      maxVisible: facet.topValueCount
    });
  }
  /**
   * Persists the facet state and initializes the default values for the top
   * and max visible values.
   */
  initialize(facet) {
    const topFacets = facet.topValueCount && facet.topValueCount > 0 ? facet.topValueCount : facet.values?.length || 0;
    if (facet.name && !this.hasState(facet)) {
      this.facetState.set(facet.name, new BehaviorSubject({
        topVisible: topFacets,
        maxVisible: topFacets
      }));
    }
  }
  /**
   * Updates the state of the facet in the local facet map.
   */
  updateState(facet, property) {
    const state = {
      ...this.getStateSnapshot(facet),
      ...property
    };
    if (facet.name) {
      this.facetState.get(facet.name)?.next(state);
    }
  }
  hasState(facet) {
    if (facet.name) {
      return this.facetState.has(facet.name);
    }
    return false;
  }
  getLinkParams(query) {
    return {
      // to avoid encoding issues with facets that have space (' ') in their name,
      // we replace the decoded '+' back to empty space ' '.
      // For more, see https://github.com/SAP/spartacus/issues/7348
      query: this.codec.decodeValue(this.decodeUriComponentSafe(query)).replace(/\+/g, ' ')
    };
  }
  decodeUriComponentSafe(query) {
    return query.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
  }
  static {
    this.ɵfac = function FacetService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FacetService)(i0.ɵɵinject(ProductFacetService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FacetService,
      factory: FacetService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FacetService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: ProductFacetService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Active facets render the applied facet values as a list of focusable buttons
 * which can be used to remove the applied facet value.
 */
class ActiveFacetsComponent {
  constructor(facetService) {
    this.facetService = facetService;
    this.role = 'group';
    this.labelledby = 'cx-active-facets-groupName';
    /** Active facets which are applied to the product results. */
    this.facetList$ = this.facetService.facetList$;
    /** Configurable icon which is used for the active facet close button */
    this.closeIcon = ICON_TYPE.CLOSE;
  }
  getLinkParams(facet) {
    return this.facetService.getLinkParams(facet.removeQuery?.query?.value ?? '');
  }
  /**
   * The focus key is used to persist the focus on the facet when the DOM is being
   * recreated. We only apply the focus key for the given _active_ facet when there
   * the original facets is not available. This happens for non multi-valued facets.
   *
   * With this approach, the we keep the focus, either at the facet list or on the
   * active facets.
   */
  getFocusKey(facetList, facet) {
    return facetList.facets?.find(f => f.values?.find(val => val.name === facet.facetValueName)) ? '' : facet.facetValueName;
  }
  /**
   * Purpose of this function is to allow keyboard users to click on a filter they
   * wish to remove by pressing spacebar. Event not handled natively by <a> elements.
   *
   * @param event spacebar keydown
   */
  removeFilterWithSpacebar(event) {
    event?.preventDefault(); // Avoid spacebar scroll
    event?.target?.dispatchEvent(new MouseEvent('click', {
      cancelable: true
    }));
  }
  static {
    this.ɵfac = function ActiveFacetsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ActiveFacetsComponent)(i0.ɵɵdirectiveInject(FacetService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ActiveFacetsComponent,
      selectors: [["cx-active-facets"]],
      hostVars: 2,
      hostBindings: function ActiveFacetsComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role)("aria-labelledby", ctx.labelledby);
        }
      },
      inputs: {
        closeIcon: "closeIcon"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["id", "cx-active-facets-groupName", 4, "ngIf"], ["routerLink", "./", "role", "button", 3, "queryParams", "cxFocus", "keydown.space", 4, "ngFor", "ngForOf"], ["id", "cx-active-facets-groupName"], ["routerLink", "./", "role", "button", 3, "keydown.space", "queryParams", "cxFocus"], ["aria-hidden", "true", 3, "type"]],
      template: function ActiveFacetsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ActiveFacetsComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.facetList$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i1$2.RouterLink, IconComponent, FocusDirective, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActiveFacetsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-active-facets',
      changeDetection: ChangeDetectionStrategy.Default,
      standalone: false,
      template: "<ng-container *ngIf=\"facetList$ | async as facetList\">\n  <div\n    id=\"cx-active-facets-groupName\"\n    *ngIf=\"facetList.activeFacets && facetList.activeFacets.length > 0\"\n  >\n    {{ 'productList.appliedFilter' | cxTranslate }}\n  </div>\n\n  <a\n    *ngFor=\"let facet of facetList?.activeFacets\"\n    routerLink=\"./\"\n    [queryParams]=\"getLinkParams(facet)\"\n    [cxFocus]=\"{ key: getFocusKey(facetList, facet) }\"\n    role=\"button\"\n    (keydown.space)=\"removeFilterWithSpacebar($event)\"\n    [attr.aria-label]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n    [attr.title]=\"\n      'productList.activeFilter' | cxTranslate: { filter: facet.facetValueName }\n    \"\n  >\n    <span>{{ facet.facetValueName }}</span>\n    <cx-icon aria-hidden=\"true\" [type]=\"closeIcon\"></cx-icon>\n  </a>\n</ng-container>\n"
    }]
  }], () => [{
    type: FacetService
  }], {
    role: [{
      type: HostBinding,
      args: ['attr.role']
    }],
    labelledby: [{
      type: HostBinding,
      args: ['attr.aria-labelledby']
    }],
    closeIcon: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ActiveFacetsModule {
  static {
    this.ɵfac = function ActiveFacetsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ActiveFacetsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ActiveFacetsModule,
      declarations: [ActiveFacetsComponent],
      imports: [CommonModule, RouterModule, I18nModule, IconModule, KeyboardFocusModule],
      exports: [ActiveFacetsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, RouterModule, I18nModule, IconModule, KeyboardFocusModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ActiveFacetsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, I18nModule, IconModule, KeyboardFocusModule],
      declarations: [ActiveFacetsComponent],
      exports: [ActiveFacetsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetComponent {
  set facet(value) {
    this._facet = value;
    this.isMultiSelect = !!value.multiSelect;
    this.state$ = this.facetService.getState(value);
  }
  get facet() {
    return this._facet;
  }
  constructor(facetService, elementRef, cd) {
    this.facetService = facetService;
    this.elementRef = elementRef;
    this.cd = cd;
    /** configurable icon that is used to collapse the facet group  */
    this.expandIcon = ICON_TYPE.EXPAND;
    this.collapseIcon = ICON_TYPE.COLLAPSE;
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
  }
  ngAfterViewInit() {
    // Update the value of `this.isExpanded` after `this.values` was initialized
    this.cd.detectChanges();
  }
  /**
   * @deprecated: Header will no longer be used in favour of TabComponent headers.
   *
   * Handles clicking the heading of the facet group, which means toggling
   * the visibility of the group (collapse / expand) and optionally focusing
   * the group.
   */
  toggleGroup(event) {
    const host = this.elementRef.nativeElement;
    const isLocked = this.keyboardFocus?.isLocked;
    this.facetService.toggle(this.facet, this.isExpanded);
    if (!isLocked || this.isExpanded) {
      host.focus();
      // we stop propagating the event as otherwise the focus on the host will trigger
      // an unlock event from the LockFocus directive.
      event.stopPropagation();
    }
  }
  get isExpanded() {
    return this.values?.first?.nativeElement.offsetParent !== null;
  }
  openLink(event) {
    event.target.click();
    event.preventDefault();
  }
  /**
   * Increases the number of visible values for the facet. This is delegated
   * to `facetService.increaseVisibleValues`.
   */
  increaseVisibleValues() {
    this.facetService.increaseVisibleValues(this.facet);
  }
  /**
   * Decreases the number of visible values for the facet. This is delegated
   * to `facetService.decreaseVisibleValues`.
   */
  decreaseVisibleValues() {
    this.facetService.decreaseVisibleValues(this.facet);
  }
  getLinkParams(value) {
    return this.facetService.getLinkParams(value.query?.query?.value ?? '');
  }
  onKeydown(event) {
    const targetIndex = this.values.toArray().findIndex(el => {
      return el.nativeElement === event.target;
    });
    // TODO: Left and Right arrow keys are disabled when setting a11yTabComponent.
    // We can remove these in the future.
    switch (event.key) {
      case 'ArrowLeft':
        this.onArrowLeft(event);
        break;
      case 'ArrowRight':
        this.onArrowRight(event);
        break;
      case 'ArrowDown':
        this.onArrowDown(event, targetIndex);
        break;
      case 'ArrowUp':
        this.onArrowUp(event, targetIndex);
        break;
      case 'Tab':
        this.onTabNavigation();
        break;
    }
  }
  /**
   * If a11yTabComponent is enabled, we temporarily disable tabbing for the facet values.
   * This is to use proper keyboard navigation keys(ArrowUp/ArrowDown) for navigating through the facet values.
   */
  onTabNavigation() {
    if (!this.featureConfigService?.isEnabled('a11yTabComponent')) {
      return;
    }
    disableTabbingForTick(this.values.map(el => el.nativeElement));
  }
  /**
   * @deprecated: Arrow key functions will be removed in favour of using the TabComponent.
   */
  onArrowRight(event) {
    if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
      return;
    }
    if (!this.isExpanded) {
      this.toggleGroup(event);
    }
  }
  /**
   * @deprecated: Arrow key functions will be removed in favour of using the TabComponent.
   */
  onArrowLeft(event) {
    // Navigate to tab buttons when tab component enabled
    if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
      return;
    }
    if (this.isExpanded) {
      this.toggleGroup(event);
      this.facetHeader.nativeElement.focus();
    }
  }
  onArrowDown(event, targetIndex) {
    if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
      event.preventDefault();
      this.values.get(targetIndex + 1)?.nativeElement.focus();
      return;
    }
    if (this.isExpanded) {
      event.preventDefault();
      if (event.target === this.facetHeader.nativeElement) {
        this.values?.first?.nativeElement.focus();
        return;
      }
      this.values.get(targetIndex + 1)?.nativeElement.focus();
    }
  }
  onArrowUp(event, targetIndex) {
    if (this.featureConfigService?.isEnabled('a11yTabComponent')) {
      event.preventDefault();
      this.values.get(targetIndex - 1)?.nativeElement.focus();
      return;
    }
    if (this.isExpanded) {
      event.preventDefault();
      this.values.get(targetIndex - 1)?.nativeElement.focus();
    }
  }
  static {
    this.ɵfac = function FacetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FacetComponent)(i0.ɵɵdirectiveInject(FacetService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FacetComponent,
      selectors: [["cx-facet"]],
      viewQuery: function FacetComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(FocusDirective, 5);
          i0.ɵɵviewQuery(_c64, 5);
          i0.ɵɵviewQuery(_c65, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.keyboardFocus = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.facetHeader = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.values = _t);
        }
      },
      hostVars: 2,
      hostBindings: function FacetComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("multi-select", ctx.isMultiSelect);
        }
      },
      inputs: {
        expandIcon: "expandIcon",
        collapseIcon: "collapseIcon",
        facet: "facet"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["facetHeader", ""], ["facetValue", ""], [4, "ngIf"], ["class", "heading", 3, "cxFocus", "click", "keydown", 4, "cxFeature"], ["routerLink", "./", "class", "value", 3, "queryParams", "selected", "cxFocus", "keydown", "keydown.space", 4, "ngFor", "ngForOf"], [1, "more"], ["aria-expanded", "true", "class", "cx-action-link", 3, "cxAtMessage", "cxFocus", "click", 4, "ngIf"], ["aria-expanded", "false", "class", "cx-action-link", 3, "cxAtMessage", "cxFocus", "click", 4, "ngIf"], [1, "heading", 3, "click", "keydown", "cxFocus"], [1, "collapse-icon", 3, "title", "type"], [1, "expand-icon", 3, "title", "type"], ["routerLink", "./", 1, "value", 3, "keydown", "keydown.space", "queryParams", "cxFocus"], ["aria-hidden", "true"], ["aria-hidden", "true", 1, "count"], [1, "count"], ["aria-expanded", "true", 1, "cx-action-link", 3, "click", "cxAtMessage", "cxFocus"], ["aria-expanded", "false", 1, "cx-action-link", 3, "click", "cxAtMessage", "cxFocus"]],
      template: function FacetComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FacetComponent_ng_container_0_Template, 10, 13, "ng-container", 2);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.state$));
        }
      },
      dependencies: [AtMessageDirective, i3.NgForOf, i3.NgIf, IconComponent, FocusDirective, i1$2.RouterLink, i1.FeatureDirective, i3.AsyncPipe, i3.SlicePipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FacetComponent, [{
    type: Component,
    args: [{
      selector: 'cx-facet',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"state$ | async as state\">\n  <button\n    class=\"heading\"\n    #facetHeader\n    (click)=\"toggleGroup($event)\"\n    (keydown)=\"onKeydown($event)\"\n    [attr.aria-expanded]=\"isExpanded\"\n    [attr.aria-label]=\"\n      'productFacetNavigation.filterBy.name' | cxTranslate: { name: facet.name }\n    \"\n    [cxFocus]=\"{ key: facet.name }\"\n    *cxFeature=\"'!a11yTabComponent'\"\n  >\n    {{ facet.name }}\n    <cx-icon\n      title=\"{{ 'common.collapse' | cxTranslate }}\"\n      class=\"collapse-icon\"\n      [type]=\"collapseIcon\"\n    ></cx-icon>\n    <cx-icon\n      title=\"{{ 'common.expand' | cxTranslate }}\"\n      class=\"expand-icon\"\n      [type]=\"expandIcon\"\n    ></cx-icon>\n  </button>\n\n  <div>\n    <!-- TODO: (CXSPA-6892) - Remove feature flag next major release. -->\n    <a\n      *ngFor=\"let value of facet.values | slice: 0 : state.topVisible\"\n      #facetValue\n      routerLink=\"./\"\n      [queryParams]=\"getLinkParams(value)\"\n      class=\"value\"\n      [class.selected]=\"value.selected\"\n      [cxFocus]=\"{ key: value.name }\"\n      (keydown)=\"onKeydown($event)\"\n      (keydown.space)=\"openLink($any($event))\"\n      [attr.role]=\"facet.multiSelect ? 'checkbox' : null\"\n      [attr.aria-checked]=\"facet.multiSelect ? value.selected : null\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate: { name: value.name, count: value.count }\n      }}\"\n    >\n      <span aria-hidden=\"true\"\n        >{{ value.name\n        }}<span aria-hidden=\"true\" class=\"count\">{{ value.count }}</span></span\n      >\n    </a>\n\n    <div class=\"more\">\n      <a\n        *ngFor=\"\n          let value of facet.values\n            | slice: state.topVisible ?? 0 : state.maxVisible\n        \"\n        #facetValue\n        routerLink=\"./\"\n        [queryParams]=\"getLinkParams(value)\"\n        class=\"value\"\n        [class.selected]=\"value.selected\"\n        [cxFocus]=\"{ key: value.name }\"\n        (keydown)=\"onKeydown($event)\"\n        (keydown.space)=\"openLink($any($event))\"\n      >\n        <span\n          >{{ value.name }}<span class=\"count\">{{ value.count }}</span></span\n        >\n      </a>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          state.topVisible &&\n          state.maxVisible > state.topVisible\n        \"\n        (click)=\"decreaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"true\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowLess' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showLess' | cxTranslate }}\n      </button>\n\n      <button\n        *ngIf=\"\n          state.maxVisible &&\n          facet.values &&\n          state.maxVisible > 0 &&\n          state.maxVisible < facet.values.length\n        \"\n        (click)=\"increaseVisibleValues()\"\n        [cxAtMessage]=\"\n          'productFacetNavigation.increaseOptionsVisibility' | cxTranslate\n        \"\n        aria-expanded=\"false\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelShowMore' | cxTranslate\n        }}\"\n        class=\"cx-action-link\"\n        [cxFocus]=\"{ key: 'moreorless' }\"\n      >\n        {{ 'productList.showMore' | cxTranslate }}\n      </button>\n    </div>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: FacetService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }], {
    expandIcon: [{
      type: Input
    }],
    collapseIcon: [{
      type: Input
    }],
    isMultiSelect: [{
      type: HostBinding,
      args: ['class.multi-select']
    }],
    values: [{
      type: ViewChildren,
      args: ['facetValue']
    }],
    keyboardFocus: [{
      type: ViewChild,
      args: [FocusDirective]
    }],
    facetHeader: [{
      type: ViewChild,
      args: ['facetHeader']
    }],
    facet: [{
      type: Input
    }],
    featureConfigService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetListComponent {
  /**
   * Indicates that the facet navigation is rendered in dialog.
   */
  set isDialog(value) {
    this._isDialog = value;
    if (value) {
      this.renderer.addClass(document.body, 'modal-open');
    }
  }
  get isDialog() {
    return this._isDialog;
  }
  handleClick() {
    this.close();
  }
  constructor(facetService, elementRef, renderer) {
    this.facetService = facetService;
    this.elementRef = elementRef;
    this.renderer = renderer;
    this.subscriptions = new Subscription();
    /** Emits when the list must close */
    this.closeList = new EventEmitter();
    /** The list of all facet and values related to the products in the list */
    this.facetList$ = this.facetService.facetList$;
    this.iconTypes = ICON_TYPE;
    this.dialogFocusConfig = {
      trap: true,
      block: true,
      focusOnEscape: true,
      autofocus: 'cx-facet > button'
    };
    this.tabConfig = {
      label: 'productFacetNavigation.productFacets',
      mode: TAB_MODE.ACCORDIAN,
      openTabs: [0],
      restrictDirectionKeys: true
    };
    this.tabs$ = new BehaviorSubject([]);
    this.focusService = inject(KeyboardFocusService, {
      optional: true
    });
    this.featureConfigService = inject(FeatureConfigService, {
      optional: true
    });
    useFeatureStyles('a11yTabComponent');
  }
  ngOnInit() {
    this.enableFocusHandlingOnFacetListChanges();
    // Required to load facets when initial load in side panel.
    this.updateTabs();
  }
  ngAfterViewInit() {
    // Required to render facets when opening filters dialog.
    this.updateTabs();
    // Required to render facet changes (ie. select facet, etc)
    this.subscriptions.add(this.facetsRef.changes.pipe(filter(changes => !!changes)).subscribe(() => {
      this.updateTabs();
    }));
  }
  updateTabs() {
    this.facetList$.pipe(take(1)).subscribe(list => {
      const facets = list.facets;
      const tabs = facets.map((facet, i) => ({
        header: facet.name,
        content: this.facetsRef?.get(i),
        disableBorderFocus: true,
        id: i
      }));
      this.tabs$.next(tabs);
    });
  }
  /**
   * Toggles the facet group in case it is not expanded.
   */
  expandFacetGroup(facet, ref) {
    if (!ref.isExpanded) {
      this.facetService.toggle(facet, ref.isExpanded);
    }
  }
  /**
   * Indicates that the facet group has been expanded.
   */
  isExpanded(facet) {
    return this.facetService.getState(facet).pipe(map(value => value.toggled === FacetGroupCollapsedState.EXPANDED));
  }
  /**
   * Indicates that the facet group has been collapsed.
   */
  isCollapsed(facet) {
    return this.facetService.getState(facet).pipe(map(value => value.toggled === FacetGroupCollapsedState.COLLAPSED));
  }
  close(event) {
    this.renderer.removeClass(document.body, 'modal-open');
    this.closeList.emit(event);
  }
  block(event) {
    event?.stopPropagation();
  }
  enableFocusHandlingOnFacetListChanges() {
    this.subscriptions.add(this.facetService.facetList$.subscribe(facetList => this.handleDialogFocus(facetList.facets)));
  }
  handleDialogFocus(facets) {
    // Only apply new focus for the dialog view
    if (!this.isDialog) {
      return;
    }
    const focusKey = this.focusService?.get();
    if (!focusKey) {
      return;
    }
    const focusedFacet = facets.find(facet => facet.values?.some(value => {
      return value.name === focusKey;
    }));
    if (focusedFacet) {
      return;
    }
    if (!facets?.length) {
      // If there are no facets to display then focus on the "Back To Results" button
      this.backToResultsBtn?.nativeElement.focus();
      this.focusService?.clear();
      return;
    }
    const firstAvailableFacet = facets[0];
    this.focusService?.set(firstAvailableFacet.name);
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  static {
    this.ɵfac = function FacetListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FacetListComponent)(i0.ɵɵdirectiveInject(FacetService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: FacetListComponent,
      selectors: [["cx-facet-list"]],
      viewQuery: function FacetListComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c69, 5);
          i0.ɵɵviewQuery(_c70, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.backToResultsBtn = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.facetsRef = _t);
        }
      },
      hostBindings: function FacetListComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function FacetListComponent_click_HostBindingHandler() {
            return ctx.handleClick();
          });
        }
      },
      inputs: {
        isDialog: "isDialog"
      },
      outputs: {
        closeList: "closeList"
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["facetsRef", ""], ["facetRef", ""], ["backToResultsBtn", ""], ["class", "inner", 3, "cxFocus", "tabindex", "esc", "click", 4, "ngIf"], [1, "inner", 3, "esc", "click", "cxFocus", "tabindex"], [1, "list-header"], ["type", "button", 1, "close", 3, "click", "title"], ["aria-hidden", "true", 3, "type"], [4, "cxFeature"], ["class", "cx-facet-list-footer", 4, "ngIf"], [3, "tabs$", "config"], [4, "ngFor", "ngForOf"], ["role", "group", 3, "facet"], ["role", "group", 3, "facet", "expanded", "collapsed", 4, "ngFor", "ngForOf"], [1, "cx-facet-list-footer"], ["cxAutoFocus", "", 1, "btn", "btn-primary", 3, "click"]],
      template: function FacetListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, FacetListComponent_section_0_Template, 13, 19, "section", 3);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          let tmp_0_0;
          i0.ɵɵproperty("ngIf", (tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.facetList$)) == null ? null : tmp_0_0.facets);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, IconComponent, FacetComponent, FocusDirective, i1.FeatureDirective, TabComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FacetListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-facet-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<section\n  class=\"inner\"\n  *ngIf=\"(facetList$ | async)?.facets as facets\"\n  [attr.aria-label]=\"'productFacetNavigation.filterBy.facet' | cxTranslate\"\n  [cxFocus]=\"isDialog ? dialogFocusConfig : {}\"\n  [tabindex]=\"-1\"\n  (esc)=\"close($event)\"\n  (click)=\"block($event)\"\n>\n  <div class=\"list-header\">\n    <h4>{{ 'productList.filterBy.label' | cxTranslate }}</h4>\n    <button\n      type=\"button\"\n      class=\"close\"\n      title=\"{{ 'common.close' | cxTranslate }}\"\n      [attr.aria-label]=\"'common.close' | cxTranslate\"\n      (click)=\"close()\"\n    >\n      <cx-icon aria-hidden=\"true\" [type]=\"iconTypes.CLOSE\"></cx-icon>\n    </button>\n  </div>\n\n  <!--\n      Here we'd like to introduce configurable facet components,\n      either by using specific configuration or generic sproutlets\n  -->\n  <ng-container *cxFeature=\"'a11yTabComponent'\">\n    <cx-tab [tabs$]=\"tabs$\" [config]=\"tabConfig\"></cx-tab>\n\n    <ng-template #facetsRef *ngFor=\"let facet of facets\">\n      <cx-facet\n        [facet]=\"facet\"\n        role=\"group\"\n        attr.aria-label=\"{{\n          'productFacetNavigation.ariaLabelItemsAvailable'\n            | cxTranslate\n              : {\n                  name: facet.name,\n                  count: facet?.values?.length,\n                }\n        }}\"\n      ></cx-facet>\n    </ng-template>\n  </ng-container>\n\n  <ng-container *cxFeature=\"'!a11yTabComponent'\">\n    <cx-facet\n      *ngFor=\"let facet of facets\"\n      #facetRef\n      [facet]=\"facet\"\n      [class.expanded]=\"isExpanded(facet) | async\"\n      [class.collapsed]=\"isCollapsed(facet) | async\"\n      role=\"group\"\n      attr.aria-label=\"{{\n        'productFacetNavigation.ariaLabelItemsAvailable'\n          | cxTranslate\n            : {\n                name: facet.name,\n                count: facet?.values?.length,\n              }\n      }}\"\n    ></cx-facet>\n  </ng-container>\n\n  <div *ngIf=\"isDialog\" class=\"cx-facet-list-footer\">\n    <button\n      #backToResultsBtn\n      class=\"btn btn-primary\"\n      (click)=\"close()\"\n      cxAutoFocus\n    >\n      {{ 'productFacetNavigation.backToResults' | cxTranslate }}\n    </button>\n  </div>\n</section>\n"
    }]
  }], () => [{
    type: FacetService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.Renderer2
  }], {
    backToResultsBtn: [{
      type: ViewChild,
      args: ['backToResultsBtn']
    }],
    isDialog: [{
      type: Input
    }],
    closeList: [{
      type: Output
    }],
    facetsRef: [{
      type: ViewChildren,
      args: ['facetsRef']
    }],
    handleClick: [{
      type: HostListener,
      args: ['click']
    }],
    focusService: [{
      type: Optional
    }],
    featureConfigService: [{
      type: Optional
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetModule {
  static {
    this.ɵfac = function FacetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FacetModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FacetModule,
      declarations: [FacetComponent],
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, KeyboardFocusModule, RouterModule, UrlModule, FeaturesConfigModule],
      exports: [FacetComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, KeyboardFocusModule, RouterModule, UrlModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FacetModule, [{
    type: NgModule,
    args: [{
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, KeyboardFocusModule, RouterModule, UrlModule, FeaturesConfigModule],
      declarations: [FacetComponent],
      exports: [FacetComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class FacetListModule {
  static {
    this.ɵfac = function FacetListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FacetListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FacetListModule,
      declarations: [FacetListComponent],
      imports: [CommonModule, I18nModule, IconModule, FacetModule, KeyboardFocusModule, FeaturesConfigModule, TabModule],
      exports: [FacetListComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, I18nModule, IconModule, FacetModule, KeyboardFocusModule, FeaturesConfigModule, TabModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FacetListModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, IconModule, FacetModule, KeyboardFocusModule, FeaturesConfigModule, TabModule],
      declarations: [FacetListComponent],
      exports: [FacetListComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductFacetNavigationComponent {
  constructor(breakpointService) {
    this.breakpointService = breakpointService;
    this.iconTypes = ICON_TYPE;
    /**
     * We delay the removal of DOM so that animations can finish playing before the
     * DOM is removed. Removing the DOM, as hidding is not enough to stop elements
     * to be focused.
     */
    this.CLOSE_DELAY = 300;
    this.open$ = new BehaviorSubject(false);
    /**
     * Emits the open state that indicates whether the facet list should be rendered.
     * This is either done instantly, or after the user triggers this by using the trigger
     * button. This driven by the visiibility of the trigger, so that the CSS drives
     * the behaviour. This can differ per breakpoint.
     *
     * There's a configurable delay for the closed state, so that the DOM is not removed
     * before some CSS animations are done.
     */
    this.isOpen$ = this.breakpointService.breakpoint$.pipe(
    // deffer emitting a new value to the next micro-task to ensure that the `hasTrigger`
    // method represents the actual UI state.
    observeOn(asapScheduler), switchMap(() => this.hasTrigger ? this.open$ : of(true)), delayWhen(launched => interval(launched ? 0 : this.CLOSE_DELAY)));
    /**
     * Emits the active state that indicates whether the facet list is activated. Activation
     * is related to the css, so that a animation or transition can visualize opening/closing
     * the list (i.e. dialog).
     */
    this.isActive$ = this.open$.pipe(
    // deffer emitting a new value to the next micro-task to ensure the active class is
    //  applied after the DOM is created
    observeOn(asapScheduler));
  }
  launch() {
    this.open$.next(true);
  }
  close() {
    this.open$.next(false);
    this.trigger.nativeElement.focus();
  }
  /**
   * Indicates that the facet navigation should be open explicitely by a trigger.
   * This is fully controlled by CSS, where the trigger button can be hidden
   * (display:none) for certain screen sizes.
   */
  get hasTrigger() {
    return this.trigger.nativeElement.offsetParent !== null;
  }
  static {
    this.ɵfac = function ProductFacetNavigationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductFacetNavigationComponent)(i0.ɵɵdirectiveInject(BreakpointService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductFacetNavigationComponent,
      selectors: [["cx-product-facet-navigation"]],
      viewQuery: function ProductFacetNavigationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c71, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
        }
      },
      standalone: false,
      decls: 8,
      vars: 7,
      consts: [["trigger", ""], [1, "btn", "btn-secondary", "btn-block", "dialog-trigger", 3, "click"], [3, "type"], [3, "isDialog", "active", "dialog", "closeList", 4, "ngIf"], [3, "closeList", "isDialog"]],
      template: function ProductFacetNavigationComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "button", 1, 0);
          i0.ɵɵlistener("click", function ProductFacetNavigationComponent_Template_button_click_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.launch());
          });
          i0.ɵɵelement(2, "cx-icon", 2);
          i0.ɵɵtext(3);
          i0.ɵɵpipe(4, "cxTranslate");
          i0.ɵɵelementEnd();
          i0.ɵɵelement(5, "cx-active-facets");
          i0.ɵɵtemplate(6, ProductFacetNavigationComponent_cx_facet_list_6_Template, 2, 7, "cx-facet-list", 3);
          i0.ɵɵpipe(7, "async");
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("type", ctx.iconTypes.FILTER);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "productList.filterBy.label"), "\n");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 5, ctx.isOpen$));
        }
      },
      dependencies: [i3.NgIf, FacetListComponent, ActiveFacetsComponent, IconComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductFacetNavigationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-facet-navigation',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<button\n  #trigger\n  class=\"btn btn-secondary btn-block dialog-trigger\"\n  (click)=\"launch()\"\n>\n  <cx-icon [type]=\"iconTypes.FILTER\"></cx-icon>\n  {{ 'productList.filterBy.label' | cxTranslate }}\n</button>\n\n<cx-active-facets></cx-active-facets>\n\n<cx-facet-list\n  *ngIf=\"isOpen$ | async\"\n  [isDialog]=\"hasTrigger\"\n  (closeList)=\"close()\"\n  [class.active]=\"isActive$ | async\"\n  [class.dialog]=\"hasTrigger\"\n></cx-facet-list>\n"
    }]
  }], () => [{
    type: BreakpointService
  }], {
    trigger: [{
      type: ViewChild,
      args: ['trigger']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductFacetNavigationModule {
  static {
    this.ɵfac = function ProductFacetNavigationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductFacetNavigationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductFacetNavigationModule,
      declarations: [ProductFacetNavigationComponent],
      imports: [CommonModule, FacetListModule, ActiveFacetsModule, IconModule, I18nModule, i1.ConfigModule],
      exports: [ProductFacetNavigationComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FacetListModule, ActiveFacetsModule, IconModule, I18nModule, ConfigModule.withConfig({
        cmsComponents: {
          ProductRefinementComponent: {
            component: ProductFacetNavigationComponent
          }
        }
      })]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductFacetNavigationModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FacetListModule, ActiveFacetsModule, IconModule, I18nModule, ConfigModule.withConfig({
        cmsComponents: {
          ProductRefinementComponent: {
            component: ProductFacetNavigationComponent
          }
        }
      })],
      declarations: [ProductFacetNavigationComponent],
      exports: [ProductFacetNavigationComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultViewConfig = {
  view: {
    defaultPageSize: 12,
    infiniteScroll: {
      active: false,
      productLimit: 0,
      showMoreButton: false
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListModule {
  static {
    this.ɵfac = function ProductListModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductListModule,
      declarations: [ProductListComponent, ProductListItemComponent, ProductGridItemComponent, ProductViewComponent, ProductScrollComponent],
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, InfiniteScrollModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, RouterModule, SpinnerModule, StarRatingModule, UrlModule, FeaturesConfigModule],
      exports: [ProductListComponent, ProductListItemComponent, ProductGridItemComponent, ProductViewComponent, ProductScrollComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [ProductListService, provideDefaultConfig(defaultViewConfig), provideDefaultConfig({
        cmsComponents: {
          CMSProductListComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          },
          ProductGridComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          },
          SearchResultsListComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          }
        }
      })],
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, InfiniteScrollModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, RouterModule, SpinnerModule, StarRatingModule, UrlModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListModule, [{
    type: NgModule,
    args: [{
      imports: [AtMessageModule, CommonModule, I18nModule, IconModule, InfiniteScrollModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, RouterModule, SpinnerModule, StarRatingModule, UrlModule, FeaturesConfigModule],
      providers: [ProductListService, provideDefaultConfig(defaultViewConfig), provideDefaultConfig({
        cmsComponents: {
          CMSProductListComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          },
          ProductGridComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          },
          SearchResultsListComponent: {
            component: ProductListComponent,
            data: {
              composition: {
                inner: ['ProductAddToCartComponent']
              }
            }
          }
        }
      })],
      declarations: [ProductListComponent, ProductListItemComponent, ProductGridItemComponent, ProductViewComponent, ProductScrollComponent],
      exports: [ProductListComponent, ProductListItemComponent, ProductGridItemComponent, ProductViewComponent, ProductScrollComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselItemComponent {
  constructor(productListItemContextSource) {
    this.productListItemContextSource = productListItemContextSource;
  }
  ngOnChanges(changes) {
    if (changes?.item) {
      this.productListItemContextSource.product$.next(this.item);
    }
  }
  static {
    this.ɵfac = function ProductCarouselItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductCarouselItemComponent)(i0.ɵɵdirectiveInject(ProductListItemContextSource));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductCarouselItemComponent,
      selectors: [["cx-product-carousel-item"]],
      inputs: {
        item: "item"
      },
      standalone: false,
      features: [i0.ɵɵProvidersFeature([ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 9,
      consts: [["tabindex", "0", 3, "routerLink"], ["format", "product", 3, "container", "alt"], [1, "cx-product-name"], [1, "price"], [1, "actions"], ["cxInnerComponentsHost", ""]],
      template: function ProductCarouselItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "a", 0);
          i0.ɵɵpipe(1, "cxUrl");
          i0.ɵɵelement(2, "cx-media", 1);
          i0.ɵɵelementStart(3, "h3", 2);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "div", 4);
          i0.ɵɵelementContainer(8, 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_2_0;
          i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(1, 5, i0.ɵɵpureFunction1(7, _c48, ctx.item)));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("container", ctx.item.images == null ? null : ctx.item.images.PRIMARY)("alt", (tmp_2_0 = ctx.item.name) !== null && tmp_2_0 !== undefined ? tmp_2_0 : "");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.item.name, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.item.price == null ? null : ctx.item.price.formattedValue, " ");
        }
      },
      dependencies: [MediaComponent, i1$2.RouterLink, InnerComponentsHostDirective, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCarouselItemComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-carousel-item',
      providers: [ProductListItemContextSource, {
        provide: ProductListItemContext,
        useExisting: ProductListItemContextSource
      }],
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n  <cx-media\n    [container]=\"item.images?.PRIMARY\"\n    format=\"product\"\n    [alt]=\"item.name ?? ''\"\n  ></cx-media>\n  <h3 class=\"cx-product-name\">\n    {{ item.name }}\n  </h3>\n  <div class=\"price\">\n    {{ item.price?.formattedValue }}\n  </div>\n</a>\n<div class=\"actions\">\n  <ng-container cxInnerComponentsHost></ng-container>\n</div>\n"
    }]
  }], () => [{
    type: ProductListItemContextSource
  }], {
    item: [{
      type: Input
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselComponent {
  constructor(componentData, productService) {
    this.componentData = componentData;
    this.productService = productService;
    this.featureConfigService = inject(FeatureConfigService);
    this.productSearchByCodeService = inject(ProductSearchByCodeService);
    this.productSearchByCategoryService = inject(ProductSearchByCategoryService);
    this.PRODUCT_SCOPE = [ProductScope.LIST, ProductScope.STOCK];
    this.PRODUCT_SCOPE_ITEM = [ProductScope.LIST_ITEM];
    this.componentData$ = this.componentData.data$.pipe(filter(data => Boolean(data)));
    /**
     * returns an Observable string for the title.
     */
    this.title$ = this.componentData$.pipe(map(data => data.title));
    /**
     * Observable that holds an Array of Observables. This is done, so that
     * the component UI could consider to lazy load the UI components when they're
     * in the viewpoint.
     * If the inner component mapping exists (e.g. ProductAddToCartComponent), we aim to leverage the full scope;
     * otherwise, we prefer to minimize the scope for better performance.
     */
    this.items$ = this.componentData$.pipe(switchMap$1(data => this.handleCategoryCodes(data)), map(data => {
      const componentMappingExist = !!data.composition?.inner?.length;
      const codes = data.productCodes?.trim().split(' ') ?? [];
      return {
        componentMappingExist,
        codes
      };
    }), map(({
      componentMappingExist,
      codes
    }) => {
      if (this.featureConfigService.isEnabled('useProductCarouselBatchApi')) {
        const scope = componentMappingExist ? 'carousel' : 'carouselMinimal';
        return codes.map(code => this.productSearchByCodeService.get({
          code,
          scope
        }));
      } else {
        const productScope = componentMappingExist ? [...this.PRODUCT_SCOPE] : [...this.PRODUCT_SCOPE_ITEM];
        return codes.map(code => this.productService.get(code, productScope));
      }
    }));
  }
  handleCategoryCodes(data) {
    const categoryCodes = data?.categoryCodes?.split(' ');
    // Try to add category codes to the carousel product codes
    if (categoryCodes && this.featureConfigService.isEnabled('enableCarouselCategoryProducts')) {
      return zip(categoryCodes.map(categoryCode => this.productSearchByCategoryService.get({
        categoryCode,
        scope: ProductScope.CODE
      }))).pipe(map(results => {
        const codes = results.flat().map(product => product?.code).join(' ');
        return {
          ...data,
          productCodes: data.productCodes + ' ' + codes
        };
      }));
    }
    return of(data);
  }
  static {
    this.ɵfac = function ProductCarouselComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductCarouselComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.ProductService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductCarouselComponent,
      selectors: [["cx-product-carousel"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["carouselItem", ""], ["role", "region", "itemWidth", "285px", 3, "items", "title", "template", 4, "ngIf"], ["role", "region", "itemWidth", "285px", 3, "items", "title", "template"], [3, "item"]],
      template: function ProductCarouselComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductCarouselComponent_cx_carousel_0_Template, 4, 13, "cx-carousel", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ProductCarouselComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.items$));
        }
      },
      dependencies: [i3.NgIf, CarouselComponent, ProductCarouselItemComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCarouselComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-carousel',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-carousel\n  *ngIf=\"items$ | async as items\"\n  role=\"region\"\n  [attr.aria-label]=\"\n    'productCarousel.carouselLabel' | cxTranslate: { title: title$ | async }\n  \"\n  [items]=\"items\"\n  [title]=\"title$ | async\"\n  [template]=\"carouselItem\"\n  itemWidth=\"285px\"\n>\n</cx-carousel>\n\n<ng-template #carouselItem let-item=\"item\">\n  <cx-product-carousel-item [item]=\"item\"></cx-product-carousel-item>\n</ng-template>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: i1.ProductService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductCarouselModule {
  static {
    this.ɵfac = function ProductCarouselModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductCarouselModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductCarouselModule,
      declarations: [ProductCarouselComponent, ProductCarouselItemComponent],
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule, I18nModule, PageComponentModule],
      exports: [ProductCarouselComponent, ProductCarouselItemComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductCarouselComponent: {
            component: ProductCarouselComponent
          }
        }
      })],
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule, I18nModule, PageComponentModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductCarouselModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule, I18nModule, PageComponentModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductCarouselComponent: {
            component: ProductCarouselComponent
          }
        }
      })],
      declarations: [ProductCarouselComponent, ProductCarouselItemComponent],
      exports: [ProductCarouselComponent, ProductCarouselItemComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReferencesComponent {
  constructor(cmsComponentData, currentProductService, productReferenceService) {
    this.cmsComponentData = cmsComponentData;
    this.currentProductService = currentProductService;
    this.productReferenceService = productReferenceService;
    /**
     * Observable with an Array of Observables. This is done so that
     * the component UI could consider to lazy load the UI components when they're
     * in the viewpoint.
     */
    this.items$ = this.productCode$.pipe(withLatestFrom(this.componentData$), tap(([productCode, data]) => this.productReferenceService.loadProductReferences(productCode, data.productReferenceTypes)), switchMap(([productCode, data]) => this.getProductReferences(productCode, data.productReferenceTypes ?? '')));
  }
  get componentData$() {
    return this.cmsComponentData.data$.pipe(filter(data => Boolean(data)));
  }
  /**
   * Returns an Observable String for the product code
   */
  get productCode$() {
    return this.currentProductService.getProduct().pipe(filter(isNotNullable), map(product => product.code ?? ''), tap(_ => this.productReferenceService.cleanReferences()));
  }
  /**
   * Returns an Observable String for the title
   */
  get title$() {
    return this.componentData$.pipe(map(data => data?.title));
  }
  /**
   * Returns an observable for product references
   */
  getProductReferences(code, referenceType) {
    return this.productReferenceService.getProductReferences(code, referenceType).pipe(filter(references => Boolean(references)), map(references => references.map(reference => of(reference.target))));
  }
  static {
    this.ɵfac = function ProductReferencesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductReferencesComponent)(i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(CurrentProductService), i0.ɵɵdirectiveInject(i1.ProductReferenceService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductReferencesComponent,
      selectors: [["cx-product-references"]],
      standalone: false,
      decls: 4,
      vars: 3,
      consts: [["carouselItem", ""], [3, "title", "items", "template", 4, "ngIf"], [3, "title", "items", "template"], ["tabindex", "0", 3, "routerLink"], ["format", "product", 3, "container"], [1, "price"]],
      template: function ProductReferencesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductReferencesComponent_cx_carousel_0_Template, 2, 5, "cx-carousel", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ProductReferencesComponent_ng_template_2_Template, 7, 8, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.items$));
        }
      },
      dependencies: [i3.NgIf, CarouselComponent, MediaComponent, i1$2.RouterLink, i3.AsyncPipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductReferencesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-references',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<cx-carousel\n  *ngIf=\"items$ | async as items\"\n  [title]=\"title$ | async\"\n  [items]=\"items\"\n  [template]=\"carouselItem\"\n>\n</cx-carousel>\n\n<ng-template #carouselItem let-item=\"item\">\n  <a tabindex=\"0\" [routerLink]=\"{ cxRoute: 'product', params: item } | cxUrl\">\n    <cx-media [container]=\"item.images?.PRIMARY\" format=\"product\"></cx-media>\n    <h4>{{ item.name }}</h4>\n    <div class=\"price\">{{ item.price?.formattedValue }}</div>\n  </a>\n</ng-template>\n"
    }]
  }], () => [{
    type: CmsComponentData
  }, {
    type: CurrentProductService
  }, {
    type: i1.ProductReferenceService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReferencesModule {
  static {
    this.ɵfac = function ProductReferencesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductReferencesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductReferencesModule,
      declarations: [ProductReferencesComponent],
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule],
      exports: [ProductReferencesComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductReferencesComponent: {
            component: ProductReferencesComponent
          }
        }
      })],
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductReferencesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, CarouselModule, MediaModule, RouterModule, UrlModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductReferencesComponent: {
            component: ProductReferencesComponent
          }
        }
      })],
      declarations: [ProductReferencesComponent],
      exports: [ProductReferencesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductImagesComponent {
  constructor(currentProductService) {
    this.currentProductService = currentProductService;
    this.mainMediaContainer = new BehaviorSubject(null);
    this.product$ = this.currentProductService.getProduct().pipe(filter(isNotNullable), distinctUntilChanged(), tap(p => {
      this.mainMediaContainer.next(p.images?.PRIMARY ? p.images.PRIMARY : {});
    }));
    this.thumbs$ = this.product$.pipe(map(p => this.createThumbs(p)));
    this.mainImage$ = combineLatest([this.product$, this.mainMediaContainer]).pipe(map(([, container]) => container));
    useFeatureStyles('a11yDifferentiateFocusedAndSelected');
  }
  openImage(item) {
    this.mainMediaContainer.next(item);
  }
  isActive(thumbnail) {
    return this.mainMediaContainer.pipe(filter(Boolean), map(container => {
      return container.zoom && container.zoom.url && thumbnail.zoom && thumbnail.zoom.url && container.zoom.url === thumbnail.zoom.url;
    }));
  }
  /** find the index of the main media in the list of media */
  getActive(thumbs) {
    return this.mainMediaContainer.pipe(filter(Boolean), map(container => {
      const current = thumbs.find(t => t.media && container.zoom && t.media.container && t.media.container.zoom && t.media.container.zoom.url === container.zoom.url);
      return thumbs.indexOf(current);
    }));
  }
  /**
   * Return an array of CarouselItems for the product thumbnails.
   * In case there are less then 2 thumbs, we return null.
   */
  createThumbs(product) {
    if (!product.images || !product.images.GALLERY || Array.isArray(product.images.GALLERY) && product.images.GALLERY.length < 2) {
      return [];
    }
    return product.images.GALLERY.map(c => of({
      container: c
    }));
  }
  static {
    this.ɵfac = function ProductImagesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductImagesComponent)(i0.ɵɵdirectiveInject(CurrentProductService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductImagesComponent,
      selectors: [["cx-product-images"]],
      standalone: false,
      decls: 6,
      vars: 6,
      consts: [["thumb", ""], [4, "ngIf"], [3, "container"], ["class", "thumbs", "itemWidth", "120px", 3, "items", "hideIndicators", "template", 4, "ngIf"], ["itemWidth", "120px", 1, "thumbs", 3, "items", "hideIndicators", "template"], ["tabindex", "0", "format", "product", 3, "focus", "container"]],
      template: function ProductImagesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductImagesComponent_ng_container_0_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ProductImagesComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
          i0.ɵɵpipe(3, "async");
          i0.ɵɵtemplate(4, ProductImagesComponent_ng_template_4_Template, 2, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.mainImage$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.thumbs$));
        }
      },
      dependencies: [i3.NgIf, MediaComponent, CarouselComponent, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductImagesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-images',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"mainImage$ | async as main\">\n  <cx-media [container]=\"main\"></cx-media>\n</ng-container>\n\n<ng-container *ngIf=\"thumbs$ | async as thumbs\">\n  <cx-carousel\n    *ngIf=\"thumbs.length\"\n    class=\"thumbs\"\n    [items]=\"thumbs\"\n    itemWidth=\"120px\"\n    [hideIndicators]=\"false\"\n    [template]=\"thumb\"\n  ></cx-carousel>\n</ng-container>\n\n<ng-template #thumb let-item=\"item\">\n  <cx-media\n    [container]=\"item.container\"\n    tabindex=\"0\"\n    (focus)=\"openImage(item.container)\"\n    [class.is-active]=\"isActive(item.container) | async\"\n    format=\"product\"\n  >\n  </cx-media>\n</ng-template>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductImagesModule {
  static {
    this.ɵfac = function ProductImagesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductImagesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductImagesModule,
      declarations: [ProductImagesComponent],
      imports: [CommonModule, RouterModule, MediaModule, OutletModule, CarouselModule],
      exports: [ProductImagesComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductImagesComponent: {
            component: ProductImagesComponent
          }
        }
      })],
      imports: [CommonModule, RouterModule, MediaModule, OutletModule, CarouselModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductImagesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, MediaModule, OutletModule, CarouselModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductImagesComponent: {
            component: ProductImagesComponent
          }
        }
      })],
      declarations: [ProductImagesComponent],
      exports: [ProductImagesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductIntroComponent {
  constructor(currentProductService, translationService, winRef, eventService) {
    this.currentProductService = currentProductService;
    this.translationService = translationService;
    this.winRef = winRef;
    this.eventService = eventService;
    this.product$ = this.currentProductService.getProduct();
    this.featureConfigService = inject(FeatureConfigService);
    /**
     * Observable that checks the reviews component availability on the page.
     *
     * @deprecated This observable controlled whether we should show reviews based
     * on the review component's existence. Instead, we are now using the "product.averageRating"
     * to check whether reviews should exist. This observable with therefore be removed.
     */
    this.areReviewsAvailable$ = merge(
    // Check if reviews component is already defined:
    defer(() => of(!!this.getReviewsComponent())),
    // Observe EventService for reviews availability:
    this.eventService.get(ComponentCreateEvent).pipe(filter(event => event.id === this.reviewsComponentId), map(() => true)), this.eventService.get(ComponentDestroyEvent).pipe(filter(event => event.id === this.reviewsComponentId), map(() => false)));
    this.reviewsComponentId = 'ProductReviewsTabComponent';
    this.reviewsTranslationKey = `TabPanelContainer.tabs.${this.reviewsComponentId}`;
  }
  /**
   * Scroll to views component on page and click "Reviews" tab
   */
  showReviews() {
    // Use translated label for Reviews tab reference
    this.translationService.translate(this.reviewsTranslationKey).subscribe(reviewsTabLabel => {
      const tabsComponent = this.getTabsComponent();
      const reviewsTab = tabsComponent && this.getTabByLabel(reviewsTabLabel, tabsComponent);
      if (reviewsTab) {
        this.clickTabIfInactive(reviewsTab);
        setTimeout(() => {
          if (this.featureConfigService?.isEnabled('a11yScrollToReviewByShowReview')) {
            requestAnimationFrame(() => {
              reviewsTab.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
              reviewsTab.focus({
                preventScroll: true
              });
            });
          } else {
            reviewsTab.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            reviewsTab.focus({
              preventScroll: true
            });
          }
        });
      }
    }).unsubscribe();
  }
  // NOTE: Does not currently exists as its own component
  // but part of tabs component. This is likely to change in refactor.
  /**
   * Get Reviews Component if exists on page
   */
  getReviewsComponent() {
    return this.winRef.document.querySelector('cx-product-reviews');
  }
  /**
   * Get Tabs Component if exists on page
   */
  getTabsComponent() {
    return this.winRef.document.querySelector('cx-tab-paragraph-container');
  }
  /**
   * Click to activate tab if not already active
   *
   * @param tab tab to click if needed
   */
  clickTabIfInactive(tab) {
    if (!tab.classList.contains('active') || tab.classList.contains('toggled')) {
      tab.click();
    }
  }
  /**
   * Get Tab by label if exists on page
   *
   * @param label label of searched tab
   * @param tabsComponent component containing tabs
   */
  getTabByLabel(label, tabsComponent) {
    // NOTE: Reads through button tags to click on correct tab
    // There may be a better way of doing this now/after refactor
    const tabElements = tabsComponent.getElementsByTagName('button');
    // Look through button tab elements until finding tab with label
    return Array.from(tabElements).find(buttonElement => buttonElement.innerHTML.includes(label));
  }
  static {
    this.ɵfac = function ProductIntroComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductIntroComponent)(i0.ɵɵdirectiveInject(CurrentProductService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i1.WindowRef), i0.ɵɵdirectiveInject(i1.EventService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductIntroComponent,
      selectors: [["cx-product-intro"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], ["class", "rating", 4, "ngIf"], [1, "code"], [1, "rating"], [3, "rating"], [1, "count"], [4, "cxFeature"], ["class", "btn btn-tertiary", 3, "click", 4, "ngIf"], [1, "btn", "btn-tertiary", 3, "click"], ["class", "btn btn-link cx-action-link", 3, "click", 4, "ngIf"], [1, "btn", "btn-link", "cx-action-link", 3, "click"]],
      template: function ProductIntroComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductIntroComponent_ng_container_0_Template, 6, 6, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
        }
      },
      dependencies: [i3.NgIf, StarRatingComponent, i1.FeatureDirective, i3.AsyncPipe, i3.DecimalPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductIntroComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-intro',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"rating\" *ngIf=\"product?.averageRating\">\n    <cx-star-rating [rating]=\"product?.averageRating ?? 0\"></cx-star-rating>\n\n    <div class=\"count\">({{ product?.numberOfReviews }})</div>\n    <!-- TODO: (CXSPA-7603) - Remove feature flag next major release. -->\n    <ng-container *cxFeature=\"'a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"product?.averageRating\"\n        class=\"btn btn-tertiary\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n    <ng-container *cxFeature=\"'!a11yLinkBtnsToTertiaryBtns'\">\n      <button\n        *ngIf=\"areReviewsAvailable$ | async\"\n        class=\"btn btn-link cx-action-link\"\n        (click)=\"showReviews()\"\n        [attr.aria-label]=\"\n          'productSummary.showReviewsDetailed'\n            | cxTranslate\n              : {\n                  rating: product?.averageRating | number: '1.0-1',\n                  count: product?.numberOfReviews,\n                }\n        \"\n      >\n        {{ 'productSummary.showReviews' | cxTranslate }}\n      </button>\n    </ng-container>\n  </div>\n  <div class=\"rating\" *ngIf=\"!product?.averageRating\">\n    {{ 'productDetails.noReviews' | cxTranslate }}\n  </div>\n  <div class=\"code\">\n    {{ 'productSummary.id' | cxTranslate }} {{ product?.code }}\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.WindowRef
  }, {
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductIntroModule {
  static {
    this.ɵfac = function ProductIntroModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductIntroModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductIntroModule,
      declarations: [ProductIntroComponent],
      imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule],
      exports: [ProductIntroComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductIntroComponent: {
            component: ProductIntroComponent
          }
        }
      })],
      imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductIntroModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule, StarRatingModule, FeaturesConfigModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductIntroComponent: {
            component: ProductIntroComponent
          }
        }
      })],
      declarations: [ProductIntroComponent],
      exports: [ProductIntroComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductSummaryComponent {
  getProduct() {
    const productScopes = [ProductScope.DETAILS, ProductScope.PRICE, ProductScope.PROMOTIONS];
    return this.currentProductService.getProduct(productScopes);
  }
  constructor(currentProductService) {
    this.currentProductService = currentProductService;
    this.outlets = ProductDetailOutlets;
    this.product$ = this.getProduct();
  }
  static {
    this.ɵfac = function ProductSummaryComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductSummaryComponent)(i0.ɵɵdirectiveInject(CurrentProductService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductSummaryComponent,
      selectors: [["cx-product-summary"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [3, "cxOutlet", "cxOutletContext"], [3, "promotions"], [1, "price"], [1, "summary", 3, "innerHTML"]],
      template: function ProductSummaryComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductSummaryComponent_ng_container_0_Template, 4, 9, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
        }
      },
      dependencies: [i3.NgIf, OutletDirective, PromotionsComponent, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductSummaryComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-summary',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"product$ | async as product\">\n  <ng-container *ngIf=\"product.potentialPromotions\">\n    <cx-promotions [promotions]=\"product.potentialPromotions\"></cx-promotions>\n  </ng-container>\n\n  <ng-template\n    [cxOutlet]=\"outlets.PRICE\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <div\n      [attr.aria-label]=\"'productSummary.newItemPrice' | cxTranslate\"\n      class=\"price\"\n    >\n      {{ product?.price?.formattedValue }}\n    </div>\n  </ng-template>\n\n  <ng-template\n    [cxOutlet]=\"outlets.SUMMARY\"\n    [cxOutletContext]=\"{ product: product }\"\n  >\n    <p [innerHTML]=\"product?.summary\" class=\"summary\"></p>\n  </ng-template>\n\n  <!-- @TODO: Temp. Comment out share link while not in use by CMS -->\n  <!-- <ng-container *cxOutlet=\"outlets.SHARE\">\n        <div>\n          <a href=\"#\" class=\"share btn-link\">\n            {{ 'productSummary.share' | cxTranslate }}\n          </a>\n        </div>\n      </ng-container> -->\n</ng-container>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductSummaryModule {
  static {
    this.ɵfac = function ProductSummaryModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductSummaryModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductSummaryModule,
      declarations: [ProductSummaryComponent],
      imports: [CommonModule, OutletModule, I18nModule, PromotionsModule, FeaturesConfigModule],
      exports: [ProductSummaryComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductSummaryComponent: {
            component: ProductSummaryComponent
          }
        }
      })],
      imports: [CommonModule, OutletModule, I18nModule, PromotionsModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductSummaryModule, [{
    type: NgModule,
    args: [{
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductSummaryComponent: {
            component: ProductSummaryComponent
          }
        }
      })],
      declarations: [ProductSummaryComponent],
      exports: [ProductSummaryComponent],
      imports: [CommonModule, OutletModule, I18nModule, PromotionsModule, FeaturesConfigModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductAttributesComponent {
  constructor(currentProductService) {
    this.currentProductService = currentProductService;
    this.product$ = this.currentProductService.getProduct(ProductScope.ATTRIBUTES);
  }
  static {
    this.ɵfac = function ProductAttributesComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductAttributesComponent)(i0.ɵɵdirectiveInject(CurrentProductService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductAttributesComponent,
      selectors: [["cx-product-attributes"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "container"], [4, "ngFor", "ngForOf"]],
      template: function ProductAttributesComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductAttributesComponent_ng_container_0_Template, 6, 4, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i3.AsyncPipe, i1.TranslatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductAttributesComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-attributes',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\">\n    <h2>{{ 'productDetails.specification' | cxTranslate }}</h2>\n    <table *ngFor=\"let class of product?.classifications\">\n      <th>\n        <h2>{{ class.name }}</h2>\n      </th>\n      <tr *ngFor=\"let feature of class.features\">\n        <td>{{ feature.name }}</td>\n        <td>\n          <ul>\n            <li *ngFor=\"let featureValue of feature?.featureValues\">\n              {{ featureValue?.value }}\n              <span\n                *ngIf=\"\n                  feature.featureUnit &&\n                  feature.featureUnit.symbol &&\n                  feature.featureUnit.symbol.length > 0 &&\n                  feature.featureUnit?.unitType !== '300'\n                \"\n              >\n                {{ feature.featureUnit?.symbol }}\n              </span>\n            </li>\n          </ul>\n        </td>\n      </tr>\n    </table>\n  </div>\n</ng-container>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductAttributesModule {
  static {
    this.ɵfac = function ProductAttributesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductAttributesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductAttributesModule,
      declarations: [ProductAttributesComponent],
      imports: [CommonModule, I18nModule],
      exports: [ProductAttributesComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductSpecsTabComponent: {
            component: ProductAttributesComponent
          }
        }
      })],
      imports: [CommonModule, I18nModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductAttributesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, I18nModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductSpecsTabComponent: {
            component: ProductAttributesComponent
          }
        }
      })],
      declarations: [ProductAttributesComponent],
      exports: [ProductAttributesComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsTabComponent {
  constructor(currentProductService, componentData, cmsService) {
    this.currentProductService = currentProductService;
    this.componentData = componentData;
    this.cmsService = cmsService;
    this.children$ = this.componentData.data$.pipe(switchMap(data => combineLatest((data?.children ?? '').split(' ').map(component => this.cmsService.getComponentData(component).pipe(distinctUntilChanged(), map(child => {
      if (!child) {
        return undefined;
      }
      if (!child.flexType) {
        child = {
          ...child,
          flexType: child.typeCode
        };
      }
      return child;
    }))))));
  }
  ngOnInit() {
    this.product$ = this.currentProductService.getProduct();
  }
  static {
    this.ɵfac = function ProductDetailsTabComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductDetailsTabComponent)(i0.ɵɵdirectiveInject(CurrentProductService), i0.ɵɵdirectiveInject(CmsComponentData), i0.ɵɵdirectiveInject(i1.CmsService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductDetailsTabComponent,
      selectors: [["cx-product-details-tab"]],
      standalone: false,
      decls: 4,
      vars: 6,
      consts: [[4, "ngIf"], [1, "container", 3, "innerHTML"], [4, "ngFor", "ngForOf"], [3, "cxOutlet", "cxOutletContext"], [1, "container"], [3, "cxComponentWrapper"]],
      template: function ProductDetailsTabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductDetailsTabComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, ProductDetailsTabComponent_ng_container_2_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(3, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.product$));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.children$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, ComponentWrapperDirective, OutletDirective, i3.AsyncPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductDetailsTabComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-details-tab',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"product$ | async as product\">\n  <div class=\"container\" [innerHTML]=\"product?.description\"></div>\n</ng-container>\n<ng-container *ngIf=\"children$ | async as children\">\n  <ng-container *ngFor=\"let child of children\">\n    <ng-container *ngIf=\"child\">\n      <ng-template [cxOutlet]=\"child.flexType\" [cxOutletContext]=\"{}\">\n        <div class=\"container\">\n          <ng-container [cxComponentWrapper]=\"child\"></ng-container>\n        </div>\n      </ng-template>\n    </ng-container>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }, {
    type: CmsComponentData
  }, {
    type: i1.CmsService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsTabModule {
  static {
    this.ɵfac = function ProductDetailsTabModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductDetailsTabModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductDetailsTabModule,
      declarations: [ProductDetailsTabComponent],
      imports: [CommonModule, PageComponentModule, OutletModule],
      exports: [ProductDetailsTabComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductDetailsTabComponent: {
            component: ProductDetailsTabComponent
          }
        }
      })],
      imports: [CommonModule, PageComponentModule, OutletModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductDetailsTabModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, PageComponentModule, OutletModule],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductDetailsTabComponent: {
            component: ProductDetailsTabComponent
          }
        }
      })],
      declarations: [ProductDetailsTabComponent],
      exports: [ProductDetailsTabComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReviewsComponent {
  constructor(reviewService, currentProductService, fb, cd) {
    this.reviewService = reviewService;
    this.currentProductService = currentProductService;
    this.fb = fb;
    this.cd = cd;
    this.isWritingReview = false;
    // TODO: configurable
    this.initialMaxListItems = 5;
    this.product$ = this.currentProductService.getProduct();
    this.reviews$ = this.product$.pipe(filter(isNotNullable), map(p => p.code ?? ''), distinctUntilChanged(), switchMap(productCode => this.reviewService.getByProductCode(productCode)), tap(() => {
      this.resetReviewForm();
      this.maxListItems = this.initialMaxListItems;
    }));
  }
  initiateWriteReview() {
    this.isWritingReview = true;
    this.cd.detectChanges();
    if (this.titleInput && this.titleInput.nativeElement) {
      this.titleInput.nativeElement.focus();
    }
  }
  cancelWriteReview() {
    this.isWritingReview = false;
    this.resetReviewForm();
    this.cd.detectChanges();
    if (this.writeReviewButton && this.writeReviewButton.nativeElement) {
      this.writeReviewButton.nativeElement.focus();
    }
  }
  setRating(rating) {
    this.reviewForm.controls.rating.setValue(rating);
  }
  submitReview(product) {
    if (this.reviewForm.valid) {
      this.addReview(product);
    } else {
      this.reviewForm.markAllAsTouched();
    }
  }
  addReview(product) {
    const reviewFormControls = this.reviewForm.controls;
    const review = {
      headline: reviewFormControls.title.value,
      comment: reviewFormControls.comment.value,
      rating: reviewFormControls.rating.value,
      alias: reviewFormControls.reviewerName.value
    };
    this.reviewService.add(product.code ?? '', review);
    this.isWritingReview = false;
    this.resetReviewForm();
    this.cd.detectChanges();
    if (this.writeReviewButton && this.writeReviewButton.nativeElement) {
      this.writeReviewButton.nativeElement.focus();
    }
  }
  resetReviewForm() {
    this.reviewForm = this.fb.group({
      title: ['', Validators.required],
      comment: ['', Validators.required],
      rating: [null, Validators.required],
      reviewerName: ''
    });
  }
  static {
    this.ɵfac = function ProductReviewsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductReviewsComponent)(i0.ɵɵdirectiveInject(i1.ProductReviewService), i0.ɵɵdirectiveInject(CurrentProductService), i0.ɵɵdirectiveInject(i1$4.UntypedFormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ProductReviewsComponent,
      selectors: [["cx-product-reviews"]],
      viewQuery: function ProductReviewsComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c73, 5);
          i0.ɵɵviewQuery(_c74, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.titleInput = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.writeReviewButton = _t.first);
        }
      },
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [["writeReview", ""], ["writeReviewButton", ""], ["titleInput", ""], ["class", "container", 4, "ngIf"], [1, "container"], [4, "ngIf", "ngIfElse"], [1, "header"], [1, "btn", "btn-primary", 3, "click"], ["class", "rating", 3, "rating", 4, "ngIf"], ["class", "rating", 4, "ngIf"], [1, "rating", 3, "rating"], [1, "rating"], [4, "ngIf"], ["class", "review", "tabindex", "0", 4, "ngFor", "ngForOf"], ["tabindex", "0", 1, "review"], [1, "title"], [3, "rating"], [1, "name"], [1, "date"], [1, "text"], ["aria-live", "polite", "class", "btn btn-primary", 3, "click", 4, "cxFeature"], [4, "cxFeature"], ["aria-live", "polite", 1, "btn", "btn-primary", 3, "click"], ["class", "btn btn-primary", 3, "click", 4, "ngIf"], [3, "ngSubmit", "formGroup"], [1, "form-group"], [1, "label-content"], ["required", "true", "type", "text", "formControlName", "title", 1, "form-control"], ["id", "titleError", 3, "translationParams", "control"], ["required", "true", "rows", "3", "formControlName", "comment", 1, "form-control"], ["id", "commentError", 3, "translationParams", "control"], ["required", "true", "type", "number", "formControlName", "rating", 1, "rating-input"], ["tabindex", "0", 3, "change", "disabled"], ["id", "ratingError", 3, "translationParams", "control"], ["type", "text", "formControlName", "reviewerName", 1, "form-control"], [1, "form-group", "row"], [1, "col-12", "col-md-4"], ["type", "button", 1, "btn", "btn-block", "btn-secondary", 3, "click"], ["type", "submit", 1, "btn", "btn-block", "btn-primary"]],
      template: function ProductReviewsComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, ProductReviewsComponent_div_0_Template, 7, 6, "div", 3);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.product$));
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i1$4.ɵNgNoValidate, i1$4.DefaultValueAccessor, i1$4.NumberValueAccessor, i1$4.NgControlStatus, i1$4.NgControlStatusGroup, i1$4.RequiredValidator, i1$4.FormGroupDirective, i1$4.FormControlName, StarRatingComponent, FormErrorsComponent, i1.FeatureDirective, FormRequiredAsterisksComponent, FormRequiredLegendComponent, i3.AsyncPipe, i3.SlicePipe, i1.TranslatePipe, i1.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductReviewsComponent, [{
    type: Component,
    args: [{
      selector: 'cx-product-reviews',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"container\" *ngIf=\"product$ | async as product\">\n  <h2>\n    {{ 'productDetails.reviews' | cxTranslate }} ({{ product.numberOfReviews }})\n  </h2>\n  <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n    <div class=\"header\">\n      <h3>{{ 'productReview.overallRating' | cxTranslate }}</h3>\n      <button\n        #writeReviewButton\n        class=\"btn btn-primary\"\n        (click)=\"initiateWriteReview()\"\n      >\n        {{ 'productReview.writeReview' | cxTranslate }}\n      </button>\n      <cx-star-rating\n        *ngIf=\"product.averageRating\"\n        class=\"rating\"\n        [rating]=\"product.averageRating\"\n      ></cx-star-rating>\n      <div class=\"rating\" *ngIf=\"!product.averageRating\">\n        {{ 'productDetails.noReviews' | cxTranslate }}\n      </div>\n    </div>\n\n    <ng-container *ngIf=\"!isWritingReview; else writeReview\">\n      <ng-container *ngIf=\"reviews$ | async as reviews\">\n        <div\n          class=\"review\"\n          tabindex=\"0\"\n          *ngFor=\"let review of reviews | slice: 0 : maxListItems\"\n        >\n          <div class=\"title\">{{ review.headline }}</div>\n          <cx-star-rating [rating]=\"review.rating ?? 0\"></cx-star-rating>\n          <div class=\"name\">\n            {{ review.alias ? review.alias : review.principal?.name }}\n          </div>\n          <div class=\"date\">{{ review.date | cxDate }}</div>\n          <div class=\"text\">{{ review.comment }}</div>\n        </div>\n        <div *ngIf=\"reviews.length > initialMaxListItems\">\n          <button\n            *cxFeature=\"'a11yShowMoreReviewsBtnFocus'\"\n            aria-live=\"polite\"\n            class=\"btn btn-primary\"\n            (click)=\"\n              maxListItems === initialMaxListItems\n                ? (maxListItems = reviews.length)\n                : (maxListItems = initialMaxListItems)\n            \"\n          >\n            {{\n              (maxListItems === initialMaxListItems\n                ? 'productReview.more'\n                : 'productReview.less'\n              ) | cxTranslate\n            }}\n          </button>\n          <ng-container *cxFeature=\"'!a11yShowMoreReviewsBtnFocus'\">\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = reviews.length\"\n              *ngIf=\"maxListItems === initialMaxListItems\"\n            >\n              {{ 'productReview.more' | cxTranslate }}\n            </button>\n            <button\n              class=\"btn btn-primary\"\n              (click)=\"maxListItems = initialMaxListItems\"\n              *ngIf=\"maxListItems !== initialMaxListItems\"\n            >\n              {{ 'productReview.less' | cxTranslate }}\n            </button>\n          </ng-container>\n        </div>\n      </ng-container>\n    </ng-container>\n  </ng-container>\n\n  <ng-template #writeReview>\n    <!-- TODO: (CXSPA-5953) Remove feature flags next major -->\n    <cx-form-required-legend />\n    <form (ngSubmit)=\"submitReview(product)\" [formGroup]=\"reviewForm\">\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewTitle' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            #titleInput\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"title\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('title')?.touched &&\n              reviewForm.get('title')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'titleError'\"\n          />\n\n          <cx-form-errors\n            id=\"titleError\"\n            [translationParams]=\"{\n              label: 'productReview.reviewTitle' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('title')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.writeYourComments' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <textarea\n            required=\"true\"\n            class=\"form-control\"\n            rows=\"3\"\n            formControlName=\"comment\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('comment')?.touched &&\n              reviewForm.get('comment')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'commentError'\"\n          ></textarea>\n\n          <cx-form-errors\n            id=\"commentError\"\n            [translationParams]=\"{\n              label: 'productReview.writeYourComments' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('comment')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.rating' | cxTranslate }}\n            <cx-form-required-asterisks />\n          </span>\n          <input\n            required=\"true\"\n            type=\"number\"\n            formControlName=\"rating\"\n            class=\"rating-input\"\n            [attr.aria-invalid]=\"\n              reviewForm.get('rating')?.touched &&\n              reviewForm.get('rating')?.invalid\n            \"\n            [attr.aria-errormessage]=\"'ratingError'\"\n          />\n          <cx-star-rating\n            tabindex=\"0\"\n            [attr.aria-label]=\"'productReview.ratingRequired' | cxTranslate\"\n            (change)=\"setRating($event)\"\n            [disabled]=\"false\"\n          ></cx-star-rating>\n\n          <cx-form-errors\n            id=\"ratingError\"\n            [translationParams]=\"{\n              label: 'productReview.rating' | cxTranslate,\n            }\"\n            [control]=\"reviewForm.get('rating')\"\n          ></cx-form-errors>\n        </label>\n      </div>\n      <div class=\"form-group\">\n        <label>\n          <span class=\"label-content\"\n            >{{ 'productReview.reviewerName' | cxTranslate }}\n          </span>\n          <input\n            type=\"text\"\n            class=\"form-control\"\n            formControlName=\"reviewerName\"\n          />\n        </label>\n      </div>\n      <div class=\"form-group row\">\n        <div class=\"col-12 col-md-4\">\n          <button\n            type=\"button\"\n            class=\"btn btn-block btn-secondary\"\n            (click)=\"cancelWriteReview()\"\n          >\n            {{ 'common.cancel' | cxTranslate }}\n          </button>\n        </div>\n        <div class=\"col-12 col-md-4\">\n          <button type=\"submit\" class=\"btn btn-block btn-primary\">\n            {{ 'common.submit' | cxTranslate }}\n          </button>\n        </div>\n      </div>\n    </form>\n  </ng-template>\n</div>\n"
    }]
  }], () => [{
    type: i1.ProductReviewService
  }, {
    type: CurrentProductService
  }, {
    type: i1$4.UntypedFormBuilder
  }, {
    type: i0.ChangeDetectorRef
  }], {
    titleInput: [{
      type: ViewChild,
      args: ['titleInput', {
        static: false
      }]
    }],
    writeReviewButton: [{
      type: ViewChild,
      args: ['writeReviewButton', {
        static: false
      }]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductReviewsModule {
  static {
    this.ɵfac = function ProductReviewsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductReviewsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductReviewsModule,
      declarations: [ProductReviewsComponent],
      imports: [CommonModule, ReactiveFormsModule, FormsModule, I18nModule, StarRatingModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      exports: [ProductReviewsComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductReviewsTabComponent: {
            component: ProductReviewsComponent
          }
        }
      })],
      imports: [CommonModule, ReactiveFormsModule, FormsModule, I18nModule, StarRatingModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductReviewsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, ReactiveFormsModule, FormsModule, I18nModule, StarRatingModule, FormErrorsModule, FeaturesConfigModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          ProductReviewsTabComponent: {
            component: ProductReviewsComponent
          }
        }
      })],
      declarations: [ProductReviewsComponent],
      exports: [ProductReviewsComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductTabsModule {
  static {
    this.ɵfac = function ProductTabsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductTabsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductTabsModule,
      imports: [ProductAttributesModule, ProductDetailsTabModule, ProductReviewsModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [ProductAttributesModule, ProductDetailsTabModule, ProductReviewsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductTabsModule, [{
    type: NgModule,
    args: [{
      imports: [ProductAttributesModule, ProductDetailsTabModule, ProductReviewsModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationDialogComponent {
  handleClick(event) {
    if (event.target.tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
  constructor(interestsService, launchDialogService, el) {
    this.interestsService = interestsService;
    this.launchDialogService = launchDialogService;
    this.el = el;
    this.subscription = new Subscription();
    this.enabledPrefs = [];
    this.focusConfig = {
      trap: true,
      block: true,
      autofocus: 'button',
      focusOnEscape: true
    };
  }
  close(reason) {
    this.launchDialogService.closeDialog(reason);
  }
  ngOnInit() {
    this.subscription.add(this.launchDialogService.data$.subscribe(data => {
      if (data) {
        this.init(data.subscribeSuccess$, data.enabledPrefs);
      }
    }));
  }
  init(subscribeSuccess$, enabledPrefs) {
    this.subscribeSuccess$ = subscribeSuccess$;
    this.enabledPrefs = enabledPrefs;
  }
  ngOnDestroy() {
    if (this.subscribeSuccess$) {
      this.subscribeSuccess$.subscribe(success => {
        if (success) {
          this.interestsService.resetAddInterestState();
        }
      }).unsubscribe();
    }
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function StockNotificationDialogComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StockNotificationDialogComponent)(i0.ɵɵdirectiveInject(i1.UserInterestsService), i0.ɵɵdirectiveInject(LaunchDialogService), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StockNotificationDialogComponent,
      selectors: [["cx-stock-notification-dialog"]],
      hostBindings: function StockNotificationDialogComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function StockNotificationDialogComponent_click_HostBindingHandler($event) {
            return ctx.handleClick($event);
          });
        }
      },
      standalone: false,
      decls: 13,
      vars: 10,
      consts: [["loading", ""], ["role", "dialog", "aria-labelledby", "dialogTitle", 1, "modal-dialog", "modal-dialog-centered", "modal-lg", 3, "esc", "cxFocus"], [1, "modal-content"], [1, "cx-dialog-header", "cx-modal-header"], ["id", "dialogTitle", "class", "cx-dialog-title modal-title", 4, "cxFeature"], ["type", "button", "tabindex", "-1", 1, "close", 3, "click"], ["aria-hidden", "true"], [4, "ngIf", "ngIfElse"], ["id", "dialogTitle", 1, "cx-dialog-title", "modal-title"], ["role", "status", 4, "cxFeature"], [1, "cx-dialog-body", "modal-body"], [1, "cx-stock-notification-content"], [1, "cx-stock-notification-text"], ["class", "channels", 4, "ngFor", "ngForOf"], [1, "link-prefs", "cx-stock-notification-link", 3, "click", "routerLink"], [1, "link-interests", "cx-stock-notification-link", 3, "click", "routerLink"], [1, "cx-modal-footer"], [1, "row"], [1, "cx-dialog-actions", "col-sm-12", "col-md-4", "offset-md-8", "col-lg-3", "offset-lg-9"], ["type", "button", 1, "btn", "btn-primary", "btn-block", "btn-ok", 3, "click"], ["role", "status"], [1, "channels"], [4, "ngIf"], [1, "cx-dialog-row"], [1, "col-sm-12"]],
      template: function StockNotificationDialogComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵlistener("esc", function StockNotificationDialogComponent_Template_div_esc_0_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Escape clicked"));
          });
          i0.ɵɵelementStart(1, "div", 2)(2, "div", 3);
          i0.ɵɵtemplate(3, StockNotificationDialogComponent_h3_3_Template, 3, 3, "h3", 4)(4, StockNotificationDialogComponent_div_4_Template, 3, 3, "div", 4);
          i0.ɵɵelementStart(5, "button", 5);
          i0.ɵɵpipe(6, "cxTranslate");
          i0.ɵɵlistener("click", function StockNotificationDialogComponent_Template_button_click_5_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.close("Button clicked"));
          });
          i0.ɵɵelementStart(7, "span", 6);
          i0.ɵɵtext(8, "\xD7");
          i0.ɵɵelementEnd()()();
          i0.ɵɵtemplate(9, StockNotificationDialogComponent_ng_container_9_Template, 35, 37, "ng-container", 7);
          i0.ɵɵpipe(10, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(11, StockNotificationDialogComponent_ng_template_11_Template, 7, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          const loading_r5 = i0.ɵɵreference(12);
          i0.ɵɵproperty("cxFocus", ctx.focusConfig);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("cxFeature", "a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵproperty("cxFeature", "!a11yDialogsHeading");
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 6, "common.close"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(10, 8, ctx.subscribeSuccess$))("ngIfElse", loading_r5);
        }
      },
      dependencies: [i3.NgForOf, i3.NgIf, i1$2.RouterLink, SpinnerComponent, FocusDirective, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StockNotificationDialogComponent, [{
    type: Component,
    args: [{
      selector: 'cx-stock-notification-dialog',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div\n  class=\"modal-dialog modal-dialog-centered modal-lg\"\n  role=\"dialog\"\n  [cxFocus]=\"focusConfig\"\n  (esc)=\"close('Escape clicked')\"\n  aria-labelledby=\"dialogTitle\"\n>\n  <div class=\"modal-content\">\n    <div class=\"cx-dialog-header cx-modal-header\">\n      <h3\n        *cxFeature=\"'a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n      >\n        {{ 'stockNotification.subscriptionDialog.header' | cxTranslate }}\n      </h3>\n      <div\n        *cxFeature=\"'!a11yDialogsHeading'\"\n        id=\"dialogTitle\"\n        class=\"cx-dialog-title modal-title\"\n      >\n        {{ 'stockNotification.subscriptionDialog.header' | cxTranslate }}\n      </div>\n      <button\n        type=\"button\"\n        [attr.aria-label]=\"'common.close' | cxTranslate\"\n        class=\"close\"\n        tabindex=\"-1\"\n        (click)=\"close('Button clicked')\"\n      >\n        <span aria-hidden=\"true\">&times;</span>\n      </button>\n    </div>\n\n    <ng-container *ngIf=\"subscribeSuccess$ | async; else loading\">\n      <div\n        *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n        role=\"status\"\n        [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n      ></div>\n      <div class=\"cx-dialog-body modal-body\">\n        <div class=\"cx-stock-notification-content\">\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedPrefix'\n                | cxTranslate\n            }}\n          </p>\n          <p *ngFor=\"let preference of enabledPrefs\" class=\"channels\">\n            <span>{{ preference.channel }}</span\n            ><span *ngIf=\"preference.value\">{{ ': ' + preference.value }}</span>\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.notifiedSuffix'\n                | cxTranslate\n            }}\n          </p>\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\"\n              class=\"link-prefs cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageChannelsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageChannelsSuffix'\n                | cxTranslate\n            }}\n          </p>\n\n          <p class=\"cx-stock-notification-text\">\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsPrefix'\n                | cxTranslate\n            }}\n            <a\n              (click)=\"close('Link clicked')\"\n              [routerLink]=\"{ cxRoute: 'myInterests' } | cxUrl\"\n              class=\"link-interests cx-stock-notification-link\"\n            >\n              {{\n                'stockNotification.subscriptionDialog.manageSubscriptionsLink'\n                  | cxTranslate\n              }}</a\n            >\n            {{\n              'stockNotification.subscriptionDialog.manageSubscriptionsSuffix'\n                | cxTranslate\n            }}\n          </p>\n        </div>\n      </div>\n      <div class=\"cx-modal-footer\">\n        <div class=\"row\">\n          <div\n            class=\"cx-dialog-actions col-sm-12 col-md-4 offset-md-8 col-lg-3 offset-lg-9\"\n          >\n            <button\n              class=\"btn btn-primary btn-block btn-ok\"\n              type=\"button\"\n              (click)=\"close('Button clicked')\"\n            >\n              {{ 'stockNotification.subscriptionDialog.okBtn' | cxTranslate }}\n            </button>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </div>\n\n  <ng-template #loading>\n    <div class=\"cx-dialog-body modal-body\">\n      <p>\n        {{ 'stockNotification.subscriptionDialog.subscribing' | cxTranslate }}\n      </p>\n      <div class=\"cx-dialog-row\">\n        <div class=\"col-sm-12\">\n          <cx-spinner></cx-spinner>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n</div>\n"
    }]
  }], () => [{
    type: i1.UserInterestsService
  }, {
    type: LaunchDialogService
  }, {
    type: i0.ElementRef
  }], {
    handleClick: [{
      type: HostListener,
      args: ['click', ['$event']]
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationComponent {
  constructor(currentProductService, globalMessageService, translationService, interestsService, notificationPrefService, userIdService, launchDialogService, vcr) {
    this.currentProductService = currentProductService;
    this.globalMessageService = globalMessageService;
    this.translationService = translationService;
    this.interestsService = interestsService;
    this.notificationPrefService = notificationPrefService;
    this.userIdService = userIdService;
    this.launchDialogService = launchDialogService;
    this.vcr = vcr;
    this.anonymous = true;
    this.enabledPrefs = [];
    this.subscriptions = new Subscription();
  }
  ngOnInit() {
    this.outOfStock$ = combineLatest([this.currentProductService.getProduct().pipe(filter(isNotNullable)), this.userIdService.getUserId()]).pipe(tap(([product, userId]) => {
      this.productCode = product.code ?? '';
      if (userId !== OCC_USER_ID_ANONYMOUS) {
        this.anonymous = false;
        this.notificationPrefService.loadPreferences();
        this.interestsService.loadProductInterests(undefined, undefined, undefined, product.code, NotificationType.BACK_IN_STOCK);
      }
    }), map(([product]) => !!product.stock && product.stock.stockLevelStatus === 'outOfStock'));
    this.hasProductInterests$ = this.interestsService.getProductInterests().pipe(map(interests => !!interests.results && interests.results.length === 1));
    this.subscribeSuccess$ = this.interestsService.getAddProductInterestSuccess();
    this.isRemoveInterestLoading$ = this.interestsService.getRemoveProdutInterestLoading();
    this.prefsEnabled$ = this.notificationPrefService.getEnabledPreferences().pipe(tap(prefs => this.enabledPrefs = prefs), map(prefs => prefs.length > 0));
    this.subscriptions.add(this.interestsService.getAddProductInterestError().subscribe(error => {
      if (error) {
        this.onInterestAddingError();
      }
    }));
    this.subscriptions.add(this.interestsService.getRemoveProdutInterestSuccess().subscribe(success => {
      if (success) {
        this.onInterestRemovingSuccess();
      }
    }));
  }
  subscribe() {
    this.openDialog();
    this.interestsService.addProductInterest(this.productCode, NotificationType.BACK_IN_STOCK);
  }
  unsubscribe() {
    this.interestsService.removeProdutInterest({
      product: {
        code: this.productCode
      },
      productInterestEntry: [{
        interestType: NotificationType.BACK_IN_STOCK
      }]
    }, true);
  }
  onInterestRemovingSuccess() {
    this.subscriptions.add(this.translationService.translate('stockNotification.unsubscribeSuccess').pipe(first()).subscribe(text => this.globalMessageService.add(text, GlobalMessageType.MSG_TYPE_INFO)));
    this.interestsService.resetRemoveInterestState();
  }
  onInterestAddingError() {
    this.launchDialogService.closeDialog('Interests error');
    this.interestsService.resetAddInterestState();
  }
  openDialog() {
    const modalInstanceData = {
      subscribeSuccess$: this.subscribeSuccess$,
      enabledPrefs: this.enabledPrefs
    };
    const dialog = this.launchDialogService.openDialog(LAUNCH_CALLER.STOCK_NOTIFICATION, this.element, this.vcr, modalInstanceData);
    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.interestsService.clearProductInterests();
    this.notificationPrefService.clearPreferences();
  }
  static {
    this.ɵfac = function StockNotificationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StockNotificationComponent)(i0.ɵɵdirectiveInject(CurrentProductService), i0.ɵɵdirectiveInject(i1.GlobalMessageService), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i1.UserInterestsService), i0.ɵɵdirectiveInject(i1.UserNotificationPreferenceService), i0.ɵɵdirectiveInject(i1.UserIdService), i0.ɵɵdirectiveInject(LaunchDialogService), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StockNotificationComponent,
      selectors: [["cx-stock-notification"]],
      viewQuery: function StockNotificationComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c45, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.element = _t.first);
        }
      },
      standalone: false,
      decls: 8,
      vars: 3,
      consts: [["disableNotify", ""], ["stopNotify", ""], ["loading", ""], ["loggedIn", ""], [4, "ngIf"], [4, "ngIf", "ngIfElse"], [1, "stock-notification-notes"], ["type", "button", 1, "btn", "btn-primary", "btn-block", "btn-notify", 3, "click"], ["id", "outOfStockMessage", 1, "stock-notification-notes"], ["type", "button", "aria-describedby", "outOfStockMessage", 1, "btn", "btn-primary", "btn-block", "btn-notify", 3, "click"], [3, "routerLink"], ["role", "status", 4, "cxFeature"], ["type", "button", 1, "btn", "btn-primary", "btn-block", "btn-stop-notify", 3, "click"], ["role", "status"], [1, "cx-dialog-body", "modal-body"], [1, "cx-dialog-row"], [1, "col-sm-12"]],
      template: function StockNotificationComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, StockNotificationComponent_ng_container_0_Template, 3, 4, "ng-container", 4);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵtemplate(2, StockNotificationComponent_ng_template_2_Template, 8, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, StockNotificationComponent_ng_template_4_Template, 2, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, StockNotificationComponent_ng_template_6_Template, 4, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.outOfStock$));
        }
      },
      dependencies: [i3.NgIf, i1$2.RouterLink, SpinnerComponent, i1.FeatureDirective, i3.AsyncPipe, i1.TranslatePipe, i1.UrlPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StockNotificationComponent, [{
    type: Component,
    args: [{
      selector: 'cx-stock-notification',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"outOfStock$ | async\">\n  <ng-container *ngIf=\"!(hasProductInterests$ | async); else stopNotify\">\n    <ng-container *ngIf=\"prefsEnabled$ | async; else disableNotify\">\n      <div class=\"stock-notification-notes\">\n        <p>{{ 'stockNotification.getNotified' | cxTranslate }}</p>\n      </div>\n      <button\n        class=\"btn btn-primary btn-block btn-notify\"\n        type=\"button\"\n        (click)=\"subscribe()\"\n      >\n        {{ 'stockNotification.notifyMe' | cxTranslate }}\n      </button>\n    </ng-container>\n  </ng-container>\n</ng-container>\n\n<ng-template #disableNotify>\n  <div class=\"stock-notification-notes\" id=\"outOfStockMessage\">\n    <p>\n      <ng-container *ngIf=\"anonymous; else loggedIn\">\n        <a [routerLink]=\"{ cxRoute: 'login' } | cxUrl\">\n          {{ 'miniLogin.signInRegister' | cxTranslate }}</a\n        >\n        {{ 'stockNotification.getNotifySuffix' | cxTranslate }}<br />\n      </ng-container>\n      <ng-template #loggedIn>\n        {{ 'stockNotification.getNotify' | cxTranslate }}<br />\n        {{ 'stockNotification.activateChannelsPrefix' | cxTranslate }}\n        <a [routerLink]=\"{ cxRoute: 'notificationPreference' } | cxUrl\">{{\n          'stockNotification.channelsLink' | cxTranslate\n        }}</a\n        >{{ 'stockNotification.activateChannelsSuffix' | cxTranslate }}\n      </ng-template>\n    </p>\n  </div>\n  <button\n    class=\"btn btn-primary btn-block btn-notify\"\n    type=\"button\"\n    [attr.disabled]=\"anonymous ? true : null\"\n    aria-describedby=\"outOfStockMessage\"\n    (click)=\"subscribe()\"\n  >\n    {{ 'stockNotification.notifyMe' | cxTranslate }}\n  </button>\n</ng-template>\n\n<ng-template #stopNotify>\n  <ng-container *ngIf=\"!(isRemoveInterestLoading$ | async); else loading\">\n    <div\n      *cxFeature=\"'!a11yRemoveStatusLoadedRole'\"\n      role=\"status\"\n      [attr.aria-label]=\"'common.loaded' | cxTranslate\"\n    ></div>\n    <div class=\"stock-notification-notes\">\n      <p>{{ 'stockNotification.notified' | cxTranslate }}</p>\n    </div>\n    <button\n      class=\"btn btn-primary btn-block btn-stop-notify\"\n      type=\"button\"\n      (click)=\"unsubscribe()\"\n    >\n      {{ 'stockNotification.stopNotify' | cxTranslate }}\n    </button>\n  </ng-container>\n</ng-template>\n\n<ng-template #loading>\n  <div class=\"cx-dialog-body modal-body\">\n    <div class=\"cx-dialog-row\">\n      <div class=\"col-sm-12\">\n        <cx-spinner></cx-spinner>\n      </div>\n    </div>\n  </div>\n</ng-template>\n"
    }]
  }], () => [{
    type: CurrentProductService
  }, {
    type: i1.GlobalMessageService
  }, {
    type: i1.TranslationService
  }, {
    type: i1.UserInterestsService
  }, {
    type: i1.UserNotificationPreferenceService
  }, {
    type: i1.UserIdService
  }, {
    type: LaunchDialogService
  }, {
    type: i0.ViewContainerRef
  }], {
    element: [{
      type: ViewChild,
      args: ['element']
    }]
  });
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultStockNotificationLayoutConfig = {
  launch: {
    STOCK_NOTIFICATION: {
      inlineRoot: true,
      component: StockNotificationDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class StockNotificationModule {
  static {
    this.ɵfac = function StockNotificationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StockNotificationModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StockNotificationModule,
      declarations: [StockNotificationComponent, StockNotificationDialogComponent],
      imports: [CommonModule, RouterModule, I18nModule, SpinnerModule, UrlModule, KeyboardFocusModule, FeaturesConfigModule],
      exports: [StockNotificationComponent, StockNotificationDialogComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultStockNotificationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          StockNotificationComponent: {
            component: StockNotificationComponent
          }
        }
      }), FeaturesConfigModule],
      imports: [CommonModule, RouterModule, I18nModule, SpinnerModule, UrlModule, KeyboardFocusModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StockNotificationModule, [{
    type: NgModule,
    args: [{
      declarations: [StockNotificationComponent, StockNotificationDialogComponent],
      imports: [CommonModule, RouterModule, I18nModule, SpinnerModule, UrlModule, KeyboardFocusModule, FeaturesConfigModule],
      providers: [provideDefaultConfig(defaultStockNotificationLayoutConfig), provideDefaultConfig({
        cmsComponents: {
          StockNotificationComponent: {
            component: StockNotificationComponent
          }
        }
      }), FeaturesConfigModule],
      exports: [StockNotificationComponent, StockNotificationDialogComponent]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards the _login_ route.
 *
 * Takes care of routing the user to a auth server login page (if implicit or code flow is used).
 * In case of Resource Owner Password Flow just renders the page as normal CMS page.
 */
class LoginGuard {
  constructor(authService, authConfigService, cmsPageGuard) {
    this.authService = authService;
    this.authConfigService = authConfigService;
    this.cmsPageGuard = cmsPageGuard;
  }
  canActivate(route, state) {
    return this.authService.isUserLoggedIn().pipe(take(1), switchMap(isUserLoggedIn => {
      if (this.authConfigService.getOAuthFlow() === OAuthFlow.ResourceOwnerPasswordFlow || isUserLoggedIn) {
        return this.cmsPageGuard.canActivate(route, state);
      } else {
        // This method can trigger redirect to OAuth server that's why we don't return anything in this case
        const redirected = this.authService.loginWithRedirect();
        if (!redirected) {
          return of(false);
        }
        return EMPTY;
      }
    }));
  }
  static {
    this.ɵfac = function LoginGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginGuard)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i1.AuthConfigService), i0.ɵɵinject(CmsPageGuard));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LoginGuard,
      factory: LoginGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.AuthService
  }, {
    type: i1.AuthConfigService
  }, {
    type: CmsPageGuard
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * This module enables to quickly switch from Resource Owner Password Flow
 * to Implicit Flow or Authorization Code Flow. The `login` route in this case will be
 * responsible for initalizing the redirect to OAuth server to login.
 *
 * Instead of manually invoking OAuth redirect you only have to redirect to `login` page.
 */
class LoginRouteModule {
  static {
    this.ɵfac = function LoginRouteModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoginRouteModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LoginRouteModule,
      imports: [PageLayoutModule, i1$2.RouterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [PageLayoutModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [LoginGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'login'
        }
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginRouteModule, [{
    type: NgModule,
    args: [{
      imports: [PageLayoutModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [LoginGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'login'
        }
      }])]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Guards the _logout_ route.
 *
 * Takes care of routing the user to a logout page (if available) or redirects to
 * the homepage. If the homepage is protected, the user is redirected
 * to the login route instead.
 */
class LogoutGuard {
  constructor(auth, cms, semanticPathService, protectedRoutes, router) {
    this.auth = auth;
    this.cms = cms;
    this.semanticPathService = semanticPathService;
    this.protectedRoutes = protectedRoutes;
    this.router = router;
  }
  canActivate() {
    /**
     * First we want to complete logout process before redirecting to logout page
     * We want to avoid errors like `token is no longer valid`
     */
    return from(this.logout()).pipe(switchMap(() => {
      return this.cms.hasPage({
        id: this.semanticPathService.get('logout') ?? '',
        type: PageType.CONTENT_PAGE
      }).pipe(map(hasPage => {
        if (!hasPage) {
          return this.getRedirectUrl();
        }
        // TODO(#9385): Use CMS page guard here.
        return hasPage;
      }));
    }));
  }
  logout() {
    return this.auth.coreLogout();
  }
  /**
   * Whenever there is no specific "logout" page configured in the CMS,
   * we redirect after the user is logged out.
   *
   * The user gets redirected to the homepage, unless the homepage is protected
   * (in case of a closed shop). We'll redirect to the login page instead.
   */
  getRedirectUrl() {
    const cxRoute = this.protectedRoutes.shouldProtect ? 'login' : 'home';
    return this.router.parseUrl(this.semanticPathService.get(cxRoute) ?? '');
  }
  static {
    this.ɵfac = function LogoutGuard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogoutGuard)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i1.CmsService), i0.ɵɵinject(i1.SemanticPathService), i0.ɵɵinject(i1.ProtectedRoutesService), i0.ɵɵinject(i1$2.Router));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LogoutGuard,
      factory: LogoutGuard.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutGuard, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.AuthService
  }, {
    type: i1.CmsService
  }, {
    type: i1.SemanticPathService
  }, {
    type: i1.ProtectedRoutesService
  }, {
    type: i1$2.Router
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class LogoutModule {
  static {
    this.ɵfac = function LogoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LogoutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: LogoutModule,
      imports: [PageLayoutModule, i1$2.RouterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [PageLayoutModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [LogoutGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'logout'
        }
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LogoutModule, [{
    type: NgModule,
    args: [{
      imports: [PageLayoutModule, RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [LogoutGuard, CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'logout'
        }
      }])]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserComponentModule {
  static {
    this.ɵfac = function UserComponentModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserComponentModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserComponentModule,
      imports: [LogoutModule, LoginRouteModule, ReactiveFormsModule, RouterModule, UrlModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [LogoutModule, LoginRouteModule, ReactiveFormsModule, RouterModule, UrlModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserComponentModule, [{
    type: NgModule,
    args: [{
      imports: [LogoutModule, LoginRouteModule, ReactiveFormsModule, RouterModule, UrlModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function getProductDetailsUrlMatcherFactory(service, defaultMatcherFactory) {
  const factory = route => {
    const defaultMatcher = defaultMatcherFactory(route);
    const suffixPDPMatcher = getSuffixUrlMatcher({
      marker: 'p',
      paramName: 'productCode'
    });
    return service.getCombined([defaultMatcher, suffixPDPMatcher]);
  };
  return factory;
}
/**
 * Injection token with url matcher factory for PDP.
 * The provided url matcher matches both:
 * - the configured `paths` from routing config and
 * - custom pattern  `** / p / :productCode`
 *
 * If the this matcher doesn't fit the requirements, it can be replaced with the DEFAULT_URL_MATCHER
 * or additional matchers can be added for a specific route.
 *
 * Note: Matchers will "match" a route, but do not contribute to the creation of the route, nor do they guard routes.
 */
const PRODUCT_DETAILS_URL_MATCHER = new InjectionToken('PRODUCT_DETAILS_URL_MATCHER', {
  providedIn: 'root',
  factory: () => getProductDetailsUrlMatcherFactory(inject(UrlMatcherService), inject(DEFAULT_URL_MATCHER))
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductDetailsPageModule {
  static {
    this.ɵfac = function ProductDetailsPageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductDetailsPageModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductDetailsPageModule,
      imports: [i1$2.RouterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        routing: {
          routes: {
            product: {
              matchers: [PRODUCT_DETAILS_URL_MATCHER]
            }
          }
        }
      })],
      imports: [RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'product'
        }
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductDetailsPageModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'product'
        }
      }])],
      providers: [provideDefaultConfig({
        routing: {
          routes: {
            product: {
              matchers: [PRODUCT_DETAILS_URL_MATCHER]
            }
          }
        }
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function getProductListingUrlMatcherFactory(service, defaultMatcherFactory) {
  const factory = route => {
    const defaultMatcher = defaultMatcherFactory(route);
    const suffixPLPMatcher = getSuffixUrlMatcher({
      marker: 'c',
      paramName: 'categoryCode'
    });
    return service.getCombined([defaultMatcher, suffixPLPMatcher]);
  };
  return factory;
}
/**
 * Injection token with url matcher factory for PLP.
 * The provided url matcher matches both:
 * - the configured `paths` from routing config and
 * - custom pattern  `** / c / :categoryCode`
 *
 * If the this matcher doesn't fit the requirements, it can be replaced with the DEFAULT_URL_MATCHER
 * or additional matchers can be added for a specific route.
 *
 * Note: Matchers will "match" a route, but do not contribute to the creation of the route, nor do they guard routes.
 */
const PRODUCT_LISTING_URL_MATCHER = new InjectionToken('PRODUCT_LISTING_URL_MATCHER', {
  providedIn: 'root',
  factory: () => getProductListingUrlMatcherFactory(inject(UrlMatcherService), inject(DEFAULT_URL_MATCHER))
});

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductListingPageModule {
  static {
    this.ɵfac = function ProductListingPageModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductListingPageModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductListingPageModule,
      imports: [i1$2.RouterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        routing: {
          routes: {
            category: {
              matchers: [PRODUCT_LISTING_URL_MATCHER]
            }
          }
        }
      })],
      imports: [RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          pageLabel: 'search',
          cxRoute: 'search'
        }
      }, {
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'brand'
        }
      }, {
        // The 'category' route  may include a greedy suffix url matcher '**/c/:categoryCode'
        // So not to shadow the specific 'brand' route, the 'category' is the last route in the sequence.
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'category'
        }
      }])]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductListingPageModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forChild([{
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          pageLabel: 'search',
          cxRoute: 'search'
        }
      }, {
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'brand'
        }
      }, {
        // The 'category' route  may include a greedy suffix url matcher '**/c/:categoryCode'
        // So not to shadow the specific 'brand' route, the 'category' is the last route in the sequence.
        // @ts-ignore
        path: null,
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
        data: {
          cxRoute: 'category'
        }
      }])],
      providers: [provideDefaultConfig({
        routing: {
          routes: {
            category: {
              matchers: [PRODUCT_LISTING_URL_MATCHER]
            }
          }
        }
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Resolves the context for the specific route, based on the property `data.cxContext`
 * defined in the Angular Route.
 */
class RoutingContextService {
  constructor(activatedRoutesService, injector) {
    this.activatedRoutesService = activatedRoutesService;
    this.injector = injector;
    /**
     * Combined context token mapping consisting of all mappings defined in currently
     * Activated Angular Routes.
     *
     * The context token mapping is read from each Route's property `data.cxContext`.
     */
    this.contextTokenMapping$ = this.activatedRoutesService.routes$.pipe(map(routes => this.getRoutesContextTokenMapping(routes)), shareReplay({
      refCount: true,
      bufferSize: 1
    }));
  }
  /**
   * Returns the merged context token mapping, consisting of mappings
   * defined in all Activated Angular Routes.
   */
  getRoutesContextTokenMapping(routes) {
    return Object.assign({}, ...routes.map(route => route?.data?.cxContext));
  }
  /**
   * Resolves the specified `contextToken` from `cxContext` data parameter of the activated Angular Routes.
   * @param contextToken
   *
   * @returns instance from the root injector if defined, otherwise `undefined`.
   */
  get(contextToken) {
    return this.contextTokenMapping$.pipe(switchMap(contextMapping => {
      const providerToken = contextMapping?.[contextToken];
      return !!providerToken ? this.injector.get(providerToken) : of(undefined);
    }));
  }
  static {
    this.ɵfac = function RoutingContextService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RoutingContextService)(i0.ɵɵinject(i1.ActivatedRoutesService), i0.ɵɵinject(i1.UnifiedInjector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: RoutingContextService,
      factory: RoutingContextService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RoutingContextService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ActivatedRoutesService
  }, {
    type: i1.UnifiedInjector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Generic service for resolving the context for the UI components.
 */
class ContextService {
  constructor(routingContextService) {
    this.routingContextService = routingContextService;
  }
  /**
   * Returns the context for the given token.
   */
  get(contextToken) {
    return this.resolveContext(contextToken).pipe(distinctUntilChanged(), shareReplay({
      refCount: true,
      bufferSize: 1
    }));
  }
  /**
   * Resolves the context for the given token.
   */
  resolveContext(contextToken) {
    return this.routingContextService.get(contextToken);
  }
  static {
    this.ɵfac = function ContextService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ContextService)(i0.ɵɵinject(RoutingContextService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ContextService,
      factory: ContextService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContextService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: RoutingContextService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user navigated to an arbitrary page.
 */
class NavigationEvent extends CxEvent {
  /**
   * Event's type
   */
  static {
    this.type = 'NavigationEvent';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited an arbitrary page.
 */
class PageEvent extends CxEvent {}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited a home page.
 */
class HomePageEvent extends PageEvent {
  /** event's type */
  static {
    this.type = 'HomePageEvent';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HomePageEventBuilder {
  constructor(eventService) {
    this.eventService = eventService;
    this.register();
  }
  register() {
    this.eventService.register(HomePageEvent, this.buildHomePageEvent());
  }
  buildHomePageEvent() {
    return this.eventService.get(NavigationEvent).pipe(filter(navigationEvent => navigationEvent.semanticRoute === 'home'), map(navigationEvent => createFrom(HomePageEvent, {
      navigation: navigationEvent
    })));
  }
  static {
    this.ɵfac = function HomePageEventBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HomePageEventBuilder)(i0.ɵɵinject(i1.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: HomePageEventBuilder,
      factory: HomePageEventBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HomePageEventBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class HomePageEventModule {
  constructor(_homePageEventBuilder) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function HomePageEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || HomePageEventModule)(i0.ɵɵinject(HomePageEventBuilder));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: HomePageEventModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HomePageEventModule, [{
    type: NgModule,
    args: [{}]
  }], () => [{
    type: HomePageEventBuilder
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * A builder for the NavigationEvent
 */
class NavigationEventBuilder {
  constructor(actions, eventService) {
    this.actions = actions;
    this.eventService = eventService;
    this.register();
  }
  /**
   * Registers events
   */
  register() {
    this.eventService.register(NavigationEvent, this.buildNavigationEvent());
  }
  /**
   * Builds the navigation events
   */
  buildNavigationEvent() {
    return this.getNavigatedEvent().pipe(map(state => createFrom(NavigationEvent, {
      context: state.context,
      semanticRoute: state.semanticRoute,
      url: state.url,
      params: state.params
    })));
  }
  getNavigatedEvent() {
    return this.actions.pipe(ofType(ROUTER_NAVIGATED), map(event => event.payload.routerState));
  }
  static {
    this.ɵfac = function NavigationEventBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationEventBuilder)(i0.ɵɵinject(i1$5.ActionsSubject), i0.ɵɵinject(i1.EventService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: NavigationEventBuilder,
      factory: NavigationEventBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationEventBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$5.ActionsSubject
  }, {
    type: i1.EventService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class NavigationEventModule {
  constructor(_navigationEventBuilder) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function NavigationEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NavigationEventModule)(i0.ɵɵinject(NavigationEventBuilder));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NavigationEventModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NavigationEventModule, [{
    type: NgModule,
    args: [{}]
  }], () => [{
    type: NavigationEventBuilder
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Indicates that a user visited a product details page.
 */
class ProductDetailsPageEvent extends PageEvent {
  /** event's type */
  static {
    this.type = 'ProductDetailsPageEvent';
  }
}
/**
 * Indicates that a user visited a category page.
 */
class CategoryPageResultsEvent extends PageEvent {
  /** event's type */
  static {
    this.type = 'CategoryPageResultsEvent';
  }
}
/**
 * Indicates that the a user visited the search results page,
 * and that the search results have been retrieved.
 */
class SearchPageResultsEvent extends PageEvent {
  /** event's type */
  static {
    this.type = 'SearchPageResultsEvent';
  }
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductPageEventBuilder {
  constructor(eventService, productService, productSearchService) {
    this.eventService = eventService;
    this.productService = productService;
    this.productSearchService = productSearchService;
    this.register();
  }
  register() {
    this.eventService.register(SearchPageResultsEvent, this.buildSearchPageResultsEvent());
    this.eventService.register(ProductDetailsPageEvent, this.buildProductDetailsPageEvent());
    this.eventService.register(CategoryPageResultsEvent, this.buildCategoryResultsPageEvent());
  }
  buildProductDetailsPageEvent() {
    return this.eventService.get(NavigationEvent).pipe(filter(navigationEvent => navigationEvent.semanticRoute === 'product'), switchMap(navigationEvent => this.productService.get(navigationEvent.context.id).pipe(filter(product => Boolean(product)), take(1), map(product => createFrom(ProductDetailsPageEvent, {
      navigation: navigationEvent,
      categories: product?.categories,
      code: product?.code,
      name: product?.name,
      price: product?.price
    })))));
  }
  buildCategoryResultsPageEvent() {
    const searchResults$ = this.productSearchService.getResults().pipe(
    // skipping the initial value, and preventing emission of the previous search state
    skip(1));
    return this.eventService.get(NavigationEvent).pipe(switchMap(navigationEvent => {
      if (navigationEvent?.semanticRoute !== 'category') {
        return EMPTY;
      }
      return searchResults$.pipe(map(searchResults => createFrom(CategoryPageResultsEvent, {
        navigation: navigationEvent,
        ...{
          categoryCode: navigationEvent?.context?.id,
          numberOfResults: searchResults?.pagination?.totalResults ?? 0,
          categoryName: searchResults.breadcrumbs?.[0].facetValueName
        }
      })));
    }));
  }
  buildSearchPageResultsEvent() {
    const searchResults$ = this.productSearchService.getResults().pipe(
    // skipping the initial value, and preventing emission of the previous search state
    skip(1));
    return this.eventService.get(NavigationEvent).pipe(switchMap(navigationEvent => {
      if (navigationEvent?.semanticRoute !== 'search') {
        return EMPTY;
      }
      return searchResults$.pipe(map(searchResults => createFrom(SearchPageResultsEvent, {
        navigation: navigationEvent,
        ...{
          searchTerm: searchResults?.freeTextSearch ?? '',
          numberOfResults: searchResults?.pagination?.totalResults ?? 0
        }
      })));
    }));
  }
  static {
    this.ɵfac = function ProductPageEventBuilder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductPageEventBuilder)(i0.ɵɵinject(i1.EventService), i0.ɵɵinject(i1.ProductService), i0.ɵɵinject(i1.ProductSearchService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ProductPageEventBuilder,
      factory: ProductPageEventBuilder.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductPageEventBuilder, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.EventService
  }, {
    type: i1.ProductService
  }, {
    type: i1.ProductSearchService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class ProductPageEventModule {
  constructor(_productPageEventBuilder) {
    // Intentional empty constructor
  }
  static {
    this.ɵfac = function ProductPageEventModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ProductPageEventModule)(i0.ɵɵinject(ProductPageEventBuilder));
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ProductPageEventModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductPageEventModule, [{
    type: NgModule,
    args: [{}]
  }], () => [{
    type: ProductPageEventBuilder
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const mediaConfig = {
  mediaFormats: {
    mobile: {
      width: 400
    },
    tablet: {
      width: 770
    },
    desktop: {
      width: 1140
    },
    widescreen: {
      width: 1400
    },
    // product media
    cartIcon: {
      width: 65
    },
    thumbnail: {
      width: 96
    },
    product: {
      width: 284
    },
    zoom: {
      width: 515
    }
  },
  media: {
    pictureElementFormats: {
      mobile: {
        mediaQueries: '(max-width: 480px)'
      },
      tablet: {
        mediaQueries: '(max-width: 770px)'
      },
      desktop: {
        mediaQueries: '(max-width: 960px)'
      },
      widescreen: {
        mediaQueries: '(min-width: 961px)'
      }
    },
    pictureFormatsOrder: ['mobile', 'tablet', 'desktop', 'widescreen']
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * The layout configuration is used to define the overall layout of the storefront.
 * The configuration includes the following aspects:
 * - breakpoint layout (AKA screen layout)
 * - Page sections slot configuration (i.e. header vs footer)
 * - page template slot configuration (i.e. landing page template vs PDP page template)
 * - deferred loading configuration
 *
 * The page slot configurations is directly related to the data in the backend. If you use the
 * Spartacus sample-data, you will have an aligned setup. However, if you introduce custom page
 * templates and/or slots, you most likely need to further adjust or replace this configuration.
 */
const layoutConfig = {
  // deferredLoading: {
  //   strategy: DeferLoadingStrategy.DEFER,
  //   intersectionMargin: '50px',
  // },
  layoutSlots: {
    header: {
      lg: {
        slots: ['PreHeader', 'SiteContext', 'SiteLinks', 'SiteLogo', 'SearchBox', 'SiteLogin', 'MiniCart', 'NavigationBar']
      },
      slots: ['PreHeader', 'SiteLogo', 'SearchBox', 'MiniCart']
    },
    navigation: {
      lg: {
        slots: []
      },
      slots: ['SiteLogin', 'NavigationBar', 'SiteContext', 'SiteLinks']
    },
    footer: {
      slots: ['Footer']
    },
    LandingPage2Template: {
      pageFold: 'Section2B',
      slots: ['Section1', 'Section2A', 'Section2B', 'Section2C', 'Section3', 'Section4', 'Section5']
    },
    ContentPage1Template: {
      slots: ['Section2A', 'Section2B']
    },
    CategoryPageTemplate: {
      pageFold: 'Section2',
      slots: ['Section1', 'Section2', 'Section3']
    },
    ProductListPageTemplate: {
      slots: ['ProductLeftRefinements', 'ProductListSlot']
    },
    ProductGridPageTemplate: {
      slots: ['ProductLeftRefinements', 'ProductGridSlot']
    },
    SearchResultsListPageTemplate: {
      slots: ['Section2', 'ProductLeftRefinements', 'SearchResultsListSlot', 'Section4']
    },
    SearchResultsGridPageTemplate: {
      slots: ['Section2', 'ProductLeftRefinements', 'SearchResultsGridSlot', 'Section4']
    },
    ProductDetailsPageTemplate: {
      lg: {
        pageFold: 'UpSelling'
      },
      pageFold: 'Summary',
      slots: ['Summary', 'UpSelling', 'CrossSelling', 'Tabs', 'PlaceholderContentSlot']
    },
    CartPageTemplate: {
      slots: ['TopContent', 'CenterRightContentSlot', 'EmptyCartMiddleContent']
    },
    AccountPageTemplate: {
      slots: ['BodyContent', 'SideContent']
    },
    LoginPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot']
    },
    ErrorPageTemplate: {
      slots: ['TopContent', 'MiddleContent', 'BottomContent']
    },
    OrderConfirmationPageTemplate: {
      slots: ['BodyContent', 'SideContent']
    },
    MultiStepCheckoutSummaryPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent', 'BottomContent']
    },
    CheckoutLoginPageTemplate: {
      slots: ['RightContentSlot']
    },
    MyAccountViewPageTemplate: {
      slots: ['LeftContentSlot', 'RightContentSlot']
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultCmsContentProviders = [provideCmsStructure({
  componentId: 'HamburgerMenuComponent',
  pageSlotPosition: 'PreHeader'
}), provideCmsStructure({
  componentId: 'LoginComponent',
  pageSlotPosition: 'SiteLogin'
})];

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultOnNavigateConfig = {
  enableResetViewOnNavigate: {
    active: true,
    ignoreQueryString: false,
    ignoreRoutes: [],
    selectedHostElement: 'body'
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OnNavigateConfig {
  static {
    this.ɵfac = function OnNavigateConfig_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OnNavigateConfig)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OnNavigateConfig,
      factory: function OnNavigateConfig_Factory(__ngFactoryType__) {
        let __ngConditionalFactory__ = null;
        if (__ngFactoryType__) {
          __ngConditionalFactory__ = new (__ngFactoryType__ || OnNavigateConfig)();
        } else {
          __ngConditionalFactory__ = i0.ɵɵinject(Config);
        }
        return __ngConditionalFactory__;
      },
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnNavigateConfig, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: Config
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class OnNavigateService {
  get hostComponent() {
    return this.injector.get(ApplicationRef)?.components?.[0];
  }
  get selectedHostElement() {
    const toSelect = this.config?.enableResetViewOnNavigate?.selectedHostElement;
    return toSelect ? this.injector.get(DOCUMENT)?.getElementsByTagName?.(toSelect)?.[0] : undefined;
  }
  constructor(config, router, viewportScroller, injector) {
    this.config = config;
    this.router = router;
    this.viewportScroller = viewportScroller;
    this.injector = injector;
    this.routerConfiguration = inject(ROUTER_CONFIGURATION, {
      optional: true
    }) || {};
  }
  /**
   * Reads configuration and enables features based on flags set.
   */
  initializeWithConfig() {
    if (this.config?.enableResetViewOnNavigate?.active) {
      this.setResetViewOnNavigate(this.config.enableResetViewOnNavigate.active);
    }
  }
  /**
   * Resets view back to the original position when performing a back navigation and to the top when performing a front navigation
   * and sets the focus back to the top of the page before skiplinks for any type of navigation
   * @param enable Enable or disable this feature
   */
  setResetViewOnNavigate(enable) {
    this.subscription?.unsubscribe();
    if (enable) {
      // Disable automatic scroll restoration to avoid race conditions
      this.viewportScroller.setHistoryScrollRestoration('manual');
      this.subscription = this.router.events.pipe(filter(event => event instanceof Scroll), pairwise()).subscribe(event => {
        const previousRoute = event[0];
        const currentRoute = event[1];
        const position = currentRoute.position;
        if (position) {
          // allow the pages to be repainted before scrolling to proper position
          this.scrollToPosition(currentRoute, position);
        } else {
          if (this.config.enableResetViewOnNavigate?.ignoreQueryString && this.isPathEqual(previousRoute, currentRoute)) {
            return;
          }
          if (this.isChildRoute(currentRoute)) {
            return;
          }
          this.scrollToPosition(currentRoute, position);
        }
        this.focusOnHostElement();
      });
    }
  }
  /**
   * Focus on selectedHostElement if set in config.
   * Otherwise, focuses on hostComponent.
   */
  focusOnHostElement() {
    if (this.selectedHostElement) {
      this.selectedHostElement?.focus();
    } else {
      this.hostComponent?.location?.nativeElement.focus();
    }
  }
  /**
   * Scrolls to a specified position or anchor based on the current route and configuration.
   * @param currentRoute The current route containing scroll information.
   * @param position The target scroll position as [x, y] coordinates, or null.
   */
  scrollToPosition(currentRoute, position) {
    const scrollTo = (anchor, scrollPosition) => {
      if (anchor && this.routerConfiguration.anchorScrolling === 'enabled') {
        this.viewportScroller.scrollToAnchor(anchor);
      } else {
        this.viewportScroller.scrollToPosition(scrollPosition);
      }
    };
    const defaultPosition = [0, 0];
    setTimeout(() => {
      const anchor = currentRoute.anchor;
      const positionToScroll = position || defaultPosition;
      scrollTo(anchor, positionToScroll);
    }, position ? 0 : 100);
  }
  /**
   * Verifies if the current route is a child route from the given ignore config route
   *
   * @param route
   * @returns boolean whether the route is a child route
   */
  isChildRoute(route) {
    return this.config.enableResetViewOnNavigate?.ignoreRoutes?.some(configRoute => this.isNavigationEnd(route.routerEvent) && route.routerEvent.urlAfterRedirects.split('/').includes(configRoute)) ?? false;
  }
  /**
   * Verifies if the previous and current route are the same without the query string
   *
   * @param previousRoute
   * @param currentRoute
   * @returns boolean depending on the previous and current route are equal without the query strings
   */
  isPathEqual(previousRoute, currentRoute) {
    if (!this.isNavigationEnd(previousRoute.routerEvent) || !this.isNavigationEnd(currentRoute.routerEvent)) {
      return false;
    }
    return previousRoute.routerEvent.urlAfterRedirects.split('?')[0] === currentRoute.routerEvent.urlAfterRedirects.split('?')[0];
  }
  /**
   * Verifies if router event is a navigation end event
   * @private
   */
  isNavigationEnd(event) {
    return event.type === EventType.NavigationEnd;
  }
  static {
    this.ɵfac = function OnNavigateService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OnNavigateService)(i0.ɵɵinject(OnNavigateConfig), i0.ɵɵinject(i1$2.Router), i0.ɵɵinject(i3.ViewportScroller), i0.ɵɵinject(i0.Injector));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OnNavigateService,
      factory: OnNavigateService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OnNavigateService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: OnNavigateConfig
  }, {
    type: i1$2.Router
  }, {
    type: i3.ViewportScroller
  }, {
    type: i0.Injector
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class AppRoutingModule {
  static {
    this.ɵfac = function AppRoutingModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AppRoutingModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AppRoutingModule,
      imports: [i1$2.RouterModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultOnNavigateConfig), {
        provide: APP_INITIALIZER,
        useFactory: onNavigateFactory,
        deps: [OnNavigateService],
        multi: true
      }],
      imports: [RouterModule.forRoot([], {
        anchorScrolling: 'enabled',
        initialNavigation: 'enabledBlocking'
      })]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AppRoutingModule, [{
    type: NgModule,
    args: [{
      imports: [RouterModule.forRoot([], {
        anchorScrolling: 'enabled',
        initialNavigation: 'enabledBlocking'
      })],
      providers: [provideDefaultConfig(defaultOnNavigateConfig), {
        provide: APP_INITIALIZER,
        useFactory: onNavigateFactory,
        deps: [OnNavigateService],
        multi: true
      }]
    }]
  }], null, null);
})();
function onNavigateFactory(onNavigateService) {
  const isReady = () => onNavigateService.initializeWithConfig();
  return isReady;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Utils for Angular forms
 */
var FormUtils;
(function (FormUtils) {
  /**
   * Calls the native Angular method `#updateValueAndValidity` for the given from control
   * and all its descendants (in case when it's `FormGroup` or `FormArray`).
   *
   * In particular it's useful for triggering re-emission of observables
   * `valueChanges` and `statusChanges` for all descendant form controls.
   *
   * _Note: Dropping this function may be considered, when it's implemented natively
   * by Angular. See https://github.com/angular/angular/issues/6170_
   *
   * @param control form control
   * @param options additional options
   * * `emitEvent`: When true or not given (the default), the `statusChanges` and
   * `valueChanges` observables emit the latest status and value. When false,
   * it doesn't trigger observables emission.
   */
  function deepUpdateValueAndValidity(control, options = {}) {
    if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {
      Object.values(control.controls).forEach(childControl => {
        deepUpdateValueAndValidity(childControl, options);
      });
    }
    control.updateValueAndValidity({
      onlySelf: true,
      // avoid calling `#updateValueAndValidity` for all ancestors
      emitEvent: options.emitEvent
    });
  }
  FormUtils.deepUpdateValueAndValidity = deepUpdateValueAndValidity;
})(FormUtils || (FormUtils = {}));

/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Get strings for phone and mobile numbers
 */
function getAddressNumbers(address, textPhone, textMobile) {
  if (address.cellphone && address.phone) {
    if (address.cellphone === address.phone) {
      return textMobile + ': ' + address.cellphone;
    }
    return `${textPhone}: ${address.phone}\n${textMobile}: ${address.cellphone}`;
  }
  if (address.cellphone) {
    return textMobile + ': ' + address.cellphone;
  }
  if (address.phone) {
    return textPhone + ': ' + address.phone;
  }
  return undefined;
}

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class BaseStorefrontModule {
  static {
    this.ɵfac = function BaseStorefrontModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BaseStorefrontModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BaseStorefrontModule,
      imports: [i1.BaseCoreModule, RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PwaModule, PageLayoutModule, SeoModule, PageComponentModule, PageSlotModule, SkipLinkModule, KeyboardFocusModule, LayoutModule, RoutingModule, MediaModule, OutletModule, StorefrontComponentModule],
      exports: [LayoutModule, StorefrontComponentModule]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [BaseCoreModule.forRoot(), RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PwaModule, PageLayoutModule, SeoModule, PageComponentModule.forRoot(), PageSlotModule, SkipLinkModule, KeyboardFocusModule, LayoutModule, RoutingModule.forRoot(), MediaModule.forRoot(), OutletModule.forRoot(), StorefrontComponentModule, LayoutModule, StorefrontComponentModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseStorefrontModule, [{
    type: NgModule,
    args: [{
      imports: [BaseCoreModule.forRoot(), RouterModule, GlobalMessageComponentModule, OutletModule, OutletRefModule, PwaModule, PageLayoutModule, SeoModule, PageComponentModule.forRoot(), PageSlotModule, SkipLinkModule, KeyboardFocusModule, LayoutModule, RoutingModule.forRoot(), MediaModule.forRoot(), OutletModule.forRoot(), StorefrontComponentModule],
      exports: [LayoutModule, StorefrontComponentModule]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/*
 * Public API Surface of storefrontlib
 */
/** AUGMENTABLE_TYPES_END */

/**
 * Generated bundle index. Do not edit.
 */

export { AVOID_STACKED_OUTLETS, ActiveFacetsComponent, ActiveFacetsModule, AddToHomeScreenBannerComponent, AddToHomeScreenBtnComponent, AddToHomeScreenComponent, AddToHomeScreenService, AnonymousConsentDialogComponent, AnonymousConsentManagementBannerComponent, AnonymousConsentManagementBannerModule, AnonymousConsentOpenDialogComponent, AnonymousConsentsDialogModule, AppRoutingModule, AtMessageDirective, AtMessageModule, AvatarComponent, BEFORE_CMS_PAGE_GUARD, BREAKPOINT, BannerCarouselComponent, BannerCarouselModule, BannerComponent, BannerModule, BaseStorefrontModule, BeforeCmsPageGuardService, BreadcrumbComponent, BreadcrumbModule, BreadcrumbSchemaBuilder, BreakpointService, BtnLikeLinkDirective, BtnLikeLinkModule, CaptchaApiConfig, CaptchaComponent, CaptchaModule, CaptchaService, CardComponent, CardModule, CarouselComponent, CarouselModule, CarouselService, CategoryNavigationComponent, CategoryNavigationModule, CategoryPageResultsEvent, ChatMessagingModule, ClaimDialogComponent, CmsComponentData, CmsComponentsService, CmsFeaturesService, CmsGuardsService, CmsI18nService, CmsInjectorService, CmsPageGuard, CmsPageGuardService, CmsParagraphModule, CmsRouteModule, CmsRoutesService, ComponentCreateEvent, ComponentDestroyEvent, ComponentEvent, ComponentHandler, ComponentHandlerService, ComponentWrapperDirective, ConsentManagementComponent, ConsentManagementComponentService, ConsentManagementFormComponent, ConsentManagementModule, ContextService, CouponCardComponent, CouponClaimComponent, CouponDialogComponent, CurrentProductService, CustomFormValidators, DIALOG_TYPE, DatePickerComponent, DatePickerModule, DatePickerService, DefaultComponentHandler, DeferLoaderService, DirectionConfig, DirectionMode, DirectionModule, DirectionService, DomChangeDirective, DomChangeModule, ExportCsvFileService, FacetComponent, FacetGroupCollapsedState, FacetListComponent, FacetListModule, FacetModule, FacetService, FileDownloadService, FileReaderService, FileUploadComponent, FileUploadModule, FilesFormValidators, FocusDirective, FocusableCarouselItemDirective, FooterNavigationComponent, FooterNavigationModule, FormConfig, FormErrorsComponent, FormErrorsModule, FormRequiredAsterisksComponent, FormRequiredLegendComponent, FormUtils, GenericLinkComponent, GenericLinkComponentService, GenericLinkModule, GlobalMessageComponent, GlobalMessageComponentModule, HamburgerMenuComponent, HamburgerMenuModule, HamburgerMenuService, HighlightPipe, HomePageEvent, HomePageEventBuilder, HomePageEventModule, ICON_TYPE, IconComponent, IconConfig, IconLoaderService, IconModule, IconResourceType, IconTestingModule, ImageFetchPriority, ImageLoadingStrategy, ImportCsvFileService, InlineRenderStrategy, InlineRootRenderStrategy, InnerComponentsHostDirective, IntersectionService, ItemCounterComponent, ItemCounterModule, JSONLD_PRODUCT_BUILDER, JsonLdBaseProductBuilder, JsonLdBuilderModule, JsonLdDirective, JsonLdProductOfferBuilder, JsonLdProductReviewBuilder, JsonLdScriptFactory, KeyboardFocusModule, KeyboardFocusService, KeyboardFocusTestingModule, LAUNCH_CALLER, LanguageCurrencyComponent, LaunchDialogModule, LaunchDialogService, LaunchRenderStrategy, LayoutConfig, LayoutModule, LazyComponentHandler, LinkComponent, LinkModule, ListNavigationModule, LoginGuard, LoginRouteModule, LogoutGuard, LogoutModule, MediaComponent, MediaConfig, MediaModule, MediaService, MediaSourcesPipe, MessageComponent, MessageComponentModule, MessagingComponent, MockIconComponent, MockIconLoaderService, MockKeyboardFocusDirective, MyAccountV2ConsentManagementComponent, MyAccountV2ConsentManagementFormComponent, MyAccountV2ConsentManagementModule, MyAccountV2Module, MyAccountV2NavigationComponent, MyAccountV2NavigationModule, MyAccountV2NotificationPreferenceComponent, MyAccountV2NotificationPreferenceModule, MyCouponsComponent, MyCouponsComponentService, MyCouponsModule, MyInterestsComponent, MyInterestsModule, NavigationComponent, NavigationEvent, NavigationEventBuilder, NavigationEventModule, NavigationModule, NavigationService, NavigationUIComponent, NgSelectA11yDirective, NgSelectA11yModule, NotificationPreferenceComponent, NotificationPreferenceModule, OnNavigateConfig, OnNavigateService, OutletContextData, OutletDirective, OutletModule, OutletPosition, OutletRefDirective, OutletRefModule, OutletRenderStrategy, OutletRendererService, OutletService, PAGE_LAYOUT_HANDLER, PDFComponent, PDFModule, PRODUCT_DETAILS_URL_MATCHER, PRODUCT_LISTING_URL_MATCHER, PWAModuleConfig, PageComponentModule, PageEvent, PageLayoutComponent, PageLayoutModule, PageLayoutService, PageMetaLinkService, PageSection, PageSlotComponent, PageSlotModule, PageSlotService, PageTemplateDirective, PageTitleComponent, PageTitleModule, PaginationBuilder, PaginationComponent, PaginationConfig, PaginationItemType, PaginationModule, PaginationNavigationPosition, ParagraphComponent, PasswordVisibilityToggleComponent, PasswordVisibilityToggleDirective, PasswordVisibilityToggleModule, PaymentMethodsComponent, PaymentMethodsModule, PopoverComponent, PopoverDirective, PopoverEvent, PopoverModule, PopoverService, PositioningService, ProductAttributesComponent, ProductAttributesModule, ProductCarouselComponent, ProductCarouselItemComponent, ProductCarouselModule, ProductCarouselService, ProductDetailOutlets, ProductDetailsPageEvent, ProductDetailsPageModule, ProductDetailsTabComponent, ProductDetailsTabModule, ProductFacetNavigationComponent, ProductFacetNavigationModule, ProductFacetService, ProductGridItemComponent, ProductImagesComponent, ProductImagesModule, ProductIntroComponent, ProductIntroModule, ProductListComponent, ProductListComponentService, ProductListItemComponent, ProductListItemContext, ProductListItemContextSource, ProductListModule, ProductListOutlets, ProductListingPageModule, ProductPageEventBuilder, ProductPageEventModule, ProductReferencesComponent, ProductReferencesModule, ProductReviewsComponent, ProductReviewsModule, ProductSchemaBuilder, ProductScrollComponent, ProductSummaryComponent, ProductSummaryModule, ProductTabsModule, ProductViewComponent, ProgressButtonComponent, ProgressButtonModule, PromotionsComponent, PromotionsModule, PwaModule, RoutingContextService, RoutingModule, RoutingRenderStrategy, SCHEMA_BUILDER, ScrollToTopComponent, ScrollToTopModule, SearchBoxComponent, SearchBoxComponentService, SearchBoxModule, SearchBoxOutlets, SearchBoxProductSelectedEvent, SearchBoxSuggestionSelectedEvent, SearchPageResultsEvent, SelectFocusUtility, SeoConfig, SeoMetaService, SeoModule, SiteContextComponentService, SiteContextSelectorComponent, SiteContextSelectorModule, SiteContextType, SiteThemeSwitcherComponent, SiteThemeSwitcherModule, SkipFocusDirective, SkipLink, SkipLinkComponent, SkipLinkConfig, SkipLinkDirective, SkipLinkModule, SkipLinkScrollPosition, SkipLinkService, SortingComponent, SortingModule, SpinnerComponent, SpinnerModule, SplitViewComponent, SplitViewModule, SplitViewService, StarRatingComponent, StarRatingModule, StockNotificationComponent, StockNotificationDialogComponent, StockNotificationModule, StorefrontComponent, StorefrontComponentModule, StorefrontOutlets, StructuredDataModule, SupplementHashAnchorsModule, SupplementHashAnchorsPipe, TAB_MODE, TabComponent, TabModule, TabPanelComponent, TabParagraphContainerComponent, TabParagraphContainerModule, TableComponent, TableConfig, TableDataCellComponent, TableDataCellModule, TableHeaderCellComponent, TableHeaderCellModule, TableLayout, TableModule, TableRendererService, TableService, ThemeModule, ThemeService, TotalComponent, TotalModule, TrapFocus, TruncatePipe, TruncateTextPopoverComponent, TruncateTextPopoverModule, USE_LEGACY_MEDIA_COMPONENT, USE_MY_ACCOUNT_V2_CONSENT, USE_MY_ACCOUNT_V2_NOTIFICATION_PREFERENCE, USE_STACKED_OUTLETS, UserComponentModule, VideoComponent, VideoModule, ViewComponent, ViewConfig, ViewModes, controlsMustMatch, defaultCmsContentProviders, defaultLayoutConfig, defaultOnNavigateConfig, defaultPWAModuleConfig, defaultPaginationConfig, defaultSeoConfig, defaultSkipLinkConfig, defaultTableConfig, defaultViewConfig, disableTabbingForTick, fontawesomeIconConfig, getAddressNumbers, getSuffixUrlMatcher, initSeoService, layoutConfig, mediaConfig, onNavigateFactory, provideCmsStructure, provideOutlet, sortTitles, titleScores };
